import { useState, useCallback, useEffect, useRef, useMemo, createContext, useContext } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc, setDoc, deleteDoc, getDocs, collection, query, where, arrayUnion, addDoc, increment } from "firebase/firestore";
import ImmersionTunnel from "./components/Immersion/ImmersionTunnel";
import ImmersionConfigTab from "./components/Immersion/ImmersionConfigTab";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, signInWithCustomToken, onAuthStateChanged } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { DiagnosticsTab, DiagResultsTab, DiagnosticParfumTab, LinkBioPublicPage, TunnelHybridePage, RecommandationPubliquePage, FormationAppTab, EntonnoirTab, FORMATION_APP_CATEGORIES, FORMATION_APP_CATEGORIES_DEFAULT } from './DiagnosticsTab';
import { FicheClienteCard, ClientsRelanceTab, ClientsTab, DistributeursTab, RelancesTab, LiensReseauxSection, MELISSA } from './ClientsTab';
import { getUnreadMessagesCount } from './MessagerieTab';
import { CommunauteTab } from './CommunauteTab';
import CarteEquipe from './CarteEquipe';
import { EditorialTab } from './EditorialTab';
import { CalendrierTab } from './CalendrierTab';
import { LinkBioTab } from './LinkBioTab';
import { AdminLinkBioSection } from './EspaceChefTab';
import { TunnelTab } from './TunnelTab';
import { DreamBoardWidget, DreamBoardTab } from './DreamBoardTab';
import { EbooksTab } from './EbooksTab';
import { SemaineThemeTab } from './SemaineThemeTab';
import { FormationProduitsTab, AdminFormationProduits, UploadPhoto, CATEGORIES_PRODUITS, chargerFormationProduits, CAT_VIDEO_ID } from './FormationProduitsTab';
import { DashboardTab } from './DashboardTab';
import { AuditResultatsTab } from './AuditResultatsTab';
import { DiagAdminEditor } from './DiagnosticsTab';
import { TemoignagesDiagAdmin } from './DiagnosticsTab';
import { ObjectionBubbles, ObjectionsTab, ScriptsTab } from './ScriptsTab';
import { FastStartTab } from './FastStartTab';
import { ObjectifsTab } from './ObjectifsTab';
import { AssistanteIATab } from './AssistanteIATab';
import { AnalyseReseauxTab } from './AnalyseReseauxTab';
import { StoriesDefiTab } from './StoriesDefi';
import { TirelireBandeau } from './TirelireGauge';
import { useDirAVenir, BasculeFuturs, DirecteursAVenirOnglet } from './DirecteursAVenir';
import { filtrerAnnuaire, estMelissaUid } from './EquipeGains';
import { AdminMajCatalogue } from './MajCatalogueMihi';
import { BoutonRemplirMihi, BoutonMoiMihi, CarteFavorisMihi } from './ChiffresMihi';
import { TunnelRecrutementTab, TunnelRecrutementPublic } from './TunnelRecrutementTab';
import RoueEquilibre from './RoueEquilibre';
import TestDISC from './TestDISC';
import TestValeurs from './TestValeurs';
import TestStyleEntrepreneur from './TestStyleEntrepreneur';
import { TokensCadeauxTab } from './TokensCadeauxTab';
import { TunnelStatsEquipeRecap } from './TunnelStatsTab';
import { BlocPaiementsAlternatifs } from './PaiementsAlternatifs';
import { buildEquipeTree, countEquipe, getLigneeChefs, countEquipeSafe, SearchSelect, todayLocalDate, todayLocalStr, BoutonMiseAJour, useLang, useTranslation, useTranslatedContent, useTranslatedProduit, T, Btn, YTBtn, DriveBtn, DocBtn, Card, Info, Tag, SecTitle, LangContext, UI_TEXTS, UI_TEXTS_PT, domOriginals, translateDOM, translateBatch, seedAnnuaireFromMembres, APP_VERSION, C } from './components';
// ── FIREBASE ──────────────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyBhsxeZe7JvliHh3kBRgRKSKA2XSiAUg9k",
  authDomain: "blazing-dinasty-1fad9.firebaseapp.com",
  projectId: "blazing-dinasty-1fad9",
  storageBucket: "blazing-dinasty-1fad9.firebasestorage.app",
  messagingSenderId: "499869328828",
  appId: "1:499869328828:web:28900482512a07ca3a77b9",
};
const fbApp = initializeApp(firebaseConfig);
const db = getFirestore(fbApp);
const storage = getStorage(fbApp);
let messaging = null;
try { messaging = getMessaging(fbApp); } catch {}
const auth = getAuth(fbApp);
export const fbFunctions = getFunctions(fbApp,'us-central1');
const authentifierFn = httpsCallable(fbFunctions,'authentifier');
const definirMotDePasseFn = httpsCallable(fbFunctions,'definirMotDePasse');
const reinitialiserMotDePasseFn = httpsCallable(fbFunctions,'reinitialiserMotDePasse');
const creerCompteStripeConnectFn = httpsCallable(fbFunctions,'creerCompteStripeConnect');
const verifierStatutStripeFn = httpsCallable(fbFunctions,'verifierStatutStripe');
const creerSessionCheckoutFn = httpsCallable(fbFunctions,'creerSessionCheckout');

// Active les rappels (notifications) sur CET appareil. Retourne : "actif" | "a-activer" | "bloque" | "ios-installer" | "indisponible" | "erreur"
// demander=false : ne déclenche pas la fenêtre d'autorisation (utile au chargement), met juste à jour l'enregistrement si c'est déjà autorisé
export async function activerNotifications(uid,{demander=true}={}){
  try{
    if(typeof window==="undefined"||!uid)return "indisponible";
    const ua=navigator.userAgent||"";
    const ios=/iPhone|iPad|iPod/i.test(ua);
    const installee=(window.matchMedia&&window.matchMedia("(display-mode: standalone)").matches)||window.navigator.standalone===true;
    if(ios&&!installee)return "ios-installer";
    if(!messaging||typeof Notification==="undefined")return "indisponible";
    if(Notification.permission==="denied")return "bloque";
    let swReg;
    if("serviceWorker" in navigator){
      try{
        swReg=await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        await navigator.serviceWorker.ready;
      }catch(e){console.error("[activerNotifications] Echec enregistrement service worker:",e);}
    }
    if(Notification.permission!=="granted"){
      if(!demander)return "a-activer";
      const permission=await Notification.requestPermission();
      if(permission==="denied")return "bloque";
      if(permission!=="granted")return "a-activer";
    }
    const token=await getToken(messaging,{
      vapidKey:"BFI7Uodh64p0EnejAc9xQ6y0hOS0w4CVA2QO-3mCxFmcm13orUtX7mYDwSRuaS8iDs8ovcClbKj2j2JzMi47sRE",
      serviceWorkerRegistration:swReg
    });
    if(!token)return "erreur";
    // Enregistre ce téléphone SANS écraser les autres appareils de la même personne
    const refTok=doc(db,"fcm_tokens",uid);
    const snapTok=await getDoc(refTok);
    const dejaLa=snapTok.exists()?Object.values(snapTok.data()||{}):[];
    if(!dejaLa.includes(token))await setDoc(refTok,{["d_"+token.slice(0,12)]:token},{merge:true});
    if(!window.__bdForegroundNotifSetup){
      window.__bdForegroundNotifSetup=true;
      onMessage(messaging,(payload)=>{
        try{
          const title=payload.notification?.title||"Blazing Dynasty";
          const body=payload.notification?.body||"";
          if(Notification.permission==="granted"){
            new Notification(title,{body,icon:"/logo192.png"});
          }
        }catch{}
      });
    }
    return "actif";
  }catch(e){
    console.error("[activerNotifications]",e);
    return "erreur";
  }
}

// Appelé à la connexion : sur iPhone on ne déclenche pas la fenêtre d'autorisation (bloquée sans geste), le bandeau du tableau de bord s'en charge
async function saveFCMToken(uid) {
  const ios=/iPhone|iPad|iPod/i.test((typeof navigator!=="undefined"&&navigator.userAgent)||"");
  await activerNotifications(uid,{demander:!ios});
}

// Bandeau du tableau de bord : invite à activer les rappels, avec un vrai bouton (indispensable sur iPhone)
export function BandeauNotifications({uid}){
  const[statut,setStatut]=useState("");
  const[confirme,setConfirme]=useState(false);
  const[enCours,setEnCours]=useState(false);
  
  useEffect(()=>{
    let vivant=true;
    (async()=>{const s=await activerNotifications(uid,{demander:false});if(vivant)setStatut(s==="erreur"?"":s);})();
    return()=>{vivant=false;};
  },[uid]);
  const activer=async()=>{
    setEnCours(true);
    const s=await activerNotifications(uid,{demander:true});
    setEnCours(false);
    setStatut(s);
    if(s==="actif")setConfirme(true);
  };
  
  if(confirme){
    return <div style={{background:"#E8F5E9",border:`1px solid ${C.vert}`,borderRadius:12,padding:".7rem .9rem",marginBottom:"1rem",fontSize:".78rem",fontWeight:700,color:C.vert}}>✅ Rappels activés sur cet appareil. Tu les recevras même quand l'appli est fermée.</div>;
  }
  if(!statut||statut==="actif"||statut==="indisponible"||statut==="bloque")return null;
  const textes={
    "a-activer":["🔔 Active tes rappels","Reçois tes relances, tes défis et les annonces de l'équipe directement sur ton téléphone, même quand l'appli est fermée."],
    "ios-installer":["🔔 Pour recevoir tes rappels sur iPhone","Ajoute d'abord l'appli à ton écran d'accueil : ouvre-la dans Safari, touche le bouton Partager, puis « Sur l'écran d'accueil ». Ouvre-la ensuite depuis la nouvelle icône : le bouton d'activation apparaîtra ici."],
    "bloque":["🔕 Les rappels sont bloqués","Réactive-les dans les réglages : sur iPhone, Réglages → Notifications → Blazing Dynasty. Sur Android ou ordinateur, touche le cadenas à côté de l'adresse → Notifications → Autoriser. Puis recharge l'appli."],
    "erreur":["🔔 Activation impossible pour l'instant","Réessaie dans un instant. Si ça ne marche toujours pas, vérifie que les notifications sont autorisées dans les réglages de ton téléphone."],
  };
  const t=textes[statut]||textes["erreur"];
  return(
    <div style={{background:"linear-gradient(135deg,#FFF3EE,#FDE8E0)",border:`1.5px solid ${C.rose}`,borderRadius:14,padding:".9rem 1rem",marginBottom:"1rem"}}>
      <div style={{fontFamily:"Georgia,serif",fontSize:".95rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>{t[0]}</div>
      <div style={{fontSize:".74rem",color:C.texte,lineHeight:1.6,marginBottom:".6rem"}}>{t[1]}</div>
      <div style={{display:"flex",gap:".5rem",alignItems:"center",flexWrap:"wrap"}}>
        {(statut==="a-activer"||statut==="erreur")&&(
          <button onClick={activer} disabled={enCours}
            style={{background:C.rose,color:"white",border:"none",borderRadius:9,padding:".5rem 1rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",opacity:enCours?.6:1}}>
            {enCours?"Activation...":"🔔 Activer mes rappels"}
          </button>
        )}
      </div>
    </div>
  );
}

// ── STORAGE (Firebase Firestore) ──────────────────────────────────────────────
export async function sg(uid, k) {
  try {
    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    if (snap.exists()) {
      const data = snap.data();
      return data[k] !== undefined ? data[k] : null;
    }
    return null;
  } catch { return null; }
}

export async function ss(uid, k, v) {
  try {
    const ref = doc(db, "users", uid);
    await setDoc(ref, { [k]: v }, { merge: true });
  } catch {}
}

// Charge toutes les données d'un utilisateur en une seule requête
export async function sgAll(uid) {
  try {
    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : {};
  } catch { return {}; }
}

// --- Suivi Formation principale (consultation, temps passe, completion) ---
export async function enregistrerConsultationFormation(uid, subTab) {
  if(!uid||!subTab)return;
  try{
    const data=await sgAll(uid);
    const progress=data["db-formation-progress"]?JSON.parse(data["db-formation-progress"]):{};
    const p=progress[subTab]||{nbConsultations:0,tempsTotalSecondes:0,termine:false};
    p.nbConsultations=(p.nbConsultations||0)+1;
    if(!p.premiereConsultation)p.premiereConsultation=new Date().toISOString();
    p.derniereConsultation=new Date().toISOString();
    progress[subTab]=p;
    await ss(uid,"db-formation-progress",JSON.stringify(progress));
  }catch(e){console.error("tracking formation:",e);}
}
export async function ajouterTempsFormation(uid, subTab, secondes) {
  if(!uid||!subTab||!secondes||secondes<2)return;
  try{
    const data=await sgAll(uid);
    const progress=data["db-formation-progress"]?JSON.parse(data["db-formation-progress"]):{};
    const p=progress[subTab]||{nbConsultations:0,tempsTotalSecondes:0,termine:false};
    p.tempsTotalSecondes=(p.tempsTotalSecondes||0)+secondes;
    progress[subTab]=p;
    await ss(uid,"db-formation-progress",JSON.stringify(progress));
  }catch(e){console.error("tracking temps formation:",e);}
}
export async function marquerFormationTerminee(uid, subTab) {
  if(!uid||!subTab)return;
  try{
    const data=await sgAll(uid);
    const progress=data["db-formation-progress"]?JSON.parse(data["db-formation-progress"]):{};
    const p=progress[subTab]||{nbConsultations:0,tempsTotalSecondes:0};
    p.termine=true;
    p.dateTermine=new Date().toISOString();
    progress[subTab]=p;
    await ss(uid,"db-formation-progress",JSON.stringify(progress));
  }catch(e){console.error("maj completion formation:",e);}
}
const SCRIPT_REUNION_VIRTUELLE=`Coucou à toutes et bienvenue ! Moi, c’est [prénom], et je suis ravie de vous accueillir pour cette petite parenthèse découverte !

Pendant quelques jours, je vais vous faire découvrir MIHI et une sélection de produits pour prendre soin de vous et de votre maison : soins du visage, cheveux, maquillage, parfums, bien-être ou encore entretien.

L’idée, c’est de vous montrer concrètement les produits, comment on les utilise et de vous aider à choisir selon vos envies et votre budget.

Et justement, c’est vous qui choisissez les thèmes ! Juste après cette vidéo, je vous partage un sondage : vous pourrez voter pour trois thèmes maximum. Les trois thèmes les plus demandés seront présentés pendant les deux jours suivants.

Si nous avons déjà choisi un thème ensemble, nous partirons directement sur celui-ci.

Vous pourrez regarder les vidéos tranquillement, au moment qui vous convient, et poser vos questions dans le groupe. Pour terminer, on se retrouvera pour un petit moment questions-réponses, en live ou dans une publication dédiée.

[Préciser ici le cadeau prévu et les conditions pour en profiter.]

Installez-vous, faites comme chez vous et n’hésitez pas à participer : ce petit groupe est là pour qu’on échange !

À vous de voter, et on se retrouve très vite pour les premières découvertes !`;
export const FORMATION_SUBTABS_SUIVIES=["mihibd","demarrage","vente","recrutement","contenu","devperso","outils","formaproduits","communication","nutrition","bonus"];
// Une formation ajoutée est affichée comme "nouvelle" pendant 3 semaines
const estNouveauJusque=(dateStr,jours=21)=>(Date.now()-new Date(dateStr+"T00:00:00").getTime())<jours*86400000;
const CLE_NEW_VUS="bd-new-vus";
const lireNewVus=()=>{try{return JSON.parse(localStorage.getItem(CLE_NEW_VUS)||"[]");}catch(e){return [];}};
const marquerNewVu=(id)=>{try{const d=new Set(lireNewVus());d.add(id);localStorage.setItem(CLE_NEW_VUS,JSON.stringify([...d]));}catch(e){}};
export const FORMATION_SUBTABS_LABELS={mihibd:"Mihi & Blazing Dynasty",demarrage:"Démarrage",vente:"Vente & Stratégies",recrutement:"Recrutement",contenu:"Création de contenu",devperso:"Développement personnel",outils:"Outils",formaproduits:"Formation produits",bonus:"Formation BONUS"};

// Met à jour la fiche d'un membre dans l'annuaire global (équipe/annuaire)
export async function syncAnnuaire(uid, displayName, objPerso, marraineUid){
  try{
    const ref = doc(db,"equipe","annuaire");
    const [prenom, ...rest] = (displayName||"").split(" ");
    const entry = {
      uid,
      prenom: prenom||"",
      nom: rest.join(" ")||"",
      palier: objPerso?.palier||"2%",
      ca: objPerso?.ca||"",
      caPerso: objPerso?.caPerso||"",
      caObj: objPerso?.caObj||"",
      recruesReal: objPerso?.recruesReal||"0",
      recruesObj: objPerso?.recruesObj||"0",
      lastActive: Date.now(),
    };
    const snap = await getDoc(ref);
    const existing = snap.exists() && snap.data().membres ? snap.data().membres : {};
    entry.dateEnreg = existing[uid]?.dateEnreg || todayLocalStr();
    if(existing[uid]?.notes) entry.notes = existing[uid].notes;
    // Marraine : utilise la nouvelle valeur si fournie, sinon conserve l'existante
    if(marraineUid) entry.marraine = marraineUid;
    else if(existing[uid]?.marraine) entry.marraine = existing[uid].marraine;
    await setDoc(ref, {membres: {...existing, [uid]: entry}}, {merge:true});
  }catch{}
}


// Construit récursivement l'arbre des filleules (recrues directes et indirectes) d'un membre
export async function copierTexteRobuste(text){
  try{
    if(navigator.clipboard&&navigator.clipboard.writeText){
      await navigator.clipboard.writeText(text);
      return true;
    }
    const zoneTemp=document.createElement("textarea");
    zoneTemp.value=text;
    zoneTemp.style.position="fixed";
    zoneTemp.style.opacity="0";
    document.body.appendChild(zoneTemp);
    zoneTemp.focus();
    zoneTemp.select();
    const succes=document.execCommand("copy");
    document.body.removeChild(zoneTemp);
    return succes;
  }catch(e){
    return false;
  }
}

// Télécharge une image : sur téléphone ouvre le menu de partage (« Enregistrer l'image »), sur ordinateur télécharge le fichier
async function telechargerImage(url,nom){
  try{
    const rep=await fetch(url);
    const blob=await rep.blob();
    const fichier=new File([blob],nom,{type:blob.type||"image/jpeg"});
    const mobile=/iPhone|iPad|Android/i.test(navigator.userAgent);
    if(mobile&&navigator.canShare&&navigator.canShare({files:[fichier]})){
      try{await navigator.share({files:[fichier]});return;}catch(e){if(e&&e.name==="AbortError")return;}
    }
    const lien=document.createElement("a");
    lien.href=URL.createObjectURL(blob);
    lien.download=nom;
    document.body.appendChild(lien);
    lien.click();
    document.body.removeChild(lien);
    setTimeout(()=>URL.revokeObjectURL(lien.href),4000);
  }catch(e){
    window.open(url,"_blank");
  }
}

// Gros bouton « Copier » (texte long à copier-coller, ex. script de vidéo)
function BoutonCopierTexte({texte,label="📋 Copier le script"}){
  const[etat,setEtat]=useState("");
  const copier=async()=>{
    const ok=await copierTexteRobuste(texte);
    setEtat(ok?"ok":"erreur");
    setTimeout(()=>setEtat(""),2500);
  };
  return(
    <button onClick={copier}
      style={{width:"100%",background:etat==="ok"?C.vert:C.brun,color:"white",border:"none",borderRadius:9,padding:".55rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginBottom:".6rem"}}>
      {etat==="ok"?"✅ Copié !":etat==="erreur"?"Copie impossible : sélectionne le texte à la main":label}
    </button>
  );
}

export function CopyBtn({text}){
  const[c,setC]=useState(false);
  const[erreur,setErreur]=useState(false);
  const copier=async()=>{
    const succes=await copierTexteRobuste(text);
    if(succes){
      setC(true);setErreur(false);
      setTimeout(()=>setC(false),2000);
    }else{
      setErreur(true);
      setTimeout(()=>setErreur(false),2500);
    }
  };
  return <button onClick={copier}
    style={{fontSize:".55rem",padding:".15rem .45rem",border:`1px solid ${c?C.vert:erreur?"#B04040":C.pale}`,borderRadius:5,background:"none",color:c?C.vert:erreur?"#B04040":C.gris,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>{c?"✓":erreur?"Échec, réessaie":"Copier"}</button>;
}

// ── POST IDEAS DATA ───────────────────────────────────────────────────────────
const POST_IDEAS = [
  {theme:"💄 Make-up & Beauté", color:C.rose, posts:[
    {id:"p1",hook:"On m'a encore demandé \"c'est quoi ton parfum ?\"",caption:"Plot twist → moins de 20€ et on me fait des compliments NON-STOP. Tu veux savoir lequel ? Écris PARFUM en commentaire 😏"},
    {id:"p2",hook:"Makeup du jour : rapide, naturel, pas besoin de 15 produits",caption:"J'utilise une mini routine makeup que je recommande souvent aux mamans pressées. Tu veux la liste des produits exacts ? Commente MAKEUP 💄"},
    {id:"p3",hook:"Toi aussi tu adores les rouges à lèvres pigmentés qui tiennent longtemps ?",caption:"Alors je pense que comme moi tu vas adorer ces petites pépites !! Tape PÉPITES je te réserve une belle surprise ❤️"},
    {id:"p4",hook:"⏰ 5 minutes. C'est le temps que je mets pour ma routine (vraiment).",caption:"Skincare + touche de makeup + parfum. Tu veux ma routine express et les produits exacts ? Écris 5MIN 💕"},
    {id:"p5",hook:"Makeup qui tient toute la journée même avec un masque ?",caption:"Oui ça existe 😂 Je vous montre ma technique en story ce soir. Restez connectées 👀"},
  ]},
  {theme:"🌿 Skincare & Soin", color:C.lilas, posts:[
    {id:"p6",hook:"💭 On parle souvent de skincare hors de prix… J'ai une routine visage SIMPLE à moins de 25€",caption:"Rien de compliqué. Rien de gadget. Juste ce qu'il faut pour une peau propre, nette et confortable. Tu veux la liste exacte ? Dis-le moi en commentaire 👇"},
    {id:"p7",hook:"On pense souvent que pour que ça marche… il faut que ce soit cher. Faux.",caption:"J'utilise des produits beaucoup plus accessibles et les résultats sont là. Tu veux voir ce que j'utilise vraiment ? Écris LISTE en commentaire."},
    {id:"p8",hook:"Prendre soin de soi ≠ se ruiner.",caption:"J'ai construit une routine complète soin + bien-être, accessible et rapide. Tu veux la liste détaillée ? Dis MOI 👇"},
    {id:"p9",hook:"Le problème ce n'est pas toi. C'est juste que ta peau n'a pas la bonne routine.",caption:"Même peau, même personne. La seule différence ? Une routine adaptée à 25€. Résultat : teint unifié, peau hydratée. Tu veux la routine ? Écris ROUTINE 👇"},
  ]},
  {theme:"💆 Bien-être & Énergie", color:C.or, posts:[
    {id:"p10",hook:"Non, je ne prends pas 12 compléments par jour.",caption:"J'ai une routine ultra simple pour l'énergie, le bien-être, me sentir mieux au quotidien. Tu veux savoir ce que je prends exactement ? Écris ROUTINE en commentaire."},
    {id:"p11",hook:"Tu te lèves fatiguée même après 8h de sommeil ?",caption:"J'étais pareille. Un truc m'a changé la vie et c'est pas du café 😂 Écris ÉNERGIE je t'explique tout 👇"},
    {id:"p12",hook:"Ventre gonflé, digestion difficile, fatigue chronique…",caption:"C'est pas une fatalité. J'ai trouvé une solution naturelle et ça m'a transformée. Qui veut en savoir plus ? 👋"},
  ]},
  {theme:"💰 Opportunité & Liberté", color:C.brun, posts:[
    {id:"p13",hook:"Je ne cherchais pas un 2ème emploi. Je cherchais quelque chose qui s'adapte à ma vie.",caption:"Aujourd'hui je travaille depuis mon canapé pendant que mes enfants dorment. Et je ne l'ai jamais regretté. Tu veux savoir comment ? Écris LIBERTÉ en commentaire 🖤"},
    {id:"p14",hook:"Mardi 15h. Je récupère mon enfant à l'école.",caption:"Pas de congés posés. Pas de permission demandée. Juste... ma vie. C'est ça que j'ai construit avec Blazing Dynasty 🖤"},
    {id:"p15",hook:"Belle journée qui commence ☀️ Appel équipe dans 1h.",caption:"J'adore ce que je fais parce que ça me ressemble. Tu es curieuse de savoir comment ? Réponds à ce message 🙂"},
    {id:"p16",hook:"La semaine a été productive 🖤",caption:"Je vous explique bientôt ce qu'il se passe dans les coulisses... Restez connectées 👀"},
    {id:"p17",hook:"On m'a demandé aujourd'hui combien je gagnais avec \"ça\".",caption:"J'ai répondu : assez pour ne plus avoir à demander de congés. Qui veut en savoir plus ? Écris ÉQUIPE en commentaire 🔥"},
  ]},
  {theme:"🌸 Storytelling & Vie perso", color:C.rose, posts:[
    {id:"p18",hook:"Il y a [X mois], j'ai pris une décision qui m'a fait peur.",caption:"Aujourd'hui je ne l'ai pas regrettée une seule fois. [Continue ton histoire authentiquement. Partage tes doutes, ta décision, où tu en es aujourd'hui.]"},
    {id:"p19",hook:"Ce que personne ne voit derrière mes posts.",caption:"Les galères, les doutes, les jours où j'avais envie d'arrêter. Je vous raconte tout parce que vous méritez la vérité, pas juste les moments parfaits."},
    {id:"p20",hook:"J'aurais aimé que quelqu'un me dise ça quand j'ai commencé.",caption:"[Partage un conseil clé que tu aurais aimé avoir. Ton expérience terrain est ton meilleur contenu.]"},
  ]},
  {theme:"🔑 Recrutement détourné", color:C.lilas, posts:[
    {id:"p21",hook:"Tu cherches un complément de revenu sans sacrifier ta famille ?",caption:"Je construis une équipe de femmes ambitieuses. Pas de stock, pas de porte-à-porte. Juste du sérieux et une vraie méthode. Écris ÉQUIPE si tu veux en savoir plus 🖤"},
    {id:"p22",hook:"3 choses que j'aurais voulu savoir avant de commencer.",caption:"1. C'est du vrai travail. 2. Ça vaut vraiment le coup. 3. Tu n'es pas seule. C'est ça Blazing Dynasty. Curiosité ? Réponds à ce message 🙂"},
    {id:"p23",hook:"Ce mois-ci j'ai gagné [montant] en travaillant depuis chez moi.",caption:"Sans boss. Sans horaires fixes. Sans sacrifier ma famille. Si tu veux comprendre comment — écris MOI en commentaire."},
  ]},
  {theme:"✨ Face Architect", color:"#9B7FA8", posts:[
    {id:"p24",hook:"Mes rides ont l'air de disparaître... et non c'est pas du filtre 😮",caption:"Le sérum que j'utilise fait vraiment la différence. C'est la gamme Face Architect de Mihi. Tu veux que je t'explique comment ça marche ? Commente VISAGE 👇"},
    {id:"p25",hook:"47 ans et on me donne 35. Mon secret en 3 produits.",caption:"Crème ExoLifting + sérum Spicule + soin contour des yeux. Moins de 80€ les 3. Tu veux les détails ? Écris ANTIAGE en commentaire ✨"},
  ]},
  {theme:"💇 Hair Architect", color:C.or, posts:[
    {id:"p26",hook:"Tes cheveux font la tête ? Secs, cassants ou carrément ternes ?",caption:"Et si je te disais qu'avec seulement 25€, tu peux leur redonner vie et brillance comme en sortant de chez le coiffeur ? Commente CHEVEUX en dessous ! 👇"},
    {id:"p27",hook:"J'ai arrêté de dépenser une fortune chez le coiffeur.",caption:"J'ai trouvé une routine capillaire qui coûte moins de 30€ et mes cheveux n'ont jamais été aussi beaux. Tu veux le nom des produits ? Écris CHEVEUX 💛"},
  ]},
];

// ── SPRINT DATA ───────────────────────────────────────────────────────────────
const SPRINT=[
  {day:1,title:"Préparer le terrain",goal:"Profil optimisé + liste des 20",focus:"rs",tasks:[
    {id:"s1a",label:"Optimiser ta bio (photo + description + lien)"},
    {id:"s1b",label:"Poster une story d'énergie — pas de pitch"},
    {id:"s1c",label:"Écrire et classer ta liste des 20 contacts"},
    {id:"s1d",label:"Liker 10 publications de ta cible",script:'"Cette semaine je me fixe un défi. Je vous tiens au courant 🔥"'},
  ]},
  {day:2,title:"Premiers contacts chauds",goal:"3 messages + 1 conversation",focus:"bao",tasks:[
    {id:"s2a",label:'3 messages WhatsApp personnels aux contacts "Chauds"',script:'"Coucou [Prénom], je pense à toi. Je développe quelque chose qui te correspondrait peut-être. 3 min à regarder ? 🙂"'},
    {id:"s2b",label:"Story vie quotidienne sans pitch"},
    {id:"s2c",label:"Répondre à toutes les réactions en DM"},
  ]},
  {day:3,title:"Contenu d'attraction",goal:"1 Reel publié + réponses mot-clé",focus:"rs",tasks:[
    {id:"s3a",label:"Créer et publier un Reel avec CTA mot-clé",script:'"Je ne cherchais pas un 2ᵉ emploi. Je cherchais quelque chose qui s\'adapte à ma vie. Écris ÉQUIPE en commentaire 🖤"'},
    {id:"s3b",label:"DM à chaque personne qui répond avec le mot-clé"},
    {id:"s3c",label:'Relancer 1–2 personnes sans réponse hier',script:'"Coucou ! Pas de souci si tu es occupée — je te laisse regarder quand t\'as 5 min 🙂"'},
  ]},
  {day:4,title:"Présenter l'opportunité",goal:"1 présentation + 5 contacts relancés",focus:"mix",tasks:[
    {id:"s4a",label:"Faire 1 présentation complète (15–30 min)",script:'"J\'ai commencé parce que j\'avais besoin de quelque chose qui s\'adapte à ma vie. Ce n\'est pas un schéma miracle — c\'est du travail qui a du sens."'},
    {id:"s4b",label:"3 nouveaux messages aux contacts Tièdes"},
    {id:"s4c",label:'Story "résultat flou" — sans tout dévoiler'},
  ]},
  {day:5,title:"Amplifier la portée",goal:"2 recommandations + 1 témoignage",focus:"mix",tasks:[
    {id:"s5a",label:"Demander à 2–3 amies de partager ta publication"},
    {id:"s5b",label:'À celles qui ont décliné : "Tu connais quelqu\'un ?"',script:'"Pas de souci ! Est-ce que tu aurais quelqu\'un dans ton entourage qui cherche un revenu complémentaire ? 🙂"'},
    {id:"s5c",label:"Post témoignage produit authentique"},
  ]},
  {day:6,title:"Café ou Zoom découverte",goal:"Événement réalisé + suivi envoyé",focus:"bao",tasks:[
    {id:"s6a",label:"Organiser un café ou Zoom 30–45 min avec 3–5 personnes"},
    {id:"s6b",label:"Présenter ton histoire + les 3 façons d'entrer"},
    {id:"s6c",label:"Suivi individuel à chaque participante dans les 2h",script:'"Merci d\'avoir pris le temps ce soir 🧡 Je suis là si tu as des questions. Pas de pression."'},
  ]},
  {day:7,title:"Bilan & relances",goal:"Bilan chiffré + plan semaine 2",focus:"mix",tasks:[
    {id:"s7a",label:"Compter : contacts · réponses · présentations · recrues"},
    {id:"s7b",label:'Relancer les personnes "en réflexion"',script:'"Coucou ! Je voulais prendre des nouvelles 🙂 Pas de pression — je suis là si tu veux avancer."'},
    {id:"s7c",label:"Story de bilan + planifier la semaine 2"},
  ]},
];

// ── CITATIONS DU JOUR ─────────────────────────────────────────────────────────
export const CITATIONS_DEFAULT=[
  "Le succès, c'est tomber 7 fois et se relever 8.",
  "Chaque jour est une nouvelle chance de changer ta vie.",
  "La discipline, c'est se rappeler ce que tu veux vraiment.",
  "Tu n'as pas besoin d'être parfaite, juste constante.",
  "Le doute tue plus de rêves que l'échec jamais ne le fera.",
  "Petit pas par petit pas, on construit de grandes choses.",
  "Ton énergie d'aujourd'hui dessine ton avenir de demain.",
  "Crois en toi, même quand personne d'autre ne le fait.",
  "La motivation te lance. L'habitude te fait tenir.",
  "Tu es plus forte que ce que tu penses.",
  "Le meilleur moment pour commencer, c'était hier. Le 2ème, c'est maintenant.",
  "Chaque 'non' te rapproche d'un 'oui'.",
  "La constance bat le talent quand le talent ne travaille pas.",
  "Sois fière de chaque petit progrès — c'est ainsi que naissent les grands changements.",
  "Ton futur toi te remerciera pour les efforts d'aujourd'hui.",
  "Les femmes fortes lèvent les autres femmes en se levant elles-mêmes.",
  "Ce n'est pas le temps qui manque, c'est la décision qui compte.",
  "Une graine plantée chaque jour devient une forêt.",
  "Ta différence est ta force, pas ta faiblesse.",
  "Avance à ton rythme — l'important c'est de ne jamais reculer.",
  "L'échec n'est qu'une information : il te dit ce qu'il faut ajuster.",
  "Les grandes histoires commencent toujours par un petit 'je vais essayer'.",
  "Investir en toi-même est le meilleur placement que tu feras jamais.",
  "Le travail discret d'aujourd'hui devient le résultat visible de demain.",
  "Sois la raison pour laquelle quelqu'un croit encore en la bonté et la persévérance.",
  "Chaque expert a un jour été débutant.",
  "Ta vie peut changer en une décision — celle de continuer.",
  "On ne grandit pas dans la zone de confort.",
  "Le secret pour avancer, c'est de commencer.",
  "Fais aujourd'hui ce que les autres ne font pas, pour avoir demain ce que les autres n'auront pas.",
  "Tu ne perds jamais vraiment — tu apprends ou tu gagnes.",
  "Une femme qui se lève chaque matin pour ses rêves est déjà une gagnante.",
  "Ton rythme n'a pas à ressembler à celui de quelqu'un d'autre.",
  "La patience n'est pas l'attente passive — c'est l'action continue.",
  "Choisis-toi, encore et encore.",
  "Les rêves ne fonctionnent que si tu fonctionnes.",
  "Aujourd'hui, fais un pas — même tout petit.",
  "Ta valeur ne dépend pas de ta productivité, mais ton avenir en dépend un peu.",
  "Le courage, c'est d'avancer même quand on a peur.",
  "On ne devient pas confiante en attendant — on le devient en agissant.",
  "Si ce n'était pas difficile, tout le monde le ferait.",
  "Le changement commence à la fin de ta zone de confort.",
  "Sois la version de toi que tu admirerais.",
  "Construire quelque chose qui dure prend du temps — et c'est normal.",
  "Ne compare pas ton chapitre 1 au chapitre 20 de quelqu'un d'autre.",
  "Une décision aujourd'hui peut changer toute ta trajectoire.",
  "Les obstacles sont souvent les détours qui mènent au bon endroit.",
  "Ton 'pourquoi' doit être plus fort que tes excuses.",
  "Le succès silencieux d'aujourd'hui sera la victoire visible de demain.",
  "Tu n'as pas à tout savoir pour commencer — juste à commencer.",
  "Avance même si c'est imparfait. Le mouvement crée la clarté.",
  "Plus tu sèmes, plus tu récoltes — sois patiente avec la croissance.",
  "Tu es la PDG de ta vie. Agis en conséquence.",
  "Le repos fait partie du progrès — prends-en sans culpabiliser.",
  "Une routine simple, répétée chaque jour, change une vie entière.",
  "Les femmes qui réussissent ne sont pas parfaites — elles sont déterminées.",
  "Ose demander, ose proposer, ose avancer.",
  "Ton énergie attire ce qui te ressemble — reste alignée.",
  "Fais-le avec amour, même les jours difficiles.",
  "Chaque client que tu aides, c'est une vie que tu touches.",
  "La liberté se construit une action à la fois.",
  "Ne laisse pas un mauvais jour devenir une mauvaise semaine.",
  "Ton parcours inspire plus de gens que tu ne le crois.",
  "L'authenticité attire plus que la perfection.",
  "Sois patiente avec toi-même — tu apprends quelque chose de nouveau chaque jour.",
  "La régularité transforme l'ordinaire en extraordinaire.",
  "Une bonne journée commence par une bonne décision dès le réveil.",
  "Tu construis ton empire une conversation à la fois.",
  "Le plus dur, c'est de commencer. Le reste suit.",
  "Si ton rêve ne te fait pas un peu peur, il n'est peut-être pas assez grand.",
  "Sois reconnaissante pour où tu es, ambitieuse pour où tu vas.",
  "Ce que tu fais aujourd'hui compte, même si ça ne se voit pas encore.",
  "Les femmes qui se soutiennent vont plus loin, ensemble.",
  "Reste fidèle à ton histoire — c'est elle qui touche les gens.",
  "On ne sait jamais quelle conversation va tout changer.",
  "Ta confiance grandit chaque fois que tu agis malgré la peur.",
  "Un petit progrès chaque jour donne de grands résultats avec le temps.",
  "Le travail acharné bat le talent quand le talent ne travaille pas.",
  "Donne-toi le droit d'évoluer, de changer d'avis, de grandir.",
  "Sois celle qui essaie, même si elle n'est pas sûre de réussir.",
  "La meilleure publicité, c'est ton enthousiasme sincère.",
  "Une cliente satisfaite en parle à 3 personnes. Une cliente transformée en parle à 30.",
  "Ne minimise jamais l'impact d'un simple message envoyé avec le cœur.",
  "Ton authenticité est ton meilleur argument de vente.",
  "La vente, c'est de l'attention donnée avant d'être reçue.",
  "Sers d'abord, vends ensuite — la confiance fera le reste.",
  "Les grandes équipes se construisent une personne à la fois, avec patience.",
  "Un leader, c'est quelqu'un qui montre le chemin en marchant devant.",
  "Aide quelqu'un à réussir et tu réussiras toi-même.",
  "Ta lumière peut allumer celle de quelqu'un d'autre — partage-la.",
  "Les femmes qui osent sont celles qui changent leur vie.",
  "Une habitude positive aujourd'hui est un cadeau pour ta toi de demain.",
  "Le succès n'est pas linéaire — accepte les hauts et les bas.",
  "Ce que tu sèmes en silence, tu le récolteras en lumière.",
  "Donne du sens à chaque action, même la plus petite.",
  "Sois fière du chemin parcouru, même s'il reste du chemin à faire.",
  "Aujourd'hui est un excellent jour pour recommencer, si besoin.",
  "Ta présence à elle seule peut inspirer quelqu'un aujourd'hui.",
  "Le plus grand risque, c'est de ne jamais essayer.",
  "Concentre-toi sur le progrès, pas sur la perfection.",
  "Un 'pas encore' n'est pas un 'jamais'.",
  "Tu mérites le succès que tu travailles si dur pour obtenir.",
  "Les meilleures opportunités se cachent souvent dans l'inconfort.",
  "Garde ton cap, même quand le vent change.",
  "Une vie extraordinaire est faite de jours ordinaires bien vécus.",
  "Sois la femme que ta fille ou ton fils admirera plus tard.",
  "Chaque grand changement a commencé par une personne qui a osé.",
  "Le bonheur n'est pas une destination — c'est une façon de voyager.",
  "Tu as déjà survécu à 100% de tes pires journées. Continue.",
  "Ce que tu fais avec constance devient ce que tu es.",
  "Une bonne énergie attire de bonnes opportunités.",
  "Les détails font la différence — prends soin des petites choses.",
  "L'audace paie, même quand elle fait peur.",
  "Le travail que tu fais en privé crée le résultat que tout le monde voit.",
  "Avancer lentement vaut mieux que ne pas avancer du tout.",
  "Crois dans ton projet autant que tu voudrais que les autres y croient.",
  "Une bonne nouvelle peut arriver à n'importe quel moment — reste prête.",
  "Sois reconnaissante chaque jour pour 3 choses, même petites.",
  "La gratitude transforme ce que tu as en suffisant.",
  "Le futur appartient à celles qui se préparent aujourd'hui.",
  "Chaque jour, choisis d'être un peu meilleure qu'hier.",
  "Ton rêve ne périmera pas — alors prends ton temps mais avance.",
  "La vraie force, c'est de continuer même quand c'est dur.",
  "Plus tu donnes de valeur, plus tu en reçois en retour.",
  "Une décision prise avec le cœur est rarement une erreur.",
  "Le succès aime la cohérence plus que l'intensité.",
  "Sois patiente : les graines ne deviennent pas des arbres en un jour.",
  "Ta vulnérabilité partagée peut devenir la force de quelqu'un d'autre.",
  "Aujourd'hui, fais quelque chose que ta future toi te remerciera d'avoir fait.",
  "L'important n'est pas où tu commences, mais où tu choisis d'aller.",
  "Un esprit positif attire des résultats positifs.",
  "Ose être vue, même imparfaite.",
  "Une vie pleine commence par des choix alignés avec tes valeurs.",
  "La meilleure version de toi t'attend du côté de l'effort.",
  "Quand tu doutes, regarde tout le chemin déjà parcouru.",
  "Les femmes inspirantes ne sont pas sans peur — elles avancent avec.",
  "Ne renonce pas à un bon rêve à cause d'une mauvaise journée.",
  "Construire un business, c'est construire sa liberté, jour après jour.",
  "Le respect de soi commence par tenir ses propres promesses.",
  "Un jour à la fois suffit — pas besoin de tout voir d'un coup.",
  "La beauté de recommencer, c'est qu'on peut le faire à chaque instant.",
  "Sois douce avec toi-même — tu fais de ton mieux avec ce que tu as.",
  "Le progrès imparfait vaut mieux que l'inaction parfaite.",
  "Crois en la magie des nouveaux départs.",
  "Un sourire sincère peut ouvrir des portes que les mots ne peuvent pas.",
  "Le succès, c'est aussi savoir s'arrêter pour se reposer sans culpabilité.",
  "Reste curieuse — c'est elle qui fait grandir tes compétences.",
  "Une petite victoire aujourd'hui mérite d'être célébrée.",
  "Ta façon unique de faire les choses est précisément ce qui te distingue.",
  "Le temps que tu investis en toi n'est jamais perdu.",
  "Avance avec foi, même sans toutes les réponses.",
  "La meilleure énergie, c'est celle qui inspire sans épuiser.",
  "Chaque conversation est une graine — certaines mettent du temps à germer.",
  "Sois fière de demander de l'aide — c'est un signe de force, pas de faiblesse.",
  "Un esprit reposé prend de meilleures décisions.",
  "Le succès partagé est un succès multiplié.",
  "Ta voix compte — utilise-la pour inspirer.",
  "Le travail d'équipe transforme les rêves individuels en réalité collective.",
  "Une bonne organisation aujourd'hui t'offre de la liberté demain.",
  "Apprends de chaque expérience — même de celles qui n'ont pas marché.",
  "Le succès n'est pas un sprint, c'est un marathon avec de bonnes chaussures.",
  "Sois reconnaissante pour les personnes qui croient en toi.",
  "La vraie richesse, c'est le temps que tu choisis pour toi-même.",
  "Un objectif écrit a beaucoup plus de chances de se réaliser.",
  "Célèbre les progrès de tes collègues comme les tiens.",
  "Une journée productive commence souvent par une bonne nuit de sommeil.",
  "Tu n'as pas besoin de la permission de quiconque pour réussir.",
  "Le doute est normal — l'action malgré le doute, c'est le courage.",
  "Sois fière de ton parcours, même les chapitres difficiles.",
  "Les graines plantées dans la difficulté donnent souvent les plus belles fleurs.",
  "Aujourd'hui compte, même si demain semble plus important.",
  "La persévérance transforme l'impossible en inévitable.",
  "Avance avec gratitude, pas avec pression.",
  "Ton intuition est souvent plus sage que tu ne le penses.",
  "Le succès attire le succès — commence petit, mais commence.",
  "Une bonne attitude vaut souvent plus qu'une bonne stratégie sans elle.",
  "Reste alignée avec tes valeurs, même quand c'est plus difficile.",
  "Le travail que tu fais aujourd'hui construit la confiance de demain.",
  "Une femme qui aide une autre femme construit un monde meilleur.",
  "Sois généreuse avec ton sourire — il ne coûte rien et vaut beaucoup.",
  "L'inspiration vient en agissant, pas en attendant.",
  "Tu es exactement où tu dois être pour grandir vers où tu veux aller.",
  "Le succès aime ceux qui se montrent, même les jours difficiles.",
  "Avance vers tes rêves un appel, un message, une action à la fois.",
  "La confiance se construit en tenant ses engagements envers soi-même.",
  "Ne sous-estime jamais l'impact d'un mot encourageant.",
  "Le bonheur authentique se voit — et il attire.",
  "Sois la femme qui se relève, encore et encore.",
  "Ta détermination d'aujourd'hui façonne ton histoire de demain.",
  "Apprends à célébrer les petites victoires — elles construisent les grandes.",
  "Le succès, c'est faire ce qu'il faut, même quand personne ne regarde.",
  "Une vie épanouie est faite de choix alignés, jour après jour.",
  "Crois en ton projet même quand tu es la seule à y croire.",
  "Le meilleur investissement, c'est celui que tu fais sur toi-même.",
  "Avance vers la lumière, même à petits pas.",
  "Une équipe soudée peut accomplir bien plus que des individus seuls.",
  "Sois patiente envers ton évolution — Rome ne s'est pas faite en un jour.",
  "Le travail discret paie toujours, tôt ou tard.",
  "Reste fidèle à ta mission, même quand le chemin est sinueux.",
  "Une cliente bien accompagnée devient une amie fidèle.",
  "La gratitude attire l'abondance.",
  "Sois ouverte aux opportunités qui se présentent sous une forme inattendue.",
  "Le courage de commencer est souvent plus grand que celui de continuer.",
  "Avance avec confiance — même les experts ont commencé par un premier pas.",
  "Le succès se construit en coulisses, longtemps avant d'être visible.",
  "Garde le sourire — il influence ta journée plus que tu ne le penses.",
  "La discipline aujourd'hui est la liberté de demain.",
  "Sois fière de chaque message envoyé, chaque appel passé, chaque effort fait.",
  "Le changement que tu cherches commence souvent par un petit geste.",
  "Avance malgré la fatigue — le repos viendra, mais d'abord, l'action.",
  "Ta réussite peut être la preuve dont quelqu'un d'autre a besoin pour croire.",
  "Le succès aime les femmes qui n'abandonnent pas après un 'non'.",
  "Sois reconnaissante pour les leçons, même celles qui ont fait mal.",
  "Une bonne énergie matinale donne le ton de toute la journée.",
  "Le progrès se mesure en mois et en années, pas en heures.",
  "Avance vers ton 'pourquoi' chaque jour, même imparfaitement.",
  "La confiance vient en répétant ce qui te fait peur jusqu'à ce que ça ne le soit plus.",
  "Sois fière d'être différente — c'est ce qui te rend mémorable.",
  "Le succès, c'est continuer même quand les résultats se font attendre.",
  "Une femme déterminée trouve toujours un chemin.",
  "Avance avec le cœur — les chiffres suivront.",
  "La meilleure version de toi grandit chaque jour, même invisiblement.",
  "Sois douce avec ton rythme — il est unique, et c'est correct.",
  "Le travail que tu fais aujourd'hui a un impact que tu ne mesures pas encore.",
  "Avance avec foi en l'avenir et discipline dans le présent.",
  "Une bonne habitude vaut mieux qu'une grande motivation ponctuelle.",
  "Sois reconnaissante envers la personne que tu étais — elle a fait de son mieux.",
  "Le succès n'attend pas la perfection — il aime l'action.",
  "Avance, même si tu ne vois pas encore la ligne d'arrivée.",
  "La vraie liberté, c'est choisir comment tu passes ton temps.",
  "Sois fière de toi pour avoir essayé, peu importe le résultat.",
  "Le succès se cultive comme un jardin — avec patience et constance.",
  "Avance avec gratitude pour ce que tu as et ambition pour ce que tu veux.",
  "Une bonne action aujourd'hui peut changer le cours de ta semaine.",
  "Sois la lumière dont quelqu'un d'autre a besoin aujourd'hui.",
  "Le succès récompense ceux qui restent quand c'est difficile.",
  "Avance vers tes rêves même quand le chemin semble flou.",
  "La confiance en soi se construit une petite victoire à la fois.",
  "Sois fière de ton authenticité — elle attire les bonnes personnes.",
  "Le succès aime la régularité plus que les grands sprints occasionnels.",
  "Avance avec le sourire — même les jours difficiles ont une fin.",
  "Une bonne nouvelle peut arriver juste après le moment où tu voulais abandonner.",
  "Sois patiente : la croissance la plus belle est souvent la plus lente.",
  "Le succès se construit jour après jour, action après action.",
  "Avance avec courage — la peur ne disparaît pas, mais elle s'apaise avec l'action.",
  "La vraie force, c'est de se relever après chaque chute, encore et encore.",
  "Sois fière de chaque étape, même les plus petites.",
  "Le succès n'a pas d'horaire — continue d'avancer à ton rythme.",
  "Avance vers la version de toi que tu rêves de devenir.",
  "Une attitude positive transforme les obstacles en opportunités.",
  "Sois reconnaissante pour aujourd'hui — c'est un cadeau.",
  "Le succès aime celles qui croient en elles avant même d'avoir des preuves.",
  "Avance avec détermination — chaque pas compte, même invisible.",
  "La meilleure façon de prédire ton avenir, c'est de le créer.",
  "Sois fière de ton parcours unique — personne d'autre ne peut le vivre comme toi.",
  "Le succès commence souvent par une décision simple : continuer.",
  "Avance avec confiance — tu as déjà tout ce qu'il faut pour réussir.",
  "Une vie pleine de sens commence par des actions alignées avec ton cœur.",
  "Sois patiente avec le processus — les meilleures choses prennent du temps.",
  "Le succès aime ceux qui se présentent, jour après jour, sans exception.",
  "Avance avec gratitude pour le chemin parcouru et excitation pour celui à venir.",
  "La vraie réussite se mesure aussi en sourires donnés et en vies touchées.",
  "Sois fière de ta croissance, même si elle est invisible aux yeux des autres.",
  "Le succès, c'est l'addition de tous les jours où tu as choisi de continuer.",
  "Avance avec amour pour ce que tu fais — ça se ressent toujours.",
  "Une bonne journée commence par une bonne intention.",
  "Sois reconnaissante pour les défis — ils te font grandir.",
  "Le succès aime la cohérence plus que la perfection.",
  "Avance vers tes objectifs avec patience et persévérance.",
  "La meilleure motivation, c'est de se rappeler pourquoi tu as commencé.",
  "Sois fière de toi pour être arrivée jusqu'ici.",
  "Le succès, c'est avancer même quand on ne voit pas encore les résultats.",
  "Avance avec foi — les graines plantées aujourd'hui fleuriront demain.",
  "Une femme inspirée inspire d'autres femmes.",
  "Sois patiente avec ton évolution — chaque jour compte.",
  "Le succès aime celles qui restent fidèles à elles-mêmes.",
  "Avance avec gratitude — chaque jour est une nouvelle opportunité.",
  "La vraie force vient de l'intérieur — nourris-la chaque jour.",
  "Sois fière de ton chemin, même s'il est différent de celui des autres.",
  "Le succès, c'est continuer d'avancer même à petits pas.",
  "Avance avec confiance vers la vie que tu mérites.",
  "Une bonne énergie attire de bonnes personnes et de bonnes opportunités.",
  "Sois reconnaissante pour chaque opportunité, même les plus petites.",
  "Le succès aime celles qui osent rêver grand et agir petit, chaque jour.",
  "Avance avec le cœur ouvert et l'esprit déterminé.",
  "La meilleure version de toi est à un choix de distance.",
  "Sois fière de ton courage — même quand il est invisible aux autres.",
  "Le succès, c'est la somme de tous les efforts que personne ne voit.",
  "Avance avec espoir — demain est plein de possibilités.",
  "Une vie extraordinaire commence par des choix ordinaires répétés.",
  "Sois patiente — le meilleur est souvent à venir.",
  "Le succès aime celles qui ne renoncent jamais à leurs rêves.",
  "Avance avec gratitude pour aujourd'hui et espoir pour demain.",
  "Ta passion d'aujourd'hui est le métier de demain.",
  "Une femme qui se lève après chaque chute devient inarrêtable.",
  "Le succès commence dans ta tête, avant de se voir dans tes résultats.",
  "Avance avec le sourire, même les jours gris.",
  "Sois fière du chemin, pas seulement de la destination.",
  "Une petite graine de constance donne un grand arbre de résultats.",
  "Ton rythme est le bon rythme, tant que tu avances.",
  "Le courage n'attend pas que la peur disparaisse — il avance avec elle.",
  "Chaque jour est une page blanche — écris-la avec intention.",
  "La meilleure énergie est celle qu'on choisit, pas celle qu'on subit.",
  "Sois la preuve vivante que le changement est possible.",
  "Un esprit reconnaissant trouve toujours une raison de sourire.",
  "Avance, même lentement — l'essentiel est de ne pas t'arrêter.",
  "Ta lumière intérieure ne dépend pas du regard des autres.",
  "Le succès se construit dans les habitudes du quotidien.",
  "Sois douce avec toi-même comme tu le serais avec une amie.",
  "Chaque relance est une preuve de ta détermination.",
  "La confiance grandit chaque fois que tu choisis d'agir.",
  "Avance avec ton cœur — il connaît souvent le chemin.",
  "Le futur se construit une décision à la fois, aujourd'hui.",
  "Le succès, c'est tomber 7 fois et se relever 8 Continue.",
  "Chaque jour est une nouvelle chance de changer ta vie Continue.",
  "La discipline, c'est se rappeler ce que tu veux vraiment Continue.",
  "Tu n'as pas besoin d'être parfaite, juste constante Continue.",
  "Le doute tue plus de rêves que l'échec jamais ne le fera Continue.",
  "Petit pas par petit pas, on construit de grandes choses Continue.",
  "Ton énergie d'aujourd'hui dessine ton avenir de demain Continue.",
  "Crois en toi, même quand personne d'autre ne le fait Continue.",
  "La motivation te lance. L'habitude te fait tenir Continue.",
  "Tu es plus forte que ce que tu penses Continue.",
  "Le meilleur moment pour commencer, c'était hier. Le 2ème, c'est maintenant Continue.",
  "Chaque 'non' te rapproche d'un 'oui' Continue.",
  "La constance bat le talent quand le talent ne travaille pas Continue.",
  "Sois fière de chaque petit progrès — c'est ainsi que naissent les grands changements Continue.",
  "Ton futur toi te remerciera pour les efforts d'aujourd'hui Continue.",
  "Les femmes fortes lèvent les autres femmes en se levant elles-mêmes Continue.",
  "Ce n'est pas le temps qui manque, c'est la décision qui compte Continue.",
  "Une graine plantée chaque jour devient une forêt Continue.",
  "Ta différence est ta force, pas ta faiblesse Continue.",
  "Avance à ton rythme — l'important c'est de ne jamais reculer Continue.",
  "L'échec n'est qu'une information : il te dit ce qu'il faut ajuster Continue.",
  "Les grandes histoires commencent toujours par un petit 'je vais essayer' Continue.",
  "Investir en toi-même est le meilleur placement que tu feras jamais Continue.",
  "Le travail discret d'aujourd'hui devient le résultat visible de demain Continue.",
  "Sois la raison pour laquelle quelqu'un croit encore en la bonté et la persévérance Continue.",
  "Chaque expert a un jour été débutant Continue.",
  "Ta vie peut changer en une décision — celle de continuer Continue.",
  "On ne grandit pas dans la zone de confort Continue.",
  "Le secret pour avancer, c'est de commencer Continue.",
  "Fais aujourd'hui ce que les autres ne font pas, pour avoir demain ce que les autres n'auront pas Continue.",
  "Tu ne perds jamais vraiment — tu apprends ou tu gagnes Continue.",
  "Une femme qui se lève chaque matin pour ses rêves est déjà une gagnante Continue.",
  "Ton rythme n'a pas à ressembler à celui de quelqu'un d'autre Continue.",
  "La patience n'est pas l'attente passive — c'est l'action continue Continue.",
  "Choisis-toi, encore et encore Continue.",
  "Les rêves ne fonctionnent que si tu fonctionnes Continue.",
  "Aujourd'hui, fais un pas — même tout petit Continue.",
  "Ta valeur ne dépend pas de ta productivité, mais ton avenir en dépend un peu Continue.",
  "Le courage, c'est d'avancer même quand on a peur Continue.",
  "On ne devient pas confiante en attendant — on le devient en agissant Continue.",
  "Si ce n'était pas difficile, tout le monde le ferait Continue.",
  "Le changement commence à la fin de ta zone de confort Continue.",
  "Sois la version de toi que tu admirerais Continue.",
  "Construire quelque chose qui dure prend du temps — et c'est normal Continue.",
  "Ne compare pas ton chapitre 1 au chapitre 20 de quelqu'un d'autre Continue.",
  "Une décision aujourd'hui peut changer toute ta trajectoire Continue.",
  "Les obstacles sont souvent les détours qui mènent au bon endroit Continue.",
  "Ton 'pourquoi' doit être plus fort que tes excuses Continue.",
  "Le succès silencieux d'aujourd'hui sera la victoire visible de demain Continue.",
  "Tu n'as pas à tout savoir pour commencer — juste à commencer Continue.",
  "Avance même si c'est imparfait. Le mouvement crée la clarté Continue.",
  "Plus tu sèmes, plus tu récoltes — sois patiente avec la croissance Continue.",
];

function getCitationDuJour(citations){
  const list=(citations&&citations.length>0)?citations:CITATIONS_DEFAULT;
  const today=new Date();
  const dayOfYear=Math.floor((today-new Date(today.getFullYear(),0,0))/86400000);
  return list[dayOfYear%list.length];
}

// ── MAIN APP ──────────────────────────────────────────────────────────────────
// ── CHALLENGE DÉCOUVERTE APP — 7 JOURS ───────────────────────────────────────
// ---- CHALLENGES : un document par challenge (anti-ecrasement) ----
export async function chargerChallenges(){
  const out = [];
  try{
    const snap = await getDocs(collection(db,"challenges","liste","items"));
    snap.forEach(d=>out.push(d.data()));
  }catch(e){ console.error("chargerChallenges:", e); }
  try{
    const legacy = await getDoc(doc(db,"challenges","liste"));
    if(legacy.exists()){
      const anciens = legacy.data().items || [];
      anciens.forEach(a=>{ if(a && a.id && !out.some(x=>x.id===a.id)) out.push(a); });
    }
  }catch(e){}
  return out;
}

export async function chargerLiensTelegramEquipe(){
  try{
    const snap=await getDoc(doc(db,"equipe","liens_telegram"));
    if(snap.exists())return snap.data().liste||[];
  }catch(e){ console.error("chargerLiensTelegramEquipe:", e); }
  return [];
}

export async function sauverLiensTelegramEquipe(liste){
  await setDoc(doc(db,"equipe","liens_telegram"),{liste});
}

export async function chargerDeclarations(){
  const res = {};
  try{
    const snap = await getDocs(collection(db,"challenges","declarations","items"));
    snap.forEach(d=>{ res[d.id] = d.data().liste || []; });
  }catch(e){ console.error("chargerDeclarations:", e); }
  try{
    const legacy = await getDoc(doc(db,"challenges","declarations"));
    if(legacy.exists()){
      Object.entries(legacy.data()).forEach(([k,v])=>{
        if(!res[k] && Array.isArray(v)) res[k] = v;
      });
    }
  }catch(e){}
  return res;
}

// ═══════════ ENTRAIDE LIENS (systeme independant, collections dediees) ═══════════
export async function chargerLiensDuJour(date=todayLocalStr()){
  try{
    const snap=await getDoc(doc(db,"entraide_liens","liens_du_jour","items",date));
    if(snap.exists())return snap.data().liste||[];
  }catch(e){ console.error("chargerLiensDuJour:", e); }
  return [];
}

// Recupere les liens des 2 jours precedents (pour le rattrapage), en ne gardant que ceux encore dans la fenetre de 72h
export async function chargerLiensRattrapage(){
  const resultats=[];
  for(let i=1;i<=2;i++){
    const dd=new Date(); dd.setDate(dd.getDate()-i);
    const cle=dd.toISOString().slice(0,10);
    const liste=await chargerLiensDuJour(cle);
    liste.forEach(l=>resultats.push({...l,dateSource:cle}));
  }
  const limite=Date.now()-72*3600000;
  return resultats.filter(l=>l.ts>=limite);
}

export async function chargerActiviteEntraide(uid){
  try{
    const snap=await getDoc(doc(db,"entraide_liens","activite","items",uid));
    if(snap.exists())return snap.data().historique||{};
  }catch(e){ console.error("chargerActiviteEntraide:", e); }
  return {};
}

export async function chargerSuspendusEntraide(){
  try{
    const snap=await getDoc(doc(db,"entraide_liens","suspendus"));
    if(snap.exists())return snap.data().liste||[];
  }catch(e){ console.error("chargerSuspendusEntraide:", e); }
  return [];
}

// Calcule si l'utilisateur est actuellement bloque (abus repete : liens postes 2 jours de suite sans jamais booster)
export function calculerBlocageEntraide(historique){
  const jours=[];
  const d=new Date();
  for(let i=1;i<=7;i++){
    const dd=new Date(d); dd.setDate(dd.getDate()-i);
    const cle=dd.toISOString().slice(0,10);
    jours.push(historique[cle]||{postes:0,boosts:0});
  }
  let streakAbus=0;
  for(const j of jours){
    if(j.postes>0&&j.boosts===0)streakAbus++;
    else break;
  }
  return streakAbus>=2;
}

export async function ajouterLienEntraide(uid,nom,url){
  const date=todayLocalStr();
  const liste=await chargerLiensDuJour();
  const id=uid+"_"+Date.now();
  liste.push({id,uid,nom,url,ts:Date.now(),boostePar:[]});
  await setDoc(doc(db,"entraide_liens","liens_du_jour","items",date),{liste});
  const hist=await chargerActiviteEntraide(uid);
  hist[date]={postes:(hist[date]?.postes||0)+1,boosts:hist[date]?.boosts||0};
  await setDoc(doc(db,"entraide_liens","activite","items",uid),{historique:hist});
  return liste;
}

export async function boosterLienEntraide(boosterUid,lienId,dateSource=todayLocalStr()){
  const date=todayLocalStr();
  const liste=await chargerLiensDuJour(dateSource);
  const lien=liste.find(l=>l.id===lienId);
  if(!lien||lien.boostePar.includes(boosterUid))return liste;
  lien.boostePar=[...lien.boostePar,boosterUid];
  await setDoc(doc(db,"entraide_liens","liens_du_jour","items",dateSource),{liste});
  const hist=await chargerActiviteEntraide(boosterUid);
  hist[date]={postes:hist[date]?.postes||0,boosts:(hist[date]?.boosts||0)+1};
  await setDoc(doc(db,"entraide_liens","activite","items",boosterUid),{historique:hist});
  return liste;
}

export async function supprimerLienEntraide(uid,lienId,dateSource=todayLocalStr()){
  const liste=await chargerLiensDuJour(dateSource);
  const nouvelleListe=liste.filter(l=>l.id!==lienId);
  await setDoc(doc(db,"entraide_liens","liens_du_jour","items",dateSource),{liste:nouvelleListe});
  const hist=await chargerActiviteEntraide(uid);
  if(hist[dateSource])hist[dateSource]={...hist[dateSource],postes:Math.max(0,(hist[dateSource].postes||0)-1)};
  await setDoc(doc(db,"entraide_liens","activite","items",uid),{historique:hist});
  return nouvelleListe;
}

export async function suspendreEntraide(uid,nom,parQui){
  const liste=await chargerSuspendusEntraide();
  if(liste.some(s=>s.uid===uid))return liste;
  const nouvelleListe=[...liste,{uid,nom,depuisLe:Date.now(),parQui}];
  await setDoc(doc(db,"entraide_liens","suspendus"),{liste:nouvelleListe});
  return nouvelleListe;
}

export async function reactiverEntraide(uid){
  const liste=await chargerSuspendusEntraide();
  const nouvelleListe=liste.filter(s=>s.uid!==uid);
  await setDoc(doc(db,"entraide_liens","suspendus"),{liste:nouvelleListe});
  return nouvelleListe;
}

export async function chargerObjectifCommun(){
  try{
    const snap=await getDoc(doc(db,"objectif_commun","actuel"));
    if(snap.exists())return snap.data();
  }catch(e){ console.error("chargerObjectifCommun:", e); }
  return null;
}

export async function chargerParticipantsObjectif(){
  try{
    const snap=await getDoc(doc(db,"objectif_commun","participants"));
    if(snap.exists())return snap.data().liste||[];
  }catch(e){ console.error("chargerParticipantsObjectif:", e); }
  return [];
}

export async function enregistrerObjectifCommun(obj){
  await setDoc(doc(db,"objectif_commun","actuel"),obj);
  await setDoc(doc(db,"objectif_commun","participants"),{liste:[]});
}

export async function supprimerObjectifCommun(){
  await deleteDoc(doc(db,"objectif_commun","actuel"));
  await deleteDoc(doc(db,"objectif_commun","participants"));
}

export async function ajouterPasObjectif(uid,nomAffiche,quantite=1){
  const participants=await chargerParticipantsObjectif();
  const qte=Math.max(1,Math.round(+quantite)||1);
  const dejaLa=participants.find(p=>p.uid===uid);
  const nouvelleListe=dejaLa
    ? participants.map(p=>p.uid===uid?{...p,pas:qte,date:Date.now()}:p)
    : [...participants,{uid,nom:nomAffiche||"",pas:qte,date:Date.now()}];
  await setDoc(doc(db,"objectif_commun","participants"),{liste:nouvelleListe});
  return nouvelleListe;
}

export async function supprimerAnnonce(id){
  await deleteDoc(doc(db,"annonces_historique",String(id)));
  try{
    const curSnap=await getDoc(doc(db,"equipe","derniere-annonce"));
    if(curSnap.exists()&&String(curSnap.data().id)===String(id)){
      const snap=await getDocs(collection(db,"annonces_historique"));
      const restantes=snap.docs.map(d=>d.data()).sort((a,b)=>(b.creeLe||0)-(a.creeLe||0));
      if(restantes.length>0)await setDoc(doc(db,"equipe","derniere-annonce"),restantes[0]);
      else await deleteDoc(doc(db,"equipe","derniere-annonce"));
    }
  }catch{}
}

export async function chargerSondages(){
  const out = [];
  try{
    const snap = await getDocs(collection(db,"sondages","liste","items"));
    snap.forEach(d=>out.push(d.data()));
  }catch(e){ console.error("chargerSondages:", e); }
  return out.sort((a,b)=>(b.creeLe||0)-(a.creeLe||0));
}

export async function chargerVotesSondages(){
  const res = {};
  try{
    const snap = await getDocs(collection(db,"sondages","votes","items"));
    snap.forEach(d=>{ res[d.id] = d.data().liste || []; });
  }catch(e){ console.error("chargerVotesSondages:", e); }
  return res;
}

export async function enregistrerSondage(s){
  await setDoc(doc(db,"sondages","liste","items",s.id), s);
}

export async function supprimerSondage(id){
  await deleteDoc(doc(db,"sondages","liste","items",String(id)));
  try{ await deleteDoc(doc(db,"sondages","votes","items",String(id))); }catch{}
}

export async function voterSondage(sondageId, uid, choix){
  const votesActuels = await chargerVotesSondages();
  const liste = (votesActuels[sondageId]||[]).filter(v=>v.uid!==uid);
  liste.push({uid, choix, votedLe:Date.now()});
  await setDoc(doc(db,"sondages","votes","items",sondageId), {liste});
  return liste;
}

export async function enregistrerChallenge(ch){
  await setDoc(doc(db,"challenges","liste","items",ch.id), ch);
}

export async function effacerChallenge(id){
  await deleteDoc(doc(db,"challenges","liste","items",id));
}

// ═══════════ TIRAGE AU SORT (tickets + resultat) ═══════════
export async function chargerTicketsManuels(challengeId){
  try{
    const snap=await getDoc(doc(db,"challenges","tickets_manuels","items",challengeId));
    if(snap.exists())return snap.data().liste||[];
  }catch(e){ console.error("chargerTicketsManuels:", e); }
  return [];
}

export async function chargerTousTicketsManuels(){
  const res={};
  try{
    const snap=await getDocs(collection(db,"challenges","tickets_manuels","items"));
    snap.forEach(d=>{ res[d.id]=d.data().liste||[]; });
  }catch(e){ console.error("chargerTousTicketsManuels:", e); }
  return res;
}

export async function ajouterTicketManuel(challengeId,nom,tickets,ajoutePar){
  const liste=await chargerTicketsManuels(challengeId);
  const nouvelleListe=[...liste,{id:Date.now(),nom,tickets:Math.max(1,Math.round(+tickets)||1),ajoutePar,ts:Date.now()}];
  await setDoc(doc(db,"challenges","tickets_manuels","items",challengeId),{liste:nouvelleListe});
  return nouvelleListe;
}

export async function supprimerTicketManuel(challengeId,ticketId){
  const liste=await chargerTicketsManuels(challengeId);
  const nouvelleListe=liste.filter(t=>t.id!==ticketId);
  await setDoc(doc(db,"challenges","tickets_manuels","items",challengeId),{liste:nouvelleListe});
  return nouvelleListe;
}

export function construireGrilleTickets(declarations,ticketsManuels){
  const grille=[];
  const parPersonne={};
  (declarations||[]).forEach(d=>{
    const nb=Math.max(1,Math.round(d.count)||1);
    parPersonne[d.userName]=(parPersonne[d.userName]||0)+nb;
  });
  (ticketsManuels||[]).forEach(t=>{
    parPersonne[t.nom]=(parPersonne[t.nom]||0)+(t.tickets||1);
  });
  Object.entries(parPersonne).forEach(([nom,nb])=>{
    for(let i=0;i<nb;i++)grille.push(nom);
  });
  return{grille,parPersonne};
}

export async function enregistrerResultatTirage(challengeId,challenge,gagnant,totalTickets){
  await enregistrerChallenge({...challenge,tirage:{gagnant,totalTickets,ts:Date.now()}});
}

export async function supprimerResultatTirage(challengeId,challenge){
  const{tirage,...sansTirage}=challenge;
  await enregistrerChallenge(sansTirage);
}

export async function chargerDeclarationsChallenge(challengeId){
  try{
    const snap=await getDoc(doc(db,"challenges","declarations","items",challengeId));
    if(snap.exists())return snap.data().liste||[];
  }catch(e){ console.error("chargerDeclarationsChallenge:", e); }
  return [];
}

export async function enregistrerDeclarations(challengeId, liste){
  await setDoc(doc(db,"challenges","declarations","items",challengeId), {liste});
}

const CHALLENGE_APP_JOURS = [
  {
    jour: 1,
    titre: "Crée ta première fiche prospect",
    emoji: "👤",
    description: "Va dans Tableau de bord → Prospects. Ajoute une vraie personne que tu as en tête. Note son prénom, son intérêt (cliente ou distributrice) et une note sur ce que tu sais d'elle.",
    action: "Ajouter 1 fiche prospect",
    tip: "💡 C'est là que tout commence. Chaque personne à qui tu penses est un futur résultat.",
    section: "prospects",
  },
  {
    jour: 2,
    titre: "Envoie ton premier diagnostic",
    emoji: "🔬",
    description: "Va dans Diagnostics. Choisis un type (Skincare, Makeup, Cheveux...), entre le prénom d'une connaissance et copie le lien à lui envoyer. Envoie-lui aujourd'hui.",
    action: "Envoyer 1 lien diagnostic",
    tip: "💡 Le diagnostic est ton meilleur outil de vente — il crée une conversation naturelle.",
    section: "diagnostics",
  },
  {
    jour: 3,
    titre: "Configure ton Link-in-Bio",
    emoji: "🔗",
    description: "Va dans Link-in-Bio. Ajoute ta photo, ton slogan, et au moins 3 liens (Instagram, Facebook, catalogue...). Copie le lien et mets-le dans ta bio Instagram.",
    action: "Compléter son Link-in-Bio",
    tip: "💡 Ton link-in-bio remplace les 10 liens que tu ne peux pas mettre ailleurs.",
    section: "linkbio",
  },
  {
    jour: 4,
    titre: "Ajoute ta première cliente",
    emoji: "🛍️",
    description: "Va dans Tableau de bord → Clients. Ajoute une vraie cliente avec sa date de naissance. Enregistre une commande qu'elle a déjà passée — même ancienne.",
    action: "Ajouter 1 cliente avec 1 commande",
    tip: "💡 Les rappels automatiques te préviendront quand ses produits seront bientôt terminés.",
    section: "clients",
  },
  {
    jour: 5,
    titre: "Lance un challenge dans ton équipe",
    emoji: "⚡",
    description: "Va dans Tableau de bord → Équipe → Challenges. Crée un Challenge Flash de 48h avec un objectif simple et un cadeau sympa. Partage-le avec ton équipe.",
    action: "Créer 1 challenge équipe",
    tip: "💡 Un challenge actif = toute l'équipe motivée au même moment.",
    section: "equipe-fun",
  },
  {
    jour: 6,
    titre: "Pose tes objectifs de période",
    emoji: "🎯",
    description: "Va dans Tableau de bord → Objectifs. Remplis ton CA cible, ton palier visé et ton nombre de recrues. Clique sur 'Mes objectifs sont posés'. C'est ton engagement envers toi-même.",
    action: "Fixer ses objectifs de période",
    tip: "💡 Ce qu'on mesure, on l'améliore. Ce qu'on écrit, on l'atteint.",
    section: "objperso",
  },
  {
    jour: 7,
    titre: "Explore ton espace chef (ou ton Dream Board)",
    emoji: "✨",
    description: "Si tu as une équipe : explore Espace Chef → Statistiques pour voir le tableau de bord de ton équipe. Sinon : va dans Dream Board et ajoute 3 rêves avec des photos.",
    action: "Explorer Espace Chef ou Dream Board",
    tip: "💡 Tu viens de découvrir les fondations de l'app. Maintenant, utilise-la chaque jour.",
    section: "dreamboard",
  },
];

function ChallengeAppPopup({uid, onClose, setTab}){
  const[etat,setEtat]=useState(null); // null=chargement
  const[jourActuel,setJourActuel]=useState(null);
  const[valide,setValide]=useState(false);
  const[saving,setSaving]=useState(false);

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",uid));
        const data=snap.exists()?snap.data():{};
        const ca=data["db-challenge-app"]?JSON.parse(data["db-challenge-app"]):null;
        if(!ca){
          // Pas encore commencé → montrer l'annonce "ça commence demain"
          setEtat("annonce");
        } else {
          const startDate=new Date(ca.startDate);
          const today=new Date();
          today.setHours(0,0,0,0);
          const diffJours=Math.floor((today-startDate)/(1000*60*60*24));
          const jour=Math.min(diffJours+1,7); // J1 à J7
          if(diffJours>=7){setEtat("termine");return;}const joursValides=ca.joursValides||[];if(joursValides.includes(jour)){setEtat("termine_jour");return;}setEtat("actif");setJourActuel(jour);setValide(joursValides.includes(jour));}
      }catch{setEtat("annonce");}
    })();
  },[uid]);

  useEffect(()=>{
    if(etat==="termine_jour"||etat==="termine"){ onClose(); }
  },[etat]);

  const demarrer=async()=>{
    setSaving(true);
    try{
      const tomorrow=new Date();
      tomorrow.setDate(tomorrow.getDate()+1);
      tomorrow.setHours(0,0,0,0);
      const ca={startDate:tomorrow.toISOString().slice(0,10),joursValides:[]};
      await setDoc(doc(db,"users",uid),{"db-challenge-app":JSON.stringify(ca)},{merge:true});
      setEtat("confirme");
    }catch{}
    setSaving(false);
  };

  const validerJour=async()=>{
    setSaving(true);
    try{
      const snap=await getDoc(doc(db,"users",uid));
      const ca=JSON.parse(snap.data()["db-challenge-app"]||"{}");
      const joursValides=[...(ca.joursValides||[])];
      if(!joursValides.includes(jourActuel)) joursValides.push(jourActuel);
      const next={...ca,joursValides};
      await setDoc(doc(db,"users",uid),{"db-challenge-app":JSON.stringify(next)},{merge:true});
      await setDoc(doc(db,"users",uid),{"db-challenge-app":JSON.stringify(next)},{merge:true});
      setValide(true);
      setTimeout(()=>onClose(),2000);
    }catch{}
    setSaving(false);
  };

  const allerSection=(section)=>{
    if(section==="prospects"||section==="clients"||section==="equipe-fun"||section==="objperso"){
      setTab("dashboard");
    } else if(section==="diagnostics"){ setTab("boiteaoutils"); }
    else if(section==="linkbio"){ setTab("boiteaoutils"); }
    else if(section==="dreamboard"){ setTab("dashboard"); }
    onClose();
  };
  if(etat==="termine_jour"||etat==="termine"){return null;}  const jour=jourActuel?CHALLENGE_APP_JOURS[jourActuel-1]:null;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.75)",zIndex:999,display:"flex",alignItems:"flex-end",justifyContent:"center"}}
      onClick={onClose}>
      <div style={{background:C.blanc,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,maxHeight:"90vh",overflowY:"auto",padding:"1.5rem"}}
        onClick={e=>e.stopPropagation()}>

        {/* Annonce de lancement */}
        {etat==="annonce"&&(
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:"2.5rem",marginBottom:".75rem"}}>🚀</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:600,color:C.brun,marginBottom:".4rem"}}>
              Challenge Découverte App
            </div>
            <div style={{fontSize:".82rem",color:C.gris,lineHeight:1.7,marginBottom:"1rem"}}>
              Pendant <strong>7 jours</strong>, une action courte chaque jour pour maîtriser l'application Blazing Dynasty.<br/>
              <strong>Ça commence demain matin.</strong> Prête ?
            </div>
            <div style={{background:C.creme,borderRadius:12,padding:".85rem",marginBottom:"1rem"}}>
              {CHALLENGE_APP_JOURS.map((j,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:".5rem",padding:".3rem 0",borderBottom:i<6?`1px solid ${C.pale}`:"none"}}>
                  <span style={{width:24,height:24,borderRadius:"50%",background:C.brun,color:"white",fontSize:".65rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{j.jour}</span>
                  <span style={{fontSize:".72rem",color:C.gris}}>{j.emoji} {j.titre}</span>
                </div>
              ))}
            </div>
            <button onClick={demarrer} disabled={saving}
              style={{width:"100%",background:`linear-gradient(135deg,${C.brun},${C.brun2})`,color:"white",border:"none",borderRadius:12,padding:".8rem",fontSize:".9rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
              {saving?"...":"🚀 Je relève le défi !"}
            </button>
            <button onClick={onClose}
              style={{width:"100%",background:"none",border:"none",color:C.gris,fontSize:".75rem",fontFamily:"inherit",cursor:"pointer",padding:".4rem"}}>
              Pas maintenant
            </button>
          </div>
        )}

        {/* Confirmation démarrage */}
        {etat==="confirme"&&(
          <div style={{textAlign:"center",padding:"1rem 0"}}>
            <div style={{fontSize:"2rem",marginBottom:".5rem"}}>✅</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",color:C.brun,marginBottom:".5rem"}}>C'est noté !</div>
            <div style={{fontSize:".8rem",color:C.gris,lineHeight:1.7}}>Le challenge commence demain. Chaque jour, une action dans l'app pour progresser. On compte sur toi 🌟</div>
            <button onClick={onClose}
              style={{marginTop:"1rem",background:C.brun,color:"white",border:"none",borderRadius:10,padding:".6rem 1.5rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              Super, à demain !
            </button>
          </div>
        )}

        {/* Jour actif */}
        {etat==="actif"&&jour&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
              <div style={{fontSize:".62rem",fontWeight:700,color:C.rose,textTransform:"uppercase",letterSpacing:".1em"}}>Challenge App — Jour {jourActuel}/7</div>
              <button onClick={onClose} style={{background:"none",border:"none",color:C.gris,fontSize:"1rem",cursor:"pointer"}}>✕</button>
            </div>
            {/* Barre progression */}
            <div style={{height:5,background:C.pale,borderRadius:10,marginBottom:"1rem",overflow:"hidden"}}>
              <div style={{height:"100%",background:`linear-gradient(90deg,${C.rose},${C.or})`,width:`${Math.round((jourActuel/7)*100)}%`,borderRadius:10}}/>
            </div>
            <div style={{textAlign:"center",marginBottom:"1rem"}}>
              <div style={{fontSize:"3rem",marginBottom:".4rem"}}>{jour.emoji}</div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:600,color:C.brun}}>{jour.titre}</div>
            </div>
            <div style={{background:C.creme,borderRadius:12,padding:".9rem 1rem",marginBottom:"1rem"}}>
              <div style={{fontSize:".78rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>{jour.description}</div>
              <div style={{fontSize:".72rem",color:C.brun,fontStyle:"italic",background:"white",borderRadius:8,padding:".45rem .65rem"}}>{jour.tip}</div>
            </div>
            <button onClick={()=>allerSection(jour.section)}
              style={{width:"100%",background:`linear-gradient(135deg,${C.rose},${C.lilas})`,color:"white",border:"none",borderRadius:12,padding:".75rem",fontSize:".85rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
              → Y aller maintenant
            </button>
            {!valide
              ?<button onClick={validerJour} disabled={saving}
                style={{width:"100%",background:C.creme,border:`1.5px solid ${C.or}`,borderRadius:12,padding:".65rem",fontSize:".8rem",fontWeight:600,color:C.brun,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
                {saving?"...":"✅ J'ai fait l'action du jour !"}
              </button>
              :<div style={{textAlign:"center",fontSize:".8rem",color:C.vert,fontWeight:700,padding:".5rem",marginBottom:".5rem"}}>✓ Action du jour validée 🎉</div>
            }
            <button onClick={onClose}
              style={{width:"100%",background:"none",border:"none",color:C.gris,fontSize:".72rem",fontFamily:"inherit",cursor:"pointer",padding:".3rem"}}>
              Fermer
            </button>
          </div>
        )}

        {/* Terminé */}
        {etat==="termine"&&(
          <div style={{textAlign:"center",padding:"1rem 0"}}>
            <div style={{fontSize:"2.5rem",marginBottom:".5rem"}}>🏆</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",color:C.brun,marginBottom:".5rem"}}>Challenge terminé !</div>
            <div style={{fontSize:".8rem",color:C.gris,lineHeight:1.7}}>Tu as découvert les 7 piliers de l'application. Maintenant tu sais tout — utilise-la chaque jour pour des résultats concrets ✨</div>
            <button onClick={onClose}
              style={{marginTop:"1rem",background:C.or,color:"white",border:"none",borderRadius:10,padding:".6rem 1.5rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              Merci ! 🌟
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

function App(){
  const[screen,setScreen]=useState("login");
  const[showWelcome,setShowWelcome]=useState(false);
  const[showNewChallenge,setShowNewChallenge]=useState(false);
  const[newChallengeData,setNewChallengeData]=useState(null);
  const[showForgotPwd,setShowForgotPwd]=useState(false);
  const[forgotMdp1,setForgotMdp1]=useState("");
  const[forgotMdp2,setForgotMdp2]=useState("");
  const[forgotLoading,setForgotLoading]=useState(false);
  const[forgotError,setForgotError]=useState("");
  const[showMonCompte,setShowMonCompte]=useState(false);
  const[pseudoLien,setPseudoLien]=useState("");const[pseudoLienActuel,setPseudoLienActuel]=useState("");const[pseudoLienSaving,setPseudoLienSaving]=useState(false);const[pseudoLienSaved,setPseudoLienSaved]=useState(false);const[pseudoLienError,setPseudoLienError]=useState("");
  const[showDecouverteCompte,setShowDecouverteCompte]=useState(false);
  const[contactWhatsapp,setContactWhatsapp]=useState("");
  const[stripeConnecte,setStripeConnecte]=useState(false);
  const[stripePret,setStripePret]=useState(false);
  const[stripeLoading,setStripeLoading]=useState(false);
  const[showStripeForm,setShowStripeForm]=useState(false);
  const[stripeForm,setStripeForm]=useState({prenom:"",nom:"",jour:"",mois:"",annee:"",adresse:"",ville:"",codePostal:"",telephone:"",email:"",accepteConditions:false});
  const[stripeFormError,setStripeFormError]=useState("");
  const chargerStripeJS=()=>new Promise((resolve,reject)=>{
    if(window.Stripe){resolve(window.Stripe);return;}
    const s=document.createElement("script");
    s.src="https://js.stripe.com/v3/";
    s.onload=()=>resolve(window.Stripe);
    s.onerror=()=>reject(new Error("Stripe.js non charge"));
    document.head.appendChild(s);
  });
  const connecterStripe=async()=>{
    setStripeFormError("");
    setShowStripeForm(true);
  };
  const soumettreStripeForm=async()=>{
    const f=stripeForm;
    if(!f.prenom.trim()||!f.nom.trim()||!f.jour||!f.mois||!f.annee||!f.adresse.trim()||!f.ville.trim()||!f.codePostal.trim()||!f.telephone.trim()||!f.email.trim()){
      setStripeFormError("Merci de remplir tous les champs.");
      return;
    }
    if(!f.accepteConditions){
      setStripeFormError("Merci d'accepter les conditions pour continuer.");
      return;
    }
    setStripeLoading(true);
    setStripeFormError("");
    try{
      const StripeCtor=await chargerStripeJS();
      const stripeJs=StripeCtor("pk_live_51TqE1PEQsV2U66LsVOutzOfwVfXPDr8iONyGYBrCkudLOyR8hazIggIQ3blHBr8Q4r7CpBjJb8CM9lCooSBkjXVO00eplccc1J");
      const telephoneFormate=(()=>{
        let t=f.telephone.trim().replace(/[\s.-]/g,"");
        if(t.startsWith("0")) t="+33"+t.slice(1);
        else if(!t.startsWith("+")) t="+33"+t;
        return t;
      })();
      const {token, error} = await stripeJs.createToken("account", {
        business_type:"individual",
        individual:{
          first_name:f.prenom.trim(),
          last_name:f.nom.trim(),
          dob:{day:parseInt(f.jour),month:parseInt(f.mois),year:parseInt(f.annee)},
          address:{line1:f.adresse.trim(),city:f.ville.trim(),postal_code:f.codePostal.trim(),country:"FR"},
          phone:telephoneFormate,
          email:f.email.trim()
        },
        tos_shown_and_accepted:true
      });
      if(error){setStripeFormError(error.message||"Erreur lors de la creation du token Stripe.");setStripeLoading(false);return;}
      const res=await creerCompteStripeConnectFn({accountToken:token.id});
      if(res.data&&res.data.url){window.location.href=res.data.url;}
    }catch(e){setStripeFormError("Erreur : "+e.message);}
    setStripeLoading(false);
  };
  const verifierStripe=async()=>{
    try{
      const res=await verifierStatutStripeFn();
      setStripeConnecte(res.data.connecte);
      setStripePret(res.data.pret);
    }catch{}
  };
  useEffect(()=>{if(showMonCompte)verifierStripe();},[showMonCompte]);
  useEffect(()=>{
    if(!showMonCompte)return;
    (async()=>{
      try{
        const uSnap=await getDoc(doc(db,"users",userId));
        const p=uSnap.exists()?(uSnap.data()["db-lien-pseudo"]||""):"";
        setPseudoLienActuel(p);setPseudoLien(p);setPseudoLienError("");
      }catch{}
    })();
  },[showMonCompte]);
  const sauverPseudoLien=async()=>{
    const nouveau=(pseudoLien||"").toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9-]/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,"");
    if(!nouveau){setPseudoLienError("Choisis au moins quelques lettres.");return;}
    if(nouveau===pseudoLienActuel){setPseudoLienError("");return;}
    setPseudoLienSaving(true);setPseudoLienError("");setPseudoLienSaved(false);
    try{
      const existant=await getDoc(doc(db,"pseudos_liens",nouveau));
      if(existant.exists()&&existant.data().uid!==userId){
        setPseudoLienError("Ce pseudo est deja pris, essaie autre chose.");
        setPseudoLienSaving(false);return;
      }
      await setDoc(doc(db,"pseudos_liens",nouveau),{uid:userId});
      if(pseudoLienActuel&&pseudoLienActuel!==nouveau){
        try{await deleteDoc(doc(db,"pseudos_liens",pseudoLienActuel));}catch{}
      }
      await setDoc(doc(db,"users",userId),{"db-lien-pseudo":nouveau},{merge:true});
      setPseudoLienActuel(nouveau);setPseudoLien(nouveau);setPseudoLienSaved(true);
      setTimeout(()=>setPseudoLienSaved(false),2500);
    }catch(e){
      setPseudoLienError("Erreur : "+e.message);
    }
    setPseudoLienSaving(false);
  };
  const[lienPaypalMe,setLienPaypalMe]=useState("");
  const[lienStripePerso,setLienStripePerso]=useState("");
  const[paiementSaving,setPaiementSaving]=useState(false);
  const[paiementSaved,setPaiementSaved]=useState(false);
  const chargerPaiementPerso=async()=>{
    try{
      const snap=await getDoc(doc(db,"users",userId));
      if(snap.exists()){
        const d=snap.data();
        setLienPaypalMe(d["db-lien-paypalme"]||"");
        setLienStripePerso(d["db-lien-stripe-perso"]||"");
      }
    }catch{}
  };
  useEffect(()=>{if(showMonCompte)chargerPaiementPerso();},[showMonCompte]);
  const sauverPaiementPerso=async()=>{
    setPaiementSaving(true);
    try{
      await setDoc(doc(db,"users",userId),{
        "db-lien-paypalme":lienPaypalMe.trim(),
        "db-lien-stripe-perso":lienStripePerso.trim()
      },{merge:true});
      // Egalement dans contacts_publics (lecture publique, accessible aux visiteuses anonymes de la boutique)
      await setDoc(doc(db,"contacts_publics",userId),{
        "db-lien-paypalme":lienPaypalMe.trim(),
        "db-lien-stripe-perso":lienStripePerso.trim()
      },{merge:true});
      setPaiementSaved(true);setTimeout(()=>setPaiementSaved(false),2000);
    }catch(e){alert("Erreur : "+e.message);}
    setPaiementSaving(false);
  };
  const[emailNotifCommandes,setEmailNotifCommandes]=useState("");
  const[emailNotifSaving,setEmailNotifSaving]=useState(false);
  const[emailNotifSaved,setEmailNotifSaved]=useState(false);
  useEffect(()=>{
    if(!showMonCompte)return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",userId));
        if(snap.exists())setEmailNotifCommandes(snap.data()["db-email-notif-commandes"]||"");
      }catch{}
    })();
  },[showMonCompte]);
  const sauverEmailNotifCommandes=async()=>{
    setEmailNotifSaving(true);
    try{
      await setDoc(doc(db,"users",userId),{"db-email-notif-commandes":emailNotifCommandes.trim()},{merge:true});
      setEmailNotifSaved(true);setTimeout(()=>setEmailNotifSaved(false),2000);
    }catch{}
    setEmailNotifSaving(false);
  };
  const[afficherPrixVIP,setAfficherPrixVIP]=useState(false);
  useEffect(()=>{
    if(!showMonCompte)return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",userId));
        if(snap.exists())setAfficherPrixVIP(!!snap.data()["db-afficher-prix-vip"]);
      }catch{}
    })();
  },[showMonCompte]);
  const toggleAfficherPrixVIP=async()=>{
    const next=!afficherPrixVIP;
    setAfficherPrixVIP(next);
    try{
      await setDoc(doc(db,"users",userId),{"db-afficher-prix-vip":next},{merge:true});
      // Egalement dans contacts_publics (lecture publique, accessible aux visiteuses anonymes de la boutique)
      await setDoc(doc(db,"contacts_publics",userId),{"db-afficher-prix-vip":next},{merge:true});
    }catch{}
  };
  const[lienInscriptionMihi,setLienInscriptionMihi]=useState("");
  const[lienInscriptionSaving,setLienInscriptionSaving]=useState(false);
  const[lienInscriptionSaved,setLienInscriptionSaved]=useState(false);
  useEffect(()=>{
    if(!showMonCompte)return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",userId));
        if(snap.exists())setLienInscriptionMihi(snap.data()["db-lien-inscription-mihi"]||"");
      }catch{}
    })();
  },[showMonCompte]);
  const sauverLienInscriptionMihi=async()=>{
    setLienInscriptionSaving(true);
    try{
      await setDoc(doc(db,"users",userId),{"db-lien-inscription-mihi":lienInscriptionMihi.trim()},{merge:true});
      setLienInscriptionSaved(true);setTimeout(()=>setLienInscriptionSaved(false),2000);
    }catch{}
    setLienInscriptionSaving(false);
  };
  const[contactMessenger,setContactMessenger]=useState("");
  const[contactInstagram,setContactInstagram]=useState("");
  const[contactSaved,setContactSaved]=useState(false);
  const[compteMdpAncien,setCompteMdpAncien]=useState("");
  const[compteMdp1,setCompteMdp1]=useState("");
  const[compteMdp2,setCompteMdp2]=useState("");
  const[compteLoading,setCompteLoading]=useState(false);
  const[compteError,setCompteError]=useState("");
  const[compteSuccess,setCompteSuccess]=useState(false);
  const[showBackupReminder,setShowBackupReminder]=useState(false);
  const[showMdpSetup,setShowMdpSetup]=useState(false);
  const[newMdp,setNewMdp]=useState("");
  const[newMdp2,setNewMdp2]=useState("");
  const[loginStep,setLoginStep]=useState(1);
  const[mdpInput,setMdpInput]=useState("");
  const[userId,setUserId]=useState("");
  const[isChefApp,setIsChefApp]=useState(false);
  const[challengeATraiterApp,setChallengeATraiterApp]=useState(false);
  const[nbNotifCommunaute,setNbNotifCommunaute]=useState(0);
  const[forceQuizJourApp,setForceQuizJourApp]=useState(null);
  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      try{
        let total=0;
        const items2=await chargerChallenges();
        const now2=Date.now();
        const actifs2=items2.filter(c=>!c.deadline||c.deadline>now2);
        if(actifs2.length>0){
          const decls2=await chargerDeclarations();
          const nbChallengesNonFaits=actifs2.filter(c=>{
            const mesDecl2=(decls2[c.id]||[]).filter(d=>d.uid===userId);
            return mesDecl2.length===0;
          }).length;
          total+=nbChallengesNonFaits;
        }
        try{
          const nbMsg=await getUnreadMessagesCount(userId);
          total+=nbMsg;
        }catch{}
        try{
          const snapI4=await getDoc(doc(db,"communaute","infos"));
          if(snapI4.exists()){
            const infosArr4=Object.values(snapI4.data());
            const uSnap5=await getDoc(doc(db,"users",userId));
            const lastVu4=uSnap5.exists()?(uSnap5.data()["db-last-infos-vu"]||0):0;
            const plusRecente4=infosArr4.length>0?Math.max(...infosArr4.map(i=>i.ts||0)):0;
            if(plusRecente4>lastVu4)total+=1;
          }
        }catch{}
        setNbNotifCommunaute(total);
        setChallengeATraiterApp(total>0);
      }catch{}
    })();
  },[userId]);
  
  const[hasTeamApp,setHasTeamApp]=useState(false);
  const[fastStartDone,setFastStartDone]=useState(false);
  const[hasFastStart,setHasFastStart]=useState(false);

  useEffect(()=>{
    if(!userId)return;
    if(userId==="melissa"||userId==="melissa-da-silveira"){setIsChefApp(true);setHasTeamApp(true);return;}
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"acces","membres"));
        const chefs=snap.exists()?snap.data().chefs||[]:[];
        setIsChefApp((Array.isArray(chefs)?chefs:Object.values(chefs||{})).includes(userId.replace(/-/g," ")));
      }catch{setIsChefApp(false);}
      try{
        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        const annuaire=annSnap.exists()?annSnap.data().membres||{}:{};
        setHasTeamApp(Object.values(annuaire).some(m=>m.marraine===userId));
      }catch{setHasTeamApp(false);}
    })();
  },[userId]);

  const[name,setName]=useState("");
  const[nameInput,setNameInput]=useState("");
  const[prenomInput,setPrenomInput]=useState("");
  const[nomInput,setNomInput]=useState("");
  const[codeInput,setCodeInput]=useState("");
  const[loginError,setLoginError]=useState("");
  const[loginLoading,setLoginLoading]=useState(false);
  const[chefs,setChefs]=useState([]);
  const[chefChoisi,setChefChoisi]=useState("");
  const[membresListe,setMembresListe]=useState([]);
  const[marraineChoisie,setMarraineChoisie]=useState("");
  const[pendingUid,setPendingUid]=useState("");
  const[pendingName,setPendingName]=useState("");
  const[pendingIsMelissa,setPendingIsMelissa]=useState(false);


  const verifierMdp=async()=>{
    if(!mdpInput.trim())return;
    setLoginLoading(true);setLoginError("");
    try{
      let authResult;
      try{
        authResult=await authentifierFn({prenom:pendingName.split(" ")[0],nom:pendingName.split(" ").slice(1).join(" "),codeSecret:SECRET_CODE,motDePasse:mdpInput.trim()});
      }catch(e){
        setLoginError("Code personnel incorrect.");setLoginLoading(false);return;
      }
      const authData=authResult.data;
      if(authData.status!=="ok"){setLoginError("Code personnel incorrect.");setLoginLoading(false);return;}
      try{ await signInWithCustomToken(auth,authData.token); }catch(e){ console.error("SIGNIN ERROR",e.code,e.message); }
      try{localStorage.setItem("bd-user",JSON.stringify({uid:pendingUid,n:pendingName,codeOk:true}));}catch{}
      setUserId(pendingUid);setName(pendingName);setScreen("app");load(pendingUid);verifierChangementPeriode(pendingUid);try{const snapCA2=await getDoc(doc(db,"users",pendingUid));const caRaw2=snapCA2.exists()?snapCA2.data()["db-challenge-app"]:null;if(caRaw2){const ca2=JSON.parse(caRaw2);const startDate2=new Date(ca2.startDate);const today2=new Date();today2.setHours(0,0,0,0);const diffJours2=Math.floor((today2-startDate2)/(1000*60*60*24));if(diffJours2<7)setTimeout(()=>setShowChallengeApp(true),2000);}else{setTimeout(()=>setShowChallengeApp(true),2000);}}catch{setTimeout(()=>setShowChallengeApp(true),2000);}
      // Rappel backup tous les 3 jours (Melissa uniquement)
      if(pendingUid==="melissa"||pendingUid==="melissa-da-silveira"){
        try{
          const snapBk=await getDoc(doc(db,"users",pendingUid));
          const lastBk=snapBk.exists()?snapBk.data()["db-last-backup"]:null;
          const joursDepuis=lastBk?Math.floor((Date.now()-new Date(lastBk).getTime())/(1000*60*60*24)):999;
          if(joursDepuis>=3) setTimeout(()=>setShowBackupReminder(true),3500);
        }catch{}
      }
      saveFCMToken(pendingUid);
      sg(pendingUid,"db-obj-perso").then(data=>{syncAnnuaire(pendingUid,pendingName,data?JSON.parse(data):null);});
    }catch{setLoginError("Erreur. Reessaie.");}
    setLoginLoading(false);
  };

  const reinitialiserMdp=async()=>{
    if(!forgotMdp1.trim()||forgotMdp1!==forgotMdp2){setForgotError("Les codes ne correspondent pas.");return;}
    if(forgotMdp1.trim().length<4){setForgotError("Le code doit faire au moins 4 caracteres.");return;}
    setForgotLoading(true);setForgotError("");
    try{
      const result=await reinitialiserMotDePasseFn({prenom:pendingName.split(" ")[0],nom:pendingName.split(" ").slice(1).join(" "),codeSecret:SECRET_CODE,nouveauMotDePasse:forgotMdp1.trim()});
      const data=result.data;
      if(data.status==="ok"){
        try{ await signInWithCustomToken(auth,data.token); }catch(e){ console.error("SIGNIN ERROR",e.code,e.message); }
        try{localStorage.setItem("bd-user",JSON.stringify({uid:data.uid,n:data.displayName,codeOk:true}));}catch{}
        setShowForgotPwd(false);setForgotMdp1("");setForgotMdp2("");
        setUserId(data.uid);setName(data.displayName);setScreen("app");load(data.uid);verifierChangementPeriode(data.uid);
        saveFCMToken(data.uid);
      }
    }catch(e){setForgotError(e.message&&e.message.includes("reconnu")?"Prenom/Nom non reconnu.":"Erreur, reessaie.");}
    setForgotLoading(false);
  };

  const sauverContacts=async()=>{
    try{
      await setDoc(doc(db,"users",userId),{
        "db-contact-whatsapp":contactWhatsapp.trim(),
        "db-contact-messenger":contactMessenger.trim(),
        "db-contact-instagram":contactInstagram.trim()
      },{merge:true});
      await setDoc(doc(db,"contacts_publics",userId),{
        whatsapp:contactWhatsapp.trim(),
        messenger:contactMessenger.trim(),
        instagram:contactInstagram.trim()
      },{merge:true});
      setContactSaved(true);
      setTimeout(()=>setContactSaved(false),2000);
    }catch{}
  };
  const changerMdpCompte=async()=>{
    if(!compteMdp1.trim()||compteMdp1!==compteMdp2){setCompteError("Les codes ne correspondent pas.");return;}
    if(compteMdp1.trim().length<4){setCompteError("Le code doit faire au moins 4 caracteres.");return;}
    setCompteLoading(true);setCompteError("");
    try{
      await definirMotDePasseFn({motDePasse:compteMdp1.trim()});
      setCompteSuccess(true);
      setCompteMdpAncien("");setCompteMdp1("");setCompteMdp2("");
      setTimeout(()=>{setCompteSuccess(false);setShowMonCompte(false);},2000);
    }catch(e){setCompteError("Erreur, reessaie.");}
    setCompteLoading(false);
  };

  const SECRET_CODE="BD-2026-FIRE";

  // â”€â”€ AUTO-LOGIN via Firebase Auth â”€â”€
  useEffect(()=>{
    const unsub=onAuthStateChanged(auth,(user)=>{
      if(user&&user.uid){
        const uid=user.uid;
        let n=uid.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");
        try{
          const saved=localStorage.getItem("bd-user");
          if(saved){
            const parsed=JSON.parse(saved);
            if(parsed.uid===uid&&parsed.n) n=parsed.n;
          }
        }catch{}
        getDoc(doc(db,"admin","config")).then(cfg=>{
          const fr=cfg.exists()?cfg.data().forceReload:0;
          const lastReload=+localStorage.getItem("bd-last-reload")||0;
          if(fr&&fr>lastReload){localStorage.setItem("bd-last-reload",String(fr));window.location.reload();return;}
          setUserId(uid);setName(n);setScreen("app");load(uid);verifierChangementPeriode(uid);saveFCMToken(uid);getDoc(doc(db,"users",uid)).then(snapCA=>{const caRaw=snapCA.exists()?snapCA.data()["db-challenge-app"]:null;if(caRaw){const ca=JSON.parse(caRaw);const startDate=new Date(ca.startDate);const today=new Date();today.setHours(0,0,0,0);const diffJours=Math.floor((today-startDate)/(1000*60*60*24));if(diffJours<7)setTimeout(()=>setShowChallengeApp(true),2000);}else{setTimeout(()=>setShowChallengeApp(true),2000);}}).catch(()=>{setTimeout(()=>setShowChallengeApp(true),2000);});
          try{const fk="bd-first-"+uid;if(!localStorage.getItem(fk)){localStorage.setItem(fk,"1");setTimeout(()=>setShowWelcome(true),1500);}}catch{}
        }).catch(()=>{
          setUserId(uid);setName(n);setScreen("app");load(uid);verifierChangementPeriode(uid);saveFCMToken(uid);getDoc(doc(db,"users",uid)).then(snapCA=>{const caRaw=snapCA.exists()?snapCA.data()["db-challenge-app"]:null;if(caRaw){const ca=JSON.parse(caRaw);const startDate=new Date(ca.startDate);const today=new Date();today.setHours(0,0,0,0);const diffJours=Math.floor((today-startDate)/(1000*60*60*24));if(diffJours<7)setTimeout(()=>setShowChallengeApp(true),2000);}else{setTimeout(()=>setShowChallengeApp(true),2000);}}).catch(()=>{setTimeout(()=>setShowChallengeApp(true),2000);});
        });
      } else {
        try{localStorage.removeItem("bd-user");}catch{}
      }
    });
    return()=>unsub();
  },[]);

  const login=async()=>{
    if(!prenomInput.trim()||!nomInput.trim()||!codeInput.trim())return;
    if(codeInput.trim().toUpperCase()!==SECRET_CODE){
      setLoginError("❌ Code d'accès incorrect.");return;
    }
    setLoginLoading(true);setLoginError("");
    try{
      const fullName=`${prenomInput.trim().toLowerCase()} ${nomInput.trim().toLowerCase()}`;
      const isMelissa=prenomInput.trim().toLowerCase()==="melissa";
      const uid=fullName.replace(/\s+/g,"-");
      const displayName=`${prenomInput.trim()} ${nomInput.trim()}`;
      let authResult;
      try{
        authResult=await authentifierFn({prenom:prenomInput.trim(),nom:nomInput.trim(),codeSecret:codeInput.trim()});
      }catch(e){
        setLoginError(e.message&&e.message.includes("reconnu")?"âŒ PrÃ©nom/Nom non reconnu. Contacte Melissa.":"âŒ "+(e.message||"Erreur de connexion."));
        setLoginLoading(false);return;
      }
      const authData=authResult.data;
      if(authData.status==="password_required"){
        setPendingUid(uid);setPendingName(displayName);setPendingIsMelissa(isMelissa);
        setLoginLoading(false);setLoginStep(3);return;
      }
      if(authData.status==="nouveau"){
        try{ await signInWithCustomToken(auth,authData.token); }catch(e){ console.error("SIGNIN ERROR",e.code,e.message); }
        setPendingUid(uid);setPendingName(displayName);setPendingIsMelissa(isMelissa);
        const chefsSnap=await getDoc(doc(db,"acces","membres"));
        const liste=chefsSnap.exists()?chefsSnap.data().chefs||[]:[];
        const tousMembres=chefsSnap.exists()?chefsSnap.data().liste||[]:[];
        setChefs(liste);
        setMembresListe(["melissa da silveira", ...tousMembres.filter(m=>m.toLowerCase()!==fullName&&m.toLowerCase()!=="melissa da silveira")]);
        setLoginLoading(false);
        setLoginStep(2);return;
      }

      // Connexion directe
      try{localStorage.setItem("bd-user",JSON.stringify({uid,n:displayName,codeOk:true}));}catch{}
      // Popup bienvenue si première connexion
      try{const snapW=await getDoc(doc(db,"users",uid));const welcomed=snapW.exists()?snapW.data()["db-welcomed"]:false;if(!welcomed){setShowWelcome(true);await setDoc(doc(db,"users",uid),{"db-welcomed":true},{merge:true});}}catch{}
      try{
        const challItems=await chargerChallenges();
        const now2=Date.now();
        const actifs2=challItems.filter(c=>!c.deadline||c.deadline>now2);
        if(actifs2.length>0){
          const userSnapC=await getDoc(doc(db,"users",uid));
          const vus=userSnapC.exists()?(userSnapC.data()["db-challenges-vus"]||[]):[];
          const isMelissaC=uid==="melissa"||uid==="melissa-da-silveira";
          let annuaireC={};
          try{
            const annSnapC=await getDoc(doc(db,"equipe","annuaire"));
            annuaireC=annSnapC.exists()?(annSnapC.data().membres||{}):{};
          }catch{}
          const nonVus=actifs2.filter(c=>{
            if(vus.includes(c.id))return false;
            if(isMelissaC)return true;
            if(c.global)return true;
            if(!c.equipesCibles||c.equipesCibles.length===0)return true;
            if(c.equipesCibles.includes("all"))return true;
            if(c.equipesCibles.includes(uid))return true;
            let current=annuaireC[uid]?.marraine;
            const visitedC=new Set();
            while(current&&!visitedC.has(current)){
              visitedC.add(current);
              if(c.equipesCibles.includes(current))return true;
              current=annuaireC[current]?.marraine;
            }
            return false;
          });
          if(nonVus.length>0){
            setNewChallengeData(nonVus[0]);
            setTimeout(()=>setShowNewChallenge(true),3000);
          }
        }
      }catch{}
      try{
        const snapFS=await getDoc(doc(db,"users",uid));
        const quizOuvert=snapFS.exists()?(snapFS.data()["db-faststart-quiz-ouvert"]||""):"";
        if(quizOuvert)setForceQuizJourApp(quizOuvert);
      }catch{}
      try{
        const snapDatesCA=await getDoc(doc(db,"admin","dates_manuelles_ca"));
        if(snapDatesCA.exists()) DATES_MANUELLES_CA=snapDatesCA.data().periodes||{};
      }catch{}
      setUserId(uid);setName(displayName);setScreen("app");load(uid);verifierChangementPeriode(uid);
      // Afficher le challenge app apres 2s seulement si pas termine
      try{const snapCA=await getDoc(doc(db,"users",uid));const caRaw=snapCA.exists()?snapCA.data()["db-challenge-app"]:null;if(caRaw){const ca=JSON.parse(caRaw);const startDate=new Date(ca.startDate);const today=new Date();today.setHours(0,0,0,0);const diffJours=Math.floor((today-startDate)/(1000*60*60*24));if(diffJours<7)setTimeout(()=>setShowChallengeApp(true),2000);}else{setTimeout(()=>setShowChallengeApp(true),2000);}}catch{setTimeout(()=>setShowChallengeApp(true),2000);}
      // Démarrer automatiquement le challenge app si première connexion
      try{
        const snap2=await getDoc(doc(db,"users",uid));
        const existingCA=snap2.exists()?snap2.data()["db-challenge-app"]:null;
        let caData=null;
        if(existingCA){try{caData=JSON.parse(existingCA);}catch{}}
        if(!caData||!caData.startDate){
          const today=new Date();
          const ca={startDate:today.toISOString().slice(0,10),joursValides:[],auto:true};
          await setDoc(doc(db,"users",uid),{"db-challenge-app":JSON.stringify(ca)},{merge:true});
        }
      }catch{}
      // Enregistrer token FCM pour les notifications
      saveFCMToken(uid);
      saveFCMToken(uid);
      // Verifier si mdp personnel existe - si non, afficher popup creation
      try{const mdpSnap=await getDoc(doc(db,"users",uid));if(!mdpSnap.exists()||!mdpSnap.data()["db-mdp"]){setTimeout(()=>setShowMdpSetup(true),1500);}}catch{}
      sg(uid,"db-obj-perso").then(data=>{
        syncAnnuaire(uid, displayName, data?JSON.parse(data):null);
      });
    }catch{
      setLoginError("❌ Erreur de connexion. Réessaie.");
    }
    setLoginLoading(false);
  };

  const confirmerChef=async()=>{
    setLoginLoading(true);
    try{
      if(chefChoisi){
        const ref=doc(db,"users",pendingUid);
        await setDoc(ref,{"chef-equipe":chefChoisi},{ merge:true });
        // Ajouter dans l'équipe du chef
        const chefUid=chefChoisi.toLowerCase().replace(/\s+/g,"-");
        const chefRef=doc(db,"users",chefUid);
        const chefSnap=await getDoc(chefRef);
        const equipe=chefSnap.exists()&&chefSnap.data()["mon-equipe"]?JSON.parse(chefSnap.data()["mon-equipe"]):[];
        if(!equipe.includes(pendingUid)){
          await setDoc(chefRef,{"mon-equipe":JSON.stringify([...equipe,pendingUid])},{merge:true});
        }
      }
      let marraineUid="";
      if(marraineChoisie){
        marraineUid=marraineChoisie.toLowerCase().replace(/\s+/g,"-");
        await setDoc(doc(db,"users",pendingUid),{"marraine":marraineUid},{merge:true});
      }
      try{localStorage.setItem("bd-user",JSON.stringify({uid:pendingUid,n:pendingName,codeOk:true}));}catch{}
      setUserId(pendingUid);setName(pendingName);setScreen("app");load(pendingUid);verifierChangementPeriode(pendingUid);
      try{const fk="bd-first-"+pendingUid;if(!localStorage.getItem(fk)){localStorage.setItem(fk,"1");setTimeout(()=>setShowWelcome(true),1500);}}catch{}
      saveFCMToken(pendingUid);
      sg(pendingUid,"db-obj-perso").then(data=>{
        syncAnnuaire(pendingUid, pendingName, data?JSON.parse(data):null, marraineUid);
      });
    }catch{}
    setLoginLoading(false);
  };
  const[tab,setTab]=useState("dashboard");
  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      try{
        let total=0;
        try{
          const items3=await chargerChallenges();
          const now3=Date.now();
          const actifs3=items3.filter(c=>!c.deadline||c.deadline>now3);
          if(actifs3.length>0){
            const decls3=await chargerDeclarations();
            const nonFaits=actifs3.filter(c=>{
              const mesDecl3=(decls3[c.id]||[]).filter(d=>d.uid===userId);
              return mesDecl3.length===0;
            });
            total+=nonFaits.length;
          }
        }catch{}
        try{
          const snapI3=await getDoc(doc(db,"communaute","infos"));
          if(snapI3.exists()){
            const infosArr3=Object.values(snapI3.data());
            const uSnap3=await getDoc(doc(db,"users",userId));
            const lastVu3=uSnap3.exists()?(uSnap3.data()["db-last-infos-vu"]||0):0;
            const nonVues=infosArr3.filter(i=>(i.ts||0)>lastVu3);
            total+=nonVues.length;
          }
        }catch{}
        try{
          const uSnap4=await getDoc(doc(db,"users",userId));
          if(uSnap4.exists()){
            const data4=uSnap4.data();
            const today4=todayLocalStr();
            const prospects4=data4["db-prospects"]?JSON.parse(data4["db-prospects"]):[];
            total+=prospects4.filter(p=>p.relance&&p.relance<=today4&&p.statut!=="Converti"&&p.statut!=="Archive").length;
            const clients4=data4["db-clients"]?JSON.parse(data4["db-clients"]):[];
            clients4.forEach(c=>{
              (c.rappels||[]).forEach(r=>{
                if(!r.fait&&r.date&&r.date<=today4)total+=1;
              });
            });
          }
        }catch{}
        try{
          total+=await getUnreadMessagesCount(userId);
        }catch{}
        if("setAppBadge" in navigator){
          try{
            if(total>0)navigator.setAppBadge(total);
            else navigator.clearAppBadge();
          }catch{}
        }
      }catch{}
    })();
  },[userId,tab]);
  const[formationSubTab,setFormationSubTab]=useState("");
  const formationTimerRef=useRef({subTab:null,startTime:null});
  // "NEW" de la formation Contenu : visible pendant la visite, puis masqué dès qu'on est passé voir
  const ID_NEW_VISUELS="contenu-visuels-parfaits";
  const[newVus,setNewVus]=useState(()=>lireNewVus());
  useEffect(()=>{
    if(tab==="formation"&&formationSubTab==="contenu"){
      marquerNewVu(ID_NEW_VISUELS);
      return()=>setNewVus(p=>p.includes(ID_NEW_VISUELS)?p:[...p,ID_NEW_VISUELS]);
    }
  },[tab,formationSubTab]);
  const afficherNewVisuels=estNouveauJusque("2026-10-12")&&!newVus.includes(ID_NEW_VISUELS);
  // "NEW" de la formation Vente « Organiser une réunion virtuelle » : même principe
  const ID_NEW_REUNION="vente-reunion-virtuelle";
  useEffect(()=>{
    if(tab==="formation"&&formationSubTab==="vente"){
      marquerNewVu(ID_NEW_REUNION);
      return()=>setNewVus(p=>p.includes(ID_NEW_REUNION)?p:[...p,ID_NEW_REUNION]);
    }
  },[tab,formationSubTab]);
  const afficherNewReunion=estNouveauJusque("2026-10-19")&&!newVus.includes(ID_NEW_REUNION);
  // "NEW" de la formation BONUS (rituel visage) : même principe
  const ID_NEW_BONUS="bonus-rituel-visage";
  useEffect(()=>{
    if(tab==="formation"&&formationSubTab==="bonus"){
      marquerNewVu(ID_NEW_BONUS);
      return()=>setNewVus(p=>p.includes(ID_NEW_BONUS)?p:[...p,ID_NEW_BONUS]);
    }
  },[tab,formationSubTab]);
  const afficherNewBonus=estNouveauJusque("2026-10-14")&&!newVus.includes(ID_NEW_BONUS);
  useEffect(()=>{
    if(tab==="formation"&&formationSubTab&&FORMATION_SUBTABS_SUIVIES.includes(formationSubTab)&&userId){
      enregistrerConsultationFormation(userId,formationSubTab);
      // la pastille NEW de cette section disparaît tout de suite (sans attendre le prochain lancement)
      setFormationNouveautes(prev=>{if(!prev[formationSubTab])return prev;const n={...prev};delete n[formationSubTab];return n;});
      formationTimerRef.current={subTab:formationSubTab,startTime:Date.now()};
    }
    return ()=>{
      const{subTab,startTime}=formationTimerRef.current;
      if(subTab&&startTime&&userId){
        const secondes=Math.round((Date.now()-startTime)/1000);
        ajouterTempsFormation(userId,subTab,secondes);
      }
      formationTimerRef.current={subTab:null,startTime:null};
    };
  },[tab,formationSubTab,userId]);
  const[formationTerminees,setFormationTerminees]=useState({});
  const[formationNouveautes,setFormationNouveautes]=useState({});
  const FORMATION_DATES_MAJ={
    mihibd:"2026-01-01", demarrage:"2026-01-01", vente:"2026-10-19T17:00:00Z",
    recrutement:"2026-07-09", contenu:"2026-10-12T14:00:00Z", devperso:"2026-07-09",
    outils:"2026-07-09", formaproduits:"2026-07-09", communication:"2026-08-17", nutrition:"2026-08-19", bonus:"2026-10-14T12:00:00Z",
  };
  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      try{
        const data=await sgAll(userId);
        const progress=data["db-formation-progress"]?JSON.parse(data["db-formation-progress"]):{};
        const termines={};
        const nouveautes={};
        Object.keys(progress).forEach(k=>{if(progress[k]?.termine)termines[k]=true;});
        let dateFormaProduits=FORMATION_DATES_MAJ.formaproduits;
        try{
          const fp=await chargerFormationProduits();
          if(fp.derniereMaj){
            dateFormaProduits=new Date(fp.derniereMaj).toISOString();
          }
        }catch{}
        FORMATION_SUBTABS_SUIVIES.forEach(id=>{
          const maj=id==="formaproduits"?dateFormaProduits:FORMATION_DATES_MAJ[id];
          const vue=progress[id]?.derniereConsultation;
          if(maj&&(!vue||new Date(vue)<new Date(maj)))nouveautes[id]=true;
        });
        setFormationTerminees(termines);
        setFormationNouveautes(nouveautes);
      }catch{}
    })();
  },[userId]);
  const marquerTermine=async(subTab)=>{
    await marquerFormationTerminee(userId,subTab);
    setFormationTerminees(prev=>({...prev,[subTab]:true}));
  };
  const BoutonTermineFormation=({subTab})=>(
    <div style={{marginTop:"1.2rem",marginBottom:"1rem"}}>
      {formationTerminees[subTab]?(
        <div style={{background:"#E8F5E9",color:"#2D5A3D",borderRadius:10,padding:".7rem",fontSize:".78rem",fontWeight:700,textAlign:"center"}}>
          ✅ Formation terminée
        </div>
      ):(
        <button onClick={()=>marquerTermine(subTab)}
          style={{width:"100%",background:C.vert||"#5C8A60",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          ✅ J'ai terminé cette formation
        </button>
      )}
    </div>
  );
  const[showObjectifs,setShowObjectifs]=useState(false);

  // â”€â”€ POWER HOUR â€” popups dÃ©marrage/fin â”€â”€
  const[showPowerHourStart,setShowPowerHourStart]=useState(false);
  const[showPowerHourEnd,setShowPowerHourEnd]=useState(false);
  const[powerHourInfo,setPowerHourInfo]=useState(null);
  useEffect(()=>{
    if(!userId||screen!=="app")return;
    const DUREE_PH=20*60000;
    const checkPowerHour=async()=>{
      try{
        const snap=await getDoc(doc(db,"equipe","power-hour"));
        if(!snap.exists())return;
        const d=snap.data();
        if(!d.startedAt)return;
        const elapsed=Date.now()-d.startedAt;
        let seenStart=null,seenEnd=null;
        try{seenStart=localStorage.getItem("bd-ph-start-seen");}catch{}
        try{seenEnd=localStorage.getItem("bd-ph-end-seen");}catch{}
        if(elapsed>=0&&elapsed<2*60000&&String(d.startedAt)!==seenStart){
          setPowerHourInfo(d);setShowPowerHourStart(true);
          try{localStorage.setItem("bd-ph-start-seen",String(d.startedAt));}catch{}
        }
        if(elapsed>=DUREE_PH&&elapsed<DUREE_PH+2*60000&&String(d.startedAt)!==seenEnd){
          setPowerHourInfo(d);setShowPowerHourEnd(true);
          try{localStorage.setItem("bd-ph-end-seen",String(d.startedAt));}catch{}
        }
      }catch{}
    };
    checkPowerHour();
    const t=setInterval(checkPowerHour,15000);
    return()=>clearInterval(t);
  },[userId,screen]);

  // â”€â”€ ANNONCES OFFICIELLES EQUIPE â”€â”€
  const[showAnnonce,setShowAnnonce]=useState(false);
  const[annonceData,setAnnonceData]=useState(null);
  const[showInfosImportantes,setShowInfosImportantes]=useState(false);
  const[showAnnonceAdminFlottant,setShowAnnonceAdminFlottant]=useState(false);
  const[glowInfos,setGlowInfos]=useState(false);
  const[tirageAVoir,setTirageAVoir]=useState(null); // {id, challenge}
  const[showTirageBanniere,setShowTirageBanniere]=useState(false);
  useEffect(()=>{
    if(!userId||screen!=="app")return;
    const checkAnnonce=async()=>{
      try{
        const snap=await getDoc(doc(db,"equipe","derniere-annonce"));
        if(!snap.exists())return;
        const d=snap.data();
        if(!d.id)return;
        let seen=null;
        try{seen=localStorage.getItem("bd-annonce-seen");}catch{}
        if(String(d.id)!==seen){
          setAnnonceData(d);
          setShowAnnonce(true);
          setGlowInfos(true);
          try{localStorage.setItem("bd-annonce-seen",String(d.id));}catch{}
          try{await setDoc(doc(db,"annonces_vues",String(d.id)),{vus:arrayUnion(userId)},{merge:true});}catch{}
        }
      }catch{}
    };
    checkAnnonce();
    const t2=setInterval(checkAnnonce,30000);
    return()=>clearInterval(t2);
  },[userId,screen]);
  const checkTirages=async()=>{
    if(!userId)return;
    try{
      const data=await chargerChallenges();
      let vus=[];
      try{vus=JSON.parse(localStorage.getItem("bd-tirages-vus")||"[]");}catch{}
      const nonVu=data.find(c=>c.tirage&&!vus.includes(c.id)&&Date.now()-c.tirage.ts<7*24*3600000);
      setTirageAVoir(nonVu?{id:nonVu.id,challenge:nonVu}:null);
    }catch{}
  };
  useEffect(()=>{
    if(!userId||screen!=="app")return;
    checkTirages();
    const t4=setInterval(checkTirages,60000);
    return()=>clearInterval(t4);
  },[userId,screen]);
  const[lang,setLang]=useState("fr");
  const[translations,setTranslations]=useState({});
  const[translating,setTranslating]=useState(false);

  // Re-traduire le DOM à chaque changement d'onglet si en mode PT
  useEffect(()=>{
    if(lang==="pt"){
      const t=setTimeout(()=>{ try{translateDOM("pt");}catch{} },400);
      return()=>clearTimeout(t);
    }
  },[tab, lang]);

  // MutationObserver : retraduire auto quand le DOM change en mode PT
  useEffect(()=>{
    if(lang!=="pt") return;
    let timer=null;
    const obs=new MutationObserver(()=>{
      clearTimeout(timer);
      timer=setTimeout(()=>{ try{translateDOM("pt");}catch{} },800);
    });
    const root=document.getElementById("root");
    if(root) obs.observe(root,{childList:true,subtree:true,characterData:false});
    return()=>{obs.disconnect();clearTimeout(timer);};
  },[lang]);

  const toggleLang=async()=>{
    const newLang=lang==="fr"?"pt":"fr";
    if(newLang==="fr"){
      setLang("fr");
      setTranslations({});
      try{ await translateDOM("fr"); }catch{}
      domOriginals.clear();
      return;
    }
    setTranslating(true);
    try{ await translateDOM(newLang); }catch(e){ console.error(e); }
    setLang(newLang);
    setTranslating(false);
  };
    const[checks,setChecks]=useState({});
  const[tasks,setTasks]=useState({});
  const[posts,setPosts]=useState({});
  const[kpis,setKpis]=useState({k1:"",k2:"",k3:"",k4:""});
  const[notes,setNotes]=useState("");
  const[loading,setLoading]=useState(false);
  const[openDays,setOpenDays]=useState({1:true});

  const load=useCallback(async(uid)=>{
    setLoading(true);
    try{
      const data = await sgAll(uid);
      if(data.checks) setChecks(JSON.parse(data.checks));
      if(data.tasks)  setTasks(JSON.parse(data.tasks));
      if(data.posts)  setPosts(JSON.parse(data.posts));
      if(data.kpis)   setKpis(JSON.parse(data.kpis));
      if(data.notes)  setNotes(data.notes);
    }catch{}
    setLoading(false);
  },[]);

  // Vérifie si la période a changé et remet à zéro les objectifs si oui
  const verifierChangementPeriode=useCallback(async(uid)=>{
    try{
      const periodeCourante=getPeriodeActuelle();
      const snap=await getDoc(doc(db,"users",uid));
      if(!snap.exists()) return;
      const d=snap.data();
      const lastPeriode=d["last_periode"];
      // Si jamais enregistré, juste stocker la période actuelle sans reset
      if(!lastPeriode){
        await setDoc(doc(db,"users",uid),{"last_periode":periodeCourante},{merge:true});
        return;
      }
      if(lastPeriode===periodeCourante) return; // Même période — rien à faire

      // Période différente → clôturer automatiquement
      const objRaw=d["db-obj-perso"];
      if(objRaw){
        const obj=JSON.parse(objRaw);
        // Sauvegarder dans l'historique
        const hist=obj.historique||[];
        const entry={
          date:todayLocalStr(),
          periode:lastPeriode,
          ca:parseFloat(obj.ca)||0,
          caObj:parseFloat(obj.caObj)||0,
          caPerso:parseFloat(obj.caPerso)||0,
          recruesReal:parseFloat(obj.recruesReal)||0,
          recruesObj:parseFloat(obj.recruesObj)||0,
          palier:obj.palier||"2%",
        };
        const newHist=[...hist,entry].slice(-24); // garder 24 périodes max
        const totalCaCumul=(parseFloat(obj.totalCaCumul)||0)+(parseFloat(obj.ca)||0);
        const totalRecruesCumul=(parseFloat(obj.totalRecruesCumul)||0)+(parseFloat(obj.recruesReal)||0);

        // Remettre à zéro les compteurs courants ET les objectifs chiffrés (nouvelle période = redéfinition complète)
        const nextObj={
          ...obj,
          ca:"",
          caPerso:"",
          caEquipe:"",
          caObj:"",
          recruesReal:"0",
          recruesObj:"",
          palier:"2%",
          objectifsPosesPeriode:"",
          // Vider le calcul du reste (directeurs) pour la nouvelle période
          nbDirecteurs:0,
          caDirecteurs:{},
          dirSelectionnes:{},
          historique:newHist,
          totalCaCumul:String(totalCaCumul),
          totalRecruesCumul:String(totalRecruesCumul),
        };
        try{
          const refCA=doc(db,"users",uid);
          const snapCA=await getDoc(refCA);
          const brutCA=snapCA.exists()?snapCA.data()["db-suivi-ca"]:null;
          const dataCA=brutCA?JSON.parse(brutCA):{};
          const keyCA="p"+lastPeriode;
          const curCA=dataCA[keyCA]||{obj:0,jours:{}};
          dataCA[keyCA]={...curCA,caPerso:parseFloat(obj.caPerso)||0,recrues:parseFloat(obj.recruesReal)||0};
          await setDoc(refCA,{"db-suivi-ca":JSON.stringify(dataCA)},{merge:true});
        }catch(e){ console.error("archivage suivi-ca:",e); }
        try{
          await setDoc(doc(db,"users",uid),{"db-rappel-periode":JSON.stringify({periode:lastPeriode,ca:parseFloat(obj.ca)||0,vu:false})},{merge:true});
        }catch(e){}
        await setDoc(doc(db,"users",uid),{"db-obj-perso":JSON.stringify(nextObj),"last_periode":periodeCourante},{merge:true});
        // Sync annuaire avec les nouvelles valeurs vides
        await syncAnnuaire(uid, name||uid, nextObj);

        // Remettre à zéro les badges sauf régularité or
        try{
          const badgesSnap=await getDoc(doc(db,"users",uid));
          if(badgesSnap.exists()){
            const bd=badgesSnap.data();
            const badgesRaw=bd["db-badges-unlocked"];
            if(badgesRaw){
              const badges=JSON.parse(badgesRaw);
              // Garder les badges permanents (régularité, recrutement, suivi)
              const garder=["regularite_or","streak_or","gold_streak","recruteur-elite","king-suivi","top-vendeur","fidelite-or","ambassador"].filter(k=>badges[k]);
              const nextBadges={};
              garder.forEach(k=>nextBadges[k]=badges[k]);
              await setDoc(doc(db,"users",uid),{"db-badges-unlocked":JSON.stringify(nextBadges)},{merge:true});
            }
          }
        }catch(e){console.error("reset badges:",e);}
        console.log(`Période ${lastPeriode}→${periodeCourante} : objectifs et badges remis à zéro`);
      } else {
        // Pas encore d'objectifs, juste enregistrer la période
        await setDoc(doc(db,"users",uid),{"last_periode":periodeCourante},{merge:true});
      }

      // Mettre à jour aussi l'annuaire
      syncAnnuaire(uid, name||"");
    }catch(e){ console.error("verifierChangementPeriode:",e); }
  },[name]);

  const save=useCallback(async(uid,c,t,_s,p,k,n)=>{
    if(!uid)return;
    try{await Promise.all([
      ss(uid,"checks",JSON.stringify(c)),ss(uid,"tasks",JSON.stringify(t)),
      ss(uid,"posts",JSON.stringify(p)),
      ss(uid,"kpis",JSON.stringify(k)),ss(uid,"notes",n),
    ]);}catch{}
  },[]);

  const tog=(type,id)=>{
    const setters={checks:[checks,setChecks],tasks:[tasks,setTasks],posts:[posts,setPosts]};
    const[state,setter]=setters[type];
    if(!state)return;
    const next={...state,[id]:!state[id]};
    setter(next);
    if(type==="tasks")save(userId,checks,next,{},posts,kpis,notes);
    else if(type==="posts")save(userId,checks,tasks,{},next,kpis,notes);
    else save(userId,next,tasks,{},posts,kpis,notes);
  };
  const updKpi=(k,v)=>{const next={...kpis,[k]:v};setKpis(next);save(userId,checks,tasks,null,posts,next,notes);};
  const updNotes=(v)=>{setNotes(v);save(userId,checks,tasks,null,posts,kpis,v);};

  const allTask=SPRINT.flatMap(d=>d.tasks.map(t=>t.id));
  const allPosts=POST_IDEAS.flatMap(th=>th.posts.map(p=>p.id));
  const donePosts=allPosts.filter(id=>posts[id]).length;

  // ── Période et bannières ──
  const periodeInfoInit=getPeriodeInfo();
  const isDebutPeriodeInit=periodeInfoInit.pctElapsed<=10;
  const bannerKeyInit=`bd-banner-${periodeInfoInit.periodEnd.toISOString().slice(0,10)}`;
  const[showBanner,setShowBanner]=useState(()=>{try{return isDebutPeriodeInit&&!localStorage.getItem(bannerKeyInit);}catch{return false;}});
  const[showChallengeApp,setShowChallengeApp]=useState(false);
  const[dismissedPeriode,setDismissedPeriode]=useState(false);
  const[objPosesLocal,setObjPosesLocal]=useState(false);
  const[nbNotifDashboard,setNbNotifDashboard]=useState({relances:0,actions:0});
  const[nbDiagNonLus,setNbDiagNonLus]=useState(0);
  const[nbNotifCalendrier,setNbNotifCalendrier]=useState(0);
  const[nbCommandesNonVues,setNbCommandesNonVues]=useState(0);
  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",userId));
        if(!snap.exists())return;
        const data=snap.data();
        const clients=data["db-clients"]?JSON.parse(data["db-clients"]):[];
        const lastVu=data["db-dernier-vu-commandes-boutique"]||0;
        let n=0;
        clients.forEach(c=>{
          (c.commandes||[]).forEach(cmd=>{
            if(cmd.source==="boutique-en-ligne"&&cmd.id>lastVu)n++;
          });
        });
        setNbCommandesNonVues(n);
      }catch{}
    })();
  },[userId]);
  const marquerCommandesVues=async()=>{
    try{
      await ss(userId,"db-dernier-vu-commandes-boutique",Date.now());
      setNbCommandesNonVues(0);
    }catch{}
  };
  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      try{
        const snapCal=await getDoc(doc(db,"equipe","calendrier"));
        const snapUser=await getDoc(doc(db,"users",userId));
        const lastVuCal=snapUser.exists()?(snapUser.data()["db-calendrier-vue"]||0):0;
        if(snapCal.exists()){
          const arrCal=Object.values(snapCal.data());
          const now=Date.now();
          const dansUneSemaine=now+7*24*60*60*1000;
          const idsAConsiderer=new Set();
          arrCal.forEach(e=>{
            const estNouveau=e.createdAt&&e.createdAt>lastVuCal;
            const estProche=e.dateTs>=now&&e.dateTs<=dansUneSemaine;
            if(estNouveau||estProche)idsAConsiderer.add(e.id);
          });
          setNbNotifCalendrier(idsAConsiderer.size);
        }
      }catch{}
    })();
  },[userId]);
  const[nbMsgsNonLusApp,setNbMsgsNonLusApp]=useState(0);
  useEffect(()=>{
    if(!userId)return;
    const checkMsgsEspaceChef=async()=>{
      try{
        const snap=await getDoc(doc(db,"messages",userId));
        if(!snap.exists()){setNbMsgsNonLusApp(0);return;}
        const msgs=snap.data().msgs||[];
        setNbMsgsNonLusApp(msgs.filter(m=>!m.lu).length);
      }catch{}
    };
    checkMsgsEspaceChef();
    const t=setInterval(checkMsgsEspaceChef,30000);
    return()=>clearInterval(t);
  },[userId]);
  const[diagResultsTrigger,setDiagResultsTrigger]=useState(0);
  const voirDiagResultats=()=>{
    setTab("boiteaoutils");
    setOutilsSousOnglet("diagnostics");
    setDiagResultsTrigger(Date.now());
  };
  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",userId));
        if(snap.exists()&&snap.data()["db-diagnostics"]){
          const arr=JSON.parse(snap.data()["db-diagnostics"]);
          setNbDiagNonLus(arr.filter(d=>d.nonLu).length);
        }
      }catch{}
    })();
  },[userId]);

  // ── Admin items ──
  const[adminItems,setAdminItems]=useState([]);
  const[adminPosts,setAdminPosts]=useState([]);
  const[adminVideosFastStart,setAdminVideosFastStart]=useState({});
  const[homeObjPerso,setHomeObjPerso]=useState(null);
  const[homeTextes,setHomeTextes]=useState(null);
  useEffect(()=>{
    if(screen!=="app")return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","contenus"));
        if(snap.exists())setAdminItems((snap.data().items||[]).filter(i=>i.actif));
      }catch{}
      try{
        const snapVFS=await getDoc(doc(db,"admin","videos_faststart"));
        if(snapVFS.exists())setAdminVideosFastStart(snapVFS.data().videos||{});
      }catch{}
      try{
        const snap2=await getDoc(doc(db,"admin","posts_extra"));
        if(snap2.exists())setAdminPosts(snap2.data().items||[]);
      }catch{}
      try{
        const snap3=await getDoc(doc(db,"users",userId));
        if(snap3.exists()&&snap3.data()["db-obj-perso"]) setHomeObjPerso(JSON.parse(snap3.data()["db-obj-perso"]));
      }catch{}
      try{
        const snap4=await getDoc(doc(db,"admin","textes"));
        if(snap4.exists()) setHomeTextes(snap4.data());
      }catch{}
    })();
  },[screen]);

  // Le bandeau « Mes recrues » met à jour l'objectif / le nombre de recrues : on garde le récap d'accueil à jour
  useEffect(()=>{
    const maj=(e)=>{const d=e&&e.detail;if(!d)return;setHomeObjPerso(o=>({...(o||{}),recruesObj:d.recruesObj,recruesReal:d.recruesReal}));};
    window.addEventListener("recrues-maj",maj);
    return()=>window.removeEventListener("recrues-maj",maj);
  },[]);
  // Les ventes notées dans la tirelire s'ajoutent à « ventes perso » : on garde le récap d'accueil à jour
  useEffect(()=>{
    const maj=(e)=>{const d=e&&e.detail;if(!d)return;setHomeObjPerso(o=>({...(o||{}),ca:d.ca,caPerso:d.caPerso,caEquipe:d.caEquipe}));};
    window.addEventListener("ventes-maj",maj);
    return()=>window.removeEventListener("ventes-maj",maj);
  },[]);
  // Melissa : son CA total d'équipe alimente la couronne « Objectifs équipe » à chaque ouverture de l'app et à chaque changement
  useEffect(()=>{
    if(!estMelissaUid(userId)||!homeObjPerso)return;
    const v=String(homeObjPerso.ca==null?"":homeObjPerso.ca).trim();
    if(v==="")return;
    setDoc(doc(db,"equipe","objectifs"),{caReal:v,caRealMaj:Date.now()},{merge:true}).catch(()=>{});
  },[userId,homeObjPerso&&homeObjPerso.ca]);

  // Rafraîchir homeObjPerso à chaque retour sur le tableau de bord (pour la bannière période)
  useEffect(()=>{
    if(tab==="dashboard"&&userId){
      getDoc(doc(db,"users",userId)).then(snap=>{
        if(snap.exists()&&snap.data()["db-obj-perso"]){
          try{ setHomeObjPerso(JSON.parse(snap.data()["db-obj-perso"])); }catch{}
        }
      }).catch(()=>{});
    }
  },[tab,userId]);

  // ── Protection clavier ──
  useEffect(()=>{
    const block=(e)=>{
      if(e.key==="F12"||(e.ctrlKey&&["u","s","a","p"].includes(e.key.toLowerCase()))){
        e.preventDefault();e.stopPropagation();
      }
    };
    document.addEventListener("keydown",block);
    return()=>document.removeEventListener("keydown",block);
  },[]);

  const TABS=[
    {id:"home",label:"🏠"},
    {id:"dashboard",label:"📊 Tableau de bord"},
    {id:"boiteaoutils",label:"🛠️ Ma Boîte à Outils"},
    {id:"communication",label:"💬 Communication & Réseaux"},
    {id:"challenge",label:"🏆 Challenge"},
    {id:"classement",label:"📊 Classement"},
    {id:"communaute",label:"🌸 Communauté"},
    {id:"carte",label:"🗺️ Carte"},
    {id:"calendrier",label:"📅 Calendrier"},
    {id:"formation",label:"🎓 Formation"},
    ...(isChefApp||hasTeamApp?[{id:"espacechef",label:"👑 Espace Chef"}]:[]),
  ];

  const DASHBOARD_SOUS_ONGLETS=[
    {id:"quotidien",label:"📊 Quotidien"},
    {id:"reseaux",label:"📱 Suivi Reseaux"},
    {id:"objperso",label:"🎯 Objectifs"},
    {id:"clients",label:"🛍 Clients"},
    {id:"distributeurs",label:"👑 Distributeurs"},
    {id:"prospects",label:"👥 Prospects"},
    {id:"relances",label:"🔔 Relances"},
    {id:"diagnostics",label:"🩺 Diagnostics"},
    {id:"business",label:"📈 Suivi CA"},
    {id:"stats",label:"📉 Stats"},
  ];
  const OUTILS_SOUS_ONGLETS=[
    {id:"linkbio",label:"🔗 Link-in-Bio"},
    {id:"boutique",label:"🛍️ Boutique"},
    {id:"diagnostics",label:"🩺 Diagnostics"},
    {id:"ebooks",label:"📚 Ebooks"},
    {id:"liensimportants",label:"🔗 Liens importants"},
    {id:"tunnel-recrutement",label:"🎯 Tunnel Recrutement"},
    {id:"monunivers",label:"🌟 Mon Univers"},
    {id:"immersion",label:"✨ Immersion"},
    {id:"audit",label:"🔍 Audit Presence Digitale"},
  ];
  const[dashboardSousOnglet,setDashboardSousOnglet]=useState("quotidien");
  const[dtab,setDtab]=useState("today");
  const[menuDashboardOuvert,setMenuDashboardOuvert]=useState(false);
  const[menuOutilsOuvert,setMenuOutilsOuvert]=useState(false);
  const[menuCommunicationOuvert,setMenuCommunicationOuvert]=useState(false);
  const[communicationSousOnglet,setCommunicationSousOnglet]=useState("analyse");
  const[storiesJourLien,setStoriesJourLien]=useState(0);
  useEffect(()=>{try{const p=new URLSearchParams(window.location.search).get("stories");if(p!==null){const n=parseInt(p,10);setStoriesJourLien(n>=1&&n<=14?n:0);setTab("communication");setCommunicationSousOnglet("stories");}}catch{}},[]);
  const COMMUNICATION_SOUS_ONGLETS=[{id:"analyse",label:"✨ Analyse réseaux IA",vedette:true},{id:"stories",label:"📱 Stories 14 jours",vedette:true},{id:"semainetheme",label:"Semaine a theme"},{id:"sprint",label:"Sprint editorial"},{id:"scripts",label:"Scripts"},{id:"editorial",label:"Editorial"}];
  const[ouvrirBusinessTrigger,setOuvrirBusinessTrigger]=useState(0);
  const[ouvrirChallengesTrigger,setOuvrirChallengesTrigger]=useState(0);
  const[outilsSousOnglet,setOutilsSousOnglet]=useState("linkbio");
  const[auditVue,setAuditVue]=useState("remplir");

  // Sous-onglets du menu Formation
  const FORMATION_TABS=[
    ...((hasFastStart&&!fastStartDone)?[{id:"faststart",label:"🚀 Fast Start",icon:"🚀",col:C.rose,desc:"Ton parcours de demarrage, etape par etape"}]:[]),
    {id:"demarrage",label:"📚 Démarrage",icon:"📚",col:C.rose,desc:"8 parties — étape par étape pour bien démarrer"},
    {id:"formationapp",label:"🎬 Formation App",icon:"🎬",col:C.lilas,desc:"Comment utiliser l'application Blazing Dynasty"},
    {id:"mihibd",label:"🔥 Mihi & Blazing Dynasty",icon:"🔥",col:C.or,desc:"Qui on est, la marque, l'équipe — pour comprendre et en parler"},
    {id:"vente",label:"🎯 Vente",icon:"🎯",col:C.or,desc:"Stratégies, scripts et objections pour booster tes ventes"},
    {id:"recrutement",label:"👥 Recrutement",icon:"👥",col:C.rose,desc:"Recrutement, affiliation et stratégies d'équipe"},
    {id:"contenu",label:"📱 Contenu",icon:"📱",col:C.lilas,desc:"Posts, storytelling, contenu qui attire"},
    {id:"outils",label:"🛠️ Outils",icon:"🛠️",col:C.or,desc:"Canva, CapCut, Linktree et plus"},
    {id:"devperso",label:"🧠 Dév. Personnel",icon:"🧠",col:C.lilas,desc:"Mindset et développement personnel"},
    {id:"formaproduits",label:"🧴 Formation Produits",icon:"🧴",col:C.rose,desc:"Tout savoir sur les produits Mihi"},
    {id:"communication",label:"💬 Comment parler correctement de Mihi",icon:"💬",col:C.or,desc:"Bien communiquer autour de la marque Mihi"},
    {id:"nutrition",label:"🥗 Nutrition Smart Meal",icon:"🥗",col:C.vert,desc:"Comprendre la nutrition et les produits Smart Meal"},
    {id:"bonus",label:"🎁 Formation BONUS",icon:"🎁",col:C.rose,desc:"Les formations bonus : rituels et soins à partager"},
  ];

  // ── MODE DIAGNOSTIC EXTERNE (cliente sans login) ──
  const urlParams = new URLSearchParams(window.location.search);
  const diagMode = urlParams.has("diag");
  const diagUidFromPath = (window.location.pathname.match(/\/d\/([^/?]+)/)||[])[1] || "";
  const diagDistrib = urlParams.get("uid")||urlParams.get("distrib")||diagUidFromPath||"";
  const [diagDistribReel, setDiagDistribReel] = useState(null);
  useEffect(()=>{
    if(!diagMode || !diagDistrib){ setDiagDistribReel(diagDistrib||"external"); return; }
    (async()=>{
      try{
        const pSnap = await getDoc(doc(db,"pseudos_liens", diagDistrib.toLowerCase()));
        if(pSnap.exists() && pSnap.data().uid){
          setDiagDistribReel(pSnap.data().uid);
        } else {
          setDiagDistribReel(diagDistrib);
        }
      }catch(e){
        setDiagDistribReel(diagDistrib);
      }
    })();
  },[diagMode, diagDistrib]);
  const immersionUidFromPath = (window.location.pathname.match(/\/immersion\/([^/?]+)/)||[])[1] || "";
  const immersionMode = urlParams.has("immersion") || !!immersionUidFromPath;
  const immersionUid = urlParams.get("immersion") || immersionUidFromPath || "";
  const immersionScore = urlParams.get("score") ? Number(urlParams.get("score")) : null;
  const [immersionData, setImmersionData] = useState(null);
  const [showDecouverteImmersion, setShowDecouverteImmersion] = useState(false);
  const [statsImmersionTrigger, setStatsImmersionTrigger] = useState(0);
  useEffect(()=>{
    if(!immersionMode) return;
    (async()=>{
      try{
        const communSnap = await getDoc(doc(db,"immersion","_commun"));
        const personalSnap = immersionUid ? await getDoc(doc(db,"immersion", immersionUid)) : null;
        const q = query(collection(db,"temoignages"), where("valide","==",true));
        const snap = await getDocs(q);
        const pool = [];
        snap.forEach(docSnap=>pool.push({id:docSnap.id, ...docSnap.data()}));
        const perso = personalSnap && personalSnap.exists() ? personalSnap.data() : {};
        const selectionnes = perso.temoignagesSelectionnes || [];
        const temoignages = selectionnes.length
          ? selectionnes.map(id=>pool.find(t=>t.id===id)).filter(Boolean)
          : pool.slice(0,5);
        setImmersionData({
          ...(communSnap.exists()?communSnap.data():{}),
          ...perso,
          temoignages,
        });
      }catch(e){
        console.error("Erreur chargement immersion", e);
        setImmersionData({});
      }
    })();
  },[immersionMode, immersionUid]);

  // ── MODE TUNNEL (vente/recrutement, visiteur sans login) ──
  const tunnelMode = urlParams.has("tunnel");
  const tunnelSlug = urlParams.get("tunnel")||"";
  useEffect(()=>{
    if(!diagMode) return;
    (async()=>{
      try{
        const cfg = await getDoc(doc(db,"admin","config"));
        const fr = cfg.exists() ? cfg.data().forceReload : 0;
        const last = +localStorage.getItem("bd-public-last-reload") || 0;
        if(fr && fr > last){
          localStorage.setItem("bd-public-last-reload", String(fr));
          window.location.reload();
        }
      }catch{}
    })();
  },[]);
  if(tunnelMode&&tunnelSlug){
    return <TunnelRecrutementPublic slug={tunnelSlug} db={db}/>;
  }
  if(diagMode){
    return(
      <div style={{minHeight:"100vh",background:C.creme,fontFamily:"'Trebuchet MS',sans-serif"}}>
        <div style={{maxWidth:480,margin:"0 auto",padding:"1rem"}}>
          <div style={{textAlign:"center",padding:"1.5rem 0 .5rem"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:300,color:C.brun,letterSpacing:".04em"}}>
              Blazing <em style={{fontStyle:"italic",color:C.rose}}>Dynasty</em>
            </div>
            <div style={{fontSize:".7rem",color:C.gris,marginTop:".2rem"}}>Diagnostic personnalisé ✨</div>
          </div>
          {diagDistribReel===null?<div style={{padding:"3rem",textAlign:"center"}}>Chargement...</div>:<DiagnosticsTab uid={diagDistribReel} userName={diagDistribReel} externalMode={true} initialType={urlParams.get("diag")||""} initialClient={urlParams.get("client")||""}/>}
        </div>
      </div>
    );
  }
  if(immersionMode){
    if(!immersionData){
      return <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#171529",color:"#F7F3EC"}}>Chargement...</div>;
    }
    return (
      <ImmersionTunnel
        data={immersionData}
        score={immersionScore}
        onLeadSubmit={async (lead)=>{
          try{
            await addDoc(collection(db,"leads"), {...lead, score:immersionScore, distributriceId: immersionUid, source:"immersion", creeLe: new Date().toISOString()});
          }catch(e){ console.error("Erreur envoi lead", e); }
        }}
          onTrack={async (evt)=>{
            try{
              await setDoc(doc(db,"immersion_stats", immersionUid||"anonyme"), { [evt]: increment(1), derniereActivite: new Date().toISOString() }, {merge:true});
            }catch(e){ console.error("Erreur tracking immersion", e); }
          }}
      />
    );
  }

  // ── LOGIN ────────────────────────────────────────────────────────────────────
  if(screen==="login")return(
    <div style={{minHeight:"100vh",background:C.brun,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"2rem 1.2rem",fontFamily:"'DM Sans',system-ui,sans-serif"}}>
      <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".25em",color:C.or,marginBottom:".5rem"}}>✦ BLAZING DYNASTY ✦</div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"clamp(1.8rem,5vw,2.6rem)",fontWeight:300,color:C.blanc,textAlign:"center",lineHeight:1.1}}>Espace Formation</div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"clamp(1.8rem,5vw,2.6rem)",fontStyle:"italic",color:C.pale,textAlign:"center",lineHeight:1.1,marginBottom:".3rem"}}>Privé</div>
      <div style={{width:48,height:1,background:C.or,margin:".85rem auto"}}/>
      <p style={{fontSize:".76rem",color:"rgba(232,213,204,.7)",textAlign:"center",marginBottom:"2rem",maxWidth:300}}>Formations · Stratégies · Outils · Suivi</p>

      <div style={{background:C.blanc,borderRadius:16,padding:"1.5rem 1.4rem",width:"100%",maxWidth:360,boxShadow:"0 8px 32px rgba(0,0,0,.25)"}}>

        {/* ÉTAPE 1 — Identité */}
        {loginStep===1&&<>
          <div style={{fontSize:".68rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".75rem",textAlign:"center"}}>🔐 Accès membres</div>
          <div style={{display:"flex",gap:".5rem",marginBottom:".45rem"}}>
            <input type="text" placeholder="Prénom" value={prenomInput} onChange={e=>{setPrenomInput(e.target.value);setLoginError("");}}
              style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}} autoFocus/>
            <input type="text" placeholder="Nom" value={nomInput} onChange={e=>{setNomInput(e.target.value);setLoginError("");}}
              style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
          </div>
          <input type="password" placeholder="Code d'accès" value={codeInput} onChange={e=>{setCodeInput(e.target.value);setLoginError("");}} onKeyDown={e=>e.key==="Enter"&&login()}
            style={{width:"100%",border:`1px solid ${loginError?C.rose:C.pale}`,borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".5rem"}}/>
          {loginError&&<div style={{fontSize:".72rem",color:"#B04040",marginBottom:".5rem",textAlign:"center"}}>{loginError}</div>}
          <button onClick={login} disabled={!prenomInput.trim()||!nomInput.trim()||!codeInput.trim()||loginLoading}
            style={{width:"100%",background:(prenomInput.trim()&&nomInput.trim()&&codeInput.trim())?C.brun:C.pale,color:(prenomInput.trim()&&nomInput.trim()&&codeInput.trim())?C.blanc:C.gris,border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",transition:"all .2s"}}>
            {loginLoading?"Vérification...":"Continuer →"}
          </button>
          <p style={{fontSize:".62rem",color:C.gris,textAlign:"center",marginTop:".7rem"}}>Espace réservé aux membres Blazing Dynasty.</p>
        </>}

        {/* ÉTAPE 2 — Choix chef d'équipe */}
        {loginStep===2&&<>
          <div style={{fontSize:".68rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem",textAlign:"center"}}>👑 Ta chef d'équipe</div>
          <p style={{fontSize:".76rem",color:C.gris,textAlign:"center",marginBottom:"1rem",lineHeight:1.6}}>
            Bienvenue {pendingName.split(" ")[0]} ! 🎉<br/>Choisis ta chef d'équipe.
          </p>
          <select value={chefChoisi} onChange={e=>setChefChoisi(e.target.value)}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:"1rem"}}>
            <option value="">— Sélectionne ta chef —</option>
            {chefs.map(c=><option key={c} value={c}>{c.split(" ").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ")}</option>)}
          </select>

          <div style={{fontSize:".68rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas,marginBottom:".5rem",textAlign:"center"}}>🌸 Ta marraine</div>
          <p style={{fontSize:".74rem",color:C.gris,textAlign:"center",marginBottom:".7rem",lineHeight:1.6}}>
            Qui t'a parrainée dans l'aventure ? (optionnel)
          </p>
          <SearchSelect value={marraineChoisie} onChange={setMarraineChoisie} options={membresListe} placeholder="🔍 Tape le nom de ta marraine..."/>
          <button onClick={confirmerChef} disabled={!chefChoisi||loginLoading}
            style={{width:"100%",background:chefChoisi?C.brun:C.pale,color:chefChoisi?C.blanc:C.gris,border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",transition:"all .2s"}}>
            {loginLoading?"Sauvegarde...":"Accéder à mon espace →"}
          </button>
          <button onClick={confirmerChef} disabled={loginLoading}
            style={{width:"100%",background:"none",border:"none",color:C.gris,fontSize:".7rem",marginTop:".5rem",cursor:"pointer",fontFamily:"inherit",padding:".3rem"}}>
            Passer cette étape
          </button>
        </>}
        {loginStep===3&&<>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:300,color:"#3D1F0E",marginBottom:"1rem",textAlign:"center"}}>🔐 Ton code <em style={{color:"#C49A8A"}}>personnel</em></div>
          <input type="password" placeholder="Ton code personnel" value={mdpInput} onChange={e=>setMdpInput(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&verifierMdp()}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".6rem .9rem",fontSize:".9rem",fontFamily:"inherit",color:"#3D2B1F",background:"white",outline:"none",marginBottom:".75rem"}}/>
          {loginError&&<div style={{color:"#C44B1A",fontSize:".75rem",marginBottom:".5rem",textAlign:"center"}}>{loginError}</div>}
          <button onClick={verifierMdp} disabled={!mdpInput.trim()||loginLoading}
            style={{width:"100%",background:"#3D1F0E",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            {loginLoading?"Verification...":"Acceder →"}
          </button>
          {!showForgotPwd&&(
            <button onClick={()=>{setShowForgotPwd(true);setForgotError("");}}
              style={{width:"100%",background:"none",border:"none",color:"#888",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit",marginTop:".6rem"}}>
              Mot de passe oublie ?
            </button>
          )}
          {showForgotPwd&&(
            <div style={{marginTop:"1rem",padding:"1rem",background:"#FAF6F2",borderRadius:12,border:"1px solid #E8DDD4"}}>
              <div style={{fontSize:".78rem",color:"#3D1F0E",fontWeight:600,marginBottom:".6rem",textAlign:"center"}}>Cree un nouveau code personnel</div>
              <input type="password" placeholder="Nouveau code personnel" value={forgotMdp1} onChange={e=>setForgotMdp1(e.target.value)}
                style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".55rem .8rem",fontSize:".82rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
              <input type="password" placeholder="Confirme le code" value={forgotMdp2} onChange={e=>setForgotMdp2(e.target.value)}
                style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".55rem .8rem",fontSize:".82rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
              {forgotError&&<div style={{color:"#C44B1A",fontSize:".72rem",marginBottom:".5rem",textAlign:"center"}}>{forgotError}</div>}
              <button onClick={reinitialiserMdp} disabled={!forgotMdp1.trim()||forgotLoading}
                style={{width:"100%",background:"#3D1F0E",color:"white",border:"none",borderRadius:10,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".4rem"}}>
                {forgotLoading?"Enregistrement...":"Enregistrer et me connecter"}
              </button>
              <button onClick={()=>{setShowForgotPwd(false);setForgotMdp1("");setForgotMdp2("");setForgotError("");}}
                style={{width:"100%",background:"none",border:"none",color:"#888",fontSize:".7rem",cursor:"pointer",fontFamily:"inherit"}}>
                Annuler
              </button>
            </div>
          )}
        </>}

      </div>
    </div>
  );


  // ── APP ──────────────────────────────────────────────────────────────────────
  const todayKey=todayLocalStr();
  const dailyActions=["a1","a2","a3","a4","a5"];
  const actionsToday=dailyActions.filter(id=>checks[`${todayKey}-${id}`]||checks[id]).length;
  const actionsIncomplete=actionsToday<5;
  const periodeInfo=getPeriodeInfo();
  // J1 seulement = moins de 24h depuis le début de la période
  const isJ1Periode = periodeInfo.pctElapsed<=Math.round(100/21);
  const periodeCourante = getPeriodeActuelle();
  const objPeriodeRemplis = objPosesLocal || homeObjPerso?.objectifsPosesPeriode===periodeCourante;
  const showPeriodeBanner = isJ1Periode && !objPeriodeRemplis;
  const bannerKey=`bd-banner-p${periodeCourante}`;
  const closeBanner=()=>{try{localStorage.setItem(bannerKey,"1");}catch{}setShowBanner(false);};

  return(
    <LangContext.Provider value={{lang, translations, t:(k)=>translations[k]||(lang==="pt"?UI_TEXTS_PT[k]:null)||UI_TEXTS[k]||k}}>
    <div
      style={{minHeight:"100vh",background:C.creme,fontFamily:"'DM Sans',system-ui,sans-serif",color:C.texte,userSelect:"none"}}
      onContextMenu={e=>e.preventDefault()}
      onCopy={e=>e.preventDefault()}
      onCut={e=>e.preventDefault()}
    >

      {showWelcome&&(<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:9999,background:"rgba(61,31,14,.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}><div style={{background:"white",borderRadius:20,maxWidth:420,width:"100%",overflow:"hidden"}}><div style={{background:"#3D1F0E",padding:"1.5rem 1.3rem",textAlign:"center"}}><div style={{fontSize:"2.5rem",marginBottom:".5rem"}}>👑</div><div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",color:"white",fontWeight:300}}>Bienvenue {name&&name.split(" ")[0]} !</div><div style={{fontSize:".78rem",color:"#C49A8A",marginTop:".25rem"}}>Tu fais maintenant partie de Blazing Dynasty ✨</div></div><div style={{padding:"1.25rem 1.3rem"}}><div style={{background:"#FAF7F2",borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",fontSize:".78rem",color:"#3D2B1F",lineHeight:1.7}}>🌸 Nous sommes tellement heureuses de t'accueillir dans notre équipe. Tu as fait le bon choix — maintenant on est là pour t'accompagner à chaque étape. Let's go ! 🔥</div><div style={{fontSize:".6rem",fontWeight:700,color:"#888",letterSpacing:".1em",textTransform:"uppercase",marginBottom:".6rem"}}>✦ TES ACCÈS DU MOMENT</div>{[{icon:"🚀",titre:"Fast Start",desc:"7 modules progressifs pour bien démarrer — commence par là !"},{icon:"📱",titre:"Formation Application",desc:"Apprends à utiliser l'appli pour te faciliter la vie"}].map((item,i)=>(<div key={i} onClick={()=>{setShowWelcome(false);setTab("formation");}} style={{display:"flex",alignItems:"center",gap:".75rem",background:"#3D1F0E",borderRadius:10,padding:".7rem .85rem",marginBottom:".4rem",cursor:"pointer"}}><span style={{fontSize:"1.3rem"}}>{item.icon}</span><div style={{flex:1}}><div style={{fontSize:".82rem",fontWeight:700,color:"white"}}>{item.titre}</div><div style={{fontSize:".68rem",color:"#C49A8A"}}>{item.desc}</div></div><span style={{color:"#C49A8A"}}>→</span></div>))}<button onClick={()=>setShowWelcome(false)} style={{width:"100%",background:"#C49A8A",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginTop:".75rem"}}>Commencer mon aventure → 🚀</button></div></div></div>)}

      {showMdpSetup&&(<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:9999,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}><div style={{background:"white",borderRadius:16,padding:"1.5rem",maxWidth:380,width:"100%"}}><div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:"#3D1F0E",marginBottom:".5rem",textAlign:"center"}}>🔐 Crée ton code personnel</div><div style={{fontSize:".75rem",color:"#888",marginBottom:"1rem",textAlign:"center",lineHeight:1.5}}>Pour sécuriser ton espace, choisis un code personnel que tu saisiras à chaque connexion.</div><input type="password" placeholder="Ton code personnel" value={newMdp} onChange={e=>setNewMdp(e.target.value)} style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/><input type="password" placeholder="Confirme ton code" value={newMdp2} onChange={e=>setNewMdp2(e.target.value)} style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",marginBottom:".75rem",outline:"none"}}/>{newMdp&&newMdp!==newMdp2&&<div style={{fontSize:".7rem",color:"#C44B1A",marginBottom:".5rem"}}>Les codes ne correspondent pas</div>}<button onClick={async()=>{if(!newMdp.trim()||newMdp!==newMdp2)return;try{await definirMotDePasseFn({motDePasse:newMdp.trim()});setShowMdpSetup(false);setNewMdp("");setNewMdp2("");}catch{}}} disabled={!newMdp.trim()||newMdp!==newMdp2} style={{width:"100%",background:"#3D1F0E",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>Enregistrer mon code</button><button onClick={()=>setShowMdpSetup(false)} style={{width:"100%",background:"none",border:"none",color:"#888",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>Plus tard</button></div></div>)}
      {showMonCompte&&(<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:9999,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}><div style={{background:"white",borderRadius:16,padding:"1.5rem",maxWidth:380,width:"100%",maxHeight:"85vh",overflowY:"auto",position:"relative"}}>
        <button onClick={()=>{setShowMonCompte(false);setCompteMdp1("");setCompteMdp2("");setCompteError("");}}
          style={{position:"sticky",top:0,float:"right",marginLeft:"auto",marginBottom:"-1.5rem",background:"#F5EFE8",border:"none",borderRadius:"50%",width:28,height:28,fontSize:"1rem",color:"#888",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2}}>
          ✕
        </button>
        <div id="decouverte-compte-titre" style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:"#3D1F0E",marginBottom:".5rem",textAlign:"center"}}>🔐 Mon compte</div>
        <div style={{display:"flex",justifyContent:"center",marginBottom:".7rem"}}>
          <button onClick={()=>setShowDecouverteCompte(true)} style={{background:"#C49A8A",color:"white",border:"none",borderRadius:20,padding:".35rem 1rem",fontSize:".72rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",boxShadow:"0 2px 8px rgba(196,154,138,.4)"}}>🧭 Découverte</button>
        </div>
        <div style={{fontSize:".75rem",color:"#888",marginBottom:"1rem",textAlign:"center",lineHeight:1.5}}>Change ton code personnel de connexion.</div>
        {compteSuccess?(
          <div style={{textAlign:"center",padding:"1rem",color:"#5A8A5A",fontSize:".85rem",fontWeight:600}}>✅ Code modifie avec succes !</div>
        ):(<>
          <input type="password" placeholder="Nouveau code personnel" value={compteMdp1} onChange={e=>setCompteMdp1(e.target.value)}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
          <input type="password" placeholder="Confirme le nouveau code" value={compteMdp2} onChange={e=>setCompteMdp2(e.target.value)}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".6rem .9rem",fontSize:".85rem",fontFamily:"inherit",marginBottom:".75rem",outline:"none"}}/>
          {compteMdp1&&compteMdp2&&compteMdp1!==compteMdp2&&<div style={{fontSize:".7rem",color:"#C44B1A",marginBottom:".5rem"}}>Les codes ne correspondent pas</div>}
          {compteError&&<div style={{fontSize:".7rem",color:"#C44B1A",marginBottom:".5rem"}}>{compteError}</div>}
          <button onClick={changerMdpCompte} disabled={!compteMdp1.trim()||compteMdp1!==compteMdp2||compteLoading}
            style={{width:"100%",background:"#3D1F0E",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
            {compteLoading?"Enregistrement...":"Enregistrer mon nouveau code"}
          </button>
          <div style={{borderTop:"1px solid #E8DDD4",margin:"1rem 0",paddingTop:"1rem"}}>
          <div style={{fontSize:".75rem",fontWeight:600,color:"#3D1F0E",marginBottom:".5rem"}}>💬 Mes liens de contact</div>
          <div style={{fontSize:".68rem",color:"#888",marginBottom:".6rem",lineHeight:1.5}}>Pour que tes prospects puissent te contacter en 1 clic apres un diagnostic ou tunnel.</div>
          <input placeholder="Numero WhatsApp (ex: 33612345678)" value={contactWhatsapp} onChange={e=>setContactWhatsapp(e.target.value)}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".55rem .8rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
          <input placeholder="Ton nom d'utilisateur Facebook (pas le lien)" value={contactMessenger} onChange={e=>setContactMessenger(e.target.value)}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".55rem .8rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
          <input placeholder="Pseudo Instagram (sans le @)" value={contactInstagram} onChange={e=>setContactInstagram(e.target.value)}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".55rem .8rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".6rem",outline:"none"}}/>
          <div style={{fontSize:".62rem",color:"#B8905F",marginBottom:".6rem",lineHeight:1.5}}>ℹ️ Instagram ouvrira ton profil, la personne devra cliquer sur "Envoyer un message" elle-meme (limite technique d'Instagram).</div>
          <button onClick={sauverContacts}
            style={{width:"100%",background:contactSaved?"#5A8A5A":"#3D1F0E",color:"white",border:"none",borderRadius:10,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            {contactSaved?"✅ Enregistre !":"Enregistrer mes liens"}
          </button>
        </div>
<div id="decouverte-compte-boutique" style={{background:"#F4F0FF",borderRadius:12,padding:"1rem",marginBottom:"1rem",border:"1px solid #D8CCFF"}}>
          <div style={{fontSize:".7rem",fontWeight:700,color:"#3D1F0E",marginBottom:".3rem"}}>🛍️ Boutique en ligne — encaisser tes ventes</div>
          <div style={{fontSize:".68rem",color:"#888",marginBottom:".7rem",lineHeight:1.5}}>
            Renseigne ton propre lien de paiement personnel (PayPal et/ou Stripe) — indépendant de la plateforme, c'est ton compte à toi, ton argent va directement chez toi.
          </div>

          <div style={{fontSize:".68rem",fontWeight:700,color:"#0070BA",marginBottom:".3rem"}}>🅿️ PayPal.me</div>
          <div style={{fontSize:".62rem",color:"#888",marginBottom:".4rem",lineHeight:1.5}}>
            Va sur <a href="https://paypal.me" target="_blank" rel="noopener noreferrer" style={{color:"#0070BA"}}>paypal.me</a> pour créer ton lien personnel (2 minutes) — indique juste ton pseudo ci-dessous, le reste est déjà prérempli.
          </div>
          <div style={{display:"flex",alignItems:"center",border:"1px solid #D8CCFF",borderRadius:8,marginBottom:".8rem",overflow:"hidden"}}>
            <span style={{padding:".42rem .5rem",fontSize:".76rem",color:"#888",background:"#F4F0FF",whiteSpace:"nowrap",fontFamily:"inherit"}}>paypal.me/</span>
            <input value={lienPaypalMe.replace(/^https?:\/\/(www\.)?paypal\.me\//i,"")} onChange={e=>setLienPaypalMe("https://paypal.me/"+e.target.value.replace(/^\/+/,""))} placeholder="tonpseudo"
              style={{flex:1,border:"none",padding:".42rem .5rem",fontSize:".76rem",fontFamily:"inherit",outline:"none"}}/>
          </div>

          <div style={{fontSize:".68rem",fontWeight:700,color:"#635BFF",marginBottom:".3rem"}}>💳 Lien de paiement Stripe</div>
          <div style={{fontSize:".62rem",color:"#888",marginBottom:".4rem",lineHeight:1.5}}>
            Crée un compte Stripe personnel sur <a href="https://dashboard.stripe.com/register" target="_blank" rel="noopener noreferrer" style={{color:"#635BFF"}}>stripe.com</a>, puis dans "Paiements → Liens de paiement", crée un lien avec l'option "La cliente choisit le montant". Colle le lien obtenu ici.
          </div>
          <input value={lienStripePerso} onChange={e=>setLienStripePerso(e.target.value)} placeholder="https://buy.stripe.com/..."
            style={{width:"100%",border:"1px solid #D8CCFF",borderRadius:8,padding:".42rem .65rem",fontSize:".76rem",fontFamily:"inherit",marginBottom:".8rem",outline:"none"}}/>

          <button onClick={sauverPaiementPerso} disabled={paiementSaving}
            style={{width:"100%",background:paiementSaved?"#2E7D32":"#3D1F0E",color:"white",border:"none",borderRadius:8,padding:".55rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            {paiementSaving?"...":paiementSaved?"✅ Enregistré !":"Enregistrer mes liens de paiement"}
          </button>
        </div>
        <BlocPaiementsAlternatifs uid={userId}/>
        {/* TOKENS-COMPTE */}
        <div style={{background:"#FDF8EC",borderRadius:12,padding:"1rem",marginBottom:"1rem",border:"1px solid #C4A962"}}>
          <div style={{fontSize:".7rem",fontWeight:700,color:"#3D1F0E",marginBottom:".3rem"}}>🎁 Tokens cadeaux — offres exclusives</div>
          <div style={{fontSize:".68rem",color:"#888",marginBottom:".7rem",lineHeight:1.5}}>
            Ajoute des liens tokens Mihi pour offrir des cadeaux a tes nouvelles clientes ou recrues. Chaque lien ne peut etre utilise qu'une seule fois.
          </div>
          <TokensCadeauxTab uid={userId} db={db} prenom={name}/>
        </div>
        <div id="decouverte-compte-email" style={{background:"#FFF3EC",borderRadius:12,padding:"1rem",marginBottom:"1rem",border:"1px solid #F0D8C8"}}>
          <div style={{fontSize:".7rem",fontWeight:700,color:"#3D1F0E",marginBottom:".3rem"}}>🔔 Alerte email nouvelle commande</div>
          <div style={{fontSize:".68rem",color:"#888",marginBottom:".6rem",lineHeight:1.5}}>
            Reçois un email à chaque fois qu'une cliente commande dans ta boutique — en plus de la notification dans l'app.
          </div>
          <input placeholder="ton-email@exemple.com" type="email" value={emailNotifCommandes} onChange={e=>setEmailNotifCommandes(e.target.value)}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:10,padding:".55rem .8rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".6rem",outline:"none"}}/>
          <button onClick={sauverEmailNotifCommandes} disabled={emailNotifSaving}
            style={{width:"100%",background:emailNotifSaved?"#2E7D32":"#C44B1A",color:"white",border:"none",borderRadius:8,padding:".55rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            {emailNotifSaving?"...":emailNotifSaved?"✅ Enregistré !":"Enregistrer mon email"}
          </button>
        </div>
        <div id="decouverte-compte-vip" style={{background:"#F3EEFB",borderRadius:12,padding:"1rem",marginBottom:"1rem",border:"1px solid #E0D4F5"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".3rem"}}>
            <div style={{fontSize:".7rem",fontWeight:700,color:"#3D1F0E"}}>💎 Afficher le prix VIP</div>
            <div onClick={toggleAfficherPrixVIP} style={{width:40,height:22,borderRadius:20,background:afficherPrixVIP?"#8B6FB3":"#DDD",position:"relative",cursor:"pointer",transition:"background .2s",flexShrink:0}}>
              <div style={{width:18,height:18,borderRadius:"50%",background:"white",position:"absolute",top:2,left:afficherPrixVIP?20:2,transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,.3)"}}/>
            </div>
          </div>
          <div style={{fontSize:".68rem",color:"#888",lineHeight:1.5}}>
            Si activé, tes diagnostics et recommandations IA afficheront aussi un prix VIP à côté du prix normal, en plus de tes clientes.
          </div>
          {afficherPrixVIP&&(
            <div style={{marginTop:".8rem",paddingTop:".8rem",borderTop:"1px solid #E0D4F5"}}>
              <div style={{fontSize:".68rem",fontWeight:700,color:"#3D1F0E",marginBottom:".3rem"}}>🔗 Lien d'inscription Mihi</div>
              <div style={{fontSize:".64rem",color:"#888",marginBottom:".5rem",lineHeight:1.5}}>
                Ce lien s'affichera dans un popup incitant tes clientes à s'inscrire pour profiter du prix VIP, juste après avoir reçu leurs recommandations.
              </div>
              <input value={lienInscriptionMihi} onChange={e=>setLienInscriptionMihi(e.target.value)} placeholder="https://..."
                style={{width:"100%",border:"1px solid #E0D4F5",borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
              <button onClick={sauverLienInscriptionMihi} disabled={lienInscriptionSaving}
                style={{width:"100%",background:lienInscriptionSaved?"#2E7D32":"#8B6FB3",color:"white",border:"none",borderRadius:8,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                {lienInscriptionSaving?"...":lienInscriptionSaved?"✅ Enregistré !":"Enregistrer ce lien"}
              </button>
            </div>
          )}
        </div>
            <div style={{marginTop:"1rem",paddingTop:"1rem",borderTop:"1px solid #E0D4F5"}}>
              <div style={{fontSize:".7rem",fontWeight:700,color:"#3D1F0E",marginBottom:".3rem"}}>{"\u{1F517} Personnalise ton lien"}</div>
              <div style={{fontSize:".68rem",color:"#888",marginBottom:".5rem",lineHeight:1.5}}>
                Remplace ton identifiant technique par un pseudo dans tes liens de diagnostic partages.
              </div>
              <div style={{fontSize:".64rem",color:"#8B6FB3",marginBottom:".4rem",fontFamily:"monospace"}}>
                blazing-dinasty-1fad9.web.app/d/{pseudoLien||"tonpseudo"}
              </div>
              <input value={pseudoLien} onChange={e=>{setPseudoLien(e.target.value);setPseudoLienError("");}} placeholder="tonpseudo"
                style={{width:"100%",border:"1px solid #E0D4F5",borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
              {pseudoLienError&&<div style={{fontSize:".66rem",color:"#B04040",marginBottom:".4rem"}}>{pseudoLienError}</div>}
              <button onClick={sauverPseudoLien} disabled={pseudoLienSaving}
                style={{width:"100%",background:pseudoLienSaved?"#2E7D32":"#8B6FB3",color:"white",border:"none",borderRadius:8,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                {pseudoLienSaving?"...":pseudoLienSaved?"Enregistre !":"Enregistrer mon pseudo"}
              </button>
            </div>
        <button onClick={()=>{setShowMonCompte(false);setCompteMdp1("");setCompteMdp2("");setCompteError("");}}
            style={{width:"100%",background:"none",border:"none",color:"#888",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>
            Fermer
          </button>
        </>)}
      </div></div>)}
      {showDecouverteCompte&&<DecouverteTour outil="moncompte" onClose={()=>setShowDecouverteCompte(false)}/>}
      {showStripeForm&&(<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:10000,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}>
        <div style={{background:"white",borderRadius:16,padding:"1.5rem",maxWidth:400,width:"100%",maxHeight:"85vh",overflowY:"auto",position:"relative"}}>
          <button onClick={()=>{setShowStripeForm(false);setStripeFormError("");}}
            style={{position:"sticky",top:0,float:"right",marginBottom:"-1.5rem",background:"#F5EFE8",border:"none",borderRadius:"50%",width:28,height:28,fontSize:"1rem",color:"#888",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2}}>✕</button>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:"#3D1F0E",marginBottom:".3rem"}}>💳 Activer tes paiements</div>
          <p style={{fontSize:".7rem",color:"#888",marginBottom:"1rem",lineHeight:1.5}}>
            Conformément à la réglementation française, tes informations personnelles sont transmises directement et de façon sécurisée à Stripe — nous ne les stockons jamais sur nos serveurs.
          </p>
          <div style={{display:"flex",gap:".5rem",marginBottom:".5rem"}}>
            <input placeholder="Prénom" value={stripeForm.prenom} onChange={e=>setStripeForm(p=>({...p,prenom:e.target.value}))}
              style={{flex:1,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none"}}/>
            <input placeholder="Nom" value={stripeForm.nom} onChange={e=>setStripeForm(p=>({...p,nom:e.target.value}))}
              style={{flex:1,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none"}}/>
          </div>
          <div style={{fontSize:".62rem",color:"#888",marginBottom:".3rem"}}>Date de naissance</div>
          <div style={{display:"flex",gap:".5rem",marginBottom:".5rem"}}>
            <input placeholder="JJ" maxLength={2} value={stripeForm.jour} onChange={e=>setStripeForm(p=>({...p,jour:e.target.value.replace(/\D/g,"")}))}
              style={{width:60,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",textAlign:"center"}}/>
            <input placeholder="MM" maxLength={2} value={stripeForm.mois} onChange={e=>setStripeForm(p=>({...p,mois:e.target.value.replace(/\D/g,"")}))}
              style={{width:60,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",textAlign:"center"}}/>
            <input placeholder="AAAA" maxLength={4} value={stripeForm.annee} onChange={e=>setStripeForm(p=>({...p,annee:e.target.value.replace(/\D/g,"")}))}
              style={{width:75,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",textAlign:"center"}}/>
          </div>
          <input placeholder="Adresse" value={stripeForm.adresse} onChange={e=>setStripeForm(p=>({...p,adresse:e.target.value}))}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",marginBottom:".5rem"}}/>
          <div style={{display:"flex",gap:".5rem",marginBottom:".5rem"}}>
            <input placeholder="Ville" value={stripeForm.ville} onChange={e=>setStripeForm(p=>({...p,ville:e.target.value}))}
              style={{flex:1,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none"}}/>
            <input placeholder="Code postal" value={stripeForm.codePostal} onChange={e=>setStripeForm(p=>({...p,codePostal:e.target.value}))}
              style={{width:110,border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none"}}/>
          </div>
          <input placeholder="Téléphone (ex: 06 12 34 56 78)" value={stripeForm.telephone} onChange={e=>setStripeForm(p=>({...p,telephone:e.target.value}))}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",marginBottom:".5rem"}}/>
          <input placeholder="Email" type="email" value={stripeForm.email} onChange={e=>setStripeForm(p=>({...p,email:e.target.value}))}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",marginBottom:".7rem"}}/>
          <label style={{display:"flex",alignItems:"flex-start",gap:".5rem",marginBottom:".8rem",cursor:"pointer"}}>
            <input type="checkbox" checked={stripeForm.accepteConditions} onChange={e=>setStripeForm(p=>({...p,accepteConditions:e.target.checked}))} style={{marginTop:".2rem"}}/>
            <span style={{fontSize:".66rem",color:"#666",lineHeight:1.5}}>
              En cochant cette case, j'accepte le <a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener noreferrer" style={{color:"#635BFF"}}>Contrat de compte connecté Stripe</a>.
            </span>
          </label>
          {stripeFormError&&<div style={{background:"#FFF3F0",color:"#C44B1A",borderRadius:8,padding:".55rem",fontSize:".72rem",marginBottom:".7rem"}}>{stripeFormError}</div>}
          <button onClick={soumettreStripeForm} disabled={stripeLoading}
            style={{width:"100%",background:"#635BFF",color:"white",border:"none",borderRadius:8,padding:".6rem",fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            {stripeLoading?"...":"Continuer vers Stripe"}
          </button>
        </div>
      </div>)}

      {/* BANNIÈRE NOUVELLE PÉRIODE */}
      {showPeriodeBanner&&(
        <div style={{background:"linear-gradient(135deg,#C44B1A,#8B3010)",padding:".85rem 1rem",display:"flex",gap:".75rem",alignItems:"flex-start",position:"sticky",top:0,zIndex:150}}>
          <span style={{fontSize:"1.2rem",flexShrink:0}}>🎯</span>
          <div style={{flex:1}}>
            <div style={{fontSize:".78rem",fontWeight:700,color:"white",marginBottom:".2rem"}}>
              Nouvelle période — Fixe tes objectifs !
            </div>
            <div style={{fontSize:".7rem",color:"rgba(255,255,255,.85)",lineHeight:1.5}}>
              Une nouvelle période de 21 jours vient de commencer. Prends 2 minutes pour fixer combien d'argent tu vas aller chercher dans ta tirelire 🐷, ainsi que ton palier et ton objectif de recrues.
            </div>
            <div style={{display:"flex",gap:".4rem",marginTop:".5rem",flexWrap:"wrap"}}>
              <button onClick={()=>{setTab("dashboard");try{window.dispatchEvent(new Event("ouvrir-tirelire"));}catch{}}}
                style={{background:"white",color:"#C44B1A",border:"none",borderRadius:8,padding:".3rem .75rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                🐷 Fixer mon objectif en €
              </button>
              <button onClick={async()=>{
                const newObj={...(homeObjPerso||{}),objectifsPosesPeriode:periodeCourante};
                setHomeObjPerso(newObj);
                setObjPosesLocal(true);
                const existingRaw=JSON.stringify(newObj);
                try{
                  await setDoc(doc(db,"users",userId),{"db-obj-perso":existingRaw},{merge:true});
                }catch(e){console.warn(e);}
              }}
                style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.5)",borderRadius:8,padding:".3rem .75rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                ✅ Mes objectifs sont posés
              </button>
            </div>
          </div>
        </div>
      )}

      {/* HEADER */}
      <div style={{background:C.brun,padding:"1rem 1rem .85rem",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",inset:0,backgroundImage:"repeating-linear-gradient(45deg,transparent,transparent 20px,rgba(196,168,130,.04) 20px,rgba(196,168,130,.04) 21px)"}}/>
        <div style={{position:"relative",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:".52rem",fontWeight:700,letterSpacing:".2em",color:C.or}}>✦ BLAZING DYNASTY</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:300,color:C.blanc,marginTop:".15rem"}}>
              Bonjour <strong style={{color:C.or,fontWeight:600}}>{name}</strong>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
            {/* Langue */}
            <a href={"https://translate.google.com/translate?sl=fr&tl=pt&u="+encodeURIComponent(window.location.href)} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}} title="Traduzir para português"><button disabled={false}
              style={{background:"rgba(196,168,130,.15)",border:`1px solid ${C.or}40`,borderRadius:20,padding:".22rem .55rem",cursor:translating?"default":"pointer",fontFamily:"inherit",fontSize:".62rem",fontWeight:700,color:C.or,opacity:translating?.6:1}}
              title={lang==="fr"?"Traduzir para português":"Revenir en français"}>
              🇵🇹
            </button></a>
            {/* Notification actions du jour */}
            {actionsIncomplete&&(
              <button onClick={()=>setTab("dashboard")}
                style={{display:"flex",alignItems:"center",gap:".35rem",background:"rgba(196,154,138,.2)",border:`1px solid ${C.rose}`,borderRadius:20,padding:".25rem .6rem",cursor:"pointer",fontFamily:"inherit"}}>
                <span style={{width:16,height:16,borderRadius:"50%",background:C.rose,color:"white",fontSize:".52rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{5-actionsToday}</span>
                <span style={{fontSize:".6rem",color:C.pale,fontWeight:600}}>actions restantes</span>
              </button>
            )}
            {!actionsIncomplete&&(
              <div style={{display:"flex",alignItems:"center",gap:".3rem",background:"rgba(127,175,138,.15)",border:`1px solid ${C.vert}`,borderRadius:20,padding:".25rem .6rem"}}>
                <span style={{fontSize:".7rem"}}>✅</span>
                <span style={{fontSize:".6rem",color:C.vert,fontWeight:600}}>Journée complète !</span>
              </div>
            )}
            <button onClick={async()=>{setShowMonCompte(true);setCompteError("");setCompteSuccess(false);try{const d=await sgAll(userId);setContactWhatsapp(d?.["db-contact-whatsapp"]||"");setContactMessenger(d?.["db-contact-messenger"]||"");setContactInstagram(d?.["db-contact-instagram"]||"");}catch{}}} style={{padding:".25rem .5rem",fontSize:".7rem",color:C.gris,border:`1px solid rgba(196,168,130,.2)`,borderRadius:20,background:"none",cursor:"pointer",fontFamily:"inherit"}}>🔐</button>
            <button onClick={()=>{try{localStorage.removeItem("bd-user");}catch{}setScreen("login");}} style={{padding:".25rem .6rem",fontSize:".6rem",color:C.gris,border:`1px solid rgba(196,168,130,.2)`,borderRadius:20,background:"none",cursor:"pointer",fontFamily:"inherit"}}>↩</button>
          </div>
        </div>
        <div style={{position:"relative",marginTop:".6rem",display:"flex",gap:".5rem"}}>
          <div style={{flex:1}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:".55rem",color:C.pale,opacity:.7,marginBottom:".2rem"}}>
              <span>Posts cochés</span><span>{donePosts}/{allPosts.length}</span>
            </div>
            <div style={{height:3,background:"rgba(255,255,255,.1)",borderRadius:10,overflow:"hidden"}}>
              <div style={{height:"100%",background:C.rose,width:(allPosts.length?Math.round(donePosts/allPosts.length*100):0)+"%",borderRadius:10,transition:"width .4s"}}/>
            </div>
          </div>
        </div>
      </div>

      {/* NAV + TIRELIRE (toujours visibles en haut) */}
      <div style={{position:"sticky",top:0,zIndex:100}}>
      <div style={{background:C.blanc,borderBottom:`1px solid ${C.pale}`,display:"flex",overflowX:"auto",boxShadow:"0 1px 8px rgba(61,31,14,.06)"}}>
        {TABS.map(tb=>(
          <button key={tb.id} onClick={()=>{
              setTab(tb.id);
              if(tb.id==="formation"){
                const nouveautesIds=Object.keys(formationNouveautes);
                if(nouveautesIds.length===1)setFormationSubTab(nouveautesIds[0]);
                else setFormationSubTab("");
              }
            }}
            style={{flex:"none",padding:".72rem .85rem",fontSize:".6rem",fontWeight:tb.id==="challenge"?800:600,letterSpacing:".05em",textTransform:"uppercase",color:tb.id==="challenge"?"#C62828":(tab===tb.id?C.brun:C.gris),border:"none",borderBottom:`2px solid ${tb.id==="challenge"?"#C62828":(tab===tb.id?C.rose:"transparent")}`,background:tb.id==="challenge"?"#C6282810":"none",cursor:"pointer",whiteSpace:"nowrap",fontFamily:"inherit",transition:"all .2s",position:"relative"}}>
            {(()=>{
              let n=0;
              if(tb.id==="communaute")n=nbNotifCommunaute;
              if(tb.id==="formation")n=Object.keys(formationNouveautes).length;
              if(tb.id==="boiteaoutils")n=nbDiagNonLus;
              if(tb.id==="calendrier")n=nbNotifCalendrier;
              if(tb.id==="espacechef")n=nbMsgsNonLusApp;
              if(tb.id==="dashboard"){
                const nUrgent=(objPeriodeRemplis?0:1)+nbNotifDashboard.relances+nbCommandesNonVues;
                const nActions=nbNotifDashboard.actions;
                return(<>
                  {nUrgent>0&&(
                    <span style={{position:"absolute",top:1,right:1,minWidth:15,height:15,padding:"0 3px",borderRadius:20,background:"#E63946",border:"1.5px solid white",boxShadow:"0 0 0 2px rgba(230,57,70,.3)",color:"white",fontSize:".55rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",lineHeight:1}}>
                      {nUrgent>99?"99+":nUrgent}
                    </span>
                  )}
                  {nActions>0&&(
                    <span style={{position:"absolute",top:1,right:nUrgent>0?16:1,minWidth:15,height:15,padding:"0 3px",borderRadius:20,background:C.or,border:"1.5px solid white",boxShadow:"0 0 0 2px rgba(196,154,84,.3)",color:"white",fontSize:".55rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",lineHeight:1}}>
                      {nActions}
                    </span>
                  )}
                </>);
              }
              if(n<=0)return null;
              return(
                <span style={{position:"absolute",top:1,right:1,minWidth:15,height:15,padding:"0 3px",borderRadius:20,background:"#E63946",border:"1.5px solid white",boxShadow:"0 0 0 2px rgba(230,57,70,.3)",color:"white",fontSize:".55rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",lineHeight:1}}>
                  {n>99?"99+":n}
                </span>
              );
            })()}
            {tb.label}
          </button>
        ))}
      </div>
      {userId&&<TirelireBandeau uid={userId} userName={name}/>}
      </div>

      {userId&&<BandeauChallenge uid={userId} onOuvrir={()=>setTab("challenge")}/>}
      {userId&&<RappelPeriodePopup uid={userId} onAller={()=>{setTab("dashboard");setDashboardSousOnglet("quotidien");setOuvrirBusinessTrigger(t=>t+1);}}/>}

      {/* SOUS-NAV TABLEAU DE BORD */}
      {tab==="dashboard"&&(
        <div style={{background:C.creme,borderBottom:`1px solid ${C.pale}`,position:"sticky",top:0,zIndex:99,padding:".6rem .9rem"}}>
          <button onClick={()=>setMenuDashboardOuvert(true)}
            style={{display:"flex",alignItems:"center",gap:".55rem",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",padding:0}}>
            <span style={{fontSize:"1.2rem"}}>&#9776;</span>
            <span>
              <div style={{fontSize:".95rem",fontWeight:700,color:C.brun}}>Menu</div>
              <div style={{fontSize:".68rem",color:C.gris}}>{DASHBOARD_SOUS_ONGLETS.find(s=>s.id===dashboardSousOnglet)?.label||""}</div>
            </span>
          </button>
        </div>
      )}
      {menuDashboardOuvert&&(
        <div onClick={()=>setMenuDashboardOuvert(false)} style={{position:"fixed",inset:0,background:"rgba(61,31,14,.45)",zIndex:998}}>
          <div onClick={e=>e.stopPropagation()} style={{position:"fixed",top:0,left:0,bottom:0,width:"78%",maxWidth:300,background:"white",zIndex:999,padding:"1rem",overflowY:"auto",boxShadow:"4px 0 24px rgba(0,0,0,.25)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
              <span style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",color:C.brun}}>Tableau de bord</span>
              <button onClick={()=>setMenuDashboardOuvert(false)} style={{background:"none",border:"none",fontSize:"1.15rem",color:C.gris,cursor:"pointer",padding:0}}>&#10005;</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
              {DASHBOARD_SOUS_ONGLETS.map(s=>{
                const nUrgentPill=s.id==="quotidien"?((objPeriodeRemplis?0:1)+nbNotifDashboard.relances):0;
                const nActionsPill=s.id==="quotidien"?nbNotifDashboard.actions:0;
                return(
                <button key={s.id} onClick={()=>{setDashboardSousOnglet(s.id);setMenuDashboardOuvert(false);}}
                  style={{width:"100%",textAlign:"left",padding:".6rem .8rem",fontSize:".76rem",fontWeight:600,borderRadius:10,border:`1.5px solid ${dashboardSousOnglet===s.id?C.rose:C.pale}`,background:dashboardSousOnglet===s.id?C.rose:C.blanc,color:dashboardSousOnglet===s.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"space-between",gap:".3rem"}}>
                  <span>{s.label}</span>
                  <span style={{display:"flex",gap:".3rem"}}>
                    {nUrgentPill>0&&<span style={{background:dashboardSousOnglet===s.id?"white":"#E63946",color:dashboardSousOnglet===s.id?C.rose:"white",borderRadius:20,fontSize:".6rem",fontWeight:700,minWidth:15,height:15,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>{nUrgentPill}</span>}
                    {nActionsPill>0&&<span style={{background:dashboardSousOnglet===s.id?"white":C.or,color:dashboardSousOnglet===s.id?C.or:"white",borderRadius:20,fontSize:".6rem",fontWeight:700,minWidth:15,height:15,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>{nActionsPill}</span>}
                  </span>
                </button>
              );})}
            </div>
          </div>
        </div>
      )}

      {/* SOUS-NAV MA BOITE A OUTILS */}
      {tab==="boiteaoutils"&&(
        <div style={{background:C.creme,borderBottom:`1px solid ${C.pale}`,position:"sticky",top:0,zIndex:99,padding:".6rem .9rem"}}>
          <button onClick={()=>setMenuOutilsOuvert(true)}
            style={{display:"flex",alignItems:"center",gap:".55rem",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",padding:0}}>
            <span style={{fontSize:"1.2rem"}}>&#9776;</span>
            <span>
              <div style={{fontSize:".95rem",fontWeight:700,color:C.brun}}>Menu</div>
              <div style={{fontSize:".68rem",color:C.gris}}>{OUTILS_SOUS_ONGLETS.find(s=>s.id===outilsSousOnglet)?.label||""}</div>
            </span>
          </button>
        </div>
      )}
      {menuOutilsOuvert&&(
        <div onClick={()=>setMenuOutilsOuvert(false)} style={{position:"fixed",inset:0,background:"rgba(61,31,14,.45)",zIndex:998}}>
          <div onClick={e=>e.stopPropagation()} style={{position:"fixed",top:0,left:0,bottom:0,width:"78%",maxWidth:300,background:"white",zIndex:999,padding:"1rem",overflowY:"auto",boxShadow:"4px 0 24px rgba(0,0,0,.25)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
              <span style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",color:C.brun}}>Boite a outils</span>
              <button onClick={()=>setMenuOutilsOuvert(false)} style={{background:"none",border:"none",fontSize:"1.15rem",color:C.gris,cursor:"pointer",padding:0}}>&#10005;</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
              {OUTILS_SOUS_ONGLETS.map(s=>{
                const nPill=s.id==="diagnostics"?nbDiagNonLus:0;
                return(
                <button key={s.id} onClick={()=>{setOutilsSousOnglet(s.id);if(s.id==="diagnostics")setNbDiagNonLus(0);setMenuOutilsOuvert(false);}}
                  style={{width:"100%",textAlign:"left",padding:".6rem .8rem",fontSize:".76rem",fontWeight:600,borderRadius:10,border:`1.5px solid ${outilsSousOnglet===s.id?C.rose:C.pale}`,background:outilsSousOnglet===s.id?C.rose:C.blanc,color:outilsSousOnglet===s.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"space-between",gap:".3rem"}}>
                  <span>{s.label}</span>
                  {nPill>0&&<span style={{background:outilsSousOnglet===s.id?"white":"#E63946",color:outilsSousOnglet===s.id?C.rose:"white",borderRadius:20,fontSize:".6rem",fontWeight:700,minWidth:15,height:15,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>{nPill}</span>}
                </button>
              );})}
            </div>
          </div>
        </div>
      )}

      {/* SOUS-NAV AIDE A LA COMMUNICATION */}
      {tab==="communication"&&(
        <div style={{background:C.creme,borderBottom:`1px solid ${C.pale}`,position:"sticky",top:0,zIndex:99,padding:".6rem .9rem"}}>
          <button onClick={()=>setMenuCommunicationOuvert(true)}
            style={{display:"flex",alignItems:"center",gap:".55rem",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",padding:0}}>
            <span style={{fontSize:"1.2rem"}}>&#9776;</span>
            <span>
              <div style={{fontSize:".95rem",fontWeight:700,color:C.brun}}>Menu</div>
              <div style={{fontSize:".68rem",color:C.gris}}>{COMMUNICATION_SOUS_ONGLETS.find(s=>s.id===communicationSousOnglet)?.label||""}</div>
            </span>
          </button>
        </div>
      )}
      {menuCommunicationOuvert&&(
        <div onClick={()=>setMenuCommunicationOuvert(false)} style={{position:"fixed",inset:0,background:"rgba(61,31,14,.45)",zIndex:998}}>
          <div onClick={e=>e.stopPropagation()} style={{position:"fixed",top:0,left:0,bottom:0,width:"78%",maxWidth:300,background:"white",zIndex:999,padding:"1rem",overflowY:"auto",boxShadow:"4px 0 24px rgba(0,0,0,.25)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
              <span style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",color:C.brun}}>Communication &amp; Réseaux</span>
              <button onClick={()=>setMenuCommunicationOuvert(false)} style={{background:"none",border:"none",fontSize:"1.15rem",color:C.gris,cursor:"pointer",padding:0}}>&#10005;</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
              <button key="analyse" onClick={()=>{setCommunicationSousOnglet("analyse");setMenuCommunicationOuvert(false);}}
                  style={{width:"100%",textAlign:"left",padding:".8rem .9rem",borderRadius:12,border:communicationSousOnglet==="analyse"?"2px solid "+C.brun:"2px solid transparent",background:"linear-gradient(135deg,"+C.rose+","+C.or+")",color:"white",cursor:"pointer",fontFamily:"inherit",boxShadow:"0 4px 14px rgba(196,117,106,.3)",marginBottom:".3rem"}}>
                  <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".14em",opacity:.9}}>✨ NOUVEAU</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:".98rem",fontWeight:700,marginTop:".1rem"}}>📈 Analyse réseaux IA</div>
                  <div style={{fontSize:".66rem",opacity:.95,marginTop:".15rem",lineHeight:1.4}}>Diagnostic · plan de posts · scripts · bibliothèque d'idées</div>
                </button>
                <button key="stories" onClick={()=>{setCommunicationSousOnglet("stories");setStoriesJourLien(0);setMenuCommunicationOuvert(false);}}
                  style={{width:"100%",textAlign:"left",padding:".7rem .9rem",borderRadius:12,border:communicationSousOnglet==="stories"?"2px solid "+C.brun:"2px solid "+C.rose,background:"white",color:C.brun,cursor:"pointer",fontFamily:"inherit",marginBottom:".3rem",display:"flex",alignItems:"center",gap:".6rem"}}>
                  <span style={{fontSize:"1.25rem"}}>📱</span>
                  <span style={{flex:1}}>
                    <span style={{display:"block",fontFamily:"Georgia,serif",fontSize:".95rem",fontWeight:700}}>Stories 14 jours</span>
                    <span style={{display:"block",fontSize:".64rem",color:C.gris,lineHeight:1.4}}>Un programme, un jour à la fois</span>
                  </span>
                  <span style={{background:C.rose,color:"white",fontSize:".58rem",fontWeight:800,letterSpacing:".08em",borderRadius:8,padding:".15rem .45rem"}}>NEW</span>
                </button>
              {COMMUNICATION_SOUS_ONGLETS.filter(s=>!s.vedette).map(s=>(
                <button key={s.id} onClick={()=>{setCommunicationSousOnglet(s.id);setMenuCommunicationOuvert(false);}}
                  style={{width:"100%",textAlign:"left",padding:".6rem .8rem",fontSize:".76rem",fontWeight:600,borderRadius:10,border:`1.5px solid ${communicationSousOnglet===s.id?C.rose:C.pale}`,background:communicationSousOnglet===s.id?C.rose:C.blanc,color:communicationSousOnglet===s.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                  {s.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* RETOUR FORMATION (quand un dossier est ouvert) */}
      {tab==="formation"&&formationSubTab&&(
        <div style={{background:C.creme,borderBottom:`1px solid ${C.pale}`,position:"sticky",top:0,zIndex:99,padding:".5rem 1rem"}}>
          <button onClick={()=>setFormationSubTab("")}
            style={{background:"none",border:"none",color:C.rose,fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit",padding:0}}>
            ← Retour à Formation
          </button>
        </div>
      )}

      {loading&&<div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>}

      <div style={{maxWidth:680,margin:"0 auto",padding:"1.1rem 1rem 4rem"}}>

        {/* ── HOME ── */}
        {tab==="home"&&(
          <div>
            {/* ── RÉCAP DU JOUR ── */}
            <HomeRecap uid={userId} name={name} objPerso={homeObjPerso} textes={homeTextes}/>

            <div style={{background:C.brun,borderRadius:16,padding:"1.4rem",marginBottom:"1rem",position:"relative",overflow:"hidden"}}>
              <div style={{position:"absolute",top:-15,right:-15,width:90,height:90,borderRadius:"50%",background:"rgba(196,154,138,.08)"}}/>
              <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".18em",color:C.or,marginBottom:".4rem"}}>✦ ESPACE PRIVÉ</div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.25rem",fontWeight:300,color:C.blanc,lineHeight:1.2,marginBottom:".4rem"}}>
                Ton hub de formation<br/><em style={{fontStyle:"italic",color:C.pale}}>Blazing Dynasty</em>
              </div>
              <p style={{fontSize:".73rem",color:C.pale,lineHeight:1.65,opacity:.85}}>
                Formations · Stratégies · Outils · Idées de posts · Suivi recrutement. Tout est ici.
              </p>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".5rem",marginBottom:"1rem"}}>
              {[["8","parties démarrage",C.rose],["11","replays Zoom",C.or],[String(allPosts.length),"idées de posts",C.lilas]].map(([n,l,col])=>(
                <div key={l} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".7rem .5rem",textAlign:"center"}}>
                  <div style={{fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:600,color:col,lineHeight:1}}>{n}</div>
                  <div style={{fontSize:".58rem",color:C.gris,marginTop:".15rem",lineHeight:1.3}}>{l}</div>
                </div>
              ))}
            </div>
            {[
              {id:"communication",sub:null,icon:"📈",col:C.rose,label:"✨ Nouveau · Analyse réseaux IA — ta community manager"},
              {id:"formation",sub:"mihibd",icon:"🔥",col:C.rose,label:"Mihi & Blazing Dynasty — Qui on est"},
              {id:"formation",sub:"demarrage",icon:"📚",col:C.rose,label:"Formation Démarrage Rapide — 8 parties"},
              {id:"formation",sub:"vente",icon:"🎯",col:C.or,label:"Vente · Stratégies · Booster ses ventes"},
              {id:"formation",sub:"recrutement",icon:"👥",col:C.rose,label:"Recrutement · Affiliation · Diagnostique"},
              {id:"formation",sub:"contenu",icon:"📱",col:C.lilas,label:"Contenu · Posts · Storytelling · Cible"},
              {id:"formation",sub:"devperso",icon:"🧠",col:C.lilas,label:"Développement Personnel"},
              {id:"formation",sub:"outils",icon:"🛠️",col:C.or,label:"Outils — Canva · CapCut · Linktree"},
              {id:"sprint",sub:null,icon:"⚡",col:C.rose,label:"Sprint Recrutement 7 jours"},
              {id:"suivi",sub:null,icon:"📋",col:C.lilas,label:"Checklist Nouvelle Recrue"},
            ].map(s=>(
              <div key={s.label} onClick={()=>{
                  if(s.id==="sprint"){setTab("dashboard");setDashboardSousOnglet("sprint");}
                  else{setTab(s.id); if(s.id==="communication")setCommunicationSousOnglet("analyse"); if(s.sub) setFormationSubTab(s.sub);}
                }}
                style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".7rem 1rem",marginBottom:".45rem",display:"flex",alignItems:"center",gap:".65rem",cursor:"pointer"}}>
                <div style={{width:30,height:30,borderRadius:"50%",background:s.col+"20",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".85rem",flexShrink:0}}>{s.icon}</div>
                <div style={{fontFamily:"Georgia,serif",fontSize:".88rem",fontWeight:600,color:C.brun,flex:1}}>{s.label}</div>
                <div style={{color:C.rose,fontSize:".68rem"}}>→</div>
              </div>
            ))}
          </div>
        )}

        {/* ── BLAZING DYNASTY ── */}

        {/* ── DÉMARRAGE RAPIDE ── */}
        {/* ── FORMATION : LISTE DE DOSSIERS ── */}
        {tab==="formation"&&!formationSubTab&&(
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
              Centre de <em style={{fontStyle:"italic",color:C.rose}}>Formation</em>
            </div>
            <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
              Choisis une catégorie pour accéder à ses formations, vidéos et ressources.
            </p>
            {FORMATION_TABS.map(f=>{
              const formationDebloquee = fastStartDone || isChefApp || hasTeamApp;
              // Onglets bloqués si Fast Start non terminé (sauf formationapp et demarrage)
              const bloque = false;
              const nouveau=!!formationNouveautes[f.id];
              const termine=formationTerminees[f.id];
              return(
                <div key={f.id} onClick={()=>!bloque&&setFormationSubTab(f.id)}
                  style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:bloque?C.creme:C.blanc,border:`1px solid ${bloque?"#ddd":(nouveau?C.rose:C.pale)}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".5rem",cursor:bloque?"default":"pointer",opacity:bloque?.6:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:".7rem"}}>
                    <div style={{width:38,height:38,borderRadius:"50%",background:bloque?"#ddd":f.col+"20",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.1rem",flexShrink:0,position:"relative"}}>
                      {bloque?"🔒":f.icon}
                      {nouveau&&!bloque&&(
                        <span style={{position:"absolute",top:-2,right:-2,width:11,height:11,borderRadius:"50%",background:"#E63946",border:"1.5px solid white"}}/>
                      )}
                    </div>
                    <div>
                      <div style={{fontFamily:"Georgia,serif",fontSize:".92rem",fontWeight:600,color:bloque?C.gris:C.brun,display:"flex",alignItems:"center",gap:".4rem"}}>
                        {f.label.replace(/^\S+\s/,"")}
                        {nouveau&&!bloque&&<span style={{background:"#E63946",color:"white",fontSize:".55rem",fontWeight:700,padding:".1rem .4rem",borderRadius:20,letterSpacing:".03em"}}>NOUVEAU</span>}
                      </div>
                      <div style={{fontSize:".66rem",color:bloque?"#bbb":C.gris}}>{bloque?"Se débloque après le Fast Start":f.desc}</div>
                    </div>
                  </div>
                  {termine?<span style={{color:C.vert,fontSize:".85rem"}}>✅</span>:<span style={{color:bloque?"#ccc":C.pale}}>{bloque?"🔒":"›"}</span>}
                </div>
              );
            })}
          </div>
        )}

        {tab==="formation"&&formationSubTab==="faststart"&&<FastStartTab uid={userId} userName={name} goToFormation={(sub)=>setFormationSubTab(sub)} forceQuizJour={forceQuizJourApp}/>}
        {tab==="formation"&&formationSubTab==="mihibd"&&(<>
          <div>
            <div style={{background:C.brun,borderRadius:16,padding:"2rem 1.4rem",marginBottom:"1rem",textAlign:"center",position:"relative",overflow:"hidden"}}>
              <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:200,height:200,borderRadius:"50%",background:"rgba(196,154,138,.05)"}}/>
              <div style={{position:"relative",fontSize:".58rem",fontWeight:700,letterSpacing:".25em",color:C.or,marginBottom:".5rem"}}>✦ NOTRE ÉQUIPE ✦</div>
              <div style={{position:"relative",fontFamily:"Georgia,serif",fontSize:"clamp(2rem,6vw,2.8rem)",fontWeight:300,color:C.blanc,lineHeight:1}}>Blazing</div>
              <div style={{position:"relative",fontFamily:"Georgia,serif",fontSize:"clamp(2rem,6vw,2.8rem)",fontStyle:"italic",color:C.pale,lineHeight:1.1}}>Dynasty</div>
              <div style={{width:48,height:1,background:C.or,margin:".9rem auto"}}/>
              <p style={{position:"relative",fontSize:".77rem",color:C.pale,opacity:.85,lineHeight:1.7,maxWidth:380,margin:"0 auto"}}>
                Une équipe de femmes et d'hommes ambitieux, bienveillants et déterminés. Pas juste un groupe — une famille qui avance ensemble vers la liberté financière.
              </p>
            </div>
            {[
              ["🌍","Une équipe internationale","Présente en France, au Portugal et au-delà. Nous grandissons ensemble, sans frontières."],
              ["💎","L'excellence comme standard","Pas pour être parfaite — pour être la meilleure version de soi. Chaque jour un peu plus."],
              ["🤝","L'entraide avant tout","Ici on ne laisse personne derrière. Si tu avances, tu tends la main à celles qui arrivent après toi."],
              ["🔥","L'ambition assumée","Nous ne nous excusons pas d'avoir des objectifs. Nous les partageons, nous nous y tenons, nous les atteignons."],
              ["👑","Des leaders, pas des vendeuses","Blazing Dynasty forme des entrepreneures et des leaders de réseau."],
            ].map(([icon,title,desc])=>(
              <div key={title} style={{display:"flex",gap:".65rem",marginBottom:".65rem",alignItems:"flex-start",background:C.blanc,borderRadius:12,padding:".75rem",border:`1px solid ${C.pale}`}}>
                <div style={{width:30,height:30,borderRadius:"50%",background:C.pale,display:"flex",alignItems:"center",justifyContent:"center",fontSize:".85rem",flexShrink:0}}>{icon}</div>
                <div><div style={{fontSize:".8rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".72rem",color:C.gris,lineHeight:1.55}}>{desc}</div></div>
              </div>
            ))}
            <div style={{background:C.brun,borderRadius:14,padding:"1.2rem",marginBottom:".75rem"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,color:C.or,marginBottom:".65rem"}}>✦ Nos valeurs</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".4rem"}}>
                {["Authenticité","Ambition","Bienveillance","Excellence","Liberté","Sororité"].map(v=>(
                  <div key={v} style={{background:"rgba(196,168,130,.12)",borderRadius:8,padding:".4rem .65rem",fontSize:".72rem",fontWeight:600,color:C.pale,textAlign:"center"}}>✦ {v}</div>
                ))}
              </div>
            </div>
            <div style={{background:`linear-gradient(135deg,rgba(196,154,138,.12),rgba(168,155,181,.08))`,border:`1px solid ${C.pale}`,borderRadius:14,padding:"1.1rem",textAlign:"center"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontStyle:"italic",color:C.brun,lineHeight:1.65}}>"Seule on va plus vite. Ensemble on va plus loin."</div>
              <div style={{fontSize:".63rem",color:C.gris,marginTop:".4rem"}}>— Blazing Dynasty</div>
            </div>
          </div>
          <div>
            <SecTitle title="Comprendre" em="Mihi" desc="L'essentiel sur la marque, les gammes et comment construire ton revenu."/>
            <Card title="🌱 Nos racines" sub="Formation à écouter à tout prix" icon="🎥" color={C.rose} defaultOpen>
              <Info color={C.rose}>Avant tout le reste, prends le temps d’écouter celle-ci. Elle explique d’où vient Mihi et pourquoi nous faisons ce que nous faisons.</Info>
              <YTBtn href="https://youtu.be/tAQ_VODoME4" label="▶ Nos racines — la formation à ne pas manquer"/>
            </Card>
            <Card title="Qui est Mihi ?" sub="Histoire · Valeurs · Forces" icon="🏢" color={C.or} defaultOpen>
              <Info color={C.or}>Mihi est une marque polonaise de bien-être, beauté et soins, portée par le laboratoire pharmaceutique <strong>ElfaPharm</strong>. Des produits avec de vraies études scientifiques derrière.</Info>
              {[
                ["🧬","Fondée par ElfaPharm","Un laboratoire pharmaceutique sérieux. Ce n'est pas du marketing — il y a une vraie R&D derrière les produits."],
                ["🌍","Présente dans 30+ pays","Une marque qui grandit vite, avec des produits testés et approuvés sur plusieurs marchés européens."],
                ["💎","Rapport qualité/prix","Des produits comparables aux grandes marques de pharmacie, à des prix distributeur compétitifs."],
                ["🔄","Modèle de vente directe","Tu distribues en direct, tes clientes commandent sur ta boutique personnelle. Pas de stock obligatoire."],
              ].map(([icon,title,desc])=>(
                <div key={title} style={{display:"flex",gap:".6rem",marginBottom:".55rem",alignItems:"flex-start"}}>
                  <div style={{width:28,height:28,borderRadius:"50%",background:C.pale,display:"flex",alignItems:"center",justifyContent:"center",fontSize:".8rem",flexShrink:0}}>{icon}</div>
                  <div><div style={{fontSize:".78rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".71rem",color:C.gris,lineHeight:1.5}}>{desc}</div></div>
                </div>
              ))}
            </Card>

            <Card title="Les gammes Mihi" sub="Ce que tu peux vendre" icon="💄" color={C.lilas}>
              {[
                ["✨","Skincare — Soin visage","Crèmes anti-âge, sérums, contour des yeux, gommages visage, mousses nettoyantes. Des soins avec de vraies actifs à des prix accessibles."],
                ["💇","Soins cheveux","Shampoings réparateurs, baumes, soins capillaires. Résultats visibles rapidement. Argument fort : résultats comparables aux marques pro, prix bien inférieurs."],
                ["💄","Make-up","Mascara volume, fond de teint matifiant, rouge à lèvres longue tenue. Qualité professionnelle. Facile à démontrer, facile à vendre."],
                ["💊","Compléments alimentaires & Perte de poids","Détox, brûle-graisses, booster de métabolisme, ginkgo biloba, vitamines. Gamme très demandée. Les résultats créent de la fidélité."],
                ["🌸","Parfums","Des jus de qualité, comparables aux grandes marques, à moins de 20€. C'est l'argument qui surprend tout le monde et crée des ventes immédiates."],
                ["🧴","Soin corps","Gommages effet or, baumes satinés, enveloppements. Un rituel luxueux à prix accessible. Parfait pour les box surprises et cadeaux."],
                ["🏠","HOME — Soins maison","Produits d'entretien naturels, désodorisants, soins textiles. Une gamme innovante pour celles qui veulent vendre à toute la famille, pas seulement sur la beauté."],
              ].map(([icon,title,desc])=>(
                <div key={title} style={{display:"flex",gap:".6rem",marginBottom:".5rem",padding:".6rem .7rem",background:C.creme,borderRadius:9,border:`1px solid ${C.pale}`}}>
                  <span style={{fontSize:"1.1rem",flexShrink:0}}>{icon}</span>
                  <div><div style={{fontSize:".78rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".7rem",color:C.gris,lineHeight:1.55}}>{desc}</div></div>
                </div>
              ))}
            </Card>

            <Card title="Comment gagner de l'argent avec Mihi" sub="Le plan de rémunération détaillé" icon="💰" color={C.or}>
              <Info color={C.or}>Il y a <strong>3 façons</strong> de gagner de l'argent avec Mihi, cumulables. Plus tu avances dans les deux, plus ton revenu est stable et croissant.</Info>

              <div style={{background:C.brun,borderRadius:10,padding:".85rem 1rem",marginBottom:".75rem"}}>
                <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginBottom:".6rem"}}>💰 Levier 1 — Vente directe</div>
                {[
                  ["Prix distributeur","Tu achètes les produits avec une remise de 20 à 30% sur le prix catalogue selon ton statut."],
                  ["Ta marge","Tu revends au prix catalogue. Ta marge = 20 à 30% du prix de vente. Ex : un produit à 40€ catalogue → tu l'achètes ~28-32€ → tu gagnes 8-12€ par vente."],
                  ["Pas de minimum","Pas de stock obligatoire, pas de commande minimum. Tu commandes ce que tes clientes ont commandé."],
                  ["Immédiat","Le bénéfice est direct, dès ta première vente. Pas de palier à atteindre."],
                ].map(([t,d])=>(
                  <div key={t} style={{display:"flex",gap:".5rem",marginBottom:".45rem"}}>
                    <span style={{color:C.or,flexShrink:0,fontSize:".75rem"}}>✦</span>
                    <div style={{fontSize:".73rem",color:C.pale,lineHeight:1.5}}><strong style={{color:C.or}}>{t} :</strong> {d}</div>
                  </div>
                ))}
              </div>

              <div style={{background:C.brun2,borderRadius:10,padding:".85rem 1rem",marginBottom:".75rem"}}>
                <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginBottom:".6rem"}}>👥 Levier 2 — Commissions équipe</div>
                {[
                  ["Comment ça marche","Tu recrutes des distributrices dans ton équipe. À chaque commande qu'elles passent, tu touches un pourcentage sur leur volume."],
                  ["Revenu passif","Même quand tu ne travailles pas, ton équipe génère du volume. C'est la base de la liberté financière."],
                  ["Duplication","Plus ton équipe recrute à son tour, plus ta structure grandit et plus tes commissions augmentent — sans que tu aies à faire plus de travail direct."],
                  ["Profondeur","Tu touches des commissions sur plusieurs niveaux de ton équipe selon ton statut de qualification."],
                ].map(([t,d])=>(
                  <div key={t} style={{display:"flex",gap:".5rem",marginBottom:".45rem"}}>
                    <span style={{color:C.or,flexShrink:0,fontSize:".75rem"}}>✦</span>
                    <div style={{fontSize:".73rem",color:C.pale,lineHeight:1.5}}><strong style={{color:C.or}}>{t} :</strong> {d}</div>
                  </div>
                ))}
              </div>

              <div style={{background:"rgba(196,168,130,.12)",border:`1px solid ${C.or}40`,borderRadius:10,padding:".85rem 1rem",marginBottom:".75rem"}}>
                <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginBottom:".6rem"}}>🏆 Levier 3 — Bonus et qualifications</div>
                {[
                  ["Bonus de démarrage","Quand tu démarres fort les 90 premiers jours, Mihi te verse des bonus supplémentaires sur ton volume personnel et équipe."],
                  ["Bonus mensuel","À chaque mois où tu atteins les objectifs de ton palier, tu touches un bonus en plus de tes commissions."],
                  ["Paliers de qualification","Distributrice → Senior → Directrice → Senior Directrice → Directrice Business. Chaque palier = plus de pourcentages et plus de bonus."],
                  ["Voyages & récompenses","Les meilleurs rangs ont accès à des voyages et événements offerts par Mihi."],
                ].map(([t,d])=>(
                  <div key={t} style={{display:"flex",gap:".5rem",marginBottom:".45rem"}}>
                    <span style={{color:C.or,flexShrink:0,fontSize:".75rem"}}>✦</span>
                    <div style={{fontSize:".73rem",color:C.texte,lineHeight:1.5}}><strong style={{color:C.brun}}>{t} :</strong> {d}</div>
                  </div>
                ))}
              </div>

              <div style={{background:C.brun,borderRadius:9,padding:".7rem .9rem",fontSize:".74rem",color:C.pale,lineHeight:1.65}}>
                💡 <strong style={{color:C.or}}>Exemple concret :</strong> Tu vends 500€ de produits ce mois → tu gardes ~125-150€ de marge. Ton équipe génère 2 000€ de volume → tu touches ~100-200€ de commissions en plus. Total : 225-350€ pour ce mois. Plus ton équipe grandit, plus le ratio s'inverse en ta faveur.
              </div>
            </Card>

            <Card title="Les programmes clients Mihi" sub="Tes arguments de vente — détails complets" icon="🎁" color={C.rose}>
              <Info>Ces programmes sont tes <strong>arguments de vente et de fidélisation</strong>. Connais-les par cœur — une cliente bien informée revient toujours.</Info>

              {[
                {icon:"🎁",title:"Welcome Bonus",tag:"1ʳᵉ commande",color:C.rose,details:[
                  "5 € offerts automatiquement sur le compte promo de chaque nouvelle cliente, dès l'inscription.",
                  "Un set de produits best-sellers disponible pour les débutants à prix réduit.",
                  "Des échantillons offerts pour toute commande passée dans les 24h après l'inscription.",
                  "👉 Comment l'utiliser : \"En t'inscrivant via mon lien aujourd'hui, tu reçois 5 € sur ta première commande. C'est automatique, pas de code promo.\"",
                ]},
                {icon:"♾️",title:"Infinity Bonus",tag:"Fidélité",color:C.lilas,details:[
                  "À partir de la 2ᵉ commande : dès 40 € de commande au prix catalogue, ta cliente choisit 1 produit du catalogue avec -70%.",
                  "Ce bonus est ILLIMITÉ — il se renouvelle à chaque période, tant qu'elle commande.",
                  "Si elle saute une période : elle doit recommander 2 périodes consécutives pour retrouver le droit.",
                  "Tous les produits sont éligibles sauf les sets et les produits \"Extra\".",
                  "👉 Comment l'utiliser : \"À chaque commande de 40 €, tu as le droit de choisir un produit à -70 %. Ça fait souvent une valeur de 20-30 € offerts.\"",
                ]},
                {icon:"🎟️",title:"Token Store",tag:"Ton outil de réachat",color:C.or,details:[
                  "Tu achètes des tokens avec ton compte promo ou ton Recruitment Bonus, et tu les envoies à tes clientes.",
                  "3 types de tokens : 5 € en cadeau (coûte 2 € pour toi) · Produit offert (2,50 €) · Remise -70% (0,50 €).",
                  "Le token est valable 24h après envoi. Si la cliente ne l'utilise pas → tu es remboursée automatiquement.",
                  "Fonctionne sur commande minimum de 40 €.",
                  "👉 Quand l'utiliser : pour relancer une cliente silencieuse, anniversaire, après une vente réussie, ou pour déclencher une 1ʳᵉ commande.",
                ]},
                {icon:"💰",title:"Recruitment Bonus",tag:"Pour toi en tant que distributrice",color:C.brun,details:[
                  "À chaque période où tu enregistres au moins 1 nouveau client avec une commande : 5 € crédités dans ton Token Store.",
                  "Ces 5 € servent directement à acheter des tokens pour tes clientes.",
                  "Non cumulatif sur plusieurs nouveaux clients — c'est 5 € fixe par période active.",
                  "👉 Utilité directe : recrute des clientes régulièrement pour alimenter ton Token Store sans bourse délier.",
                ]},
                {icon:"🛍️",title:"Smart Shopping Program",tag:"Automatique",color:C.lilas,details:[
                  "L'IA Mihi analyse les achats de chaque cliente et lui envoie automatiquement un SMS personnalisé.",
                  "L'offre : -50 % sur un produit de sa commande précédente, valable 24h.",
                  "En plus : une recommandation pop-up au moment du panier avec +5 % de remise sur un produit complémentaire.",
                  "Tu n'as rien à faire — mais informe tes clientes que ce programme existe pour qu'elles commandent à chaque période.",
                  "👉 Argument vente : \"Mihi t'envoie automatiquement des offres -50% sur tes produits préférés. Raison de plus de commander régulièrement.\"",
                ]},
                {icon:"👑",title:"Premium Club",tag:"Statut VIP",color:C.or,details:[
                  "Statut accessible aux clientes qui commandent régulièrement des volumes importants.",
                  "Avantages exclusifs : accès à des produits et sets réservés aux membres Premium, remises spéciales, privilèges.",
                  "👉 Comment le vendre : propose-le comme une récompense à tes meilleures clientes. \"Tu commandes souvent — tu mérites le statut Premium Club avec des avantages exclusifs.\"",
                ]},
              ].map(prog=>(
                <div key={prog.title} style={{background:C.creme,borderRadius:10,padding:".8rem",marginBottom:".65rem",border:`1px solid ${C.pale}`}}>
                  <div style={{display:"flex",gap:".5rem",alignItems:"center",marginBottom:".55rem"}}>
                    <span style={{fontSize:"1.1rem"}}>{prog.icon}</span>
                    <div style={{fontSize:".82rem",fontWeight:600,color:C.brun,flex:1}}>{prog.title}</div>
                    <span style={{background:prog.color+"22",color:prog.color===C.or?C.brun2:prog.color,fontSize:".55rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",padding:".13rem .4rem",borderRadius:20}}>{prog.tag}</span>
                  </div>
                  {prog.details.map((d,i)=>(
                    <div key={i} style={{fontSize:".72rem",color:d.startsWith("👉")?C.brun:C.gris,lineHeight:1.6,marginBottom:".28rem",fontWeight:d.startsWith("👉")?600:400,fontStyle:d.startsWith("👉")?"italic":"normal"}}>{d}</div>
                  ))}
                </div>
              ))}
            </Card>
            <BoutonTermineFormation subTab="mihibd"/>
          </div>
        </>)}


        {tab==="formation"&&formationSubTab==="demarrage"&&(
          <div>
            <SecTitle title="Formation" em="Démarrage Rapide" desc="7 modules — le même parcours que le Fast Start, avec les scripts complets pour chaque étape."/>
            <AdminContentBlock onglet="demarrage" items={adminItems}/>

            {FAST_START_DAYS.map(d=>{
              const checkId=`demarrage-module-${d.jour}`;
              const done=checks[checkId];
              const quiz=FAST_START_QUIZ.find(q=>q.jour===d.jour);
              return(
                <Card key={d.jour} title={d.titre} sub={quiz?.exercice||""} icon={done?"✅":`${d.jour}`} color={done?C.vert:C.rose}>
                  <div onClick={()=>tog("checks",checkId)}
                    style={{display:"flex",alignItems:"center",gap:".6rem",background:done?C.vert+"15":C.creme,borderRadius:9,padding:".55rem .8rem",marginBottom:".75rem",cursor:"pointer",border:`1px solid ${done?C.vert:C.pale}`}}>
                    <div style={{width:20,height:20,borderRadius:5,border:`2px solid ${done?C.vert:C.gris}`,background:done?C.vert:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {done&&<span style={{fontSize:".65rem",color:"white",fontWeight:700}}>✓</span>}
                    </div>
                    <span style={{fontSize:".75rem",fontWeight:600,color:done?C.vert:C.gris}}>{done?"✅ Module terminé !":"Cocher quand le module est terminé"}</span>
                  </div>

                  {/* Vidéo du module */}
                  {(()=>{
                    const vKey=`module${d.jour}`;
                    const vData=adminVideosFastStart[vKey];
                    return(
                      <div style={{marginBottom:".75rem"}}>
                        {vData?.url
                          ? <a href={vData.url} target="_blank" rel="noopener noreferrer"
                              style={{display:"flex",alignItems:"center",gap:".6rem",background:C.brun,borderRadius:10,padding:".6rem .9rem",textDecoration:"none"}}>
                              <span style={{fontSize:"1rem"}}>▶</span>
                              <div>
                                <div style={{fontSize:".78rem",fontWeight:700,color:C.blanc}}>Regarder la vidéo</div>
                                <div style={{fontSize:".62rem",color:C.pale}}>Module {d.jour} — {vData.type==="youtube"?"YouTube":vData.type==="drive"?"Drive":"Vidéo"}</div>
                              </div>
                            </a>
                          : <div style={{display:"flex",alignItems:"center",gap:".5rem",background:C.creme,borderRadius:9,padding:".55rem .8rem",fontSize:".72rem",color:C.gris,fontStyle:"italic",border:`1px solid ${C.pale}`}}>
                              🎬 Vidéo à venir — disponible prochainement
                            </div>
                        }
                      </div>
                    );
                  })()}

                  {/* Tâches du module */}
                  <div style={{marginBottom:".75rem"}}>
                    <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".4rem"}}>📋 Tâches</div>
                    {d.taches.map((t,i)=>{
                      const label=typeof t==="object"?t.t:t;
                      return(
                        <div key={i} style={{display:"flex",gap:".55rem",padding:".42rem 0",borderBottom:`1px solid rgba(232,213,204,.3)`}}>
                          <div style={{width:19,height:19,borderRadius:"50%",background:C.rose+"22",color:C.rose,fontSize:".58rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</div>
                          <div style={{fontSize:".75rem",color:C.texte,lineHeight:1.45,flex:1}}>{label}</div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Exercice */}
                  {quiz?.exercice&&(
                    <div style={{marginBottom:".75rem"}}>
                      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.lilas,marginBottom:".4rem"}}>✦ Exercice de validation</div>
                      <div style={{background:C.lilas+"15",border:`1px solid ${C.lilas}30`,borderRadius:9,padding:".6rem .85rem",fontSize:".76rem",color:C.texte,lineHeight:1.55}}>
                        {quiz.exercice}
                      </div>
                    </div>
                  )}

                  {/* Quiz */}
                  {quiz?.quiz&&(
                    <div>
                      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginBottom:".4rem"}}>📊 Quiz de validation ({quiz.quiz.length} questions)</div>
                      {quiz.quiz.map((q,i)=>(
                        <div key={i} style={{padding:".4rem 0",borderBottom:`1px solid ${C.pale}`}}>
                          <div style={{fontSize:".74rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>{i+1}. {q.q}</div>
                          {q.options.map((opt,j)=>(
                            <div key={j} style={{fontSize:".7rem",color:j===q.rep?C.vert:C.gris,padding:".15rem 0",paddingLeft:".5rem",fontWeight:j===q.rep?700:400}}>
                              {j===q.rep?"✓ ":"○ "}{opt}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </Card>
              );
            })}
            <BoutonTermineFormation subTab="demarrage"/>
          </div>
        )}


        {/* ── VENTE ── */}
        {tab==="formation"&&formationSubTab==="vente"&&(
          <div>
            <SecTitle title="Vente &" em="Stratégies" desc="Tout pour vendre plus, fidéliser tes clientes et booster ton activité."/>
            <AdminContentBlock onglet="vente" items={adminItems}/>

            <Card title={(afficherNewReunion?"🆕 ":"")+"Organiser une réunion virtuelle"} sub={(afficherNewReunion?"Nouvelle formation · ":"")+"Vidéo + visuels + script de bienvenue"} icon="💻" color={C.rose} defaultOpen>
              {afficherNewReunion&&<span style={{display:"inline-block",background:"#E53935",color:"white",fontSize:".58rem",fontWeight:800,borderRadius:8,padding:".12rem .45rem",letterSpacing:".05em",marginBottom:".7rem"}}>🆕 NOUVEAU</span>}
              <div style={{position:"relative",paddingBottom:"56.25%",height:0,overflow:"hidden",borderRadius:12,marginBottom:".9rem",background:"#000"}}>
                <iframe src="https://www.youtube.com/embed/CiEIPZh4Ns8" title="Organiser une réunion virtuelle"
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
              </div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:C.brun,lineHeight:1.35,marginBottom:".6rem"}}>Votre parenthèse découverte MIHI : comment ça se passe ?</div>
              <div style={{fontSize:".8rem",color:C.texte,lineHeight:1.7}}>
                {[
                  ["01 · Jour 1 — Bienvenue & présentation :","une courte vidéo pour faire connaissance et découvrir MIHI. Puis, si les thèmes ne sont pas déjà définis : place au sondage !"],
                  ["02 · Votre choix — 3 thèmes maximum :","elles votent, tu prépares les découvertes les plus demandées."],
                  ["03 · Jours 2 & 3 — Place aux découvertes :","des vidéos sur les thèmes choisis, des démonstrations et des conseils."],
                  ["04 · Pour terminer — Vos questions, tes réponses :","un live ou un post dédié pour échanger et les aider à choisir."],
                ].map(([lead,texte])=>(
                  <div key={lead} style={{background:C.creme,borderRadius:9,padding:".65rem .8rem",marginBottom:".5rem"}}>
                    <strong style={{color:C.brun}}>{lead}</strong> {texte}
                  </div>
                ))}
                <p style={{margin:".4rem 0 .9rem",color:C.gris,fontSize:".74rem"}}>Elles regardent à leur rythme et posent leurs questions dans le groupe.</p>
              </div>

              <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,margin:".4rem 0 .5rem"}}>🖼 Les 3 visuels à utiliser</div>
              {[
                ["reunion-virtuelle-invitation.jpg","1 · L'invitation","Vous êtes invitée — à publier pour lancer la parenthèse"],
                ["reunion-virtuelle-themes.jpg","2 · Le choix des thèmes","À vous de choisir — à poster avec le sondage du groupe"],
                ["reunion-virtuelle-deroule.jpg","3 · Le déroulé","Comment ça se passe — pour expliquer les 4 étapes"],
              ].map(([fichier,titre,legende])=>(
                <div key={fichier} style={{marginBottom:".9rem"}}>
                  <div style={{fontSize:".74rem",fontWeight:700,color:C.brun,marginBottom:".1rem"}}>{titre}</div>
                  <div style={{fontSize:".66rem",color:C.gris,marginBottom:".35rem"}}>{legende}</div>
                  <img src={(process.env.PUBLIC_URL||"")+"/"+fichier} alt={titre} loading="lazy"
                    onClick={()=>window.open((process.env.PUBLIC_URL||"")+"/"+fichier,"_blank")}
                    style={{display:"block",width:"100%",height:"auto",borderRadius:12,border:`1px solid ${C.pale}`,cursor:"zoom-in"}}/>
                  <button onClick={()=>telechargerImage((process.env.PUBLIC_URL||"")+"/"+fichier,fichier)}
                    style={{width:"100%",marginTop:".4rem",background:C.brun,color:"white",border:"none",borderRadius:9,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                    ⬇ Télécharger cette image
                  </button>
                </div>
              ))}
              <div style={{fontSize:".66rem",color:C.gris,textAlign:"center",marginBottom:".9rem"}}>Touche « Télécharger » : sur téléphone, choisis « Enregistrer l'image » dans le menu qui s'ouvre.</div>

              <Card title="📝 Script de la vidéo de bienvenue" sub="À personnaliser : [prénom] et [cadeau]" icon="📝" color={C.or} defaultOpen>
                <div style={{fontSize:".78rem",color:C.texte,lineHeight:1.75,whiteSpace:"pre-wrap",marginBottom:".7rem",userSelect:"text",WebkitUserSelect:"text"}}>
                  {SCRIPT_REUNION_VIRTUELLE.split(/(\[[^\]]+\])/).map((morceau,i)=>(
                    /^\[[^\]]+\]$/.test(morceau)
                      ?<span key={i} style={{background:C.or+"30",borderRadius:5,padding:"0 .2rem",fontWeight:700,color:C.brun}}>{morceau}</span>
                      :<span key={i}>{morceau}</span>
                  ))}
                </div>
                <BoutonCopierTexte texte={SCRIPT_REUNION_VIRTUELLE}/>
                <Info color={C.or}>Remplace [prénom] par le tien et précise le cadeau prévu avec ses conditions avant de filmer.</Info>
              </Card>

              <a href="https://youtu.be/CiEIPZh4Ns8" target="_blank" rel="noopener noreferrer" style={{display:"inline-block",marginTop:".9rem",fontSize:".74rem",fontWeight:700,color:C.rose}}>▶ Voir sur YouTube</a>
            </Card>

            <Card title="Replays Zoom Vente" sub="Les sessions de formation vente" icon="🎥" color={C.or} defaultOpen>
              <DriveBtn href="https://drive.google.com/file/d/1LMpnNRpWLAmgO3yTOR5b1-xCRUbTt3vy/view" label="Tips de vente + comprendre son pourquoi"/>
              <DriveBtn href="https://drive.google.com/file/d/1PFLOi8JNwREegXPnNAzGntKm4Z_a7dkn/view" label="Comment faire ses Lives + déclencher des ventes"/>
              <Btn href="https://us06web.zoom.us/rec/share/RwAb_48QbKt_jrn_91SJbfXZ8Sf8shCOpxzixhX0HdElfb4xDOU9nBEq-OdNms2b.RRxzRJZ53fmbvprr" label="Les réunions à domicile" icon="▶" color={C.brun}/>
              <DriveBtn href="https://drive.google.com/file/d/1wSOKykwqsrzkXPkP-alTXLZ2AIc3HyAM/view" label="Comment parler des produits (exercice équipe)"/>
            </Card>

            <Card title="Vendre grâce au BUNDLE" sub="Associer les produits selon les besoins" icon="🎁" color={C.rose} defaultOpen>
              <div style={{position:"relative",paddingBottom:"56.25%",height:0,overflow:"hidden",borderRadius:12,marginBottom:".7rem"}}>
                <iframe src="https://www.youtube.com/embed/XGjwbLJRua4" title="Vendre grâce au BUNDLE"
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none",borderRadius:12}}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
              </div>
              <div style={{fontSize:".78rem",color:C.texte,lineHeight:1.7,marginTop:".7rem",whiteSpace:"pre-wrap"}}>
{`LES BUNDLES : UN OUTIL POUR DÉVELOPPER NOTRE ACTIVITÉ 💕

Comme expliqué dans la vidéo, les bundles sont des associations de produits pensées autour de besoins précis : peau, silhouette, ménopause, sommeil, charge mentale, etc.

🎯 Leur objectif ? Nous aider à attirer de nouvelles clientes, susciter leur intérêt et faciliter nos échanges en privé.

✨ Les bundles sont des bases de travail, pas des formules toutes faites ! Ils nous donnent des idées d'associations et nous permettent de gagner du temps, notamment lorsqu'on débute ou qu'on manque d'inspiration pour construire une routine.

🤍 L'essentiel reste de personnaliser chaque proposition en fonction des besoins, des attentes et du budget de la cliente. Il ne s'agit pas de vendre le plus gros bundle, mais de proposer ce qui lui correspond réellement, sans pression.

📲 Attention : les affiches présentant les différents packs avec tous leurs prix ne sont pas destinées à être diffusées sur nos réseaux sociaux. Sur nos publications et nos stories, on met plutôt en avant les besoins et les problématiques, puis on invite les personnes intéressées à nous contacter en privé. C'est dans cet échange que nous pouvons présenter les bundles adaptés, détailler leur composition et communiquer les tarifs en toute transparence.

🌸 Notre objectif : créer du lien, conseiller avec authenticité et fidéliser grâce à la confiance.

Les bundles sont là pour nous donner un cadre, nous aider à prendre confiance et nous permettre de développer notre activité plus simplement, chacune à notre rythme. 💪💕

À nous de nous les approprier et de les adapter à notre façon de travailler ! ❤️`}
              </div>
              <div style={{marginTop:".9rem",paddingTop:".8rem",borderTop:`1px solid ${C.pale}`}}>
                <Btn href="https://t.me/+pW8IR0W5lh03OTRk" label="💬 Rejoindre le groupe Telegram Bundles" icon="▶" color={"#2AABEE"}/>
              </div>
            </Card>

            <Card title="Stratégies de vente" sub="Les méthodes qui marchent" icon="💡" color={C.or}>
              <Card title="🎁 Stratégie Enveloppe Mystère" sub="Offrir plutôt que vendre" icon="🎁" color={C.rose}>
                <p style={{fontSize:".76rem",color:C.texte,lineHeight:1.65,marginBottom:".7rem"}}>
                  On se met souvent une pression de dingue pour essayer de "vendre" à tout prix, et au final, ça bloque et on ne fait plus rien. Cette méthode est beaucoup plus zen — on ne va rien "vendre", on va juste offrir.
                </p>
                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem"}}>📎 L'opération "Enveloppes Mystères"</div>
                <p style={{fontSize:".75rem",color:C.texte,lineHeight:1.6,marginBottom:".7rem",fontStyle:"italic"}}>
                  L'idée : passer pour celle qui conseille et qui offre, pas celle qui chasse le client.
                </p>
                {[
                  ["1","Prenez une photo de vous avec 3 ou 5 petites enveloppes (ou petits paquets). On veut voir de l'humain, votre sourire, et que vous préparez des trucs."],
                  ["2","Postez ça en story ou sur votre mur avec un petit texte type présentation ci-dessous."],
                ].map(([n,texte])=>(
                  <div key={n} style={{display:"flex",gap:".6rem",marginBottom:".55rem",alignItems:"flex-start"}}>
                    <div style={{width:22,height:22,borderRadius:"50%",background:C.rose+"25",color:C.brun,fontSize:".62rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{n}</div>
                    <div style={{fontSize:".76rem",color:C.texte,lineHeight:1.6}}>{texte}</div>
                  </div>
                ))}
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.6,fontStyle:"italic",borderLeft:`2px solid ${C.rose}`,marginBottom:".6rem"}}>
                  "J'ai décidé de gâter 5 personnes aujourd'hui ! 🥳 J'ai préparé 5 enveloppes découvertes avec ma pépite du moment pour [le sommeil / la peau / l'énergie... choisissez votre domaine]. Qui veut recevoir la sienne ? C'est premier arrivé, premier servi ! Dites-moi MOI en commentaire. 👇"
                </div>
                <p style={{fontSize:".75rem",color:C.texte,lineHeight:1.6,marginBottom:".6rem"}}>
                  Le but : ce sont les gens qui viennent vers vous, vous n'avez plus qu'à cueillir. Et quand quelqu'un répond "Moi" en MP, restez hyper simples :
                </p>
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.6,fontStyle:"italic",borderLeft:`2px solid ${C.rose}`,marginBottom:".6rem"}}>
                  "C'est pour toi ! Je te prépare ça. Dis-moi juste, c'est quoi ton souci n°1 avec [le sommeil / ta peau / ta fatigue] en ce moment ? C'est pour être sûre que ça te corresponde bien avant que je te l'envoie."
                </div>
                <p style={{fontSize:".75rem",color:C.texte,lineHeight:1.6}}>
                  C'est tout. On crée de la discussion, on conseille, et la vente se fait toute seule après.
                </p>
              </Card>
              <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginBottom:".5rem",marginTop:".75rem"}}>📁 Documents stratégies</div>
              <DriveBtn href="https://drive.google.com/file/d/1XkJRZMArmWqTy11xCTaJagR4s-vEOdtL/view" label="Stratégie Catalogue — Vidéo"/>
              <Card title="📖 Stratégie Catalogue" sub="Demander un avis plutôt que vendre" icon="📖" color={C.or}>
                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".5rem"}}>✅ Script en 2 temps</div>
                <div style={{fontSize:".65rem",fontWeight:700,color:C.brun,marginBottom:".3rem"}}>1. Prendre contact</div>
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.7,fontStyle:"italic",borderLeft:`2px solid ${C.or}`,marginBottom:".5rem"}}>
                  "Coucou Christelle comment tu vas ? Dis-moi, j'aurais besoin de toi deux minutes, tu me dis quand t'es dispo"<br/><br/>
                  "Coucou poulette comment vas-tu ? Quand t'as cinq minutes j'ai besoin de toi 😂"
                </div>
                <p style={{fontSize:".72rem",color:C.gris,marginBottom:".6rem"}}>👉🏽 Quand elle répond oui, vas-y :</p>
                <div style={{fontSize:".65rem",fontWeight:700,color:C.brun,marginBottom:".3rem"}}>2. La demande</div>
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.7,fontStyle:"italic",borderLeft:`2px solid ${C.or}`,marginBottom:".5rem"}}>
                  "Super ! En fait la société pour laquelle je travaille m'a chargé d'une mission, donc j'essaye de trouver des personnes qui ne connaissent pas du tout mon activité. Je vais te mettre le lien du catalogue, t'es pas obligée de tout regarder, mais dis-moi juste ce qui te saute aux yeux en première vue."
                </div>
                <p style={{fontSize:".72rem",color:C.gris,marginBottom:".4rem"}}>Pour celles qui connaissent le MLM :</p>
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.7,fontStyle:"italic",borderLeft:`2px solid ${C.or}`,marginBottom:".8rem"}}>
                  "J'ai besoin d'un œil extérieur par rapport à la société avec laquelle je travaille, pour comprendre pourquoi certaines personnes ne commandent jamais alors que les prix sont vraiment pas chers et de qualité pharmaceutique. J'aimerais te partager le catalogue pour que tu me dises ce qui pourrait faire peur aux gens."
                </div>

                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".5rem"}}>✅ Script en 1 temps</div>
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.7,fontStyle:"italic",borderLeft:`2px solid ${C.or}`}}>
                  "Salut Audrey, j'espère que tu vas bien. Dis-moi, j'ai un petit service à te demander. Je suis mandatée par ma société pour faire une petite expertise de notre catalogue, pour voir les points à changer, les choses qui peuvent choquer, déranger... J'essaye de demander aux personnes qui ne connaissent pas du tout, pour avoir un avis vraiment objectif. Est-ce que tu pourrais jeter un coup d'œil en diagonale et me dire ce que tu en penses ?"
                </div>
              </Card>
              <DriveBtn href="https://drive.google.com/file/d/1S7IMHB9xUqY43JQRuqa8mtlqY7kabv8t/view" label="Stratégie Défi Live — Vidéo"/>
              <Card title="🎯 Stratégie Défi Live" sub="Des dizaines d'idées de défis prêts à l'emploi" icon="🎯" color={C.rose}>
                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem"}}>📐 Structure simple pour le live</div>
                {["Annoncer le défi","Montrer la tâche","Demander aux gens \"ça part ou pas ?\"","Faire le test","Montrer le résultat","Proposer le lien"].map((etape,i)=>(
                  <div key={i} style={{display:"flex",gap:".6rem",marginBottom:".4rem",alignItems:"flex-start"}}>
                    <div style={{width:20,height:20,borderRadius:"50%",background:C.rose+"25",color:C.brun,fontSize:".6rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{i+1}</div>
                    <div style={{fontSize:".75rem",color:C.texte,lineHeight:1.5}}>{etape}</div>
                  </div>
                ))}

                {[
                  {titre:"🧼 Défis Ménage (les plus puissants pour vendre)",note:"Les produits ménage Mihi sont souvent concentrés, multi-surfaces et écologiques — parfaits pour des démonstrations rapides et visuelles.",groupes:[
                    {sous:"⏱️ Défis \"chrono\" — très efficaces en live",items:["Défi 1 minute cuisine","Défi 30 secondes pour enlever une tache","Défi évier brillant en 2 minutes","Défi plaque de cuisson propre avant la fin du live","Défi miroir sans trace en 30 secondes","Défi plan de travail zéro graisse","Défi nettoyage frigo express","Défi micro-ondes propre en 1 minute","Défi salle de bain complète en 3 minutes","Défi carrelage brillant avant la fin du chrono"]},
                    {sous:"🔥 Défis \"avant / après\" — les gens adorent",items:["Avant / après vitre","Avant / après évier","Avant / après douche","Avant / après plaque de cuisson","Avant / après semelles de baskets","Avant / après robinetterie","Avant / après table collante","Avant / après planche à découper","Avant / après taches sur mur","Avant / après taches sur canapé"]},
                    {sous:"💥 Défis \"produit miracle\" — très viral",items:["1 produit = 5 surfaces","1 produit = toute la cuisine","1 produit = toute la salle de bain","1 produit = maison complète","1 produit = sol + meuble + vitre (ex: multi-surface)"]},
                    {sous:"🧪 Défis \"crash test\" — ultra engageant (demandez \"à votre avis ça part ou pas ?\")",items:["Test tache ketchup","Test tache huile","Test café","Test sauce tomate","Test chocolat fondu","Test feutre enfant","Test graisse cuisson"]},
                    {sous:"🌸 Défis \"ménage de printemps\" — très saisonnier",items:["Défi cuisine de printemps","Défi frigo propre","Défi placards","Défi vitres maison","Défi balcon propre","Défi terrasse","Défi tapis","Défi matelas"]},
                  ]},
                  {titre:"💄 Défis Beauté / Make-up",note:"Parfait pour varier le contenu.",groupes:[
                    {sous:"Défis maquillage",items:["Make-up complet en 5 minutes","Make-up avec 3 produits","Un seul produit pour tout","Make-up sans miroir","Make-up en live avec vos choix","Make-up \"maman pressée\""]},
                    {sous:"Défis skincare",items:["Routine visage en 3 minutes","Routine peau parfaite avant dodo","Défi peau glow en direct","Défi routine express matin","Avant / après soin"]},
                  ]},
                  {titre:"🎉 Défis Fun (très puissants pour l'algorithme)",note:"",groupes:[
                    {sous:"Défis vote — \"c'est vous qui décidez\"",items:["Vous choisissez la tache","Vous choisissez le produit","Vous choisissez la surface","Vous choisissez le défi"]},
                    {sous:"Défis abonnés",items:["Je teste VOS pires taches","Je nettoie ce que vous voulez","Envoyez-moi vos photos catastrophe"]},
                    {sous:"Défis \"impossible\"",items:["La pire tache de ma cuisine","Le pire coin de ma salle de bain","Le tiroir le plus sale"]},
                  ]},
                  {titre:"💰 Défis Économie (très vendeur)",note:"Angle puissant.",groupes:[
                    {sous:"",items:["Combien coûte ce ménage ?"]},
                  ]},
                ].map((section,si)=>(
                  <div key={si} style={{marginTop:"1rem"}}>
                    <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".3rem"}}>{section.titre}</div>
                    {section.note&&<p style={{fontSize:".71rem",color:C.gris,marginBottom:".5rem",lineHeight:1.5}}>{section.note}</p>}
                    {section.groupes.map((g,gi)=>(
                      <div key={gi} style={{marginBottom:".6rem"}}>
                        {g.sous&&<div style={{fontSize:".7rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>{g.sous}</div>}
                        <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem"}}>
                          {g.items.map((it,ii)=>(
                            <div key={ii} style={{fontSize:".7rem",color:C.texte,lineHeight:1.6}}>• {it}</div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </Card>
              <DriveBtn href="https://drive.google.com/file/d/1KldVcCgrfLjirxVZjyXtFCpECinKevWs/view" label="Stratégie Liste — Vidéo"/>
              <Card title="📋 Stratégie Liste" sub="Qualifier avant de proposer" icon="📋" color={C.lilas}>
                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas,marginBottom:".5rem"}}>✅ Étape 1 — La personne a tapé "LISTE" sous un post</div>
                <div style={{background:C.creme,borderRadius:8,padding:".65rem .8rem",fontSize:".72rem",color:C.brun,lineHeight:1.65,fontStyle:"italic",borderLeft:`2px solid ${C.lilas}`,marginBottom:".6rem"}}>
                  "Bonjour, afin que je puisse répondre au mieux à tes attentes, peux-tu me dire quelle catégorie de produits t'intéresserait le plus ? Maquillage, produits cheveux, parfums, compléments alimentaires, produits d'entretien"
                </div>
                <p style={{fontSize:".72rem",color:C.gris,marginBottom:".7rem",lineHeight:1.5}}>En fonction de la réponse : "Pour mieux te renseigner, j'aimerais pouvoir te poser quelques questions. Es-tu d'accord ?"</p>

                {[
                  {titre:"🔹 Perte de poids",qs:["Quel est ton objectif actuel (perte de poids, affinement, énergie, digestion, autre) ?","Combien aimerais-tu perdre, et en combien de temps idéalement ?","À quoi ressemblent tes repas sur une journée ?","As-tu tendance à grignoter ? Plutôt sucré, salé ou émotionnel ?","Bois-tu assez d'eau ? Environ combien par jour ?","Comment dors-tu en ce moment ?","Ton niveau de stress sur une échelle de 1 à 10 ?","Ton stress influence-t-il ton alimentation ?","Digères-tu bien ? Ballonnements, transit, lourdeurs ?","Te sens-tu souvent fatiguée dans la journée ?","Fais-tu un peu de sport ou de marche ? Combien de fois par semaine ?","As-tu déjà testé des compléments ou programmes ?","As-tu des allergies, intolérances ou traitements en cours ?"]},
                  {titre:"🧴 Cosmétiques / Maquillage",qs:["Tu te maquilles tous les jours, de temps en temps ou rarement ?","Tu recherches quelque chose de rapide et naturel, ou un rendu plus travaillé ?"]},
                  {titre:"✨ Soins visage",qs:["Ta peau est plutôt sèche, mixte, grasse ou sensible ?","Ta priorité : hydratation, anti-âge, imperfections, éclat ou confort ?","Tu as déjà une routine simple ou tu veux quelque chose de facile à suivre ?"]},
                  {titre:"💇‍♀️ Cheveux",qs:["Tes cheveux sont secs, abîmés, fins, épais, bouclés, colorés ?","Ton objectif : moins de casse, plus de brillance, plus de volume ou meilleure pousse ?"]},
                  {titre:"🌸 Parfums",qs:["Tu aimes les parfums légers, sucrés, fleuris ou intenses ?","Aimes-tu un parfum en particulier ?"]},
                  {titre:"🧴 Soins corps",qs:["Tu recherches hydratation, fermeté, détente ou un moment cocooning ?","Ta peau est plutôt sèche, sensible ou sans souci particulier ?"]},
                  {titre:"🌿 Compléments alimentaires",qs:["Priorité : énergie, sommeil, digestion, perte de poids ou bien-être général ?","Tu préfères une cure simple ou une routine plus complète ?","As-tu déjà testé des compléments ou jamais osé ?"]},
                  {titre:"🧼 Produits d'entretien",qs:["Tu voudrais simplifier ton placard (moins de produits) ?","Qu'aimerais-tu traiter avec les produits ?"]},
                ].map((sec,i)=>(
                  <div key={i} style={{marginBottom:".6rem"}}>
                    <div style={{fontSize:".71rem",fontWeight:700,color:C.brun,marginBottom:".3rem"}}>{sec.titre}</div>
                    <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem"}}>
                      {sec.qs.map((q,qi)=>(<div key={qi} style={{fontSize:".7rem",color:C.texte,lineHeight:1.6}}>• {q}</div>))}
                    </div>
                  </div>
                ))}

                <div style={{background:C.lilas+"15",borderRadius:8,padding:".6rem .8rem",fontSize:".71rem",color:C.brun,lineHeight:1.6,marginTop:".6rem",marginBottom:".8rem"}}>
                  "Très bien 😊 Le temps que j'analyse tes réponses pour te faire un diagnostic vraiment adapté, je t'envoie une courte vidéo qui explique le concept."
                </div>

                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas,marginBottom:".5rem"}}>✅ Étape 2 — Envoie la vidéo 1</div>
                <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.6,marginBottom:".5rem"}}><strong>Si la personne veut simplement être cliente</strong> → propose 3 packs :</p>
                <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem",marginBottom:".6rem"}}>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>• Le pack dont le prix se rapproche le plus des 25€ mis en avant</div>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>• Un pack routine complet</div>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>• Le même pack que l'intermédiaire, avec un bonus</div>
                </div>
                <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.6,marginBottom:".6rem"}}>👋 La personne choisit → création d'un lien client.</p>
                <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.6,marginBottom:".6rem"}}><strong>Si la personne veut devenir VIP/distributeur</strong> → envoie la vidéo 2, puis : "Alors dis-moi ? Comment te situes-tu ?"</p>
                <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem",marginBottom:".6rem"}}>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>Ce qu'il faut retenir : tu peux démarrer à ton rythme —</div>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>• Pas besoin de savoir vendre</div>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>• Pas besoin d'y passer tes journées</div>
                  <div style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>• On est accompagnées étape par étape</div>
                </div>
                <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.6}}>Une mini formation express de 8 vidéos permet de gagner ses premières commissions rapidement. Si la personne est ok, le plus simple est de créer son compte (gratuit), puis lui expliquer comment démarrer selon SON objectif.</p>
              </Card>
              <Card title={"🔥 Stratégie \"C'est Interdit\""} sub="Créer l'exclusivité et l'urgence" icon="🔥" color={"#C44B1A"}>
                <p style={{fontSize:".73rem",color:C.gris,marginBottom:".8rem",lineHeight:1.6}}>4 versions de messages pour partager un "replay exclusif" en créant un effet de rareté et de confiance.</p>
                {[
                  {titre:"🔴 La version \"Complice\" (très proche)",note:"Le message parfait pour une cliente fidèle ou une amie.",texte:"Coucou [Prénom] ! Écoute, je te partage un truc un peu en 'off'... Normalement, c'est réservé uniquement à l'équipe, mais j'ai tout de suite pensé à toi. Ma directrice vient de nous faire une présentation sur la nouvelle gamme Body Architect et c'est juste une dinguerie. Je t'envoie le replay en douce, regarde ça et dis-moi ce que tu en penses !"},
                  {titre:"🔴 La version \"Expertise & Résultat\" (plus pro)",note:"Pour une cliente qui fait attention à sa silhouette et cherche de l'efficacité.",texte:"Hello [Prénom], j'espère que tu vas bien. Je sors d'une réunion privée sur les nouveaux produits Corps et franchement, je n'ai pas pu m'empêcher de penser à toi. Je ne devrais pas forcément faire circuler la vidéo, mais les explications sur les actifs de Body Architect sont tellement bluffantes que je voulais que tu aies l'info avant tout le monde. Je te glisse le replay ici !"},
                  {titre:"🔴 La version \"Curiosité\" (court et percutant)",note:"Idéal pour susciter une réponse rapide.",texte:"Coucou ! Il faut que je te montre un truc... On a eu un Zoom exclusif ce soir sur la nouvelle gamme Architect et j'ai réussi à récupérer l'enregistrement. C'est du lourd, je n'ai pas le droit de le diffuser normalement alors regarde-le vite et dis-moi si ça te parle ! 😉"},
                  {titre:"🔴 La version \"Testeuse VIP\"",note:"Pour donner l'impression à la cliente qu'elle est une privilégiée.",texte:"Salut [Prénom], j'ai un petit secret pour toi ! On vient de finir une formation interne sur la gamme Body Architect. C'est censé rester entre nous, mais comme tu es une de mes meilleures clientes, je voulais que tu voies les résultats annoncés par la directrice. Regarde ce replay, c'est révolutionnaire !"},
                ].map((v,i)=>(
                  <div key={i} style={{marginBottom:".8rem"}}>
                    <div style={{fontSize:".72rem",fontWeight:700,color:C.brun,marginBottom:".15rem"}}>{v.titre}</div>
                    <div style={{fontSize:".68rem",color:C.gris,marginBottom:".35rem",fontStyle:"italic"}}>{v.note}</div>
                    <div style={{background:C.creme,borderRadius:8,padding:".6rem .75rem",fontSize:".71rem",color:C.brun,lineHeight:1.65,fontStyle:"italic",borderLeft:"2px solid #C44B1A"}}>"{v.texte}"</div>
                  </div>
                ))}

                <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#C44B1A",marginBottom:".4rem",marginTop:".9rem"}}>👉🏽 Quelques conseils</div>
                {[
                  ["Le timing","Envoyer le message juste après avoir reçu le lien du replay. Plus c'est \"chaud\", plus le côté \"je viens de voir ça\" est crédible."],
                  ["L'audio","Si elles sont à l'aise, un message vocal fonctionne encore mieux — l'excitation dans la voix rend le côté \"dinguerie\" plus réel."],
                  ["Le suivi","Ne pas oublier de recontacter la cliente 24h après si elle n'a pas répondu : \"Tu as eu le temps de jeter un œil avant que je doive supprimer le lien ?\" (ça rajoute de l'urgence)."],
                ].map(([t,d],i)=>(
                  <div key={i} style={{marginBottom:".5rem"}}>
                    <div style={{fontSize:".72rem",fontWeight:600,color:C.brun}}>{t}</div>
                    <div style={{fontSize:".71rem",color:C.texte,lineHeight:1.55}}>{d}</div>
                  </div>
                ))}

                <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#C44B1A",marginBottom:".4rem",marginTop:".9rem"}}>⚠️ Questions ouvertes à poser en fin de message</div>
                {[
                  {t:"1. Pour faire analyser ce qu'elle vient de voir",qs:["Qu'est-ce qui t'a le plus impressionnée dans la formation ?","Selon toi, qu'est-ce qui différencie cette gamme de ce que tu as déjà testé ?","Comment est-ce que tu imagines l'évolution de ta peau après 1 mois avec cette technologie ?"]},
                  {t:"2. Pour identifier un besoin spécifique (le \"pain point\")",qs:["Sur quelle partie de ton corps aimerais-tu voir les effets de la gamme Architect en priorité ?","Qu'est-ce qui te dérange le plus aujourd'hui quand tu te regardes dans le miroir au niveau de ta silhouette ?","Si tu avais une baguette magique pour ta routine corps, quel serait ton objectif principal ?"]},
                  {t:"3. Pour projeter la cliente dans l'achat",qs:["À partir de quel moment dans l'année aimerais-tu te sentir parfaitement à l'aise dans tes vêtements d'été ?","Quelle sensation recherches-tu le plus dans un soin corps : la fermeté, la texture ou le résultat visuel ?","Dans combien de temps aimerais-tu voir tes premiers résultats de transformation ?"]},
                  {t:"4. Pour contrer les objections (avec douceur)",qs:["Qu'est-ce qui te fait dire que ce n'est pas le bon moment pour toi ?","Au-delà du prix, quel est l'élément qui te fait encore hésiter ?","Quelles sont les informations qui te manquent pour être totalement convaincue par l'efficacité ?"]},
                ].map((sec,i)=>(
                  <div key={i} style={{marginBottom:".65rem"}}>
                    <div style={{fontSize:".71rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>{sec.t}</div>
                    <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem"}}>
                      {sec.qs.map((q,qi)=>(<div key={qi} style={{fontSize:".7rem",color:C.texte,lineHeight:1.6}}>• {q}</div>))}
                    </div>
                  </div>
                ))}
                <div style={{background:"#C44B1A15",borderRadius:8,padding:".6rem .8rem",fontSize:".71rem",color:C.brun,lineHeight:1.6,marginTop:".5rem"}}>
                  💡 Le petit conseil pour ton équipe : une question ouverte commence souvent par <span style={{fontWeight:700}}>Comment, Pourquoi, En quoi, Quel/Quelle, Qu'est-ce que</span>.
                </div>
              </Card>
            </Card>

            <Card title="Idées pour booster ses ventes" sub="Méthodes créatives et efficaces" icon="🚀" color={C.rose}>
              {[
                ["📦","Box surprises","La cliente choisit un montant (ex: 30€, 50€, 80€). Tu crées une box surprise avec des produits adaptés. Avantage : tu décides de la marge, tu mets en valeur les produits, effet cadeau = émotion = réachat.","Comment vendre ça : \"Tu me donnes un budget, je te crée une box personnalisée avec ce que j'aurai choisi spécialement pour toi. Parfait pour s'offrir ou offrir.\""],
                ["🎰","Tombola produits","La tombola s'auto-finance : les billets paient le lot. Objectif : faire découvrir les produits à de nouvelles personnes. 1 billet = 1 produit Mihi à tester. Les gagnantes deviennent souvent des clientes.","Organisation : 10 billets à 3€ = 30€. Tu achètes le lot à prix distributeur (~15€). Bénéfice réel = 5 nouvelles personnes qui ont découvert les produits."],
                ["🎒","Palette voyageuse","Une trousse avec des échantillons, produits phares, le catalogue et un bon de commande. Tu la fais circuler dans ton entourage (famille, collègues, voisines). Chaque personne la garde 48h.","Résultat : des ventes sans sortir de chez toi. Les gens touchent, testent, commandent."],
                ["🧪","Offre testeurs","Tu recherches 5 personnes pour tester une nouvelle gamme à prix coûtant. Objectif : créer de la preuve sociale et fidéliser. En échange : un témoignage honnête.","Comment le pitcher : \"Je recherche 5 femmes pour tester la nouvelle gamme Face Architect à prix coûtant. En échange, juste ton retour honnête. Intéressée ?\""],
                ["🎮","Jeu concours","Un jeu simple sur tes stories (sondage, devinette, tirage au sort). Le lot = un produit Mihi. Objectif : engagement + visibilité + nouvelles personnes.","Règle d'or : le jeu doit être simple (une action max), le lot doit être désirable, et tu dois relancer les participantes en DM après."],
              ].map(([icon,title,desc,tip])=>(
                <div key={title} style={{background:C.creme,borderRadius:10,padding:".8rem",marginBottom:".65rem",border:`1px solid ${C.pale}`}}>
                  <div style={{display:"flex",gap:".5rem",alignItems:"flex-start",marginBottom:".4rem"}}>
                    <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
                    <div style={{fontSize:".8rem",fontWeight:600,color:C.brun}}>{title}</div>
                  </div>
                  <p style={{fontSize:".74rem",color:C.texte,lineHeight:1.6,marginBottom:".35rem"}}>{desc}</p>
                  <div style={{background:C.blanc,borderRadius:7,padding:".5rem .65rem",fontSize:".71rem",color:C.brun,lineHeight:1.6,fontStyle:"italic",borderLeft:`2px solid ${C.or}`}}>{tip}</div>
                </div>
              ))}
            </Card>

            <Card title="Groupe Messenger clientes" sub="Comment gérer ta communauté cliente" icon="💬" color={C.lilas}>
              <Info color={C.lilas}>Un groupe Messenger bien géré = des clientes engagées qui reviennent. Un groupe mal géré = désengagement et sorties silencieuses.</Info>
              <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.vert,marginBottom:".4rem"}}>✅ À faire</div>
              {["Présenter le groupe dès l'arrivée d'une nouvelle cliente (ton nom, ce que tu partages ici)","Partager des contenus utiles et valorisants (tips beauté, routine, offres en cours)","Annoncer les nouvelles gammes et les programmes clients Mihi","Créer de l'interaction (sondages, questions, avis produits)","Célébrer les résultats des clientes (avant/après, témoignages)","Partager les promotions Mihi (Infinity Bonus, Smart Shopping, tokens)"].map((item,i)=>(
                <div key={i} style={{display:"flex",gap:".5rem",marginBottom:".35rem",alignItems:"flex-start",fontSize:".75rem",color:C.texte}}>
                  <span style={{color:C.vert,flexShrink:0}}>✓</span>{item}
                </div>
              ))}
              <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#B04040",marginBottom:".4rem",marginTop:".7rem"}}>❌ À ne pas faire</div>
              {["Spammer avec des promotions tous les jours","Copier-coller des messages génériques Mihi sans personnalisation","Ignorer les questions ou mettre du temps à répondre","Partager des prix sans contexte (toujours montrer la valeur avant le prix)","Créer plusieurs groupes pour la même clientèle (confusion)"].map((item,i)=>(
                <div key={i} style={{display:"flex",gap:".5rem",marginBottom:".35rem",alignItems:"flex-start",fontSize:".75rem",color:C.texte}}>
                  <span style={{color:"#B04040",flexShrink:0}}>✗</span>{item}
                </div>
              ))}
            </Card>

            <Card title="Base du suivi client" sub="Ne plus jamais perdre une cliente" icon="📊" color={C.or}>
              <Info color={C.or}>Une cliente qui ne commande plus n'est pas perdue — elle est juste oubliée. Le suivi c'est ce qui fait la différence entre une activité qui stagne et une qui grandit.</Info>
              {[
                ["Après la 1ʳᵉ commande","Message de remerciement dans les 24h. Demande si tout s'est bien passé. Propose un conseil d'utilisation."],
                ["À J+7","Comment elle trouve les produits ? Elle a des questions ? C'est le moment de créer le lien."],
                ["À J+21","Avant la prochaine période : \"La nouvelle période Mihi arrive, tu veux que je te prévienne des offres en cours ?\""],
                ["Si silence +30j","Relance avec un token ou une offre personnalisée. \"J'ai pensé à toi pour cette offre — ça correspond à ce que tu avais aimé.\""],
                ["À chaque anniversaire","Un message personnel. Un token en cadeau si possible. Les petites attentions créent la fidélité à vie."],
              ].map(([moment,action],i)=>(
                <div key={i} style={{display:"flex",gap:".6rem",marginBottom:".55rem",alignItems:"flex-start"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:C.or+"30",color:C.brun2,fontSize:".58rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2}}>{i+1}</div>
                  <div><div style={{fontSize:".77rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{moment}</div><div style={{fontSize:".71rem",color:C.gris,lineHeight:1.5}}>{action}</div></div>
                </div>
              ))}
            </Card>

            <Card title="Les Lives — Guide complet" sub="Différentes idées, comment varier" icon="🎥" color={C.rose}>
              {[
                ["🌟","Live démo produit","Tu montres un produit en live, tu l'appliques sur toi, tu réponds aux questions. Le plus simple et le plus efficace.","Durée : 20-30 min. Annonce 24h avant. Commence même si peu de monde."],
                ["❓","Live FAQ","\"Je réponds à toutes vos questions sur [thème].\" Collect les questions avant en story.","Crée de la confiance et de l'expertise. Les spectatrices reviennent."],
                ["🎯","Live défi en direct","\"Ce soir on fait le défi [teint parfait / cheveux brillants] ensemble.\" Chacune montre son avant.","Engagement maximal. Les participantes deviennent des ambassadrices."],
                ["🛍️","Live vente flash","\"Ce soir seulement, offre spéciale sur [produit].\" Crée l'urgence.","Ne pas en abuser. Réserver aux occasions : nouvelle gamme, fin de période, anniversaire."],
                ["📖","Live storytelling","Tu racontes ton histoire : pourquoi tu as rejoint Mihi, tes galères, tes victoires.","C'est le live le plus puissant pour le recrutement. L'authenticité convertit."],
              ].map(([icon,title,desc,tip])=>(
                <div key={title} style={{background:C.creme,borderRadius:10,padding:".75rem",marginBottom:".6rem",border:`1px solid ${C.pale}`}}>
                  <div style={{display:"flex",gap:".5rem",marginBottom:".3rem"}}><span>{icon}</span><div style={{fontSize:".8rem",fontWeight:600,color:C.brun}}>{title}</div></div>
                  <p style={{fontSize:".73rem",color:C.texte,lineHeight:1.6,marginBottom:".3rem"}}>{desc}</p>
                  <div style={{fontSize:".7rem",color:C.gris,fontStyle:"italic",borderLeft:`2px solid ${C.rose}`,paddingLeft:".5rem"}}>{tip}</div>
                </div>
              ))}
            </Card>
            {/* ── FORMATION : ARRETE DE VOULOIR TOUT VENDRE ── */}
<Card title="Arrête de vouloir tout vendre" sub="1 produit par période · 7 angles · la méthode" icon="⚠️" color={C.or} defaultOpen>

  <Info color={C.or}>
    <strong>La formation la plus importante de cet onglet.</strong> Si tu n'en appliques qu'une, prends celle-là. Elle ne te demande pas de travailler plus — elle te demande de travailler sur <em>moins de produits</em>.
  </Info>

  {/* 1. LE PIEGE */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>1 · Le piège du catalogue</div>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Ne cherche pas à couvrir le catalogue. C'est le réflexe naturel, et c'est exactement le piège : avec 400 produits, si tu en montres un nouveau chaque jour, <strong>personne ne voit jamais deux fois le même</strong>.
  </p>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Et on n'achète pas ce qu'on a vu une seule fois. On achète ce qu'on a vu assez souvent pour s'en souvenir le jour où le besoin arrive.
  </p>
  <div style={{background:"rgba(139,94,0,.08)",borderLeft:"3px solid "+C.or,padding:".7rem .8rem",borderRadius:"0 8px 8px 0",marginBottom:".6rem"}}>
    <div style={{fontSize:".72rem",color:C.brun,lineHeight:1.6}}>
      <strong>400 produits qui défilent = 0 produit installé.</strong><br/>
      17 produits travaillés en profondeur = 17 produits que ton audience connaît par cœur.
    </div>
  </div>

  {/* 2. LA REGLE */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>2 · La règle : 1 produit par période</div>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Tu as environ <strong>7 créneaux produit par période</strong>. Utilise-les <strong>tous sur le même produit</strong>, traité sous 7 angles différents.
  </p>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Ça paraît répétitif quand tu le prépares. Ça ne l'est jamais pour celle qui te lit : elle ne voit qu'une fraction de ce que tu publies. Ce qui te semble lourd, elle le vit comme « ah tiens, encore ce truc — ça doit être bien ».
  </p>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Résultat sur l'année : <strong>17 produits vraiment installés</strong> dans la tête de ton audience, au lieu de 400 qui défilent.
  </p>

  {/* 3. LES 7 ANGLES */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>3 · Les 7 angles pour un seul produit</div>
  {[
    ["1","🎯","Le problème — pas le produit","Tu n'ouvres jamais par le nom du produit. Tu ouvres par la sensation. « Ta peau tire après la douche ? » « Ce moment où tu te relèves du canapé et t'as mal partout. » Elle doit se reconnaître avant de savoir que tu vends quelque chose."],
    ["2","🎬","Ta routine, filmée","Comment tu l'utilises vraiment. Pas une démo léchée — le vrai geste, la vraie texture, la quantité réelle. C'est ce qui transforme un produit abstrait en objet qu'on imagine dans sa salle de bain."],
    ["3","💶","Le prix — la comparaison au litre","Ton hook le plus partagé. Ramène le prix au litre ou à la dose, et compare à une marque connue. Le chiffre fait le travail tout seul, tu n'as pas besoin d'en rajouter."],
    ["4","🚫","Pour qui ce n'est PAS","L'angle honnête, et celui qui crédibilise les six autres. « Si tu cherches un effet immédiat, passe ton chemin. » Dire à qui un produit ne convient pas est le signal le plus fort que tu ne racontes pas n'importe quoi."],
    ["5","💬","Le retour cliente","Avec son accord, et sans promesse de résultat. Un message brut vaut mieux qu'un témoignage reformulé — les gens reconnaissent instantanément le vrai du fabriqué."],
    ["6","😬","L'objection frontale","Tu dis toi-même ce qu'on pense tout bas. « Oui, c'est une marque que tu ne connais pas. Parlons-en. » Prendre l'objection en premier te met du côté de ta cliente, pas en face d'elle."],
    ["7","⏳","Le rappel de fin de période","La promo se termine, tu le dis. Simplement, sans faux compte à rebours et sans « dernières pièces » inventé. L'urgence honnête fonctionne. L'urgence fabriquée te grille pour de bon."],
  ].map(([n,ic,t,d])=>(
    <div key={n} style={{display:"flex",gap:".7rem",alignItems:"flex-start",marginBottom:".7rem"}}>
      <div style={{minWidth:"1.7rem",height:"1.7rem",borderRadius:"50%",background:C.or,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".7rem",fontWeight:700,flexShrink:0}}>{n}</div>
      <div>
        <div style={{fontSize:".76rem",fontWeight:700,color:C.brun,marginBottom:".15rem"}}>{ic} {t}</div>
        <div style={{fontSize:".71rem",color:C.texte,lineHeight:1.6}}>{d}</div>
      </div>
    </div>
  ))}

  {/* 4. PLAN DE PERIODE */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>4 · Ton plan de période, clé en main</div>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".7rem"}}>
    Tu n'as pas à réfléchir à l'ordre : il est déjà pensé pour amener ta cliente d'un point A à un point B.
  </p>
  {[
    ["Semaine 1","Tu installes le produit",["Angle 1 — Le problème","Angle 2 — Ta routine filmée"],C.rose],
    ["Semaine 2","Tu construis la valeur",["Angle 3 — Le prix au litre","Angle 4 — Pour qui ce n'est pas","Angle 5 — Le retour cliente"],C.lilas],
    ["Semaine 3","Tu lèves les freins",["Angle 6 — L'objection frontale","Angle 7 — Le rappel de fin de période"],C.or],
  ].map(([sem,but,items,col])=>(
    <div key={sem} style={{border:"1px solid rgba(139,94,0,.18)",borderRadius:"10px",padding:".7rem .8rem",marginBottom:".55rem",background:"rgba(255,255,255,.4)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:".4rem",flexWrap:"wrap",gap:".3rem"}}>
        <span style={{fontSize:".78rem",fontWeight:700,color:col}}>{sem}</span>
        <span style={{fontSize:".66rem",color:C.gris,fontStyle:"italic"}}>{but}</span>
      </div>
      {items.map(it=>(
        <div key={it} style={{fontSize:".71rem",color:C.texte,lineHeight:1.7,paddingLeft:".2rem"}}>• {it}</div>
      ))}
    </div>
  ))}

  {/* 5. CHOISIR SES 17 */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>5 · Comment choisir tes 17 héros</div>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Ne choisis pas au feeling. Ouvre ton back-office et sors <strong>tes ventes des 6 derniers mois</strong>. Tu vas découvrir que 10 à 15 références font la grande majorité de ton volume. Ce sont tes héros — tu les gardes toute l'année.
  </p>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Pour arbitrer les places restantes, deux critères :
  </p>
  {[
    ["🔁","Consommable avant tout","Un soin qui se termine en 6 semaines rapporte dix fois plus qu'un appareil acheté une fois. Ton PGV a besoin de récurrence, pas de nouveautés."],
    ["📅","Aligné sur le catalogue en cours","Chaque période a ses promos. Un produit en promo te donne un argument prix concret — c'est le moment de le pousser, pas dans trois mois."],
  ].map(([ic,t,d])=>(
    <div key={t} style={{display:"flex",gap:".6rem",alignItems:"flex-start",marginBottom:".55rem"}}>
      <span style={{fontSize:"1rem",flexShrink:0}}>{ic}</span>
      <div>
        <div style={{fontSize:".75rem",fontWeight:700,color:C.brun}}>{t}</div>
        <div style={{fontSize:".71rem",color:C.texte,lineHeight:1.6}}>{d}</div>
      </div>
    </div>
  ))}

  {/* 6. SEMAINES A THEME */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>6 · Organise par problème vécu, pas par catégorie</div>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Les semaines à thème : oui. Mais pas par catégorie. « Semaine crèmes », « semaine compléments » — c'est de la logique de catalogue. Ça ne parle qu'à celles qui cherchent déjà.
  </p>
  <div style={{background:"rgba(139,94,0,.06)",borderRadius:"10px",padding:".7rem .8rem",marginBottom:".6rem"}}>
    <div style={{fontSize:".64rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".08em",color:C.gris,marginBottom:".4rem"}}>Organise plutôt comme ça</div>
    {["La peau qui tire","La fatigue de fin de journée","Les cheveux qui cassent","Le ventre gonflé après les repas"].map(x=>(
      <div key={x} style={{fontSize:".72rem",color:C.brun,fontWeight:600,lineHeight:1.8}}>• {x}</div>
    ))}
  </div>
  <div style={{background:"rgba(196,120,140,.1)",borderLeft:"3px solid "+C.rose,padding:".7rem .8rem",borderRadius:"0 8px 8px 0",marginBottom:".6rem"}}>
    <div style={{fontSize:".72rem",color:C.brun,lineHeight:1.7}}>
      Une femme ne se dit <strong>jamais</strong> « il me faut un sérum ».<br/>
      Elle se dit « j'ai une sale tête ce matin ».<br/>
      <em>Tu entres par là, le produit arrive après.</em>
    </div>
  </div>

  {/* 7. GARDE-FOU */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#B3261E",marginTop:"1.2rem",marginBottom:".5rem"}}>7 · Le garde-fou — compléments alimentaires</div>
  <div style={{border:"1.5px solid rgba(179,38,30,.35)",background:"rgba(179,38,30,.05)",borderRadius:"10px",padding:".8rem"}}>
    <div style={{fontSize:".74rem",color:C.brun,lineHeight:1.7,marginBottom:".6rem"}}>
      <strong>⚠️ À lire avant de publier.</strong> Sur tout ce qui est complément alimentaire, reste dans les allégations autorisées et ne laisse <strong>jamais</strong> entendre un effet de type médicament. C'est le sujet sur lequel la DGCCRF est la plus attentive — et c'est aussi celui où tes concurrentes se plantent le plus souvent. Donc où ta rigueur se voit.
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr",gap:".5rem"}}>
      <div>
        <div style={{fontSize:".66rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".08em",color:"#2E7D32",marginBottom:".25rem"}}>✅ Tu peux dire</div>
        {["« Contribue à réduire la fatigue »","« Participe au maintien d'une peau normale »","« Ce que moi j'ai ressenti, sans promesse pour toi »","« Complément d'une alimentation variée »"].map(x=>(
          <div key={x} style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>{x}</div>
        ))}
      </div>
      <div>
        <div style={{fontSize:".66rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".08em",color:"#B3261E",marginBottom:".25rem"}}>❌ Tu ne peux pas dire</div>
        {["« Soigne », « guérit », « traite »","« Fait perdre X kilos »","« Remplace ton traitement »","Un avant/après présenté comme un résultat garanti"].map(x=>(
          <div key={x} style={{fontSize:".7rem",color:C.texte,lineHeight:1.7}}>{x}</div>
        ))}
      </div>
    </div>
    <div style={{fontSize:".68rem",color:C.gris,fontStyle:"italic",marginTop:".6rem",lineHeight:1.6}}>
      En cas de doute sur une formulation : demande-la-moi en message avant de publier. Ça prend deux minutes et ça t'évite un vrai problème.
    </div>
  </div>

  {/* 8. ERREURS */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>8 · Les 4 erreurs qui tuent la méthode</div>
  {[
    ["Craquer au bout de 3 jours","Tu vas trouver ça répétitif bien avant ton audience. C'est normal, et ce n'est pas un signal. Tiens la période complète — c'est justement à partir du 4e ou 5e contenu que ça commence à payer."],
    ["Changer de produit parce qu'un post a mal marché","Un contenu qui ne performe pas ne condamne pas le produit. Il condamne l'angle. Passe au suivant, garde le produit."],
    ["Empiler deux produits dans le même contenu","Dès qu'il y a un choix à faire, il n'y a plus de décision. Un contenu = un produit = un angle."],
    ["Attendre la nouveauté pour se relancer","La nouveauté flatte ton envie de variété, pas les ventes. Tes héros paient tes factures, pas le dernier lancement."],
  ].map(([t,d],i)=>(
    <div key={t} style={{display:"flex",gap:".6rem",alignItems:"flex-start",marginBottom:".55rem"}}>
      <span style={{fontSize:".9rem",flexShrink:0}}>❌</span>
      <div>
        <div style={{fontSize:".75rem",fontWeight:700,color:C.brun}}>{t}</div>
        <div style={{fontSize:".71rem",color:C.texte,lineHeight:1.6}}>{d}</div>
      </div>
    </div>
  ))}

  {/* 9. MESURER */}
  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.or,marginTop:"1.2rem",marginBottom:".5rem"}}>9 · Comment savoir si ça marche</div>
  <p style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
    Pas les likes. Les likes ne t'ont jamais payé une facture. Regarde ces trois chiffres à la fin de chaque période :
  </p>
  {[
    ["💬","Messages reçus sur le produit","Le vrai thermomètre. Si les angles fonctionnent, on te pose des questions."],
    ["🔁","Partages / enregistrements","Surtout sur l'angle prix. C'est le signal que ton contenu circule au-delà de tes abonnées."],
    ["🛍️","Ventes attribuées à ce produit","Compare avec la période précédente sur un produit traité à l'ancienne. L'écart te dira tout."],
  ].map(([ic,t,d])=>(
    <div key={t} style={{display:"flex",gap:".6rem",alignItems:"flex-start",marginBottom:".5rem"}}>
      <span style={{fontSize:"1rem",flexShrink:0}}>{ic}</span>
      <div>
        <div style={{fontSize:".75rem",fontWeight:700,color:C.brun}}>{t}</div>
        <div style={{fontSize:".71rem",color:C.texte,lineHeight:1.6}}>{d}</div>
      </div>
    </div>
  ))}

  {/* 10. CTA */}
  <div style={{marginTop:"1.3rem",background:"linear-gradient(135deg,rgba(139,94,0,.12),rgba(196,120,140,.12))",border:"1.5px solid rgba(139,94,0,.25)",borderRadius:"12px",padding:".9rem"}}>
    <div style={{fontSize:".82rem",fontWeight:700,color:C.brun,marginBottom:".45rem"}}>🎯 Ton plan pour cette période</div>
    <div style={{fontSize:".72rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem"}}>
      Regarde quel produit est en promo au catalogue en cours. Croise avec tes 3 meilleures ventes des 6 derniers mois. <strong>Prends celui qui coche les deux.</strong> C'est ton produit de la période, tu ne le lâches plus pendant 3 semaines.
    </div>
    <div style={{fontSize:".72rem",color:C.brun,lineHeight:1.7,fontWeight:600,borderTop:"1px solid rgba(139,94,0,.2)",paddingTop:".55rem"}}>
      ✍️ Écris-moi ton produit en message — je te rédige tes 7 angles en détail, prêts à publier.
    </div>
  </div>

</Card>
<BoutonTermineFormation subTab="vente"/>
          </div>
        )}

        {/* ── RECRUTEMENT ── */}
        {tab==="formation"&&formationSubTab==="recrutement"&&(
          <div>
            <SecTitle title="Recrutement &" em="Affiliation" desc="Stratégies, diagnostique, affiliation — tout pour développer ton équipe."/>
            <AdminContentBlock onglet="recrutement" items={adminItems}/>

            <Card title="Replays Zoom Recrutement" sub="Les sessions formation recrutement" icon="🎥" color={C.rose} defaultOpen>
              <Btn href="https://us06web.zoom.us/rec/share/viyM_OY-wZkKDCyLj-qhIEbIiDv1Yl7j06l9WctzEbvdOS6YPyNJ8RbKKINR5wcO.m5X0v3XgsWBn0ymc" label="Outils de démarrage & recrutement" icon="▶" color={C.brun}/>
              <Btn href="https://us06web.zoom.us/rec/share/hnDWdngAPCK_SGVTYzVhgk70t_nqqfesUvZF7hme8CaEgL-CpszXoantB-d2MSPZ.Yl7wHQ7KV9pZJnCL" label="Communiquer différemment pour passer au niveau supérieur" icon="▶" color={C.brun}/>
              <Btn href="https://us06web.zoom.us/rec/share/Ifld2R1bAsLQ1bJKuj0mr80yNxPt5kPOKAapDNv5jJundkKNIXrdr7de0H0Cn_qR.Yqhq_7quf10A7wtw?startTime=1774984148000" label="Stratégie — Je ne dois pas te le dire mais... 🔥" icon="▶" color={C.brun}/>
            </Card>

            <Card title="Parler de Mihi & Blazing Dynasty" sub="Comment présenter l'opportunité sans mentir ni survendre" icon="🔥" color={C.brun} defaultOpen>
              <Info color={C.brun}>Ne vends pas un rêve — partage une réalité concrète. Les gens sentent le baratin à 10km. Sois précise, honnête, et laisse l'opportunité parler d'elle-même.</Info>
              {[
                ["🏢","Mihi, c'est quoi exactement","Mihi est une marque polonaise de beauté et bien-être (parfums, skincare, compléments, minceur) lancée en 2022, fabriquée par ElfaPharm — un vrai laboratoire pharmaceutique présent dans 62 pays. Ce n'est pas une startup fantôme : derrière les produits, il y a une vraie expertise pharmaceutique. Dis-le simplement : \"Je vends une marque européenne fabriquée par un laboratoire pharma, pas un produit fabriqué dans un garage.\""],
                ["🌟","Pourquoi Blazing Dynasty et pas une autre équipe","Blazing Dynasty, c'est l'équipe que tu rejoins, pas juste un statut de distributrice isolée. Tu n'es jamais seule : formation complète (cette appli en est la preuve), accompagnement personnalisé par ta marraine, communauté de femmes qui s'entraident. Le discours : \"Tu ne rejoins pas juste Mihi, tu rejoins une équipe qui te forme et t'accompagne vraiment.\""],
                ["💰","Le modèle économique honnête","Sois transparente sur le modèle : tu gagnes sur tes propres ventes ET sur celles de l'équipe que tu formes. Ce n'est ni un système pyramidal (pas de gain juste à recruter sans vendre) ni un emploi salarié classique. C'est de la vente directe avec effet de levier d'équipe. Dis : \"Plus tu vends et plus tu aides ton équipe à vendre, plus tu gagnes — c'est aussi simple que ça.\""],
                ["🎯","Pour qui c'est fait","Sois honnête sur le profil idéal : quelqu'un qui veut un complément de revenu flexible, qui aime le contact humain, et qui est prête à apprendre. Ce n'est pas pour quelqu'un qui cherche un revenu garanti sans effort. \"Si tu cherches 2-10h par semaine pour développer un vrai revenu complémentaire avec un vrai accompagnement, on devrait parler.\""],
                ["🙅","Ce qu'il ne faut JAMAIS dire","Jamais de promesse de revenu garanti, jamais \"deviens riche vite\", jamais cacher que c'est un investissement de départ (kit) et de temps. La confiance se construit sur l'honnêteté, pas sur le rêve qui s'effondre au premier mois difficile."],
                ["💬","La phrase d'accroche qui fonctionne","\"Je fais partie d'une équipe qui vend les produits Mihi, une marque polonaise fabriquée par un vrai labo pharmaceutique. On est plusieurs femmes à se former et s'entraider pour développer une activité flexible à côté. Si jamais ça t'intéresse de voir comment ça marche, je peux t'expliquer sans pression.\""],
              ].map(([icon,title,desc])=>(
                <div key={title} style={{background:C.creme,borderRadius:9,padding:".7rem .85rem",marginBottom:".55rem",border:`1px solid ${C.pale}`}}>
                  <div style={{display:"flex",gap:".5rem",marginBottom:".3rem",alignItems:"flex-start"}}>
                    <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
                    <div style={{fontSize:".8rem",fontWeight:600,color:C.brun}}>{title}</div>
                  </div>
                  <div style={{fontSize:".72rem",color:C.gris,lineHeight:1.65}}>{desc}</div>
                </div>
              ))}
            </Card>

            <Card title="Stratégies pour attirer" sub="Comment attirer les bonnes personnes naturellement" icon="🧲" color={C.or}>
              <Info color={C.or}>Attirer c'est mieux que convaincre. Ces stratégies créent un flux entrant de personnes intéressées — sans avoir à courir après.</Info>
              {[
                ["🪝","Le profil qui attire","Ton profil Instagram/Facebook doit répondre à une question en 3 secondes : qui est cette personne et pourquoi je devrais la suivre ? Photo pro + bio qui parle à ta cible + lien Linktree. Sans ça, tout le reste ne sert à rien."],
                ["📖","Le storytelling quotidien","Partage ton histoire — tes galères, tes doutes, tes victoires. Les gens ne s'identifient pas à la perfection. Ils s'identifient à l'authenticité. Une distributrice qui raconte sa transformation attire plus que dix publications produit."],
                ["🔥","Le contenu de preuve","Témoignages clientes, résultats visuels, before/after, messages reçus. La preuve sociale est le moteur n°1 du désir. Partage tout ce qui montre que ça marche — pas en te vantant, mais en partageant."],
                ["🎯","Les hooks qui interpellent","Ta 1ʳᵉ phrase sur chaque publication doit stopper le scroll. \"Je ne cherchais pas un 2ᵉ emploi.\" \"Il y a 6 mois je ne savais pas quoi faire.\" \"Ce que personne ne te dit sur le marketing relationnel.\" La curiosité attire."],
                ["💬","L'interaction stratégique","Commente des publications de ta cible avec de vrais commentaires — pas des emojis. Réponds à toutes les stories. Pose des questions en DM sans pitcher. Crée la relation avant la proposition."],
                ["⚡","Le mot-clé en commentaire","Sur chaque publication opportunité, ferme avec un mot-clé : \"Écris ÉQUIPE en commentaire\". Tu ne réponds qu'aux personnes qui ont montré de l'intérêt. Qualité > quantité."],
              ].map(([icon,title,desc])=>(
                <div key={title} style={{background:C.creme,borderRadius:9,padding:".7rem .85rem",marginBottom:".55rem",border:`1px solid ${C.pale}`}}>
                  <div style={{display:"flex",gap:".5rem",marginBottom:".3rem",alignItems:"flex-start"}}>
                    <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
                    <div style={{fontSize:".8rem",fontWeight:600,color:C.brun}}>{title}</div>
                  </div>
                  <div style={{fontSize:".72rem",color:C.gris,lineHeight:1.6}}>{desc}</div>
                </div>
              ))}
              <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".4rem",marginTop:".5rem"}}>📹 Vidéos diagnostic à envoyer selon le profil</div>
              <DriveBtn href="https://drive.google.com/file/d/1oNIJBA9XKsZjB7idX_xV4oWxgzhHGST9/view" label="👉 Je veux m'affilier — vidéo à envoyer"/>
              <DriveBtn href="https://drive.google.com/file/d/18YRagfzUyTrlarrABNHJouqwUlzC948x/view" label="👉 Vidéo sur l'affiliation"/>
              <DriveBtn href="https://drive.google.com/file/d/1rm5kaTh90zhbd50dYjHxBVi10ud1wqqg/view" label="👉 Je ne veux pas m'affilier — vidéo à envoyer"/>
              <DriveBtn href="https://drive.google.com/file/d/1UvvOQuRetaJymObMLnuxRz6_RzvxOwBT/view" label="👉 Vidéo complémentaire"/>
            </Card>

            <Card title="Stratégies de recrutement" sub="Les méthodes avec documents complets" icon="📁" color={C.lilas}>
              <DriveBtn href="https://drive.google.com/file/d/104xn2JE-GYBos2eG9GhPcqI5ZWN78Fkp/view" label="Formation Démarrage + tips recrutement"/>
            </Card>

            <Card title="Récap outils de l'équipe" sub="Tout ce que l'équipe utilise au quotidien" icon="📋" color={C.or}>
              <Btn href="https://us02web.zoom.us/rec/share/anRmIaRRrGoC8leMrqjeOBH9IsOShB81_A99igN4pwozGtqEQ1oQUIqBSy30wqCn.gPMJZbroGZWrf7Du" label="🎥 Présentation d'opportunités" color={C.brun}/>
              <Btn href="https://t.me/+2wKWxIROE4c1M2Q0" label="📢 Telegram équipe — Visuels" color={"#0088CC"}/>
              <Btn href="https://t.me/+pv0RY_JJy4wyYzE8" label="💬 Telegram — Témoignages" color={"#0088CC"}/>
              <Btn href="https://www.facebook.com/share/g/1BGRQA1pZQ/?mibextid=wwXIfr" label="👥 Groupe Facebook équipe" color={"#1877F2"}/>
              <Info color={C.or}>Bienvenue, reconnaissance, mini-formations : tout se passe dans ces groupes. Garde ces liens sous la main.</Info>
            </Card>
            <BoutonTermineFormation subTab="recrutement"/>
          </div>
        )}

        {/* ── CONTENU ── */}
        {tab==="formation"&&formationSubTab==="contenu"&&(
          <div>
            <SecTitle title="Contenu &" em="Stratégie" desc="Personal branding, storytelling, mixing contenu — et ton tableau d'idées à cocher."/>
            <AdminContentBlock onglet="contenu" items={adminItems}/>

            <Card title={(afficherNewVisuels?"🆕 ":"")+"Pourquoi vos visuels parfaits ne vendent pas"} sub={(afficherNewVisuels?"Nouvelle formation · ":"")+"Vidéo + résumé"} icon="🎬" color={C.rose} defaultOpen>
              {afficherNewVisuels&&<span style={{display:"inline-block",background:"#E53935",color:"white",fontSize:".58rem",fontWeight:800,borderRadius:8,padding:".12rem .45rem",letterSpacing:".05em",marginBottom:".7rem"}}>🆕 NOUVEAU</span>}
              <div style={{position:"relative",paddingBottom:"56.25%",height:0,overflow:"hidden",borderRadius:12,marginBottom:".9rem",background:"#000"}}>
                <iframe src="https://www.youtube.com/embed/WB_TQBdtpIU" title="Pourquoi vos visuels parfaits ne vendent pas"
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
              </div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:C.brun,lineHeight:1.35,marginBottom:".8rem"}}>Pourquoi vos visuels parfaits ne vendent pas (et comment y remédier)</div>
              <div style={{fontSize:".8rem",color:C.texte,lineHeight:1.75}}>
                <p style={{margin:"0 0 .8rem"}}>Quand on débute ou qu'on veut bien faire, le premier réflexe est souvent de chercher à faire « pro » : on passe une heure sur Canva à aligner des éléments graphiques, on demande à ChatGPT de nous sortir un texte bien tourné, et on publie une affiche digne d'un catalogue.</p>
                <p style={{margin:"0 0 .8rem"}}>Le problème ? Sur les réseaux, un visuel publicitaire se fait immédiatement balayer du pouce.</p>
                <p style={{margin:"0 0 .8rem"}}>Vos abonnées ne se connectent pas pour lire des prospectus.</p>
                <p style={{margin:"0 0 .8rem"}}>Elles se connectent pour voir de l'humain.</p>
                <p style={{margin:"0 0 .8rem"}}>Dès qu'un contenu ressemble trop à une publicité générique, le cerveau décroche et la confiance ne s'installe pas.</p>
                <p style={{margin:"0 0 .6rem",fontWeight:700,color:C.brun}}>Ce qui déclenche réellement une décision :</p>
                {[
                  ["L'émotion plutôt que l'esthétique :","une photo prise sur le vif avec votre téléphone, sans filtre ni logo, arrête bien plus le regard parce qu'elle semble réelle et accessible."],
                  ["L'histoire plutôt que la fiche technique :","ce qui intéresse votre communauté, ce n'est pas la liste des ingrédients, c'est pourquoi vous l'avez testé, le problème précis qu'il a résolu chez vous, et votre soulagement ou excitation au résultat."],
                  ["L'enthousiasme brut plutôt que le texte parfait :","un message écrit avec vos propres mots, vos tics de langage et votre énergie a mille fois plus d'impact qu'un paragraphe impersonnel pondu par une IA."],
                ].map(([lead,texte])=>(
                  <div key={lead} style={{background:C.creme,borderRadius:9,padding:".7rem .8rem",marginBottom:".55rem"}}>
                    <strong style={{color:C.brun}}>{lead}</strong> {texte}
                  </div>
                ))}
                <p style={{margin:"0.8rem 0 .8rem"}}>Dans cette vidéo, je vous explique en détail comment délaisser ces montages chronophages pour revenir à l'essentiel : le partage sincère d'une expérience vécue.</p>
                <p style={{margin:"0 0 .8rem"}}>Prenez le temps de l'écouter avant de planifier vos prochains posts.</p>
                <p style={{margin:0}}>Vous allez gagner du temps et, surtout, recréer un vrai lien avec les personnes qui vous suivent.</p>
              </div>
              <a href="https://youtu.be/WB_TQBdtpIU" target="_blank" rel="noopener noreferrer" style={{display:"inline-block",marginTop:".9rem",fontSize:".74rem",fontWeight:700,color:C.rose}}>▶ Voir sur YouTube</a>
            </Card>

            <Card title="Formations vidéo Contenu" sub="YouTube · Les bases à connaître" icon="▶" color={C.lilas} defaultOpen>
              <YTBtn href="https://youtu.be/76SKVl4lHsw" label="📸 Comment se prendre en photo pour se mettre en valeur"/>
              <YTBtn href="https://youtu.be/j5EUiKmUSgM" label="👤 Le Personal Branding — Construire ton image"/>
              <YTBtn href="https://youtu.be/WxJFBnigjpw" label="🤝 Humaniser son contenu — Pourquoi et comment"/>
              <YTBtn href="https://youtu.be/dgylHebkai4" label="📖 Le Storytelling — Raconter pour vendre"/>
              <YTBtn href="https://youtu.be/JCgNdVywUME" label="📱 Comprendre les réseaux sociaux"/>
              <YTBtn href="https://youtu.be/6g0k-ET_lW8" label="🎯 Définir sa cible — Vente et recrutement"/>
            </Card>

            <Card title="Mixer ses publications" sub="La règle du mix pour ne pas lasser" icon="🔄" color={C.rose}>
              <Info>La règle de base : sur 10 publications, <strong>4 produits · 3 vie perso/storytelling · 2 opportunité · 1 divertissement/interaction</strong>. Ne jamais être mono-thème.</Info>
              {[
                ["💄","Contenu Produit (40%)","Démo, avant/après, routine, astuce d'utilisation, témoignage cliente, résultat concret. Toujours avec un CTA (mot-clé en commentaire, DM, lien)."],
                ["🌸","Storytelling & Vie perso (30%)","Ton histoire, tes doutes, tes victoires, ta famille, tes valeurs. Ce que les gens ne voient pas. L'authenticité crée la confiance."],
                ["🔥","Opportunité (20%)","Partager l'activité de manière détournée : liberté, moments de vie, résultats flous, témoignages d'équipe. Jamais de pitch direct en publication."],
                ["😄","Divertissement & Interaction (10%)","Sondage, quiz, question ouverte, contenu léger et fun. Ce qui fait réagir sans demander d'effort."],
              ].map(([icon,title,desc])=>(
                <div key={title} style={{display:"flex",gap:".6rem",marginBottom:".6rem",alignItems:"flex-start",background:C.creme,borderRadius:9,padding:".65rem"}}>
                  <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
                  <div><div style={{fontSize:".78rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".71rem",color:C.gris,lineHeight:1.55}}>{desc}</div></div>
                </div>
              ))}
            </Card>

            <Card title="Idées de hooks par thème" sub="10 hooks par sujet — pour accrocher dès la 1ʳᵉ ligne" icon="🪝" color={C.or}>
              <Info color={C.or}>Un hook c'est ta 1ʳᵉ phrase — celle qui donne envie de lire la suite. Sans bon hook, même le meilleur contenu ne sera pas lu.</Info>
              {[
                ["💄 Make-up",[
                  "On m'a demandé combien ça m'avait coûté... ils ont pas cru la réponse 😂",
                  "Tu veux le même résultat sans y passer 1h ?",
                  "Le makeup qui tient 12h même avec un masque — oui ça existe.",
                  "3 produits. 5 minutes. Un résultat qui change tout.",
                  "J'ai arrêté le fond de teint hors de prix. Voilà ce que j'utilise maintenant.",
                  "Le mascara dont tout le monde me demande le nom.",
                  "Mes lèvres tiennent toute la journée sans retouche — secret ?",
                  "Je maquille mes clientes depuis X ans. Le produit que je recommande à TOUTES.",
                  "Makeup naturel en moins de 5 min pour les mamans pressées.",
                  "Elle pensait que ça coûtait 80€. En vrai c'est moins de 20€ 😏",
                ]],
                ["🌿 Skincare",[
                  "La vérité sur le skincare hors de prix que personne ne te dit.",
                  "J'ai testé ça pendant 30 jours. Ce que j'ai découvert m'a surprise.",
                  "Peau terne, boutons, imperfections — j'avais tout ça. Voilà ce qui a tout changé.",
                  "Routine visage complète à moins de 25€. Simple, efficace, sans gadget.",
                  "Mon dermato m'a demandé ce que j'utilisais. Il a été étonné.",
                  "Le serum que j'utilise depuis X semaines — mes rides ont l'air de disparaître.",
                  "Non, ce n'est pas un filtre. C'est juste ma routine soin.",
                  "J'ai 47 ans. On me donne 35. Mes 3 produits secrets.",
                  "Tu penses que les bons soins sont forcément chers. Voilà pourquoi tu as tort.",
                  "Peau sèche, déshydratée, qui tire ? J'ai trouvé LA solution à 18€.",
                ]],
                ["💆 Bien-être & Énergie",[
                  "Je me levais fatiguée chaque matin malgré 8h de sommeil. Puis j'ai changé UN truc.",
                  "Non, ce n'est pas du café. Et non, ce n'est pas de l'eau.",
                  "Tu ne devrais pas avoir à souffrir de ton corps chaque jour.",
                  "Mon ventre plat n'est pas dû à une diète. C'est ça mon secret.",
                  "Fatigue chronique, digestion difficile, ventre gonflé — ce que personne ne t'a dit.",
                  "J'ai perdu X kilos sans régime. Voilà ce qui a changé.",
                  "La routine bien-être que j'aurais aimé commencer 10 ans plus tôt.",
                  "3 compléments. Pas 12. Juste 3. Et ça a tout changé.",
                  "Mon énergie avant VS après. La différence est hallucinante.",
                  "Pour celles qui veulent se sentir mieux sans se ruiner ni se priver.",
                ]],
                ["💇 Cheveux",[
                  "Tes cheveux font la tête ? Secs, ternes, cassants — ça s'explique.",
                  "J'ai arrêté de dépenser 80€ chez le coiffeur. Voilà ce que je fais maintenant.",
                  "Ma routine capillaire à 25€ qui donne des cheveux de rêve.",
                  "Ce produit a sauvé mes cheveux après la grossesse.",
                  "Brillance, douceur, volume — sans alourdir. Le secret ?",
                  "On m'a demandé ce que j'utilisais dans les cheveux. Encore et encore.",
                  "Cheveux abîmés par la coloration ? Ce soin a tout réparé.",
                  "Ma coiffeuse voulait savoir ce que j'avais changé. Voilà la réponse.",
                  "Pour celles qui ont abandonné l'idée d'avoir de beaux cheveux.",
                  "En 2 semaines, la différence était visible. Sans aller chez le coiffeur.",
                ]],
                ["🌸 Parfums",[
                  "Petit jeu : devinez le prix de mon parfum. Réponse en commentaire 😏",
                  "On me fait des compliments sur mon parfum depuis 3 semaines. Il coûte 18€.",
                  "J'ai arrêté de me ruiner en parfum. Voilà pourquoi.",
                  "Mon parfum du quotidien à moins de 20€ — et il tient toute la journée.",
                  "\"C'est quoi ton parfum ?\" La question qu'on m'a posée encore aujourd'hui.",
                  "Qualité grande marque, prix accessible. Ça existe pour les parfums aussi.",
                  "J'utilise ça depuis X mois et je ne retournerai jamais en arrière.",
                  "Pour les amoureux des beaux parfums avec un petit budget.",
                  "Ils ont cru que ça coûtait au moins 80€. Plot twist ❌",
                  "Le parfum dont je suis accro depuis que je l'ai découvert.",
                ]],
                ["💰 Opportunité & Liberté",[
                  "Je ne cherchais pas un 2ème emploi. Je cherchais quelque chose qui s'adapte à ma vie.",
                  "Mardi 15h. Je récupère mon enfant à l'école. Pas de congés posés.",
                  "Il y a 6 mois je ne savais pas quoi faire. Aujourd'hui voilà où j'en suis.",
                  "On m'a demandé si c'était une arnaque. Voilà ma réponse honnête.",
                  "Ce que j'aurais aimé que quelqu'un me dise avant de commencer.",
                  "Je ne vends pas du rêve. Je partage ce qui marche vraiment pour moi.",
                  "La liberté financière ce n'est pas pour les autres. C'est pour toi aussi.",
                  "Ce mois-ci j'ai gagné [montant] en travaillant depuis mon canapé.",
                  "5 femmes dans mon équipe ont changé de vie cette année. Comment ?",
                  "La vraie question ce n'est pas \"est-ce que ça marche ?\" C'est \"est-ce que tu vas essayer ?\"",
                ]],
                ["🔑 Recrutement détourné",[
                  "Tu cherches un complément de revenu sans sacrifier ta famille ?",
                  "3 choses que j'aurais voulu savoir avant de commencer.",
                  "Ce que personne ne montre vraiment sur les réseaux dans ce business.",
                  "J'ai refusé 3 fois avant d'accepter. Voilà pourquoi j'ai eu tort.",
                  "Le business qu'on m'a présenté et que j'ai failli ignorer.",
                  "Pour les mamans qui veulent travailler sans tout sacrifier.",
                  "Travailler de chez soi c'est possible. Pas facile. Mais possible.",
                  "Mon équipe cherche 3 femmes sérieuses. Pas des milliers. Juste 3.",
                  "Ce n'est pas pour tout le monde. Mais peut-être que c'est pour toi.",
                  "Avant de juger, lis jusqu'au bout. Tu pourrais être surpris(e).",
                ]],
              ].map(([theme,hooks])=>(
                <div key={theme} style={{marginBottom:".85rem"}}>
                  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",padding:".22rem .6rem",background:C.or+"20",color:C.brun2,borderRadius:20,display:"inline-block",marginBottom:".5rem"}}>{theme}</div>
                  {hooks.map((hook,i)=>(
                    <div key={i} style={{display:"flex",gap:".5rem",background:C.creme,borderRadius:8,padding:".45rem .65rem",marginBottom:".28rem",alignItems:"flex-start"}}>
                      <span style={{fontSize:".65rem",color:C.gris,flexShrink:0,marginTop:".1rem"}}>🪝</span>
                      <div style={{fontSize:".73rem",color:C.texte,lineHeight:1.5,flex:1,fontStyle:"italic"}}>{hook}</div>
                      <CopyBtn text={hook}/>
                    </div>
                  ))}
                </div>
              ))}
            </Card>

            {adminPosts.length>0&&(
              <Card title="✨ Idées ajoutées par Melissa" sub={`${adminPosts.length} nouvelle${adminPosts.length>1?"s":""} idée${adminPosts.length>1?"s":""}`} icon="🌟" color={C.or} defaultOpen>
                {adminPosts.map(theme=>(
                  <div key={theme.theme} style={{marginBottom:"1rem"}}>
                    <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",padding:".25rem .6rem",background:(theme.color||C.or)+"20",color:theme.color===C.or?C.brun2:(theme.color||C.brun2),borderRadius:20,display:"inline-block",marginBottom:".5rem"}}>{theme.theme}</div>
                    {theme.posts.map(post=>(
                      <div key={post.id} style={{background:posts[post.id]?C.pale+"80":C.creme,borderRadius:9,padding:".65rem .8rem",marginBottom:".35rem",border:`1px solid ${posts[post.id]?C.rose:C.pale}`,transition:"all .2s"}}>
                        <div style={{display:"flex",gap:".55rem",alignItems:"flex-start",marginBottom:posts[post.id]?0:".35rem"}}>
                          <div onClick={()=>tog("posts",post.id)} style={{width:18,height:18,borderRadius:4,border:`2px solid ${posts[post.id]?C.rose:C.pale}`,background:posts[post.id]?C.rose:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",transition:"all .15s"}}>
                            {posts[post.id]&&<span style={{fontSize:".55rem",color:"white",fontWeight:700}}>✓</span>}
                          </div>
                          <div style={{fontSize:".76rem",fontWeight:600,color:posts[post.id]?C.gris:C.brun,textDecoration:posts[post.id]?"line-through":"none",flex:1}}>{post.hook}</div>
                          <CopyBtn text={post.hook+"\n\n"+post.caption}/>
                        </div>
                        {!posts[post.id]&&<div style={{fontSize:".71rem",color:C.gris,lineHeight:1.55,marginLeft:"1.45rem"}}>{post.caption}</div>}
                      </div>
                    ))}
                  </div>
                ))}
              </Card>
            )}

            <Card title="Tableau d'idées de posts à cocher" sub={`${donePosts}/${allPosts.length} posts utilisés`} icon="📋" color={C.rose}>
              <Info>Coche les posts que tu as déjà utilisés pour suivre ta diversité de contenu. Adapte toujours à ta voix et à ton vécu.</Info>
              <div style={{marginBottom:".35rem",display:"flex",gap:".5rem",flexWrap:"wrap"}}>
                <span style={{fontSize:".62rem",color:C.gris}}>{donePosts} utilisés · {allPosts.length-donePosts} restants</span>
              </div>
              {POST_IDEAS.map(theme=>(
                <div key={theme.theme} style={{marginBottom:"1rem"}}>
                  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",padding:".25rem .6rem",background:theme.color+"20",color:theme.color===C.or?C.brun2:theme.color,borderRadius:20,display:"inline-block",marginBottom:".5rem"}}>{theme.theme}</div>
                  {theme.posts.map(post=>(
                    <div key={post.id} style={{background:posts[post.id]?C.pale+"80":C.creme,borderRadius:9,padding:".65rem .8rem",marginBottom:".35rem",border:`1px solid ${posts[post.id]?C.rose:C.pale}`,transition:"all .2s"}}>
                      <div style={{display:"flex",gap:".55rem",alignItems:"flex-start",marginBottom:posts[post.id]?0:".35rem"}}>
                        <div onClick={()=>tog("posts",post.id)} style={{width:18,height:18,borderRadius:4,border:`2px solid ${posts[post.id]?C.rose:C.pale}`,background:posts[post.id]?C.rose:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",transition:"all .15s"}}>
                          {posts[post.id]&&<span style={{fontSize:".55rem",color:"white",fontWeight:700}}>✓</span>}
                        </div>
                        <div style={{fontSize:".76rem",fontWeight:600,color:posts[post.id]?C.gris:C.brun,textDecoration:posts[post.id]?"line-through":"none",flex:1}}>{post.hook}</div>
                        <CopyBtn text={post.hook+"\n\n"+post.caption}/>
                      </div>
                      {!posts[post.id]&&<div style={{fontSize:".71rem",color:C.gris,lineHeight:1.55,marginLeft:"1.45rem"}}>{post.caption}</div>}
                    </div>
                  ))}
                </div>
              ))}
            </Card>

            <Card title="Ressources supplémentaires" sub="Documents stratégie contenu" icon="📄" color={C.lilas}>
              <Card title="💡 Idées de publications" sub={"Le hook \"moins de 25€\" — accessible et efficace"} icon="💡" color={C.or}>
                <p style={{fontSize:".72rem",color:C.gris,marginBottom:".8rem",lineHeight:1.6}}>Publications courtes avec un mot-clé à commenter — génère de l'engagement et ouvre la conversation en DM.</p>
                {[
                  {texte:"💭 On parle souvent de skincare hors de prix… Perso, j'ai une routine visage SIMPLE, efficace et à moins de 25€. Rien de compliqué. Rien de gadget. Juste ce qu'il faut pour une peau propre, nette et confortable.",cta:"Tu veux la liste exacte des produits que j'utilise ? Dis-le moi en commentaire 👇"},
                  {texte:"On m'a encore demandé aujourd'hui : \"C'est quoi ton parfum ?\" Plot twist 👉 moins de 20€ et on me fait des compliments NON-STOP.",cta:"Tu veux savoir lequel c'est ? Écris PARFUM en commentaire et je t'explique."},
                  {texte:"Makeup du jour : rapide ✔ naturel ✔ pas besoin de 15 produits ✔ J'utilise une mini routine makeup que je recommande souvent aux mamans pressées.",cta:"Tu veux la liste des produits exacts ? Commente MAKEUP 💄"},
                  {texte:"Non, je ne prends pas 12 compléments par jour. J'ai une routine ultra simple pour l'énergie ✨, le bien-être ✨, me sentir mieux au quotidien ✨",cta:"Tu veux savoir ce que je prends exactement ? Écris ROUTINE en commentaire."},
                  {texte:"Prendre soin de soi ≠ se ruiner. J'ai construit une routine complète (soin + bien-être) 💸 accessible 🕒 rapide",cta:"Tu veux la liste détaillée ? Dis MOI 👇"},
                  {texte:"On pense souvent que pour que ça marche, il faut que ce soit cher. Faux. J'utilise des produits beaucoup plus accessibles et les résultats sont là.",cta:"Tu veux voir ce que j'utilise vraiment ? Écris LISTE en commentaire."},
                  {texte:"Petit jeu 😏 On me fait tester mon parfum et on me donne un prix estimé. Résultat : \"au moins 80€ non ?\" Spoiler : ❌",cta:"Tu veux savoir lequel c'est ? Commente DEVINE 👇"},
                  {texte:"⏰ 5 minutes. C'est le temps que je mets pour ma routine (vraiment). Skincare + touche de makeup + parfum.",cta:"Tu veux ma routine express et les produits exacts ? Écris 5MIN 💕"},
                  {texte:"Je partage rarement mes routines en public… Parce que tout le monde pense que c'est compliqué ou cher. Spoiler : ni l'un ni l'autre.",cta:"Tu veux que je t'envoie la liste complète en privé ? Laisse un ❤️ ou écris-moi."},
                  {texte:"Toi aussi tu adores les rouges à lèvres pigmentés qui tiennent longtemps ?",cta:"Tape PÉPITES, je te réserve une belle surprise ❤️❤️"},
                  {texte:"Tes cheveux font la tête en ce moment ? Secs, cassants ou carrément ternes ? 😰 Et si avec seulement 25€, tu pouvais leur redonner vie et brillance comme en sortant de chez le coiffeur ? ✨ J'ai débusqué LE soin pépite qui répare sans alourdir.",cta:"Qui veut le nom de ce sauveur à 25€ ? Commente CHEVEUX 👇"},
                  {texte:"Tes cheveux font la tête ? 😩 Secs, ternes, cassants… et pourtant tu fais \"tout bien\". Le problème, ce n'est pas toi — c'est juste qu'ils n'ont pas la bonne routine. La même personne, les mêmes cheveux : la seule différence, une routine adaptée à 25€. Résultat : plus de brillance ✔️, plus de douceur ✔️, des cheveux qui revivent ✔️",cta:"Tu veux la routine ? Écris CHEVEUX en commentaire, ou clique sur le lien 🔗"},
                ].map((p,i)=>(
                  <div key={i} style={{background:C.creme,borderRadius:10,padding:".7rem .85rem",marginBottom:".55rem"}}>
                    <div style={{fontSize:".74rem",color:C.texte,lineHeight:1.6,marginBottom:".35rem"}}>{p.texte}</div>
                    <div style={{fontSize:".72rem",color:C.or,fontWeight:700,lineHeight:1.5}}>{p.cta}</div>
                  </div>
                ))}
                <div style={{background:C.or+"15",borderRadius:8,padding:".6rem .8rem",fontSize:".71rem",color:C.brun,lineHeight:1.6,marginTop:".3rem"}}>
                  💡 Tu peux aussi proposer un petit choix : "Tu préfères Makeup 💄, Parfum 🌸, ou Bien-être/énergie 💊 ?" — réponds en commentaire, j'enverrai la routine adaptée 😉
                </div>
              </Card>
              <YTBtn href="https://youtu.be/1m37A50VRN8" label="Formation Produit — Gestion perte de poids"/>
              <YTBtn href="https://youtu.be/r0MFA4bj1SY" label="Formation Produit — Ginkgo Biloba"/>
            </Card>
            <BoutonTermineFormation subTab="contenu"/>
          </div>
        )}

        {tab==="formation"&&formationSubTab==="communication"&&(
          <div>
            <SecTitle title="Communication" em="autour de Mihi" desc="Comment bien parler de Mihi, de la marque et de l'opportunité."/>
            <Card title="Formation Communication Mihi" sub="YouTube" icon="▶" color={C.or} defaultOpen>
              <YTBtn href="https://youtu.be/iSkh6iwI2uI" label="💬 Smart Cost, un concept a part entiere"/>
            </Card>
            <BoutonTermineFormation subTab="communication"/>
          </div>
        )}

        {tab==="formation"&&formationSubTab==="nutrition"&&(
          <div>
            <SecTitle title="Nutrition" em="Smart Meal" desc="Comprendre la nutrition et bien parler des produits Smart Meal."/>
            <Card title="Formation Nutrition Smart Meal" sub="YouTube" icon="▶" color={C.vert} defaultOpen>
              <YTBtn href="https://youtu.be/BUcRlG4XYok" label="🥗 Chapitre 1 — Comprendre réellement la nutrition"/>
              <YTBtn href="https://youtu.be/C7fXHxKO-ho" label="🍫 Chapitre 2 — Les barres énergétiques et protéinées"/>
            </Card>
            <BoutonTermineFormation subTab="nutrition"/>
          </div>
        )}

        {/* ── FORMATION BONUS ── */}
        {tab==="formation"&&formationSubTab==="bonus"&&(
          <div>
            <SecTitle title="Formation" em="BONUS" desc="Les formations bonus de l'équipe : à regarder, à revoir et à partager."/>
            <Card title={(afficherNewBonus?"🆕 ":"")+"Démaquiller & Masser — Le Rituel Visage"} sub={(afficherNewBonus?"Nouvelle formation · ":"")+"Vidéo + muscles du visage"} icon="🎁" color={C.rose} defaultOpen>
              {afficherNewBonus&&<span style={{display:"inline-block",background:"#E53935",color:"white",fontSize:".58rem",fontWeight:800,borderRadius:8,padding:".12rem .45rem",letterSpacing:".05em",marginBottom:".7rem"}}>🆕 NOUVEAU</span>}
              <div style={{position:"relative",paddingBottom:"56.25%",height:0,overflow:"hidden",borderRadius:12,marginBottom:".9rem",background:"#000"}}>
                <iframe src="https://www.youtube.com/embed/hkSv_nimbsc" title="Démaquiller & Masser — Le Rituel Visage"
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
              </div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:C.brun,lineHeight:1.35,marginBottom:".6rem"}}>Les muscles du visage</div>
              <div style={{fontSize:".8rem",color:C.texte,lineHeight:1.75}}>
                <ul style={{margin:"0 0 .9rem",paddingLeft:"1.1rem"}}>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>Le muscle frontal</strong> : élève les sourcils.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>Le corrugateur du sourcil et le procerus</strong> : participent aux expressions entre les sourcils, notamment la ride du lion.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>L'orbiculaire de l'œil</strong> : intervient dans la fermeture des paupières.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>Les zygomatiques majeur et mineur</strong> : participent au sourire et à l'élévation de la lèvre supérieure.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>Le buccinateur</strong> : contribue à la compression des joues.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>L'orbiculaire de la bouche</strong> : participe à la fermeture et à la projection des lèvres.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>Le mentonnier</strong> : participe aux mouvements de la lèvre inférieure et du menton.</li>
                  <li style={{marginBottom:".35rem"}}><strong style={{color:C.brun}}>Le platysma</strong> : muscle superficiel qui s'étend du bas du visage vers le cou.</li>
                </ul>
                <img src={(process.env.PUBLIC_URL||"")+"/muscles-visage.jpg"} alt="Infographie des muscles du visage, en français" loading="lazy"
                  onClick={()=>window.open((process.env.PUBLIC_URL||"")+"/muscles-visage.jpg","_blank")}
                  style={{display:"block",width:"100%",height:"auto",borderRadius:12,border:`1px solid ${C.pale}`,cursor:"zoom-in"}}/>
                <div style={{fontSize:".66rem",color:C.gris,textAlign:"center",marginTop:".35rem"}}>Touche l'image pour l'agrandir</div>
              </div>
              <a href="https://youtu.be/hkSv_nimbsc" target="_blank" rel="noopener noreferrer" style={{display:"inline-block",marginTop:".9rem",fontSize:".74rem",fontWeight:700,color:C.rose}}>▶ Voir sur YouTube</a>
            </Card>
            {(userId==="melissa-da-silveira"||userId==="melissa")&&(
              <div style={{background:C.creme,border:`1px dashed ${C.pale}`,borderRadius:10,padding:".6rem .8rem",marginTop:"1rem"}}>
                <div style={{fontSize:".68rem",color:C.gris,lineHeight:1.5,marginBottom:".45rem"}}>Visible uniquement par toi. Le « NOUVEAU » s'efface chez toi dès que tu ouvres cette formation : ce bouton te le fait revoir comme l'équipe.</div>
                <button onClick={async()=>{
                  try{
                    const ref=doc(db,"users",userId);
                    const snap=await getDoc(ref);
                    const brut=snap.exists()?snap.data()["db-formation-progress"]:null;
                    const progress=brut?JSON.parse(brut):{};
                    if(progress.bonus)delete progress.bonus.derniereConsultation;
                    await setDoc(ref,{"db-formation-progress":JSON.stringify(progress)},{merge:true});
                    try{localStorage.setItem(CLE_NEW_VUS,JSON.stringify(lireNewVus().filter(x=>x!==ID_NEW_BONUS)));}catch(e){}
                    alert("C'est fait ✅\n\nL'app va se recharger : tu verras la pastille rouge sur « Formation », le tag NOUVEAU sur « Formation BONUS », et le badge sur la carte de la vidéo.");
                    window.location.reload();
                  }catch(e){alert("Erreur : "+e.message);}
                }}
                  style={{width:"100%",background:C.blanc,color:C.brun,border:`1.5px solid ${C.rose}`,borderRadius:8,padding:".42rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                  👁 Voir la notification comme l'équipe
                </button>
              </div>
            )}
            <BoutonTermineFormation subTab="bonus"/>
          </div>
        )}

        {/* ── OUTILS ── */}
        {tab==="formation"&&formationSubTab==="devperso"&&(
          <div><DevPersoSection adminItems={adminItems}/><BoutonTermineFormation subTab="devperso"/></div>
        )}

        {tab==="formation"&&formationSubTab==="outils"&&(
          <div>
            <SecTitle title="Outils" em="indispensables" desc="Les bases de Canva, CapCut et Linktree — ce qu'il faut savoir et pas plus."/>
            <AdminContentBlock onglet="outils" items={adminItems}/>

            <Card title="Canva — Créer ses visuels" sub="Les bases pour des posts professionnels" icon="🎨" color={C.rose} defaultOpen>
              <Info>Canva c'est l'outil n°1 pour créer tes visuels sans être graphiste. Gratuit, sur mobile et desktop.</Info>
              <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>Les 5 choses à maîtriser</div>
              {[
                ["1","Les formats","Story = 1080x1920px · Post carré = 1080x1080px · Reel = 1080x1920px. Toujours commencer par choisir le bon format."],
                ["2","Les templates","Cherche \"Instagram story beauté\" ou \"post cosmétique\" dans la barre de recherche. Choisis un template, adapte les couleurs à ton branding (brun + rose + or pour Blazing Dynasty)."],
                ["3","Cohérence visuelle","Utilise toujours les mêmes 3 couleurs, les mêmes 2 polices, le même style de photos. Ton profil doit être reconnaissable au 1ᵉʳ coup d'œil."],
                ["4","Les éléments graphiques","Stickers, formes, lignes — utilise-les avec parcimonie. Moins c'est souvent plus. Un visuel épuré convertit mieux qu'un visuel surchargé."],
                ["5","Exporter et partager","Télécharge en PNG pour les images, MP4 pour les vidéos animées. Active \"Partager le lien\" pour collaborer avec ton équipe."],
              ].map(([n,title,desc])=>(
                <div key={n} style={{display:"flex",gap:".55rem",marginBottom:".55rem",alignItems:"flex-start"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:C.rose,color:"white",fontSize:".62rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{n}</div>
                  <div><div style={{fontSize:".77rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".71rem",color:C.gris,lineHeight:1.5}}>{desc}</div></div>
                </div>
              ))}
              <Btn href="https://www.canva.com" label="Ouvrir Canva" color={C.rose} icon="🎨"/>
            </Card>

            <Card title="CapCut — Monter ses vidéos" sub="Les bases pour des Reels et stories vidéo" icon="🎬" color={C.lilas}>
              <Info color={C.lilas}>CapCut c'est l'appli de montage vidéo la plus simple et la plus puissante pour créer des Reels. Gratuite sur mobile.</Info>
              {[
                ["1","Importer et couper","Importe ta vidéo, utilise l'outil \"Séparer\" pour couper les silences et les parties ratées. Garde les moments naturels — l'authenticité convertit."],
                ["2","Les sous-titres automatiques","Outils → Auto-sous-titres. CapCut génère automatiquement les sous-titres. Édite les erreurs. 85% des vidéos sont regardées sans le son."],
                ["3","La musique et les tendances","Bibliothèque → Sons tendances. Utilise une musique tendance pour augmenter ta portée. Vérifie qu'elle est autorisée pour Instagram/TikTok."],
                ["4","Les templates","Onglet \"Templates\" → cherche un format de Reel tendance. Tu remplaces juste les vidéos — le montage est déjà fait."],
                ["5","Exporter","Toujours exporter en 1080p. Désactive le filigrane CapCut si possible (ça nuit à la portée sur Instagram)."],
              ].map(([n,title,desc])=>(
                <div key={n} style={{display:"flex",gap:".55rem",marginBottom:".55rem",alignItems:"flex-start"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:C.lilas,color:"white",fontSize:".62rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{n}</div>
                  <div><div style={{fontSize:".77rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".71rem",color:C.gris,lineHeight:1.5}}>{desc}</div></div>
                </div>
              ))}
            </Card>

            <Card title="Linktree — Ton lien unique" sub="Un seul lien, toutes tes ressources" icon="🔗" color={C.or}>
              <Info color={C.or}>Linktree c'est la page qui réunit tous tes liens importants. Tu mets UN seul lien dans ta bio Instagram, et les gens y trouvent tout.</Info>
              {[
                ["1","Créer ton compte","Va sur linktree.com, inscris-toi gratuitement avec ton adresse email."],
                ["2","Ajouter tes liens","Clique \"+Ajouter lien\" pour chaque ressource : ta boutique Mihi, ton groupe Facebook, ton Telegram, ton WhatsApp, ton profil Instagram."],
                ["3","Les liens essentiels à mettre","Ma boutique Mihi · Rejoindre mon équipe · Me contacter sur WhatsApp · Mon Instagram · Mon groupe clientes."],
                ["4","Personnaliser l'apparence","Choisis un fond sombre (cohérent avec tes couleurs Blazing Dynasty). Mets ta photo de profil. Ajoute ton nom et une courte description."],
                ["5","Mettre à jour ta bio","Copie ton lien Linktree (ex: linktr.ee/tonprenom). Colle-le dans ta bio Instagram, Facebook et TikTok. Un seul lien pour tout."],
              ].map(([n,title,desc])=>(
                <div key={n} style={{display:"flex",gap:".55rem",marginBottom:".55rem",alignItems:"flex-start"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:C.or,color:C.brun,fontSize:".62rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{n}</div>
                  <div><div style={{fontSize:".77rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{title}</div><div style={{fontSize:".71rem",color:C.gris,lineHeight:1.5}}>{desc}</div></div>
                </div>
              ))}
              <Btn href="https://linktr.ee" label="Créer mon Linktree" color={C.or} icon="🔗"/>
            </Card>

            <Card title="Récap outils de l'équipe" sub="Document officiel Blazing Dynasty" icon="📋" color={C.brun}>
              <Btn href="https://us02web.zoom.us/rec/share/anRmIaRRrGoC8leMrqjeOBH9IsOShB81_A99igN4pwozGtqEQ1oQUIqBSy30wqCn.gPMJZbroGZWrf7Du" label="🎥 Présentation d'opportunités" color={C.brun2}/>
              <Btn href="https://t.me/+2wKWxIROE4c1M2Q0" label="📢 Telegram équipe — Visuels" color={"#0088CC"}/>
              <Btn href="https://t.me/+pv0RY_JJy4wyYzE8" label="💬 Telegram — Témoignages" color={"#0088CC"}/>
              <Btn href="https://www.facebook.com/share/g/1BGRQA1pZQ/?mibextid=wwXIfr" label="👥 Groupe Facebook équipe" color={"#1877F2"}/>
            </Card>

            <Card title="Immersion" sub="YouTube" icon="▶" color={C.lilas}>
              <YTBtn href="https://youtube.com/shorts/Ik-v2JTtJxU" label="🎬 Immersion"/>
            </Card>
            <BoutonTermineFormation subTab="outils"/>
          </div>
        )}

        {/* ── FORMATION PRODUITS ── */}
        {tab==="formation"&&formationSubTab==="formaproduits"&&(
          <div><FormationProduitsTab adminItems={adminItems}/><BoutonTermineFormation subTab="formaproduits"/></div>
        )}

        {/* ── SPRINT / ACCÉLÈRE ── */}
        {tab==="communication"&&communicationSousOnglet!=="analyse"&&communicationSousOnglet!=="stories"&&(
          <div onClick={()=>setCommunicationSousOnglet("analyse")} style={{background:"linear-gradient(135deg,"+C.rose+","+C.or+")",borderRadius:14,padding:".75rem 1rem",marginBottom:".9rem",display:"flex",alignItems:"center",gap:".7rem",cursor:"pointer",boxShadow:"0 4px 14px rgba(196,117,106,.3)"}}>
            <span style={{fontSize:"1.3rem"}}>📈</span>
            <span style={{flex:1,color:"white"}}><span style={{display:"block",fontSize:".58rem",fontWeight:700,letterSpacing:".14em",opacity:.9}}>✨ NOUVEAU</span><span style={{display:"block",fontFamily:"Georgia,serif",fontSize:".92rem",fontWeight:600}}>Analyse réseaux IA : ta community manager</span></span>
            <span style={{color:"white",fontWeight:700}}>→</span>
          </div>
        )}
        {tab==="communication"&&communicationSousOnglet==="analyse"&&<AnalyseReseauxTab uid={userId} userName={name} isChef={isChefApp}/>}
        {tab==="communication"&&communicationSousOnglet==="stories"&&<StoriesDefiTab uid={userId} jourLien={storiesJourLien} isChef={isChefApp}/>}
        {tab==="communication"&&communicationSousOnglet==="semainetheme"&&<SemaineThemeTab uid={userId}/>}
        {tab==="communication"&&communicationSousOnglet==="sprint"&&(
          <div>
            <SecTitle title="Prends" em="de la vitesse" desc="7 actions quotidiennes pour passer à l'action. Chaque jour compte — coche et avance."/>
            <div style={{background:C.brun,borderRadius:10,padding:".7rem 1rem",marginBottom:"1rem",fontSize:".74rem",color:C.pale,lineHeight:1.6}}>
              🚀 Chaque conversation déclenchée est une graine. Les graines d'aujourd'hui = les recrues de demain.
            </div>
            <div style={{marginBottom:"1rem"}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:".62rem",color:C.gris,marginBottom:".22rem"}}>
                <span>Progression sprint</span><span>{SPRINT.flatMap(d=>d.tasks).filter(t=>tasks[t.id]).length}/{allTask.length}</span>
              </div>
              <div style={{height:4,background:C.pale,borderRadius:10,overflow:"hidden"}}>
                <div style={{height:"100%",background:C.rose,width:(allTask.length?Math.round(SPRINT.flatMap(d=>d.tasks).filter(t=>tasks[t.id]).length/allTask.length*100):0)+"%",borderRadius:10,transition:"width .3s"}}/>
              </div>
            </div>
            {SPRINT.map(day=>{
              const isOpen=openDays[day.day];
              const dayDone=day.tasks.filter(t=>tasks[t.id]).length;
              const dayPct=Math.round(dayDone/day.tasks.length*100);
              const allDone=dayPct===100;
              const fc={rs:C.lilas,bao:C.or,mix:C.rose}[day.focus];
              const fl={rs:"Réseaux",bao:"Terrain",mix:"Mixte"}[day.focus];
              return(
                <div key={day.day} style={{background:C.blanc,border:`1px solid ${isOpen?C.rose:C.pale}`,borderRadius:14,marginBottom:".75rem",overflow:"hidden",transition:"all .2s"}}>
                  <div onClick={()=>setOpenDays(p=>({...p,[day.day]:!p[day.day]}))}
                    style={{padding:".82rem 1rem",display:"flex",alignItems:"center",gap:".6rem",cursor:"pointer",userSelect:"none"}}>
                    <div style={{width:34,height:34,borderRadius:"50%",background:allDone?C.vert:C.brun,color:allDone?"white":C.or,fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {allDone?"✓":day.day}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontFamily:"Georgia,serif",fontSize:".92rem",fontWeight:600,color:C.brun}}>{day.title}</div>
                      <div style={{fontSize:".6rem",color:C.gris}}>{day.goal}</div>
                    </div>
                    <span style={{background:fc+"22",color:fc===C.or?C.brun2:fc,fontSize:".55rem",fontWeight:700,textTransform:"uppercase",padding:".15rem .45rem",borderRadius:20,flexShrink:0}}>{fl}</span>
                    <div style={{color:C.rose,fontSize:".68rem",transform:isOpen?"rotate(180deg)":"none",transition:"transform .2s",flexShrink:0}}>▼</div>
                  </div>
                  {isOpen&&(
                    <div style={{borderTop:`1px solid ${C.pale}`}}>
                      <div style={{padding:".5rem 1rem .3rem"}}>
                        <div style={{display:"flex",justifyContent:"space-between",fontSize:".6rem",color:C.gris,marginBottom:".22rem"}}>
                          <span>{dayDone}/{day.tasks.length}</span><span>{dayPct}%</span>
                        </div>
                        <div style={{height:4,background:C.pale,borderRadius:10,overflow:"hidden"}}>
                          <div style={{height:"100%",background:C.rose,width:dayPct+"%",transition:"width .3s",borderRadius:10}}/>
                        </div>
                      </div>
                      <div style={{padding:".5rem 1rem .85rem"}}>
                        {day.tasks.map(task=>(
                          <div key={task.id}>
                            <div onClick={()=>tog("tasks",task.id)} style={{display:"flex",alignItems:"flex-start",gap:".55rem",padding:".45rem 0",borderBottom:`1px solid rgba(232,213,204,.3)`,cursor:"pointer"}}>
                              <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${C.rose}`,background:tasks[task.id]?C.rose:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center",transition:"all .15s"}}>
                                {tasks[task.id]&&<span style={{fontSize:".55rem",color:"white",fontWeight:700}}>✓</span>}
                              </div>
                              <div style={{fontSize:".76rem",color:tasks[task.id]?C.gris:C.texte,textDecoration:tasks[task.id]?"line-through":"none",lineHeight:1.45,flex:1}}>{task.label}</div>
                            </div>
                            {task.script&&(
                              <div style={{background:C.creme,borderLeft:`3px solid ${C.lilas}`,borderRadius:"0 8px 8px 0",padding:".5rem .75rem",fontSize:".72rem",fontStyle:"italic",color:C.texte,lineHeight:1.7,margin:".3rem 0 .4rem",display:"flex",gap:".5rem",alignItems:"flex-start"}}>
                                <span style={{flex:1}}>{task.script}</span>
                                <CopyBtn text={task.script}/>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:14,padding:"1.1rem"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,color:C.brun,marginBottom:".75rem"}}>📊 Mes chiffres</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:".75rem"}}>
                {[["k1","Messages envoyés"],["k2","Réponses reçues"],["k3","Présentations"],["k4","Nouvelles recrues"]].map(([k,l])=>(
                  <div key={k} style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem",textAlign:"center"}}>
                    <input type="number" min="0" value={kpis[k]||""} placeholder="0" onChange={e=>updKpi(k,e.target.value)}
                      style={{width:52,fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:600,color:C.brun,border:"none",background:"none",textAlign:"center",outline:"none"}}/>
                    <div style={{fontSize:".58rem",color:C.gris,marginTop:".12rem"}}>{l}</div>
                  </div>
                ))}
              </div>
              <textarea value={notes} onChange={e=>updNotes(e.target.value)} placeholder="Notes, blocages, questions..."
                style={{width:"100%",minHeight:80,border:`1px solid ${C.pale}`,borderRadius:8,padding:".6rem",fontFamily:"inherit",fontSize:".76rem",color:C.texte,background:C.creme,resize:"vertical",outline:"none",lineHeight:1.6}}/>
            </div>
          </div>
        )}

        {/* ── SUIVI RECRUES ── */}
        {tab==="suivi"&&<SuiviRecruTab uid={userId} isChef={isChefApp}/>}

        {/* ── TABLEAU DE BORD ── */}
        {tab==="dashboard"&&dashboardSousOnglet!=="reseaux"&&<DashboardTab uid={userId} dtab={dashboardSousOnglet==="quotidien"?"today":dashboardSousOnglet} setDtab={(d)=>setDashboardSousOnglet(d==="today"?"quotidien":d)} goToFormation={(sub)=>{setTab("formation");setFormationSubTab(sub);}} goToTab={(t)=>setTab(t)} fastStartDone={fastStartDone} onFastStartDone={setFastStartDone} hasFastStart={hasFastStart} onHasFastStart={setHasFastStart} isChef={isChefApp} onObjPersoChange={setHomeObjPerso} forceQuizJour={forceQuizJourApp} onCompteurChange={setNbNotifDashboard} nbDiagNonLus={nbDiagNonLus} onDiagNonLuChange={setNbDiagNonLus} onVoirDiagResultats={voirDiagResultats} nbCommandesNonVues={nbCommandesNonVues} onMarquerCommandesVues={marquerCommandesVues} ouvrirBusiness={ouvrirBusinessTrigger}/>}
        {tab==="communication"&&communicationSousOnglet==="scripts"&&<ScriptsTab/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="diagnostics"&&<DiagnosticsTab uid={userId} userName={name} onNonLuChange={setNbDiagNonLus} forceResultsView={diagResultsTrigger}/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="linkbio"&&<LinkBioTab uid={userId} userName={name}/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="boutique"&&<LinkBioTab uid={userId} userName={name} initialSection="boutique"/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="tunnel-recrutement"&&<TunnelRecrutementTab uid={userId} userName={name} db={db}/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="ebooks"&&<EbooksTab/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="liensimportants"&&<LiensImportantsTab uid={userId}/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="monunivers"&&<MonUniversTab uid={userId}/>}
        {tab==="boiteaoutils"&&outilsSousOnglet==="immersion"&&(
          <>
            <div style={{display:"flex",justifyContent:"flex-end",gap:".5rem",marginBottom:".5rem"}}><button onClick={()=>setStatsImmersionTrigger(t=>t+1)} style={{background:"#8B5E00",color:"white",border:"none",borderRadius:20,padding:".35rem 1rem",fontSize:".75rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",boxShadow:"0 2px 8px rgba(139,94,0,.4)"}}>{"\uD83D\uDCCA Statistiques"}</button><button onClick={()=>setShowDecouverteImmersion(true)} style={{background:"#C49A8A",color:"white",border:"none",borderRadius:20,padding:".35rem 1rem",fontSize:".75rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",boxShadow:"0 2px 8px rgba(196,154,138,.4)"}}>{"\uD83E\uDDED D\u00e9couverte"}</button></div>
            {showDecouverteImmersion&&<DecouverteTour outil="immersion" onClose={()=>setShowDecouverteImmersion(false)}/>}
            <ImmersionConfigTab uid={userId} db={db} isChef={name.toLowerCase().startsWith("melissa")} statsTrigger={statsImmersionTrigger} userName={name&&name.split(" ")[0]}/>
          </>
        )}
        {tab==="boiteaoutils"&&outilsSousOnglet==="audit"&&(
          <div>
            <div style={{display:"flex",gap:".4rem",marginBottom:"1rem"}}>
              <button onClick={()=>setAuditVue("remplir")} style={{flex:1,padding:".5rem",fontSize:".72rem",fontWeight:600,borderRadius:10,border:`1px solid ${auditVue==="remplir"?C.rose:C.pale}`,background:auditVue==="remplir"?C.rose:C.blanc,color:auditVue==="remplir"?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit"}}>Remplir</button>
              <button onClick={()=>setAuditVue("resultats")} style={{flex:1,padding:".5rem",fontSize:".72rem",fontWeight:600,borderRadius:10,border:`1px solid ${auditVue==="resultats"?C.rose:C.pale}`,background:auditVue==="resultats"?C.rose:C.blanc,color:auditVue==="resultats"?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit"}}>Resultats</button>
            </div>
            {auditVue==="remplir"&&<DiagnosticsTab uid={userId} userName={name} initialType="reseauxsociaux2"/>}
            {auditVue==="resultats"&&<AuditResultatsTab uid={userId} prenom={name&&name.split(" ")[0]}/>}
          </div>
        )}
        {tab==="challenge"&&(<div><DefisTab uid={userId} userName={name} canCreate={true} isChef={isChefApp}/><div style={{marginTop:"1rem"}}><PowerHourTab uid={userId} userName={name} canCreate={isChefApp}/></div></div>)}
        {tab==="classement"&&<ClassementEquipe uid={userId}/>}
        {tab==="communaute"&&<CommunauteTab uid={userId} userName={name} isChef={isChefApp} ouvrirChallenges={ouvrirChallengesTrigger}/>}
        {tab==="carte"&&<CarteEquipe uid={userId} userName={name}/>}
        {tab==="dashboard"&&dashboardSousOnglet==="reseaux"&&<SuiviReseauxTab uid={userId}/>}
        
        {tab==="communication"&&communicationSousOnglet==="editorial"&&<EditorialTab uid={userId} userName={name}/>}
        {tab==="espacechef"&&(isChefApp||hasTeamApp)&&<EspaceChefTab uid={userId} isChef={isChefApp}/>}
        {tab==="formation"&&formationSubTab==="formationapp"&&<FormationAppTab adminItems={adminItems}/>}
        {tab==="objectifs"&&<ObjectifsTab uid={userId} userName={name} isMelissa={name.toLowerCase().startsWith("melissa")}/>}
        {tab==="calendrier"&&<CalendrierTab uid={userId} userName={name} isMelissa={name.toLowerCase().startsWith("melissa")} isChef={isChefApp}/>}

        {/* Bouton mise à jour */}
        <div style={{padding:"1.5rem 0 .5rem",textAlign:"center"}}>
          <BoutonMiseAJour/>
          <div style={{fontSize:".58rem",color:C.pale,marginTop:".3rem"}}>v{APP_VERSION}</div>
        </div>

      </div>

      {/* WATERMARK invisible — prénom de la personne connectée */}
      <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",zIndex:9999,overflow:"hidden",opacity:.03}}>
        {Array.from({length:20}).map((_,i)=>(
          <div key={i} style={{position:"absolute",top:`${(i*11)%100}%`,left:`${(i*17)%100}%`,fontSize:"1.2rem",fontWeight:700,color:C.brun,transform:"rotate(-30deg)",whiteSpace:"nowrap",letterSpacing:".15em"}}>
            {name.toUpperCase()} · BLAZING DYNASTY
          </div>
        ))}
      </div>

      <div style={{textAlign:"center",padding:"1.1rem",fontSize:".6rem",color:C.gris,borderTop:`1px solid ${C.pale}`}}>
        <strong style={{color:C.rose}}>Blazing Dynasty</strong> · Espace Formation Privé
      </div>

      {/* ── BOUTON FLOTTANT OBJECTIFS ── */}
      <button onClick={()=>setShowObjectifs(p=>!p)}
        style={{position:"fixed",bottom:"5rem",right:"1.2rem",width:56,height:56,borderRadius:"50%",background:C.brun,border:`2px solid ${C.or}`,boxShadow:"0 4px 20px rgba(61,31,14,.4)",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,transition:"all .2s",padding:0,overflow:"hidden"}}>
        {showObjectifs
          ? <span style={{fontSize:"1rem",color:C.or,fontWeight:700}}>✕</span>
          : <span style={{fontSize:"1.4rem"}}>👑</span>
        }
      </button>

      <style>{`
        @keyframes neonPulseInfos {
          0%,100% { box-shadow: 0 4px 20px rgba(61,31,14,.4), 0 0 8px 2px ${C.or}, 0 0 16px 4px ${C.or}80; }
          50% { box-shadow: 0 4px 20px rgba(61,31,14,.4), 0 0 16px 6px ${C.or}, 0 0 28px 10px ${C.or}90; }
        }
      `}</style>
      {/* ── BOUTON FLOTTANT INFOS IMPORTANTES ── */}
      <button onClick={()=>{setShowInfosImportantes(p=>!p);setGlowInfos(false);}}
        style={{position:"fixed",bottom:"5rem",left:"1.2rem",width:56,height:56,borderRadius:"50%",background:C.brun,border:`2px solid ${C.or}`,boxShadow:"0 4px 20px rgba(61,31,14,.4)",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,transition:"all .2s",padding:0,overflow:"hidden",animation:(glowInfos&&!showInfosImportantes)?"neonPulseInfos 1.4s ease-in-out infinite":"none"}}>
        {showInfosImportantes
          ? <span style={{fontSize:"1rem",color:C.or,fontWeight:700}}>✕</span>
          : <span style={{fontSize:"1.4rem"}}>📌</span>
        }
      </button>
      {showInfosImportantes&&(
        <InfosImportantesPanel
          uid={userId}
          nomAffiche={name}
          isMelissa={userId==="melissa-da-silveira"}
          onModifierAnnonce={()=>setShowAnnonceAdminFlottant(true)}
          onClose={()=>setShowInfosImportantes(false)}
        />
      )}
      {showAnnonceAdminFlottant&&<AnnonceAdminPopup uid={userId} onClose={()=>setShowAnnonceAdminFlottant(false)}/>}

      {/* ── BANNIÈRE FLOTTANTE RÉSULTAT TIRAGE AU SORT ── */}
      {tirageAVoir&&(
        <div onClick={()=>setShowTirageBanniere(true)}
          style={{position:"fixed",top:"1rem",left:"50%",transform:"translateX(-50%)",zIndex:9500,background:"linear-gradient(135deg,#E8B84B,#C4922A)",borderRadius:16,padding:".8rem 1.3rem",boxShadow:"0 6px 24px rgba(196,146,42,.5)",cursor:"pointer",display:"flex",alignItems:"center",gap:".5rem",animation:"neonPulseInfos 1.1s ease-in-out infinite",maxWidth:"90vw"}}>
          <span style={{fontSize:"1.3rem"}}>🎉</span>
          <span style={{fontFamily:"Georgia,serif",fontWeight:700,color:"#3D1F0E",fontSize:".85rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>Le résultat du challenge est sorti !!</span>
        </div>
      )}
      {showTirageBanniere&&tirageAVoir&&(
        <TirageAuSortModal
          challenge={tirageAVoir.challenge}
          grille={[]}
          parPersonne={{}}
          resultatExistant={tirageAVoir.challenge.tirage}
          isMelissa={false}
          onClose={()=>{
            setShowTirageBanniere(false);
            try{
              const vus=JSON.parse(localStorage.getItem("bd-tirages-vus")||"[]");
              if(!vus.includes(tirageAVoir.id)){
                vus.push(tirageAVoir.id);
                localStorage.setItem("bd-tirages-vus",JSON.stringify(vus));
              }
            }catch{}
            setTirageAVoir(null);
            checkTirages();
          }}
          onTirageTermine={()=>{}}
        />
      )}

      {/* ── POPUP BIENVENUE ── */}
      {showWelcome&&(
        <WelcomePopup userName={name} onClose={()=>{
          setShowWelcome(false);
          setTab("formation");
          setFormationSubTab("faststart");
        }}/>
      )}
      {showNewChallenge&&newChallengeData&&(
        <NouveauChallengePopup challenge={newChallengeData} onClose={async()=>{
          setShowNewChallenge(false);
          try{
            const uRef=doc(db,"users",userId);
            const uSnap=await getDoc(uRef);
            const vusActuels=uSnap.exists()?(uSnap.data()["db-challenges-vus"]||[]):[];
            await setDoc(uRef,{"db-challenges-vus":[...vusActuels,newChallengeData.id]},{merge:true});
          }catch{}
        }}/>
      )}
      {showPowerHourStart&&powerHourInfo&&(
        <PowerHourStartPopup session={powerHourInfo} onClose={()=>setShowPowerHourStart(false)}/>
      )}
      {showPowerHourEnd&&powerHourInfo&&(
        <PowerHourEndPopup session={powerHourInfo} onClose={()=>setShowPowerHourEnd(false)}/>
      )}
      {showAnnonce&&annonceData&&(
        <AnnonceRecuePopup annonce={annonceData} onClose={()=>setShowAnnonce(false)}/>
      )}

      {/* ── POPUP CHALLENGE APP ── */}
      {showChallengeApp&&userId&&(
        <ChallengeAppPopup
          uid={userId}
          onClose={()=>setShowChallengeApp(false)}
          setTab={setTab}
        />
      )}

            {/* ── POPUP RAPPEL BACKUP ── */}
      {showBackupReminder&&(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:9999,background:"rgba(61,31,14,.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}>
          <div style={{background:"white",borderRadius:20,maxWidth:380,width:"100%",overflow:"hidden"}}>
            <div style={{background:"#3A6A4A",padding:"1.5rem 1.3rem",textAlign:"center"}}>
              <div style={{fontSize:"2.5rem",marginBottom:".5rem"}}>💾</div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",color:"white",fontWeight:300}}>Petit rappel backup</div>
              <div style={{fontSize:".75rem",color:"#C8E0CC",marginTop:".25rem"}}>Ca fait plus de 3 jours, pense a sauvegarder !</div>
            </div>
            <div style={{padding:"1.25rem 1.3rem"}}>
              <div style={{background:"#F0F7F2",borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",fontSize:".78rem",color:"#3D2B1F",lineHeight:1.7}}>
                Pour eviter de perdre tes donnees (clientes, CA, prospects...), telecharge un backup regulierement. Ca prend 2 secondes !
              </div>
              <button onClick={async()=>{
                try{
                  const snap=await getDoc(doc(db,"users",userId));
                  const data=snap.exists()?snap.data():{};
                  const json=JSON.stringify(data,null,2);
                  const blob=new Blob([json],{type:"application/json"});
                  const url=URL.createObjectURL(blob);
                  const a=document.createElement("a");
                  a.href=url;a.download="backup-blazing-"+new Date().toISOString().slice(0,10)+".json";
                  document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
                  await setDoc(doc(db,"users",userId),{"db-last-backup":new Date().toISOString()},{merge:true});
                }catch(e){alert("Erreur: "+e);}
                setShowBackupReminder(false);
              }} style={{width:"100%",background:"#3A6A4A",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
                Telecharger mon backup maintenant
              </button>
              <button onClick={()=>setShowBackupReminder(false)} style={{width:"100%",background:"none",border:"none",color:"#888",fontSize:".72rem",fontFamily:"inherit",cursor:"pointer",padding:".4rem"}}>
                Me le rappeler plus tard
              </button>
            </div>
          </div>
        </div>
      )}
{/* ── POPUP OBJECTIFS ── */}
      {showObjectifs&&(
        <div style={{position:"fixed",bottom:"8rem",right:"1.2rem",width:285,background:C.blanc,borderRadius:16,boxShadow:"0 8px 32px rgba(61,31,14,.25)",border:`1px solid ${C.pale}`,zIndex:199,overflow:"hidden"}}>
          <div style={{background:C.brun,padding:".85rem 1rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",gap:".6rem",alignItems:"center"}}>
              <span style={{fontSize:"1.4rem"}}>👑</span>
              <div>
                <div style={{fontSize:".55rem",fontWeight:700,letterSpacing:".15em",color:C.or}}>✦ OBJECTIFS ÉQUIPE</div>
                <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",color:C.blanc,fontWeight:300}}>Ce mois-ci</div>
              </div>
            </div>
          </div>
          <ObjectifsPopup uid={userId} setTab={setTab} onClose={()=>setShowObjectifs(false)} isMelissa={name.toLowerCase().startsWith("melissa")}/>
        </div>
      )}
    </div>
    </LangContext.Provider>
  );
}

// ── HOME RECAP (page d'accueil) ──────────────────────────────────────────────

export function HistoriquePeriodes({uid}){
  const [suiviCA,setSuiviCA]=useState({});
  const [loading,setLoading]=useState(true);
  const [ouvert,setOuvert]=useState(null);
  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,'users',uid));
        if(snap.exists()&&snap.data()['db-suivi-ca']) setSuiviCA(JSON.parse(snap.data()['db-suivi-ca']));
      }catch{}
      setLoading(false);
    })();
  },[uid]);
  const caMap={};
  const ANCRE_H=new Date('2026-01-01T12:00:00').getTime();
  Object.entries(suiviCA).forEach(([key,val])=>{
    const pNum=parseInt(key.replace('p',''));
    if(!pNum||isNaN(pNum)) return;
    const deb=new Date(ANCRE_H+(pNum-1)*PERIODE_DUREE_JOURS*24*60*60*1000);
    const fin2=new Date(deb.getTime()+PERIODE_DUREE_JOURS*24*60*60*1000-1);
    const fmtD=(dt)=>dt.toLocaleDateString('fr-FR',{day:'numeric',month:'short'});
    caMap[key]={ca:val.ca||0,obj:val.obj||0,cmds:[],label:'P'+pNum,dates:fmtD(deb)+' au '+fmtD(fin2),num:pNum};
  });;
  const periodes=Object.values(caMap).sort((a,b)=>b.num-a.num);
  const maxCA=Math.max(...periodes.map(p=>p.ca),1);
  const pActuelle=getPeriodeActuelle();
  const pActAnn=((pActuelle-1)%PERIODES_PAR_AN+PERIODES_PAR_AN)%PERIODES_PAR_AN+1;
  Object.values(caMap).forEach(p=>{const deb=new Date(PERIODE_DEBUT_ABSOLU_MS+(p.num-1)*PERIODE_DUREE_JOURS*24*60*60*1000);const fin2=new Date(deb.getTime()+PERIODE_DUREE_JOURS*24*60*60*1000-1);const ann2=((p.num-1)%PERIODES_PAR_AN+PERIODES_PAR_AN)%PERIODES_PAR_AN+1;p.label='P'+ann2;p.dates=deb.toLocaleDateString('fr-FR',{day:'numeric',month:'short'})+' au '+fin2.toLocaleDateString('fr-FR',{day:'numeric',month:'short'});});
  if(loading) return <div style={{textAlign:'center',padding:'2rem',color:C.gris}}>Chargement...</div>;
  return(
    <div style={{paddingBottom:'2rem'}}>
      <div style={{fontFamily:'Georgia,serif',fontSize:'1.35rem',fontWeight:300,color:C.brun,marginBottom:'.2rem'}}>Historique <em style={{fontStyle:'italic',color:C.rose}}>periodes</em></div>
      <p style={{fontSize:'.74rem',color:C.gris,marginBottom:'1rem'}}>Periode actuelle : <strong style={{color:C.brun}}>P{pActAnn}</strong></p>
      {periodes.length===0&&<div style={{textAlign:'center',padding:'2rem',color:C.gris}}>Aucune commande enregistree</div>}
      {periodes.map(p=>{
        const isOpen=ouvert===p.num;
        const isCur=p.num===pActuelle;
        const bar=Math.round(p.ca/maxCA*100);
        return(
          <div key={p.num} style={{background:C.blanc,border:'1.5px solid '+(isCur?C.rose:C.pale),borderRadius:12,marginBottom:'.5rem',overflow:'hidden'}}>
            <div onClick={()=>setOuvert(isOpen?null:p.num)} style={{padding:'.75rem 1rem',cursor:'pointer',display:'flex',alignItems:'center',gap:'.75rem'}}>
              <div style={{width:40,height:40,borderRadius:10,background:isCur?C.rose:C.creme,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <div style={{fontSize:'.7rem',fontWeight:700,color:isCur?'white':C.brun}}>{p.label}</div>
              </div>
              <div style={{flex:1}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'.3rem'}}>
                  <div style={{fontSize:'.82rem',fontWeight:700,color:C.brun}}>{p.label}{isCur&&<span style={{background:C.rose,color:'white',borderRadius:20,padding:'.1rem .4rem',fontSize:'.58rem',marginLeft:'.3rem'}}>En cours</span>}</div>
                  <div style={{fontSize:'.88rem',fontWeight:700,color:C.brun}}>{p.ca.toFixed(0)}EUR</div>
                </div>
                <div style={{height:4,background:C.pale,borderRadius:2,overflow:'hidden'}}>
                  <div style={{height:'100%',background:isCur?C.rose:C.or,width:bar+'%',borderRadius:2}}/>
                </div>
                <div style={{fontSize:'.62rem',color:C.gris,marginTop:'.2rem'}}>{p.cmds.length} commande{p.cmds.length>1?'s':''}</div>
              </div>
              <span style={{color:C.gris,transform:isOpen?'rotate(90deg)':'none',transition:'transform .2s'}}>›</span>
            </div>
            {isOpen&&(
              <div style={{padding:'0 1rem 1rem',borderTop:'1px solid '+C.pale}}>
                {p.cmds.sort((a,b)=>new Date(b.date)-new Date(a.date)).map((cmd,i)=>(
                  <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'.35rem 0',borderBottom:i<p.cmds.length-1?'1px solid '+C.creme:'none'}}>
                    <div>
                      <div style={{fontSize:'.78rem',fontWeight:600,color:C.brun}}>{cmd.client}</div>
                      <div style={{fontSize:'.6rem',color:C.gris}}>{new Date(cmd.date).toLocaleDateString('fr-FR')}</div>
                    </div>
                    <div style={{fontSize:'.82rem',fontWeight:700,color:C.brun}}>{cmd.montant.toFixed(0)}EUR</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      <div style={{background:C.creme,borderRadius:10,padding:'.75rem 1rem',marginTop:'.75rem',border:'1px solid '+C.pale,fontSize:'.7rem',color:C.gris,lineHeight:1.6}}>
        Si la periode affichee ne correspond pas, ajuste la date dans Admin - Configuration des Periodes.
      </div>
    </div>
  );
}

const NOTICES = {
  clients:{titre:"Mes Clientes",icon:"🛍️",explication:"Centralise toutes tes clientes, leurs commandes et suivis automatiques J+8 et J+21.",comment:["Ajoute une cliente avec le bouton +","Clique sur la fiche pour voir l'historique complet","Programme une relance depuis la fiche","Le suivi J+8 et J+21 se declenche apres chaque commande"],apport:"Tu ne perds plus aucune cliente. Les endormies sont detectees apres 60 jours automatiquement."},
  prospects:{titre:"Mes Prospects",icon:"👥",explication:"Suis tes prospects du premier contact jusqu'a la conversion en cliente ou distributrice.",comment:["Ajoute avec son statut chaud tiede ou froid","Programme une date de relance","Note chaque echange dans le journal","Convertis en cliente ou distributrice en un clic"],apport:"Vision claire de ton pipeline. Tu sais exactement qui relancer chaque jour."},
  relances:{titre:"Relances du jour",icon:"🔔",explication:"Toutes tes relances au meme endroit — prospects a recontacter et clientes endormies depuis 60 jours.",comment:["Consulte chaque matin pendant 10 minutes","Copie le message pret en un clic","Marque comme fait ou reporte de 3 ou 7 jours","Copie tous les messages endormies en une fois"],apport:"Tes relances deviennent un rituel de 10 minutes. Plus personne ne tombe dans l'oubli."},
  editorial:{titre:"Editorial IA",icon:"✍️",explication:"Planning de contenu automatique. L'IA genere hooks, legendes et stories pour 2 posts et 3 stories par jour.",comment:["Clique sur un jour pour voir les themes","Appuie sur Generer pour creer le contenu","Copie hooks et legendes en un clic","Coche A faire quand tu as publie"],apport:"Plus jamais la panne d'inspiration. Planning structure sur 4 semaines avec du contenu varie."},
  diagnostics:{titre:"Diagnostics Produits",icon:"🩺",explication:"Tes clientes repondent a 5 questions et l'IA genere une ordonnance produit personnalisee.",comment:["Choisis le type de diagnostic","Envoie le lien a ta cliente","L'ordonnance est generee automatiquement","Partage en PDF ou par lien public"],apport:"Experience personnalisee qui justifie ton role de conseillere et augmente la conversion."},
  business:{titre:"Espace Business",icon:"📊",explication:"Vue complete de ton activite — CA par periode, entonnoir de conversion et historique.",comment:["Saisis ton CA dans Suivi CA","Consulte l'Entonnoir pour voir tes taux","L'Historique montre toutes tes periodes"],apport:"Tu pilotes avec des chiffres reels et tu identifies tes axes d'amelioration."},
  distributeurs:{titre:"Mes Distributrices",icon:"👑",explication:"Gestion de tes recrues — coordonnees, statut Fast Start, challenge decouverte et suivi.",comment:["Ajoute une distributrice manuellement","Assigne le Fast Start depuis la fiche","Lance le Challenge Decouverte","Suis la progression dans Nouveaux Distrib"],apport:"Tu as une vue d'ensemble de ton equipe et tu peux animer facilement."},
  scripts:{titre:"Scripts et Fils DM",icon:"💬",explication:"Scripts prets et guides de conversation selon le CTA recu — MINCEUR, EQUIPE, DIAGNOSTIC, SILHOUETTE.",comment:["Va dans Fils DM et choisis le CTA recu","Suis le fil etape par etape","Copie et adapte le prenom de la personne"],apport:"Tu sais toujours quoi repondre. Chaque CTA a son fil conducteur jusqu'a la vente."},
};

export function NoticePanel({cleOutil,onClose,videoUrl}){
  const n=NOTICES[cleOutil];if(!n)return null;
  return(<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:9998,background:"rgba(61,31,14,.8)"}} onClick={onClose}>
    <div style={{position:"absolute",top:0,right:0,width:"85%",maxWidth:360,height:"100vh",background:"white",overflowY:"auto",display:"flex",flexDirection:"column"}} onClick={e=>e.stopPropagation()}>
      <div style={{background:"#3D1F0E",padding:"1.1rem 1.2rem",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:".65rem"}}>
          <span style={{fontSize:"1.5rem"}}>{n.icon}</span>
          <div><div style={{fontSize:".5rem",fontWeight:700,letterSpacing:".12em",color:"#C4A882",marginBottom:".1rem"}}>GUIDE D'UTILISATION</div><div style={{fontFamily:"Georgia,serif",fontSize:".95rem",color:"white",fontWeight:300}}>{n.titre}</div></div>
        </div>
        <button onClick={onClose} style={{background:"none",border:"none",color:"#C49A8A",fontSize:"1.4rem",cursor:"pointer",lineHeight:1}}>✕</button>
      </div>
      <div style={{padding:"1rem",flex:1}}>
        {videoUrl?<div style={{marginBottom:"1rem",borderRadius:10,overflow:"hidden",aspectRatio:"16/9",background:"#000"}}><iframe src={videoUrl.replace("watch?v=","embed/").replace("youtu.be/","youtube.com/embed/")} style={{width:"100%",height:"100%",border:"none"}} allowFullScreen title="tuto"/></div>:<div style={{background:"#FAF7F2",borderRadius:10,padding:".65rem",marginBottom:"1rem",textAlign:"center",border:"1px solid #E8DDD4",fontSize:".68rem",color:"#888"}}>🎬 Vidéo tuto à venir — configure depuis Admin → Vidéos outils</div>}
        <div style={{marginBottom:"1rem"}}><div style={{fontSize:".6rem",fontWeight:700,color:"#3D1F0E",textTransform:"uppercase",letterSpacing:".08em",marginBottom:".4rem"}}>📖 C'est quoi ?</div><div style={{fontSize:".78rem",color:"#3D2B1F",lineHeight:1.7,background:"#FAF7F2",borderRadius:10,padding:".65rem .85rem",border:"1px solid #E8DDD4"}}>{n.explication}</div></div>
        <div style={{marginBottom:"1rem"}}><div style={{fontSize:".6rem",fontWeight:700,color:"#3D1F0E",textTransform:"uppercase",letterSpacing:".08em",marginBottom:".4rem"}}>🛠️ Comment l'utiliser ?</div>{n.comment.map((s,i)=>(<div key={i} style={{display:"flex",gap:".6rem",alignItems:"flex-start",marginBottom:".4rem"}}><div style={{width:22,height:22,borderRadius:"50%",background:"#C49A8A",color:"white",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".65rem",fontWeight:700,flexShrink:0}}>{i+1}</div><div style={{fontSize:".76rem",color:"#3D2B1F",lineHeight:1.55}}>{s}</div></div>))}</div>
        <div style={{background:"#3D1F0E",borderRadius:12,padding:".85rem 1rem"}}><div style={{fontSize:".58rem",fontWeight:700,color:"#C4A882",letterSpacing:".1em",textTransform:"uppercase",marginBottom:".3rem"}}>✦ Ce que ca t'apporte</div><div style={{fontSize:".78rem",color:"white",lineHeight:1.65}}>{n.apport}</div></div>
      </div>
    </div>
  </div>);
}

const DECOUVERTE = {
  moncompte: [
    {titre:"Bienvenue !", texte:"Ici tu retrouves tous tes réglages personnels : ton code de connexion, ta boutique, tes alertes email, et le prix VIP. On regarde ça ensemble !", icon:"👋", cible:"decouverte-compte-titre"},
    {titre:"Ton code personnel", texte:"C'est ici que tu changes le code que tu utilises pour te connecter à l'application.", icon:"🔑", cible:"decouverte-compte-titre"},
    {titre:"Ta boutique en ligne", texte:"Colle ici ton lien PayPal.me et/ou ton lien de paiement Stripe personnel pour encaisser directement tes ventes. Avec PayPal.me, le montant se remplit tout seul pour ta cliente !", icon:"🛍️", cible:"decouverte-compte-boutique"},
    {titre:"Alerte email nouvelle commande", texte:"Renseigne ton email ici pour être prévenue à chaque nouvelle commande, en plus de la notification dans l'app.", icon:"🔔", cible:"decouverte-compte-email"},
    {titre:"Le prix VIP", texte:"Active cet interrupteur si tu veux que tes diagnostics et l'assistante IA affichent aussi un prix VIP à côté du prix normal.", icon:"💎", cible:"decouverte-compte-vip"},
    {titre:"Bravo, tu es prête !", texte:"Prends 5 minutes pour bien tout paramétrer une bonne fois pour toutes, ça te fera gagner du temps ensuite au quotidien !", icon:"🎉", cible:"decouverte-compte-titre"},
  ],
  tirelire: [
    {titre:"Bienvenue dans ta tirelire !", texte:"Ici, on ne parle plus de points mais d'argent. Ta tirelire se remplit au fur et à mesure que tu gagnes. Elle reste visible en haut de l'appli, tout le temps, pour ne jamais perdre ton objectif de vue.", icon:"🐷", cible:"decouverte-tirelire-cochon"},
    {titre:"Étape 1 : combien tu vas chercher", texte:"Choisis un montant (même petit : 50 €, 100 €...) ou tape le tien. Tu peux aller jusqu'à 5 000 € et plus. C'est l'argent que tu veux GAGNER pour toi sur la période de 21 jours.", icon:"🎯", cible:"decouverte-tirelire-objectif"},
    {titre:"Étape 2 : ton pourcentage", texte:"Tu gagnes entre 20 et 30 % sur tes ventes. Ça dépend du montant de ta commande : 20 % jusqu'à 70 €, 25 % au-dessus de 70 €, 30 % au-dessus de 145 €. Tape le montant de ta commande et l'appli te propose le bon pourcentage.", icon:"📊", cible:"decouverte-tirelire-taux"},
    {titre:"Étape 3 : note tes vraies ventes", texte:"À chaque vente, tape le prix de vente et touche « Mettre dans ma tirelire ». Une pièce tombe et ton gain s'ajoute tout seul. Tu t'es trompée ? Touche la croix pour retirer la vente.", icon:"🪙", cible:"decouverte-tirelire-ventes"},
    {titre:"Étape 4 : gagne grâce à ton équipe", texte:"Ajoute ici les personnes de ton équipe. Leur chiffre remonte seul et l'appli calcule ce que tu gagnes grâce à elles, selon le plan marketing. Ce gain s'ajoute directement dans ta tirelire.", icon:"👥", cible:"decouverte-tirelire-equipe"},
    {titre:"Bravo, tu es prête !", texte:"Jette un œil à ta tirelire chaque jour : tu sais toujours combien il te reste à vendre pour atteindre ton objectif. Elle repart à zéro à chaque nouvelle période, ton objectif et ton pourcentage sont gardés.", icon:"🎉", cible:"decouverte-tirelire-cochon"},
  ],
  recrues: [
    {titre:"Tes recrues, en lumière !", texte:"Chaque petit bonhomme représente une personne que tu veux accueillir dans ton équipe. À chaque recrue, un bonhomme s'allume. Tu les vois toujours en haut de l'appli, à côté de ta tirelire.", icon:"💡", cible:"decouverte-recrues-bonhommes"},
    {titre:"Étape 1 : ton objectif", texte:"Choisis combien de personnes tu veux recruter sur la période (1, 2, 3...) ou tape ton chiffre. Le nombre de bonhommes s'adapte tout seul.", icon:"🎯", cible:"decouverte-recrues-objectif"},
    {titre:"Étape 2 : une nouvelle recrue !", texte:"Dès qu'une personne rejoint ton équipe, touche ce bouton : un bonhomme s'allume. Une erreur ? Le petit lien en dessous retire la dernière recrue.", icon:"✨", cible:"decouverte-recrues-bouton"},
    {titre:"Bravo, tu es prête !", texte:"Quand tous les bonhommes sont allumés, ton objectif est atteint : confettis, et ta réussite est publiée dans le Wall of Fame. Ce compteur est le même que dans Mes objectifs, tout reste à jour partout.", icon:"🎉", cible:"decouverte-recrues-bonhommes"},
  ],
  equipe: [
    {titre:"Ce que ton équipe te fait gagner", texte:"Ici tu vois ce que ton équipe te rapporte, d'après le plan marketing Mihi : ton niveau (de 2 à 17 %), ton volume de groupe (PGV) et le détail du calcul.", icon:"👥", cible:"decouverte-equipe-resultat"},
    {titre:"Étape 1 : ton volume perso", texte:"C'est ce que tu as commandé ou vendu sur la période. Il faut au moins 25 € pour que ton équipe te rapporte quelque chose. Laisse vide pour reprendre ton chiffre automatiquement.", icon:"🛍️", cible:"decouverte-equipe-pv"},
    {titre:"Étape 2 : ajoute ton équipe", texte:"Touche « Ajouter toutes mes filleules directes », ou cherche une personne par son prénom. Son chiffre remonte tout seul depuis l'application.", icon:"✨", cible:"decouverte-equipe-membres"},
    {titre:"Quand quelqu'un ne se met pas à jour", texte:"Si tu vois un avertissement orange, la personne n'a pas rempli son chiffre cette période. Tape son volume dans la case à droite : il est pris en compte tout de suite. Tu peux aussi ajouter quelqu'un à la main.", icon:"✍️", cible:"decouverte-equipe-membres"},
    {titre:"Comment c'est calculé", texte:"Tu touches la différence entre ton pourcentage et celui de chaque personne de ton groupe. Exemple : tu es à 10 % et Anna à 2 % : tu gagnes 8 % de son volume. Plus ton groupe grandit, plus ton niveau monte.", icon:"🧮", cible:"decouverte-equipe-resultat"},
    {titre:"Si tu as des directrices", texte:"Une personne dont le groupe atteint 5 000 € devient directrice. Son groupe sort de ton volume et tu touches à la place des primes de directrice. Ouvre ce bloc pour voir ton statut et les primes par ligne.", icon:"👑", cible:"decouverte-equipe-directrices"},
    {titre:"Bravo, tu es prête !", texte:"Regarde ton niveau suivant : l'appli te dit combien de volume il te manque pour le passer. Ce calcul est une estimation, seul ton relevé officiel Mihi fait foi.", icon:"🎉", cible:"decouverte-equipe-resultat"},
  ],
  diagnostics: [
    {titre:"Bienvenue !", texte:"Tes clientes repondent a quelques questions et l\u2019IA genere une ordonnance produit personnalisee. C\u2019est un super outil pour les conseiller ! On regarde ca ensemble.", icon:"\uD83D\uDC4B", cible:"decouverte-diag-cats"},
    {titre:"Etape 1 : choisis une categorie", texte:"Les diagnostics sont ranges par categorie (skincare, cheveux, silhouette...). Clique sur une categorie pour voir les diagnostics disponibles.", icon:"\uD83D\uDCC1", cible:"decouverte-diag-cats"},
    {titre:"Etape 2 : le prenom de la cliente", texte:"Tu peux indiquer le prenom de ta cliente pour personnaliser le lien. C\u2019est optionnel, elle pourra renseigner ses coordonnees elle-meme a la fin.", icon:"\uD83D\uDC64", cible:"decouverte-diag-prenom"},
    {titre:"Etape 3 : choisis un diagnostic", texte:"Pour chaque diagnostic, deux options : Remplir maintenant (tu fais le diagnostic avec elle en direct) ou Envoyer le lien (elle repond seule, a son rythme).", icon:"\uD83D\uDCCB", cible:"decouverte-diag-liste"},
    {titre:"Etape 4 : recois les resultats", texte:"Une fois le diagnostic termine, l\u2019ordonnance est generee automatiquement par l\u2019IA. Tu peux la partager en PDF ou par lien public avec ta cliente.", icon:"\u2728"},
    {titre:"Bravo, tu es prete !", texte:"Cette experience personnalisee justifie ton role de conseillere et augmente tes ventes !", icon:"\uD83C\uDF89", cible:"decouverte-diag-cats"},
  ],
  immersion: [
    {titre:"Bienvenue !", texte:"Cet onglet te permet de creer ta propre page d'immersion a partager avec tes prospects : ton histoire, ta journee type, tes formations et des temoignages de l'equipe. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-immersion-onglets"},
    {titre:"Etape 1 : remplis ton contenu", texte:"Dans l'onglet Mon contenu, ecris ton accroche, ton histoire (le Avant et la bascule) et ta journee type. C'est ce qui rendra ta page unique et authentique.", icon:"\u270D\uFE0F", cible:"decouverte-immersion-onglets"},
    {titre:"Etape 2 : soumets ton temoignage", texte:"Dans Mon temoignage, choisis ta categorie (Maman, Reconversion...) et ecris quelques mots sur ton parcours. Il sera visible une fois valide.", icon:"\uD83D\uDCAC", cible:"decouverte-immersion-onglets"},
    {titre:"Etape 3 : choisis tes temoignages", texte:"Dans Choisir mes temoignages, tu peux piocher parmi tous les temoignages valides de l'equipe ceux qui apparaitront sur TA page.", icon:"\u2705", cible:"decouverte-immersion-onglets"},
    {titre:"Etape 4 : previsualise ta page", texte:"En bas de l'onglet Mon contenu, le lien Voir ma page d'immersion te montre le rendu final, exactement ce que verra ton prospect.", icon:"\uD83D\uDC41\uFE0F", cible:"decouverte-immersion-preview"},
    {titre:"Bravo, tu es prete !", texte:"Une fois ta page remplie, partage le lien avec tes prospects pour leur faire vivre une vraie immersion dans ton quotidien !", icon:"\uD83C\uDF89", cible:"decouverte-immersion-onglets"},
  ],
  scripts: [
    {titre:"Bienvenue !", texte:"Cette biblioth\u00e8que rassemble des scripts prets a utiliser pour tes conversations. Adapte toujours a ta voix, ce sont des bases de depart !", icon:"\uD83D\uDC4B", cible:"decouverte-scripts-liste"},
    {titre:"Etape 1 : choisis une categorie", texte:"Les scripts sont ranges par categorie (objections, relances, presentation...). Clique sur une categorie pour voir les scripts qu\u2019elle contient.", icon:"\uD83D\uDCC1", cible:"decouverte-scripts-liste"},
    {titre:"Etape 2 : ouvre et copie", texte:"Clique sur le titre d\u2019un script pour le lire en entier, puis clique sur Copier pour le mettre dans ton presse-papier. Colle-le ensuite dans ta conversation et personnalise avec le prenom de la personne.", icon:"\uD83D\uDCCB", cible:"decouverte-scripts-liste"},
    {titre:"Bravo, tu es prete !", texte:"Tu sais toujours quoi repondre, quelle que soit la situation !", icon:"\uD83C\uDF89", cible:"decouverte-scripts-liste"},
  ],
  calendrier: [
    {titre:"Bienvenue !", texte:"Le calendrier equipe rassemble tous les evenements partages : Zooms de formation, evenements vente, deadlines... On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-cal-liste"},
    {titre:"Etape 1 : ajoute un evenement", texte:"Si tu es cheffe d\u2019equipe, tu peux ajouter un evenement : titre, date, heure, type et lien Zoom si besoin. Sinon, c\u2019est Melissa ou tes chefs qui les ajoutent pour toi.", icon:"\u2795", cible:"decouverte-cal-add"},
    {titre:"Etape 2 : les evenements a venir", texte:"Retrouve ici tous les prochains rendez-vous de l\u2019equipe, tries par date.", icon:"\uD83D\uDCC5", cible:"decouverte-cal-liste"},
    {titre:"Bravo, tu es prete !", texte:"Tu ne rateras plus aucun rendez-vous important de l\u2019equipe !", icon:"\uD83C\uDF89", cible:"decouverte-cal-liste"},
  ],
  today: [
    {titre:"Bienvenue !", texte:"L\u2019onglet Aujourd\u2019hui, c\u2019est ton ecran d\u2019accueil. Tu y retrouves l\u2019essentiel de ta journee en un coup d\u2019oeil. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-jauge"},
    {titre:"Etape 1 : ta jauge de succes", texte:"Cette jauge te montre en un coup d\u2019oeil ou tu en es par rapport a tes objectifs de CA et de recrutement sur la periode.", icon:"\uD83C\uDFAF", cible:"decouverte-jauge"},
    {titre:"Etape 2 : tes badges", texte:"Tu debloques des badges au fur et a mesure de tes reussites (regularite, ventes, recrutement...). Une petite recompense pour tes efforts !", icon:"\uD83C\uDFC6", cible:"decouverte-badges"},
    {titre:"Etape 3 : la citation du jour", texte:"Chaque jour, une citation motivante t\u2019attend ici pour bien demarrer.", icon:"\u2728", cible:"decouverte-citation"},
    {titre:"Etape 4 : tes actions du jour", texte:"Coche les actions que tu fais chaque jour (messages envoyes, posts publies...). Ca t\u2019aide a rester regulier. Tu peux aussi en ajouter des personnalisees avec le bouton + Actions.", icon:"\u26A1", cible:"decouverte-actions-jour"},
    {titre:"Bravo, tu es prete !", texte:"Reviens ici chaque jour pour garder une vue d\u2019ensemble de ton activite et rester motivee !", icon:"\uD83C\uDF89", cible:"decouverte-jauge"},
  ],
  distributeurs: [
    {titre:"Bienvenue !", texte:"Cet onglet te sert a gerer tes recrues : leurs coordonnees, leur Fast Start, le Challenge Decouverte et leur suivi. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-distrib-add"},
    {titre:"Etape 1 : le bouton + Distributeur", texte:"Attention, ce bouton n\u2019est PAS la facon normale d\u2019ajouter une nouvelle distributrice ! Il sert uniquement si quelqu\u2019un rejoint ton equipe mais n\u2019utilise pas l\u2019application. Pour une inscription normale, ca se passe dans les Acces (elle recoit le code secret et se connecte elle-meme).", icon:"\u2795", cible:"decouverte-distrib-add"},
    {titre:"Etape 2 : ta liste et les paliers", texte:"Chaque distributeur affiche son palier actuel. Clique sur son nom pour ouvrir sa fiche et changer son palier au fur et a mesure de sa progression.", icon:"\uD83D\uDC51", cible:"decouverte-distrib-liste"},
    {titre:"Etape 3 : assigne le Fast Start", texte:"Dans la fiche d\u2019un nouveau distributeur, tu peux assigner le programme Fast Start pour l\u2019accompagner dans ses premiers jours.", icon:"\uD83D\uDE80", cible:"decouverte-distrib-liste"},
    {titre:"Etape 4 : lance le Challenge Decouverte", texte:"Toujours dans la fiche, tu peux lancer le Challenge Decouverte pour l\u2019aider a prendre en main l\u2019application pas a pas.", icon:"\uD83C\uDFAF", cible:"decouverte-distrib-liste"},
    {titre:"Etape 5 : suis les nouveaux", texte:"Clique sur l\u2019onglet Nouveaux Distri en haut pour suivre la progression de tes recrues les plus recentes en un coup d\u2019oeil.", icon:"\uD83D\uDCCB"},
    {titre:"Bravo, tu es prete !", texte:"Tu as maintenant une vue d\u2019ensemble de ton equipe et tu peux l\u2019animer facilement !", icon:"\uD83C\uDF89", cible:"decouverte-distrib-add"},
  ],
  relances: [
    {titre:"Bienvenue !", texte:"Cet onglet rassemble toutes tes relances au meme endroit : prospects a recontacter et clientes qui n\u2019ont rien commande depuis 60 jours. Consulte-le chaque matin pendant 10 minutes !", icon:"\uD83D\uDC4B", cible:"decouverte-relances-stats"},
    {titre:"Etape 1 : tes 3 chiffres", texte:"En haut, tu vois d\u2019un coup d\u2019oeil combien de prospects sont a recontacter, combien sont sans contact depuis 14 jours, et combien de clientes sont endormies depuis 60 jours.", icon:"\uD83D\uDCCA", cible:"decouverte-relances-stats"},
    {titre:"Etape 2 : choisis une section", texte:"Clique sur Prospects, Endormies ou Inactives pour voir la liste correspondante.", icon:"\uD83D\uDC46", cible:"decouverte-relances-tabs"},
    {titre:"Etape 3 : relance un prospect", texte:"Pour chaque prospect, un message est deja pret. Clique sur Copier pour le copier, colle-le dans WhatsApp ou Instagram. Ensuite marque Fait, ou reporte de 3 ou 7 jours si besoin.", icon:"\uD83D\uDCAC", cible:"decouverte-relances-tabs"},
    {titre:"Etape 4 : clientes endormies", texte:"Meme principe pour tes clientes endormies : un message tendre est pret a copier. Tu peux aussi copier tous les messages d\u2019un coup avec le bouton en bas.", icon:"\uD83D\uDCA4", cible:"decouverte-relances-tabs"},
    {titre:"Bravo, tu es prete !", texte:"Tes relances deviennent un rituel de 10 minutes. Plus personne ne tombe dans l\u2019oubli !", icon:"\uD83C\uDF89", cible:"decouverte-relances-stats"},
  ],
  business: [
    {titre:"Bienvenue !", texte:"Cet onglet te donne une vue complete de ton activite : ton chiffre d\u2019affaires, ton entonnoir de conversion, et l\u2019historique de toutes tes periodes. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-business-tabs"},
    {titre:"Etape 1 : le suivi CA", texte:"Dans l\u2019onglet CA, saisis ton chiffre d\u2019affaires jour apres jour. Chaque jour rempli met a jour ton total automatiquement.", icon:"\uD83D\uDCB0", cible:"decouverte-suivi-ca"},
    {titre:"Etape 1 bis : ventes perso et recrues", texte:"Clique sur le petit crayon d\u2019une p\u00E9riode pour ouvrir sa fiche. En plus du CA total, tu peux y noter tes ventes perso et ton nombre de recrues. Remplis-les \u00E0 chaque fin de p\u00E9riode : c\u2019est ce qui alimente tes courbes d\u2019\u00E9volution.", icon:"\u270F", cible:"decouverte-suivi-ca"},
    {titre:"Etape 2 : l\u2019entonnoir", texte:"Clique sur l\u2019onglet Entonnoir pour voir combien de tes prospects deviennent clientes, puis combien de clientes rejoignent l\u2019equipe. Ca t\u2019aide a comprendre ta conversion.", icon:"\uD83D\uDCC9", cible:"decouverte-business-tabs"},
    {titre:"Etape 3 : l\u2019historique", texte:"Clique sur l\u2019onglet Historique pour revoir toutes tes periodes precedentes et le detail de tes commandes.", icon:"\uD83D\uDCD6", cible:"decouverte-business-tabs"},
    {titre:"Bravo, tu es prete !", texte:"Tu pilotes maintenant ton activite avec de vrais chiffres. Reviens ici regulierement pour suivre ta progression !", icon:"\uD83C\uDF89", cible:"decouverte-business-tabs"},
  ],
  prospects: [
    {titre:"Bienvenue !", texte:"Cet onglet te sert a suivre tes prospects, du premier contact jusqu\u2019a la conversion en cliente ou distributrice. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-ajouter-prospect"},
    {titre:"Etape 1 : ajoute un prospect", texte:"Ecris son prenom, choisis son statut (chaud, tiede ou froid), precise si elle est interessee par les produits ou par l\u2019activite, ajoute une note si besoin, puis clique sur Ajouter le prospect.", icon:"\u2795", cible:"decouverte-ajouter-prospect"},
    {titre:"Etape 2 : tes categories", texte:"Tes prospects sont ranges par categorie : Clients potentiels, Distributeurs potentiels, et Recommandations. Clique sur une categorie pour voir la liste.", icon:"\uD83D\uDCC1", cible:"decouverte-categories-prospects"},
    {titre:"Etape 3 : ouvre une fiche", texte:"Clique sur le nom d\u2019un prospect pour ouvrir sa fiche. Tu peux y noter chaque echange dans le journal, pour te souvenir de tout.", icon:"\uD83D\uDC46", cible:"decouverte-categories-prospects"},
    {titre:"Etape 4 : programme une relance", texte:"Dans la fiche, choisis une date pour te rappeler de recontacter ce prospect. Tu le retrouveras dans l\u2019onglet Relances le jour venu.", icon:"\uD83D\uDD14", cible:"decouverte-categories-prospects"},
    {titre:"Etape 5 : convertis-le", texte:"Quand un prospect devient cliente ou distributrice, clique sur le bouton Convertir. Il passera automatiquement dans le bon onglet.", icon:"\u2728", cible:"decouverte-categories-prospects"},
    {titre:"Bravo, tu es prete !", texte:"Tu as maintenant une vision claire de ton pipeline. Tu sais exactement qui relancer chaque jour !", icon:"\uD83C\uDF89", cible:"decouverte-ajouter-prospect"},
  ],
  clients: [
    {titre:"Bienvenue !", texte:"Cet onglet centralise toutes tes clientes : leurs commandes, leurs infos, et un suivi automatique pour ne jamais les oublier. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-clients-liste"},
    {titre:"Etape 1 : ajoute une cliente", texte:"Clique sur le bouton + Nouvelle cliente, puis remplis son prenom, nom, telephone et le reste. Clique ensuite sur Ajouter.", icon:"\u2795", cible:"decouverte-nouvelle-cliente"},
    {titre:"Etape 2 : tes groupes de clientes", texte:"Tes clientes sont rangees automatiquement en 4 groupes : VIP, Fidele, A consolider, et Inactif. Clique sur un groupe pour le deplier et voir la liste.", icon:"\uD83D\uDC65", cible:"decouverte-clients-liste"},
    {titre:"Etape 3 : ouvre une fiche", texte:"Clique sur le nom d\u2019une cliente pour ouvrir sa fiche complete. C\u2019est ici que tu vas gerer ses commandes, sa carte fidelite et tes rappels.", icon:"\uD83D\uDC46", cible:"decouverte-clients-liste"},
    {titre:"Etape 4 : ajoute une commande", texte:"Dans la fiche de la cliente, clique sur le bouton pour ajouter une commande. Indique les produits achetes, le montant et la date. Ca alimente automatiquement son historique et sa carte fidelite.", icon:"\uD83D\uDED2", cible:"decouverte-clients-liste"},
    {titre:"Etape 5 : la carte fidelite", texte:"Toujours dans la fiche, tu trouveras sa carte fidelite. Elle se remplit automatiquement a chaque commande enregistree et te permet de recompenser tes meilleures clientes.", icon:"\uD83D\uDC8E", cible:"decouverte-clients-liste"},
    {titre:"Etape 6 : la recommandation", texte:"Tu peux aussi generer un lien de recommandation a partager avec ta cliente, pour qu\u2019elle te recommande facilement aupres de ses amies.", icon:"\uD83D\uDCE3", cible:"decouverte-clients-liste"},
    {titre:"Etape 7 : la vue precisions", texte:"En haut, le bouton Vue precisions te montre des details supplementaires sur chaque cliente (ambassadrice potentielle, hotesse validee...), utile pour organiser tes actions.", icon:"\uD83D\uDCCB", cible:"decouverte-toggle-vue"},
    {titre:"Bravo, tu es prete !", texte:"Tu ne perdras plus aucune cliente. Reviens ici regulierement pour faire vivre ta relation avec elles !", icon:"\uD83C\uDF89"},
  ],
  linkbio: [
    {titre:"Bienvenue !", texte:"Le LinkBio, c\u2019est TA page personnelle. Un seul lien \u00e0 mettre dans ta bio Instagram ou Facebook, et tes clientes voient TOUT. On va tout regarder ensemble, \u00e9tape par \u00e9tape. Je vais t\u2019amener sur chaque section pour que tu remplisses en m\u00eame temps !", icon:"\uD83D\uDC4B", section:null},
    {titre:"\u00c9tape 1 : ton th\u00e8me", texte:"Choisis la couleur qui te pla\u00eet le plus en cliquant dessus. Tu peux en changer plus tard si tu changes d\u2019avis !", icon:"\uD83C\uDFA8", section:"theme"},
    {titre:"\u00c9tape 2 : ton profil", texte:"Ajoute ta photo, ton pr\u00e9nom, et une petite phrase qui te repr\u00e9sente (ton slogan). Remplis les champs maintenant.", icon:"\u2728", section:"profil"},
    {titre:"\u00c9tape 3 : tes liens", texte:"Colle ici le lien vers ta boutique et vers ton recrutement. Ce sont les 2 gros boutons que verront tes visiteurs.", icon:"\uD83D\uDD17", section:"liens"},
    {titre:"\u00c9tape bonus : ton contact direct", texte:"Dans Mon compte (l\u2019ic\u00f4ne cadenas en haut de l\u2019application), tu peux ajouter ton num\u00e9ro WhatsApp, ton Messenger et ton Instagram. Ainsi, apr\u00e8s un diagnostic ou un tunnel de vente, tes prospects pourront te contacter en 1 clic !", icon:"\uD83D\uDCAC", section:null},
    
    {titre:"\u00c9tape 4 : tes photos", texte:"Ajoute jusqu\u2019\u00e0 5 photos de toi ou de tes moments Mihi. Clique sur chaque case pour choisir une photo.", icon:"\uD83D\uDCF8", section:"photos"},
    {titre:"\u00c9tape 5 : Mon Parcours", texte:"C\u2019est LA section la plus importante ! Ajoute des photos, raconte ton histoire en 3 petits paragraphes, et montre jusqu\u2019\u00e0 10 produits que tu utilises toi-m\u00eame au quotidien.", icon:"\uD83C\uDF1F", section:"parcours"},
    {titre:"\u00c9tape 6 : tes r\u00e9seaux", texte:"Colle les liens de tes comptes Facebook, Instagram, TikTok, YouTube. Ils appara\u00eetront en bas de ta page.", icon:"\uD83D\uDCF1", section:"reseaux"},
    {titre:"\u00c9tape 7 : tes ebooks", texte:"Dans cet onglet, tu peux choisir un ebook gratuit \u00e0 offrir \u00e0 tes visiteuses. C\u2019est un cadeau qui donne envie de te faire confiance.", icon:"\uD83D\uDCDA", section:"ebooks"},
    {titre:"\u00c9tape 8 : ta banni\u00e8re", texte:"Tu peux ajouter un petit message qui s\u2019affiche tout en haut de ta page, par exemple pour annoncer une promotion. Choisis ta couleur et \u00e9cris ton texte.", icon:"\uD83D\uDCE2", section:"banniere"},
    {titre:"N\u2019oublie pas d\u2019enregistrer !", texte:"Remonte en haut de la page et clique sur le bouton ENREGISTRER. Sinon tout ce que tu as fait sera perdu !", icon:"\uD83D\uDCBE", section:null},
    {titre:"Tes statistiques", texte:"Ici tu peux voir combien de personnes ont visit\u00e9 ta page et sur quels boutons elles ont cliqu\u00e9.", icon:"\uD83D\uDCCA", section:"stats"},
    {titre:"Bravo, tu es pr\u00eate !", texte:"Ta page LinkBio est pr\u00eate. Copie ton lien tout en haut de la page et colle-le dans ta bio Instagram ou Facebook !", icon:"\uD83C\uDF89", section:null},
  ],
    editorial: [
    {titre:"Bienvenue !", texte:"L\u2019Editorial IA, c\u2019est ton planning de contenu automatique. L\u2019intelligence artificielle te propose des idees de posts et de stories pretes a l\u2019emploi, jour par jour. On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-calendrier"},
    {titre:"Etape 1 : ton profil IA", texte:"Clique sur le bouton Mon profil IA en haut a droite. Raconte qui tu es en quelques mots : tes enfants, ton histoire, ta personnalite. Plus tu en dis, plus l\u2019IA generera du contenu qui te ressemble vraiment.", icon:"\u2728", cible:"decouverte-profil-ia"},
    {titre:"Etape 2 : ton calendrier", texte:"Voici ton planning sur 4 semaines. Chaque jour a deja un theme prevu pour toi : un post, une conversion, et des stories.", icon:"\uD83D\uDCC5", cible:"decouverte-calendrier"},
    {titre:"Etape 3 : ouvre un jour", texte:"Clique sur n\u2019importe quel jour du calendrier pour voir en detail les themes proposes pour ce jour-la.", icon:"\uD83D\uDC46"},
    {titre:"Etape 4 : genere le contenu", texte:"Une fois le jour ouvert, appuie sur le bouton Generer. L\u2019IA va ecrire pour toi un hook (accroche), une legende complete, et des idees de stories.", icon:"\uD83E\uDD16"},
    {titre:"Etape 5 : copie et utilise", texte:"Clique sur le texte genere pour le copier en un clic. Colle-le ensuite directement dans Instagram ou Facebook au moment de publier.", icon:"\uD83D\uDCCB"},
    {titre:"Etape 6 : coche quand c\u2019est fait", texte:"Une fois que tu as publie, reviens sur ce jour et coche A faire. Ca t\u2019aide a garder une vue claire de ce qui est deja publie.", icon:"\u2705"},
    {titre:"Bravo, tu es prete !", texte:"Tu ne seras plus jamais en panne d\u2019inspiration. Reviens chaque jour consulter ton planning !", icon:"\uD83C\uDF89"},
  ],
  dreamboard: [
    {titre:"Bienvenue !", texte:"Ton Dream Board, c'est ton tableau de visualisation. Ajoute des photos et des reves qui te motivent, et regarde-le chaque jour pour rester connectee a tes objectifs. On regarde ca ensemble !", icon:"\uD83C\uDF1F", cible:"decouverte-dream-add"},
    {titre:"Etape 1 : ajoute un reve", texte:"Clique sur + Ajouter un reve. Tu peux uploader une photo d'inspiration, ou choisir un emoji si tu n'as pas de photo.", icon:"\u2795", cible:"decouverte-dream-add"},
    {titre:"Etape 2 : donne-lui vie", texte:"Ecris un titre, une petite description si tu veux, et choisis une categorie (vie de reve, finances, famille, voyages...).", icon:"\u270F", cible:"decouverte-dream-add"},
    {titre:"Etape 3 : ton tableau", texte:"Tous tes reves s'affichent en mosaique. Clique sur un reve pour l'agrandir, le modifier ou le marquer comme realise.", icon:"\uD83D\uDDBC", cible:"decouverte-dream-mosaique"},
    {titre:"Etape 4 : celebre tes reussites", texte:"Quand un reve devient realite, marque-le comme Realise. Il rejoint une section speciale pour celebrer tout ce que tu as accompli.", icon:"\u2705", cible:"decouverte-dream-mosaique"},
    {titre:"Bravo, tu es prete !", texte:"Reviens ici chaque matin, regarde ton board, et laisse-le te rappeler pourquoi tu te leves chaque jour !", icon:"\uD83C\uDF89", cible:"decouverte-dream-add"},
  ],
  espacechef: [
    {titre:"Bienvenue !", texte:"L\u2019Espace Chef regroupe tous tes outils d\u2019animation d\u2019equipe : statistiques, suivi CA, gestion des acces, defis collectifs... On regarde ca ensemble !", icon:"\uD83D\uDC4B", cible:"decouverte-chef-stats"},
    {titre:"Etape 1 : Statistiques equipe", texte:"Ici tu retrouves le taux d\u2019utilisation de l\u2019app, la conversion, et les diagnostics realises. Des chiffres utiles pour recruter et motiver ton equipe.", icon:"\uD83D\uDCCA", cible:"decouverte-chef-stats"},
    {titre:"Etape 2 : Suivi CA", texte:"Ton chiffre d\u2019affaires periode par periode, avec tout l\u2019historique. Accessible a toute distributrice, pas seulement aux cheffes.", icon:"\uD83D\uDCC8", cible:"decouverte-chef-suivica"},
    {titre:"Etape 3 : Acces equipe", texte:"Gere les membres de ton equipe, nomme des chefs, et assigne les marraines depuis cette section.", icon:"\u2699\uFE0F", cible:"decouverte-chef-membres"},
    {titre:"Etape 4 : Assiduite equipe", texte:"Suis les connexions et les actions realisees chaque jour par chaque membre de ton equipe.", icon:"\uD83D\uDCCB", cible:"decouverte-chef-assiduite"},
    {titre:"Etape 5 : Challenge Decouverte App", texte:"Suis la progression de chaque membre dans le defi 7 jours de decouverte de l\u2019application.", icon:"\uD83C\uDFAE", cible:"decouverte-chef-challengeapp"},
    {titre:"Etape 6 : Challenge Flash et Power Hour", texte:"Lance un defi collectif pour toute l\u2019equipe, ou organise un Power Hour : un sprint synchrone de 20 minutes tous ensemble.", icon:"\uD83D\uDE80", cible:"decouverte-chef-defi"},
    {titre:"Etape 7 : Distributeurs et Nouveaux Distri", texte:"Navigue dans l\u2019arborescence complete de ton equipe, et suis l\u2019onboarding de tes recrues les plus recentes.", icon:"\uD83D\uDC51", cible:"decouverte-chef-distributeurs"},
    {titre:"Etape 8 : Actions biblio", texte:"Ajoute des actions a la bibliotheque partagee, utilisee par toute l\u2019equipe dans l\u2019onglet Aujourd\u2019hui.", icon:"\uD83D\uDCA1", cible:"decouverte-chef-actionsbiblio"},
    {titre:"Bravo, tu es prete !", texte:"Tu as maintenant tous les outils pour animer et faire grandir ton equipe !", icon:"\uD83C\uDF89", cible:"decouverte-chef-stats"},
  ],
  semainetheme: [
    {titre:"Bienvenue !", texte:"Ici, tu ne cherches plus quoi poster. Tu choisis un th\u00E8me le lundi, et tu as ta p\u00E9riode enti\u00E8re de contenu. 31 th\u00E8mes, 7 angles chacun, d\u00E9j\u00E0 \u00E9crits. On regarde \u00E7a ensemble !", icon:"\uD83D\uDC4B"},
    {titre:"Un th\u00E8me = un probl\u00E8me v\u00E9cu", texte:"Regarde les titres : ma peau tire, je grignote l\u2019apr\u00E8s-midi, mes vitres ont des traces. Jamais les soins visage. Une femme ne se dit jamais il me faut un s\u00E9rum. Elle se dit j\u2019ai une sale t\u00EAte ce matin. Tu entres par l\u00E0, le produit arrive apr\u00E8s.", icon:"\uD83C\uDFAF"},
    {titre:"Trouve ton th\u00E8me", texte:"Utilise les filtres en haut : par famille, ou Jamais fait pour voir ce que tu n\u2019as pas encore exploit\u00E9. Astuce : croise avec le produit en promo au catalogue en cours, c\u2019est l\u00E0 que tu auras le meilleur argument prix.", icon:"\uD83D\uDD0D"},
    {titre:"Tes 7 angles", texte:"Ouvre un th\u00E8me : tu trouves 7 fa\u00E7ons de parler du m\u00EAme produit. Copie l\u2019angle avec le bouton Copier, puis r\u00E9\u00E9cris-le avec tes mots. C\u2019est un point de d\u00E9part, pas un texte \u00E0 publier tel quel. Tes clientes doivent reconna\u00EEtre ta voix.", icon:"\u270F"},
    {titre:"Les encadr\u00E9s rouges", texte:"Sur les compl\u00E9ments et les produits m\u00E9nagers, respecte les formulations indiqu\u00E9es. Antibact\u00E9rien ou fait maigrir peuvent te causer de vrais ennuis. En cas de doute sur une phrase, demande avant de publier.", icon:"\u26A0"},
    {titre:"Coche ce que tu as fait", texte:"Le bouton J\u2019ai fait ce th\u00E8me garde ton historique. En un coup d\u2019oeil tu vois ce que tu as d\u00E9j\u00E0 exploit\u00E9 et ce qui dort encore. Les th\u00E8mes jamais faits sont marqu\u00E9s en rose.", icon:"\u2705"},
    {titre:"Bravo, tu es pr\u00EAte !", texte:"Toute la m\u00E9thode est expliqu\u00E9e dans Formation puis Vente puis Arr\u00EAte de vouloir tout vendre. Cet onglet, c\u2019est la mise en pratique. Un th\u00E8me par p\u00E9riode, et tu ne cherches plus jamais quoi poster.", icon:"\uD83C\uDF89"},
  ],
  objectifs: [
    {titre:"Bienvenue !", texte:"Cet onglet te sert \u00e0 suivre ton chiffre d\u2019affaires pendant la p\u00e9riode en cours. Regarde en haut : tu vois la p\u00e9riode actuelle et combien de jours il te reste.", icon:"\uD83D\uDC4B", cible:"decouverte-periode"},
    {titre:"Ton palier", texte:"Le palier, c\u2019est ton niveau actuel (2%, 4%, 6%...). Regarde o\u00f9 tu en es juste en dessous.", icon:"\uD83C\uDFAF", cible:"decouverte-palier"},
    {titre:"Remplis ton objectif", texte:"Dans la case Objectif en euros, \u00e9cris le chiffre d\u2019affaires que tu vises pour cette p\u00e9riode. Fais-le maintenant !", icon:"\u270F", cible:"decouverte-ca"},
    {titre:"Tes ventes personnelles", texte:"Juste en dessous, dans Dont mes ventes perso, mets un objectif et indique combien tu as d\u00e9j\u00e0 vendu.", icon:"\uD83D\uDECD", cible:"decouverte-ca"},
    {titre:"Regarde ta progression", texte:"La barre color\u00e9e te montre en un coup d\u2019oeil o\u00f9 tu en es par rapport \u00e0 ton objectif.", icon:"\uD83D\uDCC8", cible:"decouverte-ca"},
    {titre:"Ton \u00e9quipe", texte:"Si tu as des recrues, cette partie montre le chiffre d\u2019affaires de ton \u00e9quipe. Sinon, elle reste vide, c\u2019est normal.", icon:"\uD83D\uDC65", cible:"decouverte-reste"},
    {titre:"Ton historique", texte:"Une fois que tu auras termin\u00e9 au moins une p\u00e9riode, un petit r\u00e9sum\u00e9 de tes r\u00e9sultats pr\u00e9c\u00e9dents appara\u00eetra juste au-dessus. Pour l\u2019instant cette zone reste vide, c\u2019est totalement normal !", icon:"\uD83D\uDCD6", cible:"decouverte-reste"},
    {titre:"Bravo, tu es pr\u00eate !", texte:"Tu sais maintenant lire et remplir ton tableau Objectifs. Reviens ici r\u00e9guli\u00e8rement !", icon:"\uD83C\uDF89", cible:"decouverte-periode"},
  ],
};

export function DecouverteTour({outil, onClose, onStepChange}){
  const steps = DECOUVERTE[outil] || [];
  const [i, setI] = useState(0);
  useEffect(()=>{
    const s2 = steps[i];
    if(!s2) return;
    if(onStepChange) onStepChange(s2.section);
    let t=null, el=null;
    if(s2.cible){
      t=setTimeout(()=>{
        el=document.getElementById(s2.cible);
        if(el){
          el.scrollIntoView({behavior:"smooth", block:"start", inline:"nearest"});window.scrollBy(0,-70);
          el.classList.add("decouverte-highlight");
          el.style.outline="3px solid #C49A8A";
          el.style.outlineOffset="4px";
          el.style.boxShadow="0 0 0 8px rgba(196,154,138,.3)";
        }
      },150);
    }
    return ()=>{
      clearTimeout(t);
      if(el){
        el.classList.remove("decouverte-highlight");
        el.style.outline="";
        el.style.outlineOffset="";
        el.style.boxShadow="";
      }
    };
  },[i]);
  if(steps.length===0) return null;
  const s = steps[i];
  const isFirst = i===0;
  const isLast = i===steps.length-1;
  return(
    <div style={{position:"fixed",left:0,right:0,bottom:0,zIndex:9999,display:"flex",justifyContent:"center",padding:"0 .75rem .75rem",pointerEvents:"none"}}>
      <div style={{background:"white",borderRadius:16,maxWidth:400,width:"100%",boxShadow:"0 -4px 24px rgba(0,0,0,.25)",pointerEvents:"auto",border:"2px solid #C49A8A"}}>
        <div style={{background:"#3D1F0E",borderRadius:"14px 14px 0 0",padding:".7rem 1rem",display:"flex",alignItems:"center",gap:".6rem"}}>
          <span style={{fontSize:"1.3rem"}}>{s.icon}</span>
          <div style={{fontFamily:"Georgia,serif",fontSize:".92rem",color:"white",fontWeight:300,flex:1}}>{s.titre}</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#C49A8A",fontSize:"1.1rem",cursor:"pointer",lineHeight:1}}>{"\u2715"}</button>
        </div>
        <div style={{padding:".85rem 1rem"}}>
          <div style={{fontSize:".78rem",color:"#3D2B1F",lineHeight:1.6,marginBottom:".7rem"}}>{s.texte}</div>
          <div style={{display:"flex",justifyContent:"center",gap:".25rem",marginBottom:".7rem"}}>
            {steps.map((_,j)=>(<div key={j} style={{width:j===i?16:6,height:6,borderRadius:3,background:j===i?"#C49A8A":"#E8DDD4",transition:"all .2s"}}/>))}
          </div>
          <div style={{display:"flex",gap:".5rem"}}>
            {!isFirst&&<button onClick={()=>setI(i-1)} style={{flex:1,background:"none",border:"1.5px solid #C49A8A",borderRadius:9,padding:".5rem",fontSize:".76rem",fontWeight:600,color:"#C49A8A",cursor:"pointer",fontFamily:"inherit"}}>{"\u2190 Precedent"}</button>}
            {!isLast?
              <button onClick={()=>setI(i+1)} style={{flex:2,background:"#3D1F0E",color:"white",border:"none",borderRadius:9,padding:".5rem",fontSize:".8rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>{"Suivant \u2192"}</button>
              :<button onClick={onClose} style={{flex:2,background:"#3D1F0E",color:"white",border:"none",borderRadius:9,padding:".5rem",fontSize:".8rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>{"C\u2019est termin\u00e9 ! \uD83C\uDF89"}</button>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
function HomeRecap({uid, name, objPerso, textes}){
  const periodeInfo=getPeriodeInfo();
  const prenom=name.split(" ")[0];

  const pct=(r,o)=>{
    if(!o||!r||+o===0)return 0;
    return Math.min(100,Math.round(+r/+o*100));
  };

  const pctCA=objPerso?pct(objPerso.ca,objPerso.caObj):0;
  const pctRecrues=objPerso?pct(objPerso.recruesReal,objPerso.recruesObj):0;
  const hasObjCA=objPerso&&objPerso.caObj;
  const hasObjRecrues=objPerso&&objPerso.recruesObj&&objPerso.recruesObj!=="0";

  const urgent=periodeInfo.daysLeft<3;

  return(
    <div style={{marginBottom:"1rem"}}>
      {/* Bienvenue */}
      <div style={{background:`linear-gradient(135deg, ${C.brun}, ${C.brun2})`,borderRadius:16,padding:"1.4rem",marginBottom:".75rem",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-20,right:-20,width:100,height:100,borderRadius:"50%",background:"rgba(196,168,130,.1)"}}/>
        <div style={{position:"relative"}}>
          <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".18em",color:C.or,marginBottom:".35rem"}}>✦ BIENVENUE</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.blanc,lineHeight:1.25,marginBottom:".5rem"}}>
            Salut <em style={{fontStyle:"italic",color:C.pale}}>{prenom}</em> 👋
          </div>
          {textes?.messageAccueil&&(
            <p style={{fontSize:".74rem",color:C.pale,opacity:.9,lineHeight:1.6,marginBottom:0}}>{textes.messageAccueil}</p>
          )}
        </div>
      </div>

      {/* Période + objectifs */}
      <div style={{display:"grid",gridTemplateColumns:hasObjCA||hasObjRecrues?"1fr 1fr":"1fr",gap:".5rem",marginBottom:".75rem"}}>
        {/* Période */}
        <div style={{background:urgent?"#FFF3E0":C.blanc,border:`1px solid ${urgent?"#E6A817":C.pale}`,borderRadius:12,padding:".85rem"}}>
          <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:urgent?"#8B5E00":C.rose,marginBottom:".4rem"}}>⏱️ Période en cours</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:600,color:urgent?"#C44B1A":C.brun,lineHeight:1}}>
            {periodeInfo.daysLeft}<span style={{fontSize:".8rem",fontWeight:400,color:C.gris}}> j {periodeInfo.hoursLeft}h</span>
          </div>
          <div style={{fontSize:".6rem",color:C.gris,marginTop:".15rem"}}>restants{urgent?" ⚠️":""}</div>
          <div style={{height:4,background:C.pale,borderRadius:10,overflow:"hidden",marginTop:".5rem"}}>
            <div style={{height:"100%",background:urgent?"#E6A817":C.rose,width:periodeInfo.pctElapsed+"%",borderRadius:10}}/>
          </div>
        </div>

        {/* Objectif CA */}
        {hasObjCA&&(
          <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem"}}>
            <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".4rem"}}>💰 Mon CA</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:600,color:pctCA>=100?C.vert:C.brun,lineHeight:1}}>
              {pctCA}<span style={{fontSize:".8rem",fontWeight:400,color:C.gris}}>%</span>
            </div>
            <div style={{fontSize:".6rem",color:C.gris,marginTop:".15rem"}}>{objPerso.ca||0}€ / {objPerso.caObj}€</div>
            <div style={{height:4,background:C.pale,borderRadius:10,overflow:"hidden",marginTop:".5rem"}}>
              <div style={{height:"100%",background:pctCA>=100?C.vert:C.or,width:pctCA+"%",borderRadius:10}}/>
            </div>
          </div>
        )}

        {/* Objectif recrues (si pas de CA, prend la 2e colonne) */}
        {hasObjRecrues&&!hasObjCA&&(
          <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem"}}>
            <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas,marginBottom:".4rem"}}>👥 Mes recrues</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:600,color:pctRecrues>=100?C.vert:C.brun,lineHeight:1}}>
              {pctRecrues}<span style={{fontSize:".8rem",fontWeight:400,color:C.gris}}>%</span>
            </div>
            <div style={{fontSize:".6rem",color:C.gris,marginTop:".15rem"}}>{objPerso.recruesReal||0} / {objPerso.recruesObj}</div>
            <div style={{height:4,background:C.pale,borderRadius:10,overflow:"hidden",marginTop:".5rem"}}>
              <div style={{height:"100%",background:pctRecrues>=100?C.vert:C.lilas,width:pctRecrues+"%",borderRadius:10}}/>
            </div>
          </div>
        )}
      </div>

      {/* Objectif recrues — 2e ligne si CA présent aussi */}
      {hasObjCA&&hasObjRecrues&&(
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem",marginBottom:".75rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".4rem"}}>
            <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas}}>👥 Mes recrues</div>
            <div style={{fontSize:".75rem",fontWeight:700,color:pctRecrues>=100?C.vert:C.brun}}>{objPerso.recruesReal||0} / {objPerso.recruesObj} · {pctRecrues}%</div>
          </div>
          <div style={{height:5,background:C.pale,borderRadius:10,overflow:"hidden"}}>
            <div style={{height:"100%",background:pctRecrues>=100?C.vert:C.lilas,width:pctRecrues+"%",borderRadius:10,transition:"width .4s"}}/>
          </div>
        </div>
      )}

      {!hasObjCA&&!hasObjRecrues&&(
        <div style={{background:"rgba(196,154,138,.08)",border:`1px solid ${C.pale}`,borderRadius:10,padding:".7rem 1rem",marginBottom:".75rem",fontSize:".74rem",color:C.brun,lineHeight:1.6}}>
          💡 Définis tes objectifs du mois dans <strong>Tableau de bord → Mes objectifs</strong> pour les voir apparaître ici chaque jour.
        </div>
      )}

      {/* Citation du jour — carte interactive a retourner */}
      <CitationDuJour uid={uid}/>
    </div>
  );
}

// ── SUIVI RECRUES COMPONENT ───────────────────────────────────────────────────
const CHECKLIST_BLOCKS=[
  {day:"J+1",color:"#B04040",title:"Accueil immédiat",tasks:[
    {id:"c1",label:"Message de bienvenue vocal ou vidéo envoyé"},
    {id:"c2",label:"Accès Formation Démarrage Rapide transmis"},
    {id:"c3",label:"Date du call de suivi fixée"},
    {id:"c4",label:"Exercices expliqués (liste 20 / profil / story)"},
  ]},
  {day:"J+2",color:"#8B5E00",title:"Formation & exercices",tasks:[
    {id:"c5",label:"Formation terminée — vérifier avec elle"},
    {id:"c6",label:"Liste des 20 contacts réalisée"},
    {id:"c7",label:"Profil optimisé (photo + bio + lien)"},
    {id:"c8",label:"Première story publiée"},
    {id:"c9",label:"Call démarrage 30 min réalisé"},
  ]},
  {day:"J+3",color:"#4A4A9C",title:"Intégration équipe",tasks:[
    {id:"c10",label:"Ajoutée au groupe Facebook Blazing Dynasty"},
    {id:"c11",label:"Ajoutée au canal Telegram"},
    {id:"c12",label:"Accès site de formation transmis"},
    {id:"c13",label:"Présentée à la communauté"},
    {id:"c14",label:"Premier contact prospect approché"},
  ]},
  {day:"S1",color:"#5C8A60",title:"Semaine 1 — Premiers résultats",tasks:[
    {id:"c15",label:"1 story par jour (vie quotidienne)"},
    {id:"c16",label:"5+ personnes contactées en message personnel"},
    {id:"c17",label:"1 présentation de l'opportunité faite"},
    {id:"c18",label:"Première vente OU premier recrutement ✨"},
    {id:"c19",label:"Point de suivi hebdomadaire effectué"},
  ]},
  {day:"S2-4",color:"#6B5B8A",title:"Semaines 2-4 — Routine & croissance",tasks:[
    {id:"c20",label:"Contenu régulier publié (3x/semaine minimum)"},
    {id:"c21",label:"Sprint 7j complété dans l'appli"},
    {id:"c22",label:"Premier café ou Zoom découverte organisé"},
    {id:"c23",label:"2ᵉ vente ou 1ʳᵉ recrue dans son équipe"},
    {id:"c24",label:"Formation produits avancée suivie"},
    {id:"c25",label:"Bilan du mois réalisé avec distributrice"},
  ]},
];

const ALL_TASK_IDS=CHECKLIST_BLOCKS.flatMap(b=>b.tasks.map(t=>t.id));
const MAX_RECRUES=15;

function getProgress(r){
  const done=ALL_TASK_IDS.filter(id=>r.checks&&r.checks[id]).length;
  return{done,total:ALL_TASK_IDS.length,pct:Math.round(done/ALL_TASK_IDS.length*100)};
}

function phaseLabel(pct){
  if(pct===0)return{label:"Pas encore démarrée",col:C.gris};
  if(pct<30)return{label:"Démarrage J+1/J+2",col:"#B04040"};
  if(pct<60)return{label:"Intégration en cours",col:"#8B5E00"};
  if(pct<85)return{label:"Semaine 1 active",col:C.rose};
  if(pct<100)return{label:"En pleine progression",col:C.lilas};
  return{label:"Parcours complété 🎉",col:C.vert};
}

function RecrueFiche({recrue,onToggle,onRemove,uid,userName}){
  const[openBlocks,setOpenBlocks]=useState({"J+1":true});
  const[confirmDel,setConfirmDel]=useState(false);
  const[confettiTrigger,setConfettiTrigger]=useState(0);
  const{done,total,pct}=getProgress(recrue);
  const ph=phaseLabel(pct);

  useEffect(()=>{
    if(pct===100){
      setConfettiTrigger(t=>t+1);
      if(uid&&userName){
        postToWallOfFame(uid, userName, `a terminé le parcours d'onboarding de sa recrue ${recrue.name} ! 🎉`, "🌟");
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[pct]);

  return(
    <div>
      <Confetti trigger={confettiTrigger}/>
      {/* Header */}
      <div style={{background:C.brun,borderRadius:14,padding:"1rem 1.1rem",marginBottom:"1rem",display:"flex",alignItems:"center",gap:".85rem"}}>
        <div style={{width:42,height:42,borderRadius:"50%",background:C.rose,color:"white",fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          {recrue.name[0].toUpperCase()}
        </div>
        <div style={{flex:1}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,color:C.blanc}}>{recrue.name}</div>
          <div style={{fontSize:".62rem",color:C.pale,opacity:.75}}>Entrée le {recrue.date}</div>
          <div style={{fontSize:".65rem",fontWeight:700,color:ph.col,marginTop:".15rem"}}>{ph.label}</div>
        </div>
        <div style={{textAlign:"right",marginRight:".4rem"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.4rem",fontWeight:600,color:pct===100?C.vert:C.or,lineHeight:1}}>{pct}%</div>
          <div style={{fontSize:".58rem",color:C.pale,opacity:.7}}>{done}/{total}</div>
        </div>
        {!confirmDel
          ? <button onClick={()=>setConfirmDel(true)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:6,padding:".3rem .5rem",color:C.pale,cursor:"pointer",fontSize:".7rem",fontFamily:"inherit",flexShrink:0}}>✕</button>
          : <div style={{display:"flex",gap:".3rem",flexShrink:0}}>
              <button onClick={()=>onRemove(recrue.id)} style={{background:"#B04040",border:"none",borderRadius:6,padding:".3rem .55rem",color:"white",cursor:"pointer",fontSize:".65rem",fontFamily:"inherit"}}>Supprimer</button>
              <button onClick={()=>setConfirmDel(false)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:6,padding:".3rem .55rem",color:C.pale,cursor:"pointer",fontSize:".65rem",fontFamily:"inherit"}}>Annuler</button>
            </div>
        }
      </div>

      {/* Barre globale */}
      <div style={{marginBottom:"1rem"}}>
        <div style={{height:6,background:C.pale,borderRadius:10,overflow:"hidden"}}>
          <div style={{height:"100%",background:pct===100?C.vert:C.rose,width:pct+"%",borderRadius:10,transition:"width .4s"}}/>
        </div>
      </div>

      <div style={{background:"linear-gradient(135deg,rgba(196,154,138,.1),rgba(168,155,181,.07))",border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem 1rem",marginBottom:"1rem",fontSize:".74rem",color:C.texte,lineHeight:1.65}}>
        🏆 Objectif : 1 première vente ou 1 premier recrutement dans les 7 premiers jours.
      </div>

      {/* Blocs checklist */}
      {CHECKLIST_BLOCKS.map(block=>{
        const isOpen=openBlocks[block.day];
        const blockDone=block.tasks.filter(t=>recrue.checks&&recrue.checks[t.id]).length;
        const blockPct=Math.round(blockDone/block.tasks.length*100);
        return(
          <div key={block.day} style={{background:C.blanc,border:`1px solid ${isOpen?C.rose:C.pale}`,borderRadius:14,marginBottom:".6rem",overflow:"hidden",transition:"all .2s"}}>
            <div onClick={()=>setOpenBlocks(p=>({...p,[block.day]:!p[block.day]}))}
              style={{padding:".75rem 1rem",display:"flex",alignItems:"center",gap:".6rem",cursor:"pointer",userSelect:"none"}}>
              <div style={{width:32,height:32,borderRadius:"50%",background:blockPct===100?C.vert:block.color,color:"white",fontSize:".65rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {blockPct===100?"✓":block.day}
              </div>
              <div style={{flex:1}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,color:C.brun}}>{block.title}</div>
                <div style={{fontSize:".58rem",color:C.gris}}>{blockDone}/{block.tasks.length} · {blockPct}%</div>
              </div>
              <div style={{width:48,height:4,background:C.pale,borderRadius:10,overflow:"hidden",flexShrink:0}}>
                <div style={{height:"100%",background:blockPct===100?C.vert:block.color,width:blockPct+"%",borderRadius:10,transition:"width .3s"}}/>
              </div>
              <div style={{color:C.rose,fontSize:".65rem",transform:isOpen?"rotate(180deg)":"none",transition:"transform .2s",flexShrink:0}}>▼</div>
            </div>
            {isOpen&&(
              <div style={{borderTop:`1px solid ${C.pale}`,padding:".6rem 1rem .8rem"}}>
                {block.tasks.map(task=>{
                  const checked=recrue.checks&&recrue.checks[task.id];
                  return(
                    <div key={task.id} onClick={()=>onToggle(recrue.id,task.id)}
                      style={{display:"flex",alignItems:"flex-start",gap:".55rem",padding:".42rem 0",borderBottom:`1px solid rgba(232,213,204,.3)`,cursor:"pointer"}}>
                      <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${checked?block.color:C.rose}`,background:checked?block.color:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center",transition:"all .15s"}}>
                        {checked&&<span style={{fontSize:".55rem",color:"white",fontWeight:700}}>✓</span>}
                      </div>
                      <div style={{fontSize:".75rem",color:checked?C.gris:C.texte,textDecoration:checked?"line-through":"none",lineHeight:1.45,flex:1}}>{task.label}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export function SuiviRecruTab({uid, isChef=false}){
  const[filleules,setFilleules]=useState([]);
  const[loading,setLoading]=useState(true);
  const[sel,setSel]=useState(null);
  const[extras,setExtras]=useState({}); // uid -> {fastStart, caPerso, premiere_commande}
  const[loadingExtra,setLoadingExtra]=useState({});
  const[voirToute,setVoirToute]=useState(isChef);

  // Une recrue est "nouvelle" si inscrite il y a moins de 14 jours
  const estNouvelle=(f)=>{
    if(!f.dateEnreg)return false;
    const jours=(Date.now()-new Date(f.dateEnreg).getTime())/(1000*60*60*24);
    return jours<=14;
  };

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"equipe","annuaire"));
        if(snap.exists()){
          const membres=snap.data().membres||{};
          let liste;
          if(voirToute){
            // Chef d'équipe : toute la lignée (filleules + sous-filleules, récursif)
            const tree=buildEquipeTree(membres,uid);
            const aplatir=(nodes,niveau=1)=>nodes.flatMap(n=>[{...n,niveau},...aplatir(n.enfants||[],niveau+1)]);
            liste=aplatir(tree).sort((a,b)=>new Date(b.dateEnreg||0)-new Date(a.dateEnreg||0));
          } else {
            // Distributrice simple : filleules directes uniquement
            liste=Object.entries(membres)
              .filter(([,m])=>m.marraine===uid)
              .map(([mUid,m])=>({uid:mUid,...m,niveau:1}))
              .sort((a,b)=>new Date(b.dateEnreg||0)-new Date(a.dateEnreg||0));
          }
          setFilleules(liste);
        }
      }catch{}
      setLoading(false);
    })();
  },[uid,voirToute]);

  const chargerExtra=async(mUid)=>{
    if(extras[mUid])return;
    setLoadingExtra(p=>({...p,[mUid]:true}));
    try{
      const snap=await getDoc(doc(db,"users",mUid));
      if(snap.exists()){
        const d=snap.data();
        const obj=d["db-obj-perso"]?JSON.parse(d["db-obj-perso"]):{};
        setExtras(p=>({...p,[mUid]:{
          fastStart:d["db-fast-start"]?JSON.parse(d["db-fast-start"]):null,
          caPerso:parseFloat(obj.caPerso)||0,
          premiereCommande:!!obj.caPerso&&parseFloat(obj.caPerso)>0,
          premiereCommandeManuelle:d["premiere_commande_validee"]||false,
        }}));
      }
    }catch{}
    setLoadingExtra(p=>({...p,[mUid]:false}));
  };

  const validerPremiereCommande=async(mUid,val)=>{
    try{
      await setDoc(doc(db,"users",mUid),{premiere_commande_validee:val},{merge:true});
      setExtras(p=>({...p,[mUid]:{...p[mUid],premiereCommandeManuelle:val}}));
    }catch{}
  };

  const retirerFastStart=async(mUid,nom)=>{
    if(!window.confirm("Retirer le Fast Start de "+nom+" ?")) return;
    try{
      await setDoc(doc(db,"users",mUid),{"db-fast-start":""},  {merge:true});
      alert("Fast Start retiré pour "+nom);
    }catch(e){alert("Erreur");}
  };

  const assignerFastStart=async(mUid,nom)=>{
    try{
      const ref=doc(db,"users",mUid);
      const snap=await getDoc(ref);
      const existing=snap.exists()&&snap.data()["db-fast-start"]?JSON.parse(snap.data()["db-fast-start"]):{};
      if(!existing.startDate){
        await setDoc(ref,{"db-fast-start":JSON.stringify({startDate:todayLocalStr(),doneTasks:{},modulesValides:{}})},{merge:true});
        alert("✅ Fast Start assigné à "+nom);
        chargerExtra(mUid);
      } else {
        if(window.confirm(nom+" a déjà un Fast Start. Relancer ?")){
          await setDoc(ref,{"db-fast-start":JSON.stringify({startDate:todayLocalStr(),doneTasks:{},modulesValides:{}})},{merge:true});
          setExtras(p=>({...p,[mUid]:{...p[mUid],fastStart:{startDate:todayLocalStr(),doneTasks:{},modulesValides:{}}}}));
        }
      }
    }catch{alert("Erreur.");}
  };

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  if(filleules.length===0)return(
    <div style={{textAlign:"center",padding:"2rem",color:C.gris}}>
      <div style={{fontSize:"2rem",marginBottom:".5rem"}}>👑</div>
      <div style={{fontFamily:"Georgia,serif",fontSize:".95rem",color:C.brun,marginBottom:".3rem"}}>Aucune recrue pour l'instant</div>
      <div style={{fontSize:".72rem"}}>Tes filleules apparaîtront ici dès qu'elles s'inscrivent avec toi comme marraine.</div>
    </div>
  );

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".5rem"}}>
        Suivi <em style={{fontStyle:"italic",color:C.rose}}>nouvelles distributrices</em>
      </div>

      {isChef&&(
        <div style={{display:"flex",gap:".3rem",marginBottom:".5rem"}}>
          <button onClick={()=>setVoirToute(true)}
            style={{flex:1,padding:".4rem",fontSize:".68rem",fontWeight:600,borderRadius:9,border:`1px solid ${voirToute?C.rose:C.pale}`,background:voirToute?C.rose:C.blanc,color:voirToute?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
            👑 Toute mon équipe ({filleules.length})
          </button>
          <button onClick={()=>setVoirToute(false)}
            style={{flex:1,padding:".4rem",fontSize:".68rem",fontWeight:600,borderRadius:9,border:`1px solid ${!voirToute?C.rose:C.pale}`,background:!voirToute?C.rose:C.blanc,color:!voirToute?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
            Mes filleules directes
          </button>
        </div>
      )}

      {filleules.filter(estNouvelle).length>0&&(
        <div style={{display:"flex",alignItems:"center",gap:".4rem",background:C.or+"10",border:`1px solid ${C.or}40`,borderRadius:9,padding:".5rem .75rem",marginBottom:".75rem"}}>
          <span style={{fontSize:"1rem"}}>🆕</span>
          <span style={{fontSize:".72rem",color:C.brun,fontWeight:600}}>{filleules.filter(estNouvelle).length} nouvelle{filleules.filter(estNouvelle).length>1?"s":""} recrue{filleules.filter(estNouvelle).length>1?"s":""} (- de 14 jours)</span>
        </div>
      )}

      {filleules.map(f=>{
        const isOpen=sel===f.uid;
        const ex=extras[f.uid];
        const fs=ex?.fastStart;
        const modulesValides=fs?Object.values(fs.modulesValides||{}).filter(Boolean).length:0;
        const totalTaches=fs?FAST_START_DAYS.reduce((s,d2)=>s+d2.taches.length,0):0;
        const done=fs?FAST_START_DAYS.reduce((s,d2)=>s+d2.taches.filter((_,i)=>fs.doneTasks?.[`${d2.jour}-${i}`]).length,0):0;
        const pctGlobal=totalTaches?Math.round(done/totalTaches*100):0;
        const aPremiereCommande=ex?.premiereCommandeManuelle||(ex?.caPerso>0);

        return(
          <div key={f.uid} style={{background:C.blanc,border:`1.5px solid ${isOpen?C.rose:C.pale}`,borderRadius:12,marginBottom:".5rem",overflow:"hidden"}}>
            {/* Ligne résumé */}
            <div onClick={()=>{setSel(isOpen?null:f.uid);if(!isOpen&&!ex)chargerExtra(f.uid);}}
              style={{display:"flex",alignItems:"center",gap:".6rem",padding:".65rem .9rem",cursor:"pointer",background:estNouvelle(f)?C.or+"08":"transparent"}}>
              <div style={{width:36,height:36,borderRadius:"50%",background:estNouvelle(f)?C.or+"25":C.rose+"20",color:estNouvelle(f)?C.or:C.rose,fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,border:estNouvelle(f)?`2px solid ${C.or}`:"none"}}>
                {(f.prenom||"?")[0].toUpperCase()}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:".4rem",flexWrap:"wrap"}}>
                  <div style={{fontSize:".82rem",fontWeight:600,color:C.brun}}>{f.prenom} {f.nom}</div>
                  {estNouvelle(f)&&(
                    <span style={{fontSize:".55rem",fontWeight:700,color:"white",background:C.or,borderRadius:20,padding:".1rem .45rem"}}>🆕 Nouvelle</span>
                  )}
                  {voirToute&&f.niveau>1&&(
                    <span style={{fontSize:".55rem",fontWeight:700,color:C.lilas,background:C.lilas+"15",borderRadius:20,padding:".1rem .4rem"}}>N{f.niveau}</span>
                  )}
                </div>
                <div style={{fontSize:".6rem",color:C.gris,display:"flex",gap:".5rem",alignItems:"center",marginTop:".1rem"}}>
                  {f.dateEnreg&&<span>📅 {new Date(f.dateEnreg).toLocaleDateString("fr-FR",{day:"numeric",month:"short",year:"numeric"})}</span>}
                  {fs&&<span style={{color:pctGlobal>=100?C.vert:C.rose}}>🚀 {modulesValides}/7 modules</span>}
                  {!fs&&<span style={{color:C.pale}}>Pas de Fast Start</span>}
                </div>
              </div>
              {/* Badge première commande */}
              <div style={{display:"flex",flexDirection:"column",gap:".2rem",alignItems:"flex-end"}}>
                <div style={{fontSize:".58rem",fontWeight:700,color:aPremiereCommande?C.vert:C.pale,background:aPremiereCommande?C.vert+"15":"transparent",borderRadius:20,padding:".1rem .35rem",border:`1px solid ${aPremiereCommande?C.vert:C.pale}`}}>
                  {aPremiereCommande?"✅ 1ère cmd":"⏳ pas de cmd"}
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:".25rem",alignItems:"flex-end"}}>
                <button onClick={e=>{e.stopPropagation();if(window.confirm("Retirer "+f.prenom+" de cette liste de suivi ?")){setFilleules(fl=>fl.filter(x=>x.uid!==f.uid));if(sel===f.uid)setSel(null);}}}
                  style={{background:"none",border:`1px solid #E0C0C0`,borderRadius:6,padding:".15rem .4rem",fontSize:".58rem",color:"#B04040",cursor:"pointer",fontFamily:"inherit"}}>
                  ✕ Retirer
                </button>
              </div>
              <div style={{fontSize:".75rem",color:C.gris,transform:isOpen?"rotate(90deg)":"none",transition:"transform .2s",flexShrink:0}}>›</div>
            </div>

            {/* Détail déplié */}
            {isOpen&&(
              <div style={{borderTop:`1px solid ${C.pale}`,padding:".85rem 1rem"}}>
                {loadingExtra[f.uid]&&<div style={{textAlign:"center",color:C.gris,fontSize:".75rem",padding:".5rem"}}>Chargement...</div>}

                {ex&&(
                  <div>
                    {/* Première commande */}
                    <div style={{background:aPremiereCommande?C.vert+"10":"#FFF8E1",border:`1px solid ${aPremiereCommande?C.vert+"30":"#E6A817"}`,borderRadius:10,padding:".6rem .85rem",marginBottom:".75rem"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <div>
                          <div style={{fontSize:".7rem",fontWeight:700,color:aPremiereCommande?C.vent:"#856404"}}>🛍️ Première commande</div>
                          {ex.caPerso>0&&<div style={{fontSize:".62rem",color:C.gris,marginTop:".1rem"}}>CA perso détecté : {ex.caPerso}€</div>}
                        </div>
                        <label style={{display:"flex",alignItems:"center",gap:".4rem",cursor:"pointer"}}>
                          <input type="checkbox" checked={!!aPremiereCommande}
                            onChange={e=>validerPremiereCommande(f.uid,e.target.checked)}/>
                          <span style={{fontSize:".7rem",color:C.brun,fontWeight:600}}>Valider manuellement</span>
                        </label>
                      </div>
                    </div>

                    {/* Fast Start */}
                    {fs
                      ?<div>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".5rem"}}>
                          <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose}}>🚀 Suivi Fast Start</div>
                          <div style={{display:"flex",gap:".4rem",alignItems:"center"}}>
                            <span style={{fontSize:".6rem",color:C.gris}}>J1 : {fs.startDate?new Date(fs.startDate).toLocaleDateString("fr-FR",{day:"numeric",month:"short"}):"-"}</span>
                            <button onClick={()=>retirerFastStart(f.uid,f.prenom+" "+f.nom)}
                              style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:7,padding:".25rem .55rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit",marginRight:".3rem"}}>
                              ✕ Retirer FS
                            </button>
                            <button onClick={()=>retirerFastStart(f.uid,f.prenom+" "+f.nom)}
                          style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:7,padding:".25rem .55rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit",marginRight:".3rem"}}>
                          ✕ Retirer FS
                        </button>
                        <button onClick={()=>assignerFastStart(f.uid,f.prenom+" "+f.nom)}
                              style={{background:C.rose+"15",border:`1px solid ${C.rose}40`,borderRadius:6,padding:".15rem .45rem",fontSize:".6rem",color:C.rose,cursor:"pointer",fontFamily:"inherit"}}>🔄 Relancer</button>
                          </div>
                        </div>

                        {/* Barre globale */}
                        <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:9,padding:".55rem .75rem",marginBottom:".6rem"}}>
                          <div style={{display:"flex",justifyContent:"space-between",marginBottom:".25rem"}}>
                            <span style={{fontSize:".62rem",color:C.or,fontWeight:700}}>{modulesValides}/7 modules validés</span>
                            <span style={{fontSize:".62rem",color:C.pale}}>{done}/{totalTaches} tâches · {pctGlobal}%</span>
                          </div>
                          <div style={{height:5,background:"rgba(255,255,255,.15)",borderRadius:10,overflow:"hidden"}}>
                            <div style={{height:"100%",background:pctGlobal>=100?C.vert:C.or,width:pctGlobal+"%",borderRadius:10}}/>
                          </div>
                        </div>

                        {/* Les 7 modules — interface Fast Start */}
                        {FAST_START_DAYS.map(d2=>{
                          const moduleValide=fs.modulesValides?.[d2.jour];
                          const prevValide=d2.jour===1?true:!!fs.modulesValides?.[d2.jour-1];
                          const isLocked=!prevValide&&!moduleValide;
                          const tachesDone=d2.taches.filter((_,i)=>fs.doneTasks?.[`${d2.jour}-${i}`]).length;
                          const total2=d2.taches.length;
                          return(
                            <div key={d2.jour} style={{background:moduleValide?C.vert+"08":C.blanc,border:`1.5px solid ${moduleValide?C.vert:isLocked?C.pale:tachesDone>0?C.or:C.pale}`,borderRadius:11,padding:".65rem .85rem",marginBottom:".4rem",opacity:isLocked?.5:1}}>
                              <div style={{display:"flex",alignItems:"center",gap:".55rem"}}>
                                <div style={{width:26,height:26,borderRadius:"50%",background:moduleValide?C.vert:isLocked?C.pale:tachesDone>0?C.or+"30":C.creme,color:moduleValide?"white":isLocked?C.pale:C.brun,display:"flex",alignItems:"center",justifyContent:"center",fontSize:".7rem",fontWeight:700,flexShrink:0}}>
                                  {moduleValide?"✓":isLocked?"🔒":d2.jour}
                                </div>
                                <div style={{flex:1}}>
                                  <div style={{fontSize:".75rem",fontWeight:700,color:moduleValide?C.vent:isLocked?C.gris:C.brun,lineHeight:1.3}}>{d2.titre}</div>
                                  <div style={{height:3,background:C.pale,borderRadius:10,overflow:"hidden",marginTop:".2rem"}}>
                                    <div style={{height:"100%",background:moduleValide?C.vent:C.rose,width:(tachesDone/total2*100)+"%",borderRadius:10}}/>
                                  </div>
                                </div>
                                <div style={{fontSize:".62rem",fontWeight:700,color:moduleValide?C.vent:C.gris,flexShrink:0,textAlign:"right"}}>
                                  {moduleValide?"✅":isLocked?"🔒":`${tachesDone}/${total2}`}
                                </div>
                              </div>
                              {/* Tâches */}
                              {!isLocked&&tachesDone>0&&(
                                <div style={{paddingLeft:".5rem",marginTop:".35rem"}}>
                                  {d2.taches.map((tache,i)=>{
                                    const fait=!!fs.doneTasks?.[`${d2.jour}-${i}`];
                                    const txt=typeof tache==="string"?tache:tache.t;
                                    return fait?(
                                      <div key={i} style={{display:"flex",alignItems:"center",gap:".4rem",padding:".18rem 0",fontSize:".68rem",color:C.vent}}>
                                        <span style={{color:C.vert,fontWeight:700,flexShrink:0}}>✓</span>
                                        <span style={{textDecoration:"line-through",color:C.gris}}>{txt}</span>
                                      </div>
                                    ):null;
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      :<div style={{background:C.creme,borderRadius:9,padding:".75rem",textAlign:"center"}}>
                        <div style={{fontSize:".72rem",color:C.gris,marginBottom:".5rem"}}>🚀 Pas de Fast Start assigné</div>
                        <button onClick={()=>retirerFastStart(f.uid,f.prenom+" "+f.nom)}
                          style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:7,padding:".25rem .55rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit",marginRight:".3rem"}}>
                          ✕ Retirer FS
                        </button>
                        <button onClick={()=>assignerFastStart(f.uid,f.prenom+" "+f.nom)}
                          style={{background:C.rose,color:"white",border:"none",borderRadius:8,padding:".42rem .85rem",fontSize:".75rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                          Assigner le Fast Start
                        </button>
                      </div>
                    }
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export function ConversionPopup({prospect:p, clients, distributeurs, saveClients, saveDistributeurs, saveProspects, prospects, onClose}){
  const prenom = p.name.split(" ")[0]||p.name;
  const nom = p.name.split(" ").slice(1).join(" ")||"";
  const[tel,setTel]=useState(p.tel||"");
  const[email,setEmail]=useState(p.email||"");
  const[vers,setVers]=useState(null);

  const doublon = vers==="distributrice" ? distributeurs.find(d=>
    (d.prenom?.toLowerCase()===prenom.toLowerCase()&&d.nom?.toLowerCase()===nom.toLowerCase())||(tel&&d.tel===tel)
  ) : null;

  const confirmer=()=>{
    if(vers==="client"){
      const newClient={id:`c${Date.now()}`,prenom,nom,tel,email,notes:p.note||"",commandes:[],dateAjout:todayLocalStr()};
      saveClients([...clients,newClient]);
    } else if(vers==="distributrice"){
      if(doublon){
        saveDistributeurs(distributeurs.map(d=>d.id===doublon.id?{...d,tel:tel||d.tel,email:email||d.email,prospectId:p.id}:d));
      } else {
        const newDistrib={id:`d${Date.now()}`,prenom,nom,tel,email,palier:"2%",notes:p.note||"",dateEnreg:todayLocalStr(),prospectId:p.id};
        saveDistributeurs([...distributeurs,newDistrib]);
      }
    }
    onClose();
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9999}}>
      <div style={{background:C.blanc,borderRadius:"18px 18px 0 0",width:"100%",maxWidth:480,padding:"1.5rem",boxShadow:"0 -8px 40px rgba(0,0,0,.3)"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun,marginBottom:".25rem"}}>✅ {p.name} est convertie !</div>
        <div style={{fontSize:".72rem",color:C.gris,marginBottom:"1.2rem"}}>Elle est retirée des prospects. Où veux-tu l'ajouter ?</div>
        <div style={{display:"flex",gap:".5rem",marginBottom:"1rem"}}>
          {[{v:"client",icon:"🛍️",label:"Cliente",color:C.vert},{v:"distributrice",icon:"👑",label:"Distributrice",color:C.or}].map(opt=>(
            <button key={opt.v} onClick={()=>setVers(opt.v)}
              style={{flex:1,background:vers===opt.v?opt.color:opt.color+"15",color:vers===opt.v?"white":opt.color,border:`2px solid ${opt.color}`,borderRadius:10,padding:".6rem",fontSize:".82rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
              {opt.icon} {opt.label}
            </button>
          ))}
        </div>
        {vers&&(
          <div style={{background:C.creme,borderRadius:10,padding:".85rem",marginBottom:"1rem"}}>
            <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".5rem"}}>Coordonnées</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".4rem",marginBottom:".4rem"}}>
              <div style={{fontSize:".65rem",color:C.gris}}>Prénom : <strong style={{color:C.brun}}>{prenom}</strong></div>
              <div style={{fontSize:".65rem",color:C.gris}}>Nom : <strong style={{color:C.brun}}>{nom||"—"}</strong></div>
            </div>
            <input value={tel} onChange={e=>setTel(e.target.value)} placeholder="Téléphone / WhatsApp"
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".4rem"}}/>
            <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email"
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none"}}/>
            {doublon&&(
              <div style={{background:C.or+"20",border:`1px solid ${C.or}`,borderRadius:8,padding:".45rem .65rem",marginTop:".4rem",fontSize:".68rem",color:C.brun}}>
                ⚠️ Fiche existante : <strong>{doublon.prenom} {doublon.nom}</strong> — sera mise à jour sans doublon.
              </div>
            )}
          </div>
        )}
        <div style={{display:"flex",gap:".5rem"}}>
          <button onClick={onClose}
            style={{flex:1,background:C.pale,color:C.gris,border:"none",borderRadius:9,padding:".6rem",fontSize:".78rem",fontFamily:"inherit",cursor:"pointer"}}>
            Ignorer
          </button>
          <button onClick={confirmer} disabled={!vers}
            style={{flex:2,background:vers?C.brun:C.pale,color:vers?C.blanc:C.gris,border:"none",borderRadius:9,padding:".6rem",fontSize:".82rem",fontWeight:700,fontFamily:"inherit",cursor:vers?"pointer":"default"}}>
            {vers?"✓ Confirmer le transfert":"Choisir une destination"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── SUIVI CLIENTS ─────────────────────────────────────────────────────────────
const INP = (props) => <input {...props} style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".45rem",...props.style}}/>;

// Types de produits courants avec durée d'utilisation typique (en jours) — pour les rappels de réapprovisionnement
const TYPES_PRODUITS_DUREE=[
  {id:"shampoing",label:"🧴 Shampoing",jours:45},
  {id:"soin-cheveux",label:"💇 Soin/masque cheveux",jours:60},
  {id:"gel-douche",label:"🚿 Gel douche",jours:30},
  {id:"creme-visage",label:"✨ Crème visage",jours:60},
  {id:"serum",label:"💧 Sérum",jours:60},
  {id:"contour-yeux",label:"👁️ Contour des yeux",jours:75},
  {id:"baume-corps",label:"🧴 Baume/lait corps",jours:45},
  {id:"deodorant",label:"🌿 Déodorant",jours:60},
  {id:"parfum",label:"🌸 Parfum",jours:180},
  {id:"complement",label:"💊 Complément alimentaire",jours:30},
  {id:"maquillage",label:"💄 Maquillage",jours:90},
  {id:"autre",label:"📦 Autre",jours:30},
];

// Scripts de relance réapprovisionnement, par gamme — {produit} est remplacé par le nom tapé dans la commande
const SCRIPTS_RELANCE_GAMME={
  skincare:"Coucou {prenom} ! 😊 Je me disais que ton {produit} doit bientôt arriver à la fin... Comment se porte ta peau avec ? Si tu veux, je peux te renvoyer la même référence ou te conseiller autre chose selon ce que tu ressens en ce moment 💛",
  "soins-cheveux":"Hello {prenom} ! Petite pensée pour toi 🌸 Ton {produit} doit être presque terminé non ? Comment tu trouves le résultat sur tes cheveux ? Dis-moi si tu veux qu'on en recommande, ou si tu préfères essayer autre chose cette fois !",
  complements:"Coucou {prenom} ! Ça fait un petit moment que tu as commencé ton {produit} — comment tu te sens, des effets que tu remarques ? 😊 Si tu veux continuer la cure, c'est le bon moment pour recommander avant la fin du pot !",
  corps:"Hey {prenom} ! 🧴 Ton {produit} doit bientôt être fini... Tu en es contente ? Je peux te le renvoyer si tu veux, ou te faire découvrir une autre texture pour changer un peu 😊",
  parfum:"Coucou {prenom} ! Petit message pour prendre de tes nouvelles 🌸 Ton {produit} doit être presque vide... Toujours autant fan de cette odeur ou tu serais tentée d'essayer une nouvelle fragrance ?",
  entretien:"Hello {prenom} ! 🌿 Ton {produit} doit bientôt arriver à la fin — verdict, tu l'as trouvé efficace ? Je te le remets de côté si tu veux, dis-moi !",
};

// Mappe chaque type de produit (TYPES_PRODUITS_DUREE) vers sa gamme de script
const TYPE_TO_GAMME={
  shampoing:"soins-cheveux", "soin-cheveux":"soins-cheveux",
  "gel-douche":"corps","baume-corps":"corps","deodorant":"corps",
  "creme-visage":"skincare",serum:"skincare","contour-yeux":"skincare",maquillage:"skincare",
  parfum:"parfum",
  complement:"complements",
  autre:"entretien",
};

function genererScriptRelance(ligne, prenomClient){
  const gamme = TYPE_TO_GAMME[ligne.typeProduit]||"entretien";
  const template = SCRIPTS_RELANCE_GAMME[gamme]||SCRIPTS_RELANCE_GAMME.entretien;
  return template.replace(/{produit}/g, ligne.nom).replace(/{prenom}/g, prenomClient||"toi");
}


// Formulaire édition client avec state local pour éviter le re-render de la liste
// Fiche cliente complète — composant isolé pour éviter le re-render de la liste


// ── SCRIPTS ───────────────────────────────────────────────────────────────────
export const SCRIPTS_DATA=[
  {cat:"🔬 Proposer un diagnostic",scripts:[
    {title:"Story / DM — Diagnostic Peau (général)",text:"🌸 Tu veux enfin comprendre ce dont ta peau a VRAIMENT besoin ?\n\nJe te propose un diagnostic beauté personnalisé — 100% gratuit, 2 minutes chrono ✨\n\nÀ la clé : une ordonnance sur mesure avec les produits faits pour toi 💊\n\n👇 Écris-moi DIAGNOSTIC en MP et je t'envoie le lien !"},
    {title:"DM — Diagnostic Skincare ciblé",text:"Coucou [Prénom] ! 👋\n\nJ'ai vu que tu posais des questions sur [problème peau/routine]... J'ai quelque chose qui pourrait vraiment t'aider !\n\nJe fais des diagnostics peau personnalisés — 5 questions et je te propose une routine adaptée à TON profil avec des produits que j'adore 🌿\n\nC'est gratuit et sans engagement. Tu veux essayer ? 😊"},
    {title:"DM — Diagnostic Cheveux",text:"Coucou [Prénom] ! Je pensais à toi en voyant [contexte]...\n\nEst-ce que tes cheveux te posent des problèmes en ce moment ? (sécheresse, chute, frisottis, etc.)\n\nJe propose des diagnostics capillaires gratuits — ça prend 2 minutes et tu repars avec des conseils 100% adaptés à tes cheveux 💇‍♀️\n\nTu veux que je t'envoie le lien ?"},
    {title:"DM — Diagnostic Makeup & couleurs",text:"Coucou [Prénom] ! 💄\n\nSi tu cherches le maquillage adapté à TON teint, TON style et TON budget... j'ai créé un diagnostic makeup personnalisé !\n\n→ Teinte de fond de teint\n→ Couleurs qui te valorisent\n→ Produits adaptés à ta morphologie\n\nC'est gratuit, ça prend 3 min. Tu veux l'essayer ? 🎨"},
    {title:"DM — Diagnostic Compléments / Minceur",text:"Coucou [Prénom] ! Je voulais te partager quelque chose...\n\nJ'ai un diagnostic bien-être qui aide à identifier exactement QUELS compléments alimentaires peuvent t'aider selon tes objectifs (énergie, minceur, immunité, sommeil...)\n\nBeaucoup de gens prennent des compléments qui ne sont pas adaptés à leurs besoins — ce diagnostic évite ça 💊\n\n2 minutes, gratuit, sans engagement. Ça t'intéresse ? ✨"},
    {title:"DM — Diagnostic Peau Corps",text:"Coucou [Prénom] ! 🌿\n\nEst-ce que tu as des problèmes de peau sur le corps ? (sécheresse, taches, capitons, sensibilité...)\n\nJe fais des diagnostics corps personnalisés pour proposer une routine adaptée. Pas juste \"hydrate-toi\" — une vraie sélection de produits pour TES problèmes spécifiques 💆‍♀️\n\nC'est gratuit, 2 min. Tu veux essayer ?"},
    {title:"DM — Diagnostic Entrepreneur (recrutement)",text:"Coucou [Prénom] ! 😊\n\nJe propose un mini-diagnostic pour savoir si le marketing de réseau pourrait être une option pour toi — sans pression, juste pour avoir une vision claire de ton profil et de tes possibilités.\n\n5 questions, pas de jugement, 100% honnête. Et si ce n'est pas fait pour toi, je te le dirai aussi 😄\n\nTu serais tentée d'essayer ?"},
    {title:"Story — Booster diagnostic (engagement)",text:"🔬 J'ai envoyé [X] diagnostics ce mois-ci...\n\nRésultat : des femmes qui comprennent ENFIN leur peau / leurs cheveux / leurs besoins 🌸\n\n→ Une routine sur mesure\n→ Des produits qu'elles adorent\n→ Des résultats concrets\n\nTu n'as pas encore fait le tien ?\n\n👉 Écris-moi DIAGO en commentaire ou en MP 💬"},
    {title:"Story — Résultat diagnostic (preuve sociale)",text:"Avant le diagnostic : \"Je ne sais pas quels produits prendre, j'ai tout essayé sans résultat\" 😔\n\nAprès le diagnostic : une routine de 3 produits adaptée à son profil exact ✨\n\n→ Résultat en 3 semaines 🌟\n\nC'est ce que j'offre gratuitement à chaque femme qui fait mon diagnostic.\n\nTu veux être la prochaine ? 👇 MP ou commentaire"},
    {title:"Story — Teasing diagnostic makeup",text:"POV : tu portes depuis 3 ans une teinte de fond de teint qui n'est pas vraiment la tienne 😅\n\nJe fais des diagnostics makeup — couleurs, teinte, style — pour trouver exactement ce qui te va.\n\nEt ça change TOUT.\n\n💄 Écris MAKEUP en commentaire pour essayer"},
    {title:"Reel — Accroche diagnostic peau",text:"❌ Tu achètes des produits au hasard sur TikTok\n❌ Tu ne comprends pas pourquoi ta peau ne s'améliore pas\n❌ Tu dépenses une fortune sans résultats\n\n✅ Ce qu'il te faut : un diagnostic peau\n✅ Gratuit\n✅ 2 minutes\n✅ Une ordonnance personnalisée\n\nÉcris PEAU en commentaire 👇"},
    {title:"Approche indirecte — via problème observé",text:"Hé [Prénom] ! J'ai vu ta story avec [problème de peau/cheveux/etc.] — tu galères avec ça depuis longtemps ?\n\nSans pression, mais j'ai un truc qui pourrait vraiment aider. Je fais des petits diagnostics beauté — tu réponds à quelques questions et je te fais une sélection de produits sur mesure.\n\nC'est gratuit. Tu veux qu'on essaie ? 🌸"},
    {title:"Approche via curiosité (mystère)",text:"[Prénom], je t'envoie quelque chose demain que j'envoie seulement à quelques personnes dans mon entourage...\n\n[lendemain]\n\nVoilà ! C'est un diagnostic beauté personnalisé. Ça prend 2 min et tu repars avec une sélection de produits faite pour toi. Gratuit bien sûr 😊\n\nTu veux essayer ?"},
    {title:"Approche via résultat d'une cliente",text:"Je viens de recevoir un message d'une cliente qui a fait mon diagnostic la semaine dernière... Elle me dit que la routine que je lui ai recommandée a changé l'état de sa peau en 10 jours 🤍\n\nSi tu veux, je peux faire le tien aussi ? C'est gratuit et ça prend 2 minutes 😊"},
  ]},
{cat:"🎁 Recommandation",scripts:[
    {title:"Après une commande — demande de recommandation",text:"Merci encore pour ta commande [Prénom] ! 🥰\n\nSi jamais tu as autour de toi une amie qui pourrait aimer ces produits, n'hésite pas à lui parler de moi — je m'occupe d'elle avec le même soin que toi 💛\n\nEt en général, je fais un petit geste pour te remercier de la recommandation 😊"},
    {title:"DM — Lancer le programme recommandation",text:"Coucou [Prénom] ! 👋\n\nTu sais que quand tu me recommandes une amie et qu'elle passe commande, tu peux avoir un petit cadeau ou une réduction ? 🎁\n\nSi tu as quelqu'un en tête qui pourrait aimer les produits, dis-le moi !"},
    {title:"Story — Programme recommandation",text:"🎁 Le savais-tu ?\n\nQuand tu recommandes une amie et qu'elle commande, VOUS êtes gagnantes toutes les deux !\n\nElle découvre des produits qu'elle va adorer, et toi tu reçois un petit merci de ma part 💛\n\nÉcris-moi RECO en MP pour en savoir plus"},
    {title:"Après un retour positif client",text:"Je suis trop contente que le produit te plaise autant [Prénom] ! 🥰\n\nSi tu as une copine qui pourrait en profiter aussi, je serais ravie de m'occuper d'elle. Et comme dit, je te remercie toujours pour les recommandations 🎁"},
    {title:"Relance douce — programme recommandation",text:"Coucou [Prénom] ! Juste un petit rappel amical 😊\n\nSi jamais l'occasion se présente et que tu penses à quelqu'un qui pourrait aimer nos produits, n'oublie pas que je récompense toujours les recommandations !\n\nMerci d'avance si tu penses à moi 💛"},
    {title:"Story — Preuve sociale recommandation",text:"[Prénom] m'a recommandé sa copine cette semaine et résultat : 2 clientes hyper contentes ET un petit cadeau pour la remercier 🎁\n\nSi toi aussi tu as quelqu'un en tête, dis-le moi en MP !"},
    {title:"Explication du programme (message complet)",text:"Petite info que j'aime bien partager 😊\n\nQuand tu recommandes quelqu'un et que cette personne passe sa première commande grâce à toi, je te fais un petit geste de remerciement (cadeau ou réduction selon le montant).\n\nC'est ma façon de dire merci pour la confiance ! Si quelqu'un te vient en tête, envoie-moi juste son prénom et je m'en occupe avec plaisir 💛"},
  ]},
  {cat:"💎 Carte fidélité",scripts:[
    {title:"Présentation carte fidélité après 1ère commande",text:"Merci pour ta première commande [Prénom] ! 🥰\n\nPetite info : j'ai une carte de fidélité pour mes clientes. À chaque commande, tu avances vers des petits cadeaux ou réductions 🎁\n\nJe te tiens au courant de ta progression, pas besoin de t'en occuper !"},
    {title:"DM — Rappel carte fidélité",text:"Coucou [Prénom] ! 👋\n\nPetit rappel sympa : tu es à [X] commandes de ta prochaine récompense sur ta carte fidélité ! 🎉\n\nSi tu as besoin de quelque chose, n'hésite pas, ça te rapproche encore plus de ton cadeau 💛"},
    {title:"Story — Carte fidélité (explication générale)",text:"💎 Mes clientes fidèles ont un avantage :\n\nÀ chaque commande, elles avancent sur leur carte fidélité et débloquent des cadeaux ou réductions exclusives.\n\nC'est ma façon de vous remercier pour votre confiance 🥰\n\nTu es déjà cliente ? Écris-moi pour connaître ta progression !"},
    {title:"Carte fidélité complète — félicitations",text:"[Prénom] ! Tu as complété ta carte de fidélité ! 🎉🎉🎉\n\nTon cadeau t'attend — dis-moi comment tu veux le récupérer 🥰 Merci infiniment pour ta fidélité, ça me touche beaucoup !"},
    {title:"Relance — encourager à continuer",text:"Coucou [Prénom] ! Juste pour te dire que tu es à mi-chemin sur ta carte fidélité 😊\n\nEncore quelques commandes et tu débloques ta récompense ! Si tu as besoin d'un produit en particulier, dis-moi 💛"},
    {title:"Nouvelle cliente — présenter l'avantage",text:"Bienvenue [Prénom] ! 🥰\n\nAvant de commencer, sache que chez moi tu bénéficies d'une carte de fidélité : chaque commande te fait avancer vers des cadeaux et réductions.\n\nAucune démarche à faire, je m'occupe de tout suivre pour toi !"},    {title:"Story — Teasing récompense fidélité",text:"👀 Certaines de mes clientes ont déjà débloqué leur 2e cadeau gràce à leur carte fidélité...\n\nEt toi, tu en es où ? Ecris-moi FIDÉLITÉ en MP et je te dis ta progression !"},  ]},
  {cat:"💬 Premier contact",scripts:[
    {title:"Contact WhatsApp — Produits",text:"Coucou [Prénom] 😊 Je pensais à toi ! Je travaille avec une marque de beauté et bien-être qui m'a bluffée. Je me demandais si tu aurais 5 min pour jeter un œil ? Pas d'obligation, juste partager quelque chose qui m'a vraiment plu 🙏"},
    {title:"Contact WhatsApp — Opportunité",text:"Coucou [Prénom] ! J'espère que tu vas bien 🙂 Je développe quelque chose qui m'a permis de gagner un revenu complémentaire depuis chez moi. Ça m'a fait penser à toi — tu serais ouverte à en discuter 5 min ?"},
    {title:"Réponse à une story",text:"Coucou ! J'ai vu ta story sur [sujet] — ça m'a donné envie de te contacter 😊 Je travaille avec une marque que tu pourrais vraiment aimer. Tu veux que je t'envoie quelques infos ?"},
  ]},
  {cat:"🔄 Relance",scripts:[
    {title:"Relance douce",text:"Coucou [Prénom] ! Pas de pression du tout 🙂 Je voulais juste prendre de tes nouvelles. Tu avais eu le temps de regarder ce que je t'avais envoyé ?"},
    {title:"Relance après silence",text:"Coucou [Prénom] ! Ça fait un moment 😊 Je pense souvent à toi. Si tu es toujours curieuse de ce que je fais, je serais ravie d'en parler. Et si tu n'es pas intéressée, c'est ok aussi — dis-le moi simplement !"},
    {title:"Relance après un 'non'",text:"Pas de souci du tout [Prénom] ! Je comprends totalement. Est-ce que tu connais quelqu'un dans ton entourage qui cherche un revenu complémentaire ? Je suis preneuse de toute recommandation 🙏"},
  ]},
  {cat:"🎯 Présentation opportunité",scripts:[
    {title:"Pitch express 30 secondes",text:"En gros — je distribue des produits beauté et bien-être Mihi. Je gagne entre 20 et 30% sur chaque vente, et je touche des commissions sur l'équipe que je construis. Je travaille depuis mon téléphone, à mes heures. Ce n'est pas un miracle — c'est du vrai travail. Mais ça m'a permis de [ton résultat]. Tu veux en savoir plus ?"},
    {title:"Présentation complète — intro",text:"Je vais t'expliquer ce que je fais en 3 points. 1️⃣ Je vends des produits Mihi — beauté, bien-être, perte de poids. 2️⃣ Je gagne une marge de 20 à 30% sur chaque vente. 3️⃣ Je développe une équipe et je touche des commissions sur leur activité. Ce qui me plaît c'est que ça s'adapte à ma vie — pas l'inverse."},
    {title:"Réponse à 'c'est du MLM ?'",text:"Je comprends la méfiance — j'avais les mêmes questions 😊 Oui c'est de la vente directe. La différence avec les arnaques : il y a de vrais produits qu'on vend à de vraies clientes, avec une vraie marge. Je ne gagne pas d'argent en recrutant — je gagne en vendant et en formant une équipe qui vend. Tu veux que je te montre les chiffres concrets ?"},
  ]},
  {cat:"🛍️ Vente produits",scripts:[
    {title:"Présenter les parfums",text:"Tu sais ce que je réponds quand on me demande combien coûte mon parfum ? 😏 Moins de 20€. Et non c'est pas une arnaque — c'est Mihi, une marque que je distribue. La qualité est vraiment là. Tu veux que je t'en envoie quelques références ?"},
    {title:"Présenter les soins visage",text:"Je testais une nouvelle crème ce matin et j'ai pensé à toi 😊 La gamme soin visage que je distribue a des résultats hallucinants — et à des prix vraiment accessibles. Si tu veux, je peux te faire une sélection selon ton type de peau ?"},
    {title:"Inviter à commander",text:"Si tu veux essayer, le plus simple c'est de passer par ma boutique personnelle. Je t'envoie le lien ? Et si tu as des questions sur les produits, je suis là pour t'orienter 🙂"},
  ]},
  {cat:"👑 Recrutement équipe",scripts:[
    {title:"Approche douce recrutement",text:"Coucou [Prénom] ! Je développe mon équipe Blazing Dynasty et en te voyant, je me suis dit que tu pourrais vraiment avoir ta place ici. Je ne te demande pas de dire oui — juste d'écouter 10 min. Qu'est-ce que tu en penses ?"},
    {title:"Après une présentation",text:"Merci d'avoir pris le temps ce soir 🧡 Je suis là si tu as des questions. Pas de pression — prends le temps qu'il te faut. Si ça peut t'aider à décider, je peux te mettre en contact avec une de mes filles qui a démarré dans la même situation que toi."},
    {title:"Gérer l'objection 'je n'ai pas le temps'",text:"Je comprends totalement — moi aussi j'avais l'impression de ne pas avoir le temps au départ 😊 Ce qui m'a surprise c'est que ça prend vraiment le temps qu'on lui donne. Certaines filles de mon équipe commencent avec 30 min par jour. On peut en parler si tu veux ?"},
    {title:"Gérer l'objection 'je ne suis pas vendeuse'",text:"Moi non plus je ne me considérais pas comme vendeuse ! 😅 Ce que je fais c'est surtout partager ce que j'aime avec les gens autour de moi. Les ventes viennent naturellement après. Est-ce que tu partages déjà des produits que tu aimes avec tes amies ? Alors tu sais déjà faire 😊"},
  ]},
  {cat:"📱 Stories & contenu",scripts:[
    {title:"CTA mot-clé commentaire",text:"Tu veux savoir quel est ce produit qui me fait des compliments à chaque fois ? Écris PRODUIT en commentaire et je t'envoie tout en privé 😊"},
    {title:"CTA pour l'opportunité",text:"Tu cherches un revenu complémentaire qui s'adapte à ta vie ? Écris ÉQUIPE en commentaire — je te réponds en privé 🖤"},
    {title:"Intro storytelling",text:"Il y a [X mois], je ne savais pas quoi faire. Aujourd'hui [ton résultat]. Ce n'est pas un miracle — c'est ce que j'ai construit, étape par étape. Je vous raconte ça ce soir en story 👇"},
  ]},
  {cat:"✨ Après une inscription",scripts:[
    {title:"Message 1 — Bienvenue, valeurs & fonctionnement",text:"Bienvenue dans l'aventure Mihi [Prénom] 🥰 Je suis hyper contente de t'accueillir !\n\nPetite présentation rapide de comment on fonctionne : chez nous, pas de pression ni d'objectifs imposés — on avance chacune à son rythme, avec une équipe qui s'entraide vraiment au quotidien (pas juste des mots en l'air).\n\nNos valeurs : bienveillance, transparence, et l'envie sincère de te voir réussir à TA façon — que ce soit simplement pour profiter des produits, ou pour développer une vraie activité 🖤"},
    {title:"Message 2 — L'importance du Fast Start",text:"Une étape essentielle pour bien démarrer : le Fast Start 🚀\n\nC'est un parcours guidé, étape par étape, disponible directement dans l'application — il t'explique tout ce qu'il faut savoir pour bien commencer, sans te sentir perdue.\n\nJe te conseille vraiment de le suivre dès les premiers jours, c'est ce qui fait toute la différence pour la suite. Tu le trouveras dès l'ouverture de l'app 😊"},
    {title:"Message — Accès à l'application",text:"Voici l'accès à ton application Blazing Dynasty 📲\n\n🔗 https://blazing-dinasty-1fad9.web.app\n\n🔑 Ton code d'accès est : BD-2026-fire\n\n📥 Installer l'application :\nhttps://drive.google.com/file/d/1wVvxlIZa9TjUHY-q0OAKb6fffjF52LtH/view?usp=drivesdk"},
    {title:"Message — Inscription automatique (premier contact)",text:"Coucou [Prénom]\n\nMoi c'est [Ton prénom], je suis ta personne de contact pour l'aventure Mihi et je serai là pour t'accompagner.\n\nBienvenue parmi nous !\n\nAvant de te bombarder d'informations, j'aimerais surtout savoir comment tu souhaites être accompagnée.\n\nSi tu souhaites être cliente VIP, ou développer en tant qu'ambassadrice ?\n\nDans tous les cas, je m'adapte à toi.\n\nDis-moi ce qui te correspond le mieux 💛"},
  ]},
];

// ── ANNONCE IMPORTANTE (pop-up + bandeau) ─────────────────────────────────────

export function MarrainePopup({uid, userName}){
  const[show,setShow]=useState(false);
  const[membres,setMembres]=useState([]);
  const[choix,setChoix]=useState("");
  const[dismissed,setDismissed]=useState(false);
  const[saving,setSaving]=useState(false);

  useEffect(()=>{
    (async()=>{
      try{
        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        const annuaire=annSnap.exists()?annSnap.data().membres||{}:{};
        const moi=annuaire[uid];
        if(moi&&!moi.marraine){
          const accSnap=await getDoc(doc(db,"acces","membres"));
          const liste=accSnap.exists()?accSnap.data().liste||[]:[];
          setMembres(["melissa da silveira", ...liste.filter(m=>m.toLowerCase().replace(/\s+/g,"-")!==uid&&m.toLowerCase()!=="melissa da silveira")]);
          setShow(true);
        }
      }catch{}
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[uid]);

  const confirmer=async()=>{
    if(!choix){setShow(false);setDismissed(true);return;}
    setSaving(true);
    const marraineUid=choix.toLowerCase().replace(/\s+/g,"-");
    try{
      await setDoc(doc(db,"users",uid),{marraine:marraineUid},{merge:true});
      const ref=doc(db,"equipe","annuaire");
      const snap=await getDoc(ref);
      const existing=snap.exists()&&snap.data().membres?snap.data().membres:{};
      await setDoc(ref,{membres:{...existing,[uid]:{...existing[uid],marraine:marraineUid}}},{merge:true});
    }catch{}
    setSaving(false);setShow(false);
  };

  if(!show||dismissed) return null;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:16,padding:"1.4rem",maxWidth:380,width:"100%",boxShadow:"0 10px 40px rgba(0,0,0,.25)"}}>
        <div style={{fontSize:"1.8rem",textAlign:"center",marginBottom:".4rem"}}>🌸</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:C.brun,textAlign:"center",marginBottom:".5rem"}}>Qui t'a parrainée ?</div>
        <p style={{fontSize:".76rem",color:C.gris,textAlign:"center",lineHeight:1.6,marginBottom:"1rem"}}>
          Ça permettra à ta marraine de te retrouver dans son équipe automatiquement 💛
        </p>
        <SearchSelect value={choix} onChange={setChoix} options={membres} placeholder="🔍 Tape le nom de ta marraine..."/>
        <button onClick={confirmer} disabled={saving}
          style={{width:"100%",background:C.rose,color:"white",border:"none",borderRadius:9,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
          {saving?"...":choix?"Confirmer":"Je ne sais pas / pas de marraine"}
        </button>
        <button onClick={()=>{setShow(false);setDismissed(true);}}
          style={{width:"100%",background:"none",border:"none",color:C.gris,fontSize:".7rem",cursor:"pointer",fontFamily:"inherit",padding:".2rem"}}>
          Plus tard
        </button>
      </div>
    </div>
  );
}


export function AnnonceBanner({uid}){
  const[annonce,setAnnonce]=useState(null);
  const[showPopup,setShowPopup]=useState(false);
  const[dismissed,setDismissed]=useState(false);

  useEffect(()=>{
    (async()=>{
      try{
        const snap = await getDoc(doc(db,"admin","annonce"));
        if(snap.exists()&&snap.data().actif&&snap.data().message){
          const a = snap.data();
          setAnnonce(a);
          const vu = await sg(uid,"db-annonce-vue");
          if(!vu || +vu !== a.ts){
            setShowPopup(true);
          }
        }
      }catch{}
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[uid]);

  const fermerPopup=()=>{
    setShowPopup(false);
    if(annonce) ss(uid,"db-annonce-vue",String(annonce.ts));
  };

  if(!annonce||dismissed) return null;

  return(
    <>
      {showPopup&&(
        <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
          <div style={{background:C.blanc,borderRadius:16,padding:"1.4rem",maxWidth:380,width:"100%",boxShadow:"0 10px 40px rgba(0,0,0,.25)"}}>
            <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".18em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem"}}>📣 ANNONCE IMPORTANTE</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",color:C.brun,lineHeight:1.6,marginBottom:"1.2rem",whiteSpace:"pre-wrap"}}>{annonce.message}</div>
            <button onClick={fermerPopup}
              style={{width:"100%",background:C.rose,color:"white",border:"none",borderRadius:9,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              Compris !
            </button>
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(135deg,rgba(196,168,130,.15),rgba(196,154,138,.1))",border:`1px solid ${C.or}50`,borderRadius:12,padding:".8rem 1rem",marginBottom:"1rem",display:"flex",gap:".6rem",alignItems:"flex-start"}}>
        <div style={{fontSize:"1.1rem",flexShrink:0}}>📣</div>
        <div style={{flex:1}}>
          <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.brun,marginBottom:".2rem"}}>Annonce</div>
          <div style={{fontSize:".74rem",color:C.texte,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{annonce.message}</div>
        </div>
        <button onClick={()=>setDismissed(true)}
          style={{background:"none",border:"none",color:C.gris,cursor:"pointer",fontSize:".75rem",flexShrink:0,padding:".1rem"}}>✕</button>
      </div>
    </>
  );
}

function AdminAnnuaireSync(){
  const[status,setStatus]=useState(null);
  const[loading,setLoading]=useState(false);

  const run=async()=>{
    setLoading(true);
    const added = await seedAnnuaireFromMembres();
    setStatus(added);
    setLoading(false);
  };

  return(
    <div>
      <button onClick={run} disabled={loading}
        style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:9,padding:".55rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
        {loading?"Synchronisation...":"🔄 Synchroniser tous les membres maintenant"}
      </button>
      {status!==null&&(
        <div style={{fontSize:".68rem",color:C.vert,marginTop:".5rem",textAlign:"center"}}>
          ✅ {status} nouveau{status>1?"x":""} membre{status>1?"s":""} ajouté{status>1?"s":""} à l'annuaire.
        </div>
      )}
    </div>
  );
}


function AdminAnnonceEditor(){
  const[message,setMessage]=useState("");
  const[actif,setActif]=useState(false);
  const[loaded,setLoaded]=useState(false);
  const[saving,setSaving]=useState(false);
  const[saved,setSaved]=useState(false);

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","annonce"));
        if(snap.exists()){
          setMessage(snap.data().message||"");
          setActif(!!snap.data().actif);
        }
      }catch{}
      setLoaded(true);
    })();
  },[]);

  const save=async(nextActif)=>{
    setSaving(true);
    try{
      await setDoc(doc(db,"admin","annonce"),{message, actif:nextActif, ts:Date.now()});
      setActif(nextActif);
      setSaved(true);
      setTimeout(()=>setSaved(false),2500);
    }catch{}
    setSaving(false);
  };

  if(!loaded) return <div style={{fontSize:".74rem",color:C.gris}}>Chargement...</div>;

  return(
    <div>
      <textarea placeholder="Ex: La soirée formation de ce soir est décalée à 21h !" value={message} onChange={e=>setMessage(e.target.value)}
        style={{width:"100%",minHeight:90,border:`1px solid ${C.pale}`,borderRadius:9,padding:".6rem .8rem",fontFamily:"inherit",fontSize:".8rem",color:C.texte,background:C.creme,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:".6rem"}}/>
      {actif&&(
        <div style={{fontSize:".68rem",color:C.vert,fontWeight:600,marginBottom:".6rem"}}>✓ Annonce actuellement active — visible par toute l'équipe</div>
      )}
      <div style={{display:"flex",gap:".5rem"}}>
        <button onClick={()=>save(true)} disabled={saving||!message.trim()}
          style={{flex:1,background:C.rose,color:"white",border:"none",borderRadius:9,padding:".55rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          {saving?"...":saved?"✅ Publié !":"Publier l'annonce"}
        </button>
        {actif&&(
          <button onClick={()=>save(false)} disabled={saving}
            style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:9,padding:".55rem .9rem",fontSize:".78rem",color:C.gris,fontFamily:"inherit",cursor:"pointer"}}>
            Désactiver
          </button>
        )}
      </div>
    </div>
  );
}



export const FAST_START_DAYS=[
  {jour:1,titre:"Module 1 — Bienvenue & Prise en main 🎉",taches:[
    {t:"Regarde la vidéo du Module 1",link:{video:true,module:1}},
    {t:"Rejoins les groupes Telegram de l'équipe 🔵",link:{url:"https://t.me/+2wKWxIROE4c1M2Q0",label:"Banque d'images équipe"},link2:{url:"https://t.me/+pv0RY_JJy4wyYzE8",label:"Groupe témoignages"}},
  ]},
  {jour:2,titre:"Module 2 — Connaître Mihi 🌿",taches:[
    {t:"Regarde la vidéo du Module 2",link:{video:true,module:2}},
    "Commande ou teste au moins 1 produit Mihi si ce n'est pas fait",
    "Exo : Envoie ta liste des 3 produits préférés avec une phrase sur pourquoi à ta marraine",
  ]},
  {jour:3,titre:"Module 3 — Mon histoire & Ma Why 💫",taches:[
    {t:"Regarde la vidéo du Module 3",link:{video:true,module:3}},
    "Prends 15 minutes pour écrire ton 'pourquoi' en 3 phrases : avant / déclic / maintenant",
    "Exo : Envoie ton 'pourquoi' en quelques lignes à ta marraine",
  ]},
  {jour:4,titre:"Module 4 — Mes premiers contacts 📱",taches:[
    {t:"Regarde la vidéo du Module 4",link:{video:true,module:4}},
    "Fais ta liste de 10 contacts potentiels (famille, amies, collègues, voisines...)",
    "Exo : Envoie ta liste de 10 contacts à ta marraine",
  ]},
  {jour:5,titre:"Module 5 — Présenter Mihi 🎯",taches:[
    {t:"Regarde la vidéo du Module 5",link:{video:true,module:5}},
    "Entraîne-toi à ton pitch de 30 secondes à voix haute 3 fois",
    "Exo : Fais une story ou un post et envoie la capture à ta marraine",
  ]},
  {jour:6,titre:"Module 6 — Mes premières ventes 💰",taches:[
    {t:"Regarde la vidéo du Module 6",link:{video:true,module:6}},
    "Note 3 clientes potentielles à contacter cette semaine",
    "Exo : Envoie la confirmation de ta première commande client à ta marraine",
  ]},
  {jour:7,titre:"Module 7 — Je construis mon équipe 👑",taches:[
    {t:"Regarde la vidéo du Module 7",link:{video:true,module:7}},
    "Identifie 1 personne dans ton entourage qui pourrait être intéressée par l'opportunité",
    "Exo : Envoie le nom d'une personne contactée pour l'opportunité à ta marraine",
  ]},
];

// Quiz + exercice de validation pour chaque module
export const FAST_START_QUIZ=[
  {
    jour:1,
    exercice:null, // pas d'exercice pour module 1
    quiz:[
      {q:"Où se passe la vie d'équipe au quotidien ?",options:["Sur Facebook","Sur Telegram","Par email","Sur WhatsApp"],rep:1},
      {q:"Que représente Blazing Dynasty ?",options:["Une marque de cosmétiques","L'équipe et la communauté","Le nom de l'appli","Le groupe Facebook"],rep:1},
      {q:"Quelle est ta première mission dans l'équipe ?",options:["Faire une vente","Rejoindre Telegram et explorer l'appli","Recruter une filleule","Poster sur Instagram"],rep:1},
    ],
  },
  {
    jour:2,
    exercice:"Envoie à ta marraine ta liste des 3 produits Mihi préférés avec une phrase sur pourquoi tu les as choisis 🌿",
    quiz:[
      {q:"Qu'est-ce qui différencie Mihi des autres marques ?",options:["Le prix le plus bas","Les ingrédients naturels et la qualité","Le nombre de produits","La livraison gratuite"],rep:1},
      {q:"Pour bien parler des produits, tu dois d'abord...",options:["Les avoir vendus au moins une fois","Les avoir testés toi-même","Lire tous les fiches techniques","Regarder des vidéos YouTube"],rep:1},
      {q:"Combien de gammes principales propose Mihi ?",options:["2","4","6","Plus de 6"],rep:3},
    ],
  },
  {
    jour:3,
    exercice:"Rédige ton 'pourquoi' en 3-5 phrases (avant / déclic / maintenant) et envoie-le à ta marraine 💫",
    quiz:[
      {q:"Pourquoi ton 'pourquoi' est-il important ?",options:["Pour remplir le formulaire","C'est la base de ton authenticité et de ta connexion aux autres","Pour impressionner les prospects","Ce n'est pas vraiment important"],rep:1},
      {q:"La structure d'une bonne histoire personnelle c'est :",options:["Chiffres / résultats / objectifs","Avant / déclic / maintenant","Produits / prix / livraison","Suivis / relances / clôture"],rep:1},
      {q:"Ton histoire doit être :",options:["Parfaite et sans défauts","Longue et détaillée","Authentique et personnelle","Centrée sur les produits"],rep:2},
    ],
  },
  {
    jour:4,
    exercice:"Envoie ta liste de 10 contacts potentiels à ta marraine (prénom + lien avec toi) 📱",
    quiz:[
      {q:"Quel est le meilleur point de départ pour ta liste de contacts ?",options:["Les inconnus sur Instagram","Ton entourage proche (famille, amies, collègues)","Les groupes Facebook","Les pages professionnelles"],rep:1},
      {q:"Comment approcher naturellement un contact ?",options:["En envoyant directement le lien boutique","En prenant des nouvelles d'abord, sans parler de Mihi","En faisant un pitch complet d'emblée","En publiant son contact sur les réseaux"],rep:1},
      {q:"Combien de contacts doit contenir ta liste de départ ?",options:["5 minimum","10 minimum","50 minimum","100 minimum"],rep:1},
    ],
  },
  {
    jour:5,
    exercice:"Publie une story ou un post Mihi et envoie la capture d'écran à ta marraine 🎯",
    quiz:[
      {q:"Un bon pitch de présentation dure :",options:["5 minutes minimum","30 secondes maximum","10 minutes","1 à 2 minutes"],rep:1},
      {q:"Que doit contenir une bonne story de présentation Mihi ?",options:["Tous les prix de la gamme","Ton résultat ou ressenti personnel + appel à l'action","Le lien de la boutique uniquement","Une liste de tous les produits"],rep:1},
      {q:"Quelle est la règle d'or du contenu sur les réseaux ?",options:["Publier le plus souvent possible","Copier-coller ce qui marche pour d'autres","Être authentique et régulière","Parler uniquement des produits"],rep:2},
    ],
  },
  {
    jour:6,
    exercice:"Envoie la confirmation de ta première commande client à ta marraine 💰",
    quiz:[
      {q:"Après une commande, quand recontacter la cliente ?",options:["Jamais, c'est elle qui revient","3 à 5 jours après réception pour prendre des nouvelles","Un mois après","Uniquement si elle a un problème"],rep:1},
      {q:"Le service après-vente c'est :",options:["Une obligation légale","Un outil puissant pour fidéliser et obtenir des recommandations","Une perte de temps","Uniquement pour les problèmes"],rep:1},
      {q:"Comment transformer une cliente en ambassadrice ?",options:["En lui donnant des remises","En la suivant régulièrement et en lui demandant son avis","En lui envoyant beaucoup de messages","En lui proposant de rejoindre l'équipe dès la 1ère commande"],rep:1},
    ],
  },
  {
    jour:7,
    exercice:"Envoie le prénom et le profil d'une personne que tu as contactée pour l'opportunité business à ta marraine 👑",
    quiz:[
      {q:"Comment parler de l'opportunité sans forcer ?",options:["Envoyer le lien d'inscription directement","Partager ton propre parcours et laisser la curiosité venir","Lister tous les avantages financiers","Faire un pitch complet non sollicité"],rep:1},
      {q:"Quel profil est idéal pour l'opportunité Mihi ?",options:["Uniquement les personnes sans emploi","Uniquement les experts en vente","Toute personne motivée, quelle que soit sa situation","Uniquement les femmes de moins de 30 ans"],rep:2},
      {q:"Après 7 modules, la suite c'est :",options:["Arrêter de se former","Tout faire seule","Continuer à te former et t'appuyer sur ta marraine","Attendre les résultats"],rep:2},
    ],
  },
];

export function FastStartQuizPopup({jour, uid, userName, marraineUid, onClose, onValide}){
  const config = FAST_START_QUIZ.find(q=>q.jour===jour);
  const[step,setStep]=useState(config?.exercice?"exercice":"quiz");
  const[reponses,setReponses]=useState({});
  const[exoTexte,setExoTexte]=useState("");
  const[sending,setSending]=useState(false);
  const[sent,setSent]=useState(false);
  const[score,setScore]=useState(null);
  if(!config) return null;

  // config existe ici
  const titre=FAST_START_DAYS.find(d=>d.jour===jour)?.titre||`Module ${jour}`;
  const fmt=(id)=>id.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  const validerQuiz=()=>{
    let s=0;
    config.quiz.forEach((q,i)=>{ if(reponses[i]===q.rep) s++; });
    setScore(s);
    setStep("envoyer");
  };

  const envoyer=async()=>{
    setSending(true);
    try{
      // Message envoyé à la marraine
      if(marraineUid){
        const ref=doc(db,"messages",marraineUid);
        const snap=await getDoc(ref);
        const existing=snap.exists()?snap.data().msgs||[]:[];

        // Détail des réponses au quiz
        let quizDetail = "";
        if(config.quiz){
          config.quiz.forEach((q,i)=>{
            const repDonnee = reponses[i];
            const estJuste = repDonnee === q.rep;
            quizDetail += `\n${estJuste?"✅":"❌"} Q${i+1}: ${q.q}\n   → Réponse: "${q.options[repDonnee]||"?"}" ${estJuste?"(correct)":"(incorrect — bonne réponse: "+q.options[q.rep]+")"}\n`;
          });
        }

        const msg={
          id:`fs${Date.now()}`,
          de:uid,
          deNom:fmt(uid),
          texte:`✅ ${fmt(uid)} a validé le ${titre}\n\n${config.exercice&&exoTexte?`📝 Exercice :\n${exoTexte}\n`:""}\n📊 Quiz : ${score}/${config.quiz.length} bonnes réponses${quizDetail}`,
          ts:Date.now(),
          lu:false,
          type:"faststart",
          score,
          total:config.quiz.length,
        };
        await setDoc(ref,{msgs:[msg,...existing].slice(0,100)});
      }
      // Marquer le module comme validé
      onValide&&onValide(jour);
      setSent(true);
    }catch{}
    setSending(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9999}}>
      <div style={{background:C.blanc,borderRadius:"18px 18px 0 0",width:"100%",maxWidth:480,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.3)"}}>

        {/* Header */}
        <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:"1rem 1.2rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,color:C.blanc}}>
              {step==="exercice"?"📝 Exercice":step==="quiz"?"📊 Quiz de validation":step==="envoyer"?"📤 Envoyer à ta marraine":"✅ Validé !"}
            </div>
            <div style={{fontSize:".65rem",color:C.pale,marginTop:".15rem"}}>{titre}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.pale,fontSize:"1.2rem",cursor:"pointer"}}>✕</button>
        </div>

        <div style={{padding:"1.2rem"}}>

          {/* ÉTAPE EXERCICE */}
          {step==="exercice"&&config.exercice&&(
            <div>
              <div style={{background:C.creme,borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",borderLeft:`3px solid ${C.rose}`}}>
                <div style={{fontSize:".7rem",fontWeight:700,color:C.rose,marginBottom:".3rem"}}>📝 Exercice de validation</div>
                <div style={{fontSize:".8rem",color:C.brun,lineHeight:1.65}}>{config.exercice}</div>
              </div>
              <textarea value={exoTexte} onChange={e=>setExoTexte(e.target.value)}
                placeholder="Écris ta réponse ici... ou décris ce que tu as fait"
                style={{width:"100%",minHeight:100,border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem",fontFamily:"inherit",fontSize:".8rem",color:C.texte,background:C.blanc,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:"1rem"}}/>
              <button onClick={()=>setStep("quiz")}
                style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".7rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                Continuer → Quiz de validation
              </button>
            </div>
          )}

          {/* ÉTAPE QUIZ */}
          {step==="quiz"&&(
            <div>
              <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.6}}>
                Réponds aux questions pour valider ce module et débloquer le suivant 🎯
              </p>
              {config.quiz.map((q,i)=>(
                <div key={i} style={{marginBottom:"1rem"}}>
                  <div style={{fontSize:".8rem",fontWeight:600,color:C.brun,marginBottom:".5rem",lineHeight:1.5}}>{i+1}. {q.q}</div>
                  {q.options.map((opt,j)=>(
                    <div key={j} onClick={()=>setReponses(r=>({...r,[i]:j}))}
                      style={{display:"flex",alignItems:"center",gap:".6rem",padding:".5rem .75rem",borderRadius:9,border:`1.5px solid ${reponses[i]===j?C.rose:C.pale}`,background:reponses[i]===j?C.rose+"10":"transparent",marginBottom:".3rem",cursor:"pointer",transition:"all .15s"}}>
                      <div style={{width:18,height:18,borderRadius:"50%",border:`2px solid ${reponses[i]===j?C.rose:C.pale}`,background:reponses[i]===j?C.rose:"transparent",flexShrink:0}}/>
                      <div style={{fontSize:".76rem",color:C.texte}}>{opt}</div>
                    </div>
                  ))}
                </div>
              ))}
              <button onClick={validerQuiz}
                disabled={Object.keys(reponses).length<config.quiz.length}
                style={{width:"100%",background:Object.keys(reponses).length>=config.quiz.length?C.brun:C.pale,color:Object.keys(reponses).length>=config.quiz.length?C.blanc:C.gris,border:"none",borderRadius:10,padding:".7rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:Object.keys(reponses).length>=config.quiz.length?"pointer":"default",transition:"all .2s"}}>
                Valider le quiz →
              </button>
            </div>
          )}

          {/* ÉTAPE ENVOYER */}
          {step==="envoyer"&&!sent&&(
            <div>
              {/* Score */}
              <div style={{background:score>=2?C.vert+"15":C.rose+"15",border:`1px solid ${score>=2?C.vert:C.rose}`,borderRadius:12,padding:"1rem",textAlign:"center",marginBottom:"1rem"}}>
                <div style={{fontSize:"2rem",marginBottom:".3rem"}}>{score===config.quiz.length?"🏆":score>=2?"✅":"💪"}</div>
                <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>{score}/{config.quiz.length} bonnes réponses</div>
                <div style={{fontSize:".72rem",color:C.gris,marginTop:".2rem"}}>
                  {score===config.quiz.length?"Parfait !":score>=2?"Bien joué !":"Continue à revoir les notions du module"}
                </div>
              </div>

              {/* Récap exercice */}
              {config.exercice&&exoTexte&&(
                <div style={{background:C.creme,borderRadius:10,padding:".75rem",marginBottom:"1rem",fontSize:".74rem",color:C.brun}}>
                  <strong>Ton exercice :</strong> {exoTexte}
                </div>
              )}

              <button onClick={envoyer} disabled={sending}
                style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".75rem",fontSize:".84rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".5rem"}}>
                {sending?"Envoi en cours...":"📤 Envoyer à ma marraine pour validation"}
              </button>
              <button onClick={onClose}
                style={{width:"100%",background:"none",border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem",fontSize:".76rem",color:C.gris,fontFamily:"inherit",cursor:"pointer"}}>
                Enregistrer et fermer
              </button>
            </div>
          )}

          {/* ENVOYÉ */}
          {sent&&(
            <div style={{textAlign:"center",padding:"1.5rem 0"}}>
              <div style={{fontSize:"3rem",marginBottom:".5rem"}}>🎉</div>
              <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:600,color:C.brun,marginBottom:".5rem"}}>
                Module {jour} validé !
              </div>
              <p style={{fontSize:".78rem",color:C.gris,lineHeight:1.7,marginBottom:"1.2rem"}}>
                Ta marraine a reçu tes réponses et va valider ton module. Le module suivant se débloque automatiquement 🚀
              </p>
              <button onClick={onClose}
                style={{background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".65rem 1.4rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                Continuer →
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}



const PRODUITS_DEFAULT=[
  {id:"sk-anti-age",categorie:"Skincare",icon:"✨",nom:"Crème/Sérum anti-âge",besoins:"Rides, fermeté, peau mature",pointsForts:"Actifs concentrés, résultats visibles, texture premium",prix:""},
  {id:"sk-hydratant",categorie:"Skincare",icon:"✨",nom:"Soin hydratant visage",besoins:"Peau sèche, déshydratée, tiraillements",pointsForts:"Hydratation longue durée, confort immédiat",prix:""},
  {id:"sk-nettoyant",categorie:"Skincare",icon:"✨",nom:"Mousse / gel nettoyant",besoins:"Nettoyage en douceur, peaux sensibles",pointsForts:"Respecte le film hydrolipidique, non agressif",prix:""},
  {id:"sk-contour",categorie:"Skincare",icon:"✨",nom:"Contour des yeux",besoins:"Cernes, poches, ridules",pointsForts:"Effet coup d'éclat immédiat, action longue durée",prix:""},
  {id:"sk-gommage",categorie:"Skincare",icon:"✨",nom:"Gommage visage",besoins:"Peau terne, pores bouchés, teint irrégulier",pointsForts:"Grains fins, action douce, peau lissée immédiatement",prix:""},

  {id:"ch-secs",categorie:"Soins cheveux",icon:"💇",nom:"Shampoing/Soin cheveux secs",besoins:"Cheveux secs, abîmés, pointes fourchues",pointsForts:"Nutrition intense, résultats comparables marques pro",prix:""},
  {id:"ch-gras",categorie:"Soins cheveux",icon:"💇",nom:"Shampoing cheveux gras / racines",besoins:"Racines grasses, cheveux qui regraissent vite",pointsForts:"Effet purifiant, fraîcheur longue durée",prix:""},
  {id:"ch-reparateur",categorie:"Soins cheveux",icon:"💇",nom:"Baume / masque réparateur",besoins:"Cheveux colorés, cassants, abîmés par la chaleur",pointsForts:"Répare la fibre en profondeur, brillance retrouvée",prix:""},
  {id:"ch-volume",categorie:"Soins cheveux",icon:"💇",nom:"Soin volumateur",besoins:"Cheveux fins, sans volume, qui s'aplatissent",pointsForts:"Effet volume visible dès la première utilisation",prix:""},
  {id:"ch-anticalc",categorie:"Soins cheveux",icon:"💇",nom:"Soin anti-calcaire/eau dure",besoins:"Cheveux qui nettoient mal avec l'eau du robinet, dépôts calcaires",pointsForts:"Nettoie sans abîmer ni dessécher, douceur préservée",prix:""},

  {id:"mu-mascara",categorie:"Make-up",icon:"💄",nom:"Mascara volume",besoins:"Cils plats, peu de tenue, envie de volume",pointsForts:"Volume immédiat, longue tenue, qualité pro",prix:""},
  {id:"mu-fdt",categorie:"Make-up",icon:"💄",nom:"Fond de teint matifiant",besoins:"Peau grasse, brillances, envie de teint unifié",pointsForts:"Tenue longue durée, fini matifié naturel",prix:""},
  {id:"mu-rouge",categorie:"Make-up",icon:"💄",nom:"Rouge à lèvres longue tenue",besoins:"Couleur qui ne tient pas, lèvres sèches",pointsForts:"Tenue longue durée, confort, large choix de teintes",prix:""},
  {id:"mu-teint",categorie:"Make-up",icon:"💄",nom:"Correcteur / anti-cernes",besoins:"Cernes, imperfections, teint terne",pointsForts:"Couvrance modulable, fini naturel",prix:""},

  {id:"co-detox",categorie:"Compléments alimentaires",icon:"💊",nom:"Détox / draineur",besoins:"Sensation de lourdeur, rétention, besoin de \"reset\"",pointsForts:"Formule naturelle, effet ressenti rapidement",prix:""},
  {id:"co-brulegraisse",categorie:"Compléments alimentaires",icon:"💊",nom:"Brûle-graisses / métabolisme",besoins:"Perte de poids, coup de pouce métabolisme",pointsForts:"Booste l'énergie, soutient la perte de poids",prix:""},
  {id:"co-vitamines",categorie:"Compléments alimentaires",icon:"💊",nom:"Vitamines / énergie",besoins:"Fatigue, baisse d'énergie, immunité",pointsForts:"Formule complète, effet ressenti sur l'énergie quotidienne",prix:""},
  {id:"co-ginkgo",categorie:"Compléments alimentaires",icon:"💊",nom:"Ginkgo biloba / circulation",besoins:"Jambes lourdes, mémoire, circulation",pointsForts:"Plante reconnue, action ciblée",prix:""},

  {id:"pa-femme",categorie:"Parfums",icon:"🌸",nom:"Parfum Femme",besoins:"Envie d'un nouveau parfum, budget serré sur les grandes marques",pointsForts:"Qualité comparable aux grandes marques, à moins de 20€",prix:""},
  {id:"pa-homme",categorie:"Parfums",icon:"🌸",nom:"Parfum Homme",besoins:"Cadeau homme, parfum du quotidien",pointsForts:"Sillage qualitatif, prix très accessible",prix:""},

  {id:"sc-gommage-or",categorie:"Soin corps",icon:"🧴",nom:"Gommage effet or",besoins:"Peau terne, envie de rituel cocooning",pointsForts:"Expérience sensorielle premium, peau douce immédiatement",prix:""},
  {id:"sc-baume",categorie:"Soin corps",icon:"🧴",nom:"Baume satiné corps",besoins:"Peau sèche, manque d'éclat",pointsForts:"Hydratation longue durée, fini satiné non gras",prix:""},
  {id:"sc-enveloppement",categorie:"Soin corps",icon:"🧴",nom:"Enveloppement / soin minceur",besoins:"Cellulite, fermeté, rituel minceur",pointsForts:"Effet rituel spa, parfait pour box cadeaux",prix:""},
];


function ProduitsSearchTab(){
  const[question,setQuestion]=useState("");
  const[loading,setLoading]=useState(false);
  const[ordonnance,setOrdonnance]=useState(null);
  const[erreur,setErreur]=useState("");
  const[baseFormation,setBaseFormation]=useState({});
  const[baseLoaded,setBaseLoaded]=useState(false);

  // Charger la base Formation Produits au démarrage
  useEffect(()=>{
    (async()=>{
      try{
        const fp=await chargerFormationProduits();
        setBaseFormation(fp.produits||{});
      }catch{}
      setBaseLoaded(true);
    })();
  },[]);

  // Construire le contexte textuel à injecter dans le prompt
  const buildContexte=()=>{
    const lignes=[];
    CATEGORIES_PRODUITS.forEach(cat=>{
      if(cat.id===CAT_VIDEO_ID)return; // les formations vidéo ne sont pas des produits
      const produits=baseFormation[cat.id]||[];
      if(produits.length===0)return;
      lignes.push(`\n=== ${cat.icon} ${cat.label.toUpperCase()} ===`);
      produits.forEach(p=>{
        lignes.push(`\nProduit : ${p.titre}`);
        if(p.description) lignes.push(`Description : ${p.description.slice(0,600)}`);
      });
    });
    return lignes.join("\n");
  };

  const genererOrdonnance=async()=>{
    const q=question.trim();
    if(!q)return;
    setLoading(true);setErreur("");setOrdonnance(null);

    const contexte=buildContexte();

    if(!contexte||contexte.length<50){
      setErreur("La base de formation produits est vide. Demande à Melissa d'ajouter des produits depuis l'Admin.");
      setLoading(false);return;
    }

    const prompt=`Tu es une conseillère beauté et bien-être experte des produits Mihi, qui aide à trouver la combinaison parfaite pour chaque cliente.

BASE DE CONNAISSANCES PRODUITS MIHI :
${contexte}

QUESTION / BESOIN DE LA CLIENTE :
"${q}"

En te basant UNIQUEMENT sur les produits présents dans la base de connaissances ci-dessus, génère une ordonnance personnalisée en JSON (ne renvoie QUE le JSON, sans markdown ni commentaire) :

{
  "analyse": "2-3 phrases qui analysent le besoin exprimé et expliquent ton approche",
  "packs": [
    {
      "nom": "Pack Essentiel",
      "emoji": "💚",
      "couleur": "#27AE60",
      "description": "L'essentiel pour commencer, budget accessible",
      "produits": [
        {"nom": "Nom exact du produit", "role": "Pourquoi ce produit pour ce besoin", "categorie": "Catégorie"},
        {"nom": "Nom exact du produit 2", "role": "Pourquoi ce produit", "categorie": "Catégorie"}
      ],
      "avantage_cle": "Le principal bénéfice de ce pack en 1 phrase"
    },
    {
      "nom": "Pack Recommandé",
      "emoji": "⭐",
      "couleur": "#C49A8A",
      "description": "La combinaison idéale, notre recommandation",
      "produits": [
        {"nom": "Produit 1", "role": "Rôle", "categorie": "Catégorie"},
        {"nom": "Produit 2", "role": "Rôle", "categorie": "Catégorie"},
        {"nom": "Produit 3", "role": "Rôle", "categorie": "Catégorie"}
      ],
      "avantage_cle": "Pourquoi ce pack est le meilleur choix"
    },
    {
      "nom": "Pack Premium",
      "emoji": "👑",
      "couleur": "#C4A832",
      "description": "La routine complète, résultats maximaux",
      "produits": [
        {"nom": "Produit 1", "role": "Rôle", "categorie": "Catégorie"},
        {"nom": "Produit 2", "role": "Rôle", "categorie": "Catégorie"},
        {"nom": "Produit 3", "role": "Rôle", "categorie": "Catégorie"},
        {"nom": "Produit 4", "role": "Rôle", "categorie": "Catégorie"}
      ],
      "avantage_cle": "L'expérience complète et transformative"
    }
  ],
  "conseil": "Un conseil personnalisé final pour accompagner la cliente, en 2 phrases"
}

RÈGLES IMPORTANTES :
- N'utilise QUE les produits présents dans la base de connaissances
- Si la base ne contient pas assez de produits pour répondre, adapte les packs en conséquence
- Les packs doivent être progressifs en termes de complétude (pas nécessairement de prix)
- Sois précise et concrète dans les explications`;

    try{
      const res=await fetch("https://api.anthropic.com/v1/messages",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "x-api-key":ANTHROPIC_API_KEY,
          "anthropic-version":"2023-06-01",
          "anthropic-dangerous-direct-browser-access":"true"
        },
        body:JSON.stringify({model:"claude-sonnet-4-6",max_tokens:2000,messages:[{role:"user",content:prompt}]})
      });
      const data=await res.json();
      if(data.error)throw new Error(data.error.message);
      const text=data.content?.map(i=>i.text||"").join("")||"";
      const clean=text.replace(/```json|```/g,"").trim();
      setOrdonnance(JSON.parse(clean));
    }catch(e){
      setErreur("Erreur lors de la génération. Réessaie dans quelques secondes.");
    }
    setLoading(false);
  };

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Conseillère <em style={{fontStyle:"italic",color:C.rose}}>Produits IA</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Décris le besoin de ta cliente — l'IA sélectionne les produits Mihi adaptés et crée une ordonnance personnalisée.
      </p>

      {/* Exemples de questions */}
      {!ordonnance&&!loading&&(
        <div style={{display:"flex",flexWrap:"wrap",gap:".35rem",marginBottom:".75rem"}}>
          {["Peau sèche et terne","Perte de poids + énergie","Maquillage longue tenue","Cheveux abîmés","Complément anti-âge","Parfum féminin doux"].map(ex=>(
            <button key={ex} onClick={()=>setQuestion(ex)}
              style={{padding:".3rem .65rem",fontSize:".68rem",borderRadius:20,border:`1px solid ${C.pale}`,background:C.blanc,color:C.brun,cursor:"pointer",fontFamily:"inherit"}}>
              {ex}
            </button>
          ))}
        </div>
      )}

      {/* Champ de saisie */}
      <div style={{position:"relative",marginBottom:".75rem"}}>
        <textarea
          value={question}
          onChange={e=>setQuestion(e.target.value)}
          placeholder="Ex: Ma cliente a la peau grasse avec des imperfections, elle veut aussi perdre du poids durablement..."
          rows={3}
          style={{width:"100%",border:`1px solid ${question?C.rose:C.pale}`,borderRadius:12,padding:".65rem .85rem",fontSize:".82rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",resize:"none",lineHeight:1.6}}
        />
      </div>

      <button onClick={genererOrdonnance} disabled={loading||!question.trim()||!baseLoaded}
        style={{width:"100%",background:loading?"#aaa":question.trim()?C.brun:C.pale,color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:loading||!question.trim()?"default":"pointer",marginBottom:"1rem",transition:"background .2s"}}>
        {loading?"✨ L'IA cherche dans les produits...":!baseLoaded?"Chargement de la base...":"✨ Générer l'ordonnance produits"}
      </button>

      {erreur&&<div style={{background:"#FEE",border:"1px solid #E88",borderRadius:9,padding:".65rem .85rem",fontSize:".74rem",color:"#B04040",marginBottom:"1rem"}}>{erreur}</div>}

      {/* ORDONNANCE */}
      {ordonnance&&(
        <div>
          {/* Analyse */}
          <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:12,padding:".9rem 1rem",marginBottom:"1rem"}}>
            <div style={{fontSize:".55rem",fontWeight:700,color:C.or,letterSpacing:".12em",textTransform:"uppercase",marginBottom:".35rem"}}>🔍 Analyse du besoin</div>
            <div style={{fontSize:".82rem",color:C.pale,lineHeight:1.7}}>{ordonnance.analyse}</div>
          </div>

          {/* 3 Packs */}
          {(ordonnance.packs||[]).map((pack,idx)=>(
            <div key={idx} style={{background:C.blanc,border:`2px solid ${pack.couleur}30`,borderRadius:14,overflow:"hidden",marginBottom:".75rem"}}>
              {/* Header pack */}
              <div style={{background:`linear-gradient(135deg,${pack.couleur},${pack.couleur}bb)`,padding:".75rem 1rem"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,color:"white"}}>{pack.emoji} {pack.nom}</div>
                    <div style={{fontSize:".68rem",color:"rgba(255,255,255,.8)",marginTop:".1rem"}}>{pack.description}</div>
                  </div>
                </div>
                <div style={{background:"rgba(255,255,255,.2)",borderRadius:8,padding:".4rem .6rem",marginTop:".5rem",fontSize:".7rem",color:"white",fontWeight:600}}>
                  💡 {pack.avantage_cle}
                </div>
              </div>

              {/* Produits du pack */}
              <div style={{padding:".75rem 1rem"}}>
                {(pack.produits||[]).map((p,i)=>(
                  <div key={i} style={{display:"flex",gap:".55rem",alignItems:"flex-start",padding:".45rem 0",borderBottom:i<(pack.produits.length-1)?`1px solid ${C.pale}30`:"none"}}>
                    <div style={{width:28,height:28,borderRadius:"50%",background:pack.couleur+"20",border:`1.5px solid ${pack.couleur}40`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:".65rem",fontWeight:700,color:pack.couleur}}>
                      {i+1}
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:".8rem",fontWeight:700,color:C.brun}}>{p.nom}</div>
                      <div style={{fontSize:".68rem",color:C.gris,fontStyle:"italic",marginTop:".1rem"}}>{p.role}</div>
                      {p.categorie&&<div style={{fontSize:".58rem",color:pack.couleur,marginTop:".1rem",fontWeight:600}}>{CATEGORIES_PRODUITS.find(c=>c.id===p.categorie)?.icon||""} {p.categorie}</div>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Conseil final */}
          {ordonnance.conseil&&(
            <div style={{background:C.creme,borderRadius:10,padding:".75rem 1rem",border:`1px solid ${C.or}40`}}>
              <div style={{fontSize:".8rem",color:C.brun,lineHeight:1.7,fontStyle:"italic"}}>💛 {ordonnance.conseil}</div>
            </div>
          )}

          {/* Nouvelle question */}
          <button onClick={()=>{setOrdonnance(null);setQuestion("");}}
            style={{width:"100%",marginTop:"1rem",background:"none",border:`1px solid ${C.pale}`,borderRadius:9,padding:".5rem",fontSize:".76rem",color:C.gris,fontFamily:"inherit",cursor:"pointer"}}>
            ← Nouvelle question
          </button>
        </div>
      )}
    </div>
  );
}

export const OBJECTIONS_VENTE=[
  {id:"cher",icon:"💰",label:"C'est trop cher",reponses:["Je comprends ! Ce qui est intéressant avec Mihi, c'est que les produits sont concentrés — une petite quantité suffit, donc le flacon dure bien plus longtemps qu'un produit classique. Au final, le coût par utilisation est souvent inférieur à ce qu'on trouve en grande surface 😊","La qualité a un prix, mais avec Mihi tu ne paies pas la pub, les intermédiaires ou les rayons de supermarché. Tout va dans le produit. Tu veux que je te montre la différence de composition ?","C'est un investissement dans ta peau et ta santé. Et le plus souvent, mes clientes me disent qu'elles ont arrêté d'acheter 3 ou 4 autres produits parce que Mihi leur suffit !"]},
  {id:"besoin",icon:"🤔",label:"Je n'en ai pas besoin",reponses:["Bien sûr, tu n'es pas obligée ! Mais dis-moi, si tu pouvais avoir une peau plus lumineuse / plus d'énergie / moins de cheveux qui tombent... tu prendrais quoi comme produit actuellement ?","Je t'entends. Et souvent, on ne sait pas qu'on a besoin d'un produit avant de l'essayer. C'est pour ça que je propose des tests 😊 Qu'est-ce qui te manquerait le plus si tu pouvais changer une chose dans ta routine ?","Ce n'est pas un problème ! Je ne vends pas à tout le monde. Je te pose juste la question : est-ce que tu es contente à 100% de tes produits actuels ?"]},
  {id:"reflexion",icon:"💭",label:"Je vais réfléchir",reponses:["Bien sûr ! Je ne veux pas que tu achètes par pression. Pour t'aider à réfléchir : qu'est-ce qui te retient ? Le prix, le fait de ne pas connaître les produits, autre chose ?","Je comprends. Tu veux qu'on se rappelle dans 3 jours ? Comme ça tu as le temps d'y penser tranquillement 😊","À quoi tu dois réfléchir précisément ? Si c'est une question sur les ingrédients, les résultats ou le budget, je peux t'aider maintenant !"]},
  {id:"concurrence",icon:"🔄",label:"J'ai déjà une autre marque",reponses:["Super ! Ça veut dire que tu prends soin de toi 🌸 Et si tu ajoutes juste un produit Mihi à côté pour comparer ? Beaucoup de mes clientes ont fait ça et ont progressivement switché quand elles ont vu la différence.","C'est quoi ta marque actuelle ? Je te dis franchement si Mihi est mieux adapté ou pas à ton cas. Je préfère être honnête plutôt que de vendre pour vendre.","Je ne te demande pas de tout changer d'un coup ! Est-ce qu'il y a un seul besoin pour lequel tu n'es pas 100% satisfaite ? On peut commencer par là 😊"]},
  {id:"pharmacie",icon:"🏥",label:"Je préfère la pharmacie",reponses:["La pharmacie c'est bien pour des problèmes spécifiques ! Mais pour la routine quotidienne, Mihi propose des formules sans sulfates, sans parabènes, sans perturbateurs endocriniens. Des ingrédients que tu ne trouveras pas forcément en pharmacie.","Je comprends la confiance en pharmacie. Mihi c'est une gamme développée par ElfaPharm, qui est justement un laboratoire pharmaceutique. Tu bénéficies de la même rigueur, mais avec une distribution directe qui fait baisser le prix.","Est-ce qu'il y a un produit spécifique que tu achètes en pharmacie ? Je peux te dire si on a un équivalent et te montrer la comparaison d'ingrédients 😊"]},
];

export const OBJECTIONS_RECRUTEMENT=[
  {id:"mlm",icon:"😬",label:"C'est du MLM / arnaque",reponses:["Je te comprends totalement, j'avais les mêmes craintes au départ ! La différence fondamentale : avec Mihi, je gagne principalement sur les ventes de vrais produits à de vraies clientes. Pas sur le recrutement. Si je recrutais sans vendre, je ne gagnerais rien.","C'est une vente directe réglementée en France, pas un pyramide. Les produits existent vraiment, les clientes les achètent vraiment. Je peux te montrer mes vrais résultats du mois si tu veux être transparente.","Je ne te demande pas de me croire sur parole ! Je te propose juste de rencontrer quelques membres de l'équipe et de leur poser la question directement. Qu'est-ce qui te ferait changer d'avis si tu pouvais avoir une vraie réponse ?"]},
  {id:"temps",icon:"⏰",label:"Je n'ai pas le temps",reponses:["C'est exactement pour ça que je t'en parle ! Beaucoup de mes membres travaillent depuis leur téléphone, pendant que les enfants dorment ou pendant la pause déjeuner. On adapte à ton rythme de vie, pas l'inverse.","Combien d'heures par semaine tu penses avoir ? Parce qu'avec 3-4h par semaine, certaines de mes membres font déjà 200-300€ de ventes. C'est pas le Pérou, mais c'est un vrai complément.","Je ne veux pas que tu sacrifies du temps que tu n'as pas. On peut juste en parler 20 minutes pour que tu aies toutes les infos ? Après tu décides librement 😊"]},
  {id:"argent",icon:"💶",label:"Je n'ai pas les moyens",reponses:["Le starter kit commence à 39€. C'est le seul investissement — après tu te rembourses sur tes premières ventes. Et si vraiment c'est impossible, on peut trouver une solution ensemble.","Je comprends. Est-ce que c'est un problème de budget ponctuel ou structurel ? Parce que si c'est ponctuel, on peut attendre le bon moment. Et si c'est structurel... n'est-ce pas justement pour ça que tu as besoin de revenus complémentaires ?","On peut commencer progressivement. Parle-en autour de toi, ramène tes premières clientes sans kit, et on voit si l'activité te plaît avant d'investir quoi que ce soit."]},
  {id:"introvertie",icon:"😶",label:"Je suis trop timide / pas commerciale",reponses:["Les meilleures vendeuses de l'équipe sont souvent des personnes discrètes ! Parce qu'elles écoutent vraiment les clientes au lieu de les bombarder. Et avec les produits Mihi, tu n'as pas besoin de 'vendre' — tu partages ce que tu aimes vraiment.","Je n'étais pas commerciale du tout non plus au départ. Ce qui a tout changé : aimer les produits et en parler naturellement. Quand tu crois en ce que tu vends, ça ne ressemble plus à de la vente.","On a une formation complète pour ça ! Scripts, réponses aux objections, stories Instagram... On ne te lâche pas dans le vide. Et les premières ventes se font souvent avec l'entourage proche, pas avec des inconnus 😊"]},
  {id:"experience",icon:"📚",label:"Je n'ai pas d'expérience",reponses:["Bonne nouvelle : on n'en a pas besoin ! J'ai des membres qui n'avaient jamais vendu quoi que ce soit et qui font des centaines d'euros par mois aujourd'hui. On forme tout le monde de zéro.","L'expérience vient en faisant. Et comme je suis ta marraine, tu n'es jamais seule. Chaque question, chaque doute, je suis là pour t'aider à avancer.","La seule chose dont tu as besoin : croire aux produits et être prête à apprendre. Le reste, on te l'enseigne étape par étape dans notre programme de démarrage 🚀"]},
];

// ── CALENDRIER ────────────────────────────────────────────────────────────────

// ── OBJECTIFS POPUP ───────────────────────────────────────────────────────────
// ── PÉRIODE MIHI ─────────────────────────────────────────────────────────────
// Période de 21 jours, commence un mercredi
// Référence : période en cours se termine dans 6j 12h à partir d'aujourd'hui (11/06/2026)
export function getPeriodeInfo(){
  // Utiliser le calendrier officiel Mihi
  const campOfficielle = getCampagneMihiActuelle();
  if(campOfficielle){
    const deb = new Date(campOfficielle.debut+"T12:00:00");
    const fin = new Date(campOfficielle.fin+"T23:59:59");
    const now = Date.now();
    const PERIOD_MS = 21*24*60*60*1000;
    const msLeft = fin.getTime() - now;
    const daysLeft = Math.max(0, Math.ceil(msLeft/(1000*60*60*24)));
    const hoursLeft = Math.max(0, Math.floor((msLeft%(1000*60*60*24))/(1000*60*60)));
    const pctElapsed = Math.min(100, Math.round((now-deb.getTime())/PERIOD_MS*100));
    return {periodNum:campOfficielle.num, periodStart:deb, periodEnd:fin, daysLeft, hoursLeft, pctElapsed, pctLeft:Math.max(0,100-pctElapsed)};
  }
  // Fallback calcul linéaire
  const ANCRE = new Date("2026-01-01T12:00:00").getTime();
  const PERIOD_MS = PERIODE_DUREE_JOURS * 24 * 60 * 60 * 1000;
  const d = new Date(); const now = new Date(d.getFullYear(),d.getMonth(),d.getDate(),12,0,0).getTime();
  const periodNum = Math.max(1, Math.floor((now - ANCRE) / PERIOD_MS) + 1);
  const periodStart = new Date(ANCRE + (periodNum-1)*PERIOD_MS);
  const periodEnd = new Date(periodStart.getTime() + PERIOD_MS);
  const msLeft = periodEnd.getTime() - now;
  const daysLeft = Math.max(0, Math.floor(msLeft / (1000*60*60*24)));
  const hoursLeft = Math.max(0, Math.floor((msLeft % (1000*60*60*24)) / (1000*60*60)));
  const pctElapsed = Math.round((1 - msLeft/PERIOD_MS)*100);
  return { daysLeft, hoursLeft, pctElapsed, periodEnd, periodStart, periodNum };
}

function PeriodeTimer(){
  const[info,setInfo]=useState(getPeriodeInfo());
  useEffect(()=>{
    const t=setInterval(()=>setInfo(getPeriodeInfo()),60000);
    return()=>clearInterval(t);
  },[]);
  
  const urgent = info.daysLeft < 3;
  
  return(
    <div style={{background:urgent?"#FFF3E0":C.creme,border:`1px solid ${urgent?"#E6A817":C.pale}`,borderRadius:10,padding:".65rem .85rem",marginBottom:".75rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".35rem"}}>
        <div style={{fontSize:".65rem",fontWeight:700,color:urgent?"#8B5E00":C.brun}}>
          ⏱️ Période en cours
        </div>
        <div style={{fontSize:".65rem",fontWeight:700,color:urgent?"#C44B1A":C.rose}}>
          {info.daysLeft}j {info.hoursLeft}h restants{urgent?" ⚠️":""}
        </div>
      </div>
      <div style={{height:6,background:C.pale,borderRadius:10,overflow:"hidden",marginBottom:".3rem"}}>
        <div style={{height:"100%",background:urgent?"#E6A817":C.rose,width:info.pctElapsed+"%",borderRadius:10,transition:"width .5s"}}/>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:".58rem",color:C.gris}}>
        <span>Début {info.periodStart.toLocaleDateString("fr-FR",{day:"numeric",month:"short"})}</span>
        <span>{info.pctElapsed}% écoulé</span>
        <span>Fin {info.periodEnd.toLocaleDateString("fr-FR",{day:"numeric",month:"short"})}</span>
      </div>
    </div>
  );
}

function ObjectifsPopup({uid,setTab,onClose,isMelissa}){
  const[obj,setObj]=useState(null);

  // Se rafraîchit toute seule tant que la fenêtre est ouverte (CA d'équipe réel)
  useEffect(()=>{
    let vivant=true;
    const charger=async()=>{
      try{
        const snap=await getDoc(doc(db,"equipe","objectifs"));
        if(vivant&&snap.exists())setObj(snap.data());
      }catch{}
    };
    charger();
    const t=setInterval(charger,20000);
    return()=>{vivant=false;clearInterval(t);};
  },[uid]);
  // CA réel : celui publié par Melissa (Mihi ou saisie) ; s'il date de la campagne précédente on ne l'affiche pas
  const debutCamp=(()=>{try{return getPeriodeInfo().periodStart.getTime();}catch{return 0;}})();
  const caRelPerime=!!(obj&&obj.caRealMaj&&obj.caRealMaj<debutCamp);
  const caRelAffiche=obj?(caRelPerime?"":obj.caReal):"";

  const pct=(r,o)=>{if(!o||!r)return 0;return Math.min(100,Math.round(+r/+o*100));};

  return(
    <div>
      {/* Timer période */}
      <div style={{padding:"1rem 1rem 0"}}><PeriodeTimer/></div>

      <div style={{padding:"1rem"}}>
        {!obj
        ? <div style={{textAlign:"center",padding:"1rem",fontSize:".74rem",color:C.gris}}>
            Objectifs pas encore définis pour l'équipe.
          </div>
        : (<>
          {[
            {label:"💰 Objectif équipe",val:caRelAffiche,o:obj.caObj,unit:"€",color:C.rose},
            {label:"👥 Recrutement équipe",val:obj.recruesReal,o:obj.recruesObj,unit:"",color:C.lilas},
          ].map(({label,val,o,unit,color})=>(
            <div key={label} style={{marginBottom:".8rem"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".25rem"}}>
                <div style={{fontSize:".76rem",fontWeight:600,color:C.brun}}>{label}</div>
                <div style={{display:"flex",gap:".3rem",alignItems:"center"}}>
                  <span style={{fontFamily:"Georgia,serif",fontSize:".95rem",fontWeight:600,color:pct(val,o)>=100?C.vert:color}}>{val||"—"}{unit}</span>
                  <span style={{fontSize:".62rem",color:C.gris}}>/ {o||"—"}{unit}</span>
                  <span style={{background:color+"20",color:color,fontSize:".6rem",fontWeight:700,padding:".1rem .35rem",borderRadius:20}}>{pct(val,o)}%</span>
                </div>
              </div>
              <div style={{height:6,background:C.pale,borderRadius:10,overflow:"hidden"}}>
                <div style={{height:"100%",background:pct(val,o)>=100?C.vert:color,width:pct(val,o)+"%",borderRadius:10,transition:"width .5s"}}/>
              </div>
            </div>
          ))}
          {obj.caRealMaj&&!caRelPerime&&(
            <div style={{fontSize:".58rem",color:C.gris,marginBottom:".5rem",marginTop:"-.3rem"}}>CA équipe mis à jour le {new Date(obj.caRealMaj).toLocaleDateString("fr-FR",{day:"numeric",month:"short"})} à {new Date(obj.caRealMaj).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}</div>
          )}
          {obj.msg&&(
            <div style={{background:C.brun,borderRadius:8,padding:".65rem .8rem",marginTop:".3rem"}}>
              <div style={{fontSize:".55rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.or,marginBottom:".25rem"}}>👑 Message de Melissa</div>
              <div style={{fontSize:".72rem",color:C.blanc,lineHeight:1.5}}>{obj.msg}</div>
            </div>
          )}
        </>)}
        {isMelissa&&setTab&&(
          <button onClick={()=>{setTab("objectifs");if(onClose)onClose();}}
            style={{width:"100%",background:"none",border:`1.5px solid ${C.rose}`,color:C.rose,borderRadius:8,padding:".5rem",fontSize:".74rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginTop:".8rem"}}>
            ✏️ Modifier les objectifs équipe
          </button>
        )}
      </div>
    </div>
  );
}

// ── GAMIFICATION (Lot 2a) ─────────────────────────────────────────────────────

// Pluie de confettis CSS pure, déclenchée à chaque changement de la prop "trigger"
export function Confetti({trigger}){
  const [pieces, setPieces] = useState([]);
  useEffect(()=>{
    if(!trigger) return;
    const colors = [C.rose, C.or, C.lilas, C.vert, "#FFD700", C.brun2];
    const arr = Array.from({length:60},(_,i)=>({
      id: i+"-"+trigger,
      left: Math.random()*100,
      delay: Math.random()*0.4,
      duration: 2 + Math.random()*1.5,
      color: colors[Math.floor(Math.random()*colors.length)],
      size: 6 + Math.random()*6,
      rotate: Math.random()*360,
    }));
    setPieces(arr);
    const t = setTimeout(()=>setPieces([]), 3500);
    return ()=>clearTimeout(t);
  },[trigger]);

  if(pieces.length===0) return null;

  return(
    <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:9999,overflow:"hidden"}}>
      <style>{`
        @keyframes confetti-fall {
          0% { transform: translateY(-10vh) rotate(0deg); opacity:1; }
          100% { transform: translateY(110vh) rotate(720deg); opacity:0; }
        }
      `}</style>
      {pieces.map(p=>(
        <div key={p.id} style={{
          position:"absolute", top:0, left:p.left+"vw",
          width:p.size, height:p.size*0.4, background:p.color,
          animation:`confetti-fall ${p.duration}s ease-in ${p.delay}s forwards`,
          borderRadius:2, transform:`rotate(${p.rotate}deg)`,
        }}/>
      ))}
    </div>
  );
}

// Feu d'artifice — pour les grandes célébrations (primes validées)
function Fireworks({trigger}){
  const [bursts, setBursts] = useState([]);
  useEffect(()=>{
    if(!trigger) return;
    const colors = [C.rose, C.or, C.lilas, C.vert, "#FFD700", "#FF6B6B", "#4ECDC4"];
    const arr = Array.from({length:5},(_,i)=>({
      id: i+"-"+trigger,
      x: 15 + Math.random()*70,
      y: 15 + Math.random()*50,
      delay: i*0.3,
      color: colors[Math.floor(Math.random()*colors.length)],
      particles: Array.from({length:16},(_,j)=>({
        angle: (j/16)*360,
        dist: 40+Math.random()*40,
      })),
    }));
    setBursts(arr);
    const t = setTimeout(()=>setBursts([]), 4500);
    return ()=>clearTimeout(t);
  },[trigger]);

  if(bursts.length===0) return null;

  return(
    <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:9999,overflow:"hidden"}}>
      <style>{`
        @keyframes firework-particle {
          0% { transform: translate(0,0) scale(1); opacity:1; }
          100% { transform: translate(var(--dx), var(--dy)) scale(0); opacity:0; }
        }
        @keyframes firework-flash {
          0% { opacity:0; }
          15% { opacity:1; }
          100% { opacity:0; }
        }
      `}</style>
      {bursts.map(b=>(
        <div key={b.id} style={{position:"absolute",left:b.x+"vw",top:b.y+"vh",animation:`firework-flash 4s ${b.delay}s forwards`}}>
          {b.particles.map((p,i)=>(
            <div key={i} style={{
              position:"absolute",width:8,height:8,borderRadius:"50%",background:b.color,
              "--dx":`${Math.cos(p.angle*Math.PI/180)*p.dist}vw`,
              "--dy":`${Math.sin(p.angle*Math.PI/180)*p.dist}vh`,
              animation:`firework-particle 1.4s ease-out ${b.delay}s forwards`,
            }}/>
          ))}
        </div>
      ))}
    </div>
  );
}

// Définition des badges disponibles
export const BADGES_DEF=[
  {id:"king-suivi",icon:"📞",label:"King du Suivi",desc:"10 actions de suivi validées",
    check:(d)=> (d.totalActionsValidees||0) >= 10},
  {id:"recruteur-elite",icon:"👑",label:"Recruteur Élite",desc:"5 recrues au total",
    check:(d)=> (d.totalRecrues||0) >= 5},
  {id:"premiere-recrue",icon:"🌱",label:"Première Recrue",desc:"Ta toute première recrue",
    check:(d)=> (d.totalRecrues||0) >= 1},
  {id:"regularite",icon:"🔥",label:"Régularité",desc:"5 jours de connexion d'affilée",
    check:(d)=> (d.streak||0) >= 5},
  {id:"regularite-or",icon:"⭐",label:"Régularité Or",desc:"15 jours de connexion d'affilée",
    check:(d)=> (d.streak||0) >= 15},
  {id:"objectif-ca",icon:"💰",label:"Objectif CA Atteint",desc:"100% de ton objectif CA du mois",
    check:(d)=> (d.pctCA||0) >= 100},
  {id:"objectif-recrues",icon:"🎯",label:"Objectif Recrues Atteint",desc:"100% de ton objectif recrues du mois",
    check:(d)=> (d.pctRecrues||0) >= 100},
  {id:"premiere-vente",icon:"💎",label:"Première Vente",desc:"Ton premier point CA enregistré",
    check:(d)=> (d.ca||0) > 0},
  {id:"semaine-parfaite",icon:"✅",label:"Semaine Parfaite",desc:"Les 5 actions du jour validées",
    check:(d)=> (d.doneCount||0) >= 5},
];

// Calcule les badges débloqués à partir des données de l'utilisatrice
export function computeBadges(d){
  return BADGES_DEF.map(b=>({...b, unlocked: b.check(d)}));
}

// Citation / conseil / question d'auto-coaching du jour — carte à retourner à la 1ère ouverture du jour
// ── TO-DO LISTE PERSONNELLE ───────────────────────────────────────────────────
// ── BIBLIOTHÈQUE D'ACTIONS ────────────────────────────────────────────────────
const ACTIONS_BIBLIO = {
  ventes: [
    {id:"v1",icon:"📸",label:"Poster une photo avant/après produit"},
    {id:"v2",icon:"🎥",label:"Faire un Reel de démonstration produit"},
    {id:"v3",icon:"💬",label:"Envoyer 3 DM à des personnes qui ont liké tes posts"},
    {id:"v4",icon:"🛍️",label:"Partager un témoignage client en story"},
    {id:"v5",icon:"✨",label:"Faire une story \"routine du matin\" avec tes produits"},
    {id:"v6",icon:"📋",label:"Envoyer un devis personnalisé à une cliente intéressée"},
    {id:"v7",icon:"🎁",label:"Créer une offre groupée de 2-3 produits complémentaires"},
    {id:"v8",icon:"📞",label:"Appeler une ancienne cliente pour prendre des nouvelles"},
    {id:"v9",icon:"💌",label:"Envoyer un message de suivi à une cliente qui a commandé"},
    {id:"v10",icon:"🌟",label:"Poster un top 3 produits de la semaine"},
    {id:"v11",icon:"🎬",label:"Faire un live de 15 min sur un produit phare"},
    {id:"v12",icon:"📊",label:"Créer un sondage story sur les besoins beauté"},
    {id:"v13",icon:"💡",label:"Partager un conseil beauté lié à tes produits"},
    {id:"v14",icon:"🤳",label:"Faire un unboxing d'un produit en story"},
    {id:"v15",icon:"💰",label:"Proposer un paiement en 2-3 fois à une cliente hésitante"},
    {id:"v16",icon:"🎯",label:"Contacter 5 personnes de ta liste chaude"},
    {id:"v17",icon:"📱",label:"Publier le lien de ton diagnostic personnalisé en story"},
    {id:"v18",icon:"🌸",label:"Faire une story \"ma peau ce matin\" naturelle et authentique"},
    {id:"v19",icon:"💆",label:"Poster un rituel soin corps avec tes produits"},
    {id:"v20",icon:"🎉",label:"Annoncer une nouveauté ou lancement produit"},
    {id:"v21",icon:"📷",label:"Poster une photo lifestyle avec le produit intégré naturellement"},
    {id:"v22",icon:"🔖",label:"Partager un article ou étude sur les bienfaits d'un ingrédient"},
    {id:"v23",icon:"👩",label:"Mettre en avant le témoignage d'une cliente satisfaite"},
    {id:"v24",icon:"💎",label:"Créer un contenu comparatif avant/après 30 jours"},
    {id:"v25",icon:"🛒",label:"Faire une story avec le lien direct vers ton catalogue"},
    {id:"v26",icon:"🌙",label:"Partager ta routine du soir en stories"},
    {id:"v27",icon:"☀️",label:"Partager ta routine du matin en stories"},
    {id:"v28",icon:"📣",label:"Faire un post éducatif sur un problème de peau courant"},
    {id:"v29",icon:"🧴",label:"Filmer l'application d'un produit en texture et résultat"},
    {id:"v30",icon:"🤝",label:"Proposer un diagnostic offert à 3 personnes de ta liste"},
    {id:"v31",icon:"🎀",label:"Créer un contenu cadeau idéal pour une occasion"},
    {id:"v32",icon:"💬",label:"Répondre à tous les commentaires de tes posts récents"},
    {id:"v33",icon:"🌿",label:"Poster sur les ingrédients naturels de tes produits"},
    {id:"v34",icon:"👑",label:"Faire un carrousel top 5 produits bestsellers"},
    {id:"v35",icon:"📲",label:"Relancer par DM les personnes qui ont regardé tes stories"},
    {id:"v36",icon:"🎗️",label:"Créer un post autour d'une journée thématique"},
    {id:"v37",icon:"💫",label:"Partager ton propre résultat visible sur un produit"},
    {id:"v38",icon:"🔔",label:"Activer les rappels commandes pour 3 clientes"},
    {id:"v39",icon:"📝",label:"Rédiger 3 scripts de vente pour tes produits phares"},
    {id:"v40",icon:"🌈",label:"Faire un post sur la gamme couleur maquillage"},
    {id:"v41",icon:"🧪",label:"Tester un nouveau produit et partager ta première impression"},
    {id:"v42",icon:"💪",label:"Poster un contenu sur les compléments alimentaires et énergie"},
    {id:"v43",icon:"🏆",label:"Partager tes résultats du mois (ventes, clientes)"},
    {id:"v44",icon:"🎓",label:"Créer un mini-guide beauté à partager en DM"},
    {id:"v45",icon:"🔥",label:"Faire une vente flash 24h sur un produit"},
    {id:"v46",icon:"🌺",label:"Poster sur les bienfaits d'un produit en détail"},
    {id:"v47",icon:"💝",label:"Envoyer un message de remerciement à tes meilleures clientes"},
    {id:"v48",icon:"📌",label:"Épingler ton meilleur post de vente sur ton profil"},
    {id:"v49",icon:"🌟",label:"Demander à 3 clientes un avis écrit ou vidéo"},
    {id:"v50",icon:"🎯",label:"Identifier 10 nouvelles cibles sur Instagram et les suivre"},
    {id:"v51",icon:"💅",label:"Faire un contenu sur les soins ongles/mains"},
    {id:"v52",icon:"🧘",label:"Poster sur bien-être et beauté intérieure"},
    {id:"v53",icon:"🛁",label:"Créer un contenu rituel bain/détente avec tes produits"},
    {id:"v54",icon:"📦",label:"Filmer la préparation d'une commande cliente"},
    {id:"v55",icon:"🌍",label:"Poster sur l'engagement éco ou naturel de la marque"},
    {id:"v56",icon:"❤️",label:"Faire un post sur pourquoi tu as choisi ces produits"},
    {id:"v57",icon:"🎪",label:"Organiser un jeu concours (partage+follow)"},
    {id:"v58",icon:"💬",label:"Créer une FAQ beauté en carrousel"},
    {id:"v59",icon:"🌙",label:"Poster un contenu anti-âge ciblé"},
    {id:"v60",icon:"🏃",label:"Contacter les personnes inactives depuis 3 mois"},
    {id:"v61",icon:"🌸",label:"Faire un post sur les soins sensibles/peaux réactives"},
    {id:"v62",icon:"💡",label:"Créer un contenu mythe vs réalité beauté"},
    {id:"v63",icon:"🎥",label:"Filmer un tutoriel maquillage rapide"},
    {id:"v64",icon:"📱",label:"Mettre à jour ta bio Instagram avec ton lien diagnostic"},
    {id:"v65",icon:"🌿",label:"Poster sur les bienfaits des soins capillaires"},
    {id:"v66",icon:"✨",label:"Faire un post sur l'éclat de peau en 7 jours"},
    {id:"v67",icon:"💎",label:"Présenter la gamme premium en story"},
    {id:"v68",icon:"🛍️",label:"Créer un post \"idée cadeau sous 50€\""},
    {id:"v69",icon:"📊",label:"Faire un sondage sur le problème beauté n°1 de tes followers"},
    {id:"v70",icon:"🤳",label:"Poster une selfie naturelle avec un produit"},
    {id:"v71",icon:"🎁",label:"Offrir un échantillon à une nouvelle cliente"},
    {id:"v72",icon:"💰",label:"Calculer et partager ta marge sur une vente type"},
    {id:"v73",icon:"🌟",label:"Mettre en avant un produit méconnu de la gamme"},
    {id:"v74",icon:"📸",label:"Créer une série de 3 stories \"conseil du jour\""},
    {id:"v75",icon:"💆",label:"Poster sur les bienfaits du massage avec vos produits"},
    {id:"v76",icon:"🔑",label:"Partager 3 astuces pour maximiser l'efficacité d'un produit"},
    {id:"v77",icon:"🌺",label:"Créer un contenu saisonnier (été, hiver, rentrée...)"},
    {id:"v78",icon:"💬",label:"Réactiver une conversation DM en attente"},
    {id:"v79",icon:"📋",label:"Mettre à jour ta liste de produits favoris"},
    {id:"v80",icon:"🎯",label:"Identifier les 5 clientes avec le plus grand potentiel"},
    {id:"v81",icon:"🧴",label:"Comparer deux produits similaires de la gamme en story"},
    {id:"v82",icon:"💪",label:"Poster sur les résultats en 21 jours d'utilisation"},
    {id:"v83",icon:"🌈",label:"Créer un post coloré et vitaminé sur la gamme maquillage"},
    {id:"v84",icon:"🎬",label:"Faire un mini documentaire \"une journée avec mes produits\""},
    {id:"v85",icon:"🤝",label:"Proposer un appel découverte gratuit à 3 prospects"},
    {id:"v86",icon:"📌",label:"Créer un highlight Instagram dédié aux témoignages"},
    {id:"v87",icon:"💫",label:"Poster sur la transformation de ta peau depuis que tu utilises les produits"},
    {id:"v88",icon:"🌙",label:"Faire une story ASMR application produit"},
    {id:"v89",icon:"🎓",label:"Partager un fait méconnu sur un ingrédient clé"},
    {id:"v90",icon:"💝",label:"Envoyer un cadeau surprise à une cliente fidèle"},
    {id:"v91",icon:"📲",label:"Créer un carrousel \"erreurs beauté à éviter\""},
    {id:"v92",icon:"🌿",label:"Poster sur la composition naturelle de tes produits"},
    {id:"v93",icon:"🏆",label:"Célébrer une réussite cliente en story (avec permission)"},
    {id:"v94",icon:"🔥",label:"Lancer un défi beauté 7 jours avec tes clientes"},
    {id:"v95",icon:"💬",label:"Faire un Q&A en story sur tes produits"},
    {id:"v96",icon:"🌺",label:"Poster sur les soins corps en période hivernale"},
    {id:"v97",icon:"✨",label:"Créer un contenu sur les routines minimalistes"},
    {id:"v98",icon:"📦",label:"Faire un haul produits avec descriptions détaillées"},
    {id:"v99",icon:"💡",label:"Partager 5 façons d'utiliser un produit multi-usage"},
    {id:"v100",icon:"🎯",label:"Planifier tes 5 prochains posts de vente à l'avance"},
  ],
  recrutement: [
    {id:"r1",icon:"👥",label:"Partager ton témoignage sur ce que l'activité t'a apporté"},
    {id:"r2",icon:"💰",label:"Poster sur la liberté financière que tu vis"},
    {id:"r3",icon:"🌟",label:"Faire un post \"rejoins mon équipe\" authentique"},
    {id:"r4",icon:"📱",label:"Contacter 3 personnes qui ont montré de l'intérêt"},
    {id:"r5",icon:"🎥",label:"Faire un Reel sur ta journée type en tant que distributrice"},
    {id:"r6",icon:"💡",label:"Poster sur les avantages produits pour les distributrices"},
    {id:"r7",icon:"🤝",label:"Envoyer le lien de présentation à une contact qualifiée"},
    {id:"r8",icon:"🌸",label:"Partager les résultats de ta dernière période"},
    {id:"r9",icon:"📊",label:"Créer un post sur le plan de rémunération simplifié"},
    {id:"r10",icon:"🎯",label:"Identifier 5 profils potentiellement intéressés dans ta liste"},
    {id:"r11",icon:"💬",label:"Inviter une amie à découvrir l'activité autour d'un café"},
    {id:"r12",icon:"🏆",label:"Partager une victoire de ton équipe en story"},
    {id:"r13",icon:"✨",label:"Poster sur l'ambiance et l'esprit d'équipe Blazing Dynasty"},
    {id:"r14",icon:"🎓",label:"Expliquer la formation disponible pour les nouvelles"},
    {id:"r15",icon:"💪",label:"Faire un post sur ce que tu as appris depuis que tu as commencé"},
    {id:"r16",icon:"🌈",label:"Partager un post sur la diversité des profils dans ton équipe"},
    {id:"r17",icon:"📸",label:"Poster une photo de groupe avec ton équipe"},
    {id:"r18",icon:"🔑",label:"Expliquer le système de parrainage en story"},
    {id:"r19",icon:"💫",label:"Partager un témoignage d'une filleule sur sa progression"},
    {id:"r20",icon:"🎁",label:"Faire un post sur les cadeaux et bonus Mihi"},
    {id:"r21",icon:"🌍",label:"Poster sur la possibilité de travailler depuis n'importe où"},
    {id:"r22",icon:"⏰",label:"Faire un post sur la flexibilité des horaires"},
    {id:"r23",icon:"💌",label:"Envoyer un message personnalisé à une prospect recrutement"},
    {id:"r24",icon:"📋",label:"Préparer ton pitch de 2 minutes pour présenter l'activité"},
    {id:"r25",icon:"🎬",label:"Filmer un \"pourquoi j'ai dit oui\" sincère"},
    {id:"r26",icon:"💎",label:"Poster sur les incentives et voyages Mihi"},
    {id:"r27",icon:"🤳",label:"Faire une story sur tes objectifs du mois"},
    {id:"r28",icon:"🌺",label:"Partager un post sur l'épanouissement personnel dans l'activité"},
    {id:"r29",icon:"📱",label:"Partager ton lien diagnostic avec un angle recrutement"},
    {id:"r30",icon:"🏃",label:"Contacter une personne qui cherche un complément de revenus"},
    {id:"r31",icon:"💬",label:"Répondre à tous les commentaires sur ton post recrutement"},
    {id:"r32",icon:"🌟",label:"Faire un post sur les paliers et progression du plan"},
    {id:"r33",icon:"🎯",label:"Organiser une présentation en ligne pour 3-5 personnes"},
    {id:"r34",icon:"💡",label:"Créer un carrousel \"5 idées reçues sur le MLM\""},
    {id:"r35",icon:"🤝",label:"Faire un appel découverte avec une nouvelle prospect"},
    {id:"r36",icon:"📊",label:"Montrer concrètement combien tu as gagné ce mois"},
    {id:"r37",icon:"🎉",label:"Fêter l'anniversaire d'entrée d'une filleule en story"},
    {id:"r38",icon:"💰",label:"Poster sur les revenus passifs possibles avec l'équipe"},
    {id:"r39",icon:"🌸",label:"Partager comment l'activité a changé ta confiance en toi"},
    {id:"r40",icon:"📸",label:"Faire un before/after de ta vie avant/après l'activité"},
    {id:"r41",icon:"🎓",label:"Présenter la formation Fast Start en story"},
    {id:"r42",icon:"💪",label:"Montrer une journée productive avec ton activité Mihi"},
    {id:"r43",icon:"🌈",label:"Poster sur les possibilités d'évolution dans l'équipe"},
    {id:"r44",icon:"🔔",label:"Relancer les prospects recrutement inactifs depuis 2 semaines"},
    {id:"r45",icon:"✨",label:"Faire un post sur \"ma vie dans 1 an grâce à Mihi\""},
    {id:"r46",icon:"🎀",label:"Créer un kit de bienvenue digital pour tes nouvelles"},
    {id:"r47",icon:"💫",label:"Partager les formations et outils disponibles dans l'app"},
    {id:"r48",icon:"🏆",label:"Poster sur un objectif que tu as atteint grâce à l'activité"},
    {id:"r49",icon:"🌍",label:"Faire un post sur l'indépendance et l'entrepreneuriat féminin"},
    {id:"r50",icon:"💬",label:"Faire un sondage \"es-tu intéressée par un revenu complémentaire ?\""},
    {id:"r51",icon:"📲",label:"Créer un highlight Instagram \"rejoins l'équipe\""},
    {id:"r52",icon:"🌺",label:"Partager 3 choses que tu aurais aimé savoir avant de commencer"},
    {id:"r53",icon:"🎥",label:"Filmer une réunion d'équipe ou appel collectif"},
    {id:"r54",icon:"💡",label:"Créer un carrousel \"comment ça marche en 5 étapes\""},
    {id:"r55",icon:"🤝",label:"Présenter une filleule à tes abonnés"},
    {id:"r56",icon:"📋",label:"Écrire 3 objections courantes et tes réponses"},
    {id:"r57",icon:"💰",label:"Poster sur ce que tu as pu payer grâce à tes revenus Mihi"},
    {id:"r58",icon:"🌟",label:"Faire un post sur la communauté et le soutien entre membres"},
    {id:"r59",icon:"🎯",label:"Contacter 3 mamans à la maison dans ta liste"},
    {id:"r60",icon:"💎",label:"Partager les avantages exclusifs pour les chefs d'équipe"},
    {id:"r61",icon:"🌸",label:"Faire un post sur \"on peut commencer sans expérience\""},
    {id:"r62",icon:"📱",label:"Créer une story interactive sur l'activité"},
    {id:"r63",icon:"🏃",label:"Contacter une amie qui t'a déjà dit chercher quelque chose"},
    {id:"r64",icon:"💬",label:"Faire un live \"questions/réponses sur l'activité Mihi\""},
    {id:"r65",icon:"🌈",label:"Poster sur les valeurs de la marque et de l'équipe"},
    {id:"r66",icon:"📸",label:"Partager une photo de ton espace de travail"},
    {id:"r67",icon:"🎉",label:"Célébrer une nouvelle recrue en story"},
    {id:"r68",icon:"💪",label:"Faire un post sur la persévérance et les premiers mois"},
    {id:"r69",icon:"✨",label:"Partager ce qui te motive à continuer chaque jour"},
    {id:"r70",icon:"🎓",label:"Expliquer le rôle de cheffe d'équipe et ses avantages"},
    {id:"r71",icon:"🔑",label:"Partager ton lien de présentation dans ta bio"},
    {id:"r72",icon:"💫",label:"Faire un post sur les paliers atteints cette année"},
    {id:"r73",icon:"🌍",label:"Poster sur la possibilité de recruter en dehors de ta ville"},
    {id:"r74",icon:"💌",label:"Écrire une lettre ouverte \"pourquoi tu devrais rejoindre\""},
    {id:"r75",icon:"🏆",label:"Partager le résultat de ta meilleure période"},
    {id:"r76",icon:"🌺",label:"Faire un post sincère sur les difficultés et comment tu les surmontes"},
    {id:"r77",icon:"📊",label:"Créer une infographie simple sur le plan de rémunération"},
    {id:"r78",icon:"🤳",label:"Faire une story \"ce qui a tout changé pour moi\""},
    {id:"r79",icon:"💡",label:"Poster sur comment combiner Mihi avec un emploi salarié"},
    {id:"r80",icon:"🎯",label:"Envoyer le témoignage d'une filleule à une prospect"},
    {id:"r81",icon:"💬",label:"Créer un sondage sur les freins au démarrage d'une activité"},
    {id:"r82",icon:"🌟",label:"Faire un post sur l'impact de l'activité sur ta famille"},
    {id:"r83",icon:"🎀",label:"Préparer un kit de démarrage pour une nouvelle filleule"},
    {id:"r84",icon:"💰",label:"Calculer et partager le potentiel de revenus à 6 mois"},
    {id:"r85",icon:"🌸",label:"Poster sur les réseaux de femmes et la sororité"},
    {id:"r86",icon:"📲",label:"Contacter 5 personnes qui ont demandé \"comment tu fais\""},
    {id:"r87",icon:"🎥",label:"Faire un mini-reportage sur une journée avec tes filleules"},
    {id:"r88",icon:"💪",label:"Partager ta progression depuis ton lancement"},
    {id:"r89",icon:"✨",label:"Poster sur les reconnaissances et récompenses Mihi"},
    {id:"r90",icon:"🤝",label:"Planifier un appel de suivi avec une recrue récente"},
    {id:"r91",icon:"🌈",label:"Faire un post sur l'activité comme plan B devenu plan A"},
    {id:"r92",icon:"🎓",label:"Créer un mini guide \"commencer avec Mihi\" à partager"},
    {id:"r93",icon:"💎",label:"Partager les avantages produits dont tu bénéficies"},
    {id:"r94",icon:"🏃",label:"Contacter les amies qui ont aimé tes posts récents"},
    {id:"r95",icon:"📋",label:"Mettre à jour ta liste de prospects recrutement"},
    {id:"r96",icon:"💫",label:"Faire un post sur ce que l'activité t'a appris sur toi"},
    {id:"r97",icon:"🌺",label:"Partager les succès de ton équipe ce mois-ci"},
    {id:"r98",icon:"🎯",label:"Organiser un café virtuel recrutement avec 3 personnes"},
    {id:"r99",icon:"💬",label:"Répondre aux questions sur l'activité en story interactive"},
    {id:"r100",icon:"🏆",label:"Écrire et poster ta vision à 12 mois dans l'activité"},
  ],
  algorithme: [
    {id:"al1",icon:"⏰",label:"Poster à l'heure de pointe (7h, 12h ou 19h)"},
    {id:"al2",icon:"💬",label:"Commenter 20 posts de comptes similaires au tien"},
    {id:"al3",icon:"❤️",label:"Liker les 30 derniers posts de tes abonnés actifs"},
    {id:"al4",icon:"📊",label:"Analyser tes statistiques et noter le meilleur post de la semaine"},
    {id:"al5",icon:"🔁",label:"Repartager un contenu pertinent en story avec ton avis"},
    {id:"al6",icon:"📱",label:"Répondre à toutes tes stories reçues en DM"},
    {id:"al7",icon:"🎯",label:"Utiliser 10-15 hashtags ciblés sur ton prochain post"},
    {id:"al8",icon:"🌟",label:"Créer un carrousel (3-10 slides) — fort pour la portée"},
    {id:"al9",icon:"🎥",label:"Publier un Reel de 15-30 secondes dynamique"},
    {id:"al10",icon:"💡",label:"Poser une question ouverte dans ta légende de post"},
    {id:"al11",icon:"🤝",label:"Répondre à tous tes commentaires dans les 30 premières minutes"},
    {id:"al12",icon:"📸",label:"Publier une photo haute qualité avec lumière naturelle"},
    {id:"al13",icon:"🔔",label:"Activer tes notifications pour interagir rapidement"},
    {id:"al14",icon:"🌈",label:"Utiliser une palette de couleurs cohérente sur ton feed"},
    {id:"al15",icon:"📝",label:"Écrire une légende longue et engageante (300+ mots)"},
    {id:"al16",icon:"💫",label:"Créer un sondage en story pour maximiser les interactions"},
    {id:"al17",icon:"🎪",label:"Utiliser la fonction quiz en story"},
    {id:"al18",icon:"🌺",label:"Poster une story avec curseur de notation"},
    {id:"al19",icon:"💬",label:"Faire un \"question box\" en story"},
    {id:"al20",icon:"📌",label:"Épingler ton meilleur commentaire sur un post récent"},
    {id:"al21",icon:"🎬",label:"Faire un live et interagir en temps réel"},
    {id:"al22",icon:"🔗",label:"Mettre à jour le lien en bio avec un lien actuel"},
    {id:"al23",icon:"🌟",label:"Taguer des comptes pertinents dans tes posts (avec sens)"},
    {id:"al24",icon:"📲",label:"Utiliser la géolocalisation sur tes posts"},
    {id:"al25",icon:"🤳",label:"Faire une collab post avec un compte complémentaire"},
    {id:"al26",icon:"⚡",label:"Publier 2 stories minimum par jour"},
    {id:"al27",icon:"🌸",label:"Créer un highlight thématique et le mettre à jour"},
    {id:"al28",icon:"💡",label:"Utiliser les mots-clés dans ta bio Instagram"},
    {id:"al29",icon:"📊",label:"Vérifier tes heures de meilleure audience dans les stats"},
    {id:"al30",icon:"🎯",label:"Interagir pendant 15 min avant de publier ton post"},
    {id:"al31",icon:"💎",label:"Créer un contenu \"save-worthy\" (à sauvegarder)"},
    {id:"al32",icon:"🔥",label:"Créer un contenu \"share-worthy\" (à partager)"},
    {id:"al33",icon:"❤️",label:"Aller commenter les posts en tendance de ta niche"},
    {id:"al34",icon:"🌍",label:"Poster en story depuis un lieu avec géolocalisation"},
    {id:"al35",icon:"📱",label:"Répondre aux DM dans les 2h pour booster l'engagement"},
    {id:"al36",icon:"🎁",label:"Créer un contenu exclusif à partager uniquement en DM"},
    {id:"al37",icon:"🏆",label:"Analyser le contenu viral de ta niche et t'en inspirer"},
    {id:"al38",icon:"💬",label:"Demander à tes abonnés de taguer une amie dans un post"},
    {id:"al39",icon:"📸",label:"Faire un \"before/after\" — format très partagé"},
    {id:"al40",icon:"🎥",label:"Utiliser la tendance audio du moment pour ton Reel"},
    {id:"al41",icon:"✨",label:"Créer un filtre ou sticker de marque en story"},
    {id:"al42",icon:"🌺",label:"Partager un post de ta filleule avec ton commentaire"},
    {id:"al43",icon:"💫",label:"Faire un \"compte à rebours\" en story pour une annonce"},
    {id:"al44",icon:"🔑",label:"Créer un contenu \"liste\" numérotée — très engageant"},
    {id:"al45",icon:"📋",label:"Faire un \"Top 5\" ou \"Top 10\" dans ta niche"},
    {id:"al46",icon:"🌟",label:"Utiliser les sous-titres automatiques sur tes Reels"},
    {id:"al47",icon:"💪",label:"Poster tôt le matin (avant 8h) pour maximiser la portée"},
    {id:"al48",icon:"🎯",label:"Créer du contenu evergreen (intemporel et toujours utile)"},
    {id:"al49",icon:"🌈",label:"Alterner formats : photo, carrousel, Reel, story"},
    {id:"al50",icon:"📲",label:"Activer les sous-titres sur tous tes vidéos"},
    {id:"al51",icon:"💡",label:"Faire un \"mythe vs réalité\" dans ta niche"},
    {id:"al52",icon:"🤳",label:"Poster une selfie authentique et naturelle"},
    {id:"al53",icon:"🎬",label:"Utiliser des transitions créatives dans tes Reels"},
    {id:"al54",icon:"💬",label:"Répondre en vidéo à un commentaire pertinent"},
    {id:"al55",icon:"📊",label:"Faire un tableau ou infographie simple et lisible"},
    {id:"al56",icon:"🌸",label:"Partager un moment de coulisses (behind the scenes)"},
    {id:"al57",icon:"🎀",label:"Faire un \"wrap up\" hebdomadaire en story"},
    {id:"al58",icon:"💰",label:"Créer un contenu avec appel à l'action clair"},
    {id:"al59",icon:"🔔",label:"Demander à tes abonnés d'activer les notifications"},
    {id:"al60",icon:"🌍",label:"Participer à un challenge tendance de ta niche"},
    {id:"al61",icon:"✨",label:"Utiliser le texte animé dans tes stories"},
    {id:"al62",icon:"🏃",label:"Publier à la même heure chaque jour pour la régularité"},
    {id:"al63",icon:"💎",label:"Créer un contenu avec une promesse forte dans le titre"},
    {id:"al64",icon:"🤝",label:"Faire une mention partenaire avec une autre distributrice"},
    {id:"al65",icon:"📸",label:"Varier les angles de prise de vue (dessus, côté, gros plan)"},
    {id:"al66",icon:"🎯",label:"Utiliser des hashtags de niche (10-50k posts) pour la visibilité"},
    {id:"al67",icon:"💬",label:"Épingler une story de présentation de toi"},
    {id:"al68",icon:"🌺",label:"Faire un \"day in my life\" engageant"},
    {id:"al69",icon:"💡",label:"Poster sur un sujet controversé (positivement) de ta niche"},
    {id:"al70",icon:"📱",label:"Utiliser les stickers interactifs sur toutes tes stories"},
    {id:"al71",icon:"🎥",label:"Faire un Reel avec voix off pour plus d'authenticité"},
    {id:"al72",icon:"💫",label:"Créer une série de posts sur un même thème"},
    {id:"al73",icon:"🌟",label:"Optimiser ta bio avec des emojis et mots-clés"},
    {id:"al74",icon:"📊",label:"Tester 2 types de posts différents cette semaine"},
    {id:"al75",icon:"🎁",label:"Offrir un contenu gratuit pour les DM (PDF, guide...)"},
    {id:"al76",icon:"🔥",label:"Poster sur un sujet tendance dans ta niche"},
    {id:"al77",icon:"💬",label:"Commenter les posts des influenceurs de ta niche"},
    {id:"al78",icon:"🌸",label:"Créer un post avec beaucoup de texte pour le temps de lecture"},
    {id:"al79",icon:"❤️",label:"Faire une sélection de tes posts favoris en story"},
    {id:"al80",icon:"📸",label:"Utiliser la photo de profil comme accroche de story"},
    {id:"al81",icon:"🎯",label:"Répondre aux stories de tes abonnés pour créer du lien"},
    {id:"al82",icon:"💡",label:"Créer un post \"voici ce que j'aurais aimé savoir\""},
    {id:"al83",icon:"🏆",label:"Faire un post récapitulatif de ta semaine"},
    {id:"al84",icon:"🌈",label:"Utiliser des couleurs vives et contrastées pour attirer l'œil"},
    {id:"al85",icon:"📲",label:"Tester la fonction \"diffusion\" Instagram"},
    {id:"al86",icon:"💎",label:"Créer du contenu UGC (user generated content) avec clientes"},
    {id:"al87",icon:"🤳",label:"Faire un \"get ready with me\" dans ta niche"},
    {id:"al88",icon:"✨",label:"Utiliser les effets de lumière naturelle pour tes photos"},
    {id:"al89",icon:"🌺",label:"Poster un contenu inspirationnel qui donne envie d'agir"},
    {id:"al90",icon:"🎀",label:"Faire un \"thank you\" sincère à tes abonnés"},
    {id:"al91",icon:"💬",label:"Créer un post avec une liste de ressources utiles"},
    {id:"al92",icon:"📋",label:"Tester un nouveau format de contenu cette semaine"},
    {id:"al93",icon:"🌟",label:"Poster une citation motivante avec ta photo"},
    {id:"al94",icon:"💪",label:"Faire un contenu de \"preuve sociale\" (chiffres, résultats)"},
    {id:"al95",icon:"🎬",label:"Utiliser la musique tendance sur tes Reels"},
    {id:"al96",icon:"🔑",label:"Créer un post avec un titre accrocheur en première ligne"},
    {id:"al97",icon:"💫",label:"Utiliser la fonction \"close friends\" pour du contenu exclusif"},
    {id:"al98",icon:"🌍",label:"Poster sur l'impact positif de tes actions"},
    {id:"al99",icon:"🎯",label:"Analyser et reproduire ton post avec le plus d'engagement"},
    {id:"al100",icon:"🏃",label:"Maintenir un rythme de publication régulier pendant 21 jours"},
  ],
};

export function BiblioActionsPopup({onClose, onAjouter, actionsCustom=[]}){
  const[cat,setCat]=useState("ventes");
  const[recherche,setRecherche]=useState("");
  const[actionsChef,setActionsChef]=useState([]);

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","actions_biblio"));
        if(snap.exists()) setActionsChef(snap.data().items||[]);
      }catch{}
    })();
  },[]);

  const cats=[
    {id:"ventes",icon:"🛍️",label:"Ventes"},
    {id:"recrutement",icon:"👥",label:"Recrutement"},
    {id:"algorithme",icon:"⚡",label:"Algorithme"},
    {id:"equipe",icon:"✨",label:"Équipe"},
  ];

  const actionsEquipe=actionsChef.filter(a=>a.cat===cat||cat==="equipe"&&a.cat==="equipe");
  const actionsBase=ACTIONS_BIBLIO[cat]||[];
  const actions=cat==="equipe"?actionsEquipe:[...actionsBase,...actionsChef.filter(a=>a.cat===cat)];

  const filtrees=recherche.trim()
    ? [
        ...ACTIONS_BIBLIO.ventes,...ACTIONS_BIBLIO.recrutement,...ACTIONS_BIBLIO.algorithme,
        ...actionsChef
      ].filter(a=>a.label.toLowerCase().includes(recherche.toLowerCase()))
    : actions;

  const dejaAjoutee=(id)=>actionsCustom.some(a=>a.id===id);

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.7)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9999,padding:"0"}}>
      <div style={{background:C.blanc,borderRadius:"18px 18px 0 0",width:"100%",maxWidth:480,maxHeight:"85vh",display:"flex",flexDirection:"column",boxShadow:"0 -8px 40px rgba(0,0,0,.25)"}}>

        {/* Header */}
        <div style={{padding:"1.1rem 1.1rem .6rem",borderBottom:`1px solid ${C.pale}`,flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".7rem"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>💡 Bibliothèque d'actions</div>
            <button onClick={onClose} style={{background:"none",border:"none",fontSize:"1.2rem",color:C.gris,cursor:"pointer"}}>✕</button>
          </div>

          {/* Recherche */}
          <input value={recherche} onChange={e=>setRecherche(e.target.value)}
            placeholder="🔍 Rechercher une action..."
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".5rem .8rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".6rem"}}/>

          {/* Onglets catégories */}
          {!recherche&&(
            <div style={{display:"flex",gap:".3rem"}}>
              {cats.map(c=>(
                <button key={c.id} onClick={()=>setCat(c.id)}
                  style={{flex:1,padding:".4rem .2rem",fontSize:".68rem",fontWeight:700,border:"none",borderRadius:8,background:cat===c.id?C.brun:C.creme,color:cat===c.id?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit",transition:"all .15s"}}>
                  {c.icon} {c.label}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Liste */}
        <div style={{overflowY:"auto",flex:1,padding:".6rem .8rem"}}>
          {filtrees.map(a=>{
            const ajoutee=dejaAjoutee(a.id);
            return(
              <div key={a.id} style={{display:"flex",alignItems:"center",gap:".6rem",padding:".55rem .6rem",borderRadius:10,marginBottom:".3rem",background:ajoutee?C.vert+"10":C.blanc,border:`1px solid ${ajoutee?C.vert+"40":C.pale}`}}>
                <span style={{fontSize:"1.1rem",flexShrink:0}}>{a.icon}</span>
                <div style={{flex:1,fontSize:".76rem",color:C.texte,lineHeight:1.4}}>{a.label}</div>
                <button onClick={()=>!ajoutee&&onAjouter(a)}
                  style={{background:ajoutee?C.vert:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".28rem .6rem",fontSize:".68rem",fontWeight:700,fontFamily:"inherit",cursor:ajoutee?"default":"pointer",flexShrink:0,transition:"all .2s"}}>
                  {ajoutee?"✓ Ajoutée":"+ Ajouter"}
                </button>
              </div>
            );
          })}
        </div>

        {actionsCustom.length>0&&(
          <div style={{padding:".6rem 1rem",borderTop:`1px solid ${C.pale}`,background:C.creme,flexShrink:0}}>
            <div style={{fontSize:".68rem",color:C.gris,textAlign:"center"}}>
              ✅ {actionsCustom.length} action{actionsCustom.length>1?"s":""} ajoutée{actionsCustom.length>1?"s":""} à ta journée
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export function TodoPerso({uid}){
  const[todos,setTodos]=useState([]);
  const[newTodo,setNewTodo]=useState("");
  const[adding,setAdding]=useState(false);
  const[saving,setSaving]=useState(false);

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",uid));
        if(snap.exists()&&snap.data()["db-todos"]){
          setTodos(JSON.parse(snap.data()["db-todos"]));
        }
      }catch{}
    })();
  },[uid]);

  const saveTodos=async(next)=>{
    setTodos(next);
    try{await setDoc(doc(db,"users",uid),{"db-todos":JSON.stringify(next)},{merge:true});}catch{}
  };

  const addTodo=async()=>{
    if(!newTodo.trim())return;
    setSaving(true);
    const next=[...todos,{id:`t${Date.now()}`,text:newTodo.trim(),done:false}];
    await saveTodos(next);
    setNewTodo("");setAdding(false);setSaving(false);
  };

  const toggleTodo=(id)=>saveTodos(todos.map(t=>t.id===id?{...t,done:!t.done}:t));
  const delTodo=(id)=>saveTodos(todos.filter(t=>t.id!==id));

  const actives=todos.filter(t=>!t.done);
  const faits=todos.filter(t=>t.done);

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:14,padding:"1rem",marginBottom:"1rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".65rem"}}>
        <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.brun}}>
          ✅ Ma to-do liste
        </div>
        <button onClick={()=>setAdding(!adding)}
          style={{background:adding?C.rose:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".25rem .65rem",fontSize:".68rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          {adding?"✕":"+ Ajouter"}
        </button>
      </div>

      {adding&&(
        <div style={{display:"flex",gap:".4rem",marginBottom:".65rem"}}>
          <input
            value={newTodo} onChange={e=>setNewTodo(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&addTodo()}
            placeholder="Nouvelle tâche..."
            autoFocus
            style={{flex:1,border:`1px solid ${C.rose}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
          <button onClick={addTodo} disabled={!newTodo.trim()||saving}
            style={{background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".42rem .75rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            ✓
          </button>
        </div>
      )}

      {actives.length===0&&!adding&&(
        <div style={{fontSize:".74rem",color:C.gris,textAlign:"center",padding:".5rem",fontStyle:"italic"}}>
          Aucune tâche — ajoute ta première ! 🎯
        </div>
      )}

      {actives.map(t=>(
        <div key={t.id} style={{display:"flex",alignItems:"center",gap:".55rem",padding:".45rem 0",borderBottom:`1px solid ${C.pale}`}}>
          <div onClick={()=>toggleTodo(t.id)}
            style={{width:20,height:20,borderRadius:5,border:`2px solid ${C.rose}`,background:"transparent",flexShrink:0,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
          </div>
          <div style={{flex:1,fontSize:".8rem",color:C.texte,lineHeight:1.4}}>{t.text}</div>
          <button onClick={()=>delTodo(t.id)}
            style={{background:"none",border:"none",color:C.pale,cursor:"pointer",fontSize:".75rem",padding:".1rem .3rem",fontFamily:"inherit"}}>✕</button>
        </div>
      ))}

      {faits.length>0&&(
        <div style={{marginTop:".5rem"}}>
          <div style={{fontSize:".58rem",color:C.gris,marginBottom:".3rem",textTransform:"uppercase",letterSpacing:".08em"}}>Fait ✓</div>
          {faits.map(t=>(
            <div key={t.id} style={{display:"flex",alignItems:"center",gap:".55rem",padding:".35rem 0",opacity:.5}}>
              <div onClick={()=>toggleTodo(t.id)}
                style={{width:20,height:20,borderRadius:5,border:`2px solid ${C.vert}`,background:C.vert,flexShrink:0,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <span style={{fontSize:".55rem",color:"white",fontWeight:700}}>✓</span>
              </div>
              <div style={{flex:1,fontSize:".78rem",color:C.gris,textDecoration:"line-through"}}>{t.text}</div>
              <button onClick={()=>delTodo(t.id)}
                style={{background:"none",border:"none",color:C.pale,cursor:"pointer",fontSize:".75rem",padding:".1rem .3rem",fontFamily:"inherit"}}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── POPUP BIENVENUE (première connexion) ─────────────────────────────────────
function WelcomePopup({userName, onClose}){
  const prenom = userName.split(" ")[0] || userName;
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9999,padding:"0"}}>
      <div style={{background:C.blanc,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,maxHeight:"90vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.3)"}}>

        {/* Header */}
        <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:"1.5rem 1.2rem 1.2rem",textAlign:"center"}}>
          <div style={{fontSize:"2.2rem",marginBottom:".4rem"}}>👑</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.blanc,lineHeight:1.3}}>
            Bienvenue {prenom} !
          </div>
          <div style={{fontFamily:"Georgia,serif",fontSize:".85rem",color:C.pale,marginTop:".3rem",fontStyle:"italic"}}>
            Tu fais maintenant partie de Blazing Dynasty ✨
          </div>
        </div>

        <div style={{padding:"1.2rem"}}>

          {/* Message équipe */}
          <div style={{background:C.creme,borderRadius:12,padding:".9rem 1rem",marginBottom:"1rem",borderLeft:`3px solid ${C.or}`}}>
            <div style={{fontSize:".72rem",color:C.brun,lineHeight:1.7}}>
              🌸 Nous sommes tellement heureuses de t'accueillir dans notre équipe. Tu as fait le bon choix — maintenant on est là pour t'accompagner à chaque étape. Let's go ! 💛
            </div>
          </div>

          {/* Telegram */}
          <div style={{background:C.lilas+"15",border:`1px solid ${C.lilas}30`,borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem"}}>
            <div style={{fontSize:".78rem",fontWeight:700,color:C.brun,marginBottom:".5rem"}}>✈️ Nos groupes Telegram</div>
            <a href="https://t.me/+2wKWxIROE4c1M2Q0" target="_blank" rel="noopener noreferrer"
              style={{display:"flex",alignItems:"center",gap:".6rem",background:"#29A0D8",borderRadius:9,padding:".55rem .85rem",textDecoration:"none",marginBottom:".4rem"}}>
              <span style={{fontSize:"1rem"}}>🖼️</span>
              <div>
                <div style={{fontSize:".78rem",fontWeight:600,color:"white"}}>Banque d'images équipe</div>
                <div style={{fontSize:".62rem",color:"rgba(255,255,255,.75)"}}>Accède aux visuels de l'équipe</div>
              </div>
            </a>
            <a href="https://t.me/+pv0RY_JJy4wyYzE8" target="_blank" rel="noopener noreferrer"
              style={{display:"flex",alignItems:"center",gap:".6rem",background:"#29A0D8",borderRadius:9,padding:".55rem .85rem",textDecoration:"none"}}>
              <span style={{fontSize:"1rem"}}>⭐</span>
              <div>
                <div style={{fontSize:".78rem",fontWeight:600,color:"white"}}>Groupe témoignages</div>
                <div style={{fontSize:".62rem",color:"rgba(255,255,255,.75)"}}>Découvre les résultats de l'équipe</div>
              </div>
            </a>
          </div>

          {/* Tes 2 premiers accès */}
          <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris,marginBottom:".5rem"}}>
            🔓 Tes accès du moment
          </div>

          <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:12,padding:".85rem 1rem",marginBottom:".5rem",display:"flex",alignItems:"center",gap:".75rem"}}>
            <div style={{fontSize:"1.4rem",flexShrink:0}}>🚀</div>
            <div>
              <div style={{fontSize:".82rem",fontWeight:700,color:C.blanc}}>Fast Start</div>
              <div style={{fontSize:".68rem",color:C.pale}}>7 modules progressifs pour bien démarrer — commence par là !</div>
            </div>
          </div>

          <div style={{background:C.lilas+"15",border:`1px solid ${C.lilas}30`,borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",display:"flex",alignItems:"center",gap:".75rem"}}>
            <div style={{fontSize:"1.4rem",flexShrink:0}}>🎬</div>
            <div>
              <div style={{fontSize:".82rem",fontWeight:700,color:C.brun}}>Formation Application</div>
              <div style={{fontSize:".68rem",color:C.gris}}>Apprends à utiliser l'appli pour te faciliter la vie</div>
            </div>
          </div>

          {/* Bandeau déverrouillage */}
          <div style={{background:C.or+"20",border:`1px solid ${C.or}`,borderRadius:10,padding:".65rem .85rem",marginBottom:"1.2rem",display:"flex",alignItems:"center",gap:".5rem"}}>
            <span style={{fontSize:"1rem"}}>🔒</span>
            <div style={{fontSize:".7rem",color:C.brun,lineHeight:1.5}}>
              <strong>Le reste de la formation</strong> se débloque automatiquement quand tu auras terminé tes 7 modules Fast Start 🎉
            </div>
          </div>

          <button onClick={onClose}
            style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:12,padding:".8rem",fontSize:".88rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Commencer le Fast Start 🚀
          </button>
        </div>
      </div>
    </div>
  );
}
function PowerHourStartPopup({session, onClose}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:20,width:"100%",maxWidth:420,overflow:"hidden",boxShadow:"0 8px 40px rgba(0,0,0,.3)"}}>
        <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:"1.5rem 1.2rem",textAlign:"center"}}>
          <div style={{fontSize:"2.4rem",marginBottom:".4rem"}}>{"\u{26A1}"}</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.blanc}}>Power Hour lancee !</div>
          <div style={{fontSize:".8rem",color:C.pale,marginTop:".3rem"}}>par {session.startedBy} - 20 minutes de focus intense</div>
          {session.theme&&(
            <div style={{fontSize:".78rem",color:C.or,marginTop:".5rem",fontWeight:700,background:"rgba(255,255,255,.15)",display:"inline-block",padding:".3rem .8rem",borderRadius:20}}>
              Theme : {session.theme}
            </div>
          )}
        </div>
        <div style={{padding:"1.2rem"}}>
          <button onClick={onClose}
            style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:12,padding:".9rem",fontSize:".88rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Je participe {"\u{1F680}"}
          </button>
        </div>
      </div>
    </div>
  );
}
function PowerHourEndPopup({session, onClose}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:20,width:"100%",maxWidth:420,overflow:"hidden",boxShadow:"0 8px 40px rgba(0,0,0,.3)"}}>
        <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:"1.5rem 1.2rem",textAlign:"center"}}>
          <div style={{fontSize:"2.4rem",marginBottom:".4rem"}}>{"\u{2705}"}</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.blanc}}>Power Hour terminee !</div>
          <div style={{fontSize:".8rem",color:C.pale,marginTop:".3rem"}}>Bravo pour ces 20 minutes de focus {"\u{1F389}"}</div>
        </div>
        <div style={{padding:"1.2rem"}}>
          <button onClick={onClose}
            style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:12,padding:".9rem",fontSize:".88rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Merci {"\u{2728}"}
          </button>
        </div>
      </div>
    </div>
  );
}
function AnnonceRecuePopup({annonce, onClose}){
  const urgent=!!annonce.urgente;
  const[copie,setCopie]=useState(false);
  const copierTexte=()=>{
    navigator.clipboard.writeText(annonce.message||"").then(()=>{
      setCopie(true);
      setTimeout(()=>setCopie(false),2000);
    }).catch(()=>{});
  };
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:20,width:"100%",maxWidth:420,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,.3)"}}>
        <div style={{background:urgent?"#B8442F":`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:"1.5rem 1.2rem",textAlign:"center",borderRadius:"20px 20px 0 0"}}>
          <div style={{fontSize:"2.4rem",marginBottom:".4rem"}}>{annonce.icone||"\u{1F4E2}"}</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:300,color:C.blanc}}>{annonce.titre||"Annonce de l equipe"}</div>
          {urgent&&<div style={{fontSize:".68rem",color:"#FFD9D0",marginTop:".3rem",fontWeight:700,letterSpacing:".05em",textTransform:"uppercase"}}>Important</div>}
        </div>
        <div style={{padding:"1.2rem"}}>
          {annonce.video?(
            <div style={{marginBottom:"1rem"}}>
              <video src={annonce.video} controls style={{width:"100%",borderRadius:12,display:"block"}}/>
            </div>
          ):annonce.photo&&(
            <div style={{marginBottom:"1rem"}}>
              <img src={annonce.photo} alt="" style={{width:"100%",borderRadius:12,display:"block"}}/>
              <a href={annonce.photo} download target="_blank" rel="noreferrer"
                style={{display:"inline-flex",alignItems:"center",gap:".3rem",fontSize:".7rem",color:C.brun,marginTop:".4rem",textDecoration:"underline"}}>
                💾 Enregistrer la photo
              </a>
            </div>
          )}
          <p style={{fontSize:".84rem",color:C.texte,lineHeight:1.7,marginBottom:".6rem",whiteSpace:"pre-wrap"}}>{annonce.message}</p>
          <button onClick={copierTexte}
            style={{display:"flex",alignItems:"center",gap:".35rem",background:"none",border:"none",color:C.gris,fontSize:".72rem",fontFamily:"inherit",cursor:"pointer",padding:0,marginBottom:"1rem"}}>
            {copie?"✓ Texte copié !":"📋 Copier le texte"}
          </button>
          <button onClick={onClose}
            style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:12,padding:".9rem",fontSize:".88rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            J'ai compris {"\u{2713}"}
          </button>
        </div>
      </div>
    </div>
  );
}
function AnnonceAdminPopup({uid, onClose, annonceExistante}){
  const enEdition=!!annonceExistante;
  const ICONES=["\u{1F4E2}","\u{26A1}","\u{1F389}","\u{26A0}","\u{1F393}","\u{1F4B0}","\u{1F525}","\u{2728}"];
  const[titre,setTitre]=useState(annonceExistante?.titre||"");
  const[message,setMessage]=useState(annonceExistante?.message||"");
  const[icone,setIcone]=useState(annonceExistante?.icone||"\u{1F4E2}");
  const[urgente,setUrgente]=useState(!!annonceExistante?.urgente);
  const[sending,setSending]=useState(false);
  const[sent,setSent]=useState(false);
  const[media,setMedia]=useState(null);
  const[mediaPreview,setMediaPreview]=useState(annonceExistante?.video||annonceExistante?.photo||null);
  const[mediaType,setMediaType]=useState(annonceExistante?.video?"video":(annonceExistante?.photo?"image":null)); // "image" | "video"
  const[uploadingMedia,setUploadingMedia]=useState(false);
  const[datePublication,setDatePublication]=useState("");

  const choisirMedia=(e)=>{
    const f=e.target.files&&e.target.files[0];
    if(!f)return;
    const type=f.type.startsWith("video/")?"video":"image";
    if(type==="video"&&f.size>50*1024*1024){alert("La vidéo est trop lourde (50 Mo max).");return;}
    setMedia(f);
    setMediaType(type);
    const reader=new FileReader();
    reader.onload=()=>setMediaPreview(reader.result);
    reader.readAsDataURL(f);
  };

  const publier=async()=>{
    if(!titre.trim()||!message.trim())return;
    setSending(true);
    try{
      const id=enEdition?annonceExistante.id:Date.now();
      let photoUrl=enEdition?(annonceExistante.photo||""):"", videoUrl=enEdition?(annonceExistante.video||""):"";
      if(media){
        setUploadingMedia(true);
        try{
          const ext=mediaType==="video"?(media.name.split(".").pop()||"mp4"):"jpg";
          const chemin=storageRef(storage,`annonces/${id}.${ext}`);
          await uploadBytes(chemin,media);
          const url=await getDownloadURL(chemin);
          if(mediaType==="video"){videoUrl=url;photoUrl="";} else {photoUrl=url;videoUrl="";}
        }catch{}
        setUploadingMedia(false);
      }
      const estProgrammee=!enEdition&&datePublication&&new Date(datePublication).getTime()>Date.now();
      const donneesAnnonce={
        id,
        titre:titre.trim(),
        message:message.trim(),
        icone,
        urgente,
        photo:photoUrl,
        video:videoUrl,
        creePar:enEdition?annonceExistante.creePar:uid,
        creeLe:enEdition?annonceExistante.creeLe:id,
      };
      if(estProgrammee){
        await setDoc(doc(db,"annonces_programmees",String(id)),{...donneesAnnonce,publierLe:new Date(datePublication).getTime()});
      }else{
        await setDoc(doc(db,"annonces_historique",String(id)),donneesAnnonce);
        // Met a jour l'annonce courante seulement si c'est bien celle-ci qui est affichee actuellement
        try{
          const curSnap=await getDoc(doc(db,"equipe","derniere-annonce"));
          if(!enEdition||(curSnap.exists()&&String(curSnap.data().id)===String(id))){
            await setDoc(doc(db,"equipe","derniere-annonce"),donneesAnnonce);
          }
        }catch{}
      }
      setSent(true);
      setTimeout(()=>{onClose();},1500);
    }catch{}
    setSending(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.6)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:"16px 16px 0 0",padding:"1.4rem",width:"100%",maxWidth:480,boxShadow:"0 -8px 32px rgba(0,0,0,.2)",maxHeight:"85vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>{"\u{1F4E2}"} {enEdition?"Modifier l'annonce":"Annonce officielle"}</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:"1.2rem",color:C.gris,cursor:"pointer",padding:".2rem"}}>x</button>
        </div>
        <p style={{fontSize:".72rem",color:C.gris,marginBottom:"1rem",lineHeight:1.6}}>
          {enEdition?"Les modifications remplacent l'annonce dans l'historique (et l'annonce du moment si c'est celle-ci qui est actuellement affichée).":"Envoyee a toute l equipe, en popup dans l appli et en notification push sur leur telephone."}
        </p>
        <div style={{display:"flex",gap:".4rem",marginBottom:"1rem",flexWrap:"wrap"}}>
          {ICONES.map(ic=>(
            <button key={ic} onClick={()=>setIcone(ic)}
              style={{fontSize:"1.3rem",background:icone===ic?C.brun+"20":C.creme,border:icone===ic?`2px solid ${C.brun}`:"1px solid transparent",borderRadius:10,padding:".4rem .6rem",cursor:"pointer"}}>
              {ic}
            </button>
          ))}
        </div>
        <input value={titre} onChange={e=>setTitre(e.target.value)} placeholder="Titre de l'annonce"
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".7rem .85rem",fontFamily:"inherit",fontSize:".85rem",color:C.texte,marginBottom:".7rem",outline:"none"}}/>
        <textarea value={message} onChange={e=>setMessage(e.target.value)} placeholder="Ton message..."
          style={{width:"100%",minHeight:110,border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem",fontFamily:"inherit",fontSize:".82rem",color:C.texte,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:".8rem"}}/>
        <label style={{display:"flex",alignItems:"center",gap:".5rem",fontSize:".78rem",color:C.brun,marginBottom:".8rem",cursor:"pointer"}}>
          <input type="checkbox" checked={urgente} onChange={e=>setUrgente(e.target.checked)}/>
          Marquer comme importante (mise en avant en rouge)
        </label>
        <div style={{marginBottom:"1rem"}}>
          <label style={{display:"inline-flex",alignItems:"center",gap:".4rem",fontSize:".76rem",fontWeight:600,color:C.brun,background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .8rem",cursor:"pointer"}}>
            📷 {mediaPreview?"Changer le média":"Ajouter une photo ou vidéo (optionnel)"}
            <input type="file" accept="image/*,video/*" onChange={choisirMedia} style={{display:"none"}}/>
          </label>
          {mediaPreview&&(
            <div style={{position:"relative",marginTop:".6rem",width:120}}>
              {mediaType==="video"
                ? <video src={mediaPreview} style={{width:120,height:120,objectFit:"cover",borderRadius:10,border:`1px solid ${C.pale}`}} muted/>
                : <img src={mediaPreview} alt="Aperçu" style={{width:120,height:120,objectFit:"cover",borderRadius:10,border:`1px solid ${C.pale}`}}/>
              }
              <button onClick={()=>{setMedia(null);setMediaPreview(null);setMediaType(null);}}
                style={{position:"absolute",top:-8,right:-8,width:24,height:24,borderRadius:"50%",background:C.brun,color:"white",border:"none",fontSize:".75rem",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
            </div>
          )}
        </div>
        {!enEdition&&(
          <div style={{marginBottom:"1rem"}}>
            <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:C.gris,letterSpacing:".05em",textTransform:"uppercase",marginBottom:".35rem"}}>Programmer pour plus tard (optionnel)</label>
            <input type="datetime-local" value={datePublication} onChange={e=>setDatePublication(e.target.value)}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .7rem",fontFamily:"inherit",fontSize:".78rem",color:C.texte,outline:"none"}}/>
            {datePublication&&new Date(datePublication).getTime()>Date.now()&&(
              <div style={{fontSize:".68rem",color:C.gris,marginTop:".3rem"}}>📅 Sera publiée automatiquement le {new Date(datePublication).toLocaleDateString("fr-FR",{day:"numeric",month:"long",hour:"2-digit",minute:"2-digit"})}</div>
            )}
          </div>
        )}
        <button onClick={publier} disabled={!titre.trim()||!message.trim()||sending||sent}
          style={{width:"100%",background:sent?C.vert:(titre.trim()&&message.trim())?C.brun:C.pale,color:(titre.trim()&&message.trim())?C.blanc:C.gris,border:"none",borderRadius:10,padding:".8rem",fontSize:".85rem",fontWeight:700,fontFamily:"inherit",cursor:(titre.trim()&&message.trim())?"pointer":"default"}}>
          {sent?(enEdition?"Modifications enregistrées !":(datePublication&&new Date(datePublication).getTime()>Date.now()?"Annonce programmée !":"Envoyee a toute l equipe !")):uploadingMedia?"Envoi du média...":sending?"Envoi...":(enEdition?"Enregistrer les modifications":(datePublication&&new Date(datePublication).getTime()>Date.now()?"Programmer l'annonce →":"Publier a toute l equipe ->"))}
        </button>
      </div>
    </div>
  );
}
function SondageAdminPopup({uid, onClose}){
  const[question,setQuestion]=useState("");
  const[options,setOptions]=useState(["",""]);
  const[multiChoix,setMultiChoix]=useState(false);
  const[dateFin,setDateFin]=useState("");
  const[sending,setSending]=useState(false);
  const[sent,setSent]=useState(false);

  const modifierOption=(i,val)=>{
    const copie=[...options];
    copie[i]=val;
    setOptions(copie);
  };
  const ajouterOption=()=>{ if(options.length<6)setOptions([...options,""]); };
  const retirerOption=(i)=>{ if(options.length>2)setOptions(options.filter((_,idx)=>idx!==i)); };

  const optionsValides=options.map(o=>o.trim()).filter(Boolean);
  const pretAPublier=question.trim()&&optionsValides.length>=2;

  const publier=async()=>{
    if(!pretAPublier)return;
    setSending(true);
    try{
      const id=String(Date.now());
      await enregistrerSondage({
        id,
        question:question.trim(),
        options:optionsValides.map((texte,i)=>({id:"opt"+i,texte})),
        multiChoix,
        dateFin:dateFin?new Date(dateFin).getTime():null,
        actif:true,
        creePar:uid,
        creeLe:Date.now(),
      });
      setSent(true);
      setTimeout(()=>{onClose();},1200);
    }catch{}
    setSending(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.6)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:"20px 20px 0 0",padding:"1.4rem",width:"100%",maxWidth:480,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.3)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>🗳️ Nouveau sondage</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:"1.2rem",color:C.gris,cursor:"pointer",padding:".2rem"}}>x</button>
        </div>
        <input value={question} onChange={e=>setQuestion(e.target.value)} placeholder="Ta question..."
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".7rem .85rem",fontFamily:"inherit",fontSize:".85rem",color:C.texte,marginBottom:".8rem",outline:"none"}}/>
        <div style={{fontSize:".68rem",fontWeight:700,color:C.gris,letterSpacing:".05em",textTransform:"uppercase",marginBottom:".5rem"}}>Options de réponse</div>
        {options.map((opt,i)=>(
          <div key={i} style={{display:"flex",gap:".4rem",marginBottom:".5rem",alignItems:"center"}}>
            <input value={opt} onChange={e=>modifierOption(i,e.target.value)} placeholder={`Option ${i+1}`}
              style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .8rem",fontFamily:"inherit",fontSize:".82rem",color:C.texte,outline:"none"}}/>
            {options.length>2&&(
              <button onClick={()=>retirerOption(i)} style={{background:"none",border:"none",color:C.gris,fontSize:"1rem",cursor:"pointer",padding:".3rem"}}>✕</button>
            )}
          </div>
        ))}
        {options.length<6&&(
          <button onClick={ajouterOption}
            style={{background:"none",border:"none",color:C.brun,fontSize:".76rem",fontWeight:600,cursor:"pointer",padding:".2rem 0",marginBottom:".9rem",textDecoration:"underline"}}>
            + Ajouter une option
          </button>
        )}
        <label style={{display:"flex",alignItems:"center",gap:".5rem",fontSize:".78rem",color:C.brun,marginBottom:"1.1rem",cursor:"pointer"}}>
          <input type="checkbox" checked={multiChoix} onChange={e=>setMultiChoix(e.target.checked)}/>
          Autoriser plusieurs réponses par personne
        </label>
        <div style={{marginBottom:"1.1rem"}}>
          <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:C.gris,letterSpacing:".05em",textTransform:"uppercase",marginBottom:".35rem"}}>Date de fin (optionnel)</label>
          <input type="datetime-local" value={dateFin} onChange={e=>setDateFin(e.target.value)}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .7rem",fontFamily:"inherit",fontSize:".78rem",color:C.texte,outline:"none"}}/>
          {dateFin&&<div style={{fontSize:".68rem",color:C.gris,marginTop:".3rem"}}>🔒 Se clôturera automatiquement le {new Date(dateFin).toLocaleDateString("fr-FR",{day:"numeric",month:"long",hour:"2-digit",minute:"2-digit"})}</div>}
        </div>
        <button onClick={publier} disabled={!pretAPublier||sending||sent}
          style={{width:"100%",background:sent?C.vert:pretAPublier?C.brun:C.pale,color:pretAPublier?C.blanc:C.gris,border:"none",borderRadius:10,padding:".8rem",fontSize:".85rem",fontWeight:700,fontFamily:"inherit",cursor:pretAPublier?"pointer":"default"}}>
          {sent?"Sondage publié !":sending?"Publication...":"Publier le sondage →"}
        </button>
      </div>
    </div>
  );
}

function SondageCard({sondage, votes, uid, isMelissa, onVoted, onSupprime}){
  const monVote=votes.find(v=>v.uid===uid);
  const[selection,setSelection]=useState(monVote?monVote.choix:[]);
  const[voting,setVoting]=useState(false);
  const[suppression,setSuppression]=useState(false);
  const[modification,setModification]=useState(false);
  const dejaVote=!!monVote;
  const totalVotes=votes.length;
  const dateFinDepassee=sondage.dateFin&&Date.now()>sondage.dateFin;
  const estActif=sondage.actif&&!dateFinDepassee;

  const toggleOption=(optId)=>{
    if((dejaVote&&!modification)||!estActif)return;
    if(sondage.multiChoix){
      setSelection(p=>p.includes(optId)?p.filter(x=>x!==optId):[...p,optId]);
    }else{
      setSelection([optId]);
    }
  };

  const confirmerVote=async()=>{
    if(selection.length===0)return;
    setVoting(true);
    try{
      const nouvellesListe=await voterSondage(sondage.id,uid,selection);
      onVoted(sondage.id,nouvellesListe);
      setModification(false);
    }catch{}
    setVoting(false);
  };

  const ouvrirModification=()=>{
    setSelection(monVote?monVote.choix:[]);
    setModification(true);
  };

  const supprimer=async()=>{
    if(!window.confirm(`Supprimer definitivement le sondage "${sondage.question}" ?\n\nCette action est irreversible.`))return;
    setSuppression(true);
    try{
      await supprimerSondage(sondage.id);
      onSupprime(sondage.id);
    }catch{}
    setSuppression(false);
  };

  const compteParOption=(optId)=>votes.filter(v=>v.choix.includes(optId)).length;

  const afficherResultats=(dejaVote&&!modification)||!estActif;

  return(
    <div style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem .9rem"}}>
      <div style={{display:"flex",alignItems:"flex-start",gap:".4rem",marginBottom:".6rem"}}>
        <span style={{fontSize:"1rem"}}>🗳️</span>
        <span style={{fontSize:".8rem",fontWeight:700,color:C.brun,flex:1}}>{sondage.question}</span>
        {!estActif&&<span style={{fontSize:".55rem",fontWeight:700,color:C.gris,background:C.pale,borderRadius:6,padding:".1rem .4rem",whiteSpace:"nowrap"}}>CLÔTURÉ</span>}
        {isMelissa&&(
          <button onClick={supprimer} disabled={suppression}
            style={{background:"none",border:"none",fontSize:".78rem",cursor:"pointer",padding:".1rem .2rem",opacity:.6,flexShrink:0}}>
            {suppression?"...":"🗑️"}
          </button>
        )}
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
        {sondage.options.map(opt=>{
          const n=compteParOption(opt.id);
          const pct=totalVotes>0?Math.round((n/totalVotes)*100):0;
          const estMonChoix=selection.includes(opt.id);
          if(afficherResultats){
            return(
              <div key={opt.id} style={{position:"relative",borderRadius:8,overflow:"hidden",background:C.blanc,border:`1px solid ${estMonChoix?C.brun:C.pale}`}}>
                <div style={{position:"absolute",top:0,left:0,bottom:0,width:`${pct}%`,background:estMonChoix?C.brun+"30":C.pale+"80",transition:"width .4s"}}/>
                <div style={{position:"relative",display:"flex",justifyContent:"space-between",padding:".45rem .6rem",fontSize:".76rem"}}>
                  <span style={{color:C.texte,fontWeight:estMonChoix?700:400}}>{estMonChoix?"✓ ":""}{opt.texte}</span>
                  <span style={{color:C.gris,fontWeight:600}}>{pct}% ({n})</span>
                </div>
              </div>
            );
          }
          return(
            <button key={opt.id} onClick={()=>toggleOption(opt.id)}
              style={{textAlign:"left",background:estMonChoix?C.brun:C.blanc,color:estMonChoix?C.blanc:C.texte,border:`1px solid ${estMonChoix?C.brun:C.pale}`,borderRadius:8,padding:".5rem .7rem",fontSize:".78rem",fontFamily:"inherit",cursor:"pointer"}}>
              {opt.texte}
            </button>
          );
        })}
      </div>
      {!afficherResultats&&(
        <div style={{display:"flex",gap:".4rem",marginTop:".6rem"}}>
          <button onClick={confirmerVote} disabled={selection.length===0||voting}
            style={{flex:1,background:selection.length>0?C.brun:C.pale,color:selection.length>0?C.blanc:C.gris,border:"none",borderRadius:8,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:selection.length>0?"pointer":"default"}}>
            {voting?"Envoi...":modification?"Confirmer mon nouveau vote":"Voter"}
          </button>
          {modification&&(
            <button onClick={()=>setModification(false)}
              style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .7rem",fontSize:".76rem",color:C.gris,fontFamily:"inherit",cursor:"pointer"}}>
              Annuler
            </button>
          )}
        </div>
      )}
      {afficherResultats&&dejaVote&&estActif&&(
        <button onClick={ouvrirModification}
          style={{width:"100%",marginTop:".5rem",background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem",fontSize:".72rem",color:C.brun,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          ✏️ Modifier mon vote
        </button>
      )}
      <div style={{fontSize:".62rem",color:C.gris,marginTop:".45rem",opacity:.75}}>{totalVotes} vote{totalVotes!==1?"s":""}</div>
    </div>
  );
}

function ObjectifCommunAdminPopup({uid, onClose}){
  const[titre,setTitre]=useState("");
  const[description,setDescription]=useState("");
  const[objectifPas,setObjectifPas]=useState(20);
  const[media,setMedia]=useState(null);
  const[mediaPreview,setMediaPreview]=useState(null);
  const[uploading,setUploading]=useState(false);
  const[sending,setSending]=useState(false);
  const[sent,setSent]=useState(false);

  const choisirMedia=(e)=>{
    const f=e.target.files&&e.target.files[0];
    if(!f)return;
    setMedia(f);
    const reader=new FileReader();
    reader.onload=()=>setMediaPreview(reader.result);
    reader.readAsDataURL(f);
  };

  const pretAPublier=titre.trim()&&objectifPas>0;

  const publier=async()=>{
    if(!pretAPublier)return;
    setSending(true);
    try{
      const id=Date.now();
      let photoUrl="";
      if(media){
        setUploading(true);
        try{
          const chemin=storageRef(storage,`objectif_commun/${id}.jpg`);
          await uploadBytes(chemin,media);
          photoUrl=await getDownloadURL(chemin);
        }catch{}
        setUploading(false);
      }
      await enregistrerObjectifCommun({
        id,
        titre:titre.trim(),
        description:description.trim(),
        objectifPas:Number(objectifPas),
        photo:photoUrl,
        creePar:uid,
        creeLe:id,
      });
      setSent(true);
      setTimeout(()=>{onClose();},1200);
    }catch{}
    setSending(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.6)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:"20px 20px 0 0",padding:"1.4rem",width:"100%",maxWidth:480,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.3)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>🎯 Objectif commun</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:"1.2rem",color:C.gris,cursor:"pointer",padding:".2rem"}}>x</button>
        </div>
        <p style={{fontSize:".72rem",color:C.gris,marginBottom:"1rem",lineHeight:1.6}}>
          Ça remplace l'objectif en cours (s'il y en a un). Chaque personne de l'équipe pourra cliquer une fois pour ajouter son pas.
        </p>
        <input value={titre} onChange={e=>setTitre(e.target.value)} placeholder="Titre de l'objectif"
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".7rem .85rem",fontFamily:"inherit",fontSize:".85rem",color:C.texte,marginBottom:".7rem",outline:"none"}}/>
        <textarea value={description} onChange={e=>setDescription(e.target.value)} placeholder="Décris l'objectif et la récompense à la clé..."
          style={{width:"100%",minHeight:90,border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem",fontFamily:"inherit",fontSize:".82rem",color:C.texte,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:".8rem"}}/>
        <div style={{marginBottom:".8rem"}}>
          <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:C.gris,letterSpacing:".05em",textTransform:"uppercase",marginBottom:".4rem"}}>Nombre de pas pour atteindre l'objectif</label>
          <input type="number" min="1" value={objectifPas} onChange={e=>setObjectifPas(e.target.value)}
            style={{width:120,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .8rem",fontFamily:"inherit",fontSize:".85rem",color:C.texte,outline:"none"}}/>
        </div>
        <div style={{marginBottom:"1.1rem"}}>
          <label style={{display:"inline-flex",alignItems:"center",gap:".4rem",fontSize:".76rem",fontWeight:600,color:C.brun,background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .8rem",cursor:"pointer"}}>
            📷 {mediaPreview?"Changer la photo":"Ajouter une photo (optionnel)"}
            <input type="file" accept="image/*" onChange={choisirMedia} style={{display:"none"}}/>
          </label>
          {mediaPreview&&(
            <div style={{position:"relative",marginTop:".6rem",width:120}}>
              <img src={mediaPreview} alt="Aperçu" style={{width:120,height:120,objectFit:"cover",borderRadius:10,border:`1px solid ${C.pale}`}}/>
              <button onClick={()=>{setMedia(null);setMediaPreview(null);}}
                style={{position:"absolute",top:-8,right:-8,width:24,height:24,borderRadius:"50%",background:C.brun,color:"white",border:"none",fontSize:".75rem",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
            </div>
          )}
        </div>
        <button onClick={publier} disabled={!pretAPublier||sending||sent}
          style={{width:"100%",background:sent?C.vert:pretAPublier?C.brun:C.pale,color:pretAPublier?C.blanc:C.gris,border:"none",borderRadius:10,padding:".8rem",fontSize:".85rem",fontWeight:700,fontFamily:"inherit",cursor:pretAPublier?"pointer":"default"}}>
          {sent?"Objectif publié !":uploading?"Envoi de la photo...":sending?"Publication...":"Lancer cet objectif →"}
        </button>
      </div>
    </div>
  );
}

function ObjectifCommunCard({objectif, participants, uid, nomAffiche, isMelissa, onPasAjoute}){
  const[ajout,setAjout]=useState(false);
  const monPas=participants.find(p=>p.uid===uid);
  const dejaParticipe=!!monPas;
  const[modification,setModification]=useState(false);
  const[quantite,setQuantite]=useState(monPas?.pas||1);
  const total=participants.reduce((s,p)=>s+(p.pas||1),0);
  const cible=objectif.objectifPas||1;
  const pct=Math.min(100,Math.round((total/cible)*100));
  const atteint=total>=cible;

  const ajouterPas=async()=>{
    if(ajout||quantite<1)return;
    setAjout(true);
    try{
      const nouvelleListe=await ajouterPasObjectif(uid,nomAffiche,quantite);
      onPasAjoute(nouvelleListe);
      setModification(false);
    }catch{}
    setAjout(false);
  };

  return(
    <div style={{background:atteint?"#F0F7ED":C.creme,border:`1px solid ${atteint?"#B8D9A5":C.pale}`,borderRadius:12,padding:".85rem .9rem"}}>
      <div style={{display:"flex",alignItems:"center",gap:".4rem",marginBottom:".4rem"}}>
        <span style={{fontSize:"1rem"}}>{atteint?"🎉":"🎯"}</span>
        <span style={{fontSize:".82rem",fontWeight:700,color:C.brun,flex:1}}>{objectif.titre}</span>
      </div>
      {objectif.photo&&<img src={objectif.photo} alt="" style={{width:"100%",borderRadius:8,marginBottom:".5rem",display:"block"}}/>}
      {objectif.description&&<div style={{fontSize:".74rem",color:C.texte,lineHeight:1.55,marginBottom:".6rem",whiteSpace:"pre-wrap"}}>{objectif.description}</div>}
      <div style={{background:C.pale+"60",borderRadius:8,height:14,overflow:"hidden",marginBottom:".35rem"}}>
        <div style={{height:"100%",width:`${pct}%`,background:atteint?"#7FAF8A":C.brun,transition:"width .5s"}}/>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:".68rem",color:C.gris,marginBottom:".6rem"}}>
        <span>{total} / {cible} pas</span>
        <span>{pct}%</span>
      </div>
      {atteint?(
        <div style={{textAlign:"center",fontSize:".76rem",fontWeight:700,color:"#5A8A5A",padding:".3rem 0"}}>Objectif atteint, bravo à toute l'équipe ! 🎉</div>
      ):(dejaParticipe&&!modification)?(
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:".72rem",color:C.gris,marginBottom:".4rem"}}>✓ Tu as ajouté {monPas.pas||1} pas</div>
          <button onClick={()=>{setQuantite(monPas.pas||1);setModification(true);}}
            style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem .7rem",fontSize:".72rem",color:C.brun,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            ✏️ Modifier ma contribution
          </button>
        </div>
      ):(
        <div style={{display:"flex",gap:".4rem",alignItems:"center"}}>
          <input type="number" min="1" value={quantite} onChange={e=>setQuantite(Math.max(1,+e.target.value||1))}
            style={{width:60,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .4rem",fontSize:".82rem",fontFamily:"inherit",textAlign:"center",color:C.texte,background:C.blanc,outline:"none"}}/>
          <button onClick={ajouterPas} disabled={ajout}
            style={{flex:1,background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".55rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            {ajout?"...":modification?"Confirmer":"➕ Ajouter mes pas !"}
          </button>
          {modification&&(
            <button onClick={()=>setModification(false)}
              style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .6rem",fontSize:".78rem",color:C.gris,fontFamily:"inherit",cursor:"pointer"}}>
              Annuler
            </button>
          )}
        </div>
      )}
    </div>
  );
}

function InfosImportantesPanel({uid, nomAffiche, isMelissa, onModifierAnnonce, onClose=()=>{}}){
  const[flux,setFlux]=useState(null);
  const[loading,setLoading]=useState(true);
  const[sondages,setSondages]=useState(null);
  const[votesSondages,setVotesSondages]=useState({});
  const[showSondageAdmin,setShowSondageAdmin]=useState(false);
  const[vuesParAnnonce,setVuesParAnnonce]=useState({});
  const[objectif,setObjectif]=useState(null);
  const[participantsObjectif,setParticipantsObjectif]=useState([]);
  const[showObjectifAdmin,setShowObjectifAdmin]=useState(false);
  const[programmees,setProgrammees]=useState([]);
  const[annonceAModifier,setAnnonceAModifier]=useState(null);
  const[annonceASupprimer,setAnnonceASupprimer]=useState(null);
  const[suppressionEnCours,setSuppressionEnCours]=useState(false);

  const chargerProgrammees=async()=>{
    if(!isMelissa)return;
    try{
      const snap=await getDocs(collection(db,"annonces_programmees"));
      const liste=snap.docs.map(d=>d.data()).sort((a,b)=>(a.publierLe||0)-(b.publierLe||0));
      setProgrammees(liste);
    }catch{}
  };

  const annulerProgrammee=async(id)=>{
    try{
      await deleteDoc(doc(db,"annonces_programmees",String(id)));
      setProgrammees(p=>p.filter(a=>String(a.id)!==String(id)));
    }catch{}
  };

  const chargerSondagesEtVotes=async()=>{
    try{
      const[s,v]=await Promise.all([chargerSondages(),chargerVotesSondages()]);
      setSondages(s.slice(0,10));
      setVotesSondages(v);
    }catch{setSondages([]);}
  };

  const chargerObjectif=async()=>{
    try{
      const[o,p]=await Promise.all([chargerObjectifCommun(),chargerParticipantsObjectif()]);
      setObjectif(o);
      setParticipantsObjectif(p);
    }catch{}
  };

  const chargerFlux=async()=>{
    try{
      const snap=await getDocs(collection(db,"annonces_historique"));
      let liste=snap.docs.map(d=>d.data()).sort((a,b)=>(b.creeLe||0)-(a.creeLe||0));
      if(liste.length===0){
        // Compatibilite : si aucune annonce archivee, on retombe sur la derniere annonce seule
        try{
          const snap2=await getDoc(doc(db,"equipe","derniere-annonce"));
          if(snap2.exists()&&snap2.data().id)liste=[snap2.data()];
        }catch{}
      }
      setFlux(liste.slice(0,30));
      if(isMelissa){
        try{
          const snapVues=await getDocs(collection(db,"annonces_vues"));
          const map={};
          snapVues.forEach(d=>{map[d.id]=(d.data().vus||[]).length;});
          setVuesParAnnonce(map);
        }catch{}
      }
    }catch{setFlux([]);}
  };

  useEffect(()=>{
    (async()=>{
      await chargerFlux();
      setLoading(false);
      chargerSondagesEtVotes();
      chargerObjectif();
      chargerProgrammees();
    })();
  },[]);

  const confirmerSuppressionAnnonce=async()=>{
    if(!annonceASupprimer)return;
    setSuppressionEnCours(true);
    try{
      await supprimerAnnonce(annonceASupprimer.id);
      await chargerFlux();
    }catch{}
    setSuppressionEnCours(false);
    setAnnonceASupprimer(null);
  };

  const onVoted=(sondageId,nouvelleListe)=>{
    setVotesSondages(p=>({...p,[sondageId]:nouvelleListe}));
  };

  return(
    <>
    <div style={{position:"fixed",bottom:"8rem",left:"1.2rem",width:300,maxWidth:"calc(100vw - 2.4rem)",background:C.blanc,borderRadius:16,boxShadow:"0 8px 32px rgba(61,31,14,.25)",border:`1px solid ${C.pale}`,zIndex:199,overflow:"hidden",maxHeight:"70vh",display:"flex",flexDirection:"column"}}>
      <div style={{background:C.brun,padding:".85rem 1rem",display:"flex",alignItems:"center",gap:".6rem"}}>
        <span style={{fontSize:"1.3rem"}}>📌</span>
        <div style={{fontSize:".72rem",fontWeight:700,letterSpacing:".1em",color:C.or,textTransform:"uppercase",flex:1}}>Infos importantes</div>
        <button onClick={onClose} style={{background:"none",border:"none",color:C.or,fontSize:"1.1rem",cursor:"pointer",padding:0,lineHeight:1}}>✕</button>
      </div>
      <div style={{padding:"1rem",overflowY:"auto"}}>
        {isMelissa&&(
          <button onClick={onModifierAnnonce}
            style={{width:"100%",background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem",fontSize:".74rem",fontWeight:600,color:C.brun,fontFamily:"inherit",cursor:"pointer",marginBottom:".8rem"}}>
            ✏️ Nouvelle annonce
          </button>
        )}
        <div style={{fontSize:".62rem",fontWeight:700,color:C.gris,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".5rem"}}>Objectif commun</div>
        {isMelissa&&(
          <div style={{display:"flex",gap:".4rem",marginBottom:".6rem"}}>
            <button onClick={()=>setShowObjectifAdmin(true)}
              style={{flex:1,background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem",fontSize:".74rem",fontWeight:600,color:C.brun,fontFamily:"inherit",cursor:"pointer"}}>
              🎯 {objectif?"Modifier l'objectif":"Lancer un objectif"}
            </button>
            {objectif&&(
              <button onClick={async()=>{
                  if(!window.confirm(`Supprimer definitivement l'objectif "${objectif.titre}" et la progression de toute l'equipe ?\n\nCette action est irreversible.`))return;
                  await supprimerObjectifCommun();
                  setObjectif(null);
                  setParticipantsObjectif([]);
                }}
                style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .7rem",fontSize:".78rem",color:"#B04040",fontFamily:"inherit",cursor:"pointer"}}>
                🗑️
              </button>
            )}
          </div>
        )}
        {objectif?(
          <ObjectifCommunCard objectif={objectif} participants={participantsObjectif} uid={uid} nomAffiche={nomAffiche} isMelissa={isMelissa}
            onPasAjoute={(nouvelleListe)=>setParticipantsObjectif(nouvelleListe)}/>
        ):(
          <div style={{fontSize:".78rem",color:C.gris,fontStyle:"italic",padding:".5rem 0",marginBottom:".6rem"}}>Aucun objectif pour le moment.</div>
        )}
        <div style={{fontSize:".62rem",fontWeight:700,color:C.gris,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".5rem"}}>Sondages</div>
        {isMelissa&&(
          <button onClick={()=>setShowSondageAdmin(true)}
            style={{width:"100%",background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem",fontSize:".74rem",fontWeight:600,color:C.brun,fontFamily:"inherit",cursor:"pointer",marginBottom:".6rem"}}>
            🗳️ Créer un sondage
          </button>
        )}
        {sondages===null?(
          <div style={{fontSize:".78rem",color:C.gris,padding:".5rem 0"}}>Chargement...</div>
        ):sondages.length>0?(
          <div style={{display:"flex",flexDirection:"column",gap:".6rem",marginBottom:"1.1rem"}}>
            {sondages.map(s=>(
              <SondageCard key={s.id} sondage={s} votes={votesSondages[s.id]||[]} uid={uid} isMelissa={isMelissa} onVoted={onVoted}
                onSupprime={(id)=>setSondages(p=>p.filter(x=>x.id!==id))}/>
            ))}
          </div>
        ):(
          <div style={{fontSize:".78rem",color:C.gris,fontStyle:"italic",padding:".5rem 0",marginBottom:".6rem"}}>Aucun sondage pour le moment.</div>
        )}
        {isMelissa&&programmees.length>0&&(
          <div style={{marginBottom:".9rem"}}>
            <div style={{fontSize:".62rem",fontWeight:700,color:C.gris,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".4rem"}}>📅 Programmées</div>
            <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
              {programmees.map(a=>(
                <div key={a.id} style={{background:"#FFF8E8",border:"1px solid #E8D5A0",borderRadius:10,padding:".55rem .7rem",display:"flex",alignItems:"center",gap:".5rem"}}>
                  <span style={{fontSize:".9rem"}}>{a.icone||"📢"}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:".74rem",fontWeight:700,color:C.brun,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.titre}</div>
                    <div style={{fontSize:".62rem",color:C.gris}}>{a.publierLe?new Date(a.publierLe).toLocaleDateString("fr-FR",{day:"numeric",month:"long",hour:"2-digit",minute:"2-digit"}):""}</div>
                  </div>
                  <button onClick={()=>annulerProgrammee(a.id)}
                    style={{background:"none",border:"none",color:C.gris,fontSize:".9rem",cursor:"pointer",padding:".2rem"}}>✕</button>
                </div>
              ))}
            </div>
          </div>
        )}
        <div style={{fontSize:".62rem",fontWeight:700,color:C.gris,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".5rem"}}>Annonces de l'équipe</div>
        {loading?(
          <div style={{fontSize:".78rem",color:C.gris,padding:".5rem 0"}}>Chargement...</div>
        ):flux&&flux.length>0?(
          <div style={{display:"flex",flexDirection:"column",gap:".6rem"}}>
            {(()=>{
              const labelJour=(ts)=>{
                if(!ts)return "";
                const d=new Date(ts), auj=new Date(), hier=new Date(auj); hier.setDate(hier.getDate()-1);
                const meme=(a,b)=>a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();
                if(meme(d,auj))return "Aujourd'hui";
                if(meme(d,hier))return "Hier";
                return d.toLocaleDateString("fr-FR",{day:"numeric",month:"long"});
              };
              let dernierJour=null;
              return flux.map((a,i)=>{
                const jourActuel=labelJour(a.creeLe);
                const changementJour=jourActuel!==dernierJour;
                dernierJour=jourActuel;
                return(
                  <div key={a.id}>
                    {changementJour&&(
                      <div style={{display:"flex",alignItems:"center",gap:".5rem",margin:i===0?"0 0 .1rem":".3rem 0 .1rem"}}>
                        <div style={{flex:1,height:1,background:C.pale}}/>
                        <span style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".05em",textTransform:"uppercase"}}>{jourActuel}</span>
                        <div style={{flex:1,height:1,background:C.pale}}/>
                      </div>
                    )}
                    <div style={{background:(i===0&&a.urgente)?"#FDF0ED":C.creme,border:`1px solid ${(i===0&&a.urgente)?"#E8B4A5":C.pale}`,borderRadius:12,padding:".8rem .9rem"}}>
                      <div style={{display:"flex",alignItems:"center",gap:".4rem",marginBottom:".3rem"}}>
                        <span style={{fontSize:"1.05rem"}}>{a.icone||"📢"}</span>
                        <span style={{fontSize:".8rem",fontWeight:700,color:C.brun,flex:1}}>{a.titre}</span>
                        {i===0&&<span style={{fontSize:".55rem",fontWeight:700,color:C.or,background:C.brun,borderRadius:6,padding:".1rem .4rem"}}>NOUVEAU</span>}
                        {isMelissa&&(
                          <div style={{display:"flex",gap:".25rem",flexShrink:0}}>
                            <button onClick={()=>setAnnonceAModifier(a)}
                              style={{background:"none",border:"none",fontSize:".78rem",cursor:"pointer",padding:".15rem .3rem",opacity:.6}}>✏️</button>
                            <button onClick={()=>setAnnonceASupprimer(a)}
                              style={{background:"none",border:"none",fontSize:".78rem",cursor:"pointer",padding:".15rem .3rem",opacity:.6}}>🗑️</button>
                          </div>
                        )}
                      </div>
                      {a.video?(
                        <video src={a.video} controls style={{width:"100%",borderRadius:8,margin:".4rem 0",display:"block"}}/>
                      ):a.photo&&(
                        <img src={a.photo} alt="" style={{width:"100%",borderRadius:8,margin:".4rem 0",display:"block"}}/>
                      )}
                      <div style={{fontSize:".76rem",color:C.texte,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{a.message}</div>
                      <div style={{fontSize:".6rem",color:C.gris,marginTop:".35rem",opacity:.7,display:"flex",justifyContent:"space-between"}}>
                        <span>{a.creeLe?new Date(a.creeLe).toLocaleDateString("fr-FR",{day:"numeric",month:"long",hour:"2-digit",minute:"2-digit"}):""}</span>
                        {isMelissa&&<span>👁 {vuesParAnnonce[String(a.id)]||0} vue{(vuesParAnnonce[String(a.id)]||0)!==1?"s":""}</span>}
                      </div>
                    </div>
                  </div>
                );
              });
            })()}
          </div>
        ):(
          <div style={{fontSize:".78rem",color:C.gris,padding:".5rem 0"}}>Aucune annonce pour le moment.</div>
        )}
      </div>
    </div>
    {showSondageAdmin&&<SondageAdminPopup uid={uid} onClose={()=>{setShowSondageAdmin(false);chargerSondagesEtVotes();}}/>}
    {showObjectifAdmin&&<ObjectifCommunAdminPopup uid={uid} onClose={()=>{setShowObjectifAdmin(false);chargerObjectif();}}/>}
    {annonceAModifier&&<AnnonceAdminPopup uid={uid} annonceExistante={annonceAModifier} onClose={()=>{setAnnonceAModifier(null);chargerFlux();}}/>}
    {annonceASupprimer&&(
      <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:"1rem"}}>
        <div style={{background:C.blanc,borderRadius:16,padding:"1.2rem",width:"100%",maxWidth:340,boxShadow:"0 8px 32px rgba(0,0,0,.3)"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:C.brun,marginBottom:".6rem"}}>Supprimer cette annonce ?</div>
          <div style={{fontSize:".78rem",color:C.gris,marginBottom:"1.1rem",lineHeight:1.5}}>"{annonceASupprimer.titre}" sera définitivement retirée de l'historique et de l'affichage. Cette action est irréversible.</div>
          <div style={{display:"flex",gap:".5rem"}}>
            <button onClick={()=>setAnnonceASupprimer(null)}
              style={{flex:1,background:"none",border:`1px solid ${C.pale}`,borderRadius:9,padding:".6rem",fontSize:".78rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>
              Annuler
            </button>
            <button onClick={confirmerSuppressionAnnonce} disabled={suppressionEnCours}
              style={{flex:1,background:"#B8442F",color:"white",border:"none",borderRadius:9,padding:".6rem",fontSize:".78rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
              {suppressionEnCours?"...":"Supprimer"}
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
function NouveauChallengePopup({challenge, onClose}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.75)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9999,padding:"0"}}>
      <div style={{background:C.blanc,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,maxHeight:"90vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.3)"}}>
        <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:"1.5rem 1.2rem 1.2rem",textAlign:"center"}}>
          <div style={{fontSize:"2.2rem",marginBottom:".4rem"}}>🏆</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.blanc,lineHeight:1.3}}>
            Nouveau challenge !
          </div>
          <div style={{fontFamily:"Georgia,serif",fontSize:".95rem",color:C.pale,marginTop:".3rem",fontStyle:"italic"}}>
            {challenge.titre}
          </div>
        </div>
        <div style={{padding:"1.2rem"}}>
          {challenge.description&&(
            <div style={{background:C.creme,borderRadius:12,padding:".9rem 1rem",marginBottom:"1rem",borderLeft:`3px solid ${C.or}`}}>
              <div style={{fontSize:".78rem",color:C.brun,lineHeight:1.7}}>
                {challenge.description}
              </div>
            </div>
          )}
          {challenge.cadeau&&(
            <div style={{fontSize:".78rem",color:C.gris,marginBottom:"1rem",textAlign:"center"}}>
              🎁 A gagner : <strong style={{color:C.brun}}>{challenge.cadeau}</strong>
            </div>
          )}
          <button onClick={onClose}
            style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:12,padding:".9rem",fontSize:".88rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Je decouvre le challenge 🚀
          </button>
        </div>
      </div>
    </div>
  );
}

// ── CLASSEMENT PERMANENT VENTES & RECRUTEMENT ────────────────────────────────
export function CmdPeriodeBlock({cmdPeriode}){
  const info=getPeriodeInfo();
  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",display:"flex",alignItems:"center",gap:".75rem"}}>
      <div style={{width:38,height:38,borderRadius:"50%",background:C.rose+"20",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:"1.2rem"}}>🛍️</div>
      <div style={{flex:1}}>
        <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris,marginBottom:".15rem"}}>{fmtPLabel(info.periodNum)}</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:700,color:C.brun}}>
          {cmdPeriode.count} commande{cmdPeriode.count>1?"s":""}
          {cmdPeriode.montant>0&&<span style={{fontSize:".75rem",fontWeight:400,color:C.gris}}> · {cmdPeriode.montant}€</span>}
        </div>
      </div>
      <div style={{textAlign:"right",fontSize:".62rem",color:C.gris}}>Se remet à 0<br/>en fin de période</div>
    </div>
  );
}

export function ClassementEquipe({uid}){
  const[data,setData]=useState([]);
  const[lastData,setLastData]=useState({});
  const[loading,setLoading]=useState(true);
  const[onglet,setOnglet]=useState("ventes"); // ventes | recrues | progression
  const[lastUpdate,setLastUpdate]=useState(null);

  const charger=async()=>{
    try{
      const annSnap=await getDoc(doc(db,"equipe","annuaire"));
      if(!annSnap.exists()){setLoading(false);return;}
      const membres=annSnap.data().membres||{};

      // Données fraîches du membre courant
      const meSnap=await getDoc(doc(db,"users",uid));
      const meData=meSnap.exists()&&meSnap.data()["db-obj-perso"]?JSON.parse(meSnap.data()["db-obj-perso"]):{};

      // Historique période précédente pour la progression
      const prevPeriode=getPeriodeActuelle()-1;
      const prevKey=`hist_p${prevPeriode}`;

      const valides=Object.entries(membres).map(([mUid,m])=>{
        const isMe=mUid===uid;
        const caPerso=isMe?parseFloat(meData.caPerso)||0:parseFloat(m.caPerso)||0;
        const ca=isMe?parseFloat(meData.ca)||0:parseFloat(m.ca)||0;
        const recrues=isMe?parseInt(meData.recruesReal)||0:parseInt(m.recruesReal)||0;
        const prevCaPerso=parseFloat(m[prevKey+"_caPerso"])||0;
        const prevRecrues=parseInt(m[prevKey+"_recrues"])||0;
        const progVentes=caPerso-prevCaPerso;
        const progRecrues=recrues-prevRecrues;
        const scoreProgression=progVentes+(progRecrues*50);
        return{uid:mUid,prenom:m.prenom||mUid.split("-")[0],caPerso,ca,recrues,progVentes,progRecrues,scoreProgression};
      }).filter(m=>m.ca>0||m.caPerso>0||m.recrues>0||m.uid===uid);
      // Sauvegarder positions précédentes pour les flèches
      const prev=JSON.parse(localStorage.getItem("bd-classement-prev")||"{}");
      setLastData(prev);
      const newPrev={};
      [...valides].sort((a,b)=>b.caPerso-a.caPerso).forEach((m,i)=>{newPrev[m.uid]={v:i,r:[...valides].sort((a,b)=>b.recrues-a.recrues).findIndex(x=>x.uid===m.uid),p:[...valides].sort((a,b)=>b.scoreProgression-a.scoreProgression).findIndex(x=>x.uid===m.uid)};});
      localStorage.setItem("bd-classement-prev",JSON.stringify(newPrev));
      setData(valides);
      setLastUpdate(new Date());
    }catch(e){console.error(e);}
    setLoading(false);
  };

  useEffect(()=>{
    charger();
    const t=setInterval(charger,3*60*1000);
    // Rafraîchir aussi quand la page reprend le focus
    const onFocus=()=>charger();
    window.addEventListener('focus',onFocus);
    return()=>{clearInterval(t);window.removeEventListener('focus',onFocus);};
  },[uid]);

  if(loading)return null;

  const onglets=[
    {id:"ventes",label:"🛍️ Ventes perso",sortKey:"caPerso",unit:"€"},
    {id:"equipe",label:"👥 Équipe",sortKey:"ca",unit:"€"},
    {id:"recrues",label:"🤝 Recrues",sortKey:"recrues",unit:""},
    {id:"progression",label:"📈 Progression",sortKey:"scoreProgression",unit:""},
  ];
  // Filtre 100€ perso seulement pour l'onglet Équipe
  const filtreMin = onglet==="equipe" ? (m)=>m.caPerso>=100||m.uid===uid : ()=>true;
  const currentOnglet=onglets.find(o=>o.id===onglet)||onglets[0];
  const sorted=[...data].filter(filtreMin).sort((a,b)=>b[currentOnglet.sortKey]-a[currentOnglet.sortKey]);
  const medals=["🥇","🥈","🥉"];
  const timeStr=lastUpdate?`${lastUpdate.getHours()}h${String(lastUpdate.getMinutes()).padStart(2,"0")}`:"";

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:".75rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".75rem"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,color:C.brun}}>🏆 Classement équipe</div>
        <button onClick={charger} title="Rafraîchir"
          style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:7,padding:".2rem .4rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>🔄</button>
      </div>

      {/* Onglets */}
      <div style={{display:"flex",gap:".25rem",marginBottom:".75rem",overflowX:"auto"}}>
        {onglets.map(o=>(
          <button key={o.id} onClick={()=>setOnglet(o.id)}
            style={{flexShrink:0,padding:".3rem .55rem",fontSize:".63rem",fontWeight:600,borderRadius:9,border:`1.5px solid ${onglet===o.id?C.rose:C.pale}`,background:onglet===o.id?C.rose:C.blanc,color:onglet===o.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
            {o.label}
          </button>
        ))}
      </div>

      {/* Liste */}
      {sorted.length===0&&<div style={{textAlign:"center",fontSize:".72rem",color:C.gris,padding:".5rem"}}>Aucune donnée pour l'instant</div>}
      {sorted.map((m,i)=>{
        const isMe=m.uid===uid;
        const prevPos=lastData[m.uid];
        const curIdx=i;
        const prevIdx=currentOnglet.id==="ventes"?prevPos?.v:currentOnglet.id==="recrues"?prevPos?.r:prevPos?.p;
        const tendance=prevIdx==null?"→":prevIdx>curIdx?"⬆️":prevIdx<curIdx?"⬇️":"→";

        let valPrimary, valSecondary;
        if(onglet==="ventes"){
          valPrimary=`${m.caPerso}€`;
          valSecondary=m.progVentes!==0?`${m.progVentes>=0?"+":""}${m.progVentes}€ vs P préc.`:null;
        } else if(onglet==="equipe"){
          valPrimary=`${m.ca}€`;
          valSecondary=m.caPerso>=100?`dont ${m.caPerso}€ perso`:null;
        } else if(onglet==="recrues"){
          valPrimary=`${m.recrues} recrue${m.recrues>1?"s":""}`;
          valSecondary=m.progRecrues!==0?`${m.progRecrues>=0?"+":""}${m.progRecrues} vs P préc.`:null;
        } else {
          valPrimary=`${m.progVentes>=0?"+":""}${m.progVentes}€ · ${m.progRecrues>=0?"+":""}${m.progRecrues} rec.`;
          valSecondary=null;
        }

        return(
          <div key={m.uid} style={{display:"flex",alignItems:"center",gap:".5rem",padding:".45rem .5rem",borderRadius:9,background:isMe?C.rose+"08":"transparent",marginBottom:".2rem",border:isMe?`1px solid ${C.rose}30`:"none"}}>
            <div style={{width:26,textAlign:"center",fontSize:i<3?"1rem":".7rem",flexShrink:0}}>
              {i<3?medals[i]:`${i+1}.`}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:".78rem",fontWeight:isMe?700:500,color:isMe?C.rose:C.texte}}>{m.prenom}{isMe?" (moi)":""}</div>
              {valSecondary&&<div style={{fontSize:".6rem",color:C.vert}}>{valSecondary}</div>}
            </div>
            <div style={{fontSize:".7rem",color:C.gris,flexShrink:0}}>{tendance}</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:".85rem",fontWeight:700,color:isMe?C.rose:C.brun,flexShrink:0,textAlign:"right"}}>{valPrimary}</div>
          </div>
        );
      })}

      <div style={{fontSize:".55rem",color:C.pale,textAlign:"right",marginTop:".4rem"}}>
        {timeStr?`Màj ${timeStr} · `:""}Rafraîchi auto toutes les 3min
      </div>
    </div>
  );
}
export function CitationDuJour({uid}){
  const[citations,setCitations]=useState(null);
  const[revealed,setRevealed]=useState(false);
  const[isFirstToday,setIsFirstToday]=useState(false);
  const[flipping,setFlipping]=useState(false);

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","textes"));
        setCitations(snap.exists()?snap.data().citations:null);
      }catch{ setCitations(null); }

      const forceCard = new URLSearchParams(window.location.search).get("testcard")==="1";
      if(forceCard){
        setIsFirstToday(true);
        setRevealed(false);
        return;
      }

      const todayStr = todayLocalStr();
      let lastSeen = await sg(uid,"db-citation-vue");
      // Normaliser le format de date stocké
      if(lastSeen && lastSeen.length > 10) lastSeen = lastSeen.slice(0,10);
      if(lastSeen !== todayStr){
        setIsFirstToday(true);
        setRevealed(false);
        ss(uid,"db-citation-vue",todayStr);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[uid]);

  const citation = getCitationDuJour(citations);

  const reveal=()=>{
    if(revealed)return;
    setFlipping(true);
    setTimeout(()=>{ setRevealed(true); setFlipping(false); }, 350);
  };

  if(!isFirstToday || revealed){
    return(
      <div style={{background:`linear-gradient(135deg, rgba(196,154,138,.12), rgba(168,155,181,.08))`,border:`1px solid ${C.pale}`,borderRadius:14,padding:"1.1rem",textAlign:"center",marginBottom:"1rem",animation:isFirstToday?"card-flip-in .4s ease":"none"}}>
        <style>{`@keyframes card-flip-in{from{opacity:0;transform:scale(.96);}to{opacity:1;transform:scale(1);}}`}</style>
        <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".18em",color:C.rose,marginBottom:".5rem"}}>✦ PENSÉE DU JOUR ✦</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontStyle:"italic",color:C.brun,lineHeight:1.65}}>"{citation}"</div>
      </div>
    );
  }

  // Carte fermée — à découvrir
  return(
    <button onClick={reveal}
      style={{display:"block",width:"100%",background:`linear-gradient(135deg, ${C.brun}, ${C.brun2})`,border:`1px solid ${C.pale}`,borderRadius:14,padding:"1.3rem",textAlign:"center",marginBottom:"1rem",cursor:"pointer",opacity:flipping?0:1,transition:"opacity .35s ease",boxShadow:"0 4px 16px rgba(61,31,14,.2)",fontFamily:"inherit",WebkitTapHighlightColor:"transparent",touchAction:"manipulation",WebkitAppearance:"none",appearance:"none"}}>
      <div style={{fontSize:"1.8rem",marginBottom:".4rem"}}>🎴</div>
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".18em",color:C.or,marginBottom:".3rem"}}>✦ NOUVELLE CARTE DU JOUR ✦</div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontStyle:"italic",color:"white",lineHeight:1.5}}>Touche pour découvrir ta pensée du jour</div>
    </button>
  );
}

// Mood-check quotidien : adapte le ton de la to-do du jour
const MOODS=[
  {id:"top",icon:"⚡",label:"Au top",message:"Génial ! C'est le moment idéal pour viser tes 5 actions à fond aujourd'hui 🚀"},
  {id:"fatigue",icon:"🐢",label:"Un peu fatigué(e)",message:"Pas de souci, on avance à son rythme aujourd'hui. Fais ce que tu peux, l'essentiel c'est de ne pas t'arrêter complètement 🌱"},
  {id:"depasse",icon:"🤯",label:"Dépassé(e)",message:"Pas de panique, aujourd'hui on fait léger : choisis juste UNE action essentielle ci-dessous et fête ta victoire 💛"},
];

// Causes possibles de fatigue/surcharge (perso + travail), avec conseil ciblé
const CAUSES_FATIGUE=[
  {id:"sommeil",icon:"😴",label:"Manque de sommeil",
    conseils:[
      "Ce soir, essaie de te coucher 30 min plus tôt — même un petit ajustement peut faire une vraie différence sur ton énergie demain.",
      "Et si tu testais une micro-sieste de 15-20 min cet après-midi ? Pas besoin de dormir profondément, juste fermer les yeux peut relancer ton énergie.",
      "Le manque de sommeil affecte direct la motivation et la concentration — sois indulgente avec toi-même aujourd'hui, fais ce que tu peux, pas plus.",
      "Essaie de couper les écrans 30 min avant de dormir ce soir — ça aide vraiment à mieux récupérer pour demain.",
      "Une tisane, une lumière tamisée, un peu de calme avant le coucher... Petits rituels, grands effets sur le sommeil 🌙",
    ],
    conseilRepetition:"Ça fait plusieurs jours que le sommeil te pèse... Si ça continue, ce serait peut-être bien d'en parler à quelqu'un (médecin, proche) — ton corps t'envoie peut-être un message à écouter 💛",
  },
  {id:"charge-mentale",icon:"🧠",label:"Charge mentale élevée",
    conseils:[
      "Essaie de tout sortir de ta tête sur une liste (perso + travail) — ça libère de la place mentale, même sans tout faire aujourd'hui.",
      "Choisis UNE seule priorité pour aujourd'hui et laisse le reste de côté sans culpabiliser. Une chose à la fois.",
      "Et si tu déléguais ou reportais une tâche qui peut attendre ? Ce n'est pas un échec, c'est de la gestion intelligente.",
      "5 minutes pour respirer, sans rien faire d'autre — ça peut sembler inutile mais ça aide vraiment à retrouver de la clarté.",
      "Quand tout s'accumule, écrire ce qui tourne en boucle (même en vrac, sans ordre) aide souvent à redescendre la pression.",
    ],
    conseilRepetition:"La charge mentale revient souvent ces derniers jours... Est-ce qu'il y a une chose précise qui pèse plus que les autres ? Parfois identifier LA chose aide à mieux la gérer 🧩",
  },
  {id:"famille",icon:"👨‍👩‍👧",label:"Famille / enfants",
    conseils:[
      "C'est normal que la famille passe en priorité parfois. Ton activité Mihi peut attendre quelques heures — l'important c'est de ne pas culpabiliser.",
      "Même 10 minutes entre deux tâches familiales peuvent suffire pour répondre à un message client. Petits créneaux, ça compte aussi !",
      "Les périodes familiales chargées sont temporaires — ton activité reprendra son rythme. Profite de ces moments, ils ne reviennent pas.",
      "Et si tu impliquais un peu ta famille dans ton activité ? Parfois ça crée des moments complices en plus.",
      "Pas de pression aujourd'hui — la régularité se mesure sur la durée, pas sur une seule journée.",
    ],
    conseilRepetition:"La famille prend beaucoup de place ces derniers temps, et c'est complètement normal. Pense à te accorder aussi un petit moment pour toi, même court — tu en as besoin aussi 💛",
  },
  {id:"sante",icon:"🤒",label:"Pas en forme / santé",
    conseils:[
      "Prends soin de toi en premier. Si tu peux, hydrate-toi, repose-toi un peu — ton business sera toujours là demain.",
      "Écoute ton corps aujourd'hui. Si tu as besoin de ralentir complètement, fais-le sans culpabiliser — la santé passe avant tout.",
      "Pas en forme ne veut pas dire pas productive : même une petite action de 5 minutes compte, le reste peut attendre.",
      "Un peu d'air frais, même 5 minutes à la fenêtre ou sur le pas de la porte, peut parfois aider à se sentir un peu mieux.",
      "Si ça persiste, n'hésite pas à consulter — ce n'est jamais une perte de temps de prendre soin de sa santé.",
    ],
    conseilRepetition:"Ça fait plusieurs jours que tu ne te sens pas bien... Si ça continue, pense à consulter un professionnel de santé — ta santé est plus importante que n'importe quel objectif 💛",
  },
  {id:"motivation",icon:"💭",label:"Manque de motivation",
    conseils:[
      "C'est ok d'avoir des baisses de motivation, ça arrive à tout le monde. Relis un de tes objectifs ou un message d'une cliente satisfaite, ça peut redonner un petit coup de boost 💪",
      "Et si tu commençais par la tâche la plus facile de ta liste ? Parfois un petit succès rapide relance toute la dynamique.",
      "La motivation suit souvent l'action, pas l'inverse. Fais un petit geste, même sans envie, et observe si ça change quelque chose.",
      "Repense à ton 'pourquoi' — pourquoi as-tu commencé cette activité ? Reconnecter avec ça peut redonner du sens.",
      "Regarde le chemin déjà parcouru plutôt que ce qui reste à faire — tu as déjà avancé, et ça compte 🌱",
    ],
    conseilRepetition:"Le manque de motivation revient souvent en ce moment... Est-ce que tes objectifs actuels te parlent encore, ou est-ce qu'il serait temps de les ajuster ? Parfois un petit changement de cap redonne de l'élan 🔄",
  },
  {id:"surcharge-travail",icon:"💼",label:"Surcharge travail/emploi du temps",
    conseils:[
      "Aujourd'hui, vise juste 1 action de 10 minutes maximum. Mieux vaut un petit pas régulier qu'un gros effort suivi d'un abandon.",
      "Et si tu bloquais un créneau fixe de 15 min dans ton agenda, juste pour Mihi ? Un rendez-vous avec toi-même, non négociable.",
      "Quand tout s'accumule, trier par urgence/importance aide à voir plus clair. Tout n'a pas besoin d'être fait aujourd'hui.",
      "La surcharge est souvent temporaire. Identifie ce qui peut attendre une semaine sans conséquence, et laisse-le de côté pour l'instant.",
      "Un planning trop chargé mène souvent à rien faire du tout par overwhelm. Réduire la liste, c'est parfois la clé pour avancer.",
    ],
    conseilRepetition:"La surcharge revient souvent ces derniers jours... Est-ce qu'il y a quelque chose dans ton emploi du temps qui pourrait être allégé ou délégué sur la durée ? Un ajustement structurel aiderait peut-être plus qu'un effort ponctuel 📋",
  },
];


// Actions bonus optionnelles si "Au top"
const ACTIONS_BONUS=[
  {id:"b1",icon:"🎥",label:"Filme un contenu en avance",sub:"Prépare 1 Reel ou story pour un jour où tu seras moins motivée"},
  {id:"b2",icon:"📞",label:"Contacte 3 anciens prospects \"froids\"",sub:"Un petit message sympa pour reprendre contact, sans pression"},
  {id:"b3",icon:"🌟",label:"Aide une personne de ton équipe",sub:"Un message d'encouragement ou un conseil à une collègue"},
];

function MoodCheck({uid, onMoodChange, onBonusToggle}){
  const[mood,setMood]=useState(null);
  const[causes,setCauses]=useState([]);
  const[bonusDone,setBonusDone]=useState({});
  const[loaded,setLoaded]=useState(false);
  const[conseilHistory,setConseilHistory]=useState({});
  const todayStr = todayLocalStr();

  useEffect(()=>{
    (async()=>{
      const data = await sg(uid,"db-mood");
      if(data){
        const parsed = JSON.parse(data);
        if(parsed.date===todayStr){
          setMood(parsed.mood);
          setCauses(parsed.causes||[]);
          setBonusDone(parsed.bonusDone||{});
          onMoodChange&&onMoodChange(parsed.mood);
        }
      }
      const hist = await sg(uid,"db-mood-conseil-history");
      if(hist){
        try{ setConseilHistory(JSON.parse(hist)); }catch{}
      }
      setLoaded(true);
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[uid]);

  const persist=(next)=>{
    ss(uid,"db-mood",JSON.stringify({date:todayStr, mood, causes, bonusDone, ...next}));
  };

  // Choisit un conseil pour une cause donnée, en évitant la répétition immédiate
  // et en proposant un message spécial si la cause revient plusieurs jours d'affilée
  const getConseilPourCause=(c, history)=>{
    const h = history[c.id] || {lastDate:null, lastIndex:-1, streak:0};
    // Streak de jours consécutifs (y compris aujourd'hui)
    const streak = h.lastDate===todayStr ? h.streak
      : (h.lastDate && isYesterday(h.lastDate)) ? h.streak+1 : 1;

    if(streak>=3 && c.conseilRepetition){
      return {text:c.conseilRepetition, index:-1, streak};
    }
    // Choix pseudo-aléatoire évitant la répétition immédiate
    let index = Math.floor(Math.random()*c.conseils.length);
    if(c.conseils.length>1 && index===h.lastIndex){
      index = (index+1)%c.conseils.length;
    }
    // Si déjà choisi aujourd'hui, garder le même (cohérence si re-render)
    if(h.lastDate===todayStr && h.lastIndex>=0 && h.lastIndex<c.conseils.length){
      index = h.lastIndex;
    }
    return {text:c.conseils[index], index, streak};
  };

  const isYesterday=(dateStr)=>{
    const d=new Date(dateStr);
    const yest=new Date();
    yest.setDate(yest.getDate()-1);
    return d.toISOString().slice(0,10)===yest.toISOString().slice(0,10);
  };

  const choisir=(moodId)=>{
    setMood(moodId);
    setCauses([]);
    onMoodChange&&onMoodChange(moodId);
    ss(uid,"db-mood",JSON.stringify({date:todayStr, mood:moodId, causes:[], bonusDone:{}}));
  };

  const toggleCause=(causeId)=>{
    const next = causes.includes(causeId) ? causes.filter(c=>c!==causeId) : [...causes, causeId];
    setCauses(next);
    persist({causes:next});

    // Si on vient de cocher (pas décocher), fige le conseil du jour dans l'historique
    if(!causes.includes(causeId)){
      const c = CAUSES_FATIGUE.find(x=>x.id===causeId);
      if(c){
        const {index, streak} = getConseilPourCause(c, conseilHistory);
        const nextHistory = {...conseilHistory, [causeId]:{lastDate:todayStr, lastIndex:index, streak}};
        setConseilHistory(nextHistory);
        ss(uid,"db-mood-conseil-history",JSON.stringify(nextHistory));
      }
    }
  };

  const toggleBonus=(bonusId)=>{
    const next = {...bonusDone, [bonusId]:!bonusDone[bonusId]};
    setBonusDone(next);
    persist({bonusDone:next});
    onBonusToggle&&onBonusToggle(next);
  };

  if(!loaded) return null;
  const selected = MOODS.find(m=>m.id===mood);
  const showCauses = mood==="fatigue"||mood==="depasse";

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.brun,marginBottom:".6rem"}}>💛 Comment tu te sens aujourd'hui ?</div>
      <div style={{display:"flex",gap:".4rem",marginBottom:mood?".6rem":0}}>
        {MOODS.map(m=>(
          <button key={m.id} onClick={()=>choisir(m.id)}
            style={{flex:1,padding:".55rem .3rem",borderRadius:10,border:`1.5px solid ${mood===m.id?C.rose:C.pale}`,background:mood===m.id?C.rose+"15":C.blanc,cursor:"pointer",fontFamily:"inherit",textAlign:"center"}}>
            <div style={{fontSize:"1.3rem"}}>{m.icon}</div>
            <div style={{fontSize:".62rem",color:mood===m.id?C.brun:C.gris,fontWeight:mood===m.id?700:400,marginTop:".15rem"}}>{m.label}</div>
          </button>
        ))}
      </div>
      {selected&&(
        <div style={{fontSize:".74rem",color:C.texte,lineHeight:1.6,background:C.creme,borderRadius:8,padding:".6rem .8rem"}}>
          {selected.message}
        </div>
      )}

      {/* Mini-questionnaire causes (fatigue/dépassée) */}
      {showCauses&&(
        <div style={{marginTop:".7rem",paddingTop:".7rem",borderTop:`1px solid ${C.pale}`}}>
          <div style={{fontSize:".68rem",color:C.gris,marginBottom:".5rem"}}>Si tu veux, dis-moi ce qui pèse aujourd'hui (tu peux en cocher plusieurs) :</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:".35rem",marginBottom:causes.length>0?".6rem":0}}>
            {CAUSES_FATIGUE.map(c=>{
              const active = causes.includes(c.id);
              return(
                <button key={c.id} onClick={()=>toggleCause(c.id)}
                  style={{padding:".3rem .6rem",borderRadius:20,fontSize:".68rem",fontWeight:600,border:`1px solid ${active?C.lilas:C.pale}`,background:active?C.lilas+"15":C.blanc,color:active?C.brun:C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                  {c.icon} {c.label}
                </button>
              );
            })}
          </div>
          {causes.map(causeId=>{
            const c = CAUSES_FATIGUE.find(x=>x.id===causeId);
            if(!c) return null;
            const {text, streak} = getConseilPourCause(c, conseilHistory);
            return(
              <div key={causeId} style={{fontSize:".72rem",color:C.texte,lineHeight:1.6,background:streak>=3?"rgba(196,154,138,.12)":"rgba(168,155,181,.1)",borderLeft:`3px solid ${streak>=3?C.rose:C.lilas}`,borderRadius:"0 8px 8px 0",padding:".5rem .7rem",marginBottom:".35rem"}}>
                {streak>=3&&<span style={{fontWeight:700}}>💛 </span>}{text}
              </div>
            );
          })}
        </div>
      )}

      {/* Actions bonus (au top) */}
      {mood==="top"&&(
        <div style={{marginTop:".7rem",paddingTop:".7rem",borderTop:`1px solid ${C.pale}`}}>
          <div style={{fontSize:".68rem",color:C.gris,marginBottom:".5rem"}}>Envie d'aller plus loin ? Quelques actions bonus (optionnelles) :</div>
          {ACTIONS_BONUS.map(b=>{
            const checked = bonusDone[b.id];
            return(
              <div key={b.id} onClick={()=>toggleBonus(b.id)}
                style={{display:"flex",alignItems:"flex-start",gap:".5rem",padding:".4rem 0",cursor:"pointer"}}>
                <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${checked?C.or:C.pale}`,background:checked?C.or:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {checked&&<span style={{fontSize:".55rem",color:"white",fontWeight:700}}>✓</span>}
                </div>
                <div>
                  <div style={{fontSize:".74rem",fontWeight:600,color:checked?C.gris:C.texte,textDecoration:checked?"line-through":"none"}}>{b.icon} {b.label}</div>
                  <div style={{fontSize:".62rem",color:C.gris,marginTop:".1rem"}}>{b.sub}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}


export function JaugeSucces({pctCA, pctRecrues}){
  const score = Math.round((Math.min(100,pctCA||0) + Math.min(100,pctRecrues||0)) / 2);
  let couleur = C.rose, message = "C'est parti ! 💪";
  if(score>=100){couleur=C.vert; message="Objectif du mois atteint, bravo ! 🎉";}
  else if(score>=75){couleur=C.or; message="Tu y es presque ! 🔥";}
  else if(score>=40){couleur=C.lilas; message="Belle progression, continue ! ✨";}

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:".4rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.brun}}>🚀 Jauge de succès du mois</div>
        <div style={{fontSize:"1rem",fontWeight:700,color:couleur}}>{score}%</div>
      </div>
      <div style={{height:14,background:C.pale,borderRadius:10,overflow:"hidden"}}>
        <div style={{height:"100%",background:couleur,width:score+"%",borderRadius:10,transition:"width .5s ease"}}/>
      </div>
      <div style={{fontSize:".68rem",color:C.gris,marginTop:".4rem",textAlign:"center"}}>{message}</div>
    </div>
  );
}

// Galerie de badges
export function BadgesPanel({badges}){
  const unlocked = badges.filter(b=>b.unlocked);
  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:".6rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.brun}}>🏅 Mes Badges</div>
        <div style={{fontSize:".68rem",color:C.gris}}>{unlocked.length} / {badges.length}</div>
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:".5rem"}}>
        {badges.map(b=>(
          <div key={b.id} title={b.desc}
            style={{
              flex:"1 1 30%", minWidth:90, textAlign:"center", padding:".6rem .3rem",
              borderRadius:10, border:`1px solid ${b.unlocked?C.or+"60":C.pale}`,
              background:b.unlocked?C.or+"15":C.creme, opacity:b.unlocked?1:.45,
              transition:"all .2s",
            }}>
            <div style={{fontSize:"1.5rem",marginBottom:".2rem",filter:b.unlocked?"none":"grayscale(1)"}}>{b.icon}</div>
            <div style={{fontSize:".62rem",fontWeight:700,color:C.brun,lineHeight:1.3}}>{b.label}</div>
            <div style={{fontSize:".56rem",color:C.gris,marginTop:".15rem",lineHeight:1.3}}>{b.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── WALL OF FAME & DÉFIS ÉQUIPE (Lot 2b) ──────────────────────────────────────

const REACTION_EMOJIS = ["🔥","❤️","👏","💪"];

// Publie automatiquement une réussite sur le Wall of Fame (global, partagé)
export async function postToWallOfFame(uid, userName, message, icon="🎉"){
  try{
    const ref = doc(db,"equipe","wall-of-fame");
    const snap = await getDoc(ref);
    const existing = snap.exists() && snap.data().posts ? snap.data().posts : [];
    // Éviter les doublons rapprochés (même message, même personne, < 1h)
    const recent = existing.find(p=>p.uid===uid&&p.message===message&&(Date.now()-p.ts)<3600000);
    if(recent) return;
    const post = {id:`wf${Date.now()}`, uid, userName, message, icon, ts:Date.now(), reactions:{}};
    const next = [post, ...existing].slice(0,50);
    await setDoc(ref, {posts: next}, {merge:true});
  }catch{}
}

// Power Hour — Sprint collectif synchrone de 20 minutes, lançable par tout chef d'équipe
export function PowerHourTab({uid, userName, canCreate}){
  const[session,setSession]=useState(null);
  const[loading,setLoading]=useState(true);
  const[message,setMessage]=useState("");
  const[accepted,setAccepted]=useState(false);
  const[declined,setDeclined]=useState(false);
  const[themeInput,setThemeInput]=useState("");
  const DUREE_MIN=20;

  const load=async()=>{
    try{
      const snap=await getDoc(doc(db,"equipe","power-hour"));
      if(snap.exists()&&snap.data().startedAt){
        const d=snap.data();
        const elapsed=Date.now()-d.startedAt;
        if(elapsed < DUREE_MIN*60000+5*60000){ setSession(d); }
        else setSession(null);
      } else setSession(null);
      // Charger si l'utilisateur a accepté ou refusé cette session
      const accSnap=await getDoc(doc(db,"power-hour-accepts",uid));
      if(accSnap.exists()&&accSnap.data().sessionStart===snap.data()?.startedAt){
        setAccepted(accSnap.data().status==="accepted");
        setDeclined(accSnap.data().status==="declined");
      } else { setAccepted(false); setDeclined(false); }
    }catch{}
    setLoading(false);
  };

  useEffect(()=>{ load(); const t=setInterval(load,5000); return()=>clearInterval(t); },[]);

  const lancer=async()=>{
    const nouvelle={startedAt:Date.now(),startedBy:userName,theme:themeInput.trim(),messages:[],accepts:{}};
    try{ await setDoc(doc(db,"equipe","power-hour"),nouvelle); setSession(nouvelle); setThemeInput(""); }catch{}
  };

  const accepter=async()=>{
    if(!session)return;
    const next={...session,accepts:{...(session.accepts||{}),[uid]:{userName,ts:Date.now()}}};
    setSession(next);setAccepted(true);setDeclined(false);
    try{
      await setDoc(doc(db,"equipe","power-hour"),next,{merge:true});
      await setDoc(doc(db,"power-hour-accepts",uid),{sessionStart:session.startedAt,userName,ts:Date.now(),status:"accepted"});
    }catch{}
  };

  const refuser=async()=>{
    if(!session)return;
    setDeclined(true);setAccepted(false);
    try{
      await setDoc(doc(db,"power-hour-accepts",uid),{sessionStart:session.startedAt,userName,ts:Date.now(),status:"declined"});
    }catch{}
  };

  const envoyerMessage=async()=>{
    if(!message.trim()||!session)return;
    const msg={uid,userName,text:message.trim(),ts:Date.now()};
    const next={...session,messages:[...(session.messages||[]),msg].slice(-100)};
    setMessage("");setSession(next);
    try{ await setDoc(doc(db,"equipe","power-hour"),next,{merge:true}); }catch{}
  };

  const arreter=async()=>{
    try{ await setDoc(doc(db,"equipe","power-hour"),{startedAt:0,startedBy:"",messages:[],accepts:{}}); }catch{}
    setSession(null);
  };

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  const elapsed=session?Date.now()-session.startedAt:0;
  const remaining=session?DUREE_MIN*60000-elapsed:0;
  const isActive=session&&remaining>0;
  const minutes=Math.max(0,Math.floor(remaining/60000));
  const seconds=Math.max(0,Math.floor((remaining%60000)/1000));

  // Stats pour chef
  const acceptsList=Object.entries(session?.accepts||{});
  const totalEquipe=Math.max(1,acceptsList.length);

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun,marginBottom:".75rem"}}>⚡ Power Hour</div>

      {!session&&!isActive&&(
        <div style={{background:C.creme,borderRadius:12,padding:"1.25rem",textAlign:"center",marginBottom:"1rem"}}>
          <div style={{fontSize:"2rem",marginBottom:".5rem"}}>⚡</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",color:C.brun,marginBottom:".3rem"}}>Aucune session en cours</div>
          <div style={{fontSize:".72rem",color:C.gris,marginBottom:"1rem"}}>20 minutes de focus intense pour toute l'équipe</div>
                    {canCreate&&(
            <input value={themeInput} onChange={e=>setThemeInput(e.target.value)} placeholder="Theme du jour (optionnel) ex: Prospection"
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .8rem",fontFamily:"inherit",fontSize:".8rem",color:C.texte,marginBottom:".7rem",outline:"none",textAlign:"center"}}/>
          )}
{canCreate&&(
            <button onClick={lancer}
              style={{background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".6rem 1.5rem",fontSize:".82rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
              🚀 Lancer une Power Hour
            </button>
          )}
        </div>
      )}

      {session&&(
        <div>
          {/* Bandeau session */}
          <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:12,padding:".9rem 1rem",marginBottom:"1rem",color:C.blanc}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontSize:".58rem",fontWeight:700,color:C.or,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".15rem"}}>
                  {isActive?"⚡ POWER HOUR EN COURS":"✅ Session terminée"}
                </div>
                <div style={{fontSize:".72rem",color:C.pale}}>Lancée par {session.startedBy}{session.theme?(" - Theme : "+session.theme):""}</div>
              </div>
              {isActive&&(
                <div style={{fontFamily:"Georgia,serif",fontSize:"1.8rem",fontWeight:700,color:C.or}}>
                  {String(minutes).padStart(2,"0")}:{String(seconds).padStart(2,"0")}
                </div>
              )}
            </div>

            {/* Explication + Coche d'acceptation */}
            {isActive&&!accepted&&!declined&&(
              <div style={{marginTop:".75rem",background:"rgba(255,255,255,.08)",borderRadius:10,padding:".65rem .8rem",fontSize:".7rem",color:C.pale,lineHeight:1.6}}>
                💡 Une Power Hour, c'est <strong>20 minutes de focus intense</strong> en même temps que toute l'équipe : prospection, appels, messages... chacune choisit son action, ensemble on avance plus vite ! Tu peux participer ou passer ton tour, aucun souci.
              </div>
            )}
            {isActive&&!declined&&(
              <div onClick={!accepted?accepter:null}
                style={{marginTop:".6rem",background:accepted?"rgba(127,175,138,.25)":"rgba(255,255,255,.1)",borderRadius:10,padding:".6rem .85rem",display:"flex",alignItems:"center",gap:".6rem",cursor:accepted?"default":"pointer",border:`1px solid ${accepted?"rgba(127,175,138,.5)":"rgba(255,255,255,.2)"}`}}>
                <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${accepted?"#7FAF8A":"rgba(255,255,255,.4)"}`,background:accepted?"#7FAF8A":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {accepted&&<span style={{color:"white",fontSize:".7rem",fontWeight:700}}>✓</span>}
                </div>
                <span style={{fontSize:".78rem",fontWeight:600,color:accepted?"#B8E6C4":C.pale}}>
                  {accepted?"✅ Tu participes à cette Power Hour !":"Je participe à cette Power Hour"}
                </span>
              </div>
            )}
            {isActive&&!accepted&&(
              <button onClick={declined?null:refuser} disabled={declined}
                style={{marginTop:".4rem",width:"100%",background:declined?"rgba(255,255,255,.06)":"none",border:`1px solid rgba(255,255,255,.2)`,borderRadius:10,padding:".45rem",fontSize:".7rem",fontWeight:600,color:declined?"rgba(255,255,255,.5)":C.pale,cursor:declined?"default":"pointer",fontFamily:"inherit"}}>
                {declined?"❌ Tu as passé ton tour pour cette Power Hour":"Non merci, pas cette fois"}
              </button>
            )}

            {/* Stats chef */}
            {canCreate&&isActive&&(
              <div style={{marginTop:".5rem",background:"rgba(255,255,255,.08)",borderRadius:9,padding:".5rem .75rem"}}>
                <div style={{fontSize:".6rem",color:C.or,fontWeight:700,marginBottom:".3rem"}}>📊 Participation équipe</div>
                <div style={{display:"flex",alignItems:"center",gap:".75rem"}}>
                  <div style={{flex:1,height:6,background:"rgba(255,255,255,.15)",borderRadius:10,overflow:"hidden"}}>
                    <div style={{height:"100%",background:C.vert,width:Math.min(100,(acceptsList.length/Math.max(1,Object.keys(session.accepts||{}).length+5))*100)+"%",borderRadius:10}}/>
                  </div>
                  <span style={{fontSize:".72rem",fontWeight:700,color:C.pale,flexShrink:0}}>{acceptsList.length} participant{acceptsList.length>1?"s":""}</span>
                </div>
                {acceptsList.length>0&&(
                  <div style={{marginTop:".35rem",display:"flex",flexWrap:"wrap",gap:".25rem"}}>
                    {acceptsList.map(([,v])=>(
                      <span key={v.userName} style={{background:"rgba(255,255,255,.12)",borderRadius:20,padding:".1rem .4rem",fontSize:".6rem",color:C.pale}}>{v.userName}</span>
                    ))}
                  </div>
                )}
              </div>
            )}

            {canCreate&&<button onClick={arreter} style={{marginTop:".6rem",background:"rgba(255,255,255,.15)",border:"none",borderRadius:7,padding:".3rem .8rem",fontSize:".65rem",color:C.pale,cursor:"pointer",fontFamily:"inherit"}}>✕ Arrêter</button>}
          </div>

          {/* Chat */}
          <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem",marginBottom:".5rem"}}>
            <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".5rem"}}>💬 Messages</div>
            <div style={{maxHeight:200,overflowY:"auto",marginBottom:".5rem"}}>
              {(session.messages||[]).length===0&&<div style={{fontSize:".7rem",color:C.gris,textAlign:"center",padding:".5rem"}}>Aucun message</div>}
              {(session.messages||[]).map((m,i)=>(
                <div key={i} style={{marginBottom:".35rem",padding:".35rem .6rem",background:m.uid===uid?C.rose+"12":C.creme,borderRadius:8,border:`1px solid ${m.uid===uid?C.rose+"30":C.pale}`}}>
                  <div style={{fontSize:".6rem",fontWeight:700,color:m.uid===uid?C.rose:C.brun}}>{m.userName}</div>
                  <div style={{fontSize:".75rem",color:C.texte}}>{m.text}</div>
                </div>
              ))}
            </div>
            <div style={{display:"flex",gap:".4rem"}}>
              <input value={message} onChange={e=>setMessage(e.target.value)} placeholder="Ton message..."
                onKeyDown={e=>e.key==="Enter"&&envoyerMessage()} style={{marginBottom:0,border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem .6rem",fontSize:".78rem",fontFamily:"inherit",outline:"none",flex:1}}/>
              <button onClick={envoyerMessage} style={{background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".72rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>→</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function WallOfFameTab({uid, userName}){
  const[posts,setPosts]=useState([]);
  const[loading,setLoading]=useState(true);

  const load=async()=>{
    setLoading(true);
    try{
      const snap = await getDoc(doc(db,"equipe","wall-of-fame"));
      setPosts(snap.exists()&&snap.data().posts ? snap.data().posts : []);
    }catch{}
    setLoading(false);
  };

  useEffect(()=>{ load(); },[]);

  const react=async(postId, emoji)=>{
    const next = posts.map(p=>{
      if(p.id!==postId) return p;
      const reactions = {...(p.reactions||{})};
      const users = reactions[emoji] || [];
      reactions[emoji] = users.includes(uid) ? users.filter(u=>u!==uid) : [...users, uid];
      return {...p, reactions};
    });
    setPosts(next);
    try{ await setDoc(doc(db,"equipe","wall-of-fame"), {posts: next}, {merge:true}); }catch{}
  };

  const timeAgo=(ts)=>{
    const diff = Date.now()-ts;
    const mins = Math.floor(diff/60000);
    if(mins<1) return "à l'instant";
    if(mins<60) return `il y a ${mins} min`;
    const hours = Math.floor(mins/60);
    if(hours<24) return `il y a ${hours}h`;
    return `il y a ${Math.floor(hours/24)}j`;
  };

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Wall of <em style={{fontStyle:"italic",color:C.rose}}>Fame</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Les réussites de toute l'équipe Blazing Dynasty 🎉 — réagis pour encourager !
      </p>

      <button onClick={load} disabled={loading}
        style={{width:"100%",background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem",fontSize:".68rem",color:C.gris,fontFamily:"inherit",cursor:"pointer",marginBottom:"1rem"}}>
        {loading?"Chargement...":"🔄 Actualiser"}
      </button>

      {posts.length===0&&!loading&&(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".76rem"}}>
          Rien pour l'instant... Les prochaines réussites de l'équipe apparaîtront ici automatiquement ! ✨
        </div>
      )}

      {posts.map(p=>(
        <div key={p.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem 1rem",marginBottom:".6rem"}}>
          <div style={{display:"flex",gap:".6rem",alignItems:"flex-start"}}>
            <div style={{fontSize:"1.4rem",flexShrink:0}}>{p.icon||"🎉"}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:".75rem",color:C.texte,lineHeight:1.55}}>
                <strong style={{color:C.brun}}>{p.userName}</strong> {p.message}
              </div>
              <div style={{fontSize:".6rem",color:C.gris,marginTop:".2rem"}}>{timeAgo(p.ts)}</div>
            </div>
          </div>
          <div style={{display:"flex",gap:".35rem",marginTop:".6rem"}}>
            {REACTION_EMOJIS.map(emoji=>{
              const users = (p.reactions&&p.reactions[emoji])||[];
              const active = users.includes(uid);
              return(
                <button key={emoji} onClick={()=>react(p.id,emoji)}
                  style={{display:"flex",alignItems:"center",gap:".25rem",border:`1px solid ${active?C.rose:C.pale}`,background:active?C.rose+"15":"transparent",borderRadius:20,padding:".2rem .55rem",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit",color:active?C.brun:C.gris}}>
                  <span>{emoji}</span>{users.length>0&&<span style={{fontWeight:700}}>{users.length}</span>}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

// Module de Défis éphémères équipe
// ---- BANDEAU CHALLENGE PERMANENT ----
// ---- RAPPEL FIN DE PERIODE ----
function RappelPeriodePopup({uid, onAller}){
  const[info,setInfo]=useState(null);
  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",uid));
        if(!snap.exists())return;
        const brut=snap.data()["db-rappel-periode"];
        if(!brut)return;
        const r=JSON.parse(brut);
        if(r.vu)return;
        if(!r.ca)return;
        const brutCA=snap.data()["db-suivi-ca"];
        const dataCA=brutCA?JSON.parse(brutCA):{};
        const p=dataCA["p"+r.periode]||{};
        if((+p.caPerso||0)>0&&(+p.recrues||0)>0)return;
        setInfo(r);
      }catch(e){}
    })();
  },[uid]);
  const fermer=async()=>{
    setInfo(null);
    try{
      const snap=await getDoc(doc(db,"users",uid));
      const brut=snap.exists()?snap.data()["db-rappel-periode"]:null;
      if(brut){
        const r=JSON.parse(brut);
        await setDoc(doc(db,"users",uid),{"db-rappel-periode":JSON.stringify({...r,vu:true})},{merge:true});
      }
    }catch(e){}
  };
  if(!info)return null;
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:16,padding:"1.4rem",maxWidth:340,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:"2rem",marginBottom:".4rem"}}>{"\u{1F4CA}"}</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:C.brun,marginBottom:".5rem"}}>
          Ta periode P{info.periode} est terminee
        </div>
        <p style={{fontSize:".76rem",color:C.texte,lineHeight:1.65,marginBottom:"1rem"}}>
          Prends 30 secondes pour completer tes <strong>ventes perso</strong> et ton <strong>nombre de recrues</strong>.
          Ce sont ces chiffres qui construisent tes courbes d'evolution d'une periode a l'autre.
        </p>
        <button onClick={()=>{fermer();onAller&&onAller();}}
          style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".45rem"}}>
          Completer maintenant
        </button>
        <button onClick={fermer}
          style={{width:"100%",background:"none",border:"none",color:C.gris,fontSize:".72rem",fontFamily:"inherit",cursor:"pointer"}}>
          Plus tard
        </button>
      </div>
    </div>
  );
}

function BandeauChallenge({uid, onOuvrir}){
  const[liste,setListe]=useState([]);
  const[tick,setTick]=useState(0);

  useEffect(()=>{
    let annule=false;
    const charger=async()=>{
      try{
        const tous=await chargerChallenges();
        const now=Date.now();
        let annuaire={};
        try{
          const s=await getDoc(doc(db,"equipe","annuaire"));
          annuaire=s.exists()?(s.data().membres||{}):{};
        }catch(e){}
        const estMelissa = uid==="melissa"||uid==="melissa-da-silveira";
        const visibles=tous.filter(c=>{
          if(c.deadline&&c.deadline<now)return false;
          if(estMelissa)return true;
          if(c.global)return true;
          if(!c.equipesCibles||c.equipesCibles.length===0)return true;
          if(c.equipesCibles.includes("all"))return true;
          if(c.equipesCibles.includes(uid))return true;
          let courant=annuaire[uid]?.marraine;
          const vus=new Set();
          while(courant&&!vus.has(courant)){
            vus.add(courant);
            if(c.equipesCibles.includes(courant))return true;
            courant=annuaire[courant]?.marraine;
          }
          return false;
        });
        if(annule)return;
        const avecFin=visibles.filter(c=>c.deadline).sort((a,b)=>a.deadline-b.deadline);
        const sansFin=visibles.filter(c=>!c.deadline);
        const ordonnes=[...avecFin,...sansFin];
        setListe(ordonnes.slice(0,3));
      }catch(e){}
    };
    charger();
    const t=setInterval(charger,300000);
    return()=>{annule=true;clearInterval(t);};
  },[uid]);

  useEffect(()=>{
    const t=setInterval(()=>setTick(x=>x+1),60000);
    return()=>clearInterval(t);
  },[]);

  if(liste.length===0)return null;

  return(
    <>
      <style>{`@keyframes bd-pulse-challenge{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.45;transform:scale(1.25)}}`}</style>
      <div style={{position:"sticky",top:0,zIndex:150,display:"flex",flexDirection:"column"}}>
        {liste.map((c,idx)=>{
          let reste="";
          if(c.deadline){
            const r=c.deadline-Date.now();
            if(r<=0)return null;
            const j=Math.floor(r/86400000);
            const h=Math.floor((r%86400000)/3600000);
            const mn=Math.floor((r%3600000)/60000);
            if(c.type==="long"||j>=3) reste="J-"+(j+1);
            else if(j>0) reste=j+"j "+h+"h";
            else if(h>0) reste=h+"h "+mn+"min";
            else reste=mn+"min";
          }
          const urgent = c.deadline && (c.deadline-Date.now())<86400000;
          return(
            <div key={c.id||idx} onClick={onOuvrir}
              style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:".7rem",
                background:urgent?"linear-gradient(100deg,#C62828,#E63946)":"linear-gradient(100deg,#8B5E00,#B8862A)",
                boxShadow:"0 2px 10px rgba(0,0,0,.22)",
                padding:".5rem .85rem",cursor:"pointer",userSelect:"none",
                borderTop:idx>0?"1px solid rgba(255,255,255,.25)":"none"}}>
              <div style={{display:"flex",alignItems:"center",gap:".6rem",minWidth:0,flex:1}}>
                <span style={{width:9,height:9,borderRadius:"50%",background:"#fff",flexShrink:0,
                  animation:"bd-pulse-challenge 2s ease-in-out infinite",boxShadow:"0 0 8px rgba(255,255,255,.9)"}}/>
                <div style={{minWidth:0}}>
                  <div style={{fontSize:".8rem",fontWeight:700,color:"#fff",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.25}}>
                    {"\u{1F3C6}"} {c.titre}
                  </div>
                  <div style={{fontSize:".62rem",color:"rgba(255,255,255,.85)",lineHeight:1.3}}>
                    {urgent?"Derniers moments \u2014 clique pour participer":"Challenge en cours \u2014 clique pour participer"}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:".45rem",flexShrink:0}}>
                {reste&&(
                  <span style={{fontSize:".72rem",fontWeight:700,color:"#fff",whiteSpace:"nowrap",
                    background:"rgba(255,255,255,.22)",border:"1px solid rgba(255,255,255,.35)",
                    borderRadius:20,padding:".18rem .5rem"}}>
                    {reste}
                  </span>
                )}
                <span style={{color:"rgba(255,255,255,.8)",fontSize:".85rem",fontWeight:700}}>{"\u203A"}</span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

function TirageAuSortModal({challenge, grille, parPersonne, resultatExistant, isMelissa, onClose, onTirageTermine}){
  const[phase,setPhase]=useState(resultatExistant?"animation":"pret"); // pret | animation | resultat
  const[nomAffiche,setNomAffiche]=useState("");
  const intervalRef=useRef(null);
  const dejaLance=useRef(false);

  const lancerTirage=(gagnantForce)=>{
    setPhase("animation");
    const poolAffichage=grille.length>0?grille:["🎲","🎉","🎁","✨","🏆"];
    const gagnantNom=gagnantForce||poolAffichage[Math.floor(Math.random()*poolAffichage.length)];
    let vitesse=70,tempsEcoule=0;
    const dureeTotal=6500;
    const tick=()=>{
      setNomAffiche(poolAffichage[Math.floor(Math.random()*poolAffichage.length)]);
      tempsEcoule+=vitesse;
      if(tempsEcoule<dureeTotal*.55)vitesse=Math.min(160,vitesse+4);
      else vitesse=Math.min(380,vitesse+16);
      if(tempsEcoule>=dureeTotal){
        clearTimeout(intervalRef.current);
        setNomAffiche(gagnantNom);
        setPhase("resultat");
        onTirageTermine&&onTirageTermine(gagnantNom,grille.length);
        return;
      }
      intervalRef.current=setTimeout(tick,vitesse);
    };
    tick();
  };

  useEffect(()=>{
    if(resultatExistant&&!dejaLance.current){
      dejaLance.current=true;
      lancerTirage(resultatExistant.gagnant);
    }
    return()=>clearTimeout(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.92)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:99999,padding:"1.2rem"}}>
      <div style={{width:"100%",maxWidth:420,textAlign:"center"}}>
        <div style={{fontSize:".68rem",fontWeight:700,letterSpacing:".15em",textTransform:"uppercase",color:C.or,marginBottom:".6rem"}}>🎟️ Tirage au sort</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.15rem",fontWeight:300,color:"white",marginBottom:"1.5rem"}}>{challenge.titre}</div>

        <div style={{background:phase==="resultat"?"linear-gradient(135deg,#E8B84B,#C4922A)":"rgba(255,255,255,.08)",border:`2px solid ${phase==="resultat"?"#FFD98A":C.or}`,borderRadius:20,padding:"2rem 1.2rem",marginBottom:"1.5rem",minHeight:110,display:"flex",alignItems:"center",justifyContent:"center",boxShadow:phase==="resultat"?"0 0 40px rgba(232,184,75,.5)":"none",animation:phase==="animation"?"neonPulseInfos .3s ease-in-out infinite":"none"}}>
          {phase==="pret"?(
            <div style={{color:"rgba(255,255,255,.6)",fontSize:".85rem"}}>{grille.length} ticket{grille.length!==1?"s":""} en jeu, prêt à tirer !</div>
          ):(
            <div style={{fontFamily:"Georgia,serif",fontSize:phase==="resultat"?"1.7rem":"1.4rem",fontWeight:700,color:phase==="resultat"?"#3D1F0E":"white"}}>
              {phase==="resultat"&&"🎉 "}{nomAffiche}{phase==="resultat"&&" 🎉"}
            </div>
          )}
        </div>

        {phase==="resultat"&&(
          <div style={{color:"rgba(255,255,255,.75)",fontSize:".78rem",marginBottom:"1.3rem"}}>
            sur {resultatExistant?.totalTickets??grille.length} tickets en jeu
          </div>
        )}

        {isMelissa&&phase==="pret"&&(
          <button onClick={()=>lancerTirage()} disabled={grille.length===0}
            style={{width:"100%",background:grille.length?C.or:C.pale,color:"#3D1F0E",border:"none",borderRadius:12,padding:".8rem",fontSize:".88rem",fontWeight:700,fontFamily:"inherit",cursor:grille.length?"pointer":"default",marginBottom:".6rem"}}>
            🎲 Lancer le tirage au sort
          </button>
        )}
        {phase==="animation"&&(
          <div style={{color:"rgba(255,255,255,.6)",fontSize:".78rem",marginBottom:".6rem"}}>Tirage en cours...</div>
        )}

        <button onClick={onClose}
          style={{background:"none",border:"1px solid rgba(255,255,255,.3)",borderRadius:10,padding:".55rem 1.2rem",fontSize:".76rem",color:"rgba(255,255,255,.8)",fontFamily:"inherit",cursor:"pointer"}}>
          Fermer
        </button>
      </div>
    </div>
  );
}

function ChallengeCountdown({deadline}){
  const[r,setR]=useState(deadline-Date.now());
  useEffect(()=>{const t=setInterval(()=>setR(deadline-Date.now()),30000);return()=>clearInterval(t);},[deadline]);
  if(r<=0)return <span style={{color:"#B04040",fontWeight:700,fontSize:".72rem"}}>⏰ Terminé</span>;
  const d2=Math.floor(r/86400000),h=Math.floor((r%86400000)/3600000),m=Math.floor((r%3600000)/60000);
  const urgent=r<24*3600000;
  return <span style={{fontWeight:700,color:urgent?"#B8442F":C.or,fontSize:".72rem",animation:urgent?"neonPulseInfos 1.4s ease-in-out infinite":"none",padding:urgent?"1px 6px":0,borderRadius:urgent?8:0,background:urgent?"rgba(255,255,255,.15)":"transparent"}}>{urgent?"⚠️ ":""}{d2>0?`${d2}j `:""}{h}h {m}min{urgent?" — se termine aujourd'hui !":""}</span>;
}

export function DefisTab({uid, userName, canCreate, isChef, depuisEspaceChef=false}){
  const[challenges,setChallenges]=useState([]);
  const[loading,setLoading]=useState(true);
  const[showCreate,setShowCreate]=useState(false);
  const[form,setForm]=useState({titre:"",description:"",type:"flash",dureeHeures:"48",dateFinExacte:"",objectif:"",unite:"ventes",cadeau:"",cadeauImage:"",equipesCibles:[],global:true,actionsListe:[""]});
  const[equipes,setEquipes]=useState([]);
  const[declarations,setDeclarations]=useState({});
  const[declareInput,setDeclareInput]=useState({});
  const[annuaireData,setAnnuaireData]=useState({});
  const[ticketsManuels,setTicketsManuels]=useState({});
  const[showTirage,setShowTirage]=useState(null); // challengeId ou null
  const[showGestionTickets,setShowGestionTickets]=useState(null); // challengeId ou null
  const[nvNomTicket,setNvNomTicket]=useState("");
  const[nvNbTicket,setNvNbTicket]=useState(1);

  const isMelissa = uid==="melissa"||uid==="melissa-da-silveira";

  useEffect(()=>{
    (async()=>{
      let annuaire={};
      let chefsUids=[];
      try{
        // Charger l'annuaire et la liste des chefs en premier
        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        if(annSnap.exists()){
          annuaire=annSnap.data().membres||{};
          setAnnuaireData(annuaire);
          // Un "chef" = quelqu'un qui a au moins une filleule OU marqué isChef
          const marraines=new Set(Object.values(annuaire).map(m=>m.marraine).filter(Boolean));
          const chefsEntries=Object.entries(annuaire).filter(([k,v])=>v.isChef||marraines.has(k));
          // Ajouter Melissa (uid racine) si pas dans l'annuaire
          const melissaEntry={uid:"melissa-da-silveira",nom:"Melissa"};
          const chefsAvecMelissa=[...chefsEntries.map(([k,v])=>({uid:k,nom:v.prenom||k}))];
          if(!chefsAvecMelissa.find(e=>e.uid==="melissa-da-silveira")) chefsAvecMelissa.unshift(melissaEntry);
          chefsUids=chefsAvecMelissa.map(e=>e.uid);
          setEquipes(chefsAvecMelissa.sort((a,b)=>a.nom.localeCompare(b.nom)));
        }
      }catch{}
      try{
        // Charger les challenges
        const data=await chargerChallenges();
        // Filtrer selon l'équipe de l'utilisateur — en remontant sa lignée jusqu'aux chefs
        const now=Date.now();
        const mesChefs=getLigneeChefs(annuaire,uid,chefsUids);
        const actifs=data.filter(c=>{
          if(c.deadline&&c.deadline<now){
            const histoMs=7*24*3600000;
            if(c.deadline<now-histoMs)return false;
          }
          if(isMelissa)return true;
          if(c.global)return true;
          if(!c.equipesCibles||c.equipesCibles.length===0)return true;
          if(c.equipesCibles.includes("all"))return true;
          // Visible si l'utilisateur EST un des chefs ciblés, OU si un de ses chefs (lignée) est ciblé
          return c.equipesCibles.includes(uid)||mesChefs.some(chefUid=>c.equipesCibles.includes(chefUid));
        });
        setChallenges(actifs.sort((a,b)=>b.ts-a.ts));
        // Charger les déclarations par challenge
        setDeclarations(await chargerDeclarations());
        setTicketsManuels(await chargerTousTicketsManuels());
      }catch{}
      setLoading(false);
    })();
  },[uid]);

  const rafraichirListe=(items)=>{
    const histoMs=7*24*3600000; // Garder les challenges termines visibles (historique) pendant 7 jours
    setChallenges(items.filter(c=>{
      if(c.deadline&&c.deadline<Date.now()){
        if(c.deadline<Date.now()-histoMs)return false;
      }
      if(isMelissa)return true;
      if(c.global)return true;
      if(!c.equipesCibles||c.equipesCibles.length===0)return true;
      return c.equipesCibles.includes(uid);
    }));
  };

  const creer=async()=>{
    if(!form.titre.trim())return;
    const id=`c${Date.now()}`;
    const nouveau={
      id,titre:form.titre.trim(),description:form.description.trim(),
      type:form.type,
      deadline:form.dateFinExacte?new Date(form.dateFinExacte+"T23:59:59").getTime():(form.type==="flash"?Date.now()+(+form.dureeHeures||48)*3600000:form.type==="long"?Date.now()+21*24*3600000:null),
      objectif:form.type==="action"?0:(+form.objectif||0),unite:form.type==="action"?"actions":form.unite,
      cadeau:form.cadeau.trim(),cadeauImage:form.cadeauImage.trim(),
      actions:form.type==="action"?form.actionsListe.filter(a=>a.trim()).map((label,i)=>({id:"a"+i,label:label.trim()})):[],
      global:form.global,equipesCibles:form.global?[]:form.equipesCibles,
      createdBy:userName,createdByUid:uid,ts:Date.now(),
    };
    await enregistrerChallenge(nouveau);
    const existing=await chargerChallenges();
    rafraichirListe(existing.sort((a,b)=>b.ts-a.ts));
    try{
      const fmtNom=(id)=>id.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");
      const getDescendants=(rootUid)=>{
        const result=new Set();
        const queue=[rootUid];
        while(queue.length){
          const current=queue.pop();
          Object.entries(annuaireData).forEach(([k,m])=>{
            if(m.marraine===current&&!result.has(k)){ result.add(k); queue.push(k); }
          });
        }
        return [...result];
      };
      let destinataires=[];
      if(nouveau.global){
        destinataires=[...new Set([...Object.keys(annuaireData),...getDescendants(uid)])];
      }else{
        const dests=new Set();
        (nouveau.equipesCibles||[]).forEach(chefUid=>{
          dests.add(chefUid);
          getDescendants(chefUid).forEach(u=>dests.add(u));
        });
        destinataires=[...dests];
      }
      destinataires=destinataires.filter(d=>d&&d!==uid);
      const msg={
        id:`msg${Date.now()}`,
        de:uid, deNom:userName,
        texte:`🏆 Nouveau challenge lance : "${nouveau.titre}"${nouveau.description?" — "+nouveau.description:""}. Viens le decouvrir dans Challenges !`,
        ts:Date.now(), lu:false,
      };
      await Promise.all(destinataires.map(async(destUid)=>{
        const ref=doc(db,"messages",destUid);
        const snap=await getDoc(ref);
        const existing=snap.exists()?snap.data().msgs||[]:[];
        await setDoc(ref,{msgs:[msg,...existing].slice(0,100)},{merge:false});
      }));
    }catch(e){console.error("notif challenge msg error",e);}
    setShowCreate(false);
    setForm({titre:"",description:"",type:"flash",dureeHeures:"48",dateFinExacte:"",objectif:"",unite:"ventes",cadeau:"",cadeauImage:"",equipesCibles:[],global:true,actionsListe:[""]});
  };

  const calculerLeaderEquipe=(ch,liste)=>{
    if(!ch||ch.global||!ch.equipesCibles||ch.equipesCibles.length<2)return null;
    const totaux={};
    ch.equipesCibles.forEach(chefUid=>{totaux[chefUid]=0;});
    liste.forEach(d=>{
      const lignee=getLigneeChefs(annuaireData,d.uid,equipes.map(e=>e.uid));
      const sonChef=ch.equipesCibles.find(chefUid=>d.uid===chefUid||lignee.includes(chefUid));
      if(sonChef!==undefined)totaux[sonChef]=(totaux[sonChef]||0)+d.count;
    });
    const tries=Object.entries(totaux).sort((a,b)=>b[1]-a[1]);
    if(tries.length===0||tries[0][1]===0)return null;
    if(tries.length>1&&tries[0][1]===tries[1][1])return null; // egalite, pas de leader net
    return tries[0][0];
  };

  const declarer=async(challengeId,amount,unite)=>{
    const d={uid,userName,count:+amount||1,ts:Date.now()};
    const fraiche=await chargerDeclarationsChallenge(challengeId);
    const liste=[...fraiche,d];
    setDeclarations(prev=>({...prev,[challengeId]:liste}));
    await enregistrerDeclarations(challengeId, liste);
    const ch=challenges.find(x=>x.id===challengeId);
    postToWallOfFame&&postToWallOfFame(uid,userName,`a déclaré ${amount} ${unite||ch?.unite||""} sur le challenge "${ch?.titre||challengeId}" 💪`,"🚀");
    const leaderAvant=calculerLeaderEquipe(ch,fraiche);
    const leaderApres=calculerLeaderEquipe(ch,liste);
    if(leaderApres&&leaderApres!==leaderAvant){
      const nomEquipe=(equipes.find(e=>e.uid===leaderApres)?.nom)||leaderApres;
      postToWallOfFame&&postToWallOfFame(uid,userName,`🔥 L'équipe ${nomEquipe} passe en tête sur le challenge "${ch?.titre||challengeId}" ! Qui va reprendre l'avantage ? 👀`,"🏆");
    }
  };
  const supprimerDeclaration=async(challengeId,ts)=>{
    if(!window.confirm("Supprimer cette declaration ?"))return;
    const fraiche=await chargerDeclarationsChallenge(challengeId);
    const liste=fraiche.filter(d=>!(d.uid===uid&&d.ts===ts));
    setDeclarations(prev=>({...prev,[challengeId]:liste}));
    await enregistrerDeclarations(challengeId, liste);
  };
  const validerAction=async(challengeId,actionId,actionLabel)=>{
    const fraiche=await chargerDeclarationsChallenge(challengeId);
    const dejaFait=fraiche.find(d=>d.uid===uid&&d.actionId===actionId);
    let liste;
    if(dejaFait){
      liste=fraiche.filter(d=>!(d.uid===uid&&d.actionId===actionId));
    }else{
      const d={uid,userName,count:1,actionId,ts:Date.now()};
      liste=[...fraiche,d];
      postToWallOfFame&&postToWallOfFame(uid,userName,`a validé l'action "${actionLabel}" 💪`,"✅");
    }
    setDeclarations(prev=>({...prev,[challengeId]:liste}));
    await enregistrerDeclarations(challengeId, liste);
  };

  const supprimer=async(id)=>{
    const ch=challenges.find(x=>x.id===id);
    const nomCh=(ch&&ch.titre)||'ce challenge';
    if(!window.confirm('Supprimer definitivement : '+nomCh+' ?\n\nCette action est irreversible et concerne toute l equipe.'))return;
    await effacerChallenge(id);
    rafraichirListe(await chargerChallenges());
  };

  const[editDeadlineId,setEditDeadlineId]=useState(null);
  const[editDeadlineValue,setEditDeadlineValue]=useState("");

  const ouvrirEditDeadline=(c)=>{
    setEditDeadlineId(c.id);
    if(c.deadline){
      const d=new Date(c.deadline);
      const pad=n=>String(n).padStart(2,"0");
      setEditDeadlineValue(`${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`);
    }else{
      setEditDeadlineValue("");
    }
  };

  const enregistrerNouvelleDeadline=async()=>{
    const ch=challenges.find(x=>x.id===editDeadlineId);
    if(!ch)return;
    const nouvelleDeadline=editDeadlineValue?new Date(editDeadlineValue+"T23:59:59").getTime():null;
    await enregistrerChallenge({...ch,deadline:nouvelleDeadline});
    setEditDeadlineId(null);
    rafraichirListe(await chargerChallenges());
  };

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  const Countdown=ChallengeCountdown;

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>🏆 Challenges</div>
        {canCreate&&(
          <button onClick={()=>setShowCreate(p=>!p)}
            style={{background:showCreate?C.pale:C.brun,color:showCreate?C.gris:C.blanc,border:"none",borderRadius:9,padding:".4rem .8rem",fontSize:".72rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            {showCreate?"✕ Annuler":"+ Créer"}
          </button>
        )}
      </div>

      {/* FORMULAIRE CRÉATION */}
      {showCreate&&canCreate&&(
        <div style={{background:C.blanc,border:`1px solid ${C.rose}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.rose,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".75rem"}}>✨ Nouveau challenge</div>

          {/* Titre */}
          <input placeholder="Titre du challenge*" value={form.titre} onChange={e=>setForm(p=>({...p,titre:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem .65rem",fontSize:".82rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".5rem"}}/>
          <textarea placeholder="Description (optionnel)" value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} rows={2}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",marginBottom:".5rem"}}/>

          {/* Type */}
          <div style={{display:"flex",gap:".35rem",marginBottom:".5rem"}}>
            {[{v:"flash",l:"⚡ Challenge Flash (24-72h)"},{v:"long",l:"📅 Challenge Long terme (21j)"},{v:"libre",l:"🎯 Challenge Libre"},{v:"action",l:"✅ Challenge Actions"}].map(t=>(
              <button key={t.v} onClick={()=>setForm(p=>({...p,type:t.v}))}
                style={{flex:1,padding:".38rem .3rem",fontSize:".65rem",fontWeight:600,borderRadius:8,border:`1px solid ${form.type===t.v?C.rose:C.pale}`,background:form.type===t.v?C.rose:C.blanc,color:form.type===t.v?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                {t.l}
              </button>
            ))}
          </div>

          {/* Durée si flash */}
          {form.type==="flash"&&(
            <div style={{display:"flex",gap:".4rem",marginBottom:".5rem",alignItems:"center"}}>
              <span style={{fontSize:".7rem",color:C.gris,flexShrink:0}}>Durée :</span>
              {["24","48","72"].map(h=>(
                <button key={h} onClick={()=>setForm(p=>({...p,dureeHeures:h}))}
                  style={{flex:1,padding:".35rem",fontSize:".7rem",fontWeight:600,borderRadius:7,border:`1px solid ${form.dureeHeures===h?C.rose:C.pale}`,background:form.dureeHeures===h?C.rose:C.blanc,color:form.dureeHeures===h?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                  {h}h
                </button>
              ))}
            </div>
          )}

          {/* Date de fin precise (facultatif, remplace la duree/type par defaut) */}
          <div style={{marginBottom:".5rem"}}>
            <label style={{fontSize:".68rem",color:C.gris,display:"block",marginBottom:".25rem"}}>Ou choisir une date de fin précise (optionnel, remplace la durée ci-dessus) :</label>
            <input type="datetime-local" value={form.dateFinExacte||""} onChange={e=>setForm(p=>({...p,dateFinExacte:e.target.value}))}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .55rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
          </div>

          {form.type!=="action"?(
            <div>
              {/* Objectif + unite */}
              <div style={{display:"flex",gap:".4rem",marginBottom:".5rem"}}>
                <input type="number" placeholder="Objectif" value={form.objectif} onChange={e=>setForm(p=>({...p,objectif:e.target.value}))}
                  style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .55rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
                <input placeholder="Unite (ventes, e...)" value={form.unite} onChange={e=>setForm(p=>({...p,unite:e.target.value}))}
                  style={{flex:2,border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .55rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
              </div>
            </div>
          ):(
            <div style={{marginBottom:".5rem"}}>
              <div style={{fontSize:".62rem",color:C.gris,fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",marginBottom:".4rem"}}>Liste des actions a valider</div>
              {form.actionsListe.map((a,i)=>(
                <div key={i} style={{display:"flex",gap:".35rem",marginBottom:".35rem"}}>
                  <input placeholder={"Action "+(i+1)+" (ex: Publier une story)"} value={a} onChange={e=>{const next=[...form.actionsListe];next[i]=e.target.value;setForm(p=>({...p,actionsListe:next}));}}
                    style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".38rem .55rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
                  {form.actionsListe.length>1&&(
                    <button onClick={()=>{const next=form.actionsListe.filter((_,j)=>j!==i);setForm(p=>({...p,actionsListe:next}));}}
                      style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:"0 .5rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>-</button>
                  )}
                </div>
              ))}
              <button onClick={()=>setForm(p=>({...p,actionsListe:[...p.actionsListe,""]}))}
                style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:8,padding:".3rem .6rem",fontSize:".7rem",fontWeight:600,color:C.brun,cursor:"pointer",fontFamily:"inherit"}}>
                + Ajouter une action
              </button>
            </div>
          )}

          {/* Cadeau */}
          <input placeholder="🎁 Récompense (ex: Kit produit Mihi, carte cadeau 50€...)" value={form.cadeau} onChange={e=>setForm(p=>({...p,cadeau:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".35rem"}}/>
          <input placeholder="Image du cadeau (URL optionnel)" value={form.cadeauImage} onChange={e=>setForm(p=>({...p,cadeauImage:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".5rem"}}/>

          {/* Ciblage équipes — 2 choix clairs */}
          <div style={{marginBottom:".75rem"}}>
            <div style={{fontSize:".6rem",color:C.gris,fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",marginBottom:".4rem"}}>Portée du challenge</div>
            <div style={{display:"flex",gap:".4rem",marginBottom:".5rem"}}>
              <button onClick={()=>setForm(p=>({...p,global:true,equipesCibles:[]}))}
                style={{flex:1,padding:".5rem",fontSize:".72rem",fontWeight:600,borderRadius:9,border:`1.5px solid ${form.global?C.rose:C.pale}`,background:form.global?C.rose:C.blanc,color:form.global?"white":C.gris,cursor:"pointer",fontFamily:"inherit",textAlign:"center"}}>
                🌍 Toute l'équipe
              </button>
              <button onClick={()=>setForm(p=>({...p,global:false}))}
                style={{flex:1,padding:".5rem",fontSize:".72rem",fontWeight:600,borderRadius:9,border:`1.5px solid ${!form.global?C.or:C.pale}`,background:!form.global?C.or+"15":C.blanc,color:!form.global?C.brun:C.gris,cursor:"pointer",fontFamily:"inherit",textAlign:"center"}}>
                👑 Inter-équipes
              </button>
            </div>
            {!form.global&&(
              <div style={{background:C.creme,borderRadius:9,padding:".6rem .75rem",border:`1px solid ${C.or}40`}}>
                <div style={{fontSize:".62rem",color:C.brun,fontWeight:600,marginBottom:".35rem"}}>Sélectionne les équipes participantes :</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:".3rem"}}>
                  {equipes.map(e=>{
                    const sel=form.equipesCibles.includes(e.uid);
                    const estMoi=e.uid===uid;
                    return(
                      <button key={e.uid} onClick={()=>setForm(p=>({...p,equipesCibles:sel?p.equipesCibles.filter(x=>x!==e.uid):[...p.equipesCibles,e.uid]}))}
                        style={{padding:".28rem .65rem",fontSize:".68rem",fontWeight:600,borderRadius:8,border:`1.5px solid ${sel?C.brun:C.pale}`,background:sel?C.brun:C.blanc,color:sel?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                        {e.nom}{estMoi?" (moi)":""}
                      </button>
                    );
                  })}
                </div>
                {form.equipesCibles.length>=2&&(
                  <div style={{fontSize:".62rem",color:C.vert,fontWeight:600,marginTop:".4rem"}}>
                    ✓ {form.equipesCibles.length} équipes sélectionnées — les membres de chacune verront ce challenge
                  </div>
                )}
                {form.equipesCibles.length<2&&(
                  <div style={{fontSize:".62rem",color:C.gris,marginTop:".4rem",fontStyle:"italic"}}>
                    Sélectionne au moins 2 équipes pour un challenge inter-équipes
                  </div>
                )}
              </div>
            )}
          </div>

          <button onClick={creer}
            style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:9,padding:".6rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            🚀 Lancer le challenge
          </button>
        </div>
      )}

      {/* LISTE DES CHALLENGES */}
      {challenges.length===0&&!showCreate&&(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".76rem"}}>
          Aucun challenge en cours 🌸<br/>
          {canCreate&&<span style={{color:C.rose,fontSize:".72rem"}}>Crée le premier !</span>}
        </div>
      )}

      {[...challenges].sort((a,b)=>{
        const aFini=a.deadline&&a.deadline<Date.now()?1:0;
        const bFini=b.deadline&&b.deadline<Date.now()?1:0;
        return aFini-bFini;
      }).map(c=>{
        const decls=declarations[c.id]||[];
        const total=decls.reduce((s,d)=>s+d.count,0);
        const pct=c.objectif?Math.min(100,Math.round(total/c.objectif*100)):0;
        const classement=Object.values(decls.reduce((acc,d)=>{
          acc[d.userName]=acc[d.userName]||{userName:d.userName,total:0};
          acc[d.userName].total+=d.count;
          return acc;
        },{})).sort((a,b)=>b.total-a.total);
        const medals=["🥇","🥈","🥉"];
        const monTotal=decls.filter(d=>d.uid===uid).reduce((s,d)=>s+d.count,0);
        const estTermine=!!(c.deadline&&c.deadline<Date.now());
        const estChallengeEquipes=!c.global&&c.equipesCibles&&c.equipesCibles.length>=2;
        let classementEquipes=[];
        if(estChallengeEquipes){
          const totauxParChef={};
          c.equipesCibles.forEach(chefUid=>{totauxParChef[chefUid]=0;});
          decls.forEach(d=>{
            const ligneeDeclarant=getLigneeChefs(annuaireData,d.uid,equipes.map(e=>e.uid));
            const sonChefCible=c.equipesCibles.find(chefUid=>d.uid===chefUid||ligneeDeclarant.includes(chefUid));
            if(sonChefCible!==undefined)totauxParChef[sonChefCible]=(totauxParChef[sonChefCible]||0)+d.count;
          });
          classementEquipes=c.equipesCibles.map(chefUid=>({
            chefUid,
            nom:(equipes.find(e=>e.uid===chefUid)?.nom)||chefUid,
            total:totauxParChef[chefUid]||0,
          })).sort((a,b)=>b.total-a.total);
        }
        const peutGererChallenge=isMelissa||(depuisEspaceChef&&(c.createdByUid?c.createdByUid===uid:c.createdBy===userName));
        const{grille:grilleTickets,parPersonne:ticketsParPersonne}=construireGrilleTickets(decls,ticketsManuels[c.id]||[]);
        const totalTicketsManuels=(ticketsManuels[c.id]||[]).reduce((s,t)=>s+t.tickets,0);

        return(
          <div key={c.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:14,overflow:"hidden",marginBottom:".75rem"}}>
            {/* Header challenge */}
            <div style={{background:`linear-gradient(135deg,${c.type==="flash"?C.rose:c.type==="long"?C.lilas:C.or},${c.type==="flash"?C.brun2:c.type==="long"?C.brun:C.brun})`,padding:".9rem 1rem"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:".55rem",fontWeight:700,color:"rgba(255,255,255,.7)",letterSpacing:".1em",textTransform:"uppercase",marginBottom:".2rem"}}>
                    {estTermine?"📜 Terminé":c.type==="flash"?"⚡ Challenge Flash":c.type==="long"?"📅 Challenge Long terme":"🎯 Challenge"}
                    {!c.global&&(c.equipesCibles?.length>1?` · 👑 Challenge entre ${c.equipesCibles.length} équipes`:" · Équipe ciblée")}
                  </div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:"white"}}>{c.titre}</div>
                  {c.description&&<div style={{fontSize:".7rem",color:"rgba(255,255,255,.75)",marginTop:".2rem",lineHeight:1.5}}>{c.description}</div>}
                </div>
                <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:".2rem",flexShrink:0,marginLeft:".5rem"}}>
                  {c.deadline&&<Countdown deadline={c.deadline}/>}
                  <div style={{display:"flex",gap:".3rem"}}>
                    {depuisEspaceChef&&(c.createdByUid?c.createdByUid===uid:c.createdBy===userName)&&<button onClick={()=>ouvrirEditDeadline(c)}
                      style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:5,padding:".18rem .4rem",color:"rgba(255,255,255,.8)",cursor:"pointer",fontSize:".62rem",fontFamily:"inherit"}}>
                      ✏️
                    </button>}
                    {depuisEspaceChef&&(c.createdByUid?c.createdByUid===uid:c.createdBy===userName)&&<button onClick={()=>supprimer(c.id)}
                      style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:5,padding:".18rem .4rem",color:"rgba(255,255,255,.6)",cursor:"pointer",fontSize:".6rem",fontFamily:"inherit"}}>
                      ✕
                    </button>}
                  </div>
                </div>
              </div>
            </div>
            {editDeadlineId===c.id&&(
              <div style={{padding:".7rem 1rem",background:C.creme,borderTop:`1px solid ${C.pale}`,display:"flex",gap:".4rem",alignItems:"center",flexWrap:"wrap"}}>
                <input type="datetime-local" value={editDeadlineValue} onChange={e=>setEditDeadlineValue(e.target.value)}
                  style={{flex:1,minWidth:170,border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem .5rem",fontSize:".76rem",fontFamily:"inherit",color:C.texte,outline:"none"}}/>
                <button onClick={enregistrerNouvelleDeadline}
                  style={{background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".74rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                  ✓ Enregistrer
                </button>
                <button onClick={()=>{setEditDeadlineValue("");}}
                  style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem .6rem",fontSize:".7rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                  Sans date de fin
                </button>
                <button onClick={()=>setEditDeadlineId(null)}
                  style={{background:"none",border:"none",fontSize:".7rem",color:C.gris,cursor:"pointer",fontFamily:"inherit",padding:".4rem"}}>
                  Annuler
                </button>
              </div>
            )}

            <div style={{padding:".85rem 1rem"}}>
              {/* Barre de progression */}
              {c.objectif>0&&(
                <div style={{marginBottom:".75rem"}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:".62rem",color:C.gris,marginBottom:".25rem"}}>
                    <span>Total équipe : {total} {c.unite}</span>
                    <span style={{fontWeight:700,color:pct>=100?C.vert:C.rose}}>{pct}% · objectif {c.objectif}</span>
                  </div>
                  <div style={{height:8,background:C.pale,borderRadius:10,overflow:"hidden"}}>
                    <div style={{height:"100%",background:pct>=100?C.vert:C.rose,width:pct+"%",borderRadius:10,transition:"width .5s"}}/>
                  </div>
                </div>
              )}

              {/* Encadré cadeau */}
              {c.cadeau&&(
                <div style={{background:`linear-gradient(135deg,${C.or}20,${C.creme})`,border:`1.5px solid ${C.or}40`,borderRadius:12,padding:".75rem",marginBottom:".75rem",display:"flex",alignItems:"center",gap:".75rem"}}>
                  {c.cadeauImage
                    ?<img src={c.cadeauImage} alt="cadeau" style={{width:52,height:52,borderRadius:8,objectFit:"cover",flexShrink:0}}/>
                    :<div style={{width:44,height:44,background:`linear-gradient(135deg,${C.or},#B8962A)`,borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.4rem",flexShrink:0}}>🎁</div>
                  }
                  <div style={{flex:1}}>
                    <div style={{fontSize:".58rem",fontWeight:700,color:C.or,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".15rem"}}>Récompense</div>
                    <div style={{fontSize:".8rem",fontWeight:600,color:C.brun,lineHeight:1.5}}>{c.cadeau}</div>
                  </div>
                </div>
              )}

              {estTermine&&(
                <div style={{background:"#F0EEEA",borderRadius:10,padding:".5rem .85rem",marginBottom:".75rem",fontSize:".7rem",color:C.gris,textAlign:"center",fontStyle:"italic"}}>
                  📜 Challenge terminé — résultats conservés en historique
                </div>
              )}
              {!estTermine&&c.type!=="action"?(<>
              <div style={{background:C.creme,borderRadius:10,padding:".65rem .85rem",marginBottom:".75rem",display:"flex",alignItems:"center",gap:".6rem"}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:".6rem",color:C.gris,marginBottom:".1rem"}}>Ma participation</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:".95rem",fontWeight:700,color:C.brun}}>{monTotal} {c.unite}</div>
                </div>
                <input type="number" min="1" value={declareInput[c.id]||""} onChange={e=>setDeclareInput(p=>({...p,[c.id]:e.target.value}))}
                  placeholder="Qte"
                  style={{width:60,border:`1px solid ${C.pale}`,borderRadius:7,padding:".35rem .4rem",fontSize:".8rem",fontFamily:"inherit",textAlign:"center",color:C.texte,background:C.blanc,outline:"none"}}/>
                <button onClick={()=>{declarer(c.id,declareInput[c.id]||1,c.unite);setDeclareInput(p=>({...p,[c.id]:""}));}}
                  style={{background:C.brun,color:C.blanc,border:"none",borderRadius:7,padding:".35rem .7rem",fontSize:".72rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>
                  + Declarer
                </button>
              </div>
              {decls.filter(d=>d.uid===uid&&!d.actionId).length>0&&(
                <div style={{marginTop:"-.45rem",marginBottom:".75rem",padding:".5rem .85rem",background:"rgba(255,255,255,.5)",border:`1px solid ${C.pale}`,borderRadius:10}}>
                  <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.gris,marginBottom:".3rem"}}>
                    Mes declarations
                  </div>
                  {decls.filter(d=>d.uid===uid&&!d.actionId).sort((a,b)=>b.ts-a.ts).map(d=>(
                    <div key={d.ts} style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:".5rem",padding:".22rem 0",borderTop:`1px solid ${C.creme}`}}>
                      <span style={{fontSize:".7rem",color:C.texte}}>
                        <strong style={{color:C.brun}}>{d.count}</strong> {c.unite}
                      </span>
                      <span style={{display:"flex",alignItems:"center",gap:".45rem"}}>
                        <span style={{fontSize:".6rem",color:C.gris}}>
                          {new Date(d.ts).toLocaleDateString("fr-FR",{day:"2-digit",month:"2-digit"})} a {new Date(d.ts).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}
                        </span>
                        <button onClick={()=>supprimerDeclaration(c.id,d.ts)}
                          style={{background:"none",border:"none",color:"#C0504D",fontSize:".7rem",cursor:"pointer",fontFamily:"inherit",padding:"0 .15rem",lineHeight:1}}>
                          {"\u2715"}
                        </button>
                      </span>
                    </div>
                  ))}
                  <div style={{fontSize:".58rem",color:C.gris,fontStyle:"italic",marginTop:".35rem"}}>
                    Une erreur ? Supprime la ligne et redeclare le bon chiffre.
                  </div>
                </div>
              )}
              </>
            ):!estTermine?(
              <div style={{background:C.creme,borderRadius:10,padding:".65rem .85rem",marginBottom:".75rem"}}>
                <div style={{fontSize:".6rem",color:C.gris,marginBottom:".5rem"}}>Coche les actions realisees</div>
                {(c.actions||[]).map(a=>{
                  const fait=(declarations[c.id]||[]).some(d=>d.uid===uid&&d.actionId===a.id);
                  return(
                    <div key={a.id} onClick={()=>validerAction(c.id,a.id,a.label)}
                      style={{display:"flex",alignItems:"center",gap:".5rem",padding:".4rem 0",cursor:"pointer"}}>
                      <div style={{width:20,height:20,borderRadius:6,border:`2px solid ${fait?C.vert:C.pale}`,background:fait?C.vert:"white",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:".65rem",color:"white"}}>{fait?"✓":""}</div>
                      <div style={{fontSize:".78rem",color:fait?C.gris:C.texte,textDecoration:fait?"line-through":"none"}}>{a.label}</div>
                    </div>
                  );
                })}
              </div>
            ):null}

              {/* Jauges par equipe (challenges entre plusieurs equipes) */}
              {estChallengeEquipes&&classementEquipes.length>0&&(
                <div style={{marginBottom:".9rem"}}>
                  <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris,marginBottom:".5rem"}}>👑 Classement par équipe</div>
                  {(()=>{
                    const maxTotal=c.objectif>0?c.objectif:Math.max(1,...classementEquipes.map(e=>e.total))*1.5;
                    return classementEquipes.map((eq,i)=>(
                      <div key={eq.chefUid} style={{marginBottom:".55rem"}}>
                        <div style={{display:"flex",justifyContent:"space-between",fontSize:".74rem",marginBottom:".2rem"}}>
                          <span style={{fontWeight:700,color:C.brun}}>{i===0&&eq.total>0?"🥇 ":""}Équipe {eq.nom}</span>
                          <span style={{fontWeight:700,color:C.brun}}>{eq.total} {c.unite}</span>
                        </div>
                        <div style={{background:C.pale+"50",borderRadius:8,height:12,overflow:"hidden"}}>
                          <div style={{height:"100%",width:`${Math.min(100,Math.round((eq.total/maxTotal)*100))}%`,background:i===0?"#7FAF8A":C.rose,transition:"width .5s"}}/>
                        </div>
                      </div>
                    ));
                  })()}
                </div>
              )}

              {/* Classement */}
              {classement.length>0&&(
                <div>
                  <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris,marginBottom:".4rem"}}>{estChallengeEquipes?"Détail individuel":"🏆 Classement"}</div>
                  {classement.map((p,i)=>(
                    <div key={p.userName} style={{display:"flex",alignItems:"center",gap:".5rem",padding:".3rem 0",borderBottom:i<classement.length-1?`1px solid ${C.pale}30`:"none"}}>
                      <div style={{width:22,textAlign:"center",fontSize:i<3?"1rem":".7rem",flexShrink:0}}>{i<3?medals[i]:`${i+1}.`}</div>
                      <div style={{flex:1,fontSize:".76rem",fontWeight:p.userName===userName?700:400,color:p.userName===userName?C.rose:C.texte}}>{p.userName}{p.userName===userName?" ✓":""}</div>
                      <div style={{fontFamily:"Georgia,serif",fontSize:".85rem",fontWeight:700,color:C.brun}}>{p.total} {c.unite}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* Tickets & Tirage au sort */}
              <div style={{marginTop:".9rem",paddingTop:".8rem",borderTop:`1px solid ${C.pale}`}}>
                {c.tirage?(
                  <div>
                    <div onClick={()=>setShowTirage(c.id)} style={{background:"linear-gradient(135deg,#E8B84B,#C4922A)",borderRadius:10,padding:".65rem .8rem",cursor:"pointer",textAlign:"center"}}>
                      <div style={{fontSize:".72rem",fontWeight:700,color:"#3D1F0E"}}>🎉 Résultat du tirage : {c.tirage.gagnant} !</div>
                      <div style={{fontSize:".62rem",color:"#5A3829",marginTop:".1rem"}}>Touche pour revoir le tirage</div>
                    </div>
                    {peutGererChallenge&&(
                      <button onClick={async()=>{
                          if(!window.confirm("Relancer un nouveau tirage pour ce challenge ?\n\nLe résultat actuel sera remplacé."))return;
                          await supprimerResultatTirage(c.id,c);
                          rafraichirListe(await chargerChallenges());
                        }}
                        style={{width:"100%",background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem",fontSize:".68rem",color:C.gris,fontFamily:"inherit",cursor:"pointer",marginTop:".4rem"}}>
                        🔄 Relancer le tirage
                      </button>
                    )}
                  </div>
                ):peutGererChallenge?(
                  <div>
                    <div style={{display:"flex",gap:".4rem"}}>
                      <button onClick={()=>setShowGestionTickets(p=>p===c.id?null:c.id)}
                        style={{flex:1,background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem",fontSize:".7rem",color:C.brun,fontFamily:"inherit",cursor:"pointer"}}>
                        🎟️ Tickets manuels {totalTicketsManuels>0?`(${totalTicketsManuels})`:""}
                      </button>
                      <button onClick={()=>setShowTirage(c.id)} disabled={grilleTickets.length===0}
                        style={{flex:1,background:grilleTickets.length?C.brun:C.pale,color:grilleTickets.length?"white":C.gris,border:"none",borderRadius:8,padding:".45rem",fontSize:".7rem",fontWeight:700,fontFamily:"inherit",cursor:grilleTickets.length?"pointer":"default"}}>
                        🎲 Tirage au sort
                      </button>
                    </div>
                    {showGestionTickets===c.id&&(
                      <div style={{marginTop:".6rem",background:C.creme,borderRadius:10,padding:".65rem .75rem"}}>
                        <div style={{fontSize:".64rem",color:C.gris,marginBottom:".5rem"}}>Pour les personnes ayant participé sans l'application.</div>
                        {(ticketsManuels[c.id]||[]).map(t=>(
                          <div key={t.id} style={{display:"flex",alignItems:"center",gap:".4rem",padding:".25rem 0",borderBottom:`1px solid ${C.pale}30`}}>
                            <span style={{flex:1,fontSize:".74rem",color:C.texte}}>{t.nom}</span>
                            <span style={{fontSize:".68rem",color:C.gris,fontWeight:600}}>{t.tickets} ticket{t.tickets!==1?"s":""}</span>
                            <button onClick={async()=>{
                                const nouvelleListe=await supprimerTicketManuel(c.id,t.id);
                                setTicketsManuels(p=>({...p,[c.id]:nouvelleListe}));
                              }}
                              style={{background:"none",border:"none",color:"#B04040",fontSize:".72rem",cursor:"pointer",padding:"0 .2rem"}}>✕</button>
                          </div>
                        ))}
                        <div style={{display:"flex",gap:".35rem",marginTop:".5rem"}}>
                          <input value={nvNomTicket} onChange={e=>setNvNomTicket(e.target.value)} placeholder="Nom"
                            style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:7,padding:".35rem .5rem",fontSize:".72rem",fontFamily:"inherit",outline:"none"}}/>
                          <input type="number" min="1" value={nvNbTicket} onChange={e=>setNvNbTicket(Math.max(1,+e.target.value||1))}
                            style={{width:50,border:`1px solid ${C.pale}`,borderRadius:7,padding:".35rem .3rem",fontSize:".72rem",fontFamily:"inherit",textAlign:"center",outline:"none"}}/>
                          <button onClick={async()=>{
                              if(!nvNomTicket.trim())return;
                              const nouvelleListe=await ajouterTicketManuel(c.id,nvNomTicket.trim(),nvNbTicket,uid);
                              setTicketsManuels(p=>({...p,[c.id]:nouvelleListe}));
                              setNvNomTicket("");setNvNbTicket(1);
                            }}
                            style={{background:C.brun,color:"white",border:"none",borderRadius:7,padding:".35rem .6rem",fontSize:".7rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                            +
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ):null}
              </div>

              {showTirage===c.id&&(
                <TirageAuSortModal
                  challenge={c}
                  grille={grilleTickets}
                  parPersonne={ticketsParPersonne}
                  resultatExistant={c.tirage}
                  isMelissa={peutGererChallenge}
                  onClose={()=>setShowTirage(null)}
                  onTirageTermine={async(gagnantNom,totalTickets)=>{
                    await enregistrerResultatTirage(c.id,c,gagnantNom,totalTickets);
                    rafraichirListe(await chargerChallenges());
                    postToWallOfFame&&postToWallOfFame(uid,userName,`🎉 Tirage au sort du challenge "${c.titre}" : ${gagnantNom} remporte le lot ! Bravo à elle 🎁`,"🎟️");
                  }}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// Mini graphique d'évolution (SVG, sans dépendance externe)
function MiniChart({data, dataKey, objKey, color, unit=""}){
  if(!data || data.length < 2) return (
    <div style={{textAlign:"center",fontSize:".68rem",color:C.gris,padding:".75rem 0"}}>
      Pas encore assez d'historique — reviens après ta prochaine période pour voir ta courbe 📈
    </div>
  );

  const w=300, h=110, pad=8;
  const values = data.map(d=>+d[dataKey]||0);
  const objValues = data.map(d=>+d[objKey]||0);
  const maxV = Math.max(...values, ...objValues, 1);

  const points = values.map((v,i)=>{
    const x = pad + (i/(data.length-1)) * (w-2*pad);
    const y = h-pad - (v/maxV)*(h-2*pad);
    return `${x},${y}`;
  }).join(" ");

  const lastObj = objValues[objValues.length-1];
  const objY = h-pad - (lastObj/maxV)*(h-2*pad);

  return(
    <div>
      <svg viewBox={`0 0 ${w} ${h}`} style={{width:"100%",height:"auto",display:"block"}}>
        {lastObj>0&&(
          <line x1={pad} y1={objY} x2={w-pad} y2={objY} stroke={C.or} strokeWidth="1" strokeDasharray="4 3"/>
        )}
        <polyline points={points} fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round"/>
        {values.map((v,i)=>{
          const x = pad + (i/(data.length-1)) * (w-2*pad);
          const y = h-pad - (v/maxV)*(h-2*pad);
          return <circle key={i} cx={x} cy={y} r="3" fill={color}/>;
        })}
      </svg>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:".58rem",color:C.gris,marginTop:".2rem"}}>
        <span>{new Date(data[0].date).toLocaleDateString("fr-FR",{day:"numeric",month:"short"})}</span>
        {lastObj>0&&<span style={{color:C.or}}>┄ Objectif : {lastObj}{unit}</span>}
        <span>{new Date(data[data.length-1].date).toLocaleDateString("fr-FR",{day:"numeric",month:"short"})}</span>
      </div>
    </div>
  );
}

// Calcule la comparaison vs la période précédente
function comparaisonPeriode(historique, currentVal, key){
  if(!historique || historique.length===0) return null;
  const previous = +historique[historique.length-1][key] || 0;
  const current = +currentVal || 0;
  const diff = current - previous;
  const pct = previous!==0 ? Math.round((diff/previous)*100) : (current>0?100:0);
  return {previous, current, diff, pct};
}


// ── OBJECTIFS PERSONNELS ──────────────────────────────────────────────────────
const PALIERS_PERSO=["2%","4%","6%","8%","10%","12%","14%","17%","SR","Directeur","Structural","Business Director","SR Business Director","Business"];

// Objectif CA suggéré selon le palier visé (pré-remplissage automatique)
const PALIER_CA_OBJ={
  "2%":100, "4%":250, "6%":500, "8%":1000, "10%":1500, "12%":2000, "14%":3000, "17%":5000, "SR":7500,
};

// Paliers de qualification : nombre de directeurs requis + points requis + montant de prime
const PALIERS_QUALIFICATION=[
  {id:"Directeur", nbDirecteurs:1, pts:0, prime:1000},
  {id:"SR", nbDirecteurs:1, pts:7500, ptsOU:true, prime:500}, // 7500 pts OU 1 directeur
  {id:"Structural", nbDirecteurs:2, pts:0, prime:2000},
  {id:"Business Director", nbDirecteurs:3, pts:0, prime:3000},
  {id:"SR Business Director", nbDirecteurs:4, pts:0, prime:4000},
];

// Périodes Mihi — ancre chargée depuis Firebase admin (modifiable)
// Valeur par défaut : 19/12/2024

// ── CALENDRIER OFFICIEL MIHI PAR ANNÉE ──────────────────────────────────────
// Dates exactes extraites des catalogues officiels Mihi
export const CALENDRIER_MIHI = {
  2023: [
    {c:1, debut:"2023-01-07", fin:"2023-01-27"},
    {c:2, debut:"2023-01-28", fin:"2023-02-17"},
    {c:3, debut:"2023-02-18", fin:"2023-03-10"},
    {c:4, debut:"2023-03-11", fin:"2023-03-31"},
    {c:5, debut:"2023-04-01", fin:"2023-04-21"},
    {c:6, debut:"2023-04-22", fin:"2023-05-12"},
    {c:7, debut:"2023-05-13", fin:"2023-06-02"},
    {c:8, debut:"2023-06-03", fin:"2023-06-23"},
    {c:9, debut:"2023-06-24", fin:"2023-07-14"},
    {c:10,debut:"2023-07-15", fin:"2023-08-04"},
    {c:11,debut:"2023-08-05", fin:"2023-08-25"},
    {c:12,debut:"2023-08-26", fin:"2023-09-15"},
    {c:13,debut:"2023-09-16", fin:"2023-10-06"},
    {c:14,debut:"2023-10-07", fin:"2023-10-27"},
    {c:15,debut:"2023-10-28", fin:"2023-11-17"},
    {c:16,debut:"2023-11-18", fin:"2023-12-08"},
    {c:17,debut:"2023-12-09", fin:"2023-12-29"},
  ],
  2024: [
    {c:1, debut:"2024-01-18", fin:"2024-02-07"},
    {c:2, debut:"2024-02-08", fin:"2024-02-28"},
    {c:3, debut:"2024-02-29", fin:"2024-03-20"},
    {c:4, debut:"2024-03-21", fin:"2024-04-10"},
    {c:5, debut:"2024-04-11", fin:"2024-05-01"},
    {c:6, debut:"2024-05-02", fin:"2024-05-22"},
    {c:7, debut:"2024-05-23", fin:"2024-06-12"},
    {c:8, debut:"2024-06-13", fin:"2024-07-03"},
    {c:9, debut:"2024-07-04", fin:"2024-07-24"},
    {c:10,debut:"2024-07-25", fin:"2024-08-14"},
    {c:11,debut:"2024-08-15", fin:"2024-09-04"},
    {c:12,debut:"2024-09-05", fin:"2024-09-25"},
    {c:13,debut:"2024-09-26", fin:"2024-10-16"},
    {c:14,debut:"2024-10-17", fin:"2024-11-06"},
    {c:15,debut:"2024-11-07", fin:"2024-11-27"},
    {c:16,debut:"2024-11-28", fin:"2024-12-18"},
    {c:17,debut:"2024-12-19", fin:"2025-01-08"},
    {c:18,debut:"2023-12-28", fin:"2024-01-17"},
  ],
  2025: [
    {c:1, debut:"2025-01-09", fin:"2025-01-29"},
    {c:2, debut:"2025-01-30", fin:"2025-02-19"},
    {c:3, debut:"2025-02-20", fin:"2025-03-12"},
    {c:4, debut:"2025-03-13", fin:"2025-04-02"},
    {c:5, debut:"2025-04-03", fin:"2025-04-23"},
    {c:6, debut:"2025-04-24", fin:"2025-05-14"},
    {c:7, debut:"2025-05-15", fin:"2025-06-04"},
    {c:8, debut:"2025-06-05", fin:"2025-06-25"},
    {c:9, debut:"2025-06-26", fin:"2025-07-16"},
    {c:10,debut:"2025-07-17", fin:"2025-08-06"},
    {c:11,debut:"2025-08-07", fin:"2025-08-27"},
    {c:12,debut:"2025-08-28", fin:"2025-09-17"},
    {c:13,debut:"2025-09-18", fin:"2025-10-08"},
    {c:14,debut:"2025-10-09", fin:"2025-10-29"},
    {c:15,debut:"2025-10-30", fin:"2025-11-19"},
    {c:16,debut:"2025-11-20", fin:"2025-12-10"},
    {c:17,debut:"2025-12-11", fin:"2025-12-31"},
  ],
  2026: [
    {c:1, debut:"2026-01-01", fin:"2026-01-21"},
    {c:2, debut:"2026-01-22", fin:"2026-02-11"},
    {c:3, debut:"2026-02-12", fin:"2026-03-04"},
    {c:4, debut:"2026-03-05", fin:"2026-03-25"},
    {c:5, debut:"2026-03-26", fin:"2026-04-15"},
    {c:6, debut:"2026-04-16", fin:"2026-05-06"},
    {c:7, debut:"2026-05-07", fin:"2026-05-27"},
    {c:8, debut:"2026-05-28", fin:"2026-06-17"},
    {c:9, debut:"2026-06-18", fin:"2026-07-08"},
    {c:10,debut:"2026-07-09", fin:"2026-07-29"},
    {c:11,debut:"2026-07-30", fin:"2026-08-19"},
    {c:12,debut:"2026-08-20", fin:"2026-09-09"},
    {c:13,debut:"2026-09-10", fin:"2026-09-30"},
    {c:14,debut:"2026-10-01", fin:"2026-10-21"},
    {c:15,debut:"2026-10-22", fin:"2026-11-11"},
    {c:16,debut:"2026-11-12", fin:"2026-12-02"},
    {c:17,debut:"2026-12-03", fin:"2026-12-23"},
  ],
};

// Trouve la campagne Mihi officielle pour une date donnée
function getCampagneMihiPourDate(dateStr){
  const d = new Date(dateStr+"T12:00:00").getTime();
  for(const [annee, campagnes] of Object.entries(CALENDRIER_MIHI)){
    for(const c of campagnes){
      const deb = new Date(c.debut+"T00:00:00").getTime();
      const fin = new Date(c.fin+"T23:59:59").getTime();
      if(d >= deb && d <= fin) return {annee:parseInt(annee), num:c.c, debut:c.debut, fin:c.fin};
    }
  }
  return null;
}

// Trouve la campagne Mihi actuelle
function getCampagneMihiActuelle(){
  const today = new Date();
  const dateStr = today.getFullYear()+"-"+String(today.getMonth()+1).padStart(2,"0")+"-"+String(today.getDate()).padStart(2,"0");
  return getCampagneMihiPourDate(dateStr);
}

export let ANTHROPIC_API_KEY="";
async function chargerCleAPI(){try{const snap=await getDoc(doc(db,"admin","config"));if(snap.exists()&&snap.data().anthropicKey)ANTHROPIC_API_KEY=snap.data().anthropicKey;}catch{}}
chargerCleAPI();

export let PERIODE_DEBUT_ABSOLU_MS = new Date("2026-01-01T12:00:00").getTime();
export let DATES_MANUELLES_CA = {
  "-34":"2023-12-28","-33":"2024-01-18","-32":"2024-02-08","-31":"2024-02-29","-30":"2024-03-21",
  "-29":"2024-04-11","-28":"2024-05-02","-27":"2024-05-23","-26":"2024-06-13","-25":"2024-07-04",
  "-24":"2024-07-25","-23":"2024-08-15","-22":"2024-09-05","-21":"2024-09-26","-20":"2024-10-17",
  "-19":"2024-11-07","-18":"2024-11-28","-17":"2024-12-19",
  "-16":"2025-01-09","-15":"2025-01-30","-14":"2025-02-20","-13":"2025-03-13","-12":"2025-04-03",
  "-11":"2025-04-24","-10":"2025-05-15","-9":"2025-06-05","-8":"2025-06-26","-7":"2025-07-17",
  "-6":"2025-08-07","-5":"2025-08-28","-4":"2025-09-18","-3":"2025-10-09","-2":"2025-10-30",
  "-1":"2025-11-20","0":"2025-12-11"
}; // {nAbsolu: "YYYY-MM-DD"} pour 2024/2025 uniquement - dates reelles fournies par Melissa
export let NUMEROS_MANUELS_CA = {
  "-34":1,"-33":2,"-32":3,"-31":4,"-30":5,"-29":6,"-28":7,"-27":8,"-26":9,"-25":10,
  "-24":11,"-23":12,"-22":13,"-21":14,"-20":15,"-19":16,"-18":17,"-17":18,
  "-16":1,"-15":2,"-14":3,"-13":4,"-12":5,"-11":6,"-10":7,"-9":8,"-8":9,"-7":10,
  "-6":11,"-5":12,"-4":13,"-3":14,"-2":15,"-1":16,"0":17
}; // vrai numero de campagne (C1-C18) pour chaque nAbsolu de 2024/2025
export const CALENDRIER_PERIODES = {
  2025: [
    {num:1,debut:"2025-01-09",fin:"2025-01-29"},
    {num:2,debut:"2025-01-30",fin:"2025-02-19"},
    {num:3,debut:"2025-02-20",fin:"2025-03-12"},
    {num:4,debut:"2025-03-13",fin:"2025-04-02"},
    {num:5,debut:"2025-04-03",fin:"2025-04-23"},
    {num:6,debut:"2025-04-24",fin:"2025-05-14"},
    {num:7,debut:"2025-05-15",fin:"2025-06-04"},
    {num:8,debut:"2025-06-05",fin:"2025-06-25"},
    {num:9,debut:"2025-06-26",fin:"2025-07-16"},
    {num:10,debut:"2025-07-17",fin:"2025-08-06"},
    {num:11,debut:"2025-08-07",fin:"2025-08-27"},
    {num:12,debut:"2025-08-28",fin:"2025-09-17"},
    {num:13,debut:"2025-09-18",fin:"2025-10-08"},
    {num:14,debut:"2025-10-09",fin:"2025-10-29"},
    {num:15,debut:"2025-10-30",fin:"2025-11-19"},
    {num:16,debut:"2025-11-20",fin:"2025-12-10"},
    {num:17,debut:"2025-12-11",fin:"2025-12-31"},
  ],
  2024: [
    {num:18,debut:"2023-12-28",fin:"2024-01-17"},
    {num:1,debut:"2024-01-18",fin:"2024-02-07"},
    {num:2,debut:"2024-02-08",fin:"2024-02-28"},
    {num:3,debut:"2024-02-29",fin:"2024-03-20"},
    {num:4,debut:"2024-03-21",fin:"2024-04-10"},
    {num:5,debut:"2024-04-11",fin:"2024-05-01"},
    {num:6,debut:"2024-05-02",fin:"2024-05-22"},
    {num:7,debut:"2024-05-23",fin:"2024-06-12"},
    {num:8,debut:"2024-06-13",fin:"2024-07-03"},
    {num:9,debut:"2024-07-04",fin:"2024-07-24"},
    {num:10,debut:"2024-07-25",fin:"2024-08-14"},
    {num:11,debut:"2024-08-15",fin:"2024-09-04"},
    {num:12,debut:"2024-09-05",fin:"2024-09-25"},
    {num:13,debut:"2024-09-26",fin:"2024-10-16"},
    {num:14,debut:"2024-10-17",fin:"2024-11-06"},
    {num:15,debut:"2024-11-07",fin:"2024-11-27"},
    {num:16,debut:"2024-11-28",fin:"2024-12-18"},
    {num:17,debut:"2024-12-19",fin:"2025-01-08"},
  ],
};
export const PERIODE_DUREE_JOURS = 21;
export const PERIODES_PAR_AN = 18;

// Charge l'ancre depuis Firebase (appelé au démarrage de l'app)
async function chargerAncrePeriodesFirebase(){
  try{
    const snap = await getDoc(doc(db,"admin","config_periodes"));
    if(snap.exists()&&snap.data().ancre){
      const savedAncre = new Date(snap.data().ancre).getTime();
      // Utiliser l'ancre sauvegardée seulement si elle est récente (2026+)
      if(savedAncre >= new Date("2025-01-01").getTime()) PERIODE_DEBUT_ABSOLU_MS = savedAncre;
    }
  }catch{}
}

// Appel immédiat au chargement
chargerAncrePeriodesFirebase();

export function getDebutCampagne(annee, numC){
  if(typeof CALENDRIER_MIHI!=="undefined"&&CALENDRIER_MIHI[annee]){
    const camp=CALENDRIER_MIHI[annee].find(c=>c.c===numC);
    if(camp) return new Date(camp.debut+"T12:00:00");
  }
  return null;
}
export function getFinCampagne(annee, numC){
  if(typeof CALENDRIER_MIHI!=="undefined"&&CALENDRIER_MIHI[annee]){
    const camp=CALENDRIER_MIHI[annee].find(c=>c.c===numC);
    if(camp) return new Date(camp.fin+"T12:00:00");
  }
  return null;
}
export function getPeriodeDebut(nAbsolu){
  if(DATES_MANUELLES_CA[nAbsolu]) return new Date(DATES_MANUELLES_CA[nAbsolu]+"T12:00:00");
  // Utiliser le calendrier officiel Mihi 2026 pour la période actuelle
  const campActuelle = getCampagneMihiActuelle();
  if(campActuelle){
    const annee = campActuelle.annee;
    const camps = CALENDRIER_MIHI[annee] || [];
    // nAbsolu relatif = numéro dans l'année courante
    const numAnnee = ((nAbsolu-1) % PERIODES_PAR_AN) + 1;
    const camp = camps.find(c=>c.c===numAnnee);
    if(camp) return new Date(camp.debut+"T12:00:00");
  }
  return new Date(PERIODE_DEBUT_ABSOLU_MS + (nAbsolu-1)*PERIODE_DUREE_JOURS*24*60*60*1000);
}

export function getPeriodeActuelle(){
  const ANCRE = new Date("2026-01-01T12:00:00").getTime();
  const now = new Date(); const todayLocal = new Date(now.getFullYear(),now.getMonth(),now.getDate()).getTime(); const diffJours = Math.floor((todayLocal - ANCRE) / (24*60*60*1000));
  return Math.max(1, Math.floor(diffJours / PERIODE_DUREE_JOURS) + 1);
}

function getPeriodeLabel(nAbsolu){
  const debut = getPeriodeDebut(nAbsolu);
  const fin = new Date(debut.getTime() + PERIODE_DUREE_JOURS*24*60*60*1000 - 1);
  const fmt=(d)=>d.toLocaleDateString("fr-FR",{day:"numeric",month:"short"});
  // Numéro dans l'année et année
  // P1 2025 = abs 1, P18 2025 = abs 18, P1 2026 = abs 19...
  const numDansAnnee = NUMEROS_MANUELS_CA[nAbsolu]!==undefined ? NUMEROS_MANUELS_CA[nAbsolu] : ((nAbsolu-1) % PERIODES_PAR_AN + PERIODES_PAR_AN) % PERIODES_PAR_AN + 1;
  const annee = debut.getFullYear();
  return `P${numDansAnnee} ${annee} · ${fmt(debut)}→${fmt(fin)}`;
}

function getPeriodKeys(n=12){
  const current = getPeriodeActuelle();
  const keys = [];
  for(let i=n-1;i>=0;i--){
    const num = current - i;
    if(num > 0) keys.push(`p${num}`);
  }
  return keys;
}

// Label court d'une période : "P7 2026"
export function fmtPLabel(nAbsolu){
  const debut = getPeriodeDebut(nAbsolu);
  // Ancre 22/01/2026 = P1 Mihi
  const OFFSET_MIHI = 0;
  const numAnnee = NUMEROS_MANUELS_CA[nAbsolu]!==undefined ? NUMEROS_MANUELS_CA[nAbsolu] : ((nAbsolu - 1 + OFFSET_MIHI) % PERIODES_PAR_AN + PERIODES_PAR_AN) % PERIODES_PAR_AN + 1;
  return `P${numAnnee} ${debut.getFullYear()}`;
}

// Section "Primes de Qualification" — suivi par période de 21j
function PrimesQualificationSection({obj, save, onPrimeValidee}){
  const qualifs = obj.qualifs || {};

  const setDirecteurs=(palierId, n)=>{
    const current = qualifs[palierId] || {directeurs:0, periodes:{}, primes:{}, pts:0};
    save({...obj, qualifs:{...qualifs, [palierId]:{...current, directeurs:n}}});
  };

  const setPts=(palierId, n)=>{
    const current = qualifs[palierId] || {directeurs:0, periodes:{}, primes:{}, pts:0};
    save({...obj, qualifs:{...qualifs, [palierId]:{...current, pts:n}}});
  };

  const togglePeriode=(palierId, periodeKey)=>{
    const current = qualifs[palierId] || {directeurs:0, periodes:{}, primes:{}, pts:0};
    const periodes = {...(current.periodes||{}), [periodeKey]:!current.periodes?.[periodeKey]};
    const next = {...current, periodes};

    const keys = getPeriodKeys(12);

    // Calcul des consécutives : trouve le nombre max de périodes consécutives dans les 12
    // (pas forcément depuis la fin — on cherche le max)
    let maxConsecutifs=0, courant=0;
    for(let i=0;i<keys.length;i++){
      if(periodes[keys[i]]){ courant++; maxConsecutifs=Math.max(maxConsecutifs,courant); }
      else courant=0;
    }
    // Consécutives depuis la fin (les plus récentes)
    let consecutifsRecents=0;
    for(let i=keys.length-1;i>=0;i--){
      if(periodes[keys[i]]) consecutifsRecents++;
      else break;
    }

    const totalSur12 = keys.filter(k=>periodes[k]).length;

    const primes = {...(current.primes||{})};

    // Prime 1 : 2 périodes consécutives
    if(maxConsecutifs>=2 && !primes.consecutif){
      primes.consecutif=true;
      setTimeout(()=>onPrimeValidee&&onPrimeValidee(), 100);
    }

    // Prime 2 : 6 périodes sur 12
    if(totalSur12>=6 && !primes.sur12){
      primes.sur12=true;
      setTimeout(()=>onPrimeValidee&&onPrimeValidee(), 600); // décalé pour que les deux feux s'enchaînent
    }

    next.primes = primes;
    save({...obj, qualifs:{...qualifs, [palierId]:next}});
  };

  const currentIdx = PALIERS_PERSO.indexOf(obj.palier||"2%");
  const srIdx = PALIERS_PERSO.indexOf("SR");
  if(currentIdx < srIdx) return null;

  const periodeKeys = getPeriodKeys(12);
  const currentPeriode = getPeriodeActuelle();

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:".75rem"}}>
      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".3rem"}}>💎 Primes de qualification</div>
      <p style={{fontSize:".66rem",color:C.gris,marginBottom:".75rem",lineHeight:1.6}}>
        Coche les périodes de 21 jours où tu valides la qualification. 2 périodes consécutives ou 6 sur 12 → prime débloquée 🎉
      </p>

      {PALIERS_QUALIFICATION.map(pq=>{
        const q = qualifs[pq.id] || {directeurs:0, periodes:{}, primes:{}, pts:0};
        const periodes = q.periodes || {};
        // Consécutives récentes (depuis la fin)
        let consecutifs=0;
        for(let i=periodeKeys.length-1;i>=0;i--){
          if(periodes[periodeKeys[i]]) consecutifs++;
          else break;
        }
        // Max consécutives sur les 12
        let maxConsecutifs=0, courant=0;
        for(let i=0;i<periodeKeys.length;i++){
          if(periodes[periodeKeys[i]]){ courant++; maxConsecutifs=Math.max(maxConsecutifs,courant); }
          else courant=0;
        }
        const totalSur12 = periodeKeys.filter(k=>periodes[k]).length;

        // Condition SR : 7500 pts OU 1 directeur
        const srPtsValide = pq.ptsOU && (q.pts||0)>=pq.pts;
        const srDirValide = pq.ptsOU && q.directeurs>=1;
        const srQualifie = pq.ptsOU ? (srPtsValide || srDirValide) : true;

        return(
          <div key={pq.id} style={{marginBottom:"1rem",paddingBottom:"1rem",borderBottom:`1px solid ${C.pale}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:".4rem"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,color:C.brun}}>{pq.id}</div>
              <div style={{fontSize:".68rem",fontWeight:700,color:C.or}}>{pq.prime}€ par prime</div>
            </div>

            {/* Condition SR double */}
            {pq.ptsOU&&(
              <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem",marginBottom:".5rem",fontSize:".68rem",color:C.gris}}>
                <div style={{fontWeight:700,color:C.brun,marginBottom:".3rem"}}>Condition d'accès (au choix) :</div>
                <div style={{display:"flex",gap:".4rem",flexWrap:"wrap"}}>
                  {/* Option A : 7500 pts */}
                  <div style={{flex:1,background:srPtsValide?C.vert+"20":C.blanc,border:`1.5px solid ${srPtsValide?C.vert:C.pale}`,borderRadius:8,padding:".5rem .65rem"}}>
                    <div style={{fontSize:".62rem",fontWeight:700,color:srPtsValide?C.vert:C.gris,marginBottom:".3rem"}}>Option A — 7 500 pts</div>
                    <div style={{display:"flex",alignItems:"center",gap:".4rem"}}>
                      <input type="number" value={q.pts||""} onChange={e=>setPts(pq.id,+e.target.value||0)}
                        placeholder="0"
                        style={{width:70,border:`1px solid ${C.pale}`,borderRadius:6,padding:".25rem .4rem",fontSize:".78rem",fontFamily:"inherit",textAlign:"center"}}/>
                      <span style={{fontSize:".62rem",color:C.gris}}>/ 7500 pts</span>
                      {srPtsValide&&<span style={{color:C.vert,fontWeight:700,fontSize:".68rem"}}>✓</span>}
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",fontSize:".72rem",color:C.gris,fontWeight:700}}>OU</div>
                  {/* Option B : 1 directeur */}
                  <div style={{flex:1,background:srDirValide?C.vert+"20":C.blanc,border:`1.5px solid ${srDirValide?C.vert:C.pale}`,borderRadius:8,padding:".5rem .65rem"}}>
                    <div style={{fontSize:".62rem",fontWeight:700,color:srDirValide?C.vert:C.gris,marginBottom:".3rem"}}>Option B — 1 Directeur</div>
                    <div onClick={()=>setDirecteurs(pq.id, q.directeurs>=1?0:1)}
                      style={{width:24,height:24,borderRadius:6,border:`2px solid ${srDirValide?C.vert:C.pale}`,background:srDirValide?C.vert:"transparent",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:".7rem",color:"white",fontWeight:700}}>
                      {srDirValide?"✓":"1"}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Directeurs requis (non-SR) */}
            {pq.nbDirecteurs>0&&!pq.ptsOU&&(
              <div style={{display:"flex",alignItems:"center",gap:".4rem",marginBottom:".5rem",flexWrap:"wrap"}}>
                <span style={{fontSize:".64rem",color:C.gris}}>Directeurs dans ma structure :</span>
                {Array.from({length:pq.nbDirecteurs},(_,i)=>i+1).map(n=>(
                  <div key={n} onClick={()=>setDirecteurs(pq.id, q.directeurs>=n?n-1:n)}
                    style={{width:22,height:22,borderRadius:6,border:`2px solid ${q.directeurs>=n?C.vert:C.pale}`,background:q.directeurs>=n?C.vert:"transparent",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:".68rem",color:"white",fontWeight:700}}>
                    {q.directeurs>=n?"✓":n}
                  </div>
                ))}
                <span style={{fontSize:".62rem",color:q.directeurs>=pq.nbDirecteurs?C.vert:C.gris,fontWeight:600}}>
                  {q.directeurs}/{pq.nbDirecteurs} {q.directeurs>=pq.nbDirecteurs?"✓ Qualifiée !":""}
                </span>
              </div>
            )}

            {/* Grille périodes */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:".25rem",marginBottom:".5rem"}}>
              {periodeKeys.map(k=>{
                const num=parseInt(k.slice(1));
                const checked=periodes[k];
                const isCurrent = num===currentPeriode;
                return(
                  <div key={k} onClick={()=>togglePeriode(pq.id,k)}
                    style={{textAlign:"center",padding:".3rem 0",borderRadius:6,border:`1.5px solid ${checked?C.vert:isCurrent?C.rose:C.pale}`,background:checked?C.vert+"20":"transparent",cursor:"pointer"}}>
                    <div style={{fontSize:".58rem",fontWeight:600,color:checked?C.vert:isCurrent?C.rose:C.gris}}>{fmtPLabel(num)}</div>
                    <div style={{fontSize:".52rem",color:checked?C.vert:C.pale}}>{checked?"✓":""}</div>
                  </div>
                );
              })}
            </div>

            {/* Statut primes — 2 onglets débloquables */}
            <div style={{display:"flex",flexDirection:"column",gap:".35rem",marginTop:".5rem"}}>

              {/* Prime 1 : 2 consécutives */}
              <div style={{
                background:q.primes?.consecutif?`linear-gradient(135deg,${C.vert},#4a9a5a)`:maxConsecutifs>=2?C.or+"15":C.creme,
                border:`1.5px solid ${q.primes?.consecutif?C.vert:maxConsecutifs>=2?C.or:C.pale}`,
                borderRadius:10,padding:".6rem .85rem",
                display:"flex",justifyContent:"space-between",alignItems:"center"
              }}>
                <div>
                  <div style={{fontSize:".7rem",fontWeight:700,color:q.primes?.consecutif?"white":maxConsecutifs>=2?C.brun:C.gris}}>
                    {q.primes?.consecutif?"🎉 Prime 1 débloquée !":maxConsecutifs>=2?"✓ Condition remplie":"○ Prime 1"}
                  </div>
                  <div style={{fontSize:".6rem",color:q.primes?.consecutif?"rgba(255,255,255,.8)":C.gris,marginTop:".1rem"}}>
                    2 périodes consécutives · {maxConsecutifs}/2
                  </div>
                </div>
                <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:700,color:q.primes?.consecutif?"white":maxConsecutifs>=2?C.vert:C.gris}}>
                  {pq.prime}€
                </div>
              </div>

              {/* Prime 2 : 6 sur 12 */}
              <div style={{
                background:q.primes?.sur12?`linear-gradient(135deg,${C.or},#b8962a)`:totalSur12>=6?C.vert+"15":C.creme,
                border:`1.5px solid ${q.primes?.sur12?C.or:totalSur12>=6?C.vert:C.pale}`,
                borderRadius:10,padding:".6rem .85rem",
                display:"flex",justifyContent:"space-between",alignItems:"center"
              }}>
                <div>
                  <div style={{fontSize:".7rem",fontWeight:700,color:q.primes?.sur12?"white":totalSur12>=6?C.brun:C.gris}}>
                    {q.primes?.sur12?"🎉 Prime 2 débloquée !":totalSur12>=6?"✓ Condition remplie":"○ Prime 2"}
                  </div>
                  <div style={{fontSize:".6rem",color:q.primes?.sur12?"rgba(255,255,255,.8)":C.gris,marginTop:".1rem"}}>
                    6 périodes sur 12 · {totalSur12}/6
                  </div>
                </div>
                <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:700,color:q.primes?.sur12?"white":totalSur12>=6?C.vert:C.gris}}>
                  {pq.prime}€
                </div>
              </div>

              {/* Total débloqué */}
              {(q.primes?.consecutif||q.primes?.sur12)&&(
                <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:10,padding:".55rem .85rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontSize:".72rem",fontWeight:600,color:C.or}}>
                    💰 Total débloqué pour {pq.id}
                  </div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:700,color:C.or}}>
                    {((q.primes?.consecutif?1:0)+(q.primes?.sur12?1:0)) * pq.prime}€
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );



}
function PrimesAccordeon({obj, save, onPrimeValidee}){
  const[open,setOpen]=useState(true);
  return(
    <div style={{marginBottom:".75rem"}}>
      <div onClick={()=>setOpen(o=>!o)}
        style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:open?"12px 12px 0 0":12,padding:".75rem 1rem",cursor:"pointer",userSelect:"none"}}>
        <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
          <span style={{fontSize:"1rem"}}>💎</span>
          <div style={{fontSize:".75rem",fontWeight:700,color:C.brun}}>Primes de qualification</div>
        </div>
        <span style={{color:C.gris,fontSize:".8rem",transform:open?"rotate(90deg)":"none",transition:"transform .2s"}}>›</span>
      </div>
      {open&&(
        <div style={{border:`1px solid ${C.pale}`,borderTop:"none",borderRadius:"0 0 12px 12px",overflow:"hidden"}}>
          <PrimesQualificationSection obj={obj} save={save} onPrimeValidee={onPrimeValidee}/>
        </div>
      )}
    </div>
  );
}

// ── CALCUL DU RESTE ──────────────────────────────────────────────────────────
function ResteCalculateur({obj, save, uid=null, distributeurs=[]}){
  const[annuaire,setAnnuaire]=useState([]);
  // State local pour les saisies CA — indépendant de obj pour éviter les re-renders
  const[vals,setVals]=useState({});
  const[inited,setInited]=useState(false);
  const[ongletDir,setOngletDir]=useState("place");

  useEffect(()=>{
    (async()=>{
      try{
        const fmtUid=(u)=>u.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");
        const accesSnap=await getDoc(doc(db,"acces","membres"));
        const liste=accesSnap.exists()?(Array.isArray(accesSnap.data().liste)?accesSnap.data().liste:Object.values(accesSnap.data().liste||{})):[];
        const uidsAcces=liste.map(m=>m.uid).filter(Boolean);

        const snap=await getDoc(doc(db,"equipe","annuaire"));
        const m=snap.exists()?(snap.data().membres||{}):{};

        // Fusionne : tout le monde present dans acces/membres, avec prenom/nom de l annuaire si disponibles, sinon formate depuis l uid
        const tousUids=[...new Set([...uidsAcces, ...Object.keys(m)])];
        const complet=tousUids.map(uid=>{
          const d=m[uid]||{};
          const nomComplet=(d.prenom||d.nom)?`${d.prenom||""} ${d.nom||""}`.trim():fmtUid(uid);
          return {id:uid, prenom:d.prenom||nomComplet, nom:d.nom||"", ca:d.ca||""};
        }).sort((a,b)=>(a.prenom+a.nom).localeCompare(b.prenom+b.nom));

        // Confidentialité : seulement moi + les personnes arrivées sous moi (Melissa voit tout)
        const visibles=estMelissaUid(uid)?null:new Set(Object.keys(filtrerAnnuaire(m,uid)||{}).map(k=>(m[k]&&m[k].uid)||k));
        setAnnuaire(visibles?complet.filter(x=>visibles.has(x.id)):complet);
      }catch{}
    })();
  },[uid]);

  // Initialiser vals depuis obj.caDirecteurs une seule fois
  useEffect(()=>{
    if(!inited&&obj.caDirecteurs){
      setVals({...obj.caDirecteurs});
      setInited(true);
    }
  },[obj.caDirecteurs,inited]);

  const caEquipe=parseFloat(obj.ca)||0;
  const nbDir=parseInt(obj.nbDirecteurs)||0;
  const selectionnes=obj.dirSelectionnes||{};

  // Calcul depuis le state local vals
  const totalDir=Array.from({length:nbDir},(_,i)=>parseFloat(vals[i])||0).reduce((s,v)=>s+v,0);
  const resteSans=caEquipe-totalDir;

  // 🌟 Directeurs à venir : jauge 5 000 € + reste avec / sans eux
  const dirsEnPlace=useMemo(()=>Array.from({length:nbDir},(_,i)=>{
    const u=selectionnes[i];
    if(!u) return null;
    const d=annuaire.find(x=>x.id===u);
    return {uid:u,nom:d?`${d.prenom||""} ${d.nom||""}`.trim():u};
  }).filter(Boolean),[nbDir,selectionnes,annuaire]);
  const av=useDirAVenir(obj,save,dirsEnPlace,uid);
  const resteAvec=resteSans-av.totalInclus;
  const avecFuturs=av.mode==="avec"&&av.peutBasculer;
  const reste=avecFuturs?resteAvec:resteSans;

  const setNbDir=(n)=>{
    const nextCa={...vals};
    const nextSel={...selectionnes};
    for(let i=n;i<6;i++){delete nextCa[i];delete nextSel[i];}
    setVals(nextCa);
    save({...obj,nbDirecteurs:n,caDirecteurs:nextCa,dirSelectionnes:nextSel});
  };

  const setVal=(i,v)=>{
    const next={...vals,[i]:v};
    setVals(next);
    save({...obj,caDirecteurs:next});
  };

  const selDir=(i,uid)=>{
    const d=annuaire.find(x=>x.id===uid);
    const nextSel={...selectionnes,[i]:uid};
    // Ne pas écraser une valeur déjà saisie manuellement
    const nextCa={...vals};
    if(!vals[i]&&d?.ca) nextCa[i]=d.ca;
    setVals(nextCa);
    save({...obj,dirSelectionnes:nextSel,caDirecteurs:nextCa});
  };

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:".75rem"}}>
      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".6rem"}}><T k="obj.reste">📊 Calcul du Reste</T></div>

      {/* Onglets */}
      <div style={{display:"flex",gap:".35rem",marginBottom:".75rem"}}>
        {[["place","Directeurs en place"],["avenir","🌟 À venir"+(av.liste.length?` (${av.liste.length})`:"")]].map(([k,l])=>(
          <button key={k} onClick={()=>setOngletDir(k)}
            style={{flex:1,padding:".45rem .3rem",fontSize:".7rem",fontWeight:700,borderRadius:9,cursor:"pointer",fontFamily:"inherit",border:`1.5px solid ${ongletDir===k?C.brun:C.pale}`,background:ongletDir===k?C.brun:C.blanc,color:ongletDir===k?C.blanc:C.gris}}>
            {l}
          </button>
        ))}
      </div>

      {ongletDir==="avenir"&&(
        <div style={{marginBottom:".75rem"}}>
          <DirecteursAVenirOnglet av={av} uid={uid} personnes={annuaire} dejaDirecteurs={dirsEnPlace.map(d=>d.uid)}/>
        </div>
      )}

      {/* CA équipe */}
      <BoutonMoiMihi uid={uid} titre="Mon CA total depuis Mihi" onApply={(moi)=>{
        const vg=Math.round((moi.vg||0)*100)/100, perso=parseFloat(obj.caPerso)||0;
        save({...obj,ca:String(vg),caEquipe:String(Math.max(0,Math.round((vg-perso)*100)/100))});
      }}/>
      <div style={{background:C.creme,borderRadius:9,padding:".5rem .75rem",marginBottom:".75rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontSize:".7rem",color:C.gris}}>💰 CA total équipe (mes objectifs)</span>
        <span style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:700,color:C.brun}}>{caEquipe}€</span>
      </div>

      {/* Nombre directeurs */}
      {ongletDir==="place"&&(<>
      <div style={{marginBottom:".75rem"}}>
        <div style={{fontSize:".62rem",color:C.gris,marginBottom:".35rem",fontWeight:600}}><T k="obj.directeurs">Directeurs dans ma structure</T></div>
        <div style={{display:"flex",gap:".3rem"}}>
          {[0,1,2,3,4,5,6].map(n=>(
            <button key={n} onClick={()=>setNbDir(n)}
              style={{width:34,height:34,borderRadius:8,border:`2px solid ${nbDir===n?C.brun:C.pale}`,background:nbDir===n?C.brun:C.blanc,color:nbDir===n?C.blanc:C.gris,fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
              {n}
            </button>
          ))}
        </div>
      </div>

      {/* Champs directeurs */}
      {nbDir>0&&(
        <div style={{marginBottom:".75rem"}}>
          <BoutonRemplirMihi
            uid={uid}
            titre="Remplir les CA des directeurs depuis Mihi"
            aide="Reprend le volume de groupe (VG) de chaque directeur choisi ci-dessous : c'est ce qui sort de ton volume."
            items={Array.from({length:nbDir},(_,i)=>{const u=selectionnes[i];const d=u?annuaire.find(x=>x.id===u):null;return d?{key:i,nom:`${d.prenom||""} ${d.nom||""}`.trim(),uid:u}:null;}).filter(Boolean)}
            decrire={(mb)=>`VG ${Math.round(mb.vg*100)/100} €`}
            onApply={(liste)=>{
              const next={...vals};
              liste.forEach(({key,membre})=>{next[key]=String(Math.round(membre.vg*100)/100);});
              setVals(next);
              save({...obj,caDirecteurs:next});
            }}/>
          {Array.from({length:nbDir},(_,i)=>{
            const selUid=selectionnes[i]||"";
            const selD=selUid?annuaire.find(x=>x.id===selUid):null;
            return(
              <div key={i} style={{background:C.creme,borderRadius:9,padding:".55rem .75rem",marginBottom:".4rem",border:`1px solid ${C.pale}`}}>
                <div style={{display:"flex",alignItems:"center",gap:".5rem",marginBottom:".3rem"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:C.brun,color:C.blanc,fontSize:".65rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{i+1}</div>
                  <select value={selUid} onChange={e=>selDir(i,e.target.value)}
                    style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:7,padding:".32rem .5rem",fontSize:".75rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none"}}>
                    <option value="">— Choisir —</option>
                    {annuaire.map(d=>(
                      <option key={d.id} value={d.id}>{d.prenom} {d.nom}</option>
                    ))}
                  </select>
                </div>
                {selD&&<div style={{fontSize:".62rem",color:C.vert,marginBottom:".25rem",fontWeight:600}}>✓ {selD.prenom} {selD.nom}</div>}
                <div style={{display:"flex",alignItems:"center",gap:".4rem"}}>
                  <span style={{fontSize:".65rem",color:C.gris,flexShrink:0}}>CA ce directeur :</span>
                  <input
                    type="number"
                    value={vals[i]||""}
                    onChange={e=>setVal(i,e.target.value)}
                    placeholder="0"
                    style={{flex:1,border:`1.5px solid ${C.rose}`,borderRadius:7,padding:".32rem .5rem",fontSize:".88rem",fontFamily:"inherit",color:C.brun,background:"white",outline:"none",fontWeight:700}}
                  />
                  <span style={{fontSize:".65rem",color:C.gris}}>€</span>
                </div>
              </div>
            );
          })}

          {/* Total directeurs */}
          <div style={{background:C.creme,borderRadius:8,padding:".4rem .75rem",display:"flex",justifyContent:"space-between"}}>
            <span style={{fontSize:".7rem",color:C.gris}}>Total CA directeurs</span>
            <span style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:700,color:"#B04040"}}>− {totalDir}€</span>
          </div>
        </div>
      )}
      </>)}

      {/* Résultat */}
      <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:10,padding:".85rem 1rem"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".35rem"}}>
          <div>
            <div style={{fontSize:".58rem",fontWeight:700,color:C.or,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".1rem"}}>✨ Reste qualifiant</div>
            <div style={{fontSize:".62rem",color:C.pale}}>{caEquipe} − {totalDir}{avecFuturs?` − ${av.totalInclus} (futurs directeurs)`:""} =</div>
          </div>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.6rem",fontWeight:700,color:reste<0?"#F4A460":C.or}}>{Math.round(reste*100)/100}€</div>
        </div>
        {nbDir>0&&(
          <div style={{background:"rgba(255,255,255,.1)",borderRadius:7,padding:".3rem .6rem",fontSize:".65rem",color:C.pale}}>
            {Array.from({length:nbDir},(_,i)=>{
              const selD=selectionnes[i]?annuaire.find(x=>x.id===selectionnes[i]):null;
              return<span key={i}>{i>0?" · ":""}{selD?selD.prenom:`Dir.${i+1}`} : {parseFloat(vals[i])||0}€</span>;
            })}
          </div>
        )}
        <BasculeFuturs av={av} resteSans={resteSans} resteAvec={resteAvec}/>
      </div>
    </div>
  );
}


export function ObjPersoTab({obj,save,uid,userName,distributeurs=[]}){
  const[confettiTrigger,setConfettiTrigger]=useState(0);
  const[fireworksTrigger,setFireworksTrigger]=useState(0);
  const[showDecouverte,setShowDecouverte]=useState(false);
  const[suiviCATotal,setSuiviCATotal]=useState(0);useEffect(()=>{(async()=>{try{const snap=await getDoc(doc(db,"users",uid));if(snap.exists()&&snap.data()["db-suivi-ca"]){const sc=JSON.parse(snap.data()["db-suivi-ca"]);const total=Object.values(sc).reduce((s,v)=>s+(parseFloat(v)||0),0);setSuiviCATotal(total);}}catch{}})();},[uid]);
  const[graphEnGros,setGraphEnGros]=useState(null);
  const[histoPeriodes,setHistoPeriodes]=useState([]);
  useEffect(()=>{(async()=>{
    try{
      const snapH=await getDoc(doc(db,"users",uid));
      if(!snapH.exists())return;
      const brutH=snapH.data()["db-suivi-ca"];
      if(!brutH)return;
      const dataH=JSON.parse(brutH);
      const pts=Object.entries(dataH)
        .map(([k,v])=>({num:parseInt(String(k).replace("p",""),10),ca:+v.ca||0,caPerso:+v.caPerso||0,recrues:+v.recrues||0}))
        .filter(p=>!isNaN(p.num)&&(p.ca>0||p.caPerso>0||p.recrues>0))
        .sort((x,y)=>x.num-y.num)
        .map(p=>({...p,label:"P"+p.num}));
      setHistoPeriodes(pts);
    }catch(e){ console.error("histoPeriodes:",e); }
  })();},[uid]);
  const[recrutementOuvert,setRecrutementOuvert]=useState(()=>!!(obj.recruesObj&&obj.recruesObj!=="0"));
  // Le CA total d'équipe de Melissa alimente la couronne « Objectifs équipe » (visible par toute l'équipe)
  useEffect(()=>{
    if(!estMelissaUid(uid))return;
    const v=String(obj.ca==null?"":obj.ca).trim();
    if(v==="")return;
    const t=setTimeout(()=>{setDoc(doc(db,"equipe","objectifs"),{caReal:v,caRealMaj:Date.now()},{merge:true}).catch(()=>{});},800);
    return()=>clearTimeout(t);
  },[uid,obj.ca]);
  const raw=getPeriodeInfo();
  const pCourant=getPeriodeActuelle();

  // Score période précédente depuis l'historique
  const histPerso=obj.historique||[];
  const dernierHist=histPerso.length>0?histPerso[histPerso.length-1]:null;
  const scorePrecBadge=dernierHist?(
    <div style={{display:"flex",gap:".5rem",alignItems:"center",background:"rgba(196,154,138,.1)",border:`1px solid ${C.pale}`,borderRadius:8,padding:".3rem .65rem",marginBottom:".6rem",flexWrap:"wrap"}}>
      <span style={{fontSize:".58rem",color:C.gris}}>📊 Période précédente ({fmtPLabel(dernierHist.periode||pCourant-1)}) :</span>
      <span style={{fontSize:".65rem",fontWeight:700,color:C.rose}}>💰 {dernierHist.ca||0}€</span>
      <span style={{fontSize:".65rem",fontWeight:700,color:C.brun}}>🛍️ {dernierHist.caPerso||0}€ perso</span>
      <span style={{fontSize:".65rem",fontWeight:700,color:C.lilas}}>👥 {dernierHist.recruesReal||0} recrues</span>
    </div>
  ):null;

  const pctCA=()=>{if(!obj.caObj||!obj.ca)return 0;return Math.min(100,Math.round(+obj.ca/+obj.caObj*100));};
  const pctR=()=>{if(!obj.recruesObj||obj.recruesObj==="0"||!obj.recruesReal)return 0;return Math.min(100,Math.round(+obj.recruesReal/+obj.recruesObj*100));};
  const pct=(r,o)=>{if(!o||!r)return 0;return Math.min(100,Math.round(+r/+o*100));};

  const checkAndCelebrate=(nextObj)=>{
    const wasNot100CA=pctCA()<100,wasNot100R=pctR()<100;
    const nextPctCA=(!nextObj.caObj||!nextObj.ca)?0:Math.min(100,Math.round(+nextObj.ca/+nextObj.caObj*100));
    const nextPctR=(!nextObj.recruesObj||nextObj.recruesObj==="0"||!nextObj.recruesReal)?0:Math.min(100,Math.round(+nextObj.recruesReal/+nextObj.recruesObj*100));
    if((wasNot100CA&&nextPctCA>=100)||(wasNot100R&&nextPctR>=100))setConfettiTrigger(t=>t+1);
    if(wasNot100CA&&nextPctCA>=100&&uid&&userName)postToWallOfFame(uid,userName,"a atteint son objectif CA ! 💰","🎉");
    if(wasNot100R&&nextPctR>=100&&uid&&userName)postToWallOfFame(uid,userName,"a atteint son objectif recrutement ! 👥","🎉");
    save(nextObj);
  };

  const historique=obj.historique||[];
  const snapshotNow=()=>{
    const entry={date:todayLocalStr(),ca:+obj.ca||0,caObj:+obj.caObj||0,caPerso:+obj.caPerso||0,recruesReal:+obj.recruesReal||0,recruesObj:+obj.recruesObj||0,palier:obj.palier||"2%"};
    // Ne pas archiver un point totalement vide : il ecrase la lecture des courbes
    if(entry.ca===0&&entry.caPerso===0&&entry.recruesReal===0)return historique;
    return [...historique,entry].slice(-24);
  };
  const supprimerPointHisto=(idx)=>{
    if(!window.confirm("Supprimer ce point de l'historique ?"))return;
    save({...obj,historique:historique.filter((_,i)=>i!==idx)});
  };

  const resetPeriode=async()=>{
    try{ await archiverPeriodeSuiviCA(uid, getPeriodeActuelle(), obj.caPerso, obj.recruesReal); }catch(e){}
    const hist=snapshotNow();
    const next={...obj,ca:"",caObj:"",caPerso:"",caEquipe:"",recruesReal:"0",historique:hist};
    const totalCaCumul=(+obj.totalCaCumul||0)+(+obj.ca||0);
    const totalRecruesCumul=(+obj.totalRecruesCumul||0)+(+obj.recruesReal||0);
    checkAndCelebrate({...next,totalCaCumul,totalRecruesCumul});
  };

  const enregistrerPoint=()=>{save({...obj,historique:snapshotNow()});};
  const comparaisonPeriode=(hist,valActuelle,key)=>{if(!hist||hist.length<1)return null;const last=hist[hist.length-1];const prev=last[key]||0;const curr=+valActuelle||0;const diff=curr-prev;const pct2=prev?Math.round(diff/prev*100):0;return{diff,previous:prev,pct:pct2};};

  const PALIERS_PERSO=["2%","4%","6%","8%","10%","12%","14%","17%","SR","Directeur","Structural","Business Director","SR Business Director","Business"];
  const currentPalierIdx=PALIERS_PERSO.indexOf(obj.palier||"2%");
  const nextPalier=currentPalierIdx<PALIERS_PERSO.length-1?PALIERS_PERSO[currentPalierIdx+1]:null;

  // Mini graphique inline
  const MiniGraph=({data,dataKey,color,label,onClick})=>{
    if(!data||data.length<2)return null;
    const vals=data.map(d=>+d[dataKey]||0);
    const max=Math.max(...vals,1);
    const w=120,h=50;
    const pts=vals.map((v,i)=>`${Math.round(i/(vals.length-1)*w)},${Math.round(h-(v/max*h*.85+h*.05))}`).join(" ");
    return(
      <div onClick={onClick} style={{flex:1,minWidth:0,cursor:"pointer",padding:".4rem",background:C.blanc,borderRadius:9,border:`1px solid ${C.pale}`,transition:"transform .15s"}} title="Cliquer pour agrandir">
        <div style={{fontSize:".58rem",color:C.gris,marginBottom:".2rem",fontWeight:600}}>{label}</div>
        <svg viewBox={`0 0 ${w} ${h}`} style={{width:"100%",height:50,display:"block"}}>
          <polyline points={pts} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
          <polyline points={`0,${h} ${pts} ${w},${h}`} fill={color} fillOpacity={.12} stroke="none"/>
        </svg>
        <div style={{fontSize:".55rem",color,fontWeight:700,textAlign:"right",marginTop:".1rem"}}>{+obj[dataKey]||0}</div>
      </div>
    );
  };

  // Graphique en grand (popup)
  const GrandGraph=({data,dataKey,color,label,unit=""})=>{
    const vals=data.map(d=>+d[dataKey]||0);
    const dates=data.map(d=>d.label||(d.date?d.date.slice(5):""));
    const max=Math.max(...vals,1);
    const w=280,h=120;
    const pts=vals.map((v,i)=>`${Math.round(i/(vals.length-1)*w)},${Math.round(h-(v/max*h*.85+h*.05))}`).join(" ");
    return(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999}} onClick={()=>setGraphEnGros(null)}>
        <div style={{background:C.blanc,borderRadius:16,padding:"1.25rem",width:"90%",maxWidth:360}} onClick={e=>e.stopPropagation()}>
          <div style={{fontFamily:"Georgia,serif",fontSize:".95rem",fontWeight:600,color:C.brun,marginBottom:".75rem"}}>{label}</div>
          <svg viewBox={`0 0 ${w} ${h}`} style={{width:"100%",height:140,display:"block",marginBottom:".5rem"}}>
            <polyline points={pts} fill="none" stroke={color} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points={`0,${h} ${pts} ${w},${h}`} fill={color} fillOpacity={.1} stroke="none"/>
            {vals.map((v,i)=>(
              <g key={i}>
                <circle cx={Math.round(i/(vals.length-1)*w)} cy={Math.round(h-(v/max*h*.85+h*.05))} r={3} fill={color}/>
                <text x={Math.round(i/(vals.length-1)*w)} y={h-2} textAnchor="middle" fontSize="7" fill={C.gris}>{dates[i]}</text>
              </g>
            ))}
          </svg>
          {vals.map((v,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:".65rem",color:C.gris,padding:".2rem 0",borderBottom:`1px solid ${C.pale}`}}>
              <span>{dates[i]||`Point ${i+1}`}</span>
              <span style={{display:"flex",alignItems:"center",gap:".5rem"}}>
                <span style={{fontWeight:700,color}}>{v}{unit}</span>
                <button onClick={()=>{supprimerPointHisto(i);setGraphEnGros(null);}}
                  style={{background:"none",border:"none",color:"#C0504D",fontSize:".7rem",cursor:"pointer",fontFamily:"inherit",padding:"0 .1rem",lineHeight:1}}
                  title="Supprimer ce point">{"\u2715"}</button>
              </span>
            </div>
          ))}
          <button onClick={()=>setGraphEnGros(null)} style={{width:"100%",marginTop:".75rem",background:C.brun,color:C.blanc,border:"none",borderRadius:9,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>Fermer</button>
        </div>
      </div>
    );
  };

  return(
    <div>
      <Confetti trigger={confettiTrigger}/>
      <Fireworks trigger={fireworksTrigger}/>
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:".5rem"}}><button onClick={()=>setShowDecouverte(true)} style={{background:"#C49A8A",color:"white",border:"none",borderRadius:20,padding:".35rem 1rem",fontSize:".75rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",boxShadow:"0 2px 8px rgba(196,154,138,.4)"}}>🧭 Découverte</button></div>
      {showDecouverte&&<DecouverteTour outil="objectifs" onClose={()=>setShowDecouverte(false)}/>}
      <div onClick={()=>{try{window.dispatchEvent(new Event("ouvrir-tirelire"));}catch{}}} style={{background:"linear-gradient(135deg,#FFF8E1,#FDEBD3)",border:`1.5px solid ${C.or}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".75rem",cursor:"pointer",display:"flex",alignItems:"center",gap:".7rem"}}>
        <span style={{fontSize:"1.8rem"}}>🐷</span>
        <div style={{flex:1}}>
          <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose}}>Mon objectif en argent</div>
          <div style={{fontSize:".74rem",color:C.brun,lineHeight:1.45}}>Fixe combien tu veux gagner, ton pourcentage (20 à 30 %) et note tes ventes réelles. Ta tirelire se remplit !</div>
        </div>
        <span style={{color:C.rose,fontSize:"1.1rem"}}>›</span>
      </div>
      {graphEnGros&&histoPeriodes.length>=2&&<GrandGraph data={histoPeriodes} dataKey={graphEnGros} color={graphEnGros==="recrues"?C.lilas:graphEnGros==="caPerso"?C.rose:C.brun} label={graphEnGros==="recrues"?"👥 Recrues":graphEnGros==="caPerso"?"🛍️ Ventes perso":"💰 CA total"} unit={graphEnGros==="recrues"?"":" €"}/>}

      {/* 1. PÉRIODE EN COURS */}
      <div id="decouverte-periode" style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:12,padding:".85rem 1rem",marginBottom:".75rem",color:C.blanc}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{fontSize:".55rem",fontWeight:700,color:C.or,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".15rem"}}>⏱️ Période en cours</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,color:C.blanc}}>{fmtPLabel(pCourant)}</div>
            <div style={{fontSize:".65rem",color:C.pale}}>{raw.daysLeft}j {raw.hoursLeft}h restants</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{height:4,width:80,background:"rgba(255,255,255,.15)",borderRadius:10,overflow:"hidden",marginBottom:".2rem"}}>
              <div style={{height:"100%",background:C.or,width:raw.pctElapsed+"%",borderRadius:10}}/>
            </div>
            <div style={{fontSize:".58rem",color:C.pale}}>{raw.pctElapsed}% écoulé</div>
          </div>
        </div>
      </div>

      {/* Bouton confirmer objectifs posés */}
      {obj.objectifsPosesPeriode!==pCourant&&(
        <button onClick={()=>save({...obj,objectifsPosesPeriode:pCourant})}
          style={{width:"100%",background:C.creme,border:`1.5px dashed ${C.or}`,borderRadius:10,padding:".5rem",fontSize:".75rem",fontWeight:600,color:"#856404",fontFamily:"inherit",cursor:"pointer",marginBottom:".75rem"}}>
          ✅ Mes objectifs sont posés pour cette période
        </button>
      )}

      {/* Score période précédente */}
      {scorePrecBadge}

      {/* 2. TOTAL DEPUIS LE DÉBUT */}
      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem .85rem",marginBottom:".75rem"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:700,color:C.brun}}>{(+obj.totalCaCumul||0)+(+obj.ca||0)+(+suiviCATotal||0)}€</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:700,color:C.brun}}>{(+obj.totalCaCumul||0)+(+obj.ca||0)}€</div>
        <div style={{fontSize:".58rem",color:C.gris}}>{(+obj.totalRecruesCumul||0)+(+obj.recruesReal||0)} recrues total</div>
      </div>

      {/* 3. PALIER À ATTEINDRE */}
      <div id="decouverte-palier" style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem 1rem",marginBottom:".75rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".5rem"}}>🎯 Palier à atteindre</div>
        <div style={{display:"flex",gap:".4rem",flexWrap:"wrap"}}>
          {PALIERS_PERSO.map((p,idx)=>(
            <button key={p} onClick={()=>save({...obj,palier:p})}
              style={{padding:".3rem .55rem",fontSize:".65rem",fontWeight:600,borderRadius:8,border:`1.5px solid ${obj.palier===p?C.or:C.pale}`,background:idx<currentPalierIdx?"#E8F5E9":obj.palier===p?C.or+"20":C.blanc,color:idx<currentPalierIdx?C.vert:obj.palier===p?C.brun:C.gris,cursor:"pointer",fontFamily:"inherit"}}>
              {idx<currentPalierIdx?"✓ ":""}{p}
            </button>
          ))}
        </div>
        {nextPalier&&<div style={{fontSize:".65rem",color:C.gris,marginTop:".4rem"}}>Prochain palier → <strong style={{color:C.brun}}>{nextPalier}</strong></div>}
      </div>

      {/* 4. CHIFFRE D'AFFAIRES */}
      <div id="decouverte-ca" style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:".75rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".6rem"}}>💰 Chiffre d'affaires</div>
        <BoutonMoiMihi uid={uid} titre="Mon CA total depuis Mihi" onApply={(moi)=>{
          const vg=Math.round((moi.vg||0)*100)/100, perso=parseFloat(obj.caPerso)||0;
          checkAndCelebrate({...obj,ca:String(vg),caEquipe:String(Math.max(0,Math.round((vg-perso)*100)/100))});
        }}/>
        <div style={{display:"flex",gap:".5rem",marginBottom:".6rem"}}>
          <div style={{flex:1}}>
            <div style={{fontSize:".62rem",color:C.gris,marginBottom:".25rem"}}><T k="obj.objectif">Objectif (€)</T></div>
            <input type="number" placeholder="Ex: 500" value={obj.caObj||""} onChange={e=>save({...obj,caObj:e.target.value})}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".9rem",fontFamily:"inherit",color:C.brun,background:C.creme,outline:"none",fontWeight:600}}/>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:".62rem",color:C.gris,marginBottom:".25rem"}}><T k="obj.ca_total">CA total = ventes équipe (€)</T></div>
            <input type="number" placeholder="Ex: 250" value={obj.ca||""} onChange={e=>checkAndCelebrate({...obj,ca:e.target.value,caEquipe:String(Math.max(0,(parseFloat(e.target.value)||0)-(parseFloat(obj.caPerso)||0)))})}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".9rem",fontFamily:"inherit",color:C.brun,background:C.creme,outline:"none",fontWeight:600}}/>
          </div>
        </div>
        <div style={{background:C.creme,borderRadius:9,padding:".45rem .7rem",marginBottom:".5rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%"}}><span style={{fontSize:".68rem",color:C.gris}}>🛍️ Dont mes ventes perso</span><span style={{fontSize:".62rem",color:C.gris}}>Objectif : <input type="number" placeholder="0" value={obj.caPersoObj||""} onChange={e=>save({...obj,caPersoObj:e.target.value})} style={{width:55,border:"1px solid "+C.rose+"40",borderRadius:6,padding:".2rem .35rem",fontSize:".72rem",fontFamily:"inherit",color:C.rose,background:"white",outline:"none",textAlign:"center"}}/> €</span></div>
          <div style={{display:"flex",gap:".4rem",alignItems:"center"}}>
            <span style={{fontSize:".62rem",color:C.gris,fontWeight:600,marginRight:".25rem"}}>Réalisé</span>
            <input type="number" placeholder="0" value={obj.caPerso||""} onChange={e=>{
              const perso=parseFloat(e.target.value)||0;
              save({...obj,caPerso:e.target.value,caEquipe:String(Math.max(0,(parseFloat(obj.ca)||0)-perso))});
            }} style={{width:70,border:`1px solid ${C.rose}40`,borderRadius:7,padding:".28rem .45rem",fontSize:".8rem",fontFamily:"inherit",color:C.brun,background:"white",outline:"none",fontWeight:600,textAlign:"right"}}/>
            <span style={{fontSize:".65rem",color:C.gris}}>€</span>
          </div>
        </div>
        <div style={{height:8,background:C.pale,borderRadius:10,overflow:"hidden",marginBottom:".3rem"}}>
          <div style={{height:"100%",background:pctCA()>=100?C.vert:C.rose,width:pctCA()+"%",borderRadius:10,transition:"width .4s"}}/>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:".62rem",color:C.gris}}>
          <span>CA équipe : {Math.max(0,(parseFloat(obj.ca)||0)-(parseFloat(obj.caPerso)||0))}€</span>
          <span style={{fontWeight:700,color:pctCA()>=100?C.vert:C.rose}}>{pctCA()}%</span>
        </div>
        {pctCA()>=100&&<div style={{textAlign:"center",fontSize:".75rem",color:C.vert,fontWeight:700,marginTop:".4rem"}}>🎉 Objectif CA atteint !</div>}

        {/* Recrues */}
        {recrutementOuvert&&(
          <div style={{marginTop:".75rem",paddingTop:".6rem",borderTop:`1px solid ${C.pale}`}}>
            <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas,marginBottom:".4rem"}}>👥 Recrues</div>
            <div style={{display:"flex",gap:".5rem"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem"}}>Objectif</div>
                <input type="number" placeholder="0" value={obj.recruesObj||""} onChange={e=>save({...obj,recruesObj:e.target.value})}
                  style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".38rem .55rem",fontSize:".82rem",fontFamily:"inherit",color:C.brun,background:C.creme,outline:"none",fontWeight:600}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem"}}>Réalisé</div>
                <input type="number" placeholder="0" value={obj.recruesReal||""} onChange={e=>checkAndCelebrate({...obj,recruesReal:e.target.value})}
                  style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".38rem .55rem",fontSize:".82rem",fontFamily:"inherit",color:C.brun,background:C.creme,outline:"none",fontWeight:600}}/>
              </div>
            </div>
            <div style={{height:6,background:C.pale,borderRadius:10,overflow:"hidden",marginTop:".4rem"}}>
              <div style={{height:"100%",background:pctR()>=100?C.vert:C.lilas,width:pctR()+"%",borderRadius:10}}/>
            </div>
            <button onClick={()=>{setRecrutementOuvert(false);save({...obj,recruesObj:"0",recruesReal:""});}}
              style={{marginTop:".4rem",background:"none",border:"none",color:C.gris,fontSize:".64rem",fontFamily:"inherit",cursor:"pointer",textDecoration:"underline"}}>
              Retirer cet objectif
            </button>
          </div>
        )}
        {!recrutementOuvert&&(
          <button onClick={()=>{setRecrutementOuvert(true);save({...obj,recruesObj:"1"});}} style={{marginTop:".5rem",background:"none",border:`1px dashed ${C.pale}`,borderRadius:8,padding:".35rem .65rem",fontSize:".68rem",color:C.gris,fontFamily:"inherit",cursor:"pointer",width:"100%"}}>
            + Ajouter un objectif recrutement
          </button>
        )}
      </div>

      {/* 5. CALCUL DU RESTE */}
      <div id="decouverte-reste"><ResteCalculateur obj={obj} save={save} uid={uid} distributeurs={distributeurs}/></div>

      {/* 6. GRAPHIQUES CÔTE À CÔTE */}
      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem",marginBottom:".75rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".6rem"}}>
            <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris}}>📈 Évolution</div>
            <button onClick={enregistrerPoint} style={{background:C.lilas,color:"white",border:"none",borderRadius:7,padding:".22rem .55rem",fontSize:".62rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>+ Point</button>
          </div>
          <div style={{display:"flex",gap:".5rem"}}>
            {historique.length>=2?(<>
              <MiniGraph data={histoPeriodes.slice(-12)} dataKey="ca" color={C.brun} label="💰 CA total" onClick={()=>setGraphEnGros("ca")}/>
            <MiniGraph data={histoPeriodes.slice(-12)} dataKey="caPerso" color={C.rose} label="🛍️ Ventes perso" onClick={()=>setGraphEnGros("caPerso")}/>
            <MiniGraph data={histoPeriodes.slice(-12)} dataKey="recrues" color={C.lilas} label="👥 Recrues" onClick={()=>setGraphEnGros("recruesReal")}/>
            </>):(
              <div style={{textAlign:"center",padding:"1rem .5rem",fontSize:".72rem",color:C.gris,lineHeight:1.6}}>
                Reviens ici une fois que tu auras enregistre au moins 2 periodes pour voir tes graphiques d'evolution.
              </div>
            )}
          </div>
          <div style={{fontSize:".58rem",color:C.pale,textAlign:"center",marginTop:".4rem"}}>Clique sur un graphique pour l'agrandir</div>
        </div>

      {/* 7. PRIMES DE QUALIFICATION */}
      <PrimesAccordeon obj={obj} save={save} onPrimeValidee={()=>setFireworksTrigger(t=>t+1)}/>
    </div>
  );
}

// ── GESTION MEMBRES (Melissa uniquement) ─────────────────────────────────────
export function MembresTab({uid}){
  const isMelissa=uid==="melissa"||uid==="melissa-da-silveira";
  const[membres,setMembres]=useState([]);
  const[chefs,setChefs]=useState([]);
  const[newMembre,setNewMembre]=useState({prenom:"",nom:""});
  const[loading,setLoading]=useState(true);
  const[saving,setSaving]=useState(false);
  const[search,setSearch]=useState("");
  const[annuaire,setAnnuaire]=useState({});

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"acces","membres"));
        if(snap.exists()){
          const data=snap.data();
          setMembres(Array.isArray(data.liste)?data.liste:Object.values(data.liste||{}));
          setChefs(Array.isArray(data.chefs)?data.chefs:Object.values(data.chefs||{}));
        }
        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        setAnnuaire(annSnap.exists()?annSnap.data().membres||{}:{});
      }catch{}
      setLoading(false);
    })();
  },[]);

  // Assigne/modifie la marraine d'un membre directement depuis l'admin
  const assignerMarraine=async(membreFullName, marraineFullName)=>{
    const membreUid = membreFullName.toLowerCase().replace(/\s+/g,"-");
    const marraineUid = marraineFullName ? marraineFullName.toLowerCase().replace(/\s+/g,"-") : "";
    try{
      const ref=doc(db,"equipe","annuaire");
      const existing = annuaire[membreUid] || {uid:membreUid, prenom:"", nom:"", dateEnreg:todayLocalStr()};
      const updated = {...existing, marraine:marraineUid||null};
      const nextAnnuaire = {...annuaire, [membreUid]:updated};
      setAnnuaire(nextAnnuaire);
      await setDoc(ref, {membres:{[membreUid]:updated}}, {merge:true});
      if(marraineUid) await setDoc(doc(db,"users",membreUid),{marraine:marraineUid},{merge:true});
    }catch{}
  };

  const saveAll=async(liste,chefsList)=>{
    setSaving(true);
    try{await setDoc(doc(db,"acces","membres"),{liste,chefs:chefsList},{merge:true});}catch{}
    setSaving(false);
  };

  const add=async()=>{
    if(!newMembre.prenom.trim()||!newMembre.nom.trim())return;
    const full=`${newMembre.prenom.trim().toLowerCase()} ${newMembre.nom.trim().toLowerCase()}`;
    const listeActuelle=Array.isArray(membres)?membres:[];
    if(listeActuelle.includes(full))return;
    const next=[...listeActuelle,full];
    setMembres(next);
    await saveAll(next,Array.isArray(chefs)?chefs:[]);
    setNewMembre({prenom:"",nom:""});
  };

  const remove=async(m)=>{
    if(!window.confirm(`Supprimer l'accès de ${fmt(m)} ? Cette personne ne pourra plus se connecter.`))return;
    const nextM=membres.filter(x=>x!==m);
    const nextC=chefs.filter(x=>x!==m);
    setMembres(nextM);setChefs(nextC);
    await saveAll(nextM,nextC);
    // Bloquer aussi dans Firebase users
    try{
      const mUid=m.toLowerCase().replace(/\s+/g,"-");
      await setDoc(doc(db,"users",mUid),{accesBloqueAdmin:true},{merge:true});
    }catch{}
    try{const snapMe=await getDoc(doc(db,"users",uid));if(snapMe.exists()&&snapMe.data()["db-distributeurs"]){const distList=JSON.parse(snapMe.data()["db-distributeurs"]);const mNom=m.toLowerCase().trim();const nextD=distList.filter(d=>((d.prenom||"")+" "+(d.nom||"")).toLowerCase().trim()!==mNom);if(nextD.length!==distList.length)await setDoc(doc(db,"users",uid),{"db-distributeurs":JSON.stringify(nextD)},{merge:true});}}catch{}
  };
  const [pauses,setPauses]=useState({});
  const togglePause=async(m)=>{
    const mUid=m.toLowerCase().replace(/\s+/g,"-");
    const estPause=pauses[mUid]||false;
    const next={...pauses,[mUid]:!estPause};
    setPauses(next);
    try{
      await setDoc(doc(db,"users",mUid),{accesPause:!estPause},{merge:true});
      await setDoc(doc(db,"acces","pauses"),{[mUid]:!estPause},{merge:true});
    }catch{}
  };

  // Charger les pauses
  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"acces","pauses"));
        if(snap.exists())setPauses(snap.data());
      }catch{}
    })();
  },[]);

  const toggleChef=async(m)=>{
    const isChef=(Array.isArray(chefs)?chefs:Object.values(chefs||{})).includes(m);
    const nextC=isChef?chefs.filter(x=>x!==m):[...chefs,m];
    setChefs(nextC);
    await saveAll(membres,nextC);
  };

  const fmt=(m)=>m.split(" ").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Accès <em style={{fontStyle:"italic",color:C.rose}}>Équipe</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Gère les membres et les chefs d'équipe. Code d'accès : <strong style={{color:C.brun}}>BD-2025-FIRE</strong>
      </p>

      {/* Ajouter */}
      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".6rem"}}>➕ Ajouter un membre</div>
        <div style={{display:"flex",gap:".4rem",marginBottom:".5rem"}}>
          <input placeholder="Prénom" value={newMembre.prenom} onChange={e=>setNewMembre(p=>({...p,prenom:e.target.value}))}
            style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
          <input placeholder="Nom" value={newMembre.nom} onChange={e=>setNewMembre(p=>({...p,nom:e.target.value}))}
            onKeyDown={e=>e.key==="Enter"&&add()}
            style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
        </div>
        <button onClick={add} disabled={saving||!newMembre.prenom.trim()||!newMembre.nom.trim()}
          style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".52rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          {saving?"Sauvegarde...":"Ajouter"}
        </button>
      </div>

      {/* Barre de recherche */}
      <input placeholder="🔍 Rechercher un membre..." value={search} onChange={e=>setSearch(e.target.value)}
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .7rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".75rem",boxSizing:"border-box"}}/>

      {/* Liste */}
      <div style={{fontSize:".62rem",color:C.gris,marginBottom:".5rem"}}>
        {membres.length} membre{membres.length>1?"s":""} · {chefs.length} chef{chefs.length>1?"s":""} d'équipe
      </div>
      {membres.filter(m=>!search||m.toLowerCase().includes(search.toLowerCase())).map(m=>{
        const isChef=(Array.isArray(chefs)?chefs:Object.values(chefs||{})).includes(m);
        const mUid = m.toLowerCase().replace(/\s+/g,"-");
        const currentMarraine = annuaire[mUid]?.marraine || "";
        const currentMarraineLabel = currentMarraine ? fmt(currentMarraine) : "";
        return(
          <div key={m} style={{background:C.blanc,border:`1px solid ${isChef?C.or:C.pale}`,borderRadius:10,padding:".65rem 1rem",marginBottom:".4rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",gap:".6rem",alignItems:"center"}}>
              <div style={{width:28,height:28,borderRadius:"50%",background:isChef?C.or+"30":C.rose+"20",color:isChef?C.brun2:C.rose,fontSize:".8rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {isChef?"👑":fmt(m)[0]}
              </div>
              <div>
                <div style={{fontSize:".82rem",fontWeight:600,color:C.brun}}>{fmt(m)}</div>
                {isChef&&<div style={{fontSize:".6rem",color:C.or,fontWeight:700}}>Chef d'équipe</div>}
              </div>
            </div>
            <div style={{display:"flex",gap:".4rem"}}>
              <button onClick={()=>toggleChef(m)}
                style={{background:isChef?C.or+"20":"none",border:`1px solid ${isChef?C.or:C.pale}`,borderRadius:6,padding:".2rem .55rem",color:isChef?C.brun2:C.gris,cursor:"pointer",fontSize:".65rem",fontFamily:"inherit",fontWeight:isChef?700:400}}>
                {isChef?"👑 Chef":"→ Chef"}
              </button>
              <button onClick={()=>togglePause(m)}
                style={{background:pauses[m.toLowerCase().replace(/\s+/g,"-")]?"#FFF3CD":"none",border:`1px solid ${pauses[m.toLowerCase().replace(/\s+/g,"-")]?"#E6A817":C.pale}`,borderRadius:6,padding:".2rem .55rem",color:pauses[m.toLowerCase().replace(/\s+/g,"-")]?"#856404":C.gris,cursor:"pointer",fontSize:".65rem",fontFamily:"inherit"}}>
                {pauses[m.toLowerCase().replace(/\s+/g,"-")]?"⏸️ En pause":"⏸️"}
              </button>
              <button onClick={()=>remove(m)}
                style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:6,padding:".2rem .55rem",color:"#B04040",cursor:"pointer",fontSize:".7rem",fontFamily:"inherit"}}>
                ✕
              </button>
            </div>
          </div>
          {/* Marraine */}
          <div style={{marginTop:".5rem",paddingTop:".5rem",borderTop:`1px solid ${C.creme}`,display:"flex",alignItems:"center",gap:".5rem"}}>
            <span style={{fontSize:".64rem",color:C.gris,flexShrink:0}}>🌸 Marraine :</span>
            <div style={{flex:1}}>
              <SearchSelect
                value={currentMarraineLabel ? currentMarraineLabel.toLowerCase() : ""}
                onChange={(val)=>assignerMarraine(m, val)}
                options={["melissa da silveira", ...membres.filter(x=>x.toLowerCase()!==m.toLowerCase())]}
                placeholder="🔍 Aucune — tape pour assigner" compact/>
            </div>
            {currentMarraine&&(
              <button onClick={()=>assignerMarraine(m,"")}
                style={{background:"none",border:"none",color:C.gris,cursor:"pointer",fontSize:".62rem",fontFamily:"inherit",textDecoration:"underline",flexShrink:0}}>
                retirer
              </button>
            )}
          </div>
        </div>
        );
      })}
      {membres.length===0&&(
        <div style={{textAlign:"center",padding:"1.5rem",color:C.gris,fontSize:".76rem"}}>Aucun membre ajouté.</div>
      )}
      <div style={{background:"rgba(196,74,26,.08)",border:"1px solid rgba(196,74,26,.2)",borderRadius:10,padding:".7rem 1rem",marginTop:"1rem",fontSize:".73rem",color:C.brun,lineHeight:1.6}}>
        💡 Clique sur <strong>"→ Chef"</strong> pour promouvoir une fille chef d'équipe. Elle pourra voir les objectifs des filles qui l'ont choisie à leur inscription.
      </div>
    </div>
  );
}

// ── MON ÉQUIPE (chefs d'équipe) ───────────────────────────────────────────────
// Carte stats d'un membre (réutilisée dans MonEquipeTab et le navigateur d'équipe)
export function MembreStatsCard({m, expanded, onToggleExpand}){
  const pct=(r,o)=>{if(!o||!r)return 0;return Math.min(100,Math.round(+r/+o*100));};
  const hist = m.historique || [];
  const compCA = comparaisonPeriode(hist, m.ca, "ca");
  const compR = comparaisonPeriode(hist, m.recruesReal, "recruesReal");
  const[extra,setExtra]=useState(null);
  const[loadingExtra,setLoadingExtra]=useState(false);
  const fmt=(id)=>id.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  // Charge les données complètes depuis Firebase quand on ouvre la fiche
  useEffect(()=>{
    if(!expanded||!m.uid)return;
    setLoadingExtra(true);
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",m.uid));
        let liensReseaux=[];
        try{
          const linkSnap=await getDoc(doc(db,"linkbio",m.uid));
          if(linkSnap.exists()){
            const lb=linkSnap.data();
            const labels=lb.liensBonusLabel||[];
            const urls=lb.liensBonusUrl||[];
            liensReseaux=labels.map((lbl,i)=>({label:lbl,url:urls[i]})).filter(l=>l.label&&l.url);
          }
        }catch{}
        if(snap.exists()){
          const d=snap.data();
          setExtra({
            streak:+d["db-streak"]||0,
            lastLogin:d["db-last-login"]||null,
            actions:d["db-actions"]?JSON.parse(d["db-actions"]):{},
            totalCA:+d["db-actions-cumul"]||0,
            recrues:d["recrues"]?JSON.parse(d["recrues"]):[],
            badges:d["db-badges-unlocked"]?JSON.parse(d["db-badges-unlocked"]):[],
            notes:d["db-distributeurs-notes"]||"",
            fastStart:d["db-fast-start"]?JSON.parse(d["db-fast-start"]):null,
            liensReseaux,
          });
        }
      }catch{}
      setLoadingExtra(false);
    })();
  },[expanded,m.uid]);

  const today=todayLocalStr();
  const yesterday=new Date(Date.now()-86400000).toISOString().slice(0,10);

  return(
    <div>
      {/* ── RÉSUMÉ RAPIDE ── */}
      {[
        {label:"💰 CA",val:m.ca,goal:m.caObj,unit:"€",color:C.rose},
        {label:"👥 Recrues",val:m.recruesReal,goal:m.recruesObj,unit:"",color:C.lilas},
      ].map(({label,val,goal,unit,color})=>(
        <div key={label} style={{marginBottom:".5rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:".72rem",color:C.texte,marginBottom:".2rem"}}>
            <span style={{fontWeight:600}}>{label}</span>
            <span style={{color:pct(val,goal)>=100?C.vert:color,fontWeight:700}}>{val||"—"}{unit} / {goal||"—"}{unit} · {pct(val,goal)}%</span>
          </div>
          <div style={{height:5,background:C.pale,borderRadius:10,overflow:"hidden"}}>
            <div style={{height:"100%",background:pct(val,goal)>=100?C.vert:color,width:pct(val,goal)+"%",borderRadius:10,transition:"width .4s"}}/>
          </div>
        </div>
      ))}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:".35rem",fontSize:".7rem",color:C.gris}}>
        <span>Palier visé</span>
        <span style={{fontWeight:700,color:C.or}}>{m.palier||"2%"}</span>
      </div>

      {(compCA||compR)&&(
        <div style={{display:"flex",gap:".6rem",marginTop:".5rem",flexWrap:"wrap"}}>
          {compCA&&<span style={{fontSize:".64rem",color:compCA.diff>=0?C.vert:"#B04040"}}>{compCA.diff>=0?"📈":"📉"} CA {compCA.diff>=0?"+":""}{compCA.diff}€ vs avant</span>}
          {compR&&<span style={{fontSize:".64rem",color:compR.diff>=0?C.vert:"#B04040"}}>{compR.diff>=0?"📈":"📉"} Recrues {compR.diff>=0?"+":""}{compR.diff} vs avant</span>}
        </div>
      )}

      <button onClick={onToggleExpand}
        style={{width:"100%",background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".3rem",fontSize:".66rem",color:C.gris,fontFamily:"inherit",cursor:"pointer",marginTop:".5rem"}}>
        {expanded?"▲ Masquer la fiche complète":"▼ Voir la fiche complète"}
      </button>

      {/* ── FICHE COMPLÈTE ── */}
      {expanded&&(
        <div style={{marginTop:".6rem",paddingTop:".6rem",borderTop:`1px solid ${C.pale}`}}>
          {loadingExtra&&<div style={{textAlign:"center",fontSize:".72rem",color:C.gris,padding:".5rem"}}>Chargement...</div>}

          {extra&&(
            <div>
              {/* Connexion & Streak */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".4rem",marginBottom:".75rem"}}>
                <div style={{background:C.creme,borderRadius:9,padding:".5rem",textAlign:"center"}}>
                  <div style={{fontSize:".58rem",color:C.gris,marginBottom:".15rem"}}>🔥 Streak</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:700,color:extra.streak>=5?C.or:C.brun}}>{extra.streak}j</div>
                </div>
                <div style={{background:C.creme,borderRadius:9,padding:".5rem",textAlign:"center"}}>
                  <div style={{fontSize:".58rem",color:C.gris,marginBottom:".15rem"}}>📅 Connexion</div>
                  <div style={{fontSize:".62rem",fontWeight:700,color:extra.lastLogin===today?C.vert:extra.lastLogin===yesterday?C.or:"#C0504D"}}>
                    {extra.lastLogin===today?"Aujourd'hui":extra.lastLogin===yesterday?"Hier":extra.lastLogin?new Date(extra.lastLogin).toLocaleDateString("fr-FR",{day:"numeric",month:"short"}):"Jamais"}
                  </div>
                </div>
                <div style={{background:C.creme,borderRadius:9,padding:".5rem",textAlign:"center"}}>
                  <div style={{fontSize:".58rem",color:C.gris,marginBottom:".15rem"}}>⚡ Actions/j</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:700,color:C.brun}}>
                    {Object.values(extra.actions).filter(Boolean).length}/5
                  </div>
                </div>
              </div>

              {/* Barre actions du jour */}
              <div style={{marginBottom:".75rem"}}>
                <div style={{fontSize:".6rem",color:C.gris,marginBottom:".3rem"}}>Actions du jour</div>
                <div style={{display:"flex",gap:"3px"}}>
                  {Array.from({length:5}).map((_,i)=>(
                    <div key={i} style={{flex:1,height:6,borderRadius:3,background:i<Object.values(extra.actions).filter(Boolean).length?C.rose:C.pale}}/>
                  ))}
                </div>
              </div>

              {/* Objectifs détaillés */}
              <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:10,padding:".75rem",marginBottom:".75rem"}}>
                <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.or,marginBottom:".5rem"}}>🎯 Objectifs période</div>
                {[
                  {label:"💰 CA",val:m.ca,goal:m.caObj,unit:"€",color:C.rose},
                  {label:"👥 Recrues",val:m.recruesReal,goal:m.recruesObj,unit:"",color:C.lilas},
                ].map(({label,val,goal,unit,color})=>{
                  const p=pct(val,goal);
                  return(
                    <div key={label} style={{marginBottom:".5rem"}}>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:".68rem",color:C.pale,marginBottom:".2rem"}}>
                        <span>{label}</span>
                        <span style={{fontWeight:700,color:p>=100?C.vert:color}}>{val||0}{unit} / {goal||"—"}{unit} · {p}%</span>
                      </div>
                      <div style={{height:5,background:"rgba(255,255,255,.1)",borderRadius:10,overflow:"hidden"}}>
                        <div style={{height:"100%",background:p>=100?C.vert:color,width:p+"%",borderRadius:10}}/>
                      </div>
                    </div>
                  );
                })}
                <div style={{display:"flex",justifyContent:"space-between",fontSize:".68rem",color:C.pale,marginTop:".3rem"}}>
                  <span>Palier visé</span>
                  <span style={{fontWeight:700,color:C.or}}>{m.palier||"2%"}</span>
                </div>
              </div>

              {/* Recrues en suivi */}
              {extra.recrues.length>0&&(
                <div style={{background:C.creme,borderRadius:9,padding:".65rem",marginBottom:".75rem"}}>
                  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.lilas,marginBottom:".4rem"}}>
                    📋 Recrues en suivi ({extra.recrues.length})
                  </div>
                  {extra.recrues.map(r=>{
                    const{pct:p}=getProgress(r);
                    return(
                      <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:".3rem 0",borderBottom:`1px solid ${C.pale}`,fontSize:".7rem"}}>
                        <span style={{color:C.brun,fontWeight:600}}>{r.name}</span>
                        <span style={{color:p>=100?C.vert:C.rose,fontWeight:700}}>{p}%</span>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Fast Start — interface identique à la formation */}
              {extra.fastStart&&(
                <div style={{marginBottom:".75rem"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".6rem"}}>
                    <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose}}>🚀 Suivi Fast Start</div>
                    <div style={{fontSize:".62rem",color:C.gris}}>
                      J1 : {extra.fastStart.startDate?new Date(extra.fastStart.startDate).toLocaleDateString("fr-FR",{day:"numeric",month:"short"}):"—"}
                    </div>
                  </div>

                  {/* Progression globale */}
                  {(()=>{
                    const totalTaches=FAST_START_DAYS.reduce((s,d2)=>s+d2.taches.length,0);
                    const done=FAST_START_DAYS.reduce((s,d2)=>s+d2.taches.filter((_,i)=>extra.fastStart.doneTasks?.[`${d2.jour}-${i}`]).length,0);
                    const modulesValides=Object.values(extra.fastStart.modulesValides||{}).filter(Boolean).length;
                    const p=Math.round(done/totalTaches*100);
                    return(
                      <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:10,padding:".6rem .85rem",marginBottom:".6rem"}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:".3rem"}}>
                          <span style={{fontSize:".65rem",color:C.or,fontWeight:700}}>Progression globale</span>
                          <span style={{fontSize:".65rem",color:C.pale}}>{modulesValides}/7 modules validés</span>
                        </div>
                        <div style={{height:6,background:"rgba(255,255,255,.2)",borderRadius:10,overflow:"hidden",marginBottom:".2rem"}}>
                          <div style={{height:"100%",background:p>=100?C.vert:C.or,width:p+"%",borderRadius:10,transition:"width .5s"}}/>
                        </div>
                        <div style={{fontSize:".6rem",color:C.pale}}>{done}/{totalTaches} tâches · {p}%</div>
                      </div>
                    );
                  })()}

                  {/* Modules détaillés — même interface que FastStartTab */}
                  {FAST_START_DAYS.map(d2=>{
                    const moduleValide=extra.fastStart.modulesValides?.[d2.jour];
                    const prevValide=d2.jour===1?true:!!extra.fastStart.modulesValides?.[d2.jour-1];
                    const isLocked=!prevValide&&!moduleValide;
                    const tachesDone=d2.taches.filter((_,i)=>extra.fastStart.doneTasks?.[`${d2.jour}-${i}`]).length;
                    const total=d2.taches.length;
                    const dayDone=tachesDone===total;
                    return(
                      <div key={d2.jour} style={{background:moduleValide?C.vert+"08":C.blanc,border:`1.5px solid ${moduleValide?C.vert:dayDone?C.vert+"60":isLocked?C.pale:C.rose}`,borderRadius:12,padding:".75rem .9rem",marginBottom:".5rem",opacity:isLocked?.5:1}}>
                        <div style={{display:"flex",alignItems:"center",gap:".6rem",marginBottom:dayDone?".4rem":0}}>
                          <div style={{width:28,height:28,borderRadius:"50%",background:moduleValide?C.vert:isLocked?C.pale:C.rose,color:"white",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".75rem",fontWeight:700,flexShrink:0}}>
                            {moduleValide?"✓":isLocked?"🔒":d2.jour}
                          </div>
                          <div style={{flex:1}}>
                            <div style={{fontSize:".75rem",fontWeight:700,color:moduleValide?C.vert:isLocked?C.gris:C.brun}}>{d2.titre}</div>
                            <div style={{height:3,background:C.pale,borderRadius:10,overflow:"hidden",marginTop:".25rem"}}>
                              <div style={{height:"100%",background:moduleValide?C.vert:C.rose,width:(tachesDone/total*100)+"%",borderRadius:10}}/>
                            </div>
                          </div>
                          <div style={{fontSize:".65rem",fontWeight:700,color:moduleValide?C.vert:C.gris,flexShrink:0}}>
                            {moduleValide?"✅ Validé":isLocked?"Verrouillé":`${tachesDone}/${total}`}
                          </div>
                        </div>

                        {/* Tâches détaillées */}
                        {!isLocked&&(
                          <div style={{paddingLeft:".5rem"}}>
                            {d2.taches.map((tache,i)=>{
                              const done2=!!extra.fastStart.doneTasks?.[`${d2.jour}-${i}`];
                              const txt=typeof tache==="string"?tache:tache.t;
                              return(
                                <div key={i} style={{display:"flex",alignItems:"flex-start",gap:".45rem",padding:".25rem 0",borderBottom:i<d2.taches.length-1?`1px solid ${C.pale}30`:"none"}}>
                                  <div style={{width:16,height:16,borderRadius:4,border:`2px solid ${done2?C.vert:C.pale}`,background:done2?C.vert:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:".1rem"}}>
                                    {done2&&<span style={{color:"white",fontSize:".55rem",fontWeight:700}}>✓</span>}
                                  </div>
                                  <span style={{fontSize:".7rem",color:done2?C.vert:C.texte,textDecoration:done2?"line-through":"none",lineHeight:1.5}}>{txt}</span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {!extra.fastStart&&(
                <div style={{background:C.creme,borderRadius:9,padding:".65rem",marginBottom:".75rem",textAlign:"center"}}>
                  <div style={{fontSize:".72rem",color:C.gris,marginBottom:".4rem"}}>🚀 Pas encore de Fast Start assigné</div>
                </div>
              )}

              {/* Liens réseaux sociaux — toujours visible */}
              <LiensReseauxSection memberUid={m.uid}/>

              {/* Badges */}
              {extra.badges.length>0&&(
                <div style={{marginBottom:".75rem"}}>
                  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris,marginBottom:".4rem"}}>🏅 Badges débloqués</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:".3rem"}}>
                    {BADGES_DEF.filter(b=>extra.badges.includes(b.id)).map(b=>(
                      <div key={b.id} title={b.desc} style={{background:C.or+"20",border:`1px solid ${C.or}40`,borderRadius:8,padding:".3rem .5rem",fontSize:".65rem",color:C.brun,fontWeight:600}}>
                        {b.icon} {b.label}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Courbes historique */}
              {hist.length>=2&&(
                <>
                  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.gris,marginBottom:".3rem"}}>📈 CA</div>
                  <MiniChart data={hist} dataKey="ca" objKey="caObj" color={C.rose} unit="€"/>
                  <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.gris,marginBottom:".3rem",marginTop:".6rem"}}>📈 Recrues</div>
                  <MiniChart data={hist} dataKey="recruesReal" objKey="recruesObj" color={C.lilas}/>
                </>
              )}
              {hist.length<2&&<div style={{fontSize:".68rem",color:C.gris,textAlign:"center"}}>Pas encore d'historique pour cette personne.</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// Onglet "Assiduité équipe" — visible chefs/Melissa : connexions + actions du jour de chaque membre
const TODAY_ACTIONS_COUNT = 5;

export function AssiduiteTab({uid}){
  const[loading,setLoading]=useState(true);
  const[isAuthorized,setIsAuthorized]=useState(false);
  const[membres,setMembres]=useState([]);
  const[search,setSearch]=useState("");

  const fmtUid=(u)=>u.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  useEffect(()=>{
    (async()=>{
      try{
        const isMelissa = uid==="melissa"||uid==="melissa-da-silveira";
        const accesSnap=await getDoc(doc(db,"acces","membres"));
        const chefs=accesSnap.exists()?accesSnap.data().chefs||[]:[];
        const isChef = isMelissa || (Array.isArray(chefs)?chefs:Object.values(chefs||{})).includes(uid.replace(/-/g," "));
        if(!isChef){ setIsAuthorized(false); setLoading(false); return; }
        setIsAuthorized(true);

        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        const annuaire = annSnap.exists()?annSnap.data().membres||{}:{};

        // Détermine la liste des uids à afficher : toute l'équipe (Melissa) ou la descendance (chef)
        let targetUids;
        if(isMelissa){
          targetUids = Object.keys(annuaire);
        } else {
          const visited=new Set();
          const queue=[uid];
          while(queue.length){
            const current=queue.pop();
            Object.values(annuaire).forEach(m=>{
              if(m.marraine===current && !visited.has(m.uid)){
                visited.add(m.uid);
                queue.push(m.uid);
              }
            });
          }
          targetUids = [...visited];
        }

        // Charge les données d'assiduité de chaque membre
        const periodeNum = getPeriodeActuelle();
        const periodeKey = `p${periodeNum}`;
        const debutPeriode = getPeriodeDebut(periodeNum);
        const joursDansLaPeriode = Math.min(
          Math.floor((Date.now()-debutPeriode.getTime())/(1000*60*60*24))+1, 21
        );

        const results = await Promise.all(targetUids.map(async(mUid)=>{
          try{
            const snap=await getDoc(doc(db,"users",mUid));
            if(!snap.exists())return {uid:mUid, noData:true};
            const data=snap.data();
            const actionsRaw = data["db-actions"] ? JSON.parse(data["db-actions"]) : {};
            const todayStr = todayLocalStr();
            const isToday = actionsRaw._date === todayStr;
            const {_date, ...actionsSeules} = actionsRaw;
            const doneToday = isToday ? Object.values(actionsSeules).filter(Boolean).length : 0;
            const assiduite = data["db-assiduite"] ? JSON.parse(data["db-assiduite"]) : {};
            const joursActifs = assiduite[periodeKey]?.jours?.length || 0;
            return {
              uid:mUid,
              lastLogin: data["db-last-login"]||null,
              streak: +data["db-streak"]||0,
              doneToday,
              joursActifs,
              joursDansLaPeriode,
              periodeNum,
              noData:false,
            };
          }catch{ return {uid:mUid, noData:true}; }
        }));

        // Tri : streak décroissant, puis nom
        results.sort((a,b)=> (b.streak||0)-(a.streak||0) || a.uid.localeCompare(b.uid));
        setMembres(results);
      }catch{}
      setLoading(false);
    })();
  },[uid]);

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  if(!isAuthorized)return(
    <div style={{textAlign:"center",padding:"3rem 1rem",color:C.gris}}>
      <div style={{fontSize:"2rem",marginBottom:".75rem"}}>👑</div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",color:C.brun,marginBottom:".4rem"}}>Accès chef d'équipe</div>
      <div style={{fontSize:".75rem",lineHeight:1.6}}>Cet espace est réservé aux chefs d'équipe.<br/>Melissa peut te promouvoir depuis son espace.</div>
    </div>
  );

  const today=todayLocalStr();
  const yesterday=new Date(Date.now()-86400000).toISOString().slice(0,10);

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Assiduité <em style={{fontStyle:"italic",color:C.rose}}>Équipe</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Connexions, actions du jour et score de la période P{membres[0]?.periodeNum||""} · {membres.length} membre{membres.length>1?"s":""}.
      </p>

      <input placeholder="🔍 Rechercher un membre..." value={search} onChange={e=>setSearch(e.target.value)}
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .7rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".75rem",boxSizing:"border-box"}}/>

      {membres.filter(m=>!search||fmtUid(m.uid).toLowerCase().includes(search.toLowerCase())).length===0&&(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".76rem"}}>{membres.length===0?"Aucune donnée d'équipe pour l'instant.":"Aucun membre ne correspond à la recherche."}</div>
      )}

      {membres.filter(m=>!search||fmtUid(m.uid).toLowerCase().includes(search.toLowerCase())).map(m=>{
        const connectedToday = m.lastLogin===today;
        const connectedYesterday = m.lastLogin===yesterday;
        let statusColor, statusLabel;
        if(m.noData||!m.lastLogin){ statusColor=C.gris; statusLabel="Jamais connectée"; }
        else if(connectedToday){ statusColor=C.vert; statusLabel="Connectée aujourd'hui"; }
        else if(connectedYesterday){ statusColor=C.or; statusLabel="Connectée hier"; }
        else { statusColor="#C0504D"; statusLabel=`Dernière connexion : ${new Date(m.lastLogin).toLocaleDateString("fr-FR")}`; }

        const doneToday = m.noData ? 0 : Math.min(m.doneToday, TODAY_ACTIONS_COUNT);
        const joursActifs = m.joursActifs||0;
        const joursDispo = m.joursDansLaPeriode||1;
        const scorePct = Math.round(joursActifs/joursDispo*100);

        return(
          <div key={m.uid} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".7rem 1rem",marginBottom:".5rem"}}>
            <div style={{display:"flex",gap:".6rem",alignItems:"center"}}>
              <div style={{width:34,height:34,borderRadius:"50%",background:statusColor+"20",color:statusColor,fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,position:"relative"}}>
                {fmtUid(m.uid)[0]}
                <div style={{position:"absolute",bottom:-2,right:-2,width:10,height:10,borderRadius:"50%",background:statusColor,border:`2px solid ${C.blanc}`}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,color:C.brun}}>{fmtUid(m.uid)}</div>
                <div style={{fontSize:".62rem",color:statusColor}}>{statusLabel}</div>
              </div>
              {!m.noData&&(
                <div style={{textAlign:"right",flexShrink:0}}>
                  {m.streak>=2&&<div style={{fontSize:".68rem",fontWeight:700,color:C.or}}>🔥 {m.streak}j</div>}
                  <div style={{fontSize:".64rem",color:C.gris}}>Aujourd'hui : {doneToday}/{TODAY_ACTIONS_COUNT}</div>
                  {/* Score période */}
                  <div style={{fontSize:".68rem",fontWeight:700,color:scorePct>=80?C.vert:scorePct>=50?C.or:"#C0504D",marginTop:".1rem"}}>
                    📈 {joursActifs}/{joursDispo}j
                  </div>
                </div>
              )}
            </div>

            {!m.noData&&(
              <div style={{marginTop:".5rem"}}>
                <div style={{display:"flex",gap:"3px",marginBottom:".35rem"}}>
                  {Array.from({length:TODAY_ACTIONS_COUNT}).map((_,i)=>(
                    <div key={i} style={{flex:1,height:5,borderRadius:3,background:i<doneToday?C.rose:C.pale}}/>
                  ))}
                </div>
                <div style={{display:"flex",alignItems:"center",gap:".4rem"}}>
                  <span style={{fontSize:".58rem",color:C.gris,flexShrink:0}}>P{m.periodeNum} :</span>
                  <div style={{flex:1,height:5,background:C.pale,borderRadius:10,overflow:"hidden"}}>
                    <div style={{height:"100%",background:scorePct>=80?C.vert:scorePct>=50?C.or:"#C0504D",width:scorePct+"%",borderRadius:10}}/>
                  </div>
                  <span style={{fontSize:".6rem",fontWeight:700,color:scorePct>=80?C.vert:scorePct>=50?C.or:"#C0504D",flexShrink:0}}>{joursActifs}/{joursDispo}j</span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// Onglet "Suivi Formation" — visible chefs/Melissa : consultation, completion, temps passe par membre
function formatDureeFormation(secondes){
  if(!secondes)return "0 min";
  const mins=Math.round(secondes/60);
  if(mins<60)return mins+" min";
  const h=Math.floor(mins/60);
  const m=mins%60;
  return h+"h"+(m>0?String(m).padStart(2,"0"):"");
}

export function SuiviFormationTab({uid}){
  const[loading,setLoading]=useState(true);
  const[isAuthorized,setIsAuthorized]=useState(false);
  const[membres,setMembres]=useState([]);
  const[search,setSearch]=useState("");
  const[expandedUid,setExpandedUid]=useState(null);
  const[vue,setVue]=useState("global"); // global | membres

  const fmtUid=(u)=>u.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  useEffect(()=>{
    (async()=>{
      try{
        const isMelissa = uid==="melissa"||uid==="melissa-da-silveira";
        const accesSnap=await getDoc(doc(db,"acces","membres"));
        const chefs=accesSnap.exists()?accesSnap.data().chefs||[]:[];
        const isChef = isMelissa || (Array.isArray(chefs)?chefs:Object.values(chefs||{})).includes(uid.replace(/-/g," "));
        if(!isChef){ setIsAuthorized(false); setLoading(false); return; }
        setIsAuthorized(true);

        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        const annuaire = annSnap.exists()?annSnap.data().membres||{}:{};

        let targetUids;
        if(isMelissa){
          targetUids = Object.keys(annuaire);
        } else {
          const visited=new Set();
          const queue=[uid];
          while(queue.length){
            const current=queue.pop();
            Object.values(annuaire).forEach(m=>{
              if(m.marraine===current && !visited.has(m.uid)){
                visited.add(m.uid);
                queue.push(m.uid);
              }
            });
          }
          targetUids = [...visited];
        }

        const results = await Promise.all(targetUids.map(async(mUid)=>{
          try{
            const data=await sgAll(mUid);
            const progress=data["db-formation-progress"]?JSON.parse(data["db-formation-progress"]):{};
            return {uid:mUid, nom:annuaire[mUid]?.nom||fmtUid(mUid), progress};
          }catch{return {uid:mUid, nom:fmtUid(mUid), progress:{}};}
        }));
        results.sort((a,b)=>a.nom.localeCompare(b.nom));
        setMembres(results);
      }catch(e){console.error(e);}
      setLoading(false);
    })();
  },[uid]);

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".78rem"}}>Chargement...</div>;
  if(!isAuthorized)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".78rem"}}>Accès réservé aux cheffes d'équipe.</div>;

  const membresFiltres=membres.filter(m=>m.nom.toLowerCase().includes(search.toLowerCase()));
  const totalMembres=membres.length;

  // Agrégats globaux par formation (sur l'ensemble de l'équipe visible)
  const agregats=FORMATION_SUBTABS_SUIVIES.map(subTab=>{
    const nbConsultees=membres.filter(m=>m.progress[subTab]?.nbConsultations>0).length;
    const nbTerminees=membres.filter(m=>m.progress[subTab]?.termine).length;
    const tempsTotal=membres.reduce((s,m)=>s+(m.progress[subTab]?.tempsTotalSecondes||0),0);
    const tempsMoyen=nbConsultees>0?Math.round(tempsTotal/nbConsultees):0;
    return {subTab,nbConsultees,nbTerminees,tempsMoyen};
  });
  const nomsNonTermines=(subTab)=>membres.filter(m=>!m.progress[subTab]?.termine).map(m=>m.nom);

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>🎓 Suivi Formation</div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.6}}>Vue d'ensemble de l'engagement de ton équipe sur les formations ({totalMembres} membre{totalMembres>1?"s":""}).</p>

      <div style={{display:"flex",gap:".4rem",marginBottom:"1.1rem"}}>
        <button onClick={()=>setVue("global")} style={{flex:1,background:vue==="global"?C.rose:"white",color:vue==="global"?"white":C.brun,border:`1.5px solid ${C.rose}`,borderRadius:10,padding:".55rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>📊 Vue globale équipe</button>
        <button onClick={()=>setVue("membres")} style={{flex:1,background:vue==="membres"?C.rose:"white",color:vue==="membres"?"white":C.brun,border:`1.5px solid ${C.rose}`,borderRadius:10,padding:".55rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>👤 Par membre</button>
      </div>

      {vue==="global"&&(
        <div>
          {totalMembres===0&&(
            <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Aucun membre dans l'équipe pour l'instant.</div>
          )}
          {agregats.map(a=>{
            const pctTermine=totalMembres>0?Math.round((a.nbTerminees/totalMembres)*100):0;
            const pctConsulte=totalMembres>0?Math.round((a.nbConsultees/totalMembres)*100):0;
            const enRetard=nomsNonTermines(a.subTab);
            return(
              <div key={a.subTab} style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:".9rem 1rem",marginBottom:".65rem"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".5rem"}}>
                  <div style={{fontSize:".82rem",fontWeight:700,color:C.brun}}>{FORMATION_SUBTABS_LABELS[a.subTab]}</div>
                  <div style={{fontSize:".72rem",fontWeight:700,color:pctTermine>=80?C.vert:pctTermine>=40?C.or:"#C0504D"}}>{a.nbTerminees}/{totalMembres} terminé{a.nbTerminees>1?"s":""}</div>
                </div>
                <div style={{height:7,background:C.pale,borderRadius:10,overflow:"hidden",marginBottom:".45rem"}}>
                  <div style={{height:"100%",width:pctTermine+"%",background:pctTermine>=80?C.vert:pctTermine>=40?C.or:"#C0504D",borderRadius:10}}/>
                </div>
                <div style={{fontSize:".68rem",color:C.gris,display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:".3rem"}}>
                  <span>{pctConsulte}% ont consulté · {pctTermine}% ont terminé</span>
                  <span>Temps moyen : {formatDureeFormation(a.tempsMoyen)}</span>
                </div>
                {enRetard.length>0&&enRetard.length<=totalMembres&&(
                  <div style={{marginTop:".5rem",fontSize:".66rem",color:"#B04040",lineHeight:1.5}}>
                    <span style={{fontWeight:700}}>Pas encore terminé : </span>{enRetard.join(", ")}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {vue==="membres"&&(<>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Rechercher un membre..."
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .8rem",fontSize:".8rem",fontFamily:"inherit",marginBottom:"1rem",outline:"none"}}/>

        {membresFiltres.map(m=>{
          const nbTerminees=FORMATION_SUBTABS_SUIVIES.filter(s=>m.progress[s]?.termine).length;
          const nbConsultees=FORMATION_SUBTABS_SUIVIES.filter(s=>m.progress[s]?.nbConsultations>0).length;
          const tempsTotal=FORMATION_SUBTABS_SUIVIES.reduce((s,k)=>s+(m.progress[k]?.tempsTotalSecondes||0),0);
          const expanded=expandedUid===m.uid;
          return(
            <div key={m.uid} style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem 1rem",marginBottom:".6rem"}}>
              <div onClick={()=>setExpandedUid(expanded?null:m.uid)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
                <div>
                  <div style={{fontSize:".85rem",fontWeight:700,color:C.brun}}>{m.nom}</div>
                  <div style={{fontSize:".65rem",color:C.gris,marginTop:".15rem"}}>
                    {nbTerminees}/{FORMATION_SUBTABS_SUIVIES.length} terminées · {nbConsultees}/{FORMATION_SUBTABS_SUIVIES.length} consultées · {formatDureeFormation(tempsTotal)} au total
                  </div>
                </div>
                <span style={{color:C.pale}}>{expanded?"▲":"▼"}</span>
              </div>
              {expanded&&(
                <div style={{marginTop:".75rem",paddingTop:".75rem",borderTop:`1px solid ${C.pale}`,display:"flex",flexDirection:"column",gap:".4rem"}}>
                  {FORMATION_SUBTABS_SUIVIES.map(subTab=>{
                    const p=m.progress[subTab]||{};
                    const statut=p.termine?"✅":p.nbConsultations>0?"🔵":"⚪";
                    return(
                      <div key={subTab} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:".72rem"}}>
                        <div style={{color:C.texte}}>{statut} {FORMATION_SUBTABS_LABELS[subTab]}</div>
                        <div style={{color:C.gris,fontSize:".68rem"}}>
                          {p.nbConsultations>0?`${p.nbConsultations} vue${p.nbConsultations>1?"s":""} · ${formatDureeFormation(p.tempsTotalSecondes)}`:"Non consultée"}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        {membresFiltres.length===0&&(
          <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Aucun membre trouvé.</div>
        )}
      </>)}
    </div>
  );
}

// Onglet "Maintenance" — actions ponctuelles de correction, reservees a Melissa
export function MaintenanceTab({uid}){
  const[loading,setLoading]=useState(false);
  const[resultat,setResultat]=useState(null);
  const[confirmation,setConfirmation]=useState(false);
  const[loading2,setLoading2]=useState(false);
  const[resultat2,setResultat2]=useState(null);
  const[confirmation2,setConfirmation2]=useState(false);
  const[loading3,setLoading3]=useState(false);
  const[resultat3,setResultat3]=useState(null);
  const[confirmation3,setConfirmation3]=useState(false);

  const activerBoutiquePourTous=async()=>{
    setLoading3(true);
    setResultat3(null);
    try{
      const snap=await getDocs(collection(db,"linkbio"));
      let nbActives=0;
      let nbDejaActives=0;
      for(const d of snap.docs){
        const data=d.data();
        if(!data.boutiqueActive){
          await setDoc(doc(db,"linkbio",d.id),{boutiqueActive:true},{merge:true});
          nbActives++;
        }else{
          nbDejaActives++;
        }
      }
      setResultat3({nbActives,nbDejaActives,total:snap.docs.length});
    }catch(e){
      setResultat3({erreur:e.message});
    }
    setLoading3(false);
    setConfirmation3(false);
  };

  const ONGLETS_FORMATION_APP=["formationapp","formationchef","dashboard","outils","fa-dashboard-general","fa-objectifs","fa-clients","fa-distributeurs","fa-prospects"];

  const viderVideosFormationApp=async()=>{
    setLoading2(true);
    setResultat2(null);
    try{
      const ref=doc(db,"admin","contenus");
      const snap=await getDoc(ref);
      const items=snap.exists()?(snap.data().items||[]):[];
      let nbVides=0;
      const nextItems=items.map(item=>{
        if(ONGLETS_FORMATION_APP.includes(item.onglet)&&item.url){
          nbVides++;
          return {...item, url:""};
        }
        return item;
      });
      await setDoc(ref,{items:nextItems},{merge:true});
      setResultat2({nbVides});
    }catch(e){
      setResultat2({erreur:e.message});
    }
    setLoading2(false);
    setConfirmation2(false);
  };

  const nettoyerObjectifsEquipe=async()=>{
    setLoading(true);
    setResultat(null);
    try{
      const annSnap=await getDoc(doc(db,"equipe","annuaire"));
      const annuaire = annSnap.exists()?annSnap.data().membres||{}:{};
      const tousUids = [...new Set([...Object.keys(annuaire), uid])];
      const periodeCourante=getPeriodeActuelle();
      let nbCorriges=0;
      let nbIgnores=0;

      for(const mUid of tousUids){
        try{
          const data=await sgAll(mUid);
          const objRaw=data["db-obj-perso"];
          if(!objRaw){ nbIgnores++; continue; }
          const obj=JSON.parse(objRaw);
          const nextObj={...obj, ca:"", caPerso:"", caEquipe:"", recruesReal:"0", caObj:"", recruesObj:"", palier:"2%", objectifsPosesPeriode:"", nbDirecteurs:0, caDirecteurs:{}, dirSelectionnes:{}};
          await ss(mUid,"db-obj-perso",JSON.stringify(nextObj));
          await ss(mUid,"last_periode",periodeCourante);
          nbCorriges++;
        }catch(e){ console.error("Erreur pour",mUid,e); nbIgnores++; }
      }
      setResultat({nbCorriges, nbIgnores, total:tousUids.length});
    }catch(e){
      setResultat({erreur:e.message});
    }
    setLoading(false);
    setConfirmation(false);
  };

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>🧹 Maintenance</div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1.2rem",lineHeight:1.6}}>Actions ponctuelles de correction. À utiliser uniquement quand un bug de ce type est confirmé — pas une action à faire régulièrement.</p>

      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem",paddingLeft:".2rem"}}>🎯 Objectifs & Suivi CA</div>
      <div style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem"}}>
        <div style={{fontSize:".85rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>Réinitialiser les objectifs chiffrés de toute l'équipe</div>
        <p style={{fontSize:".72rem",color:C.gris,marginBottom:".8rem",lineHeight:1.6}}>
          Vide le CA cible, le palier, l'objectif de recrues <strong>et</strong> le CA/recrues déjà réalisés sur la période, pour chaque membre de l'équipe (sans toucher à l'historique des périodes passées). À utiliser en tout début de nouvelle période si la remise à zéro automatique n'a pas fonctionné.
        </p>
        {!confirmation?(
          <button onClick={()=>setConfirmation(true)} disabled={loading}
            style={{width:"100%",background:"#C44B1A",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Réinitialiser les objectifs de toute l'équipe
          </button>
        ):(
          <div>
            <div style={{fontSize:".76rem",color:"#C44B1A",fontWeight:700,marginBottom:".6rem"}}>⚠️ Cette action est irréversible. Confirmer ?</div>
            <div style={{display:"flex",gap:".5rem"}}>
              <button onClick={nettoyerObjectifsEquipe} disabled={loading}
                style={{flex:1,background:"#C44B1A",color:"white",border:"none",borderRadius:10,padding:".65rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                {loading?"En cours...":"Oui, confirmer"}
              </button>
              <button onClick={()=>setConfirmation(false)} disabled={loading}
                style={{flex:1,background:"white",color:C.gris,border:`1.5px solid ${C.pale}`,borderRadius:10,padding:".65rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                Annuler
              </button>
            </div>
          </div>
        )}
        {resultat&&(
          <div style={{marginTop:".9rem",padding:".7rem",background:resultat.erreur?"#FFF3F0":"#E8F5E9",borderRadius:8,fontSize:".76rem",color:resultat.erreur?"#C44B1A":"#2D5A3D"}}>
            {resultat.erreur?("Erreur : "+resultat.erreur):(`✅ ${resultat.nbCorriges} membre(s) corrigé(s) sur ${resultat.total} (${resultat.nbIgnores} sans objectifs à corriger).`)}
          </div>
        )}
      </div>

      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem",marginTop:"1.3rem",paddingLeft:".2rem"}}>🎬 Formation</div>
      <div style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem"}}>
        <div style={{fontSize:".85rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>Vider les liens vidéo de Formation App</div>
        <p style={{fontSize:".72rem",color:C.gris,marginBottom:".8rem",lineHeight:1.6}}>
          Retire tous les liens vidéo (Formation Chef, Tableau de bord et ses sous-sections, Outils généraux), en gardant les titres et descriptions intacts — pratique avant de tout réenregistrer.
        </p>
        {!confirmation2?(
          <button onClick={()=>setConfirmation2(true)} disabled={loading2}
            style={{width:"100%",background:"#8B1A1A",color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Vider les liens vidéo Formation App
          </button>
        ):(
          <div>
            <div style={{fontSize:".76rem",color:"#8B1A1A",fontWeight:700,marginBottom:".6rem"}}>⚠️ Cette action est irréversible. Confirmer ?</div>
            <div style={{display:"flex",gap:".5rem"}}>
              <button onClick={viderVideosFormationApp} disabled={loading2}
                style={{flex:1,background:"#8B1A1A",color:"white",border:"none",borderRadius:10,padding:".65rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                {loading2?"En cours...":"Oui, confirmer"}
              </button>
              <button onClick={()=>setConfirmation2(false)} disabled={loading2}
                style={{flex:1,background:"white",color:C.gris,border:`1.5px solid ${C.pale}`,borderRadius:10,padding:".65rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                Annuler
              </button>
            </div>
          </div>
        )}
        {resultat2&&(
          <div style={{marginTop:".9rem",padding:".7rem",background:resultat2.erreur?"#FFF3F0":"#E8F5E9",borderRadius:8,fontSize:".76rem",color:resultat2.erreur?"#C44B1A":"#2D5A3D"}}>
            {resultat2.erreur?("Erreur : "+resultat2.erreur):(`✅ ${resultat2.nbVides} lien(s) vidéo vidé(s). Les titres restent en place, prêts pour tes nouveaux liens.`)}
          </div>
        )}
      </div>

      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem",marginTop:"1.3rem",paddingLeft:".2rem"}}>🛍️ Boutique</div>
      <div style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem"}}>
        <div style={{fontSize:".85rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>Activer la boutique pour toute l'équipe</div>
        <p style={{fontSize:".72rem",color:C.gris,marginBottom:".8rem",lineHeight:1.6}}>
          Active la boutique en ligne (visible sur le LinkBio) pour <strong>chaque membre</strong> de l'équipe d'un coup, y compris celles qui ne l'ont jamais activée elles-mêmes. Chacune devra ensuite renseigner son propre lien PayPal.me/Stripe pour pouvoir réellement encaisser.
        </p>
        {!confirmation3?(
          <button onClick={()=>setConfirmation3(true)} disabled={loading3}
            style={{width:"100%",background:C.brun,color:"white",border:"none",borderRadius:10,padding:".7rem",fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
            Activer la boutique pour tout le monde
          </button>
        ):(
          <div>
            <div style={{fontSize:".76rem",color:"#8B1A1A",fontWeight:700,marginBottom:".6rem"}}>⚠️ Ça va activer la boutique pour toute l'équipe. Confirmer ?</div>
            <div style={{display:"flex",gap:".5rem"}}>
              <button onClick={activerBoutiquePourTous} disabled={loading3}
                style={{flex:1,background:C.brun,color:"white",border:"none",borderRadius:10,padding:".65rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                {loading3?"En cours...":"Oui, confirmer"}
              </button>
              <button onClick={()=>setConfirmation3(false)} disabled={loading3}
                style={{flex:1,background:"white",color:C.gris,border:`1.5px solid ${C.pale}`,borderRadius:10,padding:".65rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                Annuler
              </button>
            </div>
          </div>
        )}
        {resultat3&&(
          <div style={{marginTop:".9rem",padding:".7rem",background:resultat3.erreur?"#FFF3F0":"#E8F5E9",borderRadius:8,fontSize:".76rem",color:resultat3.erreur?"#C44B1A":"#2D5A3D"}}>
            {resultat3.erreur?("Erreur : "+resultat3.erreur):(`✅ Boutique activée pour ${resultat3.nbActives} personne(s) (${resultat3.nbDejaActives} l'avaient déjà, sur ${resultat3.total} au total).`)}
          </div>
        )}
      </div>
    </div>
  );
}


export function LiensImportantsTab({uid}){
  const[loaded,setLoaded]=useState(false);
  const[slug,setSlug]=useState(uid);
  const[boutiqueActive,setBoutiqueActive]=useState(false);
  const[liensPerso,setLiensPerso]=useState([]);
  const[nouveauLabel,setNouveauLabel]=useState("");
  const[nouveauUrl,setNouveauUrl]=useState("");
  const[copie,setCopie]=useState("");
  const[liensTelegram,setLiensTelegram]=useState([]);
  const[nvLabelTg,setNvLabelTg]=useState("");
  const[nvUrlTg,setNvUrlTg]=useState("");
  const isMelissa=uid==="melissa"||uid==="melissa-da-silveira";

  useEffect(()=>{
    (async()=>{
      try{
        const snapLink=await getDoc(doc(db,"linkbio",uid));
        if(snapLink.exists()){
          const d=snapLink.data();
          setSlug(d.slug||uid);
          setBoutiqueActive(!!d.boutiqueActive);
        }
      }catch{}
      try{
        const snapU=await getDoc(doc(db,"users",uid));
        if(snapU.exists()&&snapU.data()["db-liens-perso"]){
          setLiensPerso(JSON.parse(snapU.data()["db-liens-perso"]));
        }
      }catch{}
      setLiensTelegram(await chargerLiensTelegramEquipe());
      setLoaded(true);
    })();
  },[uid]);

  const ajouterLienTelegram=async()=>{
    if(!nvLabelTg.trim()||!nvUrlTg.trim())return;
    let url=nvUrlTg.trim();
    if(!/^https?:\/\//i.test(url))url="https://"+url;
    const nouvelleListe=[...liensTelegram,{id:"tg"+Date.now(),label:nvLabelTg.trim(),url}];
    setLiensTelegram(nouvelleListe);
    await sauverLiensTelegramEquipe(nouvelleListe);
    setNvLabelTg("");setNvUrlTg("");
  };
  const supprimerLienTelegram=async(id)=>{
    const nouvelleListe=liensTelegram.filter(l=>l.id!==id);
    setLiensTelegram(nouvelleListe);
    await sauverLiensTelegramEquipe(nouvelleListe);
  };

  const sauverLiensPerso=async(next)=>{
    setLiensPerso(next);
    try{await setDoc(doc(db,"users",uid),{"db-liens-perso":JSON.stringify(next)},{merge:true});}catch{}
  };

  const ajouterLien=()=>{
    if(!nouveauLabel.trim()||!nouveauUrl.trim())return;
    let url=nouveauUrl.trim();
    if(!/^https?:\/\//i.test(url))url="https://"+url;
    sauverLiensPerso([...liensPerso,{id:"lien"+Date.now(),label:nouveauLabel.trim(),url}]);
    setNouveauLabel("");setNouveauUrl("");
  };
  const supprimerLien=(id)=>sauverLiensPerso(liensPerso.filter(l=>l.id!==id));

  const copierLien=async(url,cle)=>{
    const succes=await copierTexteRobuste(url);
    if(succes){setCopie(cle);setTimeout(()=>setCopie(""),2000);}
    else{setCopie(cle+"-erreur");setTimeout(()=>setCopie(""),2500);}
  };

  const base="https://blazing-dinasty-1fad9.web.app";
  const lienLinkBio=`${base}?bio=${slug}`;
  const lienBoutique=`${base}?boutique=${slug}`;

  if(!loaded)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Liens <em style={{fontStyle:"italic",color:C.rose}}>importants</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1.2rem",lineHeight:1.65}}>
        Tous tes liens essentiels, réunis au même endroit — prêts à copier et partager.
      </p>

      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".6rem",display:"flex",justifyContent:"space-between",alignItems:"center",gap:".6rem"}}>
        <div style={{minWidth:0,flex:1}}>
          <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>🔗 Mon Link-in-Bio</div>
          <div style={{fontSize:".68rem",color:C.gris,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lienLinkBio}</div>
        </div>
        <button onClick={()=>copierLien(lienLinkBio,"bio")}
          style={{background:copie==="bio"?"#2E7D32":C.rose,color:"white",border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
          {copie==="bio"?"✅ Copié":"📋 Copier"}
        </button>
      </div>

      <div style={{marginTop:"1.4rem",marginBottom:".6rem",background:"#FDF0ED",border:"1.5px solid #D84A3A50",borderRadius:14,padding:"1rem 1.1rem"}}>
        <div style={{fontSize:".68rem",fontWeight:700,color:"#C4341F",letterSpacing:".08em",textTransform:"uppercase",marginBottom:".6rem"}}>📱 Liens Telegram de l'équipe</div>
        {liensTelegram.length===0?(
          <div style={{fontSize:".76rem",color:C.gris,fontStyle:"italic",padding:".4rem 0"}}>Aucun lien Telegram pour l'instant.</div>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:".5rem"}}>
            {liensTelegram.map(l=>(
              <div key={l.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".7rem .85rem",display:"flex",alignItems:"center",gap:".6rem"}}>
                <div style={{minWidth:0,flex:1}}>
                  <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>💬 {l.label}</div>
                  <div style={{fontSize:".68rem",color:C.gris,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l.url}</div>
                </div>
                <a href={l.url} target="_blank" rel="noopener noreferrer"
                  style={{background:"#2AABEE",color:"white",border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0,textDecoration:"none"}}>
                  Ouvrir
                </a>
                <button onClick={()=>copierLien(l.url,l.id)}
                  style={{background:copie===l.id?"#2E7D32":C.rose,color:"white",border:"none",borderRadius:8,padding:".4rem .55rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
                  {copie===l.id?"✅":"📋"}
                </button>
                {isMelissa&&(
                  <button onClick={()=>supprimerLienTelegram(l.id)}
                    style={{background:"none",border:"none",color:"#B04040",fontSize:".85rem",cursor:"pointer",padding:"0 .2rem",flexShrink:0}}>✕</button>
                )}
              </div>
            ))}
          </div>
        )}
        {isMelissa&&(
          <div style={{display:"flex",gap:".4rem",marginTop:".6rem"}}>
            <input value={nvLabelTg} onChange={e=>setNvLabelTg(e.target.value)} placeholder="Nom (ex: Groupe Équipe)"
              style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .6rem",fontSize:".74rem",fontFamily:"inherit",outline:"none"}}/>
            <input value={nvUrlTg} onChange={e=>setNvUrlTg(e.target.value)} placeholder="Lien t.me/..."
              style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .6rem",fontSize:".74rem",fontFamily:"inherit",outline:"none"}}/>
            <button onClick={ajouterLienTelegram} disabled={!nvLabelTg.trim()||!nvUrlTg.trim()}
              style={{background:(nvLabelTg.trim()&&nvUrlTg.trim())?C.brun:C.pale,color:"white",border:"none",borderRadius:8,padding:".5rem .8rem",fontSize:".74rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
              +
            </button>
          </div>
        )}
      </div>

      {boutiqueActive&&(
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".6rem",display:"flex",justifyContent:"space-between",alignItems:"center",gap:".6rem"}}>
          <div style={{minWidth:0,flex:1}}>
            <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>🛍️ Ma Boutique en ligne</div>
            <div style={{fontSize:".68rem",color:C.gris,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lienBoutique}</div>
          </div>
          <button onClick={()=>copierLien(lienBoutique,"boutique")}
            style={{background:copie==="boutique"?"#2E7D32":C.rose,color:"white",border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
            {copie==="boutique"?"✅ Copié":"📋 Copier"}
          </button>
        </div>
      )}

      {liensPerso.length>0&&(
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.rose,margin:"1rem 0 .5rem"}}>Mes liens personnalisés</div>
      )}
      {liensPerso.map(l=>(
        <div key={l.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".6rem",display:"flex",justifyContent:"space-between",alignItems:"center",gap:".6rem"}}>
          <div style={{minWidth:0,flex:1}}>
            <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>{l.label}</div>
            <div style={{fontSize:".68rem",color:C.gris,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l.url}</div>
          </div>
          <button onClick={()=>copierLien(l.url,l.id)}
            style={{background:copie===l.id?"#2E7D32":C.rose,color:"white",border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".72rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
            {copie===l.id?"✅ Copié":"📋 Copier"}
          </button>
          <button onClick={()=>supprimerLien(l.id)}
            style={{background:"none",border:"none",color:"#C0504D",fontSize:".8rem",cursor:"pointer",flexShrink:0}}>🗑️</button>
        </div>
      ))}

      <div style={{background:C.creme,border:`1px dashed ${C.pale}`,borderRadius:12,padding:".9rem 1rem",marginTop:"1rem"}}>
        <div style={{fontSize:".74rem",fontWeight:700,color:C.brun,marginBottom:".5rem"}}>➕ Ajouter un lien</div>
        <input value={nouveauLabel} onChange={e=>setNouveauLabel(e.target.value)} placeholder="Nom du lien (ex: Mon groupe Facebook)"
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".4rem",outline:"none"}}/>
        <input value={nouveauUrl} onChange={e=>setNouveauUrl(e.target.value)} placeholder="Lien (ex: facebook.com/groups/...)"
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",marginBottom:".5rem",outline:"none"}}/>
        <button onClick={ajouterLien} disabled={!nouveauLabel.trim()||!nouveauUrl.trim()}
          style={{width:"100%",background:(nouveauLabel.trim()&&nouveauUrl.trim())?C.brun:C.pale,color:(nouveauLabel.trim()&&nouveauUrl.trim())?"white":C.gris,border:"none",borderRadius:8,padding:".55rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          Ajouter ce lien
        </button>
      </div>
    </div>
  );
}

export function SuiviReseauxTab({uid}){
  const[historique,setHistorique]=useState([]);
  const[loaded,setLoaded]=useState(false);
  const[saving,setSaving]=useState(false);
  const[form,setForm]=useState({
    fbFollowers:"",fbSuivis:"",
    igFollowers:"",igSuivis:"",
    ttFollowers:"",ttSuivis:"",
  });

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",uid));
        if(snap.exists()&&snap.data()["db-suivi-reseaux"]){
          setHistorique(JSON.parse(snap.data()["db-suivi-reseaux"]));
        }
      }catch{}
      setLoaded(true);
    })();
  },[uid]);

  const ajouterEntree=async()=>{
    const nb=(v)=>parseInt(v)||0;
    const entree={
      date:new Date().toISOString().slice(0,10),
      ts:Date.now(),
      facebook:{followers:nb(form.fbFollowers),suivis:nb(form.fbSuivis)},
      instagram:{followers:nb(form.igFollowers),suivis:nb(form.igSuivis)},
      tiktok:{followers:nb(form.ttFollowers),suivis:nb(form.ttSuivis)},
    };
    setSaving(true);
    try{
      const next=[entree,...historique];
      await setDoc(doc(db,"users",uid),{"db-suivi-reseaux":JSON.stringify(next)},{merge:true});
      setHistorique(next);
      setForm({fbFollowers:"",fbSuivis:"",igFollowers:"",igSuivis:"",ttFollowers:"",ttSuivis:""});
    }catch(e){alert("Erreur : "+e.message);}
    setSaving(false);
  };

  const supprimerEntree=async(ts)=>{
    const next=historique.filter(h=>h.ts!==ts);
    try{
      await setDoc(doc(db,"users",uid),{"db-suivi-reseaux":JSON.stringify(next)},{merge:true});
      setHistorique(next);
    }catch{}
  };

  const PLATEFORMES=[
    {key:"facebook",icon:"📘",label:"Facebook",color:"#1877F2",champFollowers:"fbFollowers",champSuivis:"fbSuivis"},
    {key:"instagram",icon:"📸",label:"Instagram",color:"#C13584",champFollowers:"igFollowers",champSuivis:"igSuivis"},
    {key:"tiktok",icon:"🎵",label:"TikTok",color:"#000000",champFollowers:"ttFollowers",champSuivis:"ttSuivis"},
  ];

  const[platformeGraph,setPlatformeGraph]=useState("facebook");

  const derniere=historique[0];
  const precedente=historique[1];
  const delta=(plateforme,champ)=>{
    if(!derniere||!precedente)return null;
    return derniere[plateforme][champ]-precedente[plateforme][champ];
  };

  if(!loaded)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Suivi <em style={{fontStyle:"italic",color:C.rose}}>Réseaux</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1.2rem",lineHeight:1.65}}>
        Enregistre régulièrement tes chiffres pour suivre ta progression sur Facebook, Instagram et TikTok.
      </p>

      {derniere&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".5rem",marginBottom:"1.2rem"}}>
          {PLATEFORMES.map(p=>(
            <div key={p.key} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".7rem .5rem",textAlign:"center"}}>
              <div style={{fontSize:"1.1rem",marginBottom:".2rem"}}>{p.icon}</div>
              <div style={{fontSize:".62rem",color:C.gris,fontWeight:600,marginBottom:".3rem"}}>{p.label}</div>
              <div style={{fontSize:"1.05rem",fontWeight:700,color:C.brun}}>{derniere[p.key].followers.toLocaleString()}</div>
              <div style={{fontSize:".6rem",color:C.gris}}>abonnés</div>
              {delta(p.key,"followers")!==null&&delta(p.key,"followers")!==0&&(
                <div style={{fontSize:".62rem",fontWeight:700,color:delta(p.key,"followers")>0?"#2D5A3D":"#C0504D",marginTop:".2rem"}}>
                  {delta(p.key,"followers")>0?"+":""}{delta(p.key,"followers")}
                </div>
              )}
              <div style={{fontSize:".68rem",color:C.gris,marginTop:".4rem"}}>{derniere[p.key].suivis.toLocaleString()} suivis</div>
            </div>
          ))}
        </div>
      )}

      {historique.length>=2&&(
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.2rem"}}>
          <div style={{display:"flex",gap:".4rem",marginBottom:"1rem"}}>
            {PLATEFORMES.map(p=>(
              <button key={p.key} onClick={()=>setPlatformeGraph(p.key)}
                style={{flex:1,padding:".4rem",fontSize:".7rem",fontWeight:700,borderRadius:8,border:`1.5px solid ${platformeGraph===p.key?p.color:C.pale}`,background:platformeGraph===p.key?p.color:C.blanc,color:platformeGraph===p.key?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                {p.icon} {p.label}
              </button>
            ))}
          </div>
          {(()=>{
            const donnees=[...historique].reverse();
            const valeurs=donnees.map(h=>h[platformeGraph].followers);
            const maxV=Math.max(...valeurs,1);
            const minV=Math.min(...valeurs,0);
            const ecart=maxV-minV||1;
            const largeur=560, hauteur=140, marge=10;
            const pointX=(i)=>marge+(i/(Math.max(donnees.length-1,1)))*(largeur-2*marge);
            const pointY=(v)=>hauteur-marge-((v-minV)/ecart)*(hauteur-2*marge);
            const couleur=PLATEFORMES.find(p=>p.key===platformeGraph).color;
            const pathD=valeurs.map((v,i)=>`${i===0?"M":"L"} ${pointX(i)} ${pointY(v)}`).join(" ");
            const aireD=`${pathD} L ${pointX(valeurs.length-1)} ${hauteur-marge} L ${pointX(0)} ${hauteur-marge} Z`;
            return(
              <svg viewBox={`0 0 ${largeur} ${hauteur}`} style={{width:"100%",height:140,overflow:"visible"}}>
                <path d={aireD} fill={couleur} opacity=".08"/>
                <path d={pathD} fill="none" stroke={couleur} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round"/>
                {valeurs.map((v,i)=>(
                  <circle key={i} cx={pointX(i)} cy={pointY(v)} r="3.5" fill={couleur}/>
                ))}
                {valeurs.map((v,i)=>(
                  (i===0||i===valeurs.length-1)&&
                  <text key={"t"+i} x={pointX(i)} y={pointY(v)-10} fontSize="11" fontWeight="700" fill={couleur} textAnchor={i===0?"start":"end"}>{v.toLocaleString()}</text>
                ))}
              </svg>
            );
          })()}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:".62rem",color:C.gris,marginTop:".3rem"}}>
            <span>{new Date(historique[historique.length-1].date).toLocaleDateString("fr-FR",{day:"2-digit",month:"short"})}</span>
            <span>{new Date(historique[0].date).toLocaleDateString("fr-FR",{day:"2-digit",month:"short"})}</span>
          </div>
        </div>
      )}

      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.2rem"}}>
        <div style={{fontSize:".78rem",fontWeight:700,color:C.brun,marginBottom:".7rem"}}>➕ Nouvelle entrée — {new Date().toLocaleDateString("fr-FR")}</div>
        {PLATEFORMES.map(p=>(
          <div key={p.key} style={{marginBottom:".6rem"}}>
            <div style={{fontSize:".7rem",fontWeight:600,color:p.color,marginBottom:".3rem"}}>{p.icon} {p.label}</div>
            <div style={{display:"flex",gap:".5rem"}}>
              <input value={form[p.champFollowers]} onChange={e=>setForm(f=>({...f,[p.champFollowers]:e.target.value.replace(/\D/g,"")}))} placeholder="Nb abonnés" type="text" inputMode="numeric"
                style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem .6rem",fontSize:".78rem",fontFamily:"inherit",outline:"none"}}/>
              <input value={form[p.champSuivis]} onChange={e=>setForm(f=>({...f,[p.champSuivis]:e.target.value.replace(/\D/g,"")}))} placeholder="Nb suivis" type="text" inputMode="numeric"
                style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".45rem .6rem",fontSize:".78rem",fontFamily:"inherit",outline:"none"}}/>
            </div>
          </div>
        ))}
        <button onClick={ajouterEntree} disabled={saving}
          style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginTop:".4rem"}}>
          {saving?"...":"Enregistrer cette entrée"}
        </button>
      </div>

      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem"}}>Historique</div>
      {historique.length===0?(
        <div style={{textAlign:"center",padding:"1.5rem",color:C.gris,fontSize:".78rem"}}>Aucune entrée pour l'instant — ajoute la première ci-dessus !</div>
      ):(
        historique.map(h=>(
          <div key={h.ts} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:10,padding:".65rem .8rem",marginBottom:".4rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:".72rem",fontWeight:700,color:C.brun,marginBottom:".2rem"}}>{new Date(h.date).toLocaleDateString("fr-FR",{day:"2-digit",month:"short",year:"numeric"})}</div>
              <div style={{fontSize:".66rem",color:C.gris}}>
                📘 {h.facebook.followers.toLocaleString()} · 📸 {h.instagram.followers.toLocaleString()} · 🎵 {h.tiktok.followers.toLocaleString()}
              </div>
            </div>
            <button onClick={()=>supprimerEntree(h.ts)} style={{background:"none",border:"none",color:"#C0504D",fontSize:".68rem",cursor:"pointer"}}>🗑️</button>
          </div>
        ))
      )}
    </div>
  );
}

export function SuiviBoutiqueEquipeTab(){
  const[loading,setLoading]=useState(true);
  const[donnees,setDonnees]=useState([]);
  const[detailOuvertPour,setDetailOuvertPour]=useState(null);
  const fmtUid=(u)=>u.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  const numeroSemaine=(d)=>{
    const date=new Date(d);
    const jan1=new Date(date.getFullYear(),0,1);
    const jours=Math.floor((date-jan1)/86400000);
    return `S${Math.ceil((jours+jan1.getDay()+1)/7)}-${date.getFullYear()}`;
  };
  const cleMois=(d)=>{
    const date=new Date(d);
    return `${["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"][date.getMonth()]} ${date.getFullYear()}`;
  };

  const[diagnostic,setDiagnostic]=useState(null);
  const[recherche,setRecherche]=useState("");

  useEffect(()=>{
    (async()=>{
      try{
        const accesSnap=await getDoc(doc(db,"acces","membres"));
        const rawListe=accesSnap.exists()?accesSnap.data().liste:null;
        const liste=accesSnap.exists()?(Array.isArray(rawListe)?rawListe:Object.values(rawListe||{})):[];
        setDiagnostic({
          docExiste:accesSnap.exists(),
          typeListe:Array.isArray(rawListe)?"array":typeof rawListe,
          nbEntreesBrutes:liste.length,
          exempleEntree:liste[0]?JSON.stringify(liste[0]).slice(0,200):"aucune",
        });
        const uidsDepuisListe=liste.map(m=>{
          if(typeof m==="string")return m.trim().toLowerCase().replace(/\s+/g,"-");
          return m.uid||null;
        }).filter(Boolean);
        const uids=[...new Set([...uidsDepuisListe,"melissa-da-silveira"])];

        const resultats=await Promise.all(uids.map(async(memberUid)=>{
          let boutiqueActive=false;
          let nomAffiche=fmtUid(memberUid);
          try{
            let linkSnap=await getDoc(doc(db,"linkbio",memberUid));
            if(!linkSnap.exists()){
              // Certains comptes ont un identifiant different entre acces/membres et linkbio (ex: melissa / melissa-da-silveira)
              const alias=memberUid==="melissa"?"melissa-da-silveira":(memberUid==="melissa-da-silveira"?"melissa":null);
              if(alias)linkSnap=await getDoc(doc(db,"linkbio",alias));
            }
            if(linkSnap.exists()){
              boutiqueActive=!!linkSnap.data().boutiqueActive;
              if(linkSnap.data().prenom)nomAffiche=linkSnap.data().prenom+(linkSnap.data().nom?" "+linkSnap.data().nom:"");
            }
          }catch{}

          let commandes=[];
          let paiementConfigure=false;
          try{
            const userSnap=await getDoc(doc(db,"users",memberUid));
            if(userSnap.exists()){
              paiementConfigure=!!(userSnap.data()["db-lien-paypalme"]||userSnap.data()["db-lien-stripe-perso"]);
            }
            if(userSnap.exists()&&userSnap.data()["db-clients"]){
              const clients=JSON.parse(userSnap.data()["db-clients"]);
              clients.forEach(c=>(c.commandes||[]).forEach(cmd=>{
                if(cmd.source==="boutique-en-ligne")commandes.push({date:cmd.date,montant:cmd.montant||0});
              }));
            }
          }catch{}

          const parSemaine={};
          const parMois={};
          commandes.forEach(cmd=>{
            const sKey=numeroSemaine(cmd.date);
            const mKey=cleMois(cmd.date);
            parSemaine[sKey]=(parSemaine[sKey]||0)+cmd.montant;
            parMois[mKey]=(parMois[mKey]||0)+cmd.montant;
          });

          const semaineActuelleKey=numeroSemaine(new Date());
          const moisActuelKey=cleMois(new Date());

          return {
            uid:memberUid, nom:nomAffiche, boutiqueActive, paiementConfigure,
            caSemaine:parSemaine[semaineActuelleKey]||0,
            caMois:parMois[moisActuelKey]||0,
            historiqueSemaines:Object.entries(parSemaine).sort((a,b)=>b[0]<a[0]?-1:1).slice(0,8),
            historiqueMois:Object.entries(parMois).sort((a,b)=>b[0]<a[0]?-1:1).slice(0,6),
            totalCommandes:commandes.length,
          };
        }));

        resultats.sort((a,b)=>b.caMois-a.caMois);
        setDonnees(resultats);
      }catch(e){console.error(e);setDiagnostic(d=>({...(d||{}),erreur:e.message}));}
      setLoading(false);
    })();
  },[]);

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  const nbActives=donnees.filter(d=>d.boutiqueActive).length;
  const nbPaiementOk=donnees.filter(d=>d.paiementConfigure).length;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Suivi <em style={{fontStyle:"italic",color:C.rose}}>Boutique équipe</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Qui a activé sa boutique, et ses ventes boutique en ligne par semaine et par mois.
      </p>

      {diagnostic&&donnees.length<=1&&(
        <div style={{background:"#FFF3F0",border:"1px solid #F4C0B0",borderRadius:10,padding:".7rem .9rem",marginBottom:"1rem",fontSize:".68rem",color:"#8B1A1A",lineHeight:1.7}}>
          <strong>🔍 Diagnostic technique :</strong><br/>
          Document "acces/membres" trouvé : {diagnostic.docExiste?"oui":"non"}<br/>
          Type de la liste : {diagnostic.typeListe}<br/>
          Nombre d'entrées brutes trouvées : {diagnostic.nbEntreesBrutes}<br/>
          Exemple d'entrée : {diagnostic.exempleEntree}<br/>
          {diagnostic.erreur&&<>Erreur : {diagnostic.erreur}<br/></>}
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:"1.2rem"}}>
        <div style={{background:C.brun,borderRadius:12,padding:".85rem .5rem",color:"white",textAlign:"center"}}>
          <div style={{fontSize:"1.2rem",fontWeight:700}}>{nbActives} / {donnees.length}</div>
          <div style={{fontSize:".64rem",opacity:.85}}>ont activé leur boutique</div>
        </div>
        <div style={{background:"#8B6F47",borderRadius:12,padding:".85rem .5rem",color:"white",textAlign:"center"}}>
          <div style={{fontSize:"1.2rem",fontWeight:700}}>{nbPaiementOk} / {donnees.length}</div>
          <div style={{fontSize:".64rem",opacity:.85}}>ont configuré un paiement</div>
        </div>
      </div>

      <input value={recherche} onChange={e=>setRecherche(e.target.value)} placeholder="🔍 Rechercher une personne..."
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:10,padding:".55rem .8rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",marginBottom:".75rem"}}/>

      {donnees.filter(d=>d.nom.toLowerCase().includes(recherche.toLowerCase())).map(d=>(
        <div key={d.uid} style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".5rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:".82rem",fontWeight:700,color:C.brun}}>{d.nom}</div>
              <div style={{fontSize:".64rem",color:d.boutiqueActive?"#2D5A3D":"#B04040",fontWeight:600}}>
                {d.boutiqueActive?"✅ Boutique activée":"❌ Boutique non activée"}
              </div>
              <div style={{fontSize:".64rem",color:d.paiementConfigure?"#2D5A3D":"#C44B1A",fontWeight:600,marginTop:".1rem"}}>
                {d.paiementConfigure?"✅ Paiement configuré":"⚠️ Paiement non configuré"}
              </div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:".64rem",color:C.gris}}>Cette semaine</div>
              <div style={{fontSize:".95rem",fontWeight:700,color:C.rose}}>{d.caSemaine.toFixed(2)}€</div>
              <div style={{fontSize:".6rem",color:C.gris,marginTop:".1rem"}}>Ce mois : {d.caMois.toFixed(2)}€</div>
            </div>
          </div>
          {d.totalCommandes>0&&(
            <button onClick={()=>setDetailOuvertPour(detailOuvertPour===d.uid?null:d.uid)}
              style={{background:"none",border:"none",color:C.rose,fontSize:".64rem",fontWeight:700,cursor:"pointer",padding:0,marginTop:".4rem"}}>
              {detailOuvertPour===d.uid?"▲ Masquer l'historique":"▼ Voir l'historique"}
            </button>
          )}
          {detailOuvertPour===d.uid&&(
            <div style={{marginTop:".6rem",paddingTop:".6rem",borderTop:`1px solid ${C.pale}`}}>
              <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,marginBottom:".3rem",textTransform:"uppercase",letterSpacing:".05em"}}>Par semaine</div>
              {d.historiqueSemaines.map(([sem,montant])=>(
                <div key={sem} style={{display:"flex",justifyContent:"space-between",fontSize:".7rem",padding:".2rem 0",color:C.texte}}>
                  <span>{sem}</span><span style={{fontWeight:600}}>{montant.toFixed(2)}€</span>
                </div>
              ))}
              <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,marginTop:".5rem",marginBottom:".3rem",textTransform:"uppercase",letterSpacing:".05em"}}>Par mois</div>
              {d.historiqueMois.map(([mois,montant])=>(
                <div key={mois} style={{display:"flex",justifyContent:"space-between",fontSize:".7rem",padding:".2rem 0",color:C.texte}}>
                  <span>{mois}</span><span style={{fontWeight:600}}>{montant.toFixed(2)}€</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export const ESPACE_CHEF_SECTIONS=[
  {id:"stats",icon:"📊",label:"Statistiques équipe",desc:"Taux d'utilisation, conversion, diagnostics — chiffres pour recruter",chefOnly:true,groupe:"Suivi équipe"},
  {id:"assiduite",icon:"📋",label:"Assiduité équipe",desc:"Connexions et actions du jour de chaque membre",chefOnly:true,groupe:"Suivi équipe"},
  {id:"suiviformation",icon:"🎓",label:"Suivi Formation",desc:"Qui a consulté/terminé chaque formation, temps passé",chefOnly:true,groupe:"Suivi équipe"},
  {id:"suiviboutique",icon:"🛍️",label:"Suivi Boutique équipe",desc:"Qui a active sa boutique, ventes par semaine et par mois",chefOnly:true,groupe:"Suivi équipe"},
  {id:"challengeapp",icon:"🎮",label:"Challenge Découverte App",desc:"Progression de chaque membre dans le défi 7 jours",chefOnly:true,groupe:"Animation & Challenges"},
  {id:"actionsbiblio",icon:"💡",label:"Actions biblio",desc:"Ajouter des actions à la bibliothèque partagée de toute l'équipe",chefOnly:false,groupe:"Animation & Challenges"},
  {id:"membres",icon:"⚙️",label:"Accès équipe",desc:"Gérer les membres, chefs, et assigner les marraines",chefOnly:true,groupe:"Organisation équipe"},
  {id:"admin",icon:"🔧",label:"Administration",desc:"Gérer les contenus, citations, scripts, annonces et produits",melissaOnly:true,groupe:"Administration"},
  {id:"reclassertemoignages",icon:"📁",label:"Reclasser témoignages",desc:"Classer par thème les témoignages partagés avant l'automatisation",melissaOnly:true,groupe:"Administration"},
  {id:"maintenance",icon:"🧹",label:"Maintenance",desc:"Actions ponctuelles de correction (usage exceptionnel)",melissaOnly:true,groupe:"Administration"},
];

// ── MESSAGERIE ÉQUIPE ────────────────────────────────────────────────────────
// Popup pour envoyer un message perso ou groupé à son équipe
export function MessageEquipePopup({uid, userName, annuaire, onClose}){
  const[mode,setMode]=useState("choix"); // choix | perso | groupe
  const[destinataire,setDestinataire]=useState(null);
  const[texte,setTexte]=useState("");
  const[sending,setSending]=useState(false);
  const[sent,setSent]=useState(false);

  const fmt=(id)=>id.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  // Récupère tous les descendants directs
  const getDescendants=(rootUid)=>{
    const result=new Set();
    const queue=[rootUid];
    while(queue.length){
      const current=queue.pop();
      Object.values(annuaire).forEach(m=>{
        if(m.marraine===current&&!result.has(m.uid)){
          result.add(m.uid);
          queue.push(m.uid);
        }
      });
    }
    return [...result];
  };

  const equipe=getDescendants(uid);
  const directes=Object.values(annuaire).filter(m=>m.marraine===uid);

  const envoyerMsg=async(destinataires)=>{
    if(!texte.trim()||destinataires.length===0)return;
    setSending(true);
    const msg={
      id:`msg${Date.now()}`,
      de:uid,
      deNom:userName,
      texte:texte.trim(),
      ts:Date.now(),
      lu:false,
    };
    try{
      await Promise.all(destinataires.map(async(destUid)=>{
        const ref=doc(db,"messages",destUid);
        const snap=await getDoc(ref);
        const existing=snap.exists()?snap.data().msgs||[]:[];
        await setDoc(ref,{msgs:[msg,...existing].slice(0,100)},{merge:false});
      }));
      setSent(true);
      setTexte("");
      setTimeout(()=>{setSent(false);setMode("choix");setDestinataire(null);},2000);
    }catch{}
    setSending(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.6)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:"16px 16px 0 0",padding:"1.4rem",width:"100%",maxWidth:480,boxShadow:"0 -8px 32px rgba(0,0,0,.2)",maxHeight:"80vh",overflowY:"auto"}}>

        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>
            {mode==="choix"?"💬 Envoyer un message":mode==="groupe"?"👥 Message groupé":"💬 Message personnel"}
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:"1.2rem",color:C.gris,cursor:"pointer",padding:".2rem"}}>✕</button>
        </div>

        {/* CHOIX */}
        {mode==="choix"&&(
          <div>
            <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.6}}>
              Tu as <strong style={{color:C.brun}}>{equipe.length}</strong> personne{equipe.length>1?"s":""} dans ton équipe.
            </p>
            <div onClick={()=>setMode("groupe")}
              style={{background:C.brun,borderRadius:12,padding:"1rem",marginBottom:".6rem",cursor:"pointer",display:"flex",alignItems:"center",gap:".75rem"}}>
              <div style={{fontSize:"1.5rem"}}>👥</div>
              <div>
                <div style={{fontSize:".88rem",fontWeight:600,color:C.blanc}}>Message groupé</div>
                <div style={{fontSize:".68rem",color:C.pale}}>Envoyer à toute ton équipe ({equipe.length} personnes)</div>
              </div>
            </div>
            <div onClick={()=>setMode("perso")}
              style={{background:C.rose+"15",border:`1px solid ${C.rose}`,borderRadius:12,padding:"1rem",cursor:"pointer",display:"flex",alignItems:"center",gap:".75rem"}}>
              <div style={{fontSize:"1.5rem"}}>💌</div>
              <div>
                <div style={{fontSize:".88rem",fontWeight:600,color:C.brun}}>Message personnel</div>
                <div style={{fontSize:".68rem",color:C.gris}}>Choisir une personne spécifique</div>
              </div>
            </div>
          </div>
        )}

        {/* MESSAGE GROUPÉ */}
        {mode==="groupe"&&(
          <div>
            <button onClick={()=>setMode("choix")} style={{background:"none",border:"none",color:C.rose,fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit",padding:0,marginBottom:"1rem"}}>← Retour</button>
            <div style={{background:C.creme,borderRadius:10,padding:".7rem",marginBottom:"1rem",fontSize:".72rem",color:C.gris}}>
              📤 Sera envoyé à : <strong style={{color:C.brun}}>{equipe.map(fmt).join(", ")}</strong>
            </div>
            <textarea
              placeholder="Écris ton message ici... ex: Bravo à toutes pour cette semaine ! 🔥 On continue sur cette lancée !"
              value={texte} onChange={e=>setTexte(e.target.value)}
              style={{width:"100%",minHeight:120,border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem",fontFamily:"inherit",fontSize:".82rem",color:C.texte,background:C.blanc,resize:"vertical",outline:"none",lineHeight:1.65,marginBottom:"1rem"}}/>
            <button onClick={()=>envoyerMsg(equipe)} disabled={!texte.trim()||sending||sent}
              style={{width:"100%",background:sent?C.vert:texte.trim()?C.brun:C.pale,color:texte.trim()?C.blanc:C.gris,border:"none",borderRadius:10,padding:".7rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:texte.trim()?"pointer":"default",transition:"all .2s"}}>
              {sent?"✅ Envoyé !":sending?"Envoi...":"Envoyer à toute l'équipe →"}
            </button>
          </div>
        )}

        {/* MESSAGE PERSONNEL — CHOIX DESTINATAIRE */}
        {mode==="perso"&&!destinataire&&(
          <div>
            <button onClick={()=>setMode("choix")} style={{background:"none",border:"none",color:C.rose,fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit",padding:0,marginBottom:"1rem"}}>← Retour</button>
            <p style={{fontSize:".74rem",color:C.gris,marginBottom:".75rem"}}>Choisis la destinataire :</p>
            {equipe.map(mUid=>(
              <div key={mUid} onClick={()=>setDestinataire(mUid)}
                style={{display:"flex",alignItems:"center",gap:".65rem",background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:10,padding:".65rem .85rem",marginBottom:".4rem",cursor:"pointer"}}>
                <div style={{width:32,height:32,borderRadius:"50%",background:C.rose+"20",color:C.rose,fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {fmt(mUid)[0]}
                </div>
                <div>
                  <div style={{fontSize:".82rem",fontWeight:600,color:C.brun}}>{fmt(mUid)}</div>
                  <div style={{fontSize:".62rem",color:C.gris}}>
                    {annuaire[mUid]?.marraine===uid?"Filleule directe":"Filleule indirecte"}
                  </div>
                </div>
                <span style={{marginLeft:"auto",color:C.pale}}>›</span>
              </div>
            ))}
          </div>
        )}

        {/* MESSAGE PERSONNEL — SAISIE */}
        {mode==="perso"&&destinataire&&(
          <div>
            <button onClick={()=>setDestinataire(null)} style={{background:"none",border:"none",color:C.rose,fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit",padding:0,marginBottom:"1rem"}}>← Retour</button>
            <div style={{display:"flex",alignItems:"center",gap:".6rem",background:C.creme,borderRadius:10,padding:".65rem .85rem",marginBottom:"1rem"}}>
              <div style={{width:32,height:32,borderRadius:"50%",background:C.rose+"20",color:C.rose,fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {fmt(destinataire)[0]}
              </div>
              <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,color:C.brun}}>{fmt(destinataire)}</div>
            </div>
            <textarea
              placeholder={`Écris ton message pour ${fmt(destinataire)}...`}
              value={texte} onChange={e=>setTexte(e.target.value)}
              style={{width:"100%",minHeight:120,border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem",fontFamily:"inherit",fontSize:".82rem",color:C.texte,background:C.blanc,resize:"vertical",outline:"none",lineHeight:1.65,marginBottom:"1rem"}}/>
            <button onClick={()=>envoyerMsg([destinataire])} disabled={!texte.trim()||sending||sent}
              style={{width:"100%",background:sent?C.vert:texte.trim()?C.brun:C.pale,color:texte.trim()?C.blanc:C.gris,border:"none",borderRadius:10,padding:".7rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:texte.trim()?"pointer":"default",transition:"all .2s"}}>
              {sent?"✅ Envoyé !":sending?"Envoi...":`Envoyer à ${fmt(destinataire)} →`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// Affichage des messages reçus (popup sur le tableau de bord)
export function MessagesRecusPopup({uid, onClose}){
  const[msgs,setMsgs]=useState([]);
  const[loading,setLoading]=useState(true);
  const fmt=(id)=>id.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"messages",uid));
        if(snap.exists()) setMsgs(snap.data().msgs||[]);
      }catch{}
      setLoading(false);
    })();
  },[uid]);

  const marquerLus=async()=>{
    const next=msgs.map(m=>({...m,lu:true}));
    setMsgs(next);
    try{await setDoc(doc(db,"messages",uid),{msgs:next});}catch{}
  };

  useEffect(()=>{
    if(msgs.length>0) marquerLus();
  },[msgs.length]);

  const nonLus=msgs.filter(m=>!m.lu).length;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(61,31,14,.6)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9998,padding:"1rem"}}>
      <div style={{background:C.blanc,borderRadius:"16px 16px 0 0",padding:"1.4rem",width:"100%",maxWidth:480,boxShadow:"0 -8px 32px rgba(0,0,0,.2)",maxHeight:"80vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.1rem",fontWeight:600,color:C.brun}}>
            💬 Mes messages {nonLus>0&&<span style={{background:C.rose,color:"white",borderRadius:20,fontSize:".6rem",padding:".1rem .45rem",marginLeft:".3rem"}}>{nonLus}</span>}
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:"1.2rem",color:C.gris,cursor:"pointer"}}>✕</button>
        </div>
        {loading&&<div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".78rem"}}>Chargement...</div>}
        {!loading&&msgs.length===0&&(
          <div style={{textAlign:"center",padding:"2rem",color:C.gris}}>
            <div style={{fontSize:"2rem",marginBottom:".5rem"}}>📭</div>
            <div style={{fontSize:".76rem"}}>Aucun message pour l'instant.</div>
          </div>
        )}
        {msgs.map(m=>(
          <div key={m.id} style={{background:m.lu?C.creme:C.rose+"10",border:`1px solid ${m.lu?C.pale:C.rose+"40"}`,borderRadius:12,padding:".85rem 1rem",marginBottom:".6rem"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".4rem"}}>
              <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>{fmt(m.de)}</div>
              <div style={{fontSize:".6rem",color:C.gris}}>{new Date(m.ts).toLocaleDateString("fr-FR",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</div>
            </div>
            <div style={{fontSize:".78rem",color:C.texte,lineHeight:1.65}}>{m.texte}</div>
          </div>
        ))}
      </div>
    </div>
  );
}



// ── ACTIONS BIBLIO CHEF ───────────────────────────────────────────────────────
export function ActionsBiblioChefTab({uid}){
  const[actions,setActions]=useState([]);
  const[loading,setLoading]=useState(true);
  const[form,setForm]=useState({icon:"⚡",label:"",cat:"ventes"});
  const[saving,setSaving]=useState(false);
  const[showAdd,setShowAdd]=useState(false);

  const CATS=[
    {id:"ventes",label:"🛍️ Ventes"},
    {id:"recrutement",label:"👥 Recrutement"},
    {id:"algorithme",label:"⚡ Algorithme"},
    {id:"equipe",label:"✨ Équipe"},
  ];

  const ICONS=["⚡","💡","🎯","🔥","💪","🌟","✨","🎉","💬","📱","🤝","🏆","💰","🌸","🎥","📸","🌈","💎","🚀","❤️"];

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","actions_biblio"));
        if(snap.exists()) setActions(snap.data().items||[]);
      }catch{}
      setLoading(false);
    })();
  },[]);

  const save=async(next)=>{
    setActions(next);
    try{await setDoc(doc(db,"admin","actions_biblio"),{items:next},{merge:false});}catch{}
  };

  const add=async()=>{
    if(!form.label.trim())return;
    setSaving(true);
    const next=[...actions,{
      id:`chef-${Date.now()}`,
      icon:form.icon,
      label:form.label.trim(),
      cat:form.cat,
      ajoutePar:uid,
      ts:Date.now(),
    }];
    await save(next);
    setForm({icon:"⚡",label:"",cat:"ventes"});
    setShowAdd(false);
    setSaving(false);
  };

  const del=async(id)=>save(actions.filter(a=>a.id!==id));

  if(loading) return <div style={{padding:"2rem",textAlign:"center",color:C.gris,fontSize:".76rem"}}>Chargement...</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Actions <em style={{fontStyle:"italic",color:C.rose}}>Bibliothèque</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Les actions que tu ajoutes ici apparaissent dans l'onglet <strong>✨ Équipe</strong> de la bibliothèque d'actions de toutes les membres.
      </p>

      <button onClick={()=>setShowAdd(!showAdd)}
        style={{width:"100%",background:showAdd?C.pale:C.brun,color:showAdd?C.gris:C.blanc,border:"none",borderRadius:10,padding:".65rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:"1rem"}}>
        {showAdd?"✕ Annuler":"+ Ajouter une action"}
      </button>

      {showAdd&&(
        <div style={{background:C.blanc,border:`1px solid ${C.rose}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
          {/* Icône */}
          <div style={{fontSize:".6rem",color:C.gris,marginBottom:".3rem"}}>Icône</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:".3rem",marginBottom:".7rem"}}>
            {ICONS.map(ic=>(
              <button key={ic} onClick={()=>setForm(f=>({...f,icon:ic}))}
                style={{background:form.icon===ic?C.brun:"none",border:`1px solid ${form.icon===ic?C.brun:C.pale}`,borderRadius:8,padding:".3rem .4rem",fontSize:".9rem",cursor:"pointer"}}>
                {ic}
              </button>
            ))}
          </div>

          {/* Catégorie */}
          <div style={{fontSize:".6rem",color:C.gris,marginBottom:".3rem"}}>Catégorie</div>
          <div style={{display:"flex",gap:".3rem",flexWrap:"wrap",marginBottom:".7rem"}}>
            {CATS.map(c=>(
              <button key={c.id} onClick={()=>setForm(f=>({...f,cat:c.id}))}
                style={{padding:".3rem .65rem",fontSize:".68rem",fontWeight:600,borderRadius:20,border:`1px solid ${form.cat===c.id?C.rose:C.pale}`,background:form.cat===c.id?C.rose:C.blanc,color:form.cat===c.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
                {c.label}
              </button>
            ))}
          </div>

          {/* Label */}
          <div style={{fontSize:".6rem",color:C.gris,marginBottom:".3rem"}}>Description de l'action</div>
          <input value={form.label} onChange={e=>setForm(f=>({...f,label:e.target.value}))}
            placeholder="ex: Envoyer 3 messages de prospection..."
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .7rem",fontSize:".82rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".7rem"}}/>

          <button onClick={add} disabled={!form.label.trim()||saving}
            style={{width:"100%",background:form.label.trim()?C.brun:C.pale,color:form.label.trim()?C.blanc:C.gris,border:"none",borderRadius:8,padding:".55rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:form.label.trim()?"pointer":"default"}}>
            {saving?"Sauvegarde...":"✓ Publier dans la bibliothèque"}
          </button>
        </div>
      )}

      {/* Liste des actions ajoutées */}
      {actions.length===0&&!showAdd&&(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".76rem"}}>
          <div style={{fontSize:"2rem",marginBottom:".5rem"}}>💡</div>
          Aucune action ajoutée pour l'instant.
        </div>
      )}

      {CATS.map(c=>{
        const items=actions.filter(a=>a.cat===c.id);
        if(items.length===0)return null;
        return(
          <div key={c.id} style={{marginBottom:"1rem"}}>
            <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.gris,marginBottom:".4rem",padding:".2rem .6rem",background:C.pale,borderRadius:20,display:"inline-block"}}>{c.label}</div>
            {items.map(a=>(
              <div key={a.id} style={{display:"flex",alignItems:"center",gap:".6rem",background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .85rem",marginBottom:".35rem"}}>
                <span style={{fontSize:"1rem"}}>{a.icon}</span>
                <div style={{flex:1,fontSize:".78rem",color:C.texte}}>{a.label}</div>
                <button onClick={()=>del(a.id)}
                  style={{background:"none",border:"none",color:C.pale,cursor:"pointer",fontSize:".75rem",padding:".1rem .3rem",fontFamily:"inherit"}}>✕</button>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

// Composant global — JAMAIS défini à l'intérieur d'un autre composant
export function GrilleJoursCA({pNum, color, courante=false, joursEcoules, data, editCell, editVal, setEditCell, setEditVal, saveJour, setEditPeriode, setEditCA, setEditObj, setEditNote, setEditCaPerso, setEditRecrues}){
  const d=data[`p${pNum}`]||{ca:0,obj:0,jours:{}};
  const debut=getPeriodeDebut(pNum);
  const _n=new Date();const _t=new Date(_n.getFullYear(),_n.getMonth(),_n.getDate(),12,0,0);const _dj=Math.floor((_t.getTime()-debut.getTime())/(24*60*60*1000));const _je=courante?Math.min(21,Math.max(0,_dj+1)):joursEcoules;const isFutur=(i)=>courante&&i>=_je;const isToday=(i)=>courante&&i===_je-1;
  const pct=(ca,obj)=>obj?Math.min(100,Math.round((ca||0)/obj*100)):0;
  const fmtJour=(d2)=>d2.toLocaleDateString('fr-FR',{weekday:'short',day:'numeric'});
  return(
    <div>
      <div style={{background:courante?`linear-gradient(135deg,${C.brun},${C.brun2})`:color+'15',padding:'.5rem .5rem .4rem',borderBottom:`1px solid ${color}30`}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div style={{fontSize:'.6rem',fontWeight:700,color:courante?C.or:color}}>{fmtPLabel(pNum)}</div>
          <button onClick={()=>{setEditPeriode(pNum);setEditCA(d.ca||'');setEditObj(d.obj||'');setEditCaPerso(d.caPerso||'');setEditRecrues(d.recrues||'');setEditNote(d.note||'');}}
            style={{background:'none',border:`1px solid ${courante?'rgba(255,255,255,.25)':color+'40'}`,borderRadius:5,padding:'.1rem .35rem',fontSize:'.52rem',color:courante?C.pale:color,cursor:'pointer',fontFamily:'inherit'}}>✏️</button>
        </div>
        <div style={{fontFamily:'Georgia,serif',fontSize:'.95rem',fontWeight:700,color:courante?C.blanc:color}}>
          {fmtPLabel(pNum)}
        </div>
        <div style={{height:3,background:courante?'rgba(255,255,255,.15)':C.pale,borderRadius:10,overflow:'hidden',marginTop:'.3rem'}}>
          <div style={{height:'100%',background:courante?C.or:color,width:pct(d.ca,d.obj)+'%',borderRadius:10}}/>
        </div>
      </div>
      {Array.from({length:21},(_,i)=>{
        const dateJour=new Date(debut.getTime()+i*24*60*60*1000);
        const val=d.jours?.[i];
        const editing=editCell?.pNum===pNum&&editCell?.jourIdx===i;
        return(
          <div key={i} onClick={()=>!isFutur(i)&&!editing&&(setEditCell({pNum,jourIdx:i}),setEditVal(val||''))}
            style={{display:'flex',alignItems:'center',gap:'.3rem',padding:'.26rem .45rem',borderBottom:`1px solid ${C.pale}20`,background:isToday(i)?C.rose+'25':val>0?C.vert+'08':'transparent',cursor:isFutur(i)?'default':'pointer',opacity:isFutur(i)?.35:1}}>
            <div style={{flex:1}}>
              <div style={{fontSize:'.54rem',color:isToday(i)?C.rose:C.gris,fontWeight:isToday(i)?700:400,lineHeight:1.2}}>{fmtJour(dateJour)}</div>
            </div>
            {editing
              ?<input autoFocus type='number' defaultValue={val||''}
                  onChange={e=>setEditVal(e.target.value)}
                  onBlur={()=>saveJour(pNum,i,editVal)}
                  onKeyDown={e=>e.key==='Enter'&&saveJour(pNum,i,editVal)}
                  style={{width:44,border:`1px solid ${color}`,borderRadius:4,background:'white',textAlign:'right',fontSize:'.65rem',fontWeight:700,outline:'none',padding:'.1rem .25rem',color:C.brun}}/>
              :<div style={{fontSize:'.65rem',fontWeight:700,color:val>0?C.vert:isFutur(i)?C.pale:C.gris+'80',textAlign:'right',minWidth:36}}>
                {val>0?val+'€':'—'}
              </div>
            }
          </div>
        );
      })}
    </div>
  );
}

// ── SUIVI CHALLENGE APP PAR LE CHEF ──────────────────────────────────────────
export function ChallengeAppSuiviTab({annuaire}){
  const[membres,setMembres]=useState([]);
  const[loading,setLoading]=useState(true);

  useEffect(()=>{
    (async()=>{
      const liste=Object.entries(annuaire||{});
      const today=new Date();
      today.setHours(0,0,0,0);

      const resultats=await Promise.all(
        liste.map(async([mUid,mData])=>{
          try{
            const snap=await getDoc(doc(db,"users",mUid));
            if(!snap.exists())return null;
            const d=snap.data();
            const ca=d["db-challenge-app"]?JSON.parse(d["db-challenge-app"]):null;
            if(!ca)return{uid:mUid,nom:mData.prenom||mUid,statut:"non_commence",joursValides:[],jourActuel:0,pct:0};

            const startDate=new Date(ca.startDate);
            startDate.setHours(0,0,0,0);
            const diffJours=Math.floor((today-startDate)/(1000*60*60*24));
            const jourActuel=Math.max(0,Math.min(diffJours+1,7));
            const joursValides=ca.joursValides||[];
            const termine=diffJours>=7;
            const pct=Math.round((joursValides.length/7)*100);
            const dateEnreg=mData.dateEnreg||ca.startDate;

            return{
              uid:mUid,
              nom:mData.prenom||mUid,
              statut:termine?"termine":jourActuel===0?"demarre_demain":"actif",
              joursValides,
              jourActuel:Math.max(jourActuel,0),
              pct,
              startDate:ca.startDate,
              dateEnreg,
            };
          }catch{return null;}
        })
      );

      setMembres(resultats.filter(Boolean).sort((a,b)=>b.pct-a.pct||b.joursValides.length-a.joursValides.length));
      setLoading(false);
    })();
  },[annuaire]);

  if(loading)return<div style={{textAlign:"center",padding:"2rem",color:C.gris}}>⏳ Chargement...</div>;

  const nbActifs=membres.filter(m=>m.statut==="actif"||m.statut==="termine").length;
  const nbTermines=membres.filter(m=>m.statut==="termine").length;
  const nbNonCommences=membres.filter(m=>m.statut==="non_commence").length;
  const pctMoyen=membres.length?Math.round(membres.reduce((s,m)=>s+m.pct,0)/membres.length):0;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.brun,marginBottom:".75rem"}}>
        Challenge <em style={{fontStyle:"italic",color:C.rose}}>Découverte App</em>
      </div>

      {/* Résumé global */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:"1rem"}}>
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem",textAlign:"center"}}>
          <div style={{fontSize:"1.6rem",fontWeight:700,color:C.rose,fontFamily:"Georgia,serif"}}>{nbActifs}</div>
          <div style={{fontSize:".62rem",color:C.gris,fontWeight:600}}>En cours</div>
        </div>
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem",textAlign:"center"}}>
          <div style={{fontSize:"1.6rem",fontWeight:700,color:C.vert,fontFamily:"Georgia,serif"}}>{nbTermines}</div>
          <div style={{fontSize:".62rem",color:C.gris,fontWeight:600}}>Terminé 🏆</div>
        </div>
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem",textAlign:"center"}}>
          <div style={{fontSize:"1.6rem",fontWeight:700,color:C.or,fontFamily:"Georgia,serif"}}>{pctMoyen}%</div>
          <div style={{fontSize:".62rem",color:C.gris,fontWeight:600}}>Progression moyenne</div>
        </div>
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem",textAlign:"center"}}>
          <div style={{fontSize:"1.6rem",fontWeight:700,color:C.gris,fontFamily:"Georgia,serif"}}>{nbNonCommences}</div>
          <div style={{fontSize:".62rem",color:C.gris,fontWeight:600}}>Pas encore commencé</div>
        </div>
      </div>

      {/* Liste membres */}
      {membres.map((m,i)=>(
        <div key={m.uid} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".5rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".5rem"}}>
            <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
              <div style={{width:32,height:32,borderRadius:"50%",background:m.statut==="termine"?C.vert+"25":m.statut==="actif"?C.rose+"25":C.pale,color:m.statut==="termine"?C.vert:m.statut==="actif"?C.rose:C.gris,display:"flex",alignItems:"center",justifyContent:"center",fontSize:".78rem",fontWeight:700,flexShrink:0}}>
                {m.nom[0]?.toUpperCase()}
              </div>
              <div>
                <div style={{fontSize:".82rem",fontWeight:600,color:C.brun}}>{m.nom}</div>
                <div style={{fontSize:".6rem",color:C.gris}}>
                  {m.statut==="termine"?"🏆 Challenge terminé !":
                   m.statut==="demarre_demain"?"⏳ Commence demain":
                   m.statut==="non_commence"?"❌ Pas encore commencé":
                   `📅 Jour ${m.jourActuel}/7 en cours`}
                </div>
              </div>
            </div>
            <div style={{textAlign:"right",flexShrink:0}}>
              <div style={{fontSize:".82rem",fontWeight:700,color:m.pct===100?C.vert:m.pct>=50?C.or:C.gris}}>{m.pct}%</div>
              <div style={{fontSize:".58rem",color:C.gris}}>{m.joursValides.length}/7 jours</div>
            </div>
          </div>

          {/* Barre progression avec cases par jour */}
          <div style={{display:"flex",gap:".2rem"}}>
            {CHALLENGE_APP_JOURS.map((j,ji)=>{
              const fait=m.joursValides.includes(j.jour);
              const estCejour=m.jourActuel===j.jour;
              return(
                <div key={ji} title={j.titre}
                  style={{flex:1,height:28,borderRadius:6,background:fait?C.vert:estCejour?C.or+"40":C.pale,border:`1px solid ${fait?C.vert:estCejour?C.or:C.pale}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:".7rem",position:"relative"}}>
                  {fait?"✓":estCejour?<span style={{fontSize:".6rem",fontWeight:700,color:C.or}}>J{j.jour}</span>:<span style={{fontSize:".55rem",color:C.gris}}>{j.jour}</span>}
                </div>
              );
            })}
          </div>

          {/* Détail des jours validés */}
          {m.joursValides.length>0&&(
            <div style={{marginTop:".4rem",display:"flex",flexWrap:"wrap",gap:".2rem"}}>
              {m.joursValides.sort((a,b)=>a-b).map(j=>(
                <span key={j} style={{fontSize:".58rem",background:C.vert+"15",color:C.vert,borderRadius:20,padding:".1rem .4rem",fontWeight:600}}>
                  ✓ J{j}: {CHALLENGE_APP_JOURS[j-1]?.emoji}
                </span>
              ))}
            </div>
          )}
          <button onClick={async()=>{if(!window.confirm("Reset challenge de "+m.nom+" ?"))return;await setDoc(doc(db,"users",m.uid),{"db-challenge-app":null},{merge:true});setMembres(prev=>prev.map(x=>x.uid===m.uid?{...x,statut:"non_commence",joursValides:[],jourActuel:0,pct:0}:x));}} style={{marginTop:".4rem",width:"100%",background:"none",border:"1px solid #E8DDD4",borderRadius:8,padding:".3rem",fontSize:".62rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>Reset</button>
        </div>
      ))}

      {membres.length===0&&(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>
          Aucun membre dans l'équipe pour l'instant.
        </div>
      )}
      <button onClick={async()=>{if(!window.confirm("Remettre le challenge a zero pour tout le monde ?"))return;const liste=Object.entries(annuaire||{});await Promise.all(liste.map(([muid])=>setDoc(doc(db,"users",muid),{"db-challenge-app":null},{merge:true})));setMembres(prev=>prev.map(x=>({...x,statut:"non_commence",joursValides:[],jourActuel:0,pct:0})));}} style={{width:"100%",background:"#B04040",color:"white",border:"none",borderRadius:10,padding:".65rem",fontSize:".8rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginTop:"1rem"}}>Reset challenge tout le monde</button>
    </div>
  );
}

// ── STATISTIQUES ÉQUIPE ──────────────────────────────────────────────────────
function StatsEquipeTab({uid, annuaire}){
  const[stats,setStats]=useState(null);
  const[loading,setLoading]=useState(true);
  const[periode,setPeriode]=useState("30j");
  const[rechercheMembre,setRechercheMembre]=useState("");

  const fmt=(n,dec=0)=>typeof n==="number"?n.toFixed(dec):"-";
  const pct=(a,b)=>b>0?Math.round((a/b)*100):0;

  useEffect(()=>{
    (async()=>{
      setLoading(true);
      try{
        const membres=Object.entries(annuaire||{});
        if(!membres.length){setLoading(false);return;}

        const today=new Date();
        const cutoffJours=periode==="7j"?7:periode==="30j"?30:90;
        const cutoff=new Date(today-cutoffJours*24*60*60*1000).toISOString().slice(0,10);

        // Charger les données de chaque membre en parallèle
        const snapshots=await Promise.all(
          membres.map(([mUid])=>getDoc(doc(db,"users",mUid)).catch(()=>null))
        );

        let totalMembres=membres.length;
        let actifs=0;
        let streakTotal=0;
        let totalDiags=0;
        let totalDiagsAvecOrd=0;
        let totalProspects=0;
        let totalProspectsDepuisDiag=0;
        let totalConvertisClient=0;
        let totalConvertisDistrib=0;
        let totalClients=0;
        let totalCommandes=0;
        let totalCA=0;
        let totalRecommandations=0;
        let totalRecsConverties=0;
        let totalFastStartDone=0;
        let totalFastStartAssigne=0;
        let totalActions=0;
        let membresAvecDreamboard=0;
        let membresAvecLinkbio=0;
        let membreDetails=[];
        let diagParType={}; // comptage par type

        snapshots.forEach((snap,i)=>{
          if(!snap||!snap.exists())return;
          const d=snap.data();
          const [mUid,mData]=membres[i];

          const lastLogin=d["db-last-login"]||"";
          const estActif=lastLogin>=cutoff;
          if(estActif)actifs++;

          const streak=+d["db-streak"]||0;
          streakTotal+=streak;

          // Diagnostics
          const diags=d["db-diagnostics"]?JSON.parse(d["db-diagnostics"]):[];
          const diagsRecents=diags.filter(dg=>dg.date>=cutoff);
          totalDiags+=diagsRecents.length;
          const diagsAvecOrd=diagsRecents.filter(dg=>dg.ordonnance||dg.ordre);
          totalDiagsAvecOrd+=diagsAvecOrd.length;
          // Compter par type
          diagsRecents.forEach(dg=>{
            if(dg.type) diagParType[dg.type]=(diagParType[dg.type]||0)+1;
          });

          // Prospects
          const prospects=d["db-prospects"]?JSON.parse(d["db-prospects"]):[];
          const prospectsRecents=prospects.filter(p=>p.dateAjout>=cutoff||(p.id&&String(p.id).length===13&&new Date(+p.id)>=new Date(cutoff)));
          totalProspects+=prospectsRecents.length;
          const depuisDiag=prospects.filter(p=>p.source==="diagnostic").length;
          totalProspectsDepuisDiag+=depuisDiag;
          const convertisClient=prospects.filter(p=>p.convertiVers==="client").length;
          const convertisDistrib=prospects.filter(p=>p.convertiVers==="distributrice").length;
          totalConvertisClient+=convertisClient;
          totalConvertisDistrib+=convertisDistrib;

          // Recommandations
          const prospectsRec=prospects.filter(p=>p.source==="recommandation").length;
          totalRecommandations+=prospectsRec;
          totalRecsConverties+=prospects.filter(p=>p.source==="recommandation"&&p.convertiVers).length;

          // Clients et commandes
          const clients=d["db-clients"]?JSON.parse(d["db-clients"]):[];
          totalClients+=clients.length;
          clients.forEach(c=>{
            const cmds=(c.commandes||[]).filter(cmd=>cmd.date>=cutoff);
            totalCommandes+=cmds.length;
            totalCA+=cmds.reduce((s,cmd)=>s+(parseFloat(cmd.montant)||0),0);
          });

          // Fast Start
          const fs=d["db-fast-start"]?JSON.parse(d["db-fast-start"]):null;
          if(fs){
            totalFastStartAssigne++;
            const done=Object.values(fs.modulesValides||{}).filter(Boolean).length;
            if(done>=7)totalFastStartDone++;
          }

          // Actions biblio
          const actions=d["db-actions"]?JSON.parse(d["db-actions"]):{};
          const nbActions=Object.keys(actions).filter(k=>!k.startsWith("_")&&actions[k]).length;
          totalActions+=nbActions;

          // Dream board
          if(d["db-dreamboard"])membresAvecDreamboard++;

          membreDetails.push({
            uid:mUid,
            nom:mData.prenom||mUid.split("-").map(w=>w[0]?.toUpperCase()+w.slice(1)).join(" "),
            actif:estActif,
            lastLogin,
            streak,
            nbDiags:diagsRecents.length,
            nbDiagsAvecOrd:diagsAvecOrd.length,
            nbProspects:prospectsRecents.length,
            nbClients:clients.length,
            nbCommandes:totalCommandes,
            nbFsModules:fs?Object.values(fs.modulesValides||{}).filter(Boolean).length:0,
            fsDone:fs&&Object.values(fs.modulesValides||{}).filter(Boolean).length>=7,
          });
        });

        // Charger les recommandations depuis la collection recommandations
        try{
          const recSnap=await Promise.all(membres.map(([mUid])=>getDoc(doc(db,"recommandations",mUid)).catch(()=>null)));
          recSnap.forEach(s=>{if(s&&s.exists()){totalRecommandations+=(s.data().liste||[]).reduce((sum,r)=>sum+(r.personnes?.length||1),0);}});
        }catch{}

        const tauxUtilisation=pct(actifs,totalMembres);
        const tauxConvDiag=pct(totalProspectsDepuisDiag,totalDiags);
        const tauxConvProspect=pct(totalConvertisClient+totalConvertisDistrib,totalProspects+totalProspectsDepuisDiag);
        const tauxFastStart=pct(totalFastStartDone,totalFastStartAssigne||1);
        const tauxConvRec=pct(totalRecsConverties,totalRecommandations||1);

        setStats({
          totalMembres,actifs,tauxUtilisation,
          streakMoyen:totalMembres?Math.round(streakTotal/totalMembres):0,
          totalDiags,totalDiagsAvecOrd,tauxOrdonnance:pct(totalDiagsAvecOrd,totalDiags||1),
          totalProspects,totalProspectsDepuisDiag,tauxConvDiag,
          totalConvertisClient,totalConvertisDistrib,tauxConvProspect,
          totalClients,totalCommandes,totalCA:Math.round(totalCA),
          totalRecommandations,totalRecsConverties,tauxConvRec,
          totalFastStartAssigne,totalFastStartDone,tauxFastStart,
          totalActions,membresAvecDreamboard,
          diagParType,
          membreDetails:membreDetails.sort((a,b)=>b.nbDiags-a.nbDiags),
          cutoff,periode,
        });
      }catch(e){console.error(e);}
      setLoading(false);
    })();
  },[annuaire,periode]);

  const StatCard=({icon,label,value,sub,color,pctVal})=>(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem .85rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:".25rem"}}>
        <div style={{fontSize:".6rem",color:C.gris,fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>{icon} {label}</div>
        {pctVal!==undefined&&(
          <div style={{fontSize:".65rem",fontWeight:700,color:pctVal>=70?C.vert:pctVal>=40?"#E67E22":"#E74C3C",background:(pctVal>=70?C.vert:pctVal>=40?"#E67E22":"#E74C3C")+"15",borderRadius:20,padding:".1rem .4rem"}}>
            {pctVal}%
          </div>
        )}
      </div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.4rem",fontWeight:600,color:color||C.brun}}>{value}</div>
      {sub&&<div style={{fontSize:".62rem",color:C.gris,marginTop:".1rem"}}>{sub}</div>}
    </div>
  );

  if(loading)return(
    <div style={{textAlign:"center",padding:"2rem",color:C.gris}}>
      <div style={{fontSize:"1.5rem",marginBottom:".5rem"}}>📊</div>
      Analyse en cours...
    </div>
  );

  if(!stats)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Aucune donnée disponible.</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:300,color:C.brun,marginBottom:".5rem"}}>
        Statistiques <em style={{fontStyle:"italic",color:C.rose}}>Blazing Dynasty</em>
      </div>

      {/* Sélecteur de période */}
      <div style={{display:"flex",gap:".3rem",marginBottom:"1rem"}}>
        {["7j","30j","90j"].map(p=>(
          <button key={p} onClick={()=>setPeriode(p)}
            style={{flex:1,padding:".38rem",fontSize:".72rem",fontWeight:600,borderRadius:8,border:`1px solid ${periode===p?C.rose:C.pale}`,background:periode===p?C.rose:C.blanc,color:periode===p?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
            {p==="7j"?"7 jours":p==="30j"?"30 jours":"90 jours"}
          </button>
        ))}
      </div>

      {/* SECTION 1 — UTILISATION */}
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>📱 Utilisation de l'application</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:"1rem"}}>
        <StatCard icon="👥" label="Membres actifs" value={`${stats.actifs}/${stats.totalMembres}`} sub={`Connectées sur les ${periode}`} pctVal={stats.tauxUtilisation} color={C.rose}/>
        <StatCard icon="🔥" label="Streak moyen" value={`${stats.streakMoyen}j`} sub="Jours de connexion consécutifs" color={C.or}/>
        <StatCard icon="⚡" label="Actions biblio" value={stats.totalActions} sub={`Actions validées équipe`} color={C.brun}/>
        <StatCard icon="🌟" label="Dream Boards" value={stats.membresAvecDreamboard} sub={`Membres avec un board actif`} color={C.lilas}/>
      </div>

      {/* SECTION 2 — DIAGNOSTICS */}
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>🔬 Diagnostics & Ordonnances</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:".65rem"}}>
        <StatCard icon="📋" label="Diagnostics envoyés" value={stats.totalDiags} sub={`Sur les ${periode}`} color={C.brun}/>
        <StatCard icon="✨" label="Ordonnances générées" value={stats.totalDiagsAvecOrd} sub="Diagnostics avec résultat IA" pctVal={stats.tauxOrdonnance} color={C.rose}/>
        <StatCard icon="👤" label="Prospects créés / diag" value={stats.totalProspectsDepuisDiag} sub="Fiches créées depuis un diagnostic" color={C.or}/>
        <StatCard icon="🔄" label="Taux diag → prospect" value={`${stats.tauxConvDiag}%`} sub="Diagnostic converti en fiche" color={stats.tauxConvDiag>=30?C.vert:"#E67E22"}/>
      </div>

      {/* Classement diagnostics les plus utilisés */}
      {stats.diagParType&&Object.keys(stats.diagParType).length>0&&(
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".75rem .85rem",marginBottom:"1rem"}}>
          <div style={{fontSize:".62rem",fontWeight:700,color:C.brun,marginBottom:".5rem"}}>🏆 Diagnostics les plus utilisés</div>
          {Object.entries(stats.diagParType)
            .sort((a,b)=>b[1]-a[1])
            .slice(0,8)
            .map(([type,count],i)=>{
              const max=Object.values(stats.diagParType).reduce((a,b)=>Math.max(a,b),1);
              const label={skincare:"✨ Skincare",makeup:"💄 Makeup",peaucorps:"🧴 Peau Corps",cheveux:"💇 Cheveux",sante:"💊 Santé",silhouette:"⚖️ Silhouette",detox:"🌿 Détox",antiage:"🌸 Anti-Âge",budget:"💡 Budget Beauté",recrutement:"🤝 Recrutement",complementrevenu:"💰 Revenu +",entrepreneuriat:"🚀 Entrepreneur",valeurmarche:"💼 Valeur marché",chargementale:"🧠 Charge Mentale",libertefin:"🏖️ Liberté Fin.",maman:"🌸 Maman",reconversion:"🔄 Reconversion",confianceensoi:"💪 Confiance",reseauxsociaux2:"📲 Audit Digital",blocage:"🔓 Recrue bloquée",pasrecruiter:"😓 Non recrutement",pasvendre:"💸 Non ventes",reseaux:"📱 Réseaux"}[type]||type;
              return(
                <div key={type} style={{marginBottom:".4rem"}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:".68rem",marginBottom:".1rem"}}>
                    <span style={{color:C.brun,fontWeight:i<3?700:400}}>{i===0?"🥇":i===1?"🥈":i===2?"🥉":""} {label}</span>
                    <span style={{color:C.gris,fontWeight:600}}>{count}</span>
                  </div>
                  <div style={{height:5,background:C.pale,borderRadius:10,overflow:"hidden"}}>
                    <div style={{height:"100%",background:i<3?C.rose:C.gris+"60",borderRadius:10,width:`${Math.round((count/max)*100)}%`,transition:"width .3s"}}/>
                  </div>
                </div>
              );
            })
          }
        </div>
      )}

      {/* SECTION 3 — CONVERSION PROSPECTS */}
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>🎯 Prospects & Conversion</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:"1rem"}}>
        <StatCard icon="👥" label="Total prospects" value={stats.totalProspects} sub={`Ajoutés sur les ${periode}`} color={C.brun}/>
        <StatCard icon="✅" label="Taux de conversion" value={`${stats.tauxConvProspect}%`} sub={`${stats.totalConvertisClient} clientes · ${stats.totalConvertisDistrib} distribs`} pctVal={stats.tauxConvProspect} color={C.vert}/>
        <StatCard icon="🛍️" label="Clientes totales" value={stats.totalClients} sub="Dans toutes les fiches" color={C.rose}/>
        <StatCard icon="📦" label="Commandes enregistrées" value={stats.totalCommandes} sub={`CA estimé: ${stats.totalCA}€`} color={C.or}/>
      </div>

      {/* SECTION 4 — RECOMMANDATIONS */}
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>🤝 Système de recommandation</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:"1rem"}}>
        <StatCard icon="📨" label="Recommandations reçues" value={stats.totalRecommandations} sub="Personnes recommandées par clientes" color={C.lilas}/>
        <StatCard icon="🔁" label="Taux conversion recs" value={`${stats.tauxConvRec}%`} sub="Recommandations devenues prospects" pctVal={stats.tauxConvRec} color={C.vert}/>
      </div>

      {/* SECTION 5 — FAST START */}
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>🚀 Onboarding Fast Start</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginBottom:"1rem"}}>
        <StatCard icon="📚" label="Fast Start assignés" value={stats.totalFastStartAssigne} sub="Nouvelles avec parcours actif" color={C.brun}/>
        <StatCard icon="🏁" label="Fast Start terminés" value={stats.totalFastStartDone} sub="7 modules validés" pctVal={stats.tauxFastStart} color={C.vert}/>
      </div>

      {/* SCORE GLOBAL */}
      {(()=>{
        const score=Math.round((stats.tauxUtilisation*0.3)+(stats.tauxOrdonnance*0.2)+(stats.tauxConvProspect*0.25)+(stats.tauxFastStart*0.25));
        const couleur=score>=70?C.vert:score>=45?"#E67E22":"#E74C3C";
        return(
          <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:14,padding:"1rem 1.1rem",marginBottom:"1rem",textAlign:"center"}}>
            <div style={{fontSize:".62rem",color:C.or,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".3rem"}}>⚡ Score global Blazing Dynasty</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:"2.5rem",fontWeight:700,color:couleur}}>{score}<span style={{fontSize:"1.2rem",color:"rgba(255,255,255,.6)"}}>/100</span></div>
            <div style={{fontSize:".68rem",color:"rgba(255,255,255,.7)",marginTop:".2rem"}}>
              {score>=70?"🔥 Équipe très engagée — excellent levier de recrutement !":score>=45?"⚡ Bonne dynamique — encore des axes de progression":score>0?"💡 Potentiel à débloquer — concentre-toi sur l'engagement":""}
            </div>
          </div>
        );
      })()}

      {/* PHRASE RECRUTEMENT */}
      <div style={{background:C.creme,borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",border:`1px solid ${C.or}40`}}>
        <div style={{fontSize:".62rem",fontWeight:700,color:C.or,marginBottom:".35rem"}}>💬 Phrase toute prête pour recruter</div>
        <div style={{fontSize:".74rem",color:C.brun,lineHeight:1.7,fontStyle:"italic"}}>
          "Dans mon équipe, {stats.tauxUtilisation}% des distributrices utilisent l'outil de gestion que j'ai mis en place. Elles ont réalisé {stats.totalDiags} diagnostics clients ce mois, généré {stats.totalDiagsAvecOrd} ordonnances personnalisées, et converti {stats.tauxConvProspect}% de leurs prospects en clientes ou distributrices. C'est pas juste du MLM — c'est une vraie structure qui marche."
        </div>
        <button onClick={()=>{
          const texte=`"Dans mon équipe, ${stats.tauxUtilisation}% des distributrices utilisent l'outil de gestion que j'ai mis en place. Elles ont réalisé ${stats.totalDiags} diagnostics clients ce mois, généré ${stats.totalDiagsAvecOrd} ordonnances personnalisées, et converti ${stats.tauxConvProspect}% de leurs prospects en clientes ou distributrices. C'est pas juste du MLM — c'est une vraie structure qui marche."`;
          navigator.clipboard?.writeText(texte);
          alert("✅ Copié !");
        }}
          style={{width:"100%",background:C.or,color:"white",border:"none",borderRadius:8,padding:".42rem",fontSize:".72rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginTop:".5rem"}}>
          📋 Copier cette phrase
        </button>
      </div>

      {/* TABLEAU MEMBRE PAR MEMBRE */}
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".45rem"}}>👥 Détail par membre</div>
      <input
        placeholder="🔍 Rechercher un membre..."
        value={rechercheMembre}
        onChange={e=>setRechercheMembre(e.target.value)}
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:9,padding:".45rem .7rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".5rem"}}
      />
      {stats.membreDetails.filter(m=>m.nom.toLowerCase().includes(rechercheMembre.toLowerCase())).map((m,i)=>(
        <div key={i} style={{background:m.actif?C.blanc:C.creme,border:`1px solid ${m.actif?C.pale:"transparent"}`,borderRadius:10,padding:".55rem .75rem",marginBottom:".35rem",opacity:m.actif?1:.7}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".2rem"}}>
            <div style={{display:"flex",alignItems:"center",gap:".4rem"}}>
              <div style={{width:28,height:28,borderRadius:"50%",background:m.actif?C.rose+"25":"#ccc",color:m.actif?C.rose:"#aaa",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".75rem",fontWeight:700,flexShrink:0}}>
                {m.nom[0]?.toUpperCase()}
              </div>
              <div>
                <div style={{fontSize:".74rem",fontWeight:600,color:C.brun}}>{m.nom}</div>
                <div style={{fontSize:".58rem",color:m.actif?C.vert:C.gris}}>{m.actif?"✅ Active":"⬜ Inactive"} · {m.streak}🔥</div>
              </div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:".62rem",color:C.gris}}>🔬 {m.nbDiags} diag · 👤 {m.nbProspects} prospects</div>
              <div style={{fontSize:".6rem",color:C.gris}}>🛍️ {m.nbClients} clientes · {m.fsDone?"🏁 FS ✓":"📚 FS "+m.nbFsModules+"/7"}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// Archive caPerso + recrues dans db-suivi-ca pour la periode qui se termine
export async function archiverPeriodeSuiviCA(uid, pNum, caPerso, recrues){
  try{
    const ref=doc(db,"users",uid);
    const snap=await getDoc(ref);
    const brut=snap.exists()?snap.data()["db-suivi-ca"]:null;
    const data=brut?JSON.parse(brut):{};
    const key="p"+pNum;
    const cur=data[key]||{obj:0,jours:{}};
    data[key]={...cur,caPerso:+caPerso||0,recrues:+recrues||0};
    await setDoc(ref,{"db-suivi-ca":JSON.stringify(data)},{merge:true});
  }catch(e){ console.error("archiverPeriodeSuiviCA:",e); }
}

// ── Suivi CA : comparer au même jour J de la période ─────────────────────────
// Cumul d'une période au jour J (J = nombre de jours écoulés). Renvoie {v, est} ou null s'il n'y a rien.
// Les jours saisis sont des cumuls. Entre deux jours saisis on interpole ; "est" = valeur estimée (trou de plus de 2 jours).
export function cumulAuJour(d, J){
  if(!d) return null;
  const jours=d.jours||{};
  const pts=[];
  Object.keys(jours).forEach(k=>{
    const i=parseInt(k,10), v=parseFloat(jours[k]);
    if(!isNaN(i)&&i>=0&&i<21&&v>0) pts.push({j:i+1,v});
  });
  pts.sort((a,b)=>a.j-b.j);
  if(!pts.length){
    const ca=parseFloat(d.ca)||0;
    return ca>0?{v:Math.round(ca*J/21),est:true}:null;
  }
  let prev={j:0,v:0}, next=null;
  for(const p of pts){ if(p.j<=J) prev=p; else { next=p; break; } }
  if(prev.j===J) return {v:prev.v,est:false};
  if(!next) return {v:prev.v,est:false};
  const v=prev.v+(next.v-prev.v)*(J-prev.j)/(next.j-prev.j);
  return {v:Math.round(v),est:(next.j-prev.j)>2};
}

// Compare le CA de la période pCour (valeur cv) aux références, toutes prises au jour J.
export function comparaisonsCA(data, pCour, J, parAn){
  const prendre=(n)=>{ if(!(n>0)||n>=pCour) return null; const r=cumulAuJour(data["p"+n],J); return r?{n,v:r.v,est:r.est}:null; };
  const prec=prendre(pCour-1);
  let an=null;
  for(const dn of [0,-1,1]){ const r=prendre(pCour-parAn+dn); if(r){ an=r; break; } }
  let somme=0, nb=0;
  Object.keys(data||{}).forEach(key=>{
    const m=/^p(-?\d+)$/.exec(key); if(!m) return;
    const n=parseInt(m[1],10); if(n>=pCour) return;
    const r=cumulAuJour(data[key],J);
    if(r&&!r.est){ somme+=r.v; nb++; }
  });
  return {prec, an, moy:nb?{v:Math.round(somme/nb),nb}:null};
}

export function SuiviCATab({uid}){
  const raw = getPeriodeInfo();
  const[periodeOverride,setPeriodeOverride]=useState(null);
  const[editPeriodeNum,setEditPeriodeNum]=useState(false);
  const[inputPeriodeNum,setInputPeriodeNum]=useState("");
  const pCourante = periodeOverride || raw.periodNum || getPeriodeActuelle();
  const joursEcoules = periodeOverride ? 21 : Math.min(21, Math.max(1, 21 - (raw.daysLeft||0)));

  const[data,setData]=useState({});
  const[loading,setLoading]=useState(true);
  const[saving,setSaving]=useState(false);

  // Colonnes comparaison libres
  const[compareA,setCompareA]=useState(pCourante-1>0?pCourante-1:1);
  const[compareB,setCompareB]=useState(pCourante-PERIODES_PAR_AN>0?pCourante-PERIODES_PAR_AN:1);
  const[editColA,setEditColA]=useState(false);
  const[editColB,setEditColB]=useState(false);
  const[inputA,setInputA]=useState(String(pCourante-1>0?pCourante-1:1));
  const[inputB,setInputB]=useState(String(pCourante-PERIODES_PAR_AN>0?pCourante-PERIODES_PAR_AN:1));

  // Cellule en cours d'édition
  const[editCell,setEditCell]=useState(null);
  const[editVal,setEditVal]=useState('');

  // Édition total + objectif
  const[editPeriode,setEditPeriode]=useState(null);
  const[editCA,setEditCA]=useState('');
  const[editCaPerso,setEditCaPerso]=useState('');
  const[editRecrues,setEditRecrues]=useState('');
  const[editObj,setEditObj]=useState('');
  const[editNote,setEditNote]=useState('');

  // Historique — navigation
  const[histAnnee,setHistAnnee]=useState(new Date().getFullYear());
  const[histPeriodeOuverte,setHistPeriodeOuverte]=useState(null); // num absolu

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,'users',uid));
        if(snap.exists()&&snap.data()['db-suivi-ca'])
          setData(JSON.parse(snap.data()['db-suivi-ca']));
      }catch{}
      setLoading(false);
    })();
  },[uid]);

  const saveData=async(next)=>{
    setSaving(true);
    try{await setDoc(doc(db,'users',uid),{'db-suivi-ca':JSON.stringify(next)},{merge:true});setData(next);}catch{}
    setSaving(false);
  };

  const saveJour=(pNum,idx,val)=>{
    const pKey=`p${pNum}`;
    const cur=data[pKey]||{obj:0,jours:{}};
    const jours={...(cur.jours||{}),[idx]:parseFloat(val)||0};
    // Total = valeur du jour le plus récent rempli (saisie cumulée)
    const joursRemplis=Object.entries(jours).filter(([,v])=>parseFloat(v)>0);
    let ca=0;
    if(joursRemplis.length>0){
      const dernierIdx=Math.max(...joursRemplis.map(([k])=>parseInt(k)));
      ca=parseFloat(jours[dernierIdx])||0;
    }
    saveData({...data,[pKey]:{...cur,jours,ca}});
    setEditCell(null);
  };

  const saveEdit=()=>{
    const pKey=`p${editPeriode}`;
    const cur=data[pKey]||{jours:{}};
    saveData({...data,[pKey]:{...cur,ca:parseFloat(editCA)||0,obj:parseFloat(editObj)||0,caPerso:parseFloat(editCaPerso)||0,recrues:parseFloat(editRecrues)||0,note:editNote.trim()}});
    setEditPeriode(null);
  };

  const pct=(ca,obj)=>obj?Math.min(100,Math.round((ca||0)/obj*100)):0;
  const fmtDate=(d)=>d.toLocaleDateString('fr-FR',{day:'numeric',month:'short'});
  const fmtJour=(d)=>d.toLocaleDateString('fr-FR',{weekday:'short',day:'numeric'});

  if(loading)return <div style={{padding:'2rem',textAlign:'center',color:C.gris,fontSize:'.76rem'}}>Chargement...</div>;

  const dCour=data[`p${pCourante}`]||{ca:0,obj:0,jours:{}};
  const cvCA=dCour.ca||0;
  const cmpCA=comparaisonsCA(data,pCourante,joursEcoules,PERIODES_PAR_AN);
  const lignesCmp=[];
  if(dCour.obj>0) lignesCmp.push({k:'obj',icone:'🎯',titre:'Objectif',detail:'attendu à J'+joursEcoules+' : '+Math.round(dCour.obj*joursEcoules/21)+'€',ref:Math.round(dCour.obj*joursEcoules/21),est:false});
  lignesCmp.push({k:'prec',icone:'⏮️',titre:'Période précédente',detail:cmpCA.prec?(fmtPLabel(cmpCA.prec.n)+' : '+cmpCA.prec.v+'€'+(cmpCA.prec.est?' (estimé)':'')):'pas de données',ref:cmpCA.prec?cmpCA.prec.v:null,est:!!(cmpCA.prec&&cmpCA.prec.est)});
  lignesCmp.push({k:'an',icone:'📅',titre:"Même période l'an dernier",detail:cmpCA.an?(fmtPLabel(cmpCA.an.n)+' : '+cmpCA.an.v+'€'+(cmpCA.an.est?' (estimé)':'')):'pas de données',ref:cmpCA.an?cmpCA.an.v:null,est:!!(cmpCA.an&&cmpCA.an.est)});
  lignesCmp.push({k:'moy',icone:'📊',titre:'Moyenne des périodes saisies',detail:cmpCA.moy?('sur '+cmpCA.moy.nb+' période'+(cmpCA.moy.nb>1?'s':'')+' : '+cmpCA.moy.v+'€'):'pas de données',ref:cmpCA.moy?cmpCA.moy.v:null,est:false});
  const flecheCA=(d)=>d>0?{s:'▲ +',c:C.vert}:d<0?{s:'▼ −',c:'#FF7B6B'}:{s:'＝ ',c:C.pale};
  const teteRef=cmpCA.prec?{v:cmpCA.prec.v,t:'vs '+fmtPLabel(cmpCA.prec.n)}:cmpCA.an?{v:cmpCA.an.v,t:'vs '+fmtPLabel(cmpCA.an.n)}:cmpCA.moy?{v:cmpCA.moy.v,t:'vs la moyenne'}:(dCour.obj>0?{v:Math.round(dCour.obj*joursEcoules/21),t:"vs l'objectif"}:null);
  const teteD=teteRef?Math.round(cvCA-teteRef.v):null;

  // Grille 21 jours pour une période donnée

  // Années disponibles
  const anneesDispos=[];
  const anneeCourante=getPeriodeDebut(pCourante).getFullYear();
  for(let a=2024;a<=anneeCourante;a++) anneesDispos.push(a);

  // Périodes d'une année donnée (numéros absolus)
  const periodesDeAnnee=(annee)=>{
    const result=[];
    for(let n=-50;n<=pCourante;n++){
      try{
        const d=getPeriodeDebut(n);
        const f=new Date(d.getTime()+PERIODE_DUREE_JOURS*24*60*60*1000-1);
        if(d.getFullYear()===annee||f.getFullYear()===annee) result.push(n);
      }catch{}
    }
    return [...new Set(result)].sort((a,b)=>a-b);
  };

  return(
    <div id="decouverte-suivi-ca">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".4rem"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun}}>
          Suivi <em style={{fontStyle:"italic",color:C.rose}}>CA</em>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:".3rem"}}>
          {editPeriodeNum
            ?<div style={{display:"flex",gap:".3rem",alignItems:"center"}}>
              <span style={{fontSize:".62rem",color:C.gris}}>P n°</span>
              <input type="number" autoFocus value={inputPeriodeNum} onChange={e=>setInputPeriodeNum(e.target.value)}
                onBlur={()=>{const v=parseInt(inputPeriodeNum);if(v>0)setPeriodeOverride(v);setEditPeriodeNum(false);}}
                onKeyDown={e=>{if(e.key==="Enter"){const v=parseInt(inputPeriodeNum);if(v>0)setPeriodeOverride(v);setEditPeriodeNum(false);}}}
                style={{width:50,border:`1px solid ${C.rose}`,borderRadius:7,padding:".28rem .4rem",fontSize:".78rem",fontFamily:"inherit",textAlign:"center",outline:"none"}}/>
            </div>
            :<button onClick={()=>{setEditPeriodeNum(true);setInputPeriodeNum(String(pCourante));}}
              style={{background:periodeOverride?"#FFF3CD":"none",border:`1px solid ${periodeOverride?"#E6A817":C.pale}`,borderRadius:7,padding:".2rem .45rem",fontSize:".62rem",color:periodeOverride?"#856404":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
              {periodeOverride?`⚠️ P${pCourante} (forcé)`:"+/- Période"}
            </button>
          }
          {periodeOverride&&<button onClick={()=>setPeriodeOverride(null)} title="Revenir à la période actuelle" style={{background:"none",border:"none",color:C.gris,cursor:"pointer",fontSize:".72rem"}}>↩️</button>}
        </div>
      </div>

      {/* Bandeau période courante */}
      <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:12,padding:'.85rem 1rem',marginBottom:'1rem',color:C.blanc}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <div style={{fontSize:'.55rem',fontWeight:700,letterSpacing:'.1em',textTransform:'uppercase',color:C.or}}>{fmtPLabel(pCourante)} · J{joursEcoules}/21</div>
            <div style={{fontFamily:'Georgia,serif',fontSize:'1.3rem',fontWeight:600}}>{dCour.ca||0}€ <span style={{fontSize:'.7rem',fontWeight:400,color:C.pale}}>/ {dCour.obj||'—'}€</span></div>
          </div>
          <div style={{textAlign:'right'}}>
            {teteD!==null&&<div style={{fontSize:'.72rem',fontWeight:700,color:flecheCA(teteD).c}}>{flecheCA(teteD).s}{Math.abs(teteD)}€</div>}
            {teteD!==null&&<div style={{fontSize:'.58rem',color:C.pale}}>{teteD>0?'en avance':teteD<0?'en retard':'au même niveau'} {teteRef.t}</div>}
            <div style={{fontSize:'.55rem',color:C.pale,marginTop:'.15rem'}}>{raw.daysLeft}j {raw.hoursLeft}h restants</div>
          </div>
        </div>
        <div style={{height:5,background:'rgba(255,255,255,.15)',borderRadius:10,overflow:'hidden',marginTop:'.5rem'}}>
          <div style={{height:'100%',background:C.or,width:pct(dCour.ca,dCour.obj)+'%',borderRadius:10}}/>
        </div>
        <div className="suivi-comparaisons" style={{marginTop:'.6rem',borderTop:'1px solid rgba(255,255,255,.15)',paddingTop:'.45rem'}}>
          <div style={{fontSize:'.52rem',fontWeight:700,letterSpacing:'.1em',textTransform:'uppercase',color:C.or,marginBottom:'.2rem'}}>À J{joursEcoules}, par rapport à…</div>
          {lignesCmp.map(l=>{
            const d=l.ref===null?null:Math.round(cvCA-l.ref);
            const pc=(l.ref&&l.ref>0)?Math.round((cvCA-l.ref)/l.ref*100):null;
            return(
              <div key={l.k} style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:'.5rem',padding:'.2rem 0',borderTop:'1px solid rgba(255,255,255,.07)'}}>
                <div style={{minWidth:0}}>
                  <div style={{fontSize:'.64rem',color:C.blanc,fontWeight:600}}>{l.icone} {l.titre}</div>
                  <div style={{fontSize:'.52rem',color:C.pale}}>{l.detail}</div>
                </div>
                {d===null
                  ?<div style={{fontSize:'.55rem',color:C.pale,fontStyle:'italic'}}>—</div>
                  :<div style={{textAlign:'right',flexShrink:0}}>
                    <div style={{fontSize:'.74rem',fontWeight:700,color:flecheCA(d).c}}>{flecheCA(d).s}{Math.abs(d)}€</div>
                    {pc!==null&&pc!==0&&<div style={{fontSize:'.52rem',color:C.pale}}>{pc>0?'+':'−'}{Math.abs(pc)} %</div>}
                  </div>
                }
              </div>
            );
          })}
        </div>
      </div>

      {/* GRILLE 3 COLONNES */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'.4rem',marginBottom:'1rem'}}>
        {/* Colonne B */}
        <div style={{border:`1.5px solid #88888840`,borderRadius:12,overflow:'hidden'}}>
          <div style={{background:'#f5f5f5',height:30,boxSizing:'border-box',overflow:'hidden',padding:'.35rem .4rem .3rem',borderBottom:'1px solid #88888820',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <button onClick={()=>setCompareB(b=>Math.max(1,b-1))} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'.85rem',lineHeight:1,padding:0}}>‹</button>
            <span onClick={()=>setEditColB(true)} style={{fontSize:'.55rem',fontWeight:700,color:'#888',cursor:'pointer',textAlign:'center'}}>{editColB?<input type='number' autoFocus value={inputB} onChange={e=>setInputB(e.target.value)} onBlur={()=>{const v=parseInt(inputB);if(v>0)setCompareB(v);setEditColB(false);}} onKeyDown={e=>e.key==='Enter'&&(setCompareB(parseInt(inputB)||1),setEditColB(false))} style={{width:36,border:'1px solid #888',borderRadius:4,fontSize:'.55rem',padding:'.08rem',textAlign:'center',fontFamily:'inherit'}}/>:fmtPLabel(compareB)}</span>
            <button onClick={()=>setCompareB(b=>Math.min(pCourante-1,b+1))} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'.85rem',lineHeight:1,padding:0}}>›</button>
          </div>
          <GrilleJoursCA pNum={compareB} color='#888' joursEcoules={joursEcoules} data={data} editCell={editCell} editVal={editVal} setEditCell={setEditCell} setEditVal={setEditVal} saveJour={saveJour} setEditPeriode={setEditPeriode} setEditCA={setEditCA} setEditObj={setEditObj} setEditNote={setEditNote} setEditCaPerso={setEditCaPerso} setEditRecrues={setEditRecrues}/>
        </div>

        {/* Colonne A */}
        <div style={{border:`1.5px solid ${C.lilas}40`,borderRadius:12,overflow:'hidden'}}>
          <div style={{background:C.lilas+'10',height:30,boxSizing:'border-box',overflow:'hidden',padding:'.35rem .4rem .3rem',borderBottom:`1px solid ${C.lilas}20`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <button onClick={()=>setCompareA(a=>Math.max(1,a-1))} style={{background:'none',border:'none',color:C.lilas,cursor:'pointer',fontSize:'.85rem',lineHeight:1,padding:0}}>‹</button>
            <span onClick={()=>setEditColA(true)} style={{fontSize:'.55rem',fontWeight:700,color:C.lilas,cursor:'pointer',textAlign:'center'}}>{editColA?<input type='number' autoFocus value={inputA} onChange={e=>setInputA(e.target.value)} onBlur={()=>{const v=parseInt(inputA);if(v>0)setCompareA(v);setEditColA(false);}} onKeyDown={e=>e.key==='Enter'&&(setCompareA(parseInt(inputA)||1),setEditColA(false))} style={{width:36,border:`1px solid ${C.lilas}`,borderRadius:4,fontSize:'.55rem',padding:'.08rem',textAlign:'center',fontFamily:'inherit'}}/>:fmtPLabel(compareA)}</span>
            <button onClick={()=>setCompareA(a=>Math.min(pCourante-1,a+1))} style={{background:'none',border:'none',color:C.lilas,cursor:'pointer',fontSize:'.85rem',lineHeight:1,padding:0}}>›</button>
          </div>
          <GrilleJoursCA pNum={compareA} color={C.lilas} joursEcoules={joursEcoules} data={data} editCell={editCell} editVal={editVal} setEditCell={setEditCell} setEditVal={setEditVal} saveJour={saveJour} setEditPeriode={setEditPeriode} setEditCA={setEditCA} setEditObj={setEditObj} setEditNote={setEditNote} setEditCaPerso={setEditCaPerso} setEditRecrues={setEditRecrues}/>
        </div>
        {/* Colonne courante */}
        <div style={{border:`1.5px solid ${C.rose}40`,borderRadius:12,overflow:'hidden'}}>
          <div style={{background:C.rose+'10',height:30,boxSizing:'border-box',padding:'.35rem .4rem .3rem',borderBottom:`1px solid ${C.rose}20`,display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{fontSize:'.55rem',fontWeight:700,color:C.rose,letterSpacing:'.08em'}}>EN COURS</span></div>
          <GrilleJoursCA pNum={pCourante} color={C.rose} courante={true} joursEcoules={joursEcoules} data={data} editCell={editCell} editVal={editVal} setEditCell={setEditCell} setEditVal={setEditVal} saveJour={saveJour} setEditPeriode={setEditPeriode} setEditCA={setEditCA} setEditObj={setEditObj} setEditNote={setEditNote} setEditCaPerso={setEditCaPerso} setEditRecrues={setEditRecrues}/>
        </div>
      </div>

      {/* Formulaire édition total */}
      {editPeriode&&(
        <div style={{background:C.blanc,border:`1px solid ${C.rose}`,borderRadius:12,padding:'1rem',marginBottom:'1rem'}}>
          <div style={{fontSize:'.7rem',fontWeight:700,color:C.brun,marginBottom:'.6rem'}}>✏️ {fmtPLabel(editPeriode)} — {fmtDate(getPeriodeDebut(editPeriode))}</div>
          <div style={{display:'flex',gap:'.5rem',marginBottom:'.6rem'}}>
            <div style={{flex:1}}>
              <div style={{fontSize:'.6rem',color:C.gris,marginBottom:'.2rem'}}>CA total (€)</div>
              <input type='number' value={editCA} onChange={e=>setEditCA(e.target.value)} placeholder='0'
                style={{width:'100%',border:`1px solid ${C.pale}`,borderRadius:8,padding:'.45rem .65rem',fontSize:'.85rem',fontFamily:'inherit',color:C.texte,background:C.creme,outline:'none',fontWeight:700}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:'.6rem',color:C.gris,marginBottom:'.2rem'}}>Objectif (€)</div>
              <input type='number' value={editObj} onChange={e=>setEditObj(e.target.value)} placeholder='0'
                style={{width:'100%',border:`1px solid ${C.pale}`,borderRadius:8,padding:'.45rem .65rem',fontSize:'.85rem',fontFamily:'inherit',color:C.texte,background:C.creme,outline:'none',fontWeight:700}}/>
            </div>
          </div>
          <div style={{display:'flex',gap:'.5rem',marginBottom:'.6rem'}}>
            <div style={{flex:1}}>
              <div style={{fontSize:'.6rem',color:C.gris,marginBottom:'.2rem'}}>Ventes perso (€)</div>
              <input type='number' value={editCaPerso} onChange={e=>setEditCaPerso(e.target.value)} placeholder='0'
                style={{width:'100%',border:`1px solid ${C.pale}`,borderRadius:8,padding:'.45rem .65rem',fontSize:'.85rem',fontFamily:'inherit',color:C.texte,background:C.creme,outline:'none',fontWeight:700}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:'.6rem',color:C.gris,marginBottom:'.2rem'}}>Recrues</div>
              <input type='number' value={editRecrues} onChange={e=>setEditRecrues(e.target.value)} placeholder='0'
                style={{width:'100%',border:`1px solid ${C.pale}`,borderRadius:8,padding:'.45rem .65rem',fontSize:'.85rem',fontFamily:'inherit',color:C.texte,background:C.creme,outline:'none',fontWeight:700}}/>
            </div>
          </div>
          <div style={{marginBottom:'.6rem'}}>
            <div style={{fontSize:'.6rem',color:C.gris,marginBottom:'.2rem'}}>Note (optionnel)</div>
            <textarea value={editNote} onChange={e=>setEditNote(e.target.value)} placeholder="Ex: mois plus calme, congés..."
              style={{width:'100%',border:`1px solid ${C.pale}`,borderRadius:8,padding:'.45rem .65rem',fontSize:'.78rem',fontFamily:'inherit',color:C.texte,background:C.creme,outline:'none',resize:'vertical',minHeight:50}}/>
          </div>
          <div style={{display:'flex',gap:'.4rem'}}>
            <button onClick={saveEdit} disabled={saving}
              style={{flex:1,background:C.brun,color:C.blanc,border:'none',borderRadius:8,padding:'.5rem',fontSize:'.78rem',fontWeight:600,fontFamily:'inherit',cursor:'pointer'}}>
              {saving?'Sauvegarde...':'✓ Enregistrer'}
            </button>
            <button onClick={()=>setEditPeriode(null)}
              style={{flex:1,background:C.pale,color:C.gris,border:'none',borderRadius:8,padding:'.5rem',fontSize:'.78rem',fontFamily:'inherit',cursor:'pointer'}}>Annuler</button>
          </div>
        </div>
      )}

      {/* HISTORIQUE — par année puis période */}
      <div style={{marginBottom:'.5rem',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div style={{fontSize:'.6rem',fontWeight:700,letterSpacing:'.1em',textTransform:'uppercase',color:C.gris}}>📅 Historique</div>
        <div style={{display:'flex',gap:'.3rem'}}>
          {anneesDispos.map(a=>(
            <button key={a} onClick={()=>{setHistAnnee(a);setHistPeriodeOuverte(null);}}
              style={{padding:'.22rem .55rem',fontSize:'.65rem',fontWeight:600,borderRadius:8,border:`1px solid ${histAnnee===a?C.brun:C.pale}`,background:histAnnee===a?C.brun:C.blanc,color:histAnnee===a?C.blanc:C.gris,cursor:'pointer',fontFamily:'inherit'}}>
              {a}
            </button>
          ))}
        </div>
      </div>

      {periodesDeAnnee(histAnnee).reverse().map(num=>{
        const d3=data[`p${num}`]||{};
        const pc3=pct(d3.ca||0,d3.obj||0);
        const isCourante=num===pCourante;
        const isOuverte=histPeriodeOuverte===num;
        const numAnnee=((num-1)%PERIODES_PAR_AN+PERIODES_PAR_AN)%PERIODES_PAR_AN+1;
        return(
          <div key={num} style={{marginBottom:'.4rem',border:`1.5px solid ${isCourante?C.rose:isOuverte?C.brun:C.pale}`,borderRadius:isOuverte?'12px 12px 0 0':12,overflow:'hidden'}}>
            {/* Ligne de la période */}
            <div onClick={()=>setHistPeriodeOuverte(isOuverte?null:num)}
              style={{display:'flex',alignItems:'center',gap:'.6rem',background:isCourante?C.brun:isOuverte?C.brun+'08':C.blanc,padding:'.5rem .85rem',cursor:'pointer'}}>
              <div style={{width:36,height:36,borderRadius:'50%',background:isCourante?C.or+'30':C.rose+'15',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,fontSize:'.65rem',fontWeight:700,color:isCourante?C.or:C.rose}}>P{numAnnee}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:'.62rem',fontWeight:600,color:isCourante?C.blanc:C.brun}}>{fmtDate(getPeriodeDebut(num))} → {fmtDate(new Date(getPeriodeDebut(num).getTime()+20*24*60*60*1000))}</div>
                <div style={{height:4,background:isCourante?'rgba(255,255,255,.15)':C.pale,borderRadius:10,overflow:'hidden',marginTop:'.2rem'}}>
                  <div style={{height:'100%',background:isCourante?C.or:C.rose,width:pc3+'%',borderRadius:10}}/>
                </div>
              </div>
              <div style={{textAlign:'right',flexShrink:0}}>
                <div style={{fontFamily:'Georgia,serif',fontSize:'.9rem',fontWeight:700,color:isCourante?C.blanc:C.brun}}>{d3.ca||'—'}{d3.ca?'€':''}</div>
                <div style={{fontSize:'.58rem',color:isCourante?C.pale:C.gris}}>{d3.obj?pc3+'%':''}</div>
              </div>
              <div style={{fontSize:'.75rem',color:isCourante?C.pale:C.gris,transform:isOuverte?'rotate(90deg)':'none',transition:'transform .2s',flexShrink:0}}>›</div>
            </div>

            {/* Grille jour par jour dépliable */}
            {isOuverte&&(
              <div style={{borderTop:`1px solid ${C.pale}`,background:C.blanc}}>
                <div style={{padding:'.5rem .65rem .2rem',background:C.creme,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div style={{fontSize:'.6rem',color:C.gris}}>Clique sur un jour pour saisir ou modifier</div>
                  <button onClick={()=>{setEditPeriode(num);setEditCA(d3.ca||'');setEditObj(d3.obj||'');setEditCaPerso(d3.caPerso||'');setEditRecrues(d3.recrues||'');setEditNote(d3.note||'');}}
                    style={{background:C.brun,color:C.blanc,border:'none',borderRadius:6,padding:'.2rem .5rem',fontSize:'.6rem',fontWeight:600,fontFamily:'inherit',cursor:'pointer'}}>✏️ Total & Obj.</button>
                </div>
                <GrilleJoursCA pNum={num} color={isCourante?C.rose:C.lilas} courante={isCourante} joursEcoules={joursEcoules} data={data} editCell={editCell} editVal={editVal} setEditCell={setEditCell} setEditVal={setEditVal} saveJour={saveJour} setEditPeriode={setEditPeriode} setEditCA={setEditCA} setEditObj={setEditObj} setEditNote={setEditNote} setEditCaPerso={setEditCaPerso} setEditRecrues={setEditRecrues}/>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}


function ResumeSemaineChef({annuaire}){
  const [resume,setResume]=useState(null);
  const [ouvert,setOuvert]=useState(false);
  useEffect(()=>{
    (async()=>{
      try{
        const membres=Object.entries(annuaire||{});
        if(!membres.length) return;
        const lundi=new Date();lundi.setDate(lundi.getDate()-lundi.getDay()+1);
        const lundiStr=lundi.toISOString().slice(0,10);
        const snaps=await Promise.all(membres.map(([mUid])=>getDoc(doc(db,"users",mUid)).catch(()=>null)));
        let actives=0,diags=0,cmds=0,ca=0,det=[];
        snaps.forEach((snap,i)=>{
          if(!snap?.exists()) return;
          const d=snap.data();const [mUid,mData]=membres[i];
          const nom=mData.prenom||mUid.split("-").map(w=>w[0]?.toUpperCase()+w.slice(1)).join(" ");
          const actif=(d["db-last-login"]||"")>=lundiStr;if(actif)actives++;
          const nd=(d["db-diagnostics"]?JSON.parse(d["db-diagnostics"]):[]).filter(dg=>dg.date>=lundiStr).length;diags+=nd;
          let nc=0,nca=0;
          (d["db-clients"]?JSON.parse(d["db-clients"]):[]).forEach(cl=>{(cl.commandes||[]).filter(cmd=>cmd.date>=lundiStr).forEach(cmd=>{nc++;nca+=parseFloat(cmd.montant)||0;});});
          cmds+=nc;ca+=nca;
          det.push({nom,actif,nd,nc,nca:Math.round(nca)});
        });
        setResume({actives,total:membres.length,diags,cmds,ca:Math.round(ca),det:det.sort((a,b)=>(b.actif?1:0)-(a.actif?1:0)||b.nd-a.nd)});
      }catch{}
    })();
  },[annuaire]);
  if(!resume) return null;
  return(
    <div style={{background:C.brun,borderRadius:14,padding:"1rem 1.1rem",marginBottom:"1rem"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".65rem"}}>
        <div><div style={{fontSize:".55rem",fontWeight:700,letterSpacing:".15em",color:C.or,marginBottom:".2rem"}}>CETTE SEMAINE</div><div style={{fontFamily:"Georgia,serif",fontSize:"1rem",color:"white",fontWeight:300}}>{resume.actives} active{resume.actives>1?"s":""} / {resume.total}</div></div>
        <button onClick={()=>setOuvert(!ouvert)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:8,padding:".3rem .65rem",color:"rgba(255,255,255,.8)",fontSize:".68rem",cursor:"pointer",fontFamily:"inherit"}}>{ouvert?"Fermer":"Détails"}</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".4rem",marginBottom:ouvert?".75rem":"0"}}>
        {[[resume.diags,"Diagnostics",C.rose],[resume.cmds,"Commandes",C.or],[resume.ca+"EUR","CA",C.vert]].map(([val,label,col])=>(<div key={label} style={{textAlign:"center",background:"rgba(255,255,255,.08)",borderRadius:8,padding:".45rem .3rem"}}><div style={{fontSize:"1.1rem",fontWeight:700,color:col}}>{val}</div><div style={{fontSize:".58rem",color:"rgba(255,255,255,.55)"}}>{label}</div></div>))}
      </div>
      {ouvert&&<div style={{borderTop:"1px solid rgba(255,255,255,.1)",paddingTop:".65rem"}}>
        {resume.det.map((m,i)=>(<div key={i} style={{display:"flex",alignItems:"center",gap:".6rem",padding:".35rem 0",borderBottom:i<resume.det.length-1?"1px solid rgba(255,255,255,.06)":"none"}}>
          <div style={{width:8,height:8,borderRadius:"50%",background:m.actif?C.vert:"rgba(255,255,255,.2)",flexShrink:0}}/>
          <div style={{flex:1,fontSize:".75rem",color:m.actif?"white":"rgba(255,255,255,.4)",fontWeight:m.actif?600:400}}>{m.nom}</div>
          <div style={{display:"flex",gap:".5rem"}}>
            {m.nd>0&&<span style={{fontSize:".62rem",color:C.rose,fontWeight:600}}>{m.nd} diag</span>}
            {m.nc>0&&<span style={{fontSize:".62rem",color:C.or,fontWeight:600}}>{m.nc} cmd</span>}
            {m.nca>0&&<span style={{fontSize:".62rem",color:C.vert,fontWeight:600}}>{m.nca}EUR</span>}
            {!m.actif&&<span style={{fontSize:".6rem",color:"rgba(255,255,255,.3)"}}>Absente</span>}
          </div>
        </div>))}
      </div>}
    </div>
  );
}
function EspaceChefTab({uid, isChef}){
  const[section,setSection]=useState("");
  const[showDecouverte,setShowDecouverte]=useState(false);
  const[distrib,setDistrib]=useState([]);
  const[annuaire,setAnnuaire]=useState({});
  const[showMsg,setShowMsg]=useState(false);
  const[showAnnonceAdmin,setShowAnnonceAdmin]=useState(false);
  const[showMsgsRecus,setShowMsgsRecus]=useState(false);
  const[nbMsgsNonLus,setNbMsgsNonLus]=useState(0);
  const userName=uid.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");
  const isMelissaChef = uid==="melissa"||uid==="melissa-da-silveira";
  const sections = ESPACE_CHEF_SECTIONS.filter(s=>{
    if(s.melissaOnly) return isMelissaChef;
    if(s.chefOnly) return isChef;
    return true;
  });

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"equipe","annuaire"));
        setAnnuaire(snap.exists()?snap.data().membres||{}:{});
      }catch{}
      try{
        const snap2=await getDoc(doc(db,"messages",uid));
        if(snap2.exists()){
          const msgs=snap2.data().msgs||[];
          setNbMsgsNonLus(msgs.filter(m=>!m.lu).length);
        }
      }catch{}
    })();
  },[uid]);

  // Charge les distributeurs manuels depuis Firebase quand on entre dans cette section
  const loadDistrib=async()=>{
    const data=await sgAll(uid);
    if(data["db-distributeurs"]){try{setDistrib(JSON.parse(data["db-distributeurs"]));}catch{}}
  };
  const saveDistrib=(d)=>{setDistrib(d);ss(uid,"db-distributeurs",JSON.stringify(d));};

  if(section){
    const s=sections.find(x=>x.id===section);
    return(
      <div>
        <button onClick={()=>setSection("")}
          style={{background:"none",border:"none",color:C.rose,fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit",padding:0,marginBottom:".75rem"}}>
          ← Retour à Espace Chef
        </button>
        {section==="stats"&&<StatsEquipeTab uid={uid} annuaire={annuaire}/>}
        {section==="challengeapp"&&<ChallengeAppSuiviTab annuaire={annuaire}/>}
        {section==="suivica"&&<SuiviCATab uid={uid}/>}
        {section==="suiviboutique"&&<SuiviBoutiqueEquipeTab/>}
        {section==="actionsbiblio"&&<ActionsBiblioChefTab uid={uid}/>}
        {section==="membres"&&<MembresTab uid={uid}/>}
        {section==="assiduite"&&<AssiduiteTab uid={uid}/>}
        {section==="suiviformation"&&<SuiviFormationTab uid={uid}/>}
        {section==="defi"&&<DefisTab uid={uid} userName={uid.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ")} canCreate={true} isChef={isChef} depuisEspaceChef={true}/>}
        {section==="powerhour"&&<PowerHourTab uid={uid} userName={uid.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ")} canCreate={isChef}/>}
        {section==="distributeurs"&&<DistributeursTab distributeurs={distrib} save={saveDistrib} uid={uid}/>}
        {section==="monequipe"&&<MonEquipeTab uid={uid}/>}
        {section==="nouveaux"&&<SuiviRecruTab uid={uid} isChef={isChef}/>}
        {section==="admin"&&(uid==="melissa"||uid==="melissa-da-silveira")&&<AdminTab uid={uid}/>}
        {section==="reclassertemoignages"&&(uid==="melissa"||uid==="melissa-da-silveira")&&<ReclasserTemoignagesTab/>}
        {section==="maintenance"&&(uid==="melissa"||uid==="melissa-da-silveira")&&<MaintenanceTab uid={uid}/>}
      </div>
    );
  }

  return(
    <div>
      {showMsg&&<MessageEquipePopup uid={uid} userName={userName} annuaire={annuaire} onClose={()=>setShowMsg(false)}/>}
      {showAnnonceAdmin&&<AnnonceAdminPopup uid={uid} onClose={()=>setShowAnnonceAdmin(false)}/>}
      {showMsgsRecus&&<MessagesRecusPopup uid={uid} onClose={()=>{setShowMsgsRecus(false);setNbMsgsNonLus(0);}}/>}

      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:".5rem"}}><button onClick={()=>setShowDecouverte(true)} style={{background:"#C49A8A",color:"white",border:"none",borderRadius:20,padding:".35rem 1rem",fontSize:".75rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",boxShadow:"0 2px 8px rgba(196,154,138,.4)"}}>🧭 Découverte</button></div>
      {showDecouverte&&<DecouverteTour outil="espacechef" onClose={()=>setShowDecouverte(false)}/>}
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Espace <em style={{fontStyle:"italic",color:C.rose}}>Chef</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Toutes tes fonctions de cheffe d'équipe, au même endroit.
      </p>

      <CarteFavorisMihi uid={uid} avecCatalogue={isMelissaChef}/>

      {/* Boutons messagerie */}
      <div style={{display:"flex",gap:".5rem",marginBottom:"1rem"}}>
        <button onClick={()=>setShowMsg(true)}
          style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:".4rem",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".6rem",fontSize:".76rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          💬 Envoyer un message
        </button>
        <button onClick={()=>setShowMsgsRecus(true)}
          style={{position:"relative",background:nbMsgsNonLus>0?C.rose+"15":C.creme,border:`1px solid ${nbMsgsNonLus>0?C.rose:C.pale}`,borderRadius:10,padding:".6rem .9rem",fontSize:".76rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",color:nbMsgsNonLus>0?C.rose:C.gris}}>
          📭 Reçus
          {nbMsgsNonLus>0&&(
            <span style={{position:"absolute",top:-6,right:-6,background:C.rose,color:"white",borderRadius:"50%",minWidth:18,height:18,fontSize:".6rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>
              {nbMsgsNonLus}
            </span>
          )}
        </button>
      </div>

      {/* Mise à jour app */}
      <div style={{marginBottom:"1rem"}}>
        {isMelissaChef&&(
        <div style={{marginBottom:"1rem"}}>
          <button onClick={()=>setShowAnnonceAdmin(true)}
            style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:".4rem",background:"#B8442F",color:C.blanc,border:"none",borderRadius:10,padding:".6rem",fontSize:".76rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            Annonce officielle a toute l equipe
          </button>
        </div>
      )}

      <BoutonMiseAJour style={{width:"100%",justifyContent:"center"}}/>
      </div>

      <ResumeSemaineChef annuaire={annuaire}/>

      {Object.entries(sections.reduce((acc,s)=>{
        const g=s.groupe||"Autre";
        (acc[g]=acc[g]||[]).push(s);
        return acc;
      },{})).map(([groupe,items])=>(
        <div key={groupe} style={{marginBottom:"1.1rem"}}>
          <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".5rem",paddingLeft:".2rem"}}>{groupe}</div>
          {items.map(s=>(
            <div key={s.id} id={"decouverte-chef-"+s.id} onClick={()=>{if(s.id==="distributeurs")loadDistrib();setSection(s.id);}}
              style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem 1rem",marginBottom:".5rem",cursor:"pointer"}}>
              <div style={{display:"flex",alignItems:"center",gap:".7rem"}}>
                <div style={{width:38,height:38,borderRadius:"50%",background:C.rose+"20",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.1rem",flexShrink:0}}>{s.icon}</div>
                <div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:".92rem",fontWeight:600,color:C.brun}}>{s.label}</div>
                  <div style={{fontSize:".66rem",color:C.gris}}>{s.desc}</div>
                </div>
              </div>
              <span style={{color:C.pale}}>›</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}


function MonEquipeTab({uid}){
  const[annuaire,setAnnuaire]=useState({});
  const[loading,setLoading]=useState(true);
  const[isChef,setIsChef]=useState(false);
  const[authorized,setAuthorized]=useState(false);
  const[expanded,setExpanded]=useState(null);
  const[search,setSearch]=useState(""); // Chemin de navigation : liste d'uids, le dernier = dossier actuellement ouvert
  const[path,setPath]=useState([]);

  useEffect(()=>{
    (async()=>{
      try{
        const accesSnap=await getDoc(doc(db,"acces","membres"));
        const chefs=accesSnap.exists()?accesSnap.data().chefs||[]:[];
        const chef=(Array.isArray(chefs)?chefs:Object.values(chefs||{})).includes(uid.replace(/-/g," "))||uid==="melissa-da-silveira"||uid==="melissa";
        setIsChef(chef);

        const annSnap=await getDoc(doc(db,"equipe","annuaire"));
        const annuaire=annSnap.exists()?annSnap.data().membres||{}:{};
        setAnnuaire(annuaire);

        const hasTeam = Object.values(annuaire).some(m=>m.marraine===uid);
        if(!chef&&!hasTeam){setLoading(false);return;}
        setAuthorized(true);
      }catch{}
      setLoading(false);
    })();
  },[uid]);

  const fmt=(id)=>id.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");

  if(loading)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  if(!authorized)return(
    <div style={{textAlign:"center",padding:"3rem 1rem",color:C.gris}}>
      <div style={{fontSize:"2rem",marginBottom:".75rem"}}>👑</div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1rem",color:C.brun,marginBottom:".4rem"}}>Pas encore d'équipe</div>
      <div style={{fontSize:".75rem",lineHeight:1.6}}>Cet espace s'active dès que tu as au moins une filleule.<br/>Reviens ici quand quelqu'un t'aura choisie comme marraine !</div>
    </div>
  );

  // Racine = mes propres filleules directes
  const currentUid = path.length>0 ? path[path.length-1] : uid;
  const enfants = Object.values(annuaire).filter(m=>m.marraine===currentUid);
  const currentPerson = path.length>0 ? annuaire[currentUid] : null;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Mon <em style={{fontStyle:"italic",color:C.rose}}>Équipe</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        {path.length===0
          ? `Tes ${enfants.length} filleule${enfants.length>1?"s":""} directe${enfants.length>1?"s":""}. Clique sur 📁 pour voir la sous-équipe d'une personne.`
          : `Équipe de ${currentPerson?fmt(currentPerson.uid):""} — ${enfants.length} filleule${enfants.length>1?"s":""} directe${enfants.length>1?"s":""}.`}
      </p>

      {/* Fil d'ariane */}
      {path.length>0&&(
        <div style={{display:"flex",flexWrap:"wrap",gap:".3rem",alignItems:"center",marginBottom:"1rem",fontSize:".7rem"}}>
          <button onClick={()=>setPath([])} style={{background:"none",border:"none",color:C.rose,fontWeight:600,cursor:"pointer",fontFamily:"inherit",padding:".2rem"}}>🏠 Mon équipe</button>
          {path.map((pUid,i)=>(
            <span key={pUid} style={{display:"flex",alignItems:"center",gap:".3rem"}}>
              <span style={{color:C.pale}}>›</span>
              <button onClick={()=>setPath(path.slice(0,i+1))}
                style={{background:"none",border:"none",color:i===path.length-1?C.brun:C.rose,fontWeight:i===path.length-1?700:600,cursor:"pointer",fontFamily:"inherit",padding:".2rem"}}>
                {fmt(pUid)}
              </button>
            </span>
          ))}
        </div>
      )}

      {/* Fiche de la personne dont on consulte l'équipe */}
      {currentPerson&&(
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".9rem 1rem",marginBottom:"1rem"}}>
          <div style={{display:"flex",gap:".6rem",alignItems:"center",marginBottom:".6rem"}}>
            <div style={{width:34,height:34,borderRadius:"50%",background:C.rose+"20",color:C.rose,fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {fmt(currentPerson.uid)[0]}
            </div>
            <div style={{fontFamily:"Georgia,serif",fontSize:".95rem",fontWeight:600,color:C.brun}}>{fmt(currentPerson.uid)}</div>
          </div>
          <MembreStatsCard m={currentPerson} expanded={expanded===currentPerson.uid} onToggleExpand={()=>setExpanded(expanded===currentPerson.uid?null:currentPerson.uid)}/>
        </div>
      )}

      {enfants.length===0&&!search&&(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".76rem"}}>
          {path.length===0
            ?<>Aucune fille ne t'a encore choisie comme marraine.<br/>Elles apparaîtront ici dès qu'elles t'auront sélectionnée à l'inscription ou via le pop-up.</>
            :"Cette personne n'a pas encore de filleules."}
        </div>
      )}

      {enfants.length>0&&(
        <input placeholder="🔍 Rechercher dans l'équipe..." value={search} onChange={e=>setSearch(e.target.value)}
          style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .7rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".75rem",boxSizing:"border-box"}}/>
      )}

      {enfants.filter(m=>!search||fmt(m.uid).toLowerCase().includes(search.toLowerCase())).map(m=>{
        const sousEquipeCount = countEquipeSafe(annuaire, m.uid);
        const hasTeam = sousEquipeCount>0;
        return(
          <div key={m.uid} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".7rem 1rem",marginBottom:".5rem"}}>
            <div style={{display:"flex",gap:".6rem",alignItems:"center"}}>
              <div style={{width:34,height:34,borderRadius:"50%",background:C.rose+"20",color:C.rose,fontFamily:"Georgia,serif",fontSize:"1rem",fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {fmt(m.uid)[0]}
              </div>
              <div style={{flex:1}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:".92rem",fontWeight:600,color:C.brun}}>{fmt(m.uid)}</div>
                <div style={{fontSize:".62rem",color:C.gris}}>{m.palier||"2%"}{m.ca?` · ${m.ca}€`:""}</div>
              </div>
              {hasTeam&&(
                <button onClick={()=>setPath([...path,m.uid])}
                  style={{display:"flex",alignItems:"center",gap:".3rem",background:C.lilas+"15",border:`1px solid ${C.lilas}50`,borderRadius:8,padding:".35rem .6rem",fontSize:".68rem",fontWeight:600,color:C.lilas,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>
                  📁 {sousEquipeCount}
                </button>
              )}
              <button onClick={async()=>{
                try{
                  const ref=doc(db,"users",m.uid);
                  const snap=await getDoc(ref);
                  const existing=snap.exists()&&snap.data()["db-fast-start"]?JSON.parse(snap.data()["db-fast-start"]):{};
                  const nom=(m.prenom||"")+" "+(m.nom||"");
                  if(!existing.startDate){
                    await setDoc(ref,{"db-fast-start":JSON.stringify({startDate:todayLocalStr(),doneTasks:{},modulesValides:{}})},{merge:true});
                    alert("✅ Fast Start assigné à "+nom.trim());
                  } else {
                    if(window.confirm(nom.trim()+" a déjà un Fast Start (démarré le "+existing.startDate+"). Relancer depuis le début ?")){
                      await setDoc(ref,{"db-fast-start":JSON.stringify({startDate:todayLocalStr(),doneTasks:{},modulesValides:{}})},{merge:true});
                      alert("✅ Fast Start relancé pour "+nom.trim());
                    }
                  }
                }catch{alert("Erreur.");}
              }}
                style={{background:C.rose+"15",border:`1px solid ${C.rose}50`,borderRadius:8,padding:".35rem .55rem",fontSize:".65rem",fontWeight:600,color:C.rose,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}
                title="Assigner/relancer le Fast Start">
                🚀
              </button>
              <button onClick={()=>setExpanded(expanded===m.uid?null:m.uid)}
                style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:8,padding:".35rem .55rem",fontSize:".68rem",color:C.gris,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>
                {expanded===m.uid?"▲":"▼"}
              </button>
            </div>
            {expanded===m.uid&&(
              <div style={{marginTop:".6rem",paddingTop:".6rem",borderTop:`1px solid ${C.pale}`}}>
                <MembreStatsCard m={m} expanded={true} onToggleExpand={()=>setExpanded(null)}/>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── ADMIN TAB (Melissa uniquement) ───────────────────────────────────────────
function AdminConfigPeriodes(){
  const[ancre,setAncre]=useState("2026-01-03");
  const[periodeNum,setPeriodeNum]=useState("");
  const[periodeDebut,setPeriodeDebut]=useState("");
  const[saving,setSaving]=useState(false);
  const[saved,setSaved]=useState(false);
  const[loaded,setLoaded]=useState(false);
  const[resetUid,setResetUid]=useState("");
  const[resetResult,setResetResult]=useState("");
  const[resetSearch,setResetSearch]=useState("");
  const[membres,setMembres]=useState([]);
  const[resetSaving,setResetSaving]=useState(false);
  const[resetVals,setResetVals]=useState({});
  const[resetGlobalSaving,setResetGlobalSaving]=useState(false);
  const[resetGlobalResult,setResetGlobalResult]=useState("");

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","config_periodes"));
        if(snap.exists()&&snap.data().ancre) setAncre(snap.data().ancre.slice(0,10));
      }catch{}
      // Charger aussi les membres de l'annuaire
      try{
        const snap2=await getDoc(doc(db,"equipe","annuaire"));
        if(snap2.exists()) setMembres(Object.entries(snap2.data().membres||{}).map(([uid,m])=>({uid,prenom:m.prenom||"",nom:m.nom||""})).sort((a,b)=>(a.prenom+a.nom).localeCompare(b.prenom+b.nom)));
      }catch{}
      setLoaded(true);
    })();
  },[]);

  const save=async()=>{
    setSaving(true);
    try{
      await setDoc(doc(db,"admin","config_periodes"),{ancre:ancre+"T12:00:00"});
      // Met à jour la variable globale immédiatement
      PERIODE_DEBUT_ABSOLU_MS = new Date(ancre+"T12:00:00").getTime();
      setSaved(true);setTimeout(()=>setSaved(false),2000);
    }catch{}
    setSaving(false);
  };

  // Prévisualisation
  const ancreDate = new Date(ancre+"T00:00:00");
  const today = new Date();
  const diffMs = today.getTime() - ancreDate.getTime();
  const n = diffMs>0 ? Math.floor(diffMs/(PERIODE_DUREE_JOURS*24*60*60*1000))+1 : 1;
  const debut = new Date(ancreDate.getTime()+(n-1)*PERIODE_DUREE_JOURS*24*60*60*1000);
  const fin = new Date(debut.getTime()+PERIODE_DUREE_JOURS*24*60*60*1000-1);
  const numAnnee = ((n-1)%PERIODES_PAR_AN+PERIODES_PAR_AN)%PERIODES_PAR_AN+1;
  const resteDays = Math.ceil((fin.getTime()-today.getTime())/(24*60*60*1000));

  if(!loaded) return null;

  return(
    <div style={{background:"#FFF8E1",border:"1.5px solid #E6A817",borderRadius:12,padding:"1rem",marginBottom:"1.25rem"}}>
      <div style={{fontSize:".6rem",fontWeight:700,color:"#856404",letterSpacing:".1em",textTransform:"uppercase",marginBottom:".6rem"}}>⚙️ Configuration des Périodes Mihi</div>
      <p style={{fontSize:".7rem",color:"#856404",marginBottom:".75rem",lineHeight:1.6}}>
        La date d'ancre détermine le calcul de toutes les périodes pour <strong>toute l'équipe</strong>. Modifie uniquement si les dates sont incorrectes.
      </p>
      <div style={{marginBottom:".6rem"}}>
        <div style={{fontSize:".62rem",color:C.gris,marginBottom:".25rem",fontWeight:600}}>Je suis en periode :</div>
        <div style={{display:"flex",gap:".3rem",flexWrap:"wrap",marginBottom:".6rem"}}>{[6,7,8,9,10,11,12,13,14,15,16,17,18].map(n=>(<button key={n} onClick={()=>setPeriodeNum(String(n))} style={{padding:".3rem .55rem",fontSize:".72rem",fontWeight:700,borderRadius:8,border:"1.5px solid "+(periodeNum===String(n)?"#E6A817":"#E8DDD4"),background:periodeNum===String(n)?"#E6A817":"white",color:periodeNum===String(n)?"white":"#3D1F0E",cursor:"pointer",fontFamily:"inherit"}}>P{n}</button>))}</div>
        <div style={{fontSize:".62rem",color:C.gris,marginBottom:".25rem",fontWeight:600}}>Date de debut de cette periode</div>
        <input type="date" value={periodeDebut||""} onChange={e=>setPeriodeDebut(e.target.value)} style={{width:"100%",border:"1px solid #E6A817",borderRadius:8,padding:".42rem .65rem",fontSize:".85rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none",marginBottom:".4rem"}}/>
        {periodeNum&&periodeDebut&&<div style={{fontSize:".7rem",color:"#856404",background:"#FFF8E1",borderRadius:6,padding:".4rem .6rem",marginBottom:".4rem"}}>P{periodeNum} commence le {new Date(periodeDebut+"T00:00:00").toLocaleDateString("fr-FR",{day:"numeric",month:"long"})}</div>}
        <div style={{fontSize:".62rem",color:C.gris,marginBottom:".25rem",fontWeight:600}}>Date de début de P1 (ancre)</div>
        <input type="date" value={ancre} onChange={e=>setAncre(e.target.value)}
          style={{width:"100%",border:`1px solid #E6A817`,borderRadius:8,padding:".42rem .65rem",fontSize:".85rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none",fontWeight:600}}/>
      </div>
      {/* Prévisualisation */}
      <div style={{background:"white",borderRadius:8,padding:".5rem .75rem",marginBottom:".6rem",fontSize:".72rem",color:C.brun}}>
        <strong>Prévisualisation :</strong> Aujourd'hui = <strong style={{color:C.rose}}>P{numAnnee} {debut.getFullYear()}</strong> · {debut.toLocaleDateString("fr-FR",{day:"numeric",month:"short"})} → {fin.toLocaleDateString("fr-FR",{day:"numeric",month:"short"})} · {Math.max(0,resteDays)}j restants
      </div>
      <button onClick={save} disabled={saving}
        style={{width:"100%",background:"#E6A817",color:"white",border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
        {saving?"Sauvegarde...":saved?"✅ Appliqué à toute l'équipe !":"✓ Appliquer à toute l'équipe"}
      </button>

      {/* Reset global tous les membres */}
      <div style={{marginTop:"1rem",paddingTop:"1rem",borderTop:"1px solid #E6A817"}}>
        <div style={{fontSize:".62rem",fontWeight:700,color:"#C0392B",marginBottom:".4rem"}}>🔄 Remise à zéro de toute l'équipe</div>
        <p style={{fontSize:".68rem",color:"#856404",marginBottom:".5rem",lineHeight:1.5}}>
          Remet le CA et les recrues à 0 pour <strong>tous les membres</strong> (sans effacer le cumul ni l'historique). À utiliser au changement de période/campagne.
        </p>
        {resetGlobalResult&&<div style={{fontSize:".7rem",color:resetGlobalResult.startsWith("✅")?C.vert:"#B04040",marginBottom:".4rem"}}>{resetGlobalResult}</div>}
          <button onClick={async()=>{
            if(!window.confirm("Remettre CA et recrues a 0 pour TOUTE l equipe ? Cette action est irreversible. Les membres deja repassees en nouvelle periode seront ignorees automatiquement."))return;
            setResetGlobalSaving(true);setResetGlobalResult("");
            try{
              const annRef=doc(db,"equipe","annuaire");
              const annSnap=await getDoc(annRef);
              if(!annSnap.exists()){setResetGlobalResult("Erreur : Annuaire introuvable.");setResetGlobalSaving(false);return;}
              const membres2=annSnap.data().membres||{};
              const uids=Object.keys(membres2);
              const periodeCourante=getPeriodeActuelle();
              let ok=0,err=0,ignorees=0;
              const newMembres={...membres2};
              for(const uid2 of uids){
                try{
                  const uSnap=await getDoc(doc(db,"users",uid2));
                  if(uSnap.exists()){
                    const d2=uSnap.data();
                    if(d2["last_periode"]===periodeCourante){
                      ignorees++;
                      continue;
                    }
                    if(d2["db-obj-perso"]){
                      const obj2=JSON.parse(d2["db-obj-perso"]);
                      const hist2=obj2.historique||[];
                      if(obj2.ca||obj2.caPerso||obj2.recruesReal!=="0"){
                        hist2.push({date:todayLocalStr(),periode:periodeCourante-1,ca:+obj2.ca||0,caPerso:+obj2.caPerso||0,recruesReal:+obj2.recruesReal||0,palier:obj2.palier||"2%"});
                      }
                      const totalCaCumul=(+obj2.totalCaCumul||0)+(+obj2.ca||0);
                      const totalRecruesCumul=(+obj2.totalRecruesCumul||0)+(+obj2.recruesReal||0);
                      const nextObj2={...obj2,ca:"",caPerso:"",caEquipe:"",recruesReal:"0",nbDirecteurs:0,caDirecteurs:{},dirSelectionnes:{},historique:hist2.slice(-24),totalCaCumul:String(totalCaCumul),totalRecruesCumul:String(totalRecruesCumul)};
                      await setDoc(doc(db,"users",uid2),{"db-obj-perso":JSON.stringify(nextObj2),"last_periode":periodeCourante},{merge:true});
                      newMembres[uid2]={...membres2[uid2],ca:"",caPerso:"",recruesReal:"0"};
                    } else {
                      await setDoc(doc(db,"users",uid2),{"last_periode":periodeCourante},{merge:true});
                    }
                    ok++;
                  }
                }catch{err++;}
              }
              await setDoc(annRef,{membres:newMembres},{merge:true});
              setResetGlobalResult(`OK : ${ok} membres remis a zero, ${ignorees} deja a jour ignorees${err>0?` (${err} erreurs)`:""}.`);
            }catch(e){setResetGlobalResult("Erreur : "+e.message);}
            setResetGlobalSaving(false);
          }} disabled={resetGlobalSaving}
          style={{width:"100%",background:resetGlobalSaving?"#aaa":"#C0392B",color:"white",border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:resetGlobalSaving?"default":"pointer"}}>
          {resetGlobalSaving?"Remise à zéro en cours...":"🔄 Remettre toute l'équipe à zéro"}
        </button>
      </div>

      {/* Correction cumul individuel */}
      <div style={{marginTop:"1rem",paddingTop:"1rem",borderTop:"1px solid #E6A817"}}>
        <div style={{fontSize:".62rem",fontWeight:700,color:"#856404",marginBottom:".4rem"}}>🔧 Corriger les objectifs d'un membre</div>
        <p style={{fontSize:".68rem",color:"#856404",marginBottom:".5rem",lineHeight:1.5}}>
          Recherche un membre et modifie directement ses valeurs (cumul, CA, recrues).
        </p>
        <input value={resetSearch} onChange={e=>{setResetSearch(e.target.value);setResetResult("");setResetUid("");}}
          placeholder="Rechercher par prénom ou nom..."
          style={{width:"100%",border:"1px solid #E6A817",borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",background:"white",outline:"none",marginBottom:".4rem"}}/>
        {resetSearch.length>=2&&(()=>{
          const filtres=membres.filter(m=>(m.prenom+" "+m.nom).toLowerCase().includes(resetSearch.toLowerCase())).slice(0,6);
          if(!filtres.length) return <div style={{fontSize:".7rem",color:"#B04040",marginBottom:".4rem"}}>Aucun membre trouvé</div>;
          return(
            <div style={{background:"white",border:"1px solid #E6A817",borderRadius:8,marginBottom:".4rem",overflow:"hidden"}}>
              {filtres.map(m=>(
                <div key={m.uid} onClick={async()=>{
                  setResetUid(m.uid);setResetSearch(m.prenom+" "+m.nom);
                  // Charger les valeurs actuelles
                  try{
                    const snap=await getDoc(doc(db,"users",m.uid));
                    if(snap.exists()){
                      const d=snap.data();
                      const obj2=d["db-obj-perso"]?JSON.parse(d["db-obj-perso"]):{};
                      setResetVals({
                        ca:obj2.ca||"",caPerso:obj2.caPerso||"",recruesReal:obj2.recruesReal||"0",
                        totalCaCumul:obj2.totalCaCumul||"0",totalRecruesCumul:obj2.totalRecruesCumul||"0",
                      });
                    }
                  }catch{}
                }}
                  style={{padding:".45rem .65rem",cursor:"pointer",borderBottom:"1px solid #FFF3CD",display:"flex",justifyContent:"space-between",alignItems:"center",background:resetUid===m.uid?"#FFF3CD":"white"}}>
                  <span style={{fontSize:".78rem",color:C.brun,fontWeight:resetUid===m.uid?700:400}}>{m.prenom} {m.nom}</span>
                </div>
              ))}
            </div>
          );
        })()}

        {resetUid&&(
          <div style={{background:"#FFF8E1",borderRadius:10,padding:".75rem",border:"1px solid #E6A817",marginBottom:".5rem"}}>
            <div style={{fontSize:".65rem",fontWeight:700,color:"#856404",marginBottom:".6rem"}}>✏️ {resetSearch} — valeurs modifiables</div>
            {[
              {label:"CA total période (€)",key:"ca"},
              {label:"Ventes perso (€)",key:"caPerso"},
              {label:"Recrues cette période",key:"recruesReal"},
              {label:"Cumul CA total (€)",key:"totalCaCumul"},
              {label:"Cumul recrues total",key:"totalRecruesCumul"},
            ].map(f=>(
              <div key={f.key} style={{display:"flex",alignItems:"center",gap:".5rem",marginBottom:".35rem"}}>
                <span style={{fontSize:".65rem",color:"#856404",flex:1}}>{f.label}</span>
                <input type="number" value={resetVals[f.key]||""} onChange={e=>setResetVals(p=>({...p,[f.key]:e.target.value}))}
                  style={{width:90,border:"1px solid #E6A817",borderRadius:6,padding:".28rem .45rem",fontSize:".8rem",fontFamily:"inherit",textAlign:"right",outline:"none",fontWeight:700}}/>
              </div>
            ))}
            <div style={{display:"flex",gap:".4rem",marginTop:".5rem"}}>
              <button onClick={async()=>{
                setResetSaving(true);
                try{
                  const ref=doc(db,"users",resetUid);
                  const snap=await getDoc(ref);
                  if(!snap.exists()){setResetResult("❌ Utilisateur non trouvé.");setResetSaving(false);return;}
                  const obj2=snap.data()["db-obj-perso"]?JSON.parse(snap.data()["db-obj-perso"]):{};
                  const next={...obj2,...resetVals};
                  await setDoc(ref,{"db-obj-perso":JSON.stringify(next)},{merge:true});
                  await syncAnnuaire(resetUid,resetSearch,next);
                  setResetResult("✅ Valeurs mises à jour pour "+resetSearch);
                  setResetUid("");setResetSearch("");setResetVals({});
                }catch(e){setResetResult("Erreur : "+e.message);}
                setResetSaving(false);
              }} disabled={resetSaving}
                style={{flex:1,background:"#856404",color:"white",border:"none",borderRadius:8,padding:".45rem",fontSize:".75rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                {resetSaving?"Sauvegarde...":"✓ Appliquer"}
              </button>
              <button onClick={()=>{setResetUid("");setResetSearch("");setResetVals({});}}
                style={{flex:1,background:"#ccc",color:"white",border:"none",borderRadius:8,padding:".45rem",fontSize:".75rem",fontFamily:"inherit",cursor:"pointer"}}>
                Annuler
              </button>
            </div>
          </div>
        )}
        {resetResult&&<div style={{fontSize:".7rem",color:resetResult.startsWith("✅")?C.vert:"#B04040",marginTop:".3rem"}}>{resetResult}</div>}
      </div>
    </div>
  );
}

function AdminEbooksSection(){
  const[banniere,setBanniere]=useState({texte:"",couleur:"#C49A8A",lien:"",actif:false});
  const[saving,setSaving]=useState(false);
  const[saved,setSaved]=useState(false);
  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","linkbio_banniere"));
        if(snap.exists()) setBanniere(p=>({...p,...snap.data()}));
      }catch{}
    })();
  },[]);
  const save=async()=>{
    setSaving(true);
    try{
      await setDoc(doc(db,"admin","linkbio_banniere"),banniere);
      setSaved(true);setTimeout(()=>setSaved(false),2000);
    }catch{}
    setSaving(false);
  };
  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.25rem"}}>
      <div style={{fontSize:".6rem",fontWeight:700,color:C.rose,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".75rem"}}>🔗 Bannière Link-in-Bio (toute l'équipe)</div>
      <p style={{fontSize:".7rem",color:C.gris,marginBottom:".75rem",lineHeight:1.6}}>
        Cette bannière s'affichera sur la page de TOUTES les distributrices. Chaque membre peut choisir de l'afficher ou non.
      </p>
      <input value={banniere.texte} onChange={e=>setBanniere(p=>({...p,texte:e.target.value}))} placeholder="Ex: 🎉 Promo -20% jusqu'au 30 juin !"
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
      <input value={banniere.lien} onChange={e=>setBanniere(p=>({...p,lien:e.target.value}))} placeholder="Lien (optionnel)"
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
      <div style={{display:"flex",alignItems:"center",gap:".75rem",marginBottom:".5rem"}}>
        <div style={{fontSize:".7rem",color:C.gris}}>Couleur :</div>
        <input type="color" value={banniere.couleur} onChange={e=>setBanniere(p=>({...p,couleur:e.target.value}))} style={{width:32,height:28,border:"none",borderRadius:6,cursor:"pointer"}}/>
        <label style={{display:"flex",alignItems:"center",gap:".4rem",cursor:"pointer"}}>
          <input type="checkbox" checked={banniere.actif} onChange={e=>setBanniere(p=>({...p,actif:e.target.checked}))}/>
          <span style={{fontSize:".72rem",color:C.brun,fontWeight:600}}>Activer</span>
        </label>
      </div>
      <button onClick={save} disabled={saving}
        style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
        {saving?"Sauvegarde...":saved?"✅ Sauvegardé !":"✓ Appliquer à toute l'équipe"}
      </button>
    </div>
  );
}

function AdminImportCatalogue(){
  const[importing,setImporting]=useState(false);
  const[result,setResult]=useState(null);
  const[stats,setStats]=useState(null);

  const CAT_MAP={
    'VISAGE':'face','CORPS':'corps','CHEVEUX':'hair',
    'Make Up':'makeup','PARFUMS':'parfums','SANTÉ':'health',
    'Hommes':'hommes','Enfants':'enfants','HOME':'home','Sets':'sets',
    'nutrition':'nutrition','Nutrition':'nutrition','NUTRITION':'nutrition'
  };

  const handleFile=async(e)=>{
    const file=e.target.files?.[0];
    if(!file)return;
    setImporting(true);setResult(null);setStats(null);

    try{
      // Charger SheetJS depuis un tag script déjà présent (index.html) ou CDN via un élément script injecté
      const xlsx = await new Promise((resolve,reject)=>{
        if(window.XLSX){resolve(window.XLSX);return;}
        const s=document.createElement('script');
        s.src='https://cdn.sheetjs.com/xlsx-0.20.0/package/dist/xlsx.full.min.js';
        s.onload=()=>resolve(window.XLSX);
        s.onerror=()=>reject(new Error('SheetJS non chargé'));
        document.head.appendChild(s);
      });

      const buf=await file.arrayBuffer();
      const wb=xlsx.read(buf,{type:'array'});
      const ws=wb.Sheets[wb.SheetNames[0]];
      const rows=xlsx.utils.sheet_to_json(ws);

      const seen=new Set();
      const catalogue={};
      Object.values(CAT_MAP).forEach(k=>{catalogue[k]=[];});

      for(const row of rows){
        const art=String(row['Art']||'').replace('.0','').trim();
        if(!art||seen.has(art))continue;
        seen.add(art);
        const cat=row['Category']||'';
        const key=CAT_MAP[cat];
        if(!key)continue;
        const priceRaw=String(row['Price']||'').replace('€','').replace(',','.').trim();
        const prix=parseFloat(priceRaw)||0;
        const offerPriceRaw=String(row['Offer price']||'').replace('€','').replace(',','.').trim();
        const vipKey=Object.keys(row).find(k=>k.trim().toLowerCase()==='prix vip');
        const vipPriceRaw=String((vipKey?row[vipKey]:'')||'').replace('€','').replace(',','.').trim();
        // Colonne optionnelle « Prix catalogue » : le prix payé par une cliente (« Price » = prix distributrice)
        const catKey=Object.keys(row).find(k=>/^(prix\s*catalogue|catalog(ue)?\s*price|prix\s*public)$/i.test(k.trim()));
        const catPriceRaw=String((catKey?row[catKey]:'')||'').replace('€','').replace(',','.').trim();
        const ruptureKey=Object.keys(row).find(k=>k.trim().toLowerCase()==='rupture');
        const ruptureRaw=String((ruptureKey?row[ruptureKey]:'')||'').trim().toLowerCase();
        const enRupture=['oui','yes','1','x','true','vrai'].includes(ruptureRaw);
        catalogue[key].push({
          nom:String(row['Name']||''),
          prix,
          ref:art,
          serie:cat,
          offre:row['Offer']?String(row['Offer']):'',
          prixOffre:offerPriceRaw?parseFloat(offerPriceRaw)||0:'',
          prixVIP:vipPriceRaw?parseFloat(vipPriceRaw)||0:'',
          prixCatalogue:catPriceRaw?parseFloat(catPriceRaw)||'':'',
          image:row['Image']?String(row['Image']).trim():'',
          rupture:enRupture,
        });
      }

      const total=Object.values(catalogue).reduce((s,v)=>s+v.length,0);
      await setDoc(doc(db,"admin","catalogue_mihi"),catalogue);
      const statsObj={};
      Object.entries(catalogue).forEach(([k,v])=>{if(v.length)statsObj[k]=v.length;});
      setStats({total,details:statsObj});
      setResult("✅ Import réussi !");
    }catch(err){
      setResult("❌ Erreur : "+err.message);
    }
    setImporting(false);
    e.target.value="";
  };

  return(
    <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.25rem"}}>
      <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".6rem"}}>📦 Import Catalogue Mihi (Excel)</div>
      <p style={{fontSize:".72rem",color:C.gris,marginBottom:".75rem",lineHeight:1.6}}>
        Sélectionne le fichier Excel du catalogue Mihi pour mettre à jour les produits dans l'application. Colonnes attendues : Art, Category, Name, Price, Offer, Offer price, <strong>Prix VIP</strong> (optionnelle), <strong>Rupture</strong> (optionnelle, mettre "Oui" pour marquer un produit en rupture), Image.
      </p>
      <label style={{display:"block",background:importing?C.pale:C.brun,color:"white",borderRadius:9,padding:".55rem",textAlign:"center",fontSize:".78rem",fontWeight:600,cursor:importing?"default":"pointer",fontFamily:"inherit"}}>
        {importing?"⏳ Import en cours...":"📂 Choisir le fichier Excel (.xlsx)"}
        <input type="file" accept=".xlsx,.xls" onChange={handleFile} style={{display:"none"}} disabled={importing}/>
      </label>
      {result&&<div style={{marginTop:".6rem",fontSize:".74rem",fontWeight:600,color:result.startsWith("✅")?C.vert:"#B04040"}}>{result}</div>}
      {stats&&(
        <div style={{background:C.creme,borderRadius:8,padding:".6rem .75rem",marginTop:".5rem"}}>
          <div style={{fontSize:".68rem",fontWeight:700,color:C.brun,marginBottom:".35rem"}}>{stats.total} produits importés :</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:".3rem"}}>
            {Object.entries(stats.details).map(([k,v])=>(
              <span key={k} style={{fontSize:".62rem",background:C.pale,borderRadius:20,padding:".1rem .45rem",color:C.brun}}>{k}: {v}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function AdminTab({uid}){
  const[items,setItems]=useState([]);
  const[loading,setLoading]=useState(true);
  const[showAdd,setShowAdd]=useState(false);
  const[editId,setEditId]=useState(null);
  const[saving,setSaving]=useState(false);
  const[videosFastStart,setVideosFastStart]=useState({});
  const[anthropicKey,setAnthropicKey]=useState("");
  const[savingKey,setSavingKey]=useState(false);
  const[savedKey,setSavedKey]=useState(false);
  useEffect(()=>{(async()=>{try{const snap=await getDoc(doc(db,"admin","config"));if(snap.exists()&&snap.data().anthropicKey)setAnthropicKey(snap.data().anthropicKey);if(snap.exists()&&snap.data().catalogueLien)setCatalogueLien(snap.data().catalogueLien);}catch{}})();},[]);
  const[catalogueLien,setCatalogueLien]=useState("");
  const[savingCatalogue,setSavingCatalogue]=useState(false);
  const[savedCatalogue,setSavedCatalogue]=useState(false);
  const sauvegarderCatalogue=async()=>{setSavingCatalogue(true);try{await setDoc(doc(db,"admin","config"),{catalogueLien:catalogueLien.trim()},{merge:true});setSavedCatalogue(true);setTimeout(()=>setSavedCatalogue(false),2000);}catch{}setSavingCatalogue(false);};
  const[datesCA,setDatesCA]=useState({});
  const[savingDatesCA,setSavingDatesCA]=useState(false);
  const[savedDatesCA,setSavedDatesCA]=useState(false);
  useEffect(()=>{(async()=>{try{const snapDCA=await getDoc(doc(db,"admin","dates_manuelles_ca"));if(snapDCA.exists()&&Object.keys(snapDCA.data().periodes||{}).length>0)setDatesCA(snapDCA.data().periodes);else setDatesCA(DATES_MANUELLES_CA);}catch{setDatesCA(DATES_MANUELLES_CA);}})();},[]);
  const sauvegarderDatesCA=async()=>{
    setSavingDatesCA(true);
    try{
      await setDoc(doc(db,"admin","dates_manuelles_ca"),{periodes:datesCA},{merge:true});
      DATES_MANUELLES_CA=datesCA;
      setSavedDatesCA(true);
      setTimeout(()=>setSavedDatesCA(false),2000);
    }catch{}
    setSavingDatesCA(false);
  };
  const sauvegarderCle=async()=>{setSavingKey(true);try{await setDoc(doc(db,"admin","config"),{anthropicKey},{merge:true});ANTHROPIC_API_KEY=anthropicKey;setSavedKey(true);setTimeout(()=>setSavedKey(false),2000);}catch{}setSavingKey(false);};
  const[savingFS,setSavingFS]=useState(false);
  const[filterDest,setFilterDest]=useState("all");

  const EMPLACEMENTS=[
    {groupe:"🎓 Formation",options:[
      {id:"demarrage",       label:"Formation Démarrage"},
      {id:"vente",           label:"Formation Vente"},
      {id:"recrutement",     label:"Formation Recrutement"},
      {id:"contenu",         label:"Formation Contenu/Réseaux"},
      {id:"devperso",        label:"Développement Personnel Business"},
      {id:"videoannexe",     label:"Vidéos Annexes"},
      {id:"outils",          label:"Formation Outils"},
      {id:"formationapp",    label:"Formation App (général)"},
      {id:"formationchef",   label:"Formation App — Chef d'équipe"},
      {id:"dashboard",        label:"Formation App — Tableau de bord"},
      {id:"outils",           label:"Formation App — Outils généraux"},
    ]},
    {groupe:"🧴 Produits",options:[
      {id:"produits_parfum",      label:"Produits — Parfum"},
      {id:"produits_makeup",      label:"Produits — Maquillage"},
      {id:"produits_complement",  label:"Produits — Compléments alimentaires"},
      {id:"produits_poids",       label:"Produits — Perte de poids"},
      {id:"produits_skincare",    label:"Produits — Skincare"},
      {id:"produits_corpsoin",    label:"Produits — Soins corps"},
      {id:"produits_entretien",   label:"Produits — Entretien"},
    ]},
    {groupe:"🏠 Dashboard",options:[
      {id:"today_top",       label:"Aujourd'hui — En-tête"},
      {id:"today_bottom",    label:"Aujourd'hui — Bas de page"},
      {id:"annonces",        label:"Annonces équipe (popup)"},
    ]},
    {groupe:"📱 Réseaux / Posts",options:[
      {id:"posts_instagram", label:"Posts — Idées Instagram"},
      {id:"posts_facebook",  label:"Posts — Idées Facebook"},
      {id:"posts_stories",   label:"Posts — Idées Stories"},
    ]},
    {groupe:"🔗 Liens & Tunnels",options:[
      {id:"linkbio_liens",   label:"Link-in-Bio — Liens supplémentaires"},
      {id:"tunnel_vente",    label:"Tunnel Vente — Ressources"},
      {id:"tunnel_recrut",   label:"Tunnel Recrutement — Ressources"},
    ]},
  ];

  const TOUS_IDS=EMPLACEMENTS.flatMap(g=>g.options.map(o=>o.id));
  const getLabel=(id)=>{
    for(const g of EMPLACEMENTS) for(const o of g.options) if(o.id===id)return o.label;
    return id;
  };

  const TYPES=[
    {id:"video",    label:"▶ Vidéo Zoom",emoji:"🎬"},
    {id:"youtube",  label:"▶ YouTube",   emoji:"▶️"},
    {id:"drive",    label:"📄 Drive",    emoji:"📄"},
    {id:"doc",      label:"📝 Google Doc",emoji:"📝"},
    {id:"image",    label:"🖼️ Image",    emoji:"🖼️"},
    {id:"info",     label:"💡 Texte",    emoji:"💡"},
    {id:"lien",     label:"🔗 Lien",     emoji:"🔗"},
  ];

  const emptyForm={destination:TOUS_IDS[0],titre:"",description:"",url:"",type:"video",actif:true,image:""};
  const[form,setForm]=useState(emptyForm);

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","contenus"));
        if(snap.exists())setItems(snap.data().items||[]);
      }catch{}
      try{
        const snap2=await getDoc(doc(db,"admin","videos_faststart"));
        if(snap2.exists())setVideosFastStart(snap2.data().videos||{});
      }catch{}
      setLoading(false);
    })();
  },[]);

  const saveItems=async(next)=>{
    setSaving(true);
    try{await setDoc(doc(db,"admin","contenus"),{items:next});}catch{}
    setSaving(false);
  };

  const saveVideoFS=async(v)=>{
    setSavingFS(true);
    try{await setDoc(doc(db,"admin","videos_faststart"),{videos:v});}catch{}
    setVideosFastStart(v);
    setSavingFS(false);
  };

  const add=async()=>{
    if(!form.titre.trim())return;
    let next;
    if(editId){
      next=items.map(it=>it.id===editId?{...it,...form}:it);
    } else {
      next=[...items,{id:`adm${Date.now()}`,...form}];
    }
    setItems(next);
    await saveItems(next);
    setForm(emptyForm);setShowAdd(false);setEditId(null);
  };

  const del=async(id)=>{
    if(!window.confirm("Supprimer ce contenu ?"))return;
    const next=items.filter(it=>it.id!==id);
    setItems(next);await saveItems(next);
  };

  const toggle=async(id)=>{
    const next=items.map(it=>it.id===id?{...it,actif:!it.actif}:it);
    setItems(next);await saveItems(next);
  };

  const startEdit=(it)=>{
    setForm({destination:it.destination||it.onglet||TOUS_IDS[0],titre:it.titre||"",description:it.description||"",url:it.url||"",type:it.type||"video",actif:it.actif!==false,image:it.image||""});
    setEditId(it.id);setShowAdd(true);
  };

  if(loading)return<div style={{textAlign:"center",padding:"2rem",color:C.gris}}>Chargement...</div>;

  const itemsFiltres=filterDest==="all"?items:items.filter(it=>(it.destination||it.onglet)===filterDest);


  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Espace <em style={{fontStyle:"italic",color:C.rose}}>Admin</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Ajoute du contenu à n'importe quel endroit du site — formations, vidéos, annonces, ressources.
      </p>

      {/* Sections fixes */}
      <AdminLinkBioSection/>
      <AdminConfigPeriodes/>
      <AdminImportCatalogue/>
      <AdminMajCatalogue/>
      <AdminFormationProduits uid={uid}/>

      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.25rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".75rem"}}>Instructions IA par diagnostic</div>
        <DiagAdminEditor/>
      </div>
      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.25rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".75rem"}}>Temoignages diagnostics (mon espace prive)</div>
        <TemoignagesDiagAdmin/>
      </div>

      {/* Fast Start vidéos */}
      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1.25rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".75rem"}}>🚀 Vidéos Fast Start — 7 modules</div>
        {FAST_START_DAYS.map(d=>{
          const key=`module${d.jour}`;
          const cur=videosFastStart[key]||{url:"",type:"youtube"};
          return(
            <div key={d.jour} style={{marginBottom:".6rem",paddingBottom:".6rem",borderBottom:`1px solid ${C.pale}`}}>
              <div style={{fontSize:".72rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>Module {d.jour} — {d.titre.split("—")[0].trim()}</div>
              <div style={{display:"flex",gap:".4rem"}}>
                <select value={cur.type} onChange={e=>{const v={...videosFastStart,[key]:{...cur,type:e.target.value}};saveVideoFS(v);}}
                  style={{border:`1px solid ${C.pale}`,borderRadius:7,padding:".35rem .4rem",fontSize:".72rem",fontFamily:"inherit",background:C.creme,outline:"none",flexShrink:0}}>
                  <option value="youtube">YouTube</option>
                  <option value="video">Zoom</option>
                  <option value="drive">Drive</option>
                </select>
                <input value={cur.url} onChange={e=>{const v={...videosFastStart,[key]:{...cur,url:e.target.value}};setVideosFastStart(v);}}
                  onBlur={()=>saveVideoFS(videosFastStart)}
                  placeholder="URL de la vidéo"
                  style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:7,padding:".35rem .55rem",fontSize:".75rem",fontFamily:"inherit",background:C.creme,outline:"none"}}/>
              </div>
            </div>
          );
        })}
        {savingFS&&<div style={{fontSize:".65rem",color:C.vert,textAlign:"right"}}>Sauvegardé ✓</div>}
      </div>

      {/* ── CONTENU LIBRE ── */}
      <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".75rem"}}>
          <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose}}>📦 Contenu libre — {items.length} éléments</div>
          <button onClick={()=>{setShowAdd(!showAdd);setForm(emptyForm);setEditId(null);}}
            style={{background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".35rem .75rem",fontSize:".72rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            {showAdd&&!editId?"✕ Annuler":"+ Ajouter"}
          </button>
        </div>

        {/* Formulaire ajout/édition */}
        {showAdd&&(
          <div style={{background:C.creme,borderRadius:10,padding:".85rem",marginBottom:".75rem",border:`1px solid ${C.pale}`}}>
            <div style={{fontSize:".68rem",fontWeight:700,color:C.brun,marginBottom:".65rem"}}>{editId?"✏️ Modifier":"+ Nouveau contenu"}</div>

            {/* Destination */}
            <div style={{marginBottom:".5rem"}}>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>📍 Où afficher ce contenu ?</div>
              <select value={form.destination} onChange={e=>setForm(p=>({...p,destination:e.target.value}))}
                style={{width:"100%",border:`1.5px solid ${C.rose}`,borderRadius:8,padding:".45rem .65rem",fontSize:".82rem",fontFamily:"inherit",color:C.brun,background:"white",outline:"none",fontWeight:600}}>
                {EMPLACEMENTS.map(g=>(
                  <optgroup key={g.groupe} label={g.groupe}>
                    {g.options.map(o=><option key={o.id} value={o.id}>{o.label}</option>)}
                  </optgroup>
                ))}
              </select>
            </div>

            <AdminSEL label="Type de contenu" field="type" options={TYPES.map(t=><option key={t.id} value={t.id}>{t.emoji} {t.label}</option>)} form={form} setForm={setForm}/>
            <AdminINP label="Titre *" field="titre" placeholder="Ex: Comment aborder une inconnue sur Instagram" form={form} setForm={setForm}/>
            <AdminINP label="Description" field="description" placeholder="Résumé, conseils..." textarea form={form} setForm={setForm}/>
            {["video","youtube","drive","doc","lien"].includes(form.type)&&
              <AdminINP label="URL" field="url" placeholder="https://..." form={form} setForm={setForm}/>
            }
            {form.type==="image"&&
              <UploadPhoto label="Image" value={form.image} onChange={v=>setForm(p=>({...p,image:v}))} folder="admin-contenu"/>
            }
            <label style={{display:"flex",alignItems:"center",gap:".5rem",fontSize:".75rem",color:C.brun,cursor:"pointer",marginTop:".25rem"}}>
              <input type="checkbox" checked={!!form.actif} onChange={e=>setForm(p=>({...p,actif:e.target.checked}))}/>
              Visible immédiatement
            </label>
            <div style={{display:"flex",gap:".4rem",marginTop:".65rem"}}>
              <button onClick={add} disabled={saving||!form.titre.trim()}
                style={{flex:1,background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                {saving?"Sauvegarde...":editId?"✓ Modifier":"✓ Ajouter"}
              </button>
              <button onClick={()=>{setShowAdd(false);setEditId(null);setForm(emptyForm);}}
                style={{flex:1,background:C.pale,color:C.gris,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontFamily:"inherit",cursor:"pointer"}}>
                Annuler
              </button>
            </div>
          </div>
        )}

        {/* Filtre par destination */}
        <div style={{marginBottom:".65rem"}}>
          <select value={filterDest} onChange={e=>setFilterDest(e.target.value)}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem .65rem",fontSize:".76rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}>
            <option value="all">Tous les contenus ({items.length})</option>
            {EMPLACEMENTS.map(g=>(
              <optgroup key={g.groupe} label={g.groupe}>
                {g.options.map(o=>{
                  const n=items.filter(it=>(it.destination||it.onglet)===o.id).length;
                  return<option key={o.id} value={o.id}>{o.label} ({n})</option>;
                })}
              </optgroup>
            ))}
          </select>
        </div>

        {/* Liste items */}
        {itemsFiltres.length===0&&<div style={{textAlign:"center",fontSize:".72rem",color:C.gris,padding:".75rem",fontStyle:"italic"}}>Aucun contenu{filterDest!=="all"?" dans cet emplacement":""}</div>}
        {itemsFiltres.map(it=>{
          const T=TYPES.find(t=>t.id===it.type)||TYPES[0];
          return(
            <div key={it.id} style={{display:"flex",alignItems:"center",gap:".5rem",background:it.actif?C.creme:"#f0f0f0",borderRadius:9,padding:".5rem .75rem",marginBottom:".35rem",border:`1px solid ${it.actif?C.pale:"#ddd"}`,opacity:it.actif?1:.7}}>
              <span style={{fontSize:"1rem",flexShrink:0}}>{T.emoji}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:".78rem",fontWeight:600,color:C.brun,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{it.titre}</div>
                <div style={{fontSize:".6rem",color:C.rose,fontWeight:600}}>📍 {getLabel(it.destination||it.onglet||"")}</div>
              </div>
              <button onClick={()=>toggle(it.id)} title={it.actif?"Masquer":"Afficher"}
                style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:6,padding:".18rem .35rem",fontSize:".65rem",color:it.actif?C.vert:C.gris,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>
                {it.actif?"👁️":"🙈"}
              </button>
              <button onClick={()=>startEdit(it)}
                style={{background:"none",border:`1px solid ${C.pale}`,borderRadius:6,padding:".18rem .35rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>✏️</button>
              <button onClick={()=>del(it.id)}
                style={{background:"none",border:`1px solid #E0C0C0`,borderRadius:6,padding:".18rem .35rem",fontSize:".65rem",color:"#B04040",cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>✕</button>
            </div>
          );
        })}
      </div>

      {/* Clé API Anthropic */}
      <div style={{background:C.creme,borderRadius:12,padding:"1rem",marginTop:"1rem",border:"1px solid "+C.pale}}>
        <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.brun,marginBottom:".5rem"}}>🔑 Clé API Anthropic (IA)</div>
        <div style={{fontSize:".72rem",color:C.gris,marginBottom:".5rem",lineHeight:1.5}}>Renouvelle-la si les diagnostics IA ne fonctionnent plus.</div>
        <input type="password" placeholder="sk-ant-api03-..." value={anthropicKey} onChange={e=>setAnthropicKey(e.target.value)}
          style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none",marginBottom:".5rem"}}/>
        <button onClick={sauvegarderCle} disabled={savingKey||!anthropicKey.trim()}
          style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".45rem 1rem",fontSize:".75rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          {savingKey?"...":savedKey?"✅ Sauvegardée !":"💾 Sauvegarder la clé"}
        </button>
      </div>

      {/* Lien catalogue LinkBio */}
      <div style={{background:C.creme,borderRadius:12,padding:"1rem",marginTop:"1rem",border:"1px solid "+C.pale}}>
        <div style={{fontSize:".68rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>Lien du catalogue produits (LinkBio)</div>
        <div style={{fontSize:".68rem",color:C.gris,marginBottom:".6rem",lineHeight:1.5}}>Ce lien sera utilisable par toutes les distributrices qui activent le catalogue sur leur page LinkBio.</div>
        <input placeholder="https://..." value={catalogueLien} onChange={e=>setCatalogueLien(e.target.value)}
          style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".45rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none",marginBottom:".5rem"}}/>
        <button onClick={sauvegarderCatalogue} disabled={savingCatalogue}
          style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".45rem 1rem",fontSize:".75rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          {savingCatalogue?"...":savedCatalogue?"Enregistre !":"Sauvegarder le lien"}
        </button>
      </div>
            {/* Dates manuelles Suivi CA 2024/2025 */}
      <div style={{background:C.creme,borderRadius:12,padding:"1rem",marginTop:"1rem",border:"1px solid "+C.pale}}>
        <div style={{fontSize:".68rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>Dates manuelles Suivi CA (2024 et 2025 uniquement)</div>
        <div style={{fontSize:".68rem",color:C.gris,marginBottom:".6rem",lineHeight:1.5}}>Ces dates remplacent le calcul automatique uniquement pour les 36 periodes de 2024 et 2025. Une fois validees, elles s'appliquent a toute l'equipe. Les autres annees ne sont pas concernees.</div>
        <div style={{maxHeight:400,overflowY:"auto",marginBottom:".6rem"}}>
          {Array.from({length:36},(_,i)=>-35+i).map(n=>(
            <div key={n} style={{display:"flex",alignItems:"center",gap:".5rem",marginBottom:".35rem"}}>
              <div style={{fontSize:".68rem",color:C.texte,width:50,flexShrink:0}}>n={n}</div>
              <input type="date" value={datesCA[n]||""} onChange={e=>setDatesCA(p=>({...p,[n]:e.target.value}))}
                style={{flex:1,border:"1px solid "+C.pale,borderRadius:8,padding:".35rem .5rem",fontSize:".75rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none"}}/>
            </div>
          ))}
        </div>
        <button onClick={sauvegarderDatesCA} disabled={savingDatesCA}
          style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".45rem 1rem",fontSize:".75rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          {savingDatesCA?"...":savedDatesCA?"Valide et applique a tous !":"Valider les dates"}
        </button>
      </div>      {/* Scripts personnalisés */}
      <div style={{background:C.creme,borderRadius:12,padding:"1rem",marginTop:"1rem",border:"1px solid "+C.pale}}>
        <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.brun,marginBottom:".75rem"}}>📝 Scripts personnalisés</div>
        <AdminScriptsEditor/>
      </div>
      {/* Nettoyage mdp */}
      <div style={{background:"#FFF0F0",borderRadius:12,padding:"1rem",marginTop:"1rem",border:"1px solid #E0C0C0"}}>
        <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#B04040",marginBottom:".5rem"}}>🔐 Réinitialiser les codes personnels</div>
        <div style={{fontSize:".72rem",color:"#888",marginBottom:".75rem",lineHeight:1.5}}>Supprime tous les db-mdp existants. Les membres devront créer un nouveau code à leur prochaine connexion.</div>
        <button onClick={async()=>{
          if(!window.confirm("Supprimer tous les codes personnels ?"))return;
          try{
            const {getDocs,collection,writeBatch}=await import("firebase/firestore");
            const snap=await getDocs(collection(db,"users"));
            const batch=writeBatch(db);
            const {deleteField}=await import("firebase/firestore");
            snap.docs.forEach(d=>{if(d.data()["db-mdp"])batch.update(d.ref,{"db-mdp":deleteField()});});
            await batch.commit();
            alert("✅ Codes supprimés !");
          }catch(e){alert("Erreur: "+e.message);}
        }} style={{background:"#B04040",color:"white",border:"none",borderRadius:8,padding:".55rem 1rem",fontSize:".75rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          🗑️ Supprimer tous les codes
        </button>
      </div>
      <div style={{background:"#F0F7FF",borderRadius:12,padding:"1rem",marginTop:"1rem",border:"1px solid #B0C4DE"}}>
        <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#1a5276",marginBottom:".5rem"}}>🔄 Forcer la mise à jour pour tous</div>
        <div style={{fontSize:".72rem",color:"#888",marginBottom:".75rem",lineHeight:1.5}}>Force toutes les membres a recharger l app au prochain chargement.</div>
        <button onClick={async()=>{try{await setDoc(doc(db,"admin","config"),{forceReload:Date.now()},{merge:true});alert("Mise a jour forcee !");}catch(e){alert("Erreur: "+e.message);}}}
          style={{background:"#1a5276",color:"white",border:"none",borderRadius:8,padding:".55rem 1rem",fontSize:".75rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
          🔄 Forcer la mise a jour
        </button>
      </div>
      <div style={{marginTop:"1.5rem",background:"#F0F7F2",border:"1px solid #5C8A6A40",borderRadius:12,padding:"1rem"}}>
        <div style={{fontSize:".62rem",fontWeight:700,color:"#3A6A4A",letterSpacing:".1em",textTransform:"uppercase",marginBottom:".5rem"}}>💾 Backup équipe complète</div>
        <div style={{fontSize:".7rem",color:"#666",marginBottom:".65rem",lineHeight:1.5}}>Télécharge ou restaure les données de TOUTE l équipe (tous les membres) en un fichier.</div>
        <button onClick={async()=>{try{const snap=await getDocs(collection(db,"users"));const all={};snap.forEach(d=>{all[d.id]=d.data();});const json=JSON.stringify(all,null,2);const blob=new Blob([json],{type:"application/json"});const url=URL.createObjectURL(blob);const a=document.createElement("a");a.href=url;a.download="backup-equipe-"+new Date().toISOString().slice(0,10)+".json";document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);}catch(e){alert("Erreur: "+e);}}} style={{background:"#3A6A4A",color:"white",border:"none",borderRadius:10,padding:".55rem 1rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginRight:".5rem",marginBottom:".5rem"}}>⬇️ Télécharger backup équipe</button>
        <input type="file" id="restore-file-input" accept="application/json" style={{display:"none"}} onChange={async(e)=>{const file=e.target.files[0];if(!file)return;const confirmText=window.prompt("Cette action va ECRASER les données actuelles de tous les membres presents dans le fichier. Tape RESTAURER pour confirmer:");if(confirmText!=="RESTAURER"){e.target.value="";return;}try{const text=await file.text();const parsed=JSON.parse(text);const uids=Object.keys(parsed);let count=0;for(const uid2 of uids){await setDoc(doc(db,"users",uid2),parsed[uid2]);count++;}alert("Restauration terminee : "+count+" membre(s) restaure(s).");}catch(err){alert("Erreur lors de la restauration: "+err.message);}e.target.value="";}}/>
        <button onClick={()=>document.getElementById("restore-file-input").click()} style={{background:"#B04040",color:"white",border:"none",borderRadius:10,padding:".55rem 1rem",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>♻️ Restaurer un backup équipe</button>
      </div>
    </div>
  );
}



function DevPersoSection({adminItems}){
  const[dvpTab,setDvpTab]=useState("business");
  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".5rem"}}>
        Développement <em style={{fontStyle:"italic",color:C.rose}}>Personnel</em>
      </div>
      <div style={{display:"flex",gap:".35rem",marginBottom:"1rem"}}>
        {[{id:"business",label:"🧠 Business"},{id:"annexe",label:"🎥 Vidéos annexes"}].map(t=>(
          <button key={t.id} onClick={()=>setDvpTab(t.id)}
            style={{flex:1,padding:".5rem",fontSize:".75rem",fontWeight:600,borderRadius:10,border:`1.5px solid ${dvpTab===t.id?C.rose:C.pale}`,background:dvpTab===t.id?C.rose:C.blanc,color:dvpTab===t.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
            {t.label}
          </button>
        ))}
      </div>
      {dvpTab==="business"&&(
        <div>
          <AdminContentBlock onglet="devperso" items={adminItems}/>
          {[
            {icon:"🧠",title:"Dégommer son plafond de verre",desc:"Identifier les croyances limitantes qui t'empêchent d'avancer et les transformer en force.",video:"https://drive.google.com/file/d/1VLaGx4hcH5bVc8xBN1_MU8RmDwhWiqk0/view",drive:true},
            {icon:"🚀",title:"Sortir de sa zone de confort",desc:"Apprendre à avancer malgré la peur et l'inconfort du changement.",video:"https://drive.google.com/file/d/1i4k0waoHx0gqlouN2ksfa919ksuKpdbF/view",drive:true},
            {icon:"🎯",title:"Fixer ses objectifs — méthode complète",desc:"Des objectifs qui fonctionnent vraiment.",video:"https://us06web.zoom.us/rec/share/E1JtWx4furUdNFt4wKKCJYcfD4ScYwhJZ3BfUnHZYOnbUzcRYLzdLq5WuoyJSjw.MsevJMjQXIrzr1rp?startTime=1771357741000"},
            {icon:"👑",title:"Développer son leadership",desc:"Comment inspirer, guider et faire grandir son équipe.",video:"https://us06web.zoom.us/rec/share/hnDWdngAPCK_SGVTYzVhgk70t_nqqfesUvZF7hme8CaEgL-CpszXoantB-d2MSPZ.Yl7wHQ7KV9pZJnCL"},
            {icon:"📱",title:"Personal branding",desc:"Qui tu es en ligne = qui tu attires.",video:"https://youtu.be/j5EUiKmUSgM"},
            {icon:"🤝",title:"Humaniser son contenu",desc:"Pourquoi les gens achètent à des personnes, pas à des marques.",video:"https://youtu.be/WxJFBnigjpw"},
            {icon:"📖",title:"Le storytelling",desc:"Raconter pour vendre, pour convaincre, pour recruter.",video:"https://youtu.be/dgylHebkai4"},
          ].map(item=>(
            <div key={item.title} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".85rem 1rem",marginBottom:".6rem"}}>
              <div style={{display:"flex",gap:".6rem",alignItems:"flex-start",marginBottom:item.video?".6rem":0}}>
                <span style={{fontSize:"1.1rem",flexShrink:0}}>{item.icon}</span>
                <div style={{flex:1}}>
                  <div style={{fontFamily:"Georgia,serif",fontSize:".9rem",fontWeight:600,color:C.brun,marginBottom:".15rem"}}>{item.title}</div>
                  <div style={{fontSize:".72rem",color:C.gris,lineHeight:1.55}}>{item.desc}</div>
                </div>
              </div>
              {item.video&&(item.drive?<DriveBtn href={item.video} label="▶ Voir la formation"/>:<YTBtn href={item.video} label="▶ Voir la formation"/>)}
            </div>
          ))}
        </div>
      )}
      {dvpTab==="annexe"&&(
        <div>
          <AdminContentBlock onglet="videoannexe" items={adminItems}/>
          <div style={{background:C.creme,borderRadius:10,padding:".75rem 1rem",fontSize:".75rem",color:C.gris,lineHeight:1.65}}>
            💡 Les vidéos annexes sont ajoutées depuis l'espace Admin.
          </div>
        </div>
      )}
    </div>
  );
}

function AdminContentBlock({onglet,items}){
  const {lang} = useLang();
  const filtered=(items||[]).filter(i=>(i.destination||i.onglet)===onglet&&i.actif!==false);
  if(filtered.length===0)return null;

  const typeConfig={
    video:{icon:"▶",color:"#8B1A1A",label:"Zoom"},
    youtube:{icon:"▶",color:"#8B1A1A",label:"YouTube"},
    drive:{icon:"📄",color:"#5C3020",label:"Drive"},
    doc:{icon:"📝",color:"#1a4a8b",label:"Doc"},
    info:{icon:"💡",color:"#5C8A60",label:"Info"},
  };

  return(
    <div style={{marginTop:".5rem"}}>
      <div style={{fontSize:".58rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:C.rose,marginBottom:".4rem"}}>✦ Ajouté par Melissa</div>
      {filtered.map(item=>{
        const cfg=typeConfig[item.type]||typeConfig.info;
        return <AdminContentItem key={item.id} item={item} cfg={cfg} lang={lang}/>;
      })}
    </div>
  );
}

function AdminContentItem({item,cfg,lang}){
  const[titre,setTitre]=useState(item.titre||"");
  const[desc,setDesc]=useState(item.description||"");

  useEffect(()=>{
    if(lang==="fr"){setTitre(item.titre||"");setDesc(item.description||"");return;}
    const toTr=[item.titre||"",item.description||""].filter(Boolean);
    if(!toTr.length)return;
    translateBatch(toTr,lang).then(res=>{
      setTitre(res[0]||item.titre);
      if(item.description) setDesc(res[1]||item.description);
    });
  },[lang,item.id]);

  return(
    <div style={{background:"rgba(196,154,138,.08)",border:`1px solid ${C.pale}`,borderRadius:10,padding:".65rem .85rem",marginBottom:".4rem"}}>
      <div style={{fontSize:".78rem",fontWeight:600,color:C.brun,marginBottom:desc?".2rem":item.url?".35rem":0}}>{titre}</div>
      {desc&&<div style={{fontSize:".72rem",color:C.gris,lineHeight:1.5,marginBottom:item.url?".4rem":0}}>{desc}</div>}
      {item.url&&(
        <a href={item.url} target="_blank" rel="noopener noreferrer"
          style={{display:"flex",alignItems:"center",gap:".5rem",background:cfg.color,borderRadius:8,padding:".45rem .8rem",textDecoration:"none",marginTop:".1rem"}}>
          <span style={{fontSize:".8rem",flexShrink:0}}>{cfg.icon}</span>
          <span style={{fontSize:".72rem",fontWeight:600,color:"white"}}>
            {lang==="pt"?"Abrir":"Ouvrir"} — {cfg.label}
          </span>
          <span style={{marginLeft:"auto",color:"rgba(255,255,255,.6)",fontSize:".6rem"}}>→</span>
        </a>
      )}
    </div>
  );
}

// ── ADMIN POSTS EDITOR ───────────────────────────────────────────────────────
function AdminPostsEditor(){
  const[items,setItems]=useState([]);
  const[loaded,setLoaded]=useState(false);
  const[saving,setSaving]=useState(false);
  const[showAdd,setShowAdd]=useState(false);
  const[form,setForm]=useState({theme:"",hook:"",caption:""});

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","posts_extra"));
        if(snap.exists()) setItems(snap.data().items||[]);
      }catch{}
      setLoaded(true);
    })();
  },[]);

  const save=async(next)=>{
    setSaving(true);
    try{await setDoc(doc(db,"admin","posts_extra"),{items:next});}catch{}
    setItems(next);
    setSaving(false);
  };

  const add=()=>{
    if(!form.theme.trim()||!form.hook.trim()||!form.caption.trim())return;
    const postId="adm-post-"+Date.now();
    const themeKey=form.theme.trim();
    const existing=items.find(t=>t.theme===themeKey);
    let next;
    if(existing){
      next=items.map(t=>t.theme===themeKey?{...t,posts:[...t.posts,{id:postId,hook:form.hook.trim(),caption:form.caption.trim()}]}:t);
    } else {
      next=[...items,{theme:themeKey,color:C.or,posts:[{id:postId,hook:form.hook.trim(),caption:form.caption.trim()}]}];
    }
    save(next);
    setForm({theme:"",hook:"",caption:""});
    setShowAdd(false);
  };

  const delPost=(themeKey,postId)=>{
    let next=items.map(t=>t.theme===themeKey?{...t,posts:t.posts.filter(p=>p.id!==postId)}:t).filter(t=>t.posts.length>0);
    save(next);
  };

  const totalPosts=items.reduce((a,t)=>a+t.posts.length,0);

  if(!loaded) return <div style={{fontSize:".74rem",color:C.gris}}>Chargement...</div>;

  return(
    <div>
      <button onClick={()=>setShowAdd(p=>!p)}
        style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:"1rem"}}>
        ➕ Ajouter une idée de post ({totalPosts})
      </button>

      {showAdd&&(
        <div style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
          <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".6rem"}}>Nouvelle idée</div>
          <input placeholder="Thème (ex: 🎉 Promo de printemps)" value={form.theme} onChange={e=>setForm(p=>({...p,theme:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".45rem"}}/>
          <input placeholder="Hook (1ère phrase qui accroche)" value={form.hook} onChange={e=>setForm(p=>({...p,hook:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".45rem"}}/>
          <textarea placeholder="Caption complète (avec CTA)" value={form.caption} onChange={e=>setForm(p=>({...p,caption:e.target.value}))}
            style={{width:"100%",minHeight:80,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .65rem",fontFamily:"inherit",fontSize:".78rem",color:C.texte,background:C.blanc,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:".6rem"}}/>
          <div style={{display:"flex",gap:".4rem"}}>
            <button onClick={add} disabled={saving} style={{flex:1,background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              {saving?"...":"Ajouter"}
            </button>
            <button onClick={()=>setShowAdd(false)} style={{flex:1,background:C.pale,color:C.gris,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontFamily:"inherit",cursor:"pointer"}}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {items.map(theme=>(
        <div key={theme.theme} style={{marginBottom:".75rem"}}>
          <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",padding:".2rem .6rem",background:C.or+"20",color:C.brun2,borderRadius:20,display:"inline-block",marginBottom:".4rem"}}>{theme.theme}</div>
          {theme.posts.map(post=>(
            <div key={post.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:9,padding:".55rem .75rem",marginBottom:".3rem",display:"flex",gap:".5rem",alignItems:"flex-start"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:".75rem",fontWeight:600,color:C.brun}}>{post.hook}</div>
                <div style={{fontSize:".68rem",color:C.gris,marginTop:".15rem"}}>{post.caption}</div>
              </div>
              <button onClick={()=>delPost(theme.theme,post.id)} style={{background:"none",border:"none",color:"#B04040",cursor:"pointer",fontSize:".7rem",padding:".15rem",fontFamily:"inherit",flexShrink:0}}>✕</button>
            </div>
          ))}
        </div>
      ))}
      {items.length===0&&<div style={{fontSize:".73rem",color:C.gris,fontStyle:"italic"}}>Aucune idée ajoutée encore.</div>}
    </div>
  );
}

// ── ADMIN SCRIPTS EDITOR ─────────────────────────────────────────────────────
function AdminScriptsEditor(){
  const[items,setItems]=useState([]);
  const[loaded,setLoaded]=useState(false);
  const[saving,setSaving]=useState(false);
  const[showAdd,setShowAdd]=useState(false);
  const[form,setForm]=useState({cat:"",title:"",text:""});

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","scripts_extra"));
        if(snap.exists()) setItems(snap.data().items||[]);
      }catch{}
      setLoaded(true);
    })();
  },[]);

  const save=async(next)=>{
    setSaving(true);
    try{await setDoc(doc(db,"admin","scripts_extra"),{items:next});}catch{}
    setItems(next);
    setSaving(false);
  };

  const add=()=>{
    if(!form.cat.trim()||!form.title.trim()||!form.text.trim())return;
    const catKey=form.cat.trim();
    const existing=items.find(c=>c.cat===catKey);
    let next;
    if(existing){
      next=items.map(c=>c.cat===catKey?{...c,scripts:[...c.scripts,{title:form.title.trim(),text:form.text.trim()}]}:c);
    } else {
      next=[...items,{cat:catKey,scripts:[{title:form.title.trim(),text:form.text.trim()}]}];
    }
    save(next);
    setForm({cat:"",title:"",text:""});
    setShowAdd(false);
  };

  const delScript=(catKey,title)=>{
    let next=items.map(c=>c.cat===catKey?{...c,scripts:c.scripts.filter(s=>s.title!==title)}:c).filter(c=>c.scripts.length>0);
    save(next);
  };

  const total=items.reduce((a,c)=>a+c.scripts.length,0);

  if(!loaded) return <div style={{fontSize:".74rem",color:C.gris}}>Chargement...</div>;

  return(
    <div>
      <button onClick={()=>setShowAdd(p=>!p)}
        style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:"1rem"}}>
        ➕ Ajouter un script ({total})
      </button>

      {showAdd&&(
        <div style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
          <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".6rem"}}>Nouveau script</div>
          <input placeholder="Catégorie (ex: 💬 Premier contact)" value={form.cat} onChange={e=>setForm(p=>({...p,cat:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".45rem"}}/>
          <input placeholder="Titre du script" value={form.title} onChange={e=>setForm(p=>({...p,title:e.target.value}))}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".45rem"}}/>
          <textarea placeholder="Texte du script" value={form.text} onChange={e=>setForm(p=>({...p,text:e.target.value}))}
            style={{width:"100%",minHeight:90,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .65rem",fontFamily:"inherit",fontSize:".78rem",color:C.texte,background:C.blanc,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:".6rem"}}/>
          <div style={{display:"flex",gap:".4rem"}}>
            <button onClick={add} disabled={saving} style={{flex:1,background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              {saving?"...":"Ajouter"}
            </button>
            <button onClick={()=>setShowAdd(false)} style={{flex:1,background:C.pale,color:C.gris,border:"none",borderRadius:8,padding:".5rem",fontSize:".78rem",fontFamily:"inherit",cursor:"pointer"}}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {items.map(cat=>(
        <div key={cat.cat} style={{marginBottom:".75rem"}}>
          <div style={{fontSize:".6rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",padding:".2rem .6rem",background:C.or+"20",color:C.brun2,borderRadius:20,display:"inline-block",marginBottom:".4rem"}}>{cat.cat}</div>
          {cat.scripts.map(s=>(
            <div key={s.title} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:9,padding:".55rem .75rem",marginBottom:".3rem",display:"flex",gap:".5rem",alignItems:"flex-start"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:".75rem",fontWeight:600,color:C.brun}}>{s.title}</div>
                <div style={{fontSize:".68rem",color:C.gris,marginTop:".15rem"}}>{s.text}</div>
              </div>
              <button onClick={()=>delScript(cat.cat,s.title)} style={{background:"none",border:"none",color:"#B04040",cursor:"pointer",fontSize:".7rem",padding:".15rem",fontFamily:"inherit",flexShrink:0}}>✕</button>
            </div>
          ))}
        </div>
      ))}
      {items.length===0&&<div style={{fontSize:".73rem",color:C.gris,fontStyle:"italic"}}>Aucun script ajouté encore.</div>}
    </div>
  );
}

// ── ADMIN TEXTES EDITOR ──────────────────────────────────────────────────────
function AdminTextesEditor(){
  const[citations,setCitations]=useState([]);
  const[messageAccueil,setMessageAccueil]=useState("");
  const[loaded,setLoaded]=useState(false);
  const[saving,setSaving]=useState(false);
  const[saved,setSaved]=useState(false);
  const[newCitation,setNewCitation]=useState("");

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","textes"));
        if(snap.exists()){
          const d=snap.data();
          setCitations(d.citations||CITATIONS_DEFAULT);
          setMessageAccueil(d.messageAccueil||"");
        } else {
          setCitations(CITATIONS_DEFAULT);
        }
      }catch{
        setCitations(CITATIONS_DEFAULT);
      }
      setLoaded(true);
    })();
  },[]);

  const save=async(nextCitations,nextMsg)=>{
    setSaving(true);
    try{await setDoc(doc(db,"admin","textes"),{citations:nextCitations,messageAccueil:nextMsg});}catch{}
    setSaving(false);
    setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  };

  const addCitation=()=>{
    if(!newCitation.trim())return;
    const next=[...citations,newCitation.trim()];
    setCitations(next);
    setNewCitation("");
    save(next,messageAccueil);
  };

  const delCitation=(idx)=>{
    const next=citations.filter((_,i)=>i!==idx);
    setCitations(next);
    save(next,messageAccueil);
  };

  const saveMsg=()=>save(citations,messageAccueil);

  if(!loaded) return <div style={{fontSize:".74rem",color:C.gris}}>Chargement...</div>;

  return(
    <div>
      {/* Message d'accueil équipe */}
      <div style={{marginBottom:"1.25rem"}}>
        <div style={{fontSize:".65rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>👋 Message d'accueil (page d'accueil de l'équipe)</div>
        <textarea
          placeholder="Ex: Bienvenue dans ton espace Blazing Dynasty ! On est fières de t'avoir avec nous 🖤"
          value={messageAccueil}
          onChange={e=>setMessageAccueil(e.target.value)}
          style={{width:"100%",minHeight:70,border:`1px solid ${C.pale}`,borderRadius:9,padding:".6rem .8rem",fontFamily:"inherit",fontSize:".76rem",color:C.texte,background:C.creme,resize:"vertical",outline:"none",lineHeight:1.6,marginBottom:".5rem"}}/>
        <button onClick={saveMsg} disabled={saving}
          style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:9,padding:".5rem",fontSize:".76rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          {saving?"Sauvegarde...":saved?"✅ Sauvegardé !":"Sauvegarder le message"}
        </button>
      </div>

      {/* Citations */}
      <div>
        <div style={{fontSize:".65rem",fontWeight:700,color:C.brun,marginBottom:".4rem"}}>✨ Citations motivantes ({citations.length})</div>
        <p style={{fontSize:".68rem",color:C.gris,marginBottom:".5rem",lineHeight:1.5}}>Une citation différente s'affiche chaque jour sur la page d'accueil, dans l'ordre du jour de l'année (rotation automatique).</p>
        <div style={{display:"flex",gap:".4rem",marginBottom:".75rem"}}>
          <input placeholder="Nouvelle citation..." value={newCitation} onChange={e=>setNewCitation(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&addCitation()}
            style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
          <button onClick={addCitation} disabled={saving||!newCitation.trim()}
            style={{background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".42rem .8rem",fontSize:".76rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
            Ajouter
          </button>
        </div>
        <div style={{maxHeight:280,overflowY:"auto"}}>
          {citations.map((c,i)=>(
            <div key={i} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem .7rem",marginBottom:".3rem",display:"flex",gap:".5rem",alignItems:"flex-start"}}>
              <div style={{flex:1,fontSize:".74rem",color:C.texte,fontStyle:"italic",lineHeight:1.5}}>{c}</div>
              <button onClick={()=>delCitation(i)} style={{background:"none",border:"none",color:"#B04040",cursor:"pointer",fontSize:".7rem",padding:".15rem",fontFamily:"inherit",flexShrink:0}}>✕</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── BANQUE D'IMAGES ───────────────────────────────────────────────────────────
function AdminSEL({label,field,options,small=false,form,setForm}){
  return(
    <div style={{marginBottom:".5rem"}}>
      <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>{label}</div>
      <select value={form[field]} onChange={e=>setForm(p=>({...p,[field]:e.target.value}))}
        style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:small?".35rem .5rem":".42rem .65rem",fontSize:small?".75rem":".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}>
        {options}
      </select>
    </div>
  );
}
function AdminINP({label,field,placeholder,textarea=false,form,setForm}){
  return(
    <div style={{marginBottom:".5rem"}}>
      <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>{label}</div>
      {textarea
        ?<textarea value={form[field]||""} onChange={e=>setForm(p=>({...p,[field]:e.target.value}))} placeholder={placeholder} rows={3}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",lineHeight:1.6}}/>
        :<input value={form[field]||""} onChange={e=>setForm(p=>({...p,[field]:e.target.value}))} placeholder={placeholder}
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
      }
    </div>
  );
}

export const THEMES_IMAGES=[
  {id:"skincare",icon:"✨",label:"Skincare"},
  {id:"cheveux",icon:"💇",label:"Soins cheveux"},
  {id:"makeup",icon:"💄",label:"Make-up"},
  {id:"complements",icon:"💊",label:"Compléments"},
  {id:"parfums",icon:"🌸",label:"Parfums"},
  {id:"corps",icon:"🧴",label:"Soin corps"},
  {id:"home",icon:"🏠",label:"HOME"},
  {id:"perte_poids",icon:"⚖️",label:"Perte de poids"},
  {id:"recrutement",icon:"👑",label:"Recrutement"},
  {id:"outils",icon:"🛠️",label:"Outils équipe"},
];

export function BanqueImagesTab({isMelissa,userName}){
  const[images,setImages]=useState([]);
  const[dossiersVisuels,setDossiersVisuels]=useState([]);
  const[vueTab,setVueTab]=useState("temoignages"); // temoignages | visuels | avalider
  const[theme,setTheme]=useState("skincare");
  const[dossierActif,setDossierActif]=useState(null);
  const[showAdd,setShowAdd]=useState(false);
  const[form,setForm]=useState({titre:"",url:"",theme:"skincare",dossier:"",type:"image"});
  const[saving,setSaving]=useState(false);
  const[loaded,setLoaded]=useState(false);
  const[showAddDossier,setShowAddDossier]=useState(false);
  const[nouveauDossier,setNouveauDossier]=useState({label:"",icon:"📁"});
  const[copieId,setCopieId]=useState(null);

  const copierTexte=(id,texte)=>{
    try{
      navigator.clipboard.writeText(texte);
      setCopieId(id);
      setTimeout(()=>setCopieId(null),1800);
    }catch{}
  };

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"banque","images"));
        if(snap.exists()) setImages(snap.data().items||[]);
      }catch{}
      try{
        const snapD=await getDoc(doc(db,"banque","dossiers_visuels"));
        if(snapD.exists()&&snapD.data().folders&&snapD.data().folders.length>0){
          setDossiersVisuels(snapD.data().folders);
        }else{
          // Initialisation : reprend les anciens themes comme dossiers de depart
          const initiaux=THEMES_IMAGES.map(t=>({id:t.id,label:t.label,icon:t.icon}));
          setDossiersVisuels(initiaux);
          await setDoc(doc(db,"banque","dossiers_visuels"),{folders:initiaux});
        }
      }catch{}
      setLoaded(true);
    })();
  },[]);

  useEffect(()=>{
    if(dossiersVisuels.length>0&&!dossierActif)setDossierActif(dossiersVisuels[0].id);
  },[dossiersVisuels]);

  const saveImages=async(items)=>{
    setSaving(true);
    try{await setDoc(doc(db,"banque","images"),{items});}catch{}
    setSaving(false);
  };
  const saveDossiers=async(folders)=>{
    try{await setDoc(doc(db,"banque","dossiers_visuels"),{folders});}catch{}
  };

  const add=async()=>{
    if(!form.titre.trim()||!form.url.trim())return;
    const item={id:`img${Date.now()}`,titre:form.titre,url:form.url,type:form.type,
      auteur:userName||"",valide:!!isMelissa,
      ...(vueTab==="temoignages"?{theme:form.theme,sousTheme:"temoignages",texte:form.texte||""}:{dossier:form.dossier||dossierActif,sousTheme:"visuels"})};
    const next=[...images,item];
    setImages(next);await saveImages(next);
    setForm({titre:"",url:"",theme:"skincare",dossier:"",type:"image",texte:""});
    setShowAdd(false);
  };

  const del=async(id)=>{
    const next=images.filter(i=>i.id!==id);
    setImages(next);await saveImages(next);
  };

  const validerItem=async(id)=>{
    const next=images.map(i=>i.id===id?{...i,valide:true}:i);
    setImages(next);await saveImages(next);
  };

  const ajouterDossier=async()=>{
    if(!nouveauDossier.label.trim())return;
    const nouveau={id:`d${Date.now()}`,label:nouveauDossier.label.trim(),icon:nouveauDossier.icon||"📁"};
    const next=[...dossiersVisuels,nouveau];
    setDossiersVisuels(next);
    await saveDossiers(next);
    setDossierActif(nouveau.id);
    setNouveauDossier({label:"",icon:"📁"});
    setShowAddDossier(false);
  };

  const filteredTemoignages=images.filter(i=>i.sousTheme==="temoignages"&&i.theme===theme&&i.valide!==false);
  const filteredVisuels=images.filter(i=>i.sousTheme==="visuels"&&i.dossier===dossierActif&&i.valide!==false);
  const enAttente=images.filter(i=>i.valide===false);

  if(!loaded)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
        Banque <em style={{fontStyle:"italic",color:C.rose}}>d'Images</em>
      </div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1rem",lineHeight:1.65}}>
        Retrouve les témoignages et visuels pour tes publications.
      </p>

      {/* Toggle principal Témoignages / Visuels / A valider */}
      <div style={{display:"flex",gap:".4rem",marginBottom:"1rem"}}>
        <button onClick={()=>setVueTab("temoignages")}
          style={{flex:1,padding:".55rem",fontSize:".8rem",fontWeight:700,borderRadius:10,border:`1.5px solid ${vueTab==="temoignages"?C.rose:C.pale}`,background:vueTab==="temoignages"?C.rose:C.blanc,color:vueTab==="temoignages"?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
          💬 Témoignages
        </button>
        <button onClick={()=>setVueTab("visuels")}
          style={{flex:1,padding:".55rem",fontSize:".8rem",fontWeight:700,borderRadius:10,border:`1.5px solid ${vueTab==="visuels"?C.rose:C.pale}`,background:vueTab==="visuels"?C.rose:C.blanc,color:vueTab==="visuels"?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
          📸 Visuels
        </button>
        {isMelissa&&(
          <button onClick={()=>setVueTab("avalider")}
            style={{position:"relative",flex:.8,padding:".55rem",fontSize:".8rem",fontWeight:700,borderRadius:10,border:`1.5px solid ${vueTab==="avalider"?"#C44B1A":C.pale}`,background:vueTab==="avalider"?"#C44B1A":C.blanc,color:vueTab==="avalider"?"white":C.gris,cursor:"pointer",fontFamily:"inherit"}}>
            🕐 À valider
            {enAttente.length>0&&(
              <span style={{position:"absolute",top:-6,right:-6,background:"#C44B1A",color:"white",borderRadius:"50%",minWidth:18,height:18,fontSize:".6rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px",border:"2px solid white"}}>
                {enAttente.length}
              </span>
            )}
          </button>
        )}
      </div>

      {vueTab!=="avalider"&&(
        <button onClick={()=>setShowAdd(p=>!p)}
          style={{width:"100%",background:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".6rem",fontSize:".8rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",marginBottom:".4rem"}}>
          ➕ Ajouter {vueTab==="temoignages"?"un témoignage":"un visuel"}
        </button>
      )}
      {vueTab!=="avalider"&&!isMelissa&&(
        <p style={{fontSize:".65rem",color:C.gris,marginBottom:"1rem",fontStyle:"italic",textAlign:"center"}}>
          Ton ajout sera visible pour toute l'équipe après validation de Melissa.
        </p>
      )}

      {showAdd&&(
        <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem",marginBottom:"1rem"}}>
          <div style={{fontSize:".62rem",fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.rose,marginBottom:".6rem"}}>Nouveau contenu</div>
          <input placeholder="Titre" value={form.titre} onChange={e=>setForm(p=>({...p,titre:e.target.value}))}
            style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",marginBottom:".45rem"}}/>
          <div style={{display:"flex",gap:".4rem",marginBottom:".5rem"}}><button onClick={()=>setForm(p=>({...p,type:"image"}))} style={{flex:1,padding:".4rem",fontSize:".72rem",fontWeight:600,borderRadius:9,border:"2px solid "+(form.type!=="video"?C.brun:C.pale),background:form.type!=="video"?C.brun:C.blanc,color:form.type!=="video"?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit"}}>📸 Photo</button><button onClick={()=>setForm(p=>({...p,type:"video"}))} style={{flex:1,padding:".4rem",fontSize:".72rem",fontWeight:600,borderRadius:9,border:"2px solid "+(form.type==="video"?C.brun:C.pale),background:form.type==="video"?C.brun:C.blanc,color:form.type==="video"?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit"}}>🎥 Video</button></div>
          {form.type==="video"?<input placeholder="URL video YouTube TikTok Instagram" value={form.url} onChange={e=>setForm(p=>({...p,url:e.target.value}))} style={{width:"100%",border:"1px solid #E8DDD4",borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",outline:"none",marginBottom:".45rem"}}/>:<UploadPhoto label="Photo" value={form.url} onChange={v=>setForm(p=>({...p,url:v}))} folder="banque-images" maxSize={1200} quality={0.88}/>}
          {vueTab==="temoignages"?(<>
            <select value={form.theme} onChange={e=>setForm(p=>({...p,theme:e.target.value}))}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginTop:".3rem",marginBottom:".45rem"}}>
              {THEMES_IMAGES.map(t=><option key={t.id} value={t.id}>{t.icon} {t.label}</option>)}
            </select>
            <textarea placeholder="Texte du témoignage (optionnel, pour pouvoir le copier facilement)" value={form.texte||""} onChange={e=>setForm(p=>({...p,texte:e.target.value}))}
              style={{width:"100%",minHeight:60,border:`1px solid ${C.pale}`,borderRadius:8,padding:".5rem",fontFamily:"inherit",fontSize:".76rem",color:C.texte,background:C.creme,resize:"vertical",outline:"none",lineHeight:1.5}}/>
          </>):(
            <select value={form.dossier||dossierActif} onChange={e=>setForm(p=>({...p,dossier:e.target.value}))}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginTop:".3rem"}}>
              {dossiersVisuels.map(d=><option key={d.id} value={d.id}>{d.icon} {d.label}</option>)}
            </select>
          )}
          <div style={{display:"flex",gap:".4rem",marginTop:".5rem"}}>
            <button onClick={add} disabled={saving||!form.titre.trim()||!form.url.trim()}
              style={{flex:1,background:C.brun,color:C.blanc,border:"none",borderRadius:8,padding:".52rem",fontSize:".78rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              {saving?"...":"Ajouter"}
            </button>
            <button onClick={()=>setShowAdd(false)}
              style={{flex:1,background:C.pale,color:C.gris,border:"none",borderRadius:8,padding:".52rem",fontSize:".78rem",fontFamily:"inherit",cursor:"pointer"}}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {vueTab==="temoignages"?(<>
        {/* Filtres thèmes (fixes) */}
        <div style={{display:"flex",gap:".3rem",overflowX:"auto",marginBottom:"1rem",paddingBottom:".3rem"}}>
          {THEMES_IMAGES.map(t=>(
            <button key={t.id} onClick={()=>setTheme(t.id)}
              style={{flex:"none",padding:".35rem .7rem",fontSize:".65rem",fontWeight:600,borderRadius:20,border:`1px solid ${theme===t.id?C.rose:C.pale}`,background:theme===t.id?C.rose:C.blanc,color:theme===t.id?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
              {t.icon} {t.label}
            </button>
          ))}
        </div>
        {filteredTemoignages.length===0?(
          <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Aucun témoignage dans ce thème pour l'instant.</div>
        ):(
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".7rem"}}>
            {filteredTemoignages.map(i=>(
              <div key={i.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,overflow:"hidden"}}>
                {i.type==="video"?(
                  <a href={i.url} target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",justifyContent:"center",height:120,background:C.creme,textDecoration:"none",fontSize:"1.8rem"}}>▶</a>
                ):(<img src={i.url} alt={i.titre} style={{width:"100%",height:120,objectFit:"cover",display:"block"}}/>)}
                <div style={{padding:".5rem .6rem"}}>
                  <div style={{fontSize:".7rem",fontWeight:600,color:C.brun,marginBottom:".4rem"}}>{i.titre}</div>
                  <div style={{display:"flex",gap:".3rem",marginBottom:isMelissa?".3rem":0}}>
                    {i.type!=="video"&&(
                      <a href={i.url} download target="_blank" rel="noopener noreferrer"
                        style={{flex:1,background:C.brun,color:"white",borderRadius:7,padding:".28rem",fontSize:".62rem",fontWeight:600,textDecoration:"none",textAlign:"center",display:"block"}}>
                        ⬇ Photo
                      </a>
                    )}
                    {i.texte&&(
                      <button onClick={()=>copierTexte(i.id,i.texte)}
                        style={{flex:1,background:copieId===i.id?"#2D5A3D":"none",border:`1px solid ${copieId===i.id?"#2D5A3D":C.pale}`,color:copieId===i.id?"white":C.gris,borderRadius:7,padding:".28rem",fontSize:".62rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                        {copieId===i.id?"✅ Copié !":"📋 Texte"}
                      </button>
                    )}
                  </div>
                  {isMelissa&&<button onClick={()=>del(i.id)} style={{background:"none",border:"none",color:"#C0504D",fontSize:".62rem",cursor:"pointer",fontFamily:"inherit",padding:0}}>🗑️ Retirer</button>}
                </div>
              </div>
            ))}
          </div>
        )}
      </>):vueTab==="visuels"?(<>
        {/* Dossiers personnalises Visuels */}
        <div style={{display:"flex",gap:".3rem",overflowX:"auto",marginBottom:".6rem",paddingBottom:".3rem"}}>
          {dossiersVisuels.map(d=>(
            <button key={d.id} onClick={()=>setDossierActif(d.id)}
              style={{flex:"none",padding:".35rem .7rem",fontSize:".65rem",fontWeight:600,borderRadius:20,border:`1px solid ${dossierActif===d.id?C.rose:C.pale}`,background:dossierActif===d.id?C.rose:C.blanc,color:dossierActif===d.id?C.blanc:C.gris,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
              {d.icon} {d.label}
            </button>
          ))}
          {isMelissa&&(
            <button onClick={()=>setShowAddDossier(p=>!p)}
              style={{flex:"none",padding:".35rem .7rem",fontSize:".65rem",fontWeight:600,borderRadius:20,border:`1.5px dashed ${C.pale}`,background:C.blanc,color:C.gris,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
              + Nouveau dossier
            </button>
          )}
        </div>
        {showAddDossier&&isMelissa&&(
          <div style={{display:"flex",gap:".4rem",marginBottom:"1rem"}}>
            <input placeholder="Emoji" value={nouveauDossier.icon} onChange={e=>setNouveauDossier(p=>({...p,icon:e.target.value}))}
              style={{width:50,border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem",fontSize:".85rem",fontFamily:"inherit",outline:"none",textAlign:"center"}}/>
            <input placeholder="Nom du dossier" value={nouveauDossier.label} onChange={e=>setNouveauDossier(p=>({...p,label:e.target.value}))}
              style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".4rem .6rem",fontSize:".78rem",fontFamily:"inherit",outline:"none"}}/>
            <button onClick={ajouterDossier} disabled={!nouveauDossier.label.trim()}
              style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".4rem .8rem",fontSize:".75rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
              OK
            </button>
          </div>
        )}
        {filteredVisuels.length===0?(
          <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Aucun visuel dans ce dossier pour l'instant.</div>
        ):(
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".7rem"}}>
            {filteredVisuels.map(i=>(
              <div key={i.id} style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,overflow:"hidden"}}>
                {i.type==="video"?(
                  <a href={i.url} target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",justifyContent:"center",height:120,background:C.creme,textDecoration:"none",fontSize:"1.8rem"}}>▶</a>
                ):(<img src={i.url} alt={i.titre} style={{width:"100%",height:120,objectFit:"cover",display:"block"}}/>)}
                <div style={{padding:".5rem .6rem"}}>
                  <div style={{fontSize:".7rem",fontWeight:600,color:C.brun,marginBottom:".4rem"}}>{i.titre}</div>
                  {i.type!=="video"&&(
                    <a href={i.url} download target="_blank" rel="noopener noreferrer"
                      style={{display:"block",background:C.brun,color:"white",borderRadius:7,padding:".28rem",fontSize:".62rem",fontWeight:600,textDecoration:"none",textAlign:"center",marginBottom:isMelissa?".3rem":0}}>
                      ⬇ Télécharger
                    </a>
                  )}
                  {isMelissa&&<button onClick={()=>del(i.id)} style={{background:"none",border:"none",color:"#C0504D",fontSize:".62rem",cursor:"pointer",fontFamily:"inherit",padding:0}}>🗑️ Retirer</button>}
                </div>
              </div>
            ))}
          </div>
        )}
      </>):vueTab==="avalider"?(
        enAttente.length===0?(
          <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>🎉 Rien à valider pour l'instant !</div>
        ):(
          enAttente.map(i=>(
            <div key={i.id} style={{background:"white",border:`1.5px solid #C44B1A`,borderRadius:12,padding:".8rem",marginBottom:".7rem",display:"flex",gap:".7rem"}}>
              {i.type==="video"?(
                <a href={i.url} target="_blank" rel="noopener noreferrer" style={{width:70,height:70,borderRadius:8,background:C.creme,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.5rem",flexShrink:0,textDecoration:"none"}}>▶</a>
              ):(<img src={i.url} alt="" style={{width:70,height:70,borderRadius:8,objectFit:"cover",flexShrink:0}}/>)}
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:".72rem",fontWeight:600,color:C.brun,marginBottom:".15rem"}}>{i.titre}</div>
                <div style={{fontSize:".65rem",color:C.gris,marginBottom:".5rem"}}>
                  Ajouté par {i.auteur||"quelqu'un"} · {i.sousTheme==="temoignages"?`Thème : ${THEMES_IMAGES.find(t=>t.id===i.theme)?.label||i.theme}`:`Dossier : ${dossiersVisuels.find(d=>d.id===i.dossier)?.label||i.dossier}`}
                </div>
                <div style={{display:"flex",gap:".4rem"}}>
                  <button onClick={()=>validerItem(i.id)}
                    style={{flex:1,background:"#2D5A3D",color:"white",border:"none",borderRadius:8,padding:".4rem",fontSize:".68rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                    ✅ Valider
                  </button>
                  <button onClick={()=>del(i.id)}
                    style={{flex:1,background:"none",border:"1px solid #C0504D",color:"#C0504D",borderRadius:8,padding:".4rem",fontSize:".68rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                    ✕ Refuser
                  </button>
                </div>
              </div>
            </div>
          ))
        )
      ):null}
    </div>
  );
}
// Outil pour classer retroactivement les temoignages partages dans Communaute avant l'existence du classement automatique
function ReclasserTemoignagesTab(){
  const[posts,setPosts]=useState([]);
  const[dejaClasses,setDejaClasses]=useState(new Set());
  const[choix,setChoix]=useState({});
  const[loaded,setLoaded]=useState(false);
  const[classement,setClassement]=useState({});

  useEffect(()=>{
    (async()=>{
      try{
        const snapPosts=await getDoc(doc(db,"communaute","posts"));
        const allPosts=snapPosts.exists()?Object.values(snapPosts.data()):[];
        const temoignages=allPosts.filter(p=>p.type==="temoignage"&&p.photo).sort((a,b)=>b.ts-a.ts);

        const snapBanque=await getDoc(doc(db,"banque","images"));
        const items=snapBanque.exists()?(snapBanque.data().items||[]):[];
        const urlsClassees=new Set(items.filter(i=>i.sousTheme==="temoignages").map(i=>i.url));

        setPosts(temoignages);
        setDejaClasses(urlsClassees);
      }catch{}
      setLoaded(true);
    })();
  },[]);

  const classerUn=async(post)=>{
    const themeChoisi=choix[post.id]||"skincare";
    setClassement(p=>({...p,[post.id]:"encours"}));
    try{
      const snapBanque=await getDoc(doc(db,"banque","images"));
      const items=snapBanque.exists()?(snapBanque.data().items||[]):[];
      const item={
        id:`img${Date.now()}`,
        titre:`Témoignage de ${post.author}`,
        url:post.photo,
        texte:post.text||"",
        theme:themeChoisi,
        sousTheme:"temoignages",
        type:"image",
        auteur:post.author,
        valide:true,
      };
      await setDoc(doc(db,"banque","images"),{items:[...items,item]});
      setDejaClasses(p=>new Set([...p,post.photo]));
      setClassement(p=>({...p,[post.id]:"fait"}));
    }catch{
      setClassement(p=>({...p,[post.id]:null}));
    }
  };

  const aClasser=posts.filter(p=>!dejaClasses.has(p.photo));

  if(!loaded)return <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>Chargement...</div>;

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:600,color:C.brun,marginBottom:".3rem"}}>📁 Reclasser les témoignages</div>
      <p style={{fontSize:".74rem",color:C.gris,marginBottom:"1.2rem",lineHeight:1.6}}>
        Témoignages partagés dans Communauté avant la mise en place du classement automatique. Choisis un thème et clique sur "Classer" pour les ajouter à la Banque d'Images.
      </p>

      {aClasser.length===0?(
        <div style={{textAlign:"center",padding:"2rem",color:C.gris,fontSize:".8rem"}}>
          🎉 Tous les témoignages avec photo sont déjà classés !
        </div>
      ):(
        aClasser.map(post=>(
          <div key={post.id} style={{background:"white",border:`1px solid ${C.pale}`,borderRadius:12,padding:".9rem",marginBottom:".7rem",display:"flex",gap:".7rem"}}>
            <img src={post.photo} alt="" style={{width:70,height:70,borderRadius:8,objectFit:"cover",flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:".72rem",fontWeight:600,color:C.brun,marginBottom:".2rem"}}>{post.author}</div>
              <div style={{fontSize:".7rem",color:C.gris,lineHeight:1.4,marginBottom:".5rem",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{post.text}</div>
              {classement[post.id]==="fait"?(
                <div style={{fontSize:".72rem",color:"#2D5A3D",fontWeight:700}}>✅ Classé !</div>
              ):(
                <div style={{display:"flex",gap:".3rem"}}>
                  <select value={choix[post.id]||"skincare"} onChange={e=>setChoix(p=>({...p,[post.id]:e.target.value}))}
                    style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:8,padding:".3rem .5rem",fontSize:".68rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}>
                    {THEMES_IMAGES.map(t=><option key={t.id} value={t.id}>{t.icon} {t.label}</option>)}
                  </select>
                  <button onClick={()=>classerUn(post)} disabled={classement[post.id]==="encours"}
                    style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".3rem .7rem",fontSize:".68rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
                    {classement[post.id]==="encours"?"...":"Classer"}
                  </button>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}



// ── DIAGNOSTICS ───────────────────────────────────────────────────────────────
// ── DIAGNOSTIC BUSINESS (recrutement / ventes / réseaux) ─────────────────────


// ── MON UNIVERS TAB ──────────────────────────────────────────────────────────
export function MonUniversTab({uid}) {
  const [onglet, setOnglet] = useState('roue');
  const onglets = [
    {id:'roue', label:'Equilibre'},
    {id:'disc', label:'DISC'},
    {id:'valeurs', label:'Valeurs'},
    {id:'style', label:'Style'},
    {id:'dream', label:'Dream Board'},
  ];
  return (
    <div style={{fontFamily:'inherit',padding:'0 0 2rem'}}>
      <div style={{display:'flex',gap:'.4rem',overflowX:'auto',padding:'.7rem 1rem',background:'white',borderBottom:'1px solid #EDE8E0',position:'sticky',top:0,zIndex:10}}>
        {onglets.map(function(o){ return (
          <button key={o.id} onClick={function(){setOnglet(o.id);}}
            style={{flexShrink:0,padding:'.4rem .85rem',borderRadius:20,border:'none',background:onglet===o.id?'#5A3829':'#EDE8E0',color:onglet===o.id?'white':'#9A8C8C',fontFamily:'inherit',fontSize:'.72rem',fontWeight:onglet===o.id?700:400,cursor:'pointer'}}>
            {o.label}
          </button>
        );})}
      </div>
      {onglet==='roue'&&<RoueEquilibre/>}
      {onglet==='disc'&&<TestDISC/>}
      {onglet==='valeurs'&&<TestValeurs/>}
      {onglet==='style'&&<TestStyleEntrepreneur/>}
      {onglet==='dream'&&<DreamBoardWidget uid={uid}/>}
    </div>
  );
}

export default App;
